/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 697);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(72);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(95);
__webpack_require__(587);
var inversify_binding_decorators_1 = __webpack_require__(380);
var inversify_inject_decorators_1 = __webpack_require__(386);
exports.container = new inversify_1.Container();
var provide = inversify_binding_decorators_1.makeFluentProvideDecorator(exports.container);
// tslint:disable-next-line:no-any
function provideInstance(identifier) {
    return provide(identifier).done();
}
exports.provideInstance = provideInstance;
// tslint:disable-next-line:no-any
function provideSingleton(identifier) {
    return provide(identifier).inSingletonScope().done();
}
exports.provideSingleton = provideSingleton;
exports.inject = inversify_inject_decorators_1.default(exports.container).lazyInject;
/**
 * Decorator um Klassenmethoden an Klassenkontext zu binden
 * macht Konstrukt this.methodenname = this.mehtodenname.bind(this) obsolet
 */
function bind(target, propertyKey, descriptor) {
    if (!descriptor || (typeof descriptor.value !== 'function')) {
        throw new TypeError("Only functions can be decorated with @bind. <" + propertyKey + "> is not a function!");
    }
    return {
        configurable: true,
        get: function () {
            var bound = descriptor.value.bind(this);
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: true,
                writable: true
            });
            return bound;
        }
    };
}
exports.bind = bind;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return __WEBPACK_IMPORTED_MODULE_0__Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_1__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_2__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return __WEBPACK_IMPORTED_MODULE_8__Carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_10__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Clearfix", function() { return __WEBPACK_IMPORTED_MODULE_11__Clearfix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ControlLabel__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ControlLabel", function() { return __WEBPACK_IMPORTED_MODULE_12__ControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Col__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return __WEBPACK_IMPORTED_MODULE_13__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Collapse__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_14__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Dropdown__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return __WEBPACK_IMPORTED_MODULE_15__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DropdownButton__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return __WEBPACK_IMPORTED_MODULE_16__DropdownButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Fade__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return __WEBPACK_IMPORTED_MODULE_17__Fade__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Form__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_18__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__FormControl__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_19__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormGroup__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_20__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Glyphicon__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Glyphicon", function() { return __WEBPACK_IMPORTED_MODULE_21__Glyphicon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Grid__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_22__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HelpBlock__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HelpBlock", function() { return __WEBPACK_IMPORTED_MODULE_23__HelpBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Image__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_24__Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__InputGroup__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return __WEBPACK_IMPORTED_MODULE_25__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Jumbotron__ = __webpack_require__(443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return __WEBPACK_IMPORTED_MODULE_26__Jumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Label__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_27__Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ListGroup__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return __WEBPACK_IMPORTED_MODULE_28__ListGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroupItem__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return __WEBPACK_IMPORTED_MODULE_29__ListGroupItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Media__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_30__Media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__MenuItem__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_31__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Modal__ = __webpack_require__(453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_32__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ModalBody__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return __WEBPACK_IMPORTED_MODULE_33__ModalBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalFooter__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return __WEBPACK_IMPORTED_MODULE_34__ModalFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalHeader__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return __WEBPACK_IMPORTED_MODULE_35__ModalHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalTitle__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalTitle", function() { return __WEBPACK_IMPORTED_MODULE_36__ModalTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Nav__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return __WEBPACK_IMPORTED_MODULE_37__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Navbar__ = __webpack_require__(456);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_38__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__NavbarBrand__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return __WEBPACK_IMPORTED_MODULE_39__NavbarBrand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NavDropdown__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return __WEBPACK_IMPORTED_MODULE_40__NavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavItem__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavItem", function() { return __WEBPACK_IMPORTED_MODULE_41__NavItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Overlay__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Overlay", function() { return __WEBPACK_IMPORTED_MODULE_42__Overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__OverlayTrigger__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayTrigger", function() { return __WEBPACK_IMPORTED_MODULE_43__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__PageHeader__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageHeader", function() { return __WEBPACK_IMPORTED_MODULE_44__PageHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PageItem__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageItem", function() { return __WEBPACK_IMPORTED_MODULE_45__PageItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Pager__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pager", function() { return __WEBPACK_IMPORTED_MODULE_46__Pager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Pagination__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return __WEBPACK_IMPORTED_MODULE_47__Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__PaginationButton__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationButton", function() { return __WEBPACK_IMPORTED_MODULE_48__PaginationButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Panel__ = __webpack_require__(465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return __WEBPACK_IMPORTED_MODULE_49__Panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__PanelGroup__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanelGroup", function() { return __WEBPACK_IMPORTED_MODULE_50__PanelGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Popover__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_51__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ProgressBar__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return __WEBPACK_IMPORTED_MODULE_52__ProgressBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Radio__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_53__Radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ResponsiveEmbed__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResponsiveEmbed", function() { return __WEBPACK_IMPORTED_MODULE_54__ResponsiveEmbed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Row__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return __WEBPACK_IMPORTED_MODULE_55__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__SafeAnchor__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SafeAnchor", function() { return __WEBPACK_IMPORTED_MODULE_56__SafeAnchor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SplitButton__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SplitButton", function() { return __WEBPACK_IMPORTED_MODULE_57__SplitButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Tab__ = __webpack_require__(473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_58__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__TabContainer__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContainer", function() { return __WEBPACK_IMPORTED_MODULE_59__TabContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContent__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_60__TabContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Table__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_61__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__TabPane__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_62__TabPane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Tabs__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_63__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Thumbnail__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return __WEBPACK_IMPORTED_MODULE_64__Thumbnail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Tooltip__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_65__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Well__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Well", function() { return __WEBPACK_IMPORTED_MODULE_66__Well__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__utils__ = __webpack_require__(482);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_67__utils__; });









































































































































/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extras", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Atom", function() { return Atom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAtom", function() { return BaseAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStrict", function() { return useStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStrictModeEnabled", function() { return isStrictModeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asReference", function() { return asReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asFlat", function() { return asFlat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asStructure", function() { return asStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asMap", function() { return asMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isModifierDescriptor", function() { return isModifierDescriptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IObservableFactories", function() { return IObservableFactories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorunAsync", function() { return autorunAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expr", function() { return expr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformer", function() { return createTransformer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whyRun", function() { return whyRun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return (interceptable.interceptors && interceptable.interceptors.length > 0);
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", { set: function () { v = true; } });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
var ObservableArrayAdministration = (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || ("ObservableArray@" + getNextId()));
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.array,
            type: "update",
            index: index, newValue: newValue, oldValue: oldValue
        } : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.array,
            type: "splice",
            index: index, removed: removed, added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return isObservableArray(a) ? a.peek() : a; }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
        functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
        since these functions alter the inner structure of the array, the have side effects.
        Because the have side effects, they should not be used in computed function,
        and for that reason the do not call dependencyState.notifyObserved
        */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [oldItems[fromIndex]], oldItems.slice(toIndex + 1));
        }
        else {
            newItems = oldItems.slice(0, toIndex).concat([oldItems[fromIndex]], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index, newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
/**
 * Wrap function from prototype
 */
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue, oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, { object: this, type: "update", newValue: newValue });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue
            ? newValue
            : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue, oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    "m001": "It is not allowed to assign new values to @action fields",
    "m002": "`runInAction` expects a function",
    "m003": "`runInAction` expects a function without arguments",
    "m004": "autorun expects a function",
    "m005": "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    "m006": "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    "m007": "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    "m008": "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    "m009": "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    "m010": "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    "m011": "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    "m012": "computed takes one or two arguments if used as function",
    "m013": "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    "m014": "extendObservable expected 2 or more arguments",
    "m015": "extendObservable expects an object as first argument",
    "m016": "extendObservable should not be used on maps, use map.merge instead",
    "m017": "all arguments of extendObservable should be objects",
    "m018": "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    "m019": "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    "m020": "modifiers can only be used for individual object properties",
    "m021": "observable expects zero or one arguments",
    "m022": "@observable can not be used on getters, use @computed instead",
    "m023": "Using `transaction` is deprecated, use `runInAction` or `(@)action` instead.",
    "m024": "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    "m025": "whyRun can only be used on reactions and computed values",
    "m026": "`action` can only be invoked on functions",
    "m028": "It is not allowed to set `useStrict` when a derivation is running",
    "m029": "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    "m030a": "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    "m030b": "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    "m031": "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    "m032": "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    "m033": "`observe` doesn't support the fire immediately property for observable maps.",
    "m034": "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    "m035": "Cannot make the designated object observable; it is not extensible",
    "m036": "It is not possible to get index atoms from arrays",
    "m037": "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    "m038": "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
    /**
     * This function is invoked once, when the property is added to a new instance.
     * When this happens is not strictly determined due to differences in TS and Babel:
     * Typescript: Usually when constructing the new instance
     * Babel, sometimes Typescript: during the first get / set
     * Both: when calling `runLazyInitializers(instance)`
     */
    onInitialize, get, set, enumerable, 
    /**
     * Can this decorator invoked with arguments? e.g. @decorator(args)
     */
    allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || arguments.length === 5 && argLen < 3) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, (initializer_1 ? initializer_1.call(instance) : value_1), customArgs, descriptor);
            });
            return {
                enumerable: enumerable, configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) { return classPropertyDecorator(target, key, descriptor, outerArgs, argLen); };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers && instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = (args && args.length === 1) ? args[0] : (value.name || key || "<unnamed action>");
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || ("Autorun@" + getNextId());
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = ("When@" + getNextId());
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || ("AutorunAsync@" + getNextId());
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() { func(r); }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name = opts.name || expression.name || effect.name || ("Reaction@" + getNextId());
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var nextValue;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var v = expression(r);
            changed = valueDidChange(opts.compareStructural, nextValue, v);
            nextValue = v;
        });
        if (firstTime && opts.fireImmediately)
            effect(nextValue, r);
        if (!firstTime && changed === true)
            effect(nextValue, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember result of the computation for duration of a batch, or being observed
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `compareStructural` property indicates whether the return values should be compared structurally.
     * Normally, a computed value will not notify an upstream observer if a newly produced value is strictly equal to the previously produced value.
     * However, enabling compareStructural can be convenient if you always produce an new aggregated object and don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, compareStructural, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.compareStructural = compareStructural;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = undefined;
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // just for small optimization, can be droped for simplicity
            // computed called outside of any mobx stuff. batch observing shuold be enough, don't need tracking
            // because it will never be called again inside this batch
            startBatch();
            if (shouldCompute(this))
                this.value = this.computeValue(false);
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var newValue = this.value = this.computeValue(true);
        return isCaughtException(newValue) || valueDidChange(this.compareStructural, newValue, oldValue);
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking ? "[active] the value of this computation is needed by a reaction" : this.isComputing ? "[get] The value of this computed was requested outside a reaction" : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING ? getMessage("m032") :
                " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + ((this.isComputing && isTracking) ? " (... or any observable accessed during the remainder of the current run)" : "") + "\n\t" + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
        * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
        * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
        * for callback details
        */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName]) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, false, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false);
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, compareStructural, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, compareStructural, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
        configurable: true,
        enumerable: true,
        get: function () {
            return this.$mobx.values[propName].get();
        },
        set: function (v) {
            setPropertyValue(this, propName, v);
        }
    });
}
function generateComputedPropConfig(propName) {
    return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
        configurable: true,
        enumerable: false,
        get: function () {
            return this.$mobx.values[propName].get();
        },
        set: function (v) {
            return this.$mobx.values[propName].set(v);
        }
    });
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name, newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy ? {
            type: "update",
            object: instance,
            oldValue: observable.value,
            name: name, newValue: newValue
        } : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy ? {
        type: "add",
        object: object, name: name, newValue: newValue
    } : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
    * Returns true if the provided value is reactive.
    * @param value object, function or array
    * @param propertyName if propertyName is specified, checkes whether value.propertyName is reactive.
    */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value.$mobx || isAtom(value) || isReaction(value) || isComputedValue(value);
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined)
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!(isObservableMap(target)), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param value the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var IObservableFactories = (function () {
    function IObservableFactories() {
    }
    IObservableFactories.prototype.box = function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    };
    IObservableFactories.prototype.shallowBox = function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    };
    IObservableFactories.prototype.array = function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    };
    IObservableFactories.prototype.shallowArray = function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    };
    IObservableFactories.prototype.map = function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    };
    IObservableFactories.prototype.shallowMap = function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    };
    IObservableFactories.prototype.object = function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    };
    IObservableFactories.prototype.shallowObject = function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    };
    IObservableFactories.prototype.ref = function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    };
    IObservableFactories.prototype.shallow = function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    };
    IObservableFactories.prototype.deep = function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    };
    IObservableFactories.prototype.struct = function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    };
    return IObservableFactories;
}());
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
// ES6 class methods aren't enumerable, can't use Object.keys
Object.getOwnPropertyNames(IObservableFactories.prototype)
    .filter(function (name) { return name !== "constructor"; })
    .forEach(function (name) { return observable[name] = IObservableFactories.prototype[name]; });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * @deprecated
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * Deprecated to simplify api; transactions offer no real benefit above actions.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    deprecated(getMessage("m023"));
    return runInTransaction.apply(undefined, arguments);
}
function runInTransaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    return executeAction("", action);
}

var ObservableMapMarker = {};
var ObservableMap = (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: this._data[key].value,
                name: key
            } : null;
            if (notifySpy)
                spyReportStart(change);
            runInTransaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "update",
                object: this,
                oldValue: observable$$1.value,
                name: name, newValue: newValue
            } : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        runInTransaction(function () {
            var observable$$1 = _this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false);
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            type: "add",
            object: this,
            name: name,
            newValue: newValue
        } : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        runInTransaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        runInTransaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        runInTransaction(function () {
            _this.clear();
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return res[key] = _this.get(key); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return this.name + "[{ " + this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") + " }]";
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit ? " (... and " + (things.length - limit) + "more)" : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
function valueDidChange(compareStructural, oldValue, newValue) {
    if (typeof oldValue === 'number' && isNaN(oldValue)) {
        return typeof newValue !== 'number' || !isNaN(newValue);
    }
    return compareStructural
        ? !deepEqual(oldValue, newValue)
        : oldValue !== newValue;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function getEnumerableKeys(obj) {
    var res = [];
    for (var key in obj)
        res.push(key);
    return res;
}
/**
 * Naive deepEqual. Doesn't check for prototype, non-enumerable or out-of-range properties on arrays.
 * If you have such a case, you probably should use this function but something fancier :).
 */
function deepEqual(a, b) {
    if (a === null && b === null)
        return true;
    if (a === undefined && b === undefined)
        return true;
    if (typeof a !== "object")
        return a === b;
    var aIsArray = isArrayLike(a);
    var aIsMap = isMapLike(a);
    if (aIsArray !== isArrayLike(b)) {
        return false;
    }
    else if (aIsMap !== isMapLike(b)) {
        return false;
    }
    else if (aIsArray) {
        if (a.length !== b.length)
            return false;
        for (var i = a.length - 1; i >= 0; i--)
            if (!deepEqual(a[i], b[i]))
                return false;
        return true;
    }
    else if (aIsMap) {
        if (a.size !== b.size)
            return false;
        var equals_1 = true;
        a.forEach(function (value, key) {
            equals_1 = equals_1 && deepEqual(b.get(key), value);
        });
        return equals_1;
    }
    else if (typeof a === "object" && typeof b === "object") {
        if (a === null || b === null)
            return false;
        if (isMapLike(a) && isMapLike(b)) {
            if (a.size !== b.size)
                return false;
            // Freaking inefficient.... Create PR if you run into this :) Much appreciated!
            return deepEqual(observable.shallowMap(a).entries(), observable.shallowMap(b).entries());
        }
        if (getEnumerableKeys(a).length !== getEnumerableKeys(b).length)
            return false;
        for (var prop in a) {
            if (!(prop in b))
                return false;
            if (!deepEqual(a[prop], b[prop]))
                return false;
        }
        return true;
    }
    return false;
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isMapLike(x) {
    return isES6Map(x) || isObservableMap(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? ("" + value) : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
function shareGlobalState() {
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didnt add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesnt have holes
        if (filler !== node) {
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, shuold only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE)
            d.onBecomeStale();
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE)
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // shallow dependency changed
    // will need to recompute when it's needed
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var CaughtException = (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out wether any dependency of derivation actually changed
 * If dependenciesState is 1 it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over dependencies in the same order they were reported and stoping on first change
 * all recalculations are called only for ComputedValues that will be tracked anyway by derivation.
 * That is because we assume that if first x dependencies of derivation doesn't change
 * than derivation shuold run the same way up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE: return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE: return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = derivation.observing = derivation.newObserving;
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurence, change to 1 and keep it
    //   1: extra occurence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations might become stale during this derivation computation
    // so say had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

var Reaction = (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brough you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                startBatch();
                clearObserving(this); // if disposed while running, clean up later. Maybe not optimal, but rare case
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return ("\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed ? "stopped" : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + ((this._isRunning) ? " (... or any observable accessed during the remainder of the current run)" : "") + "\n\t" + getMessage("m038") + "\n");
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations."
                + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(compareStructural) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, compareStructural, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined)
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(false);
var computedStructDecorator = createComputedDecorator(true);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = (function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    return new ComputedValue(arg1, opts.context, opts.compareStructural || opts.struct || false, opts.name || arg1.name || "", opts.setter);
});
computed.struct = computedStructDecorator;

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
    * expr can be used to create temporarily views inside views.
    * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
    *
    * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
    * instead it will only rerenders when the current todo is (de)selected.
    *
    * reactiveComponent((props) => {
    *     const todo = props.todo;
    *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
    *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
    * });
    *
    */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

// internal overload
function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return res_1[key] = toJS(value, detectCycles, __alreadySeen); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, false, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === 'string' || typeof object === 'number')
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    switch (arguments.length) {
        case 0:
            thing = globalState.trackingDerivation;
            if (!thing)
                return log(getMessage("m024"));
            break;
        case 2:
            thing = getAtom(thing, prop);
            break;
    }
    thing = getAtom(thing);
    if (isComputedValue(thing))
        return log(thing.whyRun());
    else if (isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom, BaseAtom: BaseAtom,
    useStrict: useStrict, isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    asReference: asReference, asFlat: asFlat, asStructure: asStructure, asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap, isObservableMap: isObservableMap, map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable, extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun, autorunAsync: autorunAsync, when: when, reaction: reaction,
    action: action, isAction: isAction, runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras,
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn('Using default export (`import mobx from \'mobx\'`) is deprecated ' +
                    'and won’t work in mobx@4.0.0\n' +
                    'Use `import * as mobx from \'mobx\'` instead');
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* harmony default export */ __webpack_exports__["default"] = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(174)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports, __webpack_require__(3), __webpack_require__(0), __webpack_require__(30)) :
	typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
	(factory((global.mobxReact = global.mobxReact || {}),global.mobx,global.React,global.ReactDOM));
}(this, (function (exports,mobx,React,ReactDOM) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;
var ReactDOM__default = 'default' in ReactDOM ? ReactDOM['default'] : ReactDOM;

var empty = {};

var empty_1 = empty.unstable_batchedUpdates;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
  function EventEmitter() {
    classCallCheck(this, EventEmitter);
    this.listeners = [];
  }

  createClass(EventEmitter, [{
    key: "on",
    value: function on(cb) {
      var _this = this;

      this.listeners.push(cb);
      return function () {
        var index = _this.listeners.indexOf(cb);
        if (index !== -1) _this.listeners.splice(index, 1);
      };
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (fn) {
        return fn(data);
      });
    }
  }]);
  return EventEmitter;
}();

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    return mobx.untracked(function () {
      componentName = componentName || '<<anonymous>>';
      propFullName = propFullName || propName;
      if (props[propName] == null) {
        if (isRequired) {
          var actual = props[propName] === null ? 'null' : 'undefined';
          return new Error('The ' + location + ' `' + propFullName + '` is marked as required ' + 'in `' + componentName + '`, but its value is `' + actual + '`.');
        }
        return null;
      } else {
        return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
      }
    });
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    return mobx.untracked(function () {
      if (allowNativeType) {
        if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
      }
      var mobxChecker = void 0;
      switch (mobxType) {
        case 'Array':
          mobxChecker = mobx.isObservableArray;break;
        case 'Object':
          mobxChecker = mobx.isObservableObject;break;
        case 'Map':
          mobxChecker = mobx.isObservableMap;break;
        default:
          throw new Error('Unexpected mobxType: ' + mobxType);
      }
      var propValue = props[propName];
      if (!mobxChecker(propValue)) {
        var preciseType = getPreciseType(propValue);
        var nativeTypeExpectationMessage = allowNativeType ? ' or javascript `' + mobxType.toLowerCase() + '`' : '';
        return new Error('Invalid prop `' + propFullName + '` of type `' + preciseType + '` supplied to' + ' `' + componentName + '`, expected `mobx.Observable' + mobxType + '`' + nativeTypeExpectationMessage + '.');
      }
      return null;
    });
  });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
      rest[_key2 - 5] = arguments[_key2];
    }

    return mobx.untracked(function () {
      if (typeof typeChecker !== 'function') {
        return new Error('Property `' + propFullName + '` of component `' + componentName + '` has ' + 'invalid PropType notation.');
      }
      var error = createObservableTypeCheckerCreator(allowNativeType, 'Array')(props, propName, componentName);
      if (error instanceof Error) return error;
      var propValue = props[propName];
      for (var i = 0; i < propValue.length; i++) {
        error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + '[' + i + ']'].concat(rest));
        if (error instanceof Error) return error;
      }
      return null;
    });
  });
}

var observableArray = createObservableTypeCheckerCreator(false, 'Array');
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, 'Map');
var observableObject = createObservableTypeCheckerCreator(false, 'Object');
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, 'Array');
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, 'Object');



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

var index = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};

function isStateless(component) {
  // `function() {}` has prototype, but `() => {}` doesn't
  // `() => {}` via Babel has prototype too.
  return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
  mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
  contextTypes: {
    get: function get$$1() {
      return injectorContextTypes;
    },
    set: function set$$1(_) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: true,
    enumerable: false
  },
  isMobxInjector: {
    value: true,
    writable: true,
    configurable: true,
    enumerable: true
  }
};

/**
 * Store Injection
 */
function createStoreInjector(grabStoresFn, component, injectNames) {
  var _class, _temp2;

  var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
  if (injectNames) displayName += "-with-" + injectNames;

  var Injector = (_temp2 = _class = function (_Component) {
    inherits(Injector, _Component);

    function Injector() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, Injector);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
        _this.wrappedInstance = instance;
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Injector, [{
      key: 'render',
      value: function render() {
        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
        // See this test: 'using a custom injector is not too reactive' in inject.js
        var newProps = {};
        for (var key in this.props) {
          if (this.props.hasOwnProperty(key)) {
            newProps[key] = this.props[key];
          }
        }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
        for (var _key2 in additionalProps) {
          newProps[_key2] = additionalProps[_key2];
        }

        if (!isStateless(component)) {
          newProps.ref = this.storeRef;
        }

        return React__default.createElement(component, newProps);
      }
    }]);
    return Injector;
  }(React.Component), _class.displayName = displayName, _temp2);

  // Static fields from component should be visible on the generated Injector

  index(Injector, component);

  Injector.wrappedComponent = component;
  Object.defineProperties(Injector, proxiedInjectorProps);

  return Injector;
}

function grabStoresByName(storeNames) {
  return function (baseStores, nextProps) {
    storeNames.forEach(function (storeName) {
      if (storeName in nextProps) // prefer props over stores
        return;
      if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
      nextProps[storeName] = baseStores[storeName];
    });
    return nextProps;
  };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
  var grabStoresFn = void 0;
  if (typeof arguments[0] === "function") {
    grabStoresFn = arguments[0];
    return function (componentClass) {
      var injected = createStoreInjector(grabStoresFn, componentClass);
      injected.isMobxInjector = false; // supress warning
      // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
      // see #111
      injected = observer(injected);
      injected.isMobxInjector = true; // restore warning
      return injected;
    };
  } else {
    var storeNames = [];
    for (var i = 0; i < arguments.length; i++) {
      storeNames[i] = arguments[i];
    }grabStoresFn = grabStoresByName(storeNames);
    return function (componentClass) {
      return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
    };
  }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode(component) {
  if (ReactDOM__default) {
    try {
      return ReactDOM__default.findDOMNode(component);
    } catch (e) {
      // findDOMNode will throw in react-test-renderer, see:
      // See https://github.com/mobxjs/mobx-react/issues/216
      // Is there a better heuristic?
      return null;
    }
  }
  return null;
}

function reportRendering(component) {
  var node = findDOMNode(component);
  if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

  renderReporter.emit({
    event: 'render',
    renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
    totalTime: Date.now() - component.__$mobRenderStart,
    component: component,
    node: node
  });
}

function trackComponents() {
  if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
  if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
  isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
  var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var base = target[funcName];
  var mixinFunc = reactiveMixin[funcName];
  var f = !base ? mixinFunc : runMixinFirst === true ? function () {
    mixinFunc.apply(this, arguments);
    base.apply(this, arguments);
  } : function () {
    base.apply(this, arguments);
    mixinFunc.apply(this, arguments);
  };

  // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
  // ...but that breaks react-hot-loader, see #231...
  target[funcName] = f;
}

function isObjectShallowModified(prev, next) {
  if (null == prev || null == next || (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) !== "object" || (typeof next === 'undefined' ? 'undefined' : _typeof(next)) !== "object") {
    return prev !== next;
  }
  var keys = Object.keys(prev);
  if (keys.length !== Object.keys(next).length) {
    return true;
  }
  var key = void 0;
  for (var i = keys.length - 1; i >= 0, key = keys[i]; i--) {
    if (next[key] !== prev[key]) {
      return true;
    }
  }
  return false;
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
  componentWillMount: function componentWillMount() {
    var _this = this;

    if (isUsingStaticRendering === true) return;
    // Generate friendly name for debugging
    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID;

    /**
     * If props are shallowly modified, react will render anyway,
     * so atom.reportChanged() should not result in yet another re-render
     */
    var skipRender = false;
    /**
     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
     * so detect these changes
     */
    var isForcingUpdate = false;

    function makePropertyObservableReference(propName) {
      var valueHolder = this[propName];
      var atom = new mobx.Atom("reactive " + propName);
      Object.defineProperty(this, propName, {
        configurable: true, enumerable: true,
        get: function get$$1() {
          atom.reportObserved();
          return valueHolder;
        },
        set: function set$$1(v) {
          if (!isForcingUpdate && isObjectShallowModified(valueHolder, v)) {
            valueHolder = v;
            skipRender = true;
            atom.reportChanged();
            skipRender = false;
          } else {
            valueHolder = v;
          }
        }
      });
    }

    // make this.props an observable reference, see #124
    makePropertyObservableReference.call(this, "props");
    // make state an observable reference
    makePropertyObservableReference.call(this, "state");

    // wire up reactive render
    var baseRender = this.render.bind(this);
    var reaction = null;
    var isRenderingPending = false;

    var initialRender = function initialRender() {
      reaction = new mobx.Reaction(initialName + '#' + rootNodeID + '.render()', function () {
        if (!isRenderingPending) {
          // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
          // This unidiomatic React usage but React will correctly warn about this so we continue as usual
          // See #85 / Pull #44
          isRenderingPending = true;
          if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
          if (_this.__$mobxIsUnmounted !== true) {
            // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
            // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
            // However, people also claim this migth happen during unit tests..
            var hasError = true;
            try {
              isForcingUpdate = true;
              if (!skipRender) React__default.Component.prototype.forceUpdate.call(_this);
              hasError = false;
            } finally {
              isForcingUpdate = false;
              if (hasError) reaction.dispose();
            }
          }
        }
      });
      reactiveRender.$mobx = reaction;
      _this.render = reactiveRender;
      return reactiveRender();
    };

    var reactiveRender = function reactiveRender() {
      isRenderingPending = false;
      var exception = undefined;
      var rendering = undefined;
      reaction.track(function () {
        if (isDevtoolsEnabled) {
          _this.__$mobRenderStart = Date.now();
        }
        try {
          rendering = mobx.extras.allowStateChanges(false, baseRender);
        } catch (e) {
          exception = e;
        }
        if (isDevtoolsEnabled) {
          _this.__$mobRenderEnd = Date.now();
        }
      });
      if (exception) {
        errorsReporter.emit(exception);
        throw exception;
      }
      return rendering;
    };

    this.render = initialRender;
  },

  componentWillUnmount: function componentWillUnmount() {
    if (isUsingStaticRendering === true) return;
    this.render.$mobx && this.render.$mobx.dispose();
    this.__$mobxIsUnmounted = true;
    if (isDevtoolsEnabled) {
      var node = findDOMNode(this);
      if (node && componentByNodeRegistery) {
        componentByNodeRegistery.delete(node);
      }
      renderReporter.emit({
        event: 'destroy',
        component: this,
        node: node
      });
    }
  },

  componentDidMount: function componentDidMount() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (isUsingStaticRendering) {
      console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    }
    // update on any state changes (as is the default)
    if (this.state !== nextState) {
      return true;
    }
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return isObjectShallowModified(this.props, nextProps);
  }
};

/**
 * Observer function / decorator
 */
function observer(arg1, arg2) {
  if (typeof arg1 === "string") {
    throw new Error("Store names should be provided as array");
  }
  if (Array.isArray(arg1)) {
    // component needs stores
    if (!warnedAboutObserverInjectDeprecation) {
      warnedAboutObserverInjectDeprecation = true;
      console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
    }
    if (!arg2) {
      // invoked as decorator
      return function (componentClass) {
        return observer(arg1, componentClass);
      };
    } else {
      return inject.apply(null, arg1)(observer(arg2));
    }
  }
  var componentClass = arg1;

  if (componentClass.isMobxInjector === true) {
    console.warn('Mobx observer: You are trying to use \'observer\' on a component that already has \'inject\'. Please apply \'observer\' before applying \'inject\'');
  }

  // Stateless function component:
  // If it is function but doesn't seem to be a react class constructor,
  // wrap it to a react class automatically
  if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React__default.Component.isPrototypeOf(componentClass)) {
    var _class, _temp;

    return observer((_temp = _class = function (_Component) {
      inherits(_class, _Component);

      function _class() {
        classCallCheck(this, _class);
        return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      createClass(_class, [{
        key: 'render',
        value: function render() {
          return componentClass.call(this, this.props, this.context);
        }
      }]);
      return _class;
    }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
  }

  if (!componentClass) {
    throw new Error("Please pass a valid component to 'observer'");
  }

  var target = componentClass.prototype || componentClass;
  mixinLifecycleEvents(target);
  componentClass.isMobXReactObserver = true;
  return componentClass;
}

function mixinLifecycleEvents(target) {
  patch(target, "componentWillMount", true);
  ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
    patch(target, funcName);
  });
  if (!target.shouldComponentUpdate) {
    target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
  }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
  var children = _ref.children;
  return children();
});

Observer.propTypes = {
  children: function children(propValue, key, componentName, location, propFullName) {
    if (typeof propValue[key] !== 'function') return new Error('Invalid prop `' + propFullName + '` of type `' + _typeof(propValue[key]) + '` supplied to' + ' `' + componentName + '`, expected `function`.');
  }
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
  inherits(Provider, _Component);

  function Provider() {
    classCallCheck(this, Provider);
    return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  createClass(Provider, [{
    key: 'render',
    value: function render() {
      return React__default.Children.only(this.props.children);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var stores = {};
      // inherit stores
      var baseStores = this.context.mobxStores;
      if (baseStores) for (var key in baseStores) {
        stores[key] = baseStores[key];
      }
      // add own stores
      for (var _key in this.props) {
        if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
      }return {
        mobxStores: stores
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Maybe this warning is too aggressive?
      if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
      if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
        if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
    }
  }]);
  return Provider;
}(React.Component), _class.contextTypes = {
  mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
  mobxStores: objectOrObservableObject.isRequired
}, _temp);

var TARGET_LIB_NAME = void 0;
TARGET_LIB_NAME = 'mobx-react';
if (!mobx) throw new Error(TARGET_LIB_NAME + ' requires the MobX package');
if (!React__default) throw new Error(TARGET_LIB_NAME + ' requires React to be available');

if ("browser" === 'browser' && typeof ReactDOM.unstable_batchedUpdates === "function") mobx.extras.setReactionScheduler(ReactDOM.unstable_batchedUpdates);
if (false) mobx.extras.setReactionScheduler(empty_1);

var onError = function onError(fn) {
  return errorsReporter.on(fn);
};

/* DevTool support */
if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ? 'undefined' : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === 'object') {
  var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx);
}

exports.propTypes = propTypes;
exports.PropTypes = propTypes;
exports.onError = onError;
exports['default'] = exports;
exports.observer = observer;
exports.Observer = Observer;
exports.renderReporter = renderReporter;
exports.componentByNodeRegistery = componentByNodeRegistery;
exports.trackComponents = trackComponents;
exports.useStaticRendering = useStaticRendering;
exports.Provider = Provider;
exports.inject = inject;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(292);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(291);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(114);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(114);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(175);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(418)();
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["prefix"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bsClass", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bsStyles", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bsSizes", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["getClassSet"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["splitBsProps"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["splitBsPropsAndOmit"] = splitBsPropsAndOmit;
/* harmony export (immutable) */ __webpack_exports__["addStyle"] = addStyle;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_curry", function() { return _curry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(29);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  !(props.bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = propType._values = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["a" /* SIZE_MAP */][size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["a" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var ToastStore_1 = __webpack_require__(286);
exports.TOKEN_SESSION_KEY = 'token';
// tslint:disable-next-line:no-any
var createJsonBlob = function (data) {
    return new Blob([JSON.stringify(data)], { type: 'application/json' });
};
var apiRoutes = {
    login: '/api/login',
    logout: '/api/logout',
    arbeitsmittel: '/api/aw/arbeitsmittel',
    orte: '/api/aw/orte',
    profil: '/api/profile',
    freigaben: '/api/profile/freigaben',
    objekte: '/api/aw/objekte',
    befugnisse: '/api/profile/befugnisse',
    dienstleistungen: '/api/profile/dienstleistungen',
    personalliste: '/api/user/personalliste',
    personallisteKategorie: '/api/user/personalliste',
    qmdokumentation: '/api/user/qmdokumentation',
    auftraege: '/api/aw/auftraege',
    lizenzauftraege: '/api/aw/lizenz/auftraege',
    vorgaenge: '/api/aw/vorgaenge',
    beurteilungaufstellflaecheFahrzeug: '/api/labor/ses/beurteilungaufstellflaeche/fahrzeug',
    beurteilungaufstellflaecheSep: '/api/labor/ses/beurteilungaufstellflaeche/sep',
    beurteilungaufstellflaecheKalibrierschein: '/api/labor/ses/beurteilungaufstellflaeche/kalibrierschein',
    auswertungMesswerte: '/api/labor/ses/beurteilungaufstellflaeche/auswertung',
    messwerteSesVorhanden: '/api/labor/ses/messwerte',
    versionsinfo: '/api/labor/versionsinfo',
    rechnungspositionen: '/api/aw/rechnungen/rechnungspositionen',
    rechnungsuebersicht: '/api/rechnungen/uebersicht',
    rechnungsdetail: '/api/rechnungen/rechnung',
    rechnungenauftrag: '/api/rechnungen/auftrag',
    rueckmeldung: '/api/rueckmeldung'
};
/**
 * Kapselklasse für Api/Backend Aufrufe
 */
var ApiStore = (function () {
    function ApiStore() {
        this.token = '';
        this.requestCount = 0;
        this.sessionMessage = '';
        this.loadToken();
    }
    ApiStore_1 = ApiStore;
    ApiStore.prototype.incrementRequestCount = function () {
        this.requestCount++;
    };
    ApiStore.prototype.decrementRequestCount = function () {
        if (this.requestCount <= 0) {
            this.requestCount = 0;
        }
        else {
            this.requestCount--;
        }
    };
    Object.defineProperty(ApiStore.prototype, "isLoading", {
        get: function () {
            return this.requestCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    ApiStore.prototype.loadToken = function () {
        var storedToken = window.localStorage.getItem(exports.TOKEN_SESSION_KEY);
        if (storedToken && storedToken.length > 0) {
            this.token = storedToken;
            this.sessionMessage = '';
        }
    };
    ApiStore.prototype.setToken = function (token) {
        if (token.length === 0) {
            throw new Error('Do not set empty tokens!');
        }
        window.localStorage.setItem(exports.TOKEN_SESSION_KEY, token);
        this.token = token;
    };
    ApiStore.prototype.deleteToken = function () {
        window.localStorage.removeItem(exports.TOKEN_SESSION_KEY);
        this.token = '';
        this.sessionMessage = '';
    };
    ApiStore.prototype.setSessionMessage = function (message) {
        this.sessionMessage = message;
    };
    ApiStore.prototype.getDefaultRequestOptions = function () {
        return (this.token && this.token.length > 0) ? {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.token
            }
        } : {};
    };
    ApiStore.prototype.getRouteErrorLabel = function (route) {
        if (route.startsWith(apiRoutes.auftraege)) {
            return 'beim Laden des Auftrags';
        }
        switch (route) {
            case apiRoutes.login:
                return 'beim Login';
            case apiRoutes.logout:
                return 'beim Logout';
            case apiRoutes.arbeitsmittel:
                return 'beim Laden der Arbeitsmittel';
            case apiRoutes.profil:
                return 'beim Laden des Benutzerprofils';
            case apiRoutes.befugnisse:
                return 'beim Laden der Befugnisse';
            case apiRoutes.dienstleistungen:
                return 'beim Laden der Dienstleistungen';
            case apiRoutes.dienstleistungen:
                return 'beim Laden der Aufträge';
            case apiRoutes.beurteilungaufstellflaecheFahrzeug:
            case apiRoutes.beurteilungaufstellflaecheSep:
                return 'beim Validieren der Messwerte';
            case apiRoutes.auswertungMesswerte:
                return 'beim Erzeugen der Auswertung';
            case apiRoutes.freigaben:
                return 'beim Laden der Freigaben';
            case apiRoutes.personalliste:
                return 'beim Laden der Personalliste';
            case apiRoutes.qmdokumentation:
                return 'beim Laden der QM-Dokumentation';
            default:
                return route;
        }
    };
    ApiStore.prototype.request = function (route, requestOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1, message, responseJson, e_2, message, showToast, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.incrementRequestCount();
                        return [4 /*yield*/, window.fetch(route, Object.assign({}, this.getDefaultRequestOptions(), requestOptions))];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.decrementRequestCount();
                        message = "Es ist ein Fehler " + this.getRouteErrorLabel(route) + " aufgetreten.";
                        this.toastStore.show({
                            kind: 'error',
                            message: message,
                            details: e_1.message
                        });
                        return [2 /*return*/, {
                                ok: false,
                                error: message
                            }];
                    case 3:
                        // Server Session abgelaufen => lokales token löschen
                        if ((response.status === 401 || response.status === 400) && route !== apiRoutes.login) {
                            this.deleteToken();
                        }
                        this.decrementRequestCount();
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, response.json()];
                    case 5:
                        responseJson = _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        message = "Es ist ein Fehler " + this.getRouteErrorLabel(route) + " aufgetreten.";
                        this.toastStore.show({
                            kind: 'error',
                            message: message,
                            details: e_2.message
                        });
                        return [2 /*return*/, {
                                ok: false,
                                error: message
                            }];
                    case 7:
                        if ('error' in responseJson) {
                            showToast = true;
                            if (responseJson.error) {
                                switch (responseJson.error) {
                                    case 'session_expired':
                                        this.setSessionMessage('Sitzung abgelaufen. Bitte melden Sie sich neu an.');
                                        showToast = false;
                                        break;
                                    case 'session_invalid':
                                        this.setSessionMessage('Sitzung ungültig. Bitte melden Sie sich neu an.');
                                        showToast = false;
                                        break;
                                    default:
                                        this.setSessionMessage('');
                                }
                            }
                            if (showToast) {
                                this.toastStore.show({
                                    kind: 'error',
                                    message: responseJson.error,
                                    details: JSON.stringify(responseJson)
                                });
                            }
                            return [2 /*return*/, {
                                    ok: false,
                                    error: responseJson.error
                                }];
                        }
                        else if (response.status !== 200) {
                            message = "Es ist ein Fehler " + this.getRouteErrorLabel(route) + " aufgetreten.";
                            this.toastStore.show({
                                kind: 'error',
                                message: message,
                                details: JSON.stringify(responseJson)
                            });
                            return [2 /*return*/, {
                                    ok: false,
                                    error: message
                                }];
                        }
                        else {
                            return [2 /*return*/, {
                                    ok: true,
                                    json: responseJson
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ApiStore.prototype.login = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.login, {
                            method: 'POST',
                            body: createJsonBlob({
                                username: username,
                                password: password,
                                application: 'LaborPortal',
                                applicationrole: 'AppLaborPortal'
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.logout, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.arbeitsmittel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.arbeitsmittel, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.arbeitsmittelDetail = function (arbeitsmittelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.arbeitsmittel + "/" + arbeitsmittelId, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.orte = function (typ) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.orte + "?typ=" + typ, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.profil = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.profil, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.freigaben = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.freigaben, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.personallistekategorie = function (kategorie) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.personallisteKategorie + "/" + kategorie, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.befugnisse = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.befugnisse, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.dienstleistungen = function (kategorie) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.dienstleistungen + "?kategorie=" + kategorie, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftraege = function (pageNumber, filter, status, lizenz) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = apiRoutes.auftraege + "?page=" + pageNumber;
                        if (lizenz) {
                            url = apiRoutes.lizenzauftraege + "?page=" + pageNumber;
                        }
                        if (filter !== '') {
                            url += "&filter=" + filter;
                        }
                        if (status !== '') {
                            url += "&status=" + status;
                        }
                        return [4 /*yield*/, this.request(url, {
                                method: 'GET'
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.lizenzauftraege = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.lizenzauftraege, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftraegeanzahl = function (status) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/aw/auftraegeanzahl?status=" + status, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftraegemesswerte = function (kategorie) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/auftraege/messwerte/" + kategorie, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.objekte = function (typ, pageNumber, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = apiRoutes.objekte + "?typ=" + typ + "&page=" + pageNumber;
                        if (filter !== '') {
                            url += "&filter=" + filter;
                        }
                        return [4 /*yield*/, this.request(url, {
                                method: 'GET'
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.objektVorlagen = function (kategorie) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.objekte + "/vorlagen/" + kategorie, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.objektVorlage = function (objektGuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/aw/objekte/" + objektGuid + "/vorlage", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.objektStatus = function (objektGuid, status) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/aw/objekte/" + objektGuid + "/status", {
                            method: 'POST',
                            body: createJsonBlob({
                                status: status
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.objektAnlegen = function (objekt, auftragId, vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.objekte, {
                            method: 'POST',
                            body: createJsonBlob({
                                objekt: objekt,
                                auftragGuid: auftragId,
                                vorgangGuid: vorgangId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragAnlegen = function (daten) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege, {
                            method: 'POST',
                            body: createJsonBlob(daten)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragDetailsAaendern = function (auftragsId, daten) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragsId + "/details", {
                            method: 'POST',
                            body: createJsonBlob(daten)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragAdresseAendern = function (auftragsId, adressArt, daten) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragsId + "/adresse/" + adressArt, {
                            method: 'POST',
                            body: createJsonBlob(daten)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftraegeAendern = function (auftragsId, auftragName, metadaten, li) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragsId, {
                            method: 'PUT',
                            body: createJsonBlob({
                                auftragname: auftragName,
                                meta: metadaten,
                                lizenznehmer: li
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragDetails = function (auftragsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragsId, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragDokumente = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/dokumente", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragDokumentenSuche = function (auftragId, suchbegriff) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/dokumentensuche/" + suchbegriff, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragFormularDatenSuche = function (auftragId, kuerzel) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/formulardatensuchen/" + kuerzel, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragDienstleistungAnlegen = function (auftragId, dienstleistung) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/dienstleistungen", {
                            method: 'PUT',
                            body: createJsonBlob({
                                dienstleistungen: [
                                    dienstleistung
                                ]
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragDokumentDownloadUrl = function (auftragId, dokumentId) {
        return apiRoutes.auftraege + "/" + auftragId + "/dokumente/" + dokumentId + "/download?token=" + this.token;
    };
    ApiStore.prototype.auftragFolgeaAuftragAnlegen = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/folgeauftrag", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragAbschliessen = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/externabschliessen", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragZurueckstellen = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/zurueckstellen", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragInArbeit = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/inarbeit", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangDetails = function (vorgangsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangDokumente = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangId + "/dokumente", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangThumbnails = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangId + "/thumbnails", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangThumbnailPreviewUrl = function (vorgangId, thumbnailId) {
        return apiRoutes.vorgaenge + "/" + vorgangId + "/thumbnails/" + thumbnailId + "?token=" + this.token;
    };
    ApiStore.prototype.vorgangKorrigieren = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangId + "/korrektur", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangDokumentDownloadUrl = function (vorgangId, dokumentId) {
        return apiRoutes.vorgaenge + "/" + vorgangId + "/dokumente/" + dokumentId + "/download?token=" + this.token;
    };
    ApiStore.prototype.vorgangVorlage = function (vorgangsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/vorlage", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangVorlageErzeugen = function (vorgangsId, vorlage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/vorlage/erzeugen", {
                            method: 'POST',
                            body: createJsonBlob({
                                vorlage: vorlage
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangProtokollUpload = function (vorgangsId, titel, protokollDatei, vorgangAbschliessen) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new FormData();
                        data.append('file', protokollDatei);
                        data.append('titel', titel);
                        if (vorgangAbschliessen !== undefined) {
                            data.append('abschliessen', vorgangAbschliessen ? 'true' : 'false');
                        }
                        return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/vorlage/upload", {
                                method: 'POST',
                                body: data
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangDateiUpload = function (vorgangsId, titel, datei) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new FormData();
                        data.append('file', datei);
                        data.append('titel', titel);
                        return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/datei/upload", {
                                method: 'POST',
                                body: data
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangFotoUpload = function (vorgangsId, kategorie, files) {
        return __awaiter(this, void 0, void 0, function () {
            var data, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new FormData();
                        for (i = 0; i < files.length; i++) {
                            data.append("file" + i, files[i], files[i].name);
                        }
                        data.append('kategorie', kategorie);
                        return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/foto/upload", {
                                method: 'POST',
                                body: data
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangArbeitsmittel = function (vorgangsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/arbeitsmittel", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangArbeitsmittelEntfernen = function (vorgangsId, arbeitsmittelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/arbeitsmittel/" + arbeitsmittelId, {
                            method: 'DELETE'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangObjekte = function (vorgangsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/objekte", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangOrtSetzen = function (vorgangsId, ortsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/ort", {
                            method: 'POST',
                            body: createJsonBlob({
                                ortguid: ortsId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangObjektSetzen = function (vorgangsId, objektId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/objekt", {
                            method: 'POST',
                            body: createJsonBlob({
                                objektguid: objektId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangObjektEntfernen = function (vorgangsId, objektId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/objekt", {
                            method: 'DELETE',
                            body: createJsonBlob({
                                objektguid: objektId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangFormularEingaben = function (vorgangsId, formularDaten) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/formulareingaben", {
                            method: 'POST',
                            body: createJsonBlob({
                                formulardaten: formularDaten
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangFormularEingabenVollstaendig = function (vorgangsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/formulareingabenvollstaendig", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorgangAbschliessen = function (vorgangsId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangsId + "/status/abschliessen", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragObjektSetzen = function (auftragId, objektId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/objekt", {
                            method: 'POST',
                            body: createJsonBlob({
                                objektguid: objektId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.auftragObjektEntfernen = function (auftragId, objektId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/objekt", {
                            method: 'DELETE',
                            body: createJsonBlob({
                                objektguid: objektId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.beurteilungFahrzeugAufstellflaeche = function (messung) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.beurteilungaufstellflaecheFahrzeug, {
                            method: 'POST',
                            body: createJsonBlob(messung)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.beurteilungSepAufstellflaeche = function (messung) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.beurteilungaufstellflaecheSep, {
                            method: 'POST',
                            body: createJsonBlob(messung)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.erzeugeMessergebnisAuswertung = function (vorgangId, messwerteFahrzeug, messwerteSep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auswertungMesswerte, {
                            method: 'POST',
                            body: createJsonBlob({
                                vorgang: vorgangId,
                                messdaten: {
                                    fahrzeug: messwerteFahrzeug,
                                    sep: messwerteSep
                                }
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.messwerteSesVorhanden = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.messwerteSesVorhanden + "/" + vorgangId, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.ubernehmeMesswerteSes = function (vorgangId, auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/ses/messwerte/" + vorgangId + "/uebernehmen", {
                            method: 'POST',
                            body: createJsonBlob({
                                auftrag_quelle: auftragId
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.ergebnisBlockSes = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/ses/messwerte/ergebnisblock/" + vorgangId, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.beurteilungaufstellflaecheKalibrierschein = function (vorgang, auftrag) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.beurteilungaufstellflaecheKalibrierschein, {
                            method: 'POST',
                            body: createJsonBlob({
                                auftrag: auftrag,
                                vorgang: vorgang
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.eingabenAuswertungSesSpeichern = function (vorgangId, messwerteFahrzeug, messwerteSep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/ses/messwerte/eingabenspeichern/" + vorgangId, {
                            method: 'POST',
                            body: createJsonBlob({
                                vorgang: vorgangId,
                                messdaten: {
                                    fahrzeug: messwerteFahrzeug,
                                    sep: messwerteSep
                                }
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.eingabenAuswertungSesLaden = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/ses/messwerte/eingabenladen/" + vorgangId, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /* Beurteilung SES Richtlinie 2018 */
    ApiStore.prototype.beurteilungFahrzeugAufstellflaecheRili2018 = function (messung) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/api/labor/ses/beurteilungaufstellflaeche/rili2018/fahrzeug', {
                            method: 'POST',
                            body: createJsonBlob(messung)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.erzeugeDokumentAuswertungRili2018 = function (vorgangId, messwerteFahrzeug, messwerteSep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/api/labor/ses/beurteilungaufstellflaeche/rili2018/auswertung', {
                            method: 'POST',
                            body: createJsonBlob({
                                vorgang: vorgangId,
                                messdaten: {
                                    fahrzeug: messwerteFahrzeug,
                                    sep: messwerteSep
                                }
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /* Beurteilung SES Richtlinie 2025 */
    ApiStore.prototype.beurteilungFahrzeugAufstellflaecheRili2025 = function (messung) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/api/labor/ses/beurteilungaufstellflaeche/rili2025/fahrzeug', {
                            method: 'POST',
                            body: createJsonBlob(messung)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.erzeugeDokumentAuswertungRili2025 = function (vorgangId, messwerteFahrzeug, messwerteSep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/api/labor/ses/beurteilungaufstellflaeche/rili2025/auswertung', {
                            method: 'POST',
                            body: createJsonBlob({
                                vorgang: vorgangId,
                                messdaten: {
                                    fahrzeug: messwerteFahrzeug,
                                    sep: messwerteSep
                                }
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /* Sonstiges */
    ApiStore.prototype.auftragNichtErteilt = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.auftraege + "/" + auftragId + "/nichterteilt", {
                            method: 'POST'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.qmdokumentation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.qmdokumentation, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.qmDokumentDownloadUrl = function (befugnis, dateiname) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, apiRoutes.qmdokumentation + "/" + befugnis + "/" + dateiname + "?token=" + this.token];
            });
        });
    };
    ApiStore.prototype.rechnungspositionenDienstleistung = function (dienstleistung) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.rechnungspositionen + "/dienstleistung/" + dienstleistung, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.rechnungErzeugen = function (vorgangId, rechnungspositionen, mailRechnungsversand, rechnungPostalisch) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangId + "/abrechnen", {
                            method: 'POST',
                            body: createJsonBlob({
                                positionen: rechnungspositionen,
                                mail: mailRechnungsversand,
                                postalisch: rechnungPostalisch
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.sammelRechnungErzeugen = function (vorgangId, rechnungspositionen) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.vorgaenge + "/" + vorgangId + "/sammelabrechnen", {
                            method: 'POST',
                            body: createJsonBlob({
                                positionen: rechnungspositionen
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.versionsinfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.versionsinfo, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.feVersionsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/version.json', {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.rueckmeldung = function (betreff, nachricht) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("" + apiRoutes.rueckmeldung, {
                            method: 'POST',
                            body: createJsonBlob({
                                betreff: betreff,
                                nachricht: nachricht
                            })
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.benachrichtigung = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request('/api/user/benachrichtigung', {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.vorlagenElementImageUrl = function (elementId) {
        return "/api/aw/vorlagen/elemente/" + elementId + "/image?token=" + this.token;
    };
    // Öffentliche Routen
    ApiStore.prototype.publicAuftragDokumente = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/public/auftrag/" + auftragId + "/dokumente", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.publicAuftragDokumentDownloadUrl = function (auftragId, dokumentId) {
        return "/api/public/auftrag/" + auftragId + "/dokumente/" + dokumentId + "/download";
    };
    ApiStore.prototype.publicAuftragAnfrageFolgeAuftrag = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/public/auftrag/" + auftragId + "/anfragefolgeauftrag", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** Kalibrierung BPS Richtlinie */
    ApiStore.prototype.bpsReferenzkraftMesspunkte = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/bps/referenzkraft/messpunkte", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.bpsReferenzkraftBeurteilung = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/bps/referenzkraft/beurteilung", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** Kalibrierung BPS Richtlinie 2021 */
    ApiStore.prototype.bpsReferenzkraftMesspunkteRili2021 = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/bps/referenzkraft/2021/messpunkte", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.bpsReferenzkraftBeurteilungRili2021 = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/bps/referenzkraft/2021/beurteilung", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** Kalibrierung BPS Platte */
    ApiStore.prototype.bpsReferenzkraftMesspunktePlatte = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/bps/referenzkraft/platte/messpunkte", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.bpsReferenzkraftBeurteilungPlatte = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/bps/referenzkraft/platte/beurteilung", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** Kalibrierung AGT Partikelzähler */
    ApiStore.prototype.agtPartikelzaehlerChargingBeurteilung = function (messwerte) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/labor/agt/partikelzaehler/beurteilung", {
                            method: 'POST',
                            body: createJsonBlob(messwerte)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** Routen für Abruf der Stammdaten  */
    ApiStore.prototype.untersuchungsstelleVorhanden = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/stammdaten/untersuchungsstelle/" + id + "/vorhanden", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.untersuchungsstelleAdresse = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/stammdaten/untersuchungsstelle/" + id + "/adresse", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.adresseVorhanden = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/stammdaten/adresse/" + id + "/vorhanden", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.adresseDaten = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/stammdaten/adresse/" + id + "/daten", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.messmittelVorhanden = function (kategorie, id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/stammdaten/messmittel/" + kategorie + "/" + id + "/vorhanden", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.messmittelDaten = function (kategorie, id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request("/api/stammdaten/messmittel/" + kategorie + "/" + id + "/daten", {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.rechnungsuebersicht = function (pageNumber, filter, status, art) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = apiRoutes.rechnungsuebersicht + "?page=" + pageNumber;
                        if (filter !== '') {
                            url += "&filter=" + filter;
                        }
                        if (status !== null) {
                            url += "&status=" + status;
                        }
                        if (art !== null) {
                            url += "&art=" + art;
                        }
                        return [4 /*yield*/, this.request(url, {
                                method: 'GET'
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.rechnungDetail = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(apiRoutes.rechnungsdetail + "/" + id, {
                            method: 'GET'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ApiStore.prototype.rechnungenAuftrag = function (anr) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = apiRoutes.rechnungenauftrag + "/" + anr;
                        return [4 /*yield*/, this.request(url, {
                                method: 'GET'
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ApiStore.prototype, "token", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ApiStore.prototype, "requestCount", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ApiStore.prototype, "sessionMessage", void 0);
    __decorate([
        decorators_1.inject(ToastStore_1.ToastStore),
        __metadata("design:type", ToastStore_1.ToastStore)
    ], ApiStore.prototype, "toastStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ApiStore.prototype, "incrementRequestCount", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ApiStore.prototype, "decrementRequestCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ApiStore.prototype, "isLoading", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ApiStore.prototype, "loadToken", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ApiStore.prototype, "setToken", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ApiStore.prototype, "deleteToken", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ApiStore.prototype, "setSessionMessage", null);
    ApiStore = ApiStore_1 = __decorate([
        decorators_1.provideSingleton(ApiStore_1),
        __metadata("design:paramtypes", [])
    ], ApiStore);
    return ApiStore;
    var ApiStore_1;
}());
exports.ApiStore = ApiStore;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var createBrowserHistory_1 = __webpack_require__(199);
var mobx_react_router_1 = __webpack_require__(415);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
/**
 * Store für globale UI Funktionen sowie Routing
 */
var UiStore = (function () {
    function UiStore() {
        this.history = mobx_react_router_1.syncHistoryWithStore(createBrowserHistory_1.default(), new mobx_react_router_1.RouterStore());
        this.benachrichtigung = '';
    }
    UiStore_1 = UiStore;
    Object.defineProperty(UiStore.prototype, "isLoggedIn", {
        get: function () {
            return (this.apiStore.token !== '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiStore.prototype, "userDisplayName", {
        get: function () {
            return (this.userProfile) ? this.userProfile.vorname + " " + this.userProfile.nachname : '';
        },
        enumerable: true,
        configurable: true
    });
    UiStore.prototype.loadUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile, benachrichtigung;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.profil()];
                    case 1:
                        userProfile = _a.sent();
                        if (!userProfile.ok) return [3 /*break*/, 3];
                        this.setUserProfile(userProfile.json);
                        return [4 /*yield*/, this.apiStore.benachrichtigung()];
                    case 2:
                        benachrichtigung = _a.sent();
                        if (benachrichtigung.ok) {
                            this.setBenachrichtigung(benachrichtigung.json.text);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UiStore.prototype.setUserProfile = function (userProfile) {
        this.userProfile = userProfile;
    };
    UiStore.prototype.loadFreigaben = function () {
        return __awaiter(this, void 0, void 0, function () {
            var freigaben;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.freigaben()];
                    case 1:
                        freigaben = _a.sent();
                        if (freigaben.ok) {
                            this.setFreigaben(freigaben.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UiStore.prototype.setFreigaben = function (freigaben) {
        this.freigaben = freigaben;
    };
    UiStore.prototype.loadPersonallisteKategorie = function (kategorie) {
        return __awaiter(this, void 0, void 0, function () {
            var personalliste;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.personallistekategorie(kategorie)];
                    case 1:
                        personalliste = _a.sent();
                        if (personalliste.ok) {
                            this.setPersonalliste(personalliste.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UiStore.prototype.setPersonalliste = function (personalliste) {
        this.personalliste = personalliste;
    };
    UiStore.prototype.clearUserProfile = function () {
        this.userProfile = undefined;
        this.benachrichtigung = '';
    };
    UiStore.prototype.setBenachrichtigung = function (value) {
        this.benachrichtigung = value;
    };
    UiStore.prototype.navigateTo = function (page, replace) {
        if (replace === void 0) { replace = false; }
        var toPage = (page[0] === '/') ? page : this.history.location.pathname + "/" + page;
        if (replace) {
            this.history.replace(toPage);
        }
        else {
            this.history.push(toPage);
        }
    };
    UiStore.prototype.navigateBack = function () {
        this.history.goBack();
    };
    Object.defineProperty(UiStore.prototype, "currentLocation", {
        get: function () {
            return this.history.location;
        },
        enumerable: true,
        configurable: true
    });
    UiStore.prototype.login = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.login(username, password)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (response.json.token) {
                                this.apiStore.setToken(response.json.token);
                            }
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    UiStore.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.logout()];
                    case 1:
                        _a.sent();
                        this.clearUserProfile();
                        this.apiStore.deleteToken();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], UiStore.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UiStore.prototype, "userProfile", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UiStore.prototype, "freigaben", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], UiStore.prototype, "personalliste", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], UiStore.prototype, "benachrichtigung", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UiStore.prototype, "isLoggedIn", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UiStore.prototype, "userDisplayName", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UiStore.prototype, "setUserProfile", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UiStore.prototype, "setFreigaben", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UiStore.prototype, "setPersonalliste", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UiStore.prototype, "clearUserProfile", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], UiStore.prototype, "setBenachrichtigung", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UiStore.prototype, "currentLocation", null);
    UiStore = UiStore_1 = __decorate([
        decorators_1.provideSingleton(UiStore_1)
    ], UiStore);
    return UiStore;
    var UiStore_1;
}());
exports.UiStore = UiStore;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout = (function (_super) {
    __extends(Callout, _super);
    function Callout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Callout.prototype.render = function () {
        return (React.createElement("div", { className: "bs-callout bs-callout-" + this.props.bsStyle + " " + this.props.className }, this.props.children));
    };
    Callout.defaultProps = {
        bsStyle: 'default',
        className: ''
    };
    return Callout;
}(React.Component));
exports.default = Callout;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(34);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(107);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FaIcon = (function (_super) {
    __extends(FaIcon, _super);
    function FaIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FaIcon.prototype.render = function () {
        return (React.createElement("i", { className: "fa fa-" + this.props.icon + " fa-fw", style: this.props.style }));
    };
    return FaIcon;
}(React.Component));
exports.default = FaIcon;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SES_BAHN = 'ses_bahn';
exports.SES_TYP = 'ses_typ';
exports.SES_UST = 'ust';
exports.AGT_4GAS = '4gas';
exports.AGT_OPAZIMETER = 'opazimeter';
exports.AGT_KOMBI = 'kombi';
exports.AGT_PARTIKEL_DC = 'partikel_dc';
exports.AGT_PARTIKEL_CPC = 'partikel_cpc';
exports.AGT_UNBEKANNT = '';
exports.AUFTRAG_KATEGORIE_SES = 'ses';
var AdressArt;
(function (AdressArt) {
    AdressArt["Auftraggeber"] = "auftraggeber";
    AdressArt["Beauftragter"] = "beauftragter";
    AdressArt["Untersuchungsstelle"] = "beauftragter";
    AdressArt["Lieferadresse"] = "lieferadresse"; // = Beauftragter, abweichende Benennung für bessere Lesbarkeit
})(AdressArt = exports.AdressArt || (exports.AdressArt = {}));
var DokumentenStatus;
(function (DokumentenStatus) {
    DokumentenStatus[DokumentenStatus["NichtVorhanden"] = 0] = "NichtVorhanden";
    DokumentenStatus[DokumentenStatus["Angefordert"] = 1] = "Angefordert";
    DokumentenStatus[DokumentenStatus["Erzeugt"] = 2] = "Erzeugt";
})(DokumentenStatus = exports.DokumentenStatus || (exports.DokumentenStatus = {}));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
/** Singleton für aktuellen Vorgang */
var VorgangStore = (function () {
    function VorgangStore() {
        this.vorgang = undefined;
        this.vorlage = undefined;
        this.objekte = undefined;
    }
    VorgangStore_1 = VorgangStore;
    VorgangStore.prototype.setVorgang = function (vorgang) {
        this.vorgang = vorgang;
    };
    VorgangStore.prototype.setVorlage = function (vorlage) {
        this.vorlage = vorlage;
    };
    VorgangStore.prototype.setObjekte = function (objekte) {
        this.objekte = objekte;
    };
    VorgangStore.prototype.clearVorgang = function () {
        this.vorlage = undefined;
        this.vorgang = undefined;
    };
    VorgangStore.prototype.clearObjekte = function () {
        this.objekte = undefined;
    };
    VorgangStore.prototype.setAbgeschlossen = function () {
        if (this.vorgang && !this.vorgang.abgeschlossen) {
            this.vorgang.abgeschlossen = true;
        }
    };
    VorgangStore.prototype.loadVorgang = function (vorgangId, vorlageAbgefragtHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var response, vorlage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (vorlageAbgefragtHandler) {
                            vorlageAbgefragtHandler(false);
                        }
                        this.clearVorgang();
                        return [4 /*yield*/, this.apiStore.vorgangDetails(vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setVorgang(response.json);
                        }
                        return [4 /*yield*/, this.apiStore.vorgangVorlage(vorgangId)];
                    case 2:
                        vorlage = _a.sent();
                        if (vorlage.ok) {
                            this.setVorlage(vorlage.json);
                        }
                        if (vorlageAbgefragtHandler) {
                            vorlageAbgefragtHandler(true);
                        }
                        this.loadObjekte(vorgangId);
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangStore.prototype.loadObjekte = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var objektliste;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearObjekte();
                        return [4 /*yield*/, this.apiStore.vorgangObjekte(vorgangId)];
                    case 1:
                        objektliste = _a.sent();
                        if (objektliste.ok) {
                            this.setObjekte(objektliste.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangStore.prototype.messwerteSesVorhanden = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.messwerteSesVorhanden(vorgangId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, (response.ok && response.json.messwerte) ? true : false];
                }
            });
        });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorgangStore.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangStore.prototype, "vorgang", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangStore.prototype, "vorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangStore.prototype, "objekte", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangStore.prototype, "setVorgang", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangStore.prototype, "setVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangStore.prototype, "setObjekte", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorgangStore.prototype, "clearVorgang", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorgangStore.prototype, "clearObjekte", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorgangStore.prototype, "setAbgeschlossen", null);
    VorgangStore = VorgangStore_1 = __decorate([
        decorators_1.provideSingleton(VorgangStore_1)
    ], VorgangStore);
    return VorgangStore;
    var VorgangStore_1;
}());
exports.VorgangStore = VorgangStore;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var DOMProperty = __webpack_require__(70);
var ReactDOMComponentFlags = __webpack_require__(231);

var invariant = __webpack_require__(15);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var AuftragStore = (function () {
    function AuftragStore() {
        this.auftrag = undefined;
    }
    AuftragStore_1 = AuftragStore;
    AuftragStore.prototype.setAuftrag = function (auftrag) {
        this.auftrag = auftrag;
    };
    AuftragStore.prototype.clearAuftrag = function () {
        this.auftrag = undefined;
    };
    AuftragStore.prototype.loadAuftrag = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearAuftrag();
                        return [4 /*yield*/, this.apiStore.auftragDetails(auftragId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setAuftrag(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragStore.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragStore.prototype, "auftrag", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragStore.prototype, "setAuftrag", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragStore.prototype, "clearAuftrag", null);
    AuftragStore = AuftragStore_1 = __decorate([
        decorators_1.provideSingleton(AuftragStore_1)
    ], AuftragStore);
    return AuftragStore;
    var AuftragStore_1;
}());
exports.AuftragStore = AuftragStore;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMED_TAG = "named";
exports.NAME_TAG = "name";
exports.UNMANAGED_TAG = "unmanaged";
exports.OPTIONAL_TAG = "optional";
exports.INJECT_TAG = "inject";
exports.MULTI_INJECT_TAG = "multi_inject";
exports.TAGGED = "inversify:tagged";
exports.TAGGED_PROP = "inversify:tagged_props";
exports.PARAM_TYPES = "inversify:paramtypes";
exports.DESIGN_PARAM_TYPES = "design:paramtypes";
exports.POST_CONSTRUCT = "post_construct";


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(496);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = undefined;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function round(value, precision) {
    var factor = Math.pow(10, precision);
    var tempNumber = value * factor;
    var roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
}
exports.round = round;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var template_1 = __webpack_require__(413);
exports.DUPLICATED_INJECTABLE_DECORATOR = "Cannot apply @injectable decorator multiple times.";
exports.DUPLICATED_METADATA = "Metadata key was used more than once in a parameter:";
exports.NULL_ARGUMENT = "NULL argument";
exports.KEY_NOT_FOUND = "Key Not Found";
exports.AMBIGUOUS_MATCH = "Ambiguous match found for serviceIdentifier:";
exports.CANNOT_UNBIND = "Could not unbind serviceIdentifier:";
exports.NOT_REGISTERED = "No matching bindings found for serviceIdentifier:";
exports.MISSING_INJECTABLE_ANNOTATION = "Missing required @injectable annotation in:";
exports.MISSING_INJECT_ANNOTATION = "Missing required @inject or @multiInject annotation in:";
exports.CIRCULAR_DEPENDENCY = "Circular dependency found:";
exports.NOT_IMPLEMENTED = "Sorry, this feature is not fully implemented yet.";
exports.INVALID_BINDING_TYPE = "Invalid binding type:";
exports.NO_MORE_SNAPSHOTS_AVAILABLE = "No snapshot available to restore.";
exports.INVALID_MIDDLEWARE_RETURN = "Invalid return type in middleware. Middleware must return!";
exports.INVALID_FUNCTION_BINDING = "Value provided to function binding must be a function!";
exports.INVALID_TO_SELF_VALUE = "The toSelf function can only be applied when a constructor is " +
    "used as service identifier";
exports.INVALID_DECORATOR_OPERATION = "The @inject @multiInject @tagged and @named decorators " +
    "must be applied to the parameters of a class constructor or a class property.";
exports.ARGUMENTS_LENGTH_MISMATCH_1 = "The number of constructor arguments in the derived class ";
exports.ARGUMENTS_LENGTH_MISMATCH_2 = " must be >= than the number of constructor arguments of its base class.";
exports.CONTAINER_OPTIONS_MUST_BE_AN_OBJECT = "Invalid Container constructor argument. Container options " +
    "must be an object.";
exports.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE = "Invalid Container option. Default scope must " +
    "be a string ('singleton' or 'transient').";
exports.MULTIPLE_POST_CONSTRUCT_METHODS = "Cannot apply @postConstruct decorator multiple times in the same class";
exports.POST_CONSTRUCT_ERROR = (_a = ["@postConstruct error in class ", ": ", ""], _a.raw = ["@postConstruct error in class ", ": ", ""], template_1.template(_a, 0, 1));
var _a;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(27);
var Metadata = (function () {
    function Metadata(key, value) {
        this.key = key;
        this.value = value;
    }
    Metadata.prototype.toString = function () {
        if (this.key === METADATA_KEY.NAMED_TAG) {
            return "named: " + this.value.toString() + " ";
        }
        else {
            return "tagged: { key:" + this.key.toString() + ", value: " + this.value + " }";
        }
    };
    return Metadata;
}());
exports.Metadata = Metadata;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 39 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(124)('wks')
  , uid        = __webpack_require__(90)
  , Symbol     = __webpack_require__(47).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);









var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SafeAnchor);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'disabled']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pointerEvents: 'none' }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.handleClick
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var CallbackQueue = __webpack_require__(229);
var PooledClass = __webpack_require__(61);
var ReactFeatureFlags = __webpack_require__(234);
var ReactReconciler = __webpack_require__(71);
var Transaction = __webpack_require__(101);

var invariant = __webpack_require__(15);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var PooledClass = __webpack_require__(61);

var emptyFunction = __webpack_require__(34);
var warning = __webpack_require__(17);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var KalibrierGegenstand_1 = __webpack_require__(112);
var round_1 = __webpack_require__(33);
var ApiStore_1 = __webpack_require__(13);
var VorgangStore_1 = __webpack_require__(22);
/**
 * Singleton für globale Eigenschaften zur BPS Kalibrierung mit Referenzkraft-Verfahren
 */
var BpsReferenzkraftKalibrierungStore = (function () {
    function BpsReferenzkraftKalibrierungStore() {
        this.objektVorlage = undefined;
        this.kalibrierGegenstand = undefined;
        this.justage = false;
        this.readOnly = false;
        // @todo: Naming
        this.muAbrufTimeoutRef = 0;
        this.datensatz = {
            version: 1,
            rollendurchmesser: {
                messwerte: [[undefined, undefined, undefined], [undefined, undefined, undefined], [undefined, undefined, undefined], [undefined, undefined, undefined]],
                mittelwert: {
                    links: undefined,
                    rechts: undefined
                }
            },
            oberflaeche: 'beschichtet',
            messart: 'durchmesser',
            messbereich: undefined,
            messbereichKlein: undefined,
            messbereichGross: undefined,
            anzeige: undefined,
            rollensatz: {
                links: {
                    position: 'links',
                    messpunkte: [],
                    vorbelastung: {
                        messpunkte: [
                            { anzeige: null, normal: null },
                            { anzeige: null, normal: null }
                        ]
                    }
                },
                rechts: {
                    position: 'rechts',
                    messpunkte: [],
                    vorbelastung: {
                        messpunkte: [
                            { anzeige: null, normal: null },
                            { anzeige: null, normal: null }
                        ]
                    }
                }
            },
            pruefortparameter: {
                beginn: {
                    luftfeuchtigkeit: {
                        wert: null,
                        min: 0,
                        max: 85
                    },
                    lufttemperatur: {
                        wert: null,
                        min: 5,
                        max: 35
                    }
                },
                ende: {
                    luftfeuchtigkeit: {
                        wert: null,
                        min: 0,
                        max: 85
                    },
                    lufttemperatur: {
                        wert: null,
                        min: 5,
                        max: 35
                    }
                }
            },
            waegezelle: {
                messwerte: [undefined, undefined, undefined],
                sollwert: 49,
                toleranz: 1
            },
            drehzahlschlupf: {
                links: {
                    geschwindigkeit: [undefined, undefined],
                    schlupf: null
                },
                rechts: {
                    geschwindigkeit: [undefined, undefined],
                    schlupf: null
                },
                mingeschwindigkeit: 2,
                maxschlupf: 30
            }
        };
        this.messbereiche = [4, 5, 6, 8, 12, 25, 30, 40];
    }
    BpsReferenzkraftKalibrierungStore_1 = BpsReferenzkraftKalibrierungStore;
    BpsReferenzkraftKalibrierungStore.prototype.clear = function () {
        this.datensatz = {
            version: 1,
            rollendurchmesser: {
                messwerte: [[undefined, undefined, undefined], [undefined, undefined, undefined], [undefined, undefined, undefined], [undefined, undefined, undefined]],
                mittelwert: {
                    links: undefined,
                    rechts: undefined
                }
            },
            oberflaeche: 'beschichtet',
            messart: 'durchmesser',
            messbereich: undefined,
            messbereichKlein: undefined,
            messbereichGross: undefined,
            anzeige: undefined,
            rollensatz: {
                links: {
                    position: 'links',
                    messpunkte: [],
                    vorbelastung: {
                        messpunkte: [
                            { anzeige: null, normal: null },
                            { anzeige: null, normal: null }
                        ]
                    }
                },
                rechts: {
                    position: 'rechts',
                    messpunkte: [],
                    vorbelastung: {
                        messpunkte: [
                            { anzeige: null, normal: null },
                            { anzeige: null, normal: null }
                        ]
                    }
                }
            },
            pruefortparameter: {
                beginn: {
                    luftfeuchtigkeit: {
                        wert: null,
                        min: 0,
                        max: 85
                    },
                    lufttemperatur: {
                        wert: null,
                        min: 5,
                        max: 35
                    }
                },
                ende: {
                    luftfeuchtigkeit: {
                        wert: null,
                        min: 0,
                        max: 85
                    },
                    lufttemperatur: {
                        wert: null,
                        min: 5,
                        max: 35
                    }
                }
            },
            waegezelle: {
                messwerte: [undefined, undefined, undefined],
                sollwert: 49,
                toleranz: 1
            },
            drehzahlschlupf: {
                links: {
                    geschwindigkeit: [undefined, undefined],
                    schlupf: null
                },
                rechts: {
                    geschwindigkeit: [undefined, undefined],
                    schlupf: null
                },
                mingeschwindigkeit: 2,
                maxschlupf: 30
            }
        };
    };
    /**
     * Ruft mit der aktuellen Eingabe Sollwerte aus dem Back-End ab
     */
    BpsReferenzkraftKalibrierungStore.prototype.messpunkteAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, datensatz, kalibrierGegenstand, messwerte, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
                        if (!(kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich && datensatz.rollendurchmesser.mittelwert.links && datensatz.rollendurchmesser.mittelwert.rechts)) return [3 /*break*/, 2];
                        if ((datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichKlein) {
                            // @todo: reset
                            return [2 /*return*/];
                        }
                        if ((datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichGross) {
                            // @todo: reset
                            return [2 /*return*/];
                        }
                        messwerte = {
                            mittelwerte: {
                                links: datensatz.rollendurchmesser.mittelwert.links,
                                rechts: datensatz.rollendurchmesser.mittelwert.rechts
                            },
                            messbereich: datensatz.messbereich,
                            messbereiche: {
                                klein: datensatz.messbereichKlein,
                                gross: datensatz.messbereichGross
                            },
                            objekt: kalibrierGegenstand.objekt.objektguid
                        };
                        return [4 /*yield*/, this.apiStore.bpsReferenzkraftMesspunkte(messwerte)];
                    case 1:
                        response = _b.sent();
                        if (response.ok) {
                            return [2 /*return*/, response];
                        }
                        _b.label = 2;
                    case 2: 
                    // @todo: Hinweis/Ergebnis bereinigen
                    return [2 /*return*/, undefined];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMesspunkt = function (ziel, anzeige, normal, fehlergrenze) {
        if (ziel) {
            ziel.anzeige = anzeige;
            ziel.normal = normal;
            ziel.fehlergrenze = fehlergrenze;
        }
    };
    /**
     * Aktualisiert die Sollwerte für bereits angelegte Messpunkte
     */
    BpsReferenzkraftKalibrierungStore.prototype.messpunkteAktualisieren = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, datensatz, messpunkte;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.messpunkteAbrufen()];
                    case 1:
                        response = _a.sent();
                        datensatz = this.datensatz;
                        if (response && response.ok) {
                            messpunkte = response.json;
                            // @todo: check if count of measurement points align
                            messpunkte.forEach(function (mp, index) {
                                _this.setMesspunkt(datensatz.rollensatz.links.messpunkte[index], mp.anzeige, mp.normal.links, mp.fehlergrenze);
                                _this.setMesspunkt(datensatz.rollensatz.rechts.messpunkte[index], mp.anzeige, mp.normal.rechts, mp.fehlergrenze);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Anfang Beurteilungen abrufen */
    /**
     * @todo: document
     */
    BpsReferenzkraftKalibrierungStore.prototype.beurteilungAbrufen = function (ziel) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var nullpunktVollstaendig, kmg, messwerte, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // @todo: prüfen ob daten vorhanden
                        if (ziel.messpunkte.length === 0) {
                            return [2 /*return*/];
                        }
                        nullpunktVollstaendig = ziel.messpunkte[0].messwerte.every(function (wert) { return wert !== null; });
                        if (!this.kalibrierGegenstand || !this.kalibrierGegenstand.objekt) {
                            return [2 /*return*/];
                        }
                        if (!nullpunktVollstaendig) {
                            ziel.messpunkte.forEach(function (element, index) {
                                _this.beurteilungMesspunktLoeschen(ziel, index);
                            });
                            return [2 /*return*/];
                        }
                        kmg = this.kraftMessGeraet();
                        if (!kmg) {
                            return [2 /*return*/];
                        }
                        messwerte = {
                            mittelwerte: {
                                links: this.datensatz.rollendurchmesser.mittelwert.links,
                                rechts: this.datensatz.rollendurchmesser.mittelwert.rechts
                            },
                            position: ziel.position,
                            messbereich: this.datensatz.messbereich,
                            messbereiche: {
                                klein: this.datensatz.messbereichKlein,
                                gross: this.datensatz.messbereichGross
                            },
                            messwerte: [],
                            objekt: this.kalibrierGegenstand.objekt.objektguid,
                            kmg: kmg.arbeitsmittelguid
                        };
                        ziel.messpunkte.forEach(function (mp) {
                            messwerte.messwerte.push({
                                messwerte: mp.messwerte,
                                fehlergrenze: mp.fehlergrenze,
                                messunsicherheit: mp.messunsicherheit,
                                abweichung: mp.mittelwertabweichung
                            });
                        });
                        return [4 /*yield*/, this.apiStore.bpsReferenzkraftBeurteilung(messwerte)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.length > 0) {
                            response.json.forEach(function (element, index) {
                                _this.beurteilungMesspunktSetzen(ziel, index, element);
                            });
                        }
                        else {
                            // @todo: Hinweis/Ergebnis bereinigen
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @todo: document
     */
    BpsReferenzkraftKalibrierungStore.prototype.beurteilungAbrufenGesamt = function () {
        var _this = this;
        [this.datensatz.rollensatz.links, this.datensatz.rollensatz.rechts].forEach(function (rs) {
            _this.beurteilungAbrufen(rs);
        });
    };
    BpsReferenzkraftKalibrierungStore.prototype.beurteilungMesspunktSetzen = function (ziel, index, beurteilung) {
        ziel.messpunkte[index].messunsicherheit = beurteilung.messunsicherheit;
        ziel.messpunkte[index].konformitaet = beurteilung.konformitaet;
        ziel.messpunkte[index].mittelwertabweichung = beurteilung.mittelwertabweichung;
    };
    BpsReferenzkraftKalibrierungStore.prototype.beurteilungMesspunktLoeschen = function (ziel, index) {
        ziel.messpunkte[index].messunsicherheit = null;
        ziel.messpunkte[index].konformitaet = null;
        ziel.messpunkte[index].mittelwertabweichung = null;
    };
    /**
     * @todo: document
     */
    BpsReferenzkraftKalibrierungStore.prototype.beurteilungAbrufenDelayed = function (ziel) {
        var _this = this;
        if (this.muAbrufTimeoutRef > 0) {
            window.clearTimeout(this.muAbrufTimeoutRef);
            this.muAbrufTimeoutRef = 0;
        }
        var validateTimeoutInMs = 400;
        this.muAbrufTimeoutRef = window.setTimeout(function () {
            _this.beurteilungAbrufen(ziel);
        }, validateTimeoutInMs);
    };
    /** Ende Beurteilungen abrufen */
    /**
     * Berechnet die Mittelwerte für die Betrachtung des Rollendurchmessers
     * @note Ruft im Bedarfsfall über das Back-End neue Sollwerte ab
     */
    BpsReferenzkraftKalibrierungStore.prototype.berechneMittelwerteRolle = function () {
        var _this = this;
        var _a = this, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
        ['links', 'rechts'].map(function (position) {
            var oldVal = position === 'links' ? datensatz.rollendurchmesser.mittelwert.links : datensatz.rollendurchmesser.mittelwert.rechts;
            var xstart = position === 'links' ? 0 : 2;
            var xende = position === 'links' ? 1 : 3;
            var sum = 0;
            var count = 0;
            for (var x = xstart; x <= xende; x++) {
                for (var y = 0; y < 3; y++) {
                    var messwert = datensatz.rollendurchmesser.messwerte[x][y];
                    if (messwert !== undefined && !isNaN(messwert)) {
                        sum += messwert;
                        count++;
                    }
                    else {
                        _this.setMittelwert(position, undefined);
                    }
                }
            }
            var avg = sum / count;
            // Bei geschweißten Rollen wird der Nenndurchmesser der Rolle mit betrachtet
            if (datensatz.oberflaeche === 'geschweisst') {
                if (kalibrierGegenstand) {
                    var rollendurchmesser = kalibrierGegenstand.meta('rollendurchmesser');
                    if (rollendurchmesser) {
                        avg = (avg + parseFloat(rollendurchmesser)) / 2;
                    }
                }
            }
            // Bei Rollenmessung über den Umfang, durch PI teilen
            if (datensatz.messart === 'umfang') {
                avg /= Math.PI;
            }
            _this.setMittelwert(position, round_1.round(avg, 1));
            var newVal = position === 'links' ? datensatz.rollendurchmesser.mittelwert.links : datensatz.rollendurchmesser.mittelwert.rechts;
            if (oldVal !== newVal) {
                _this.messpunkteAktualisieren();
            }
        });
    };
    /**
     * Ermittelt das zu nutzende Kraftmessgerät aus den im Vorgang gewählten Arbeitsmitteln
     */
    BpsReferenzkraftKalibrierungStore.prototype.kraftMessGeraet = function () {
        if (!this.vorgangStore.vorgang) {
            return undefined;
        }
        for (var _i = 0, _a = this.vorgangStore.vorgang.arbeitsmittel; _i < _a.length; _i++) {
            var am = _a[_i];
            if (am.typ.toLowerCase() === 'bps_kmg') {
                return am;
            }
        }
        return undefined;
    };
    BpsReferenzkraftKalibrierungStore.prototype.messbereichGueltig = function () {
        var datensatz = this.datensatz;
        if ((datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichKlein) {
            return false;
        }
        if ((datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichGross) {
            return false;
        }
        return true;
    };
    BpsReferenzkraftKalibrierungStore.prototype.setObjektVorlage = function (value) {
        this.objektVorlage = value;
    };
    BpsReferenzkraftKalibrierungStore.prototype.setKalibrierGegenstand = function (value) {
        if (!value) {
            // Standardwerte setzen, falls noch kein Bremsenprüfstand gewählt wurde
            this.kalibrierGegenstand = undefined;
            this.datensatz.drehzahlschlupf.mingeschwindigkeit = 4;
            this.datensatz.anzeige = 'analog';
            return;
        }
        this.kalibrierGegenstand = new KalibrierGegenstand_1.default(value);
        // Die min. Geschwindigkeit für die Beurteilung von Drehzahl und Schlupf hängt von der Fz.Art. des Prüfstands ab
        // 4 km/h bei reinen PKW-Prüfständen, 2 km/h für alle anderen (LKW und PKW/LKW kombiniert)
        var fzart = this.kalibrierGegenstand.meta('fzart');
        if (fzart && fzart.toLowerCase() !== 'pkw') {
            this.datensatz.drehzahlschlupf.mingeschwindigkeit = 2;
        }
        else {
            this.datensatz.drehzahlschlupf.mingeschwindigkeit = 4;
        }
        // Art der Anzeige speichern, diese hat Auswirkungen auf die Auswertung
        this.datensatz.anzeige = 'analog';
        var anzeigeart = this.kalibrierGegenstand.meta('anzeigeart');
        if (anzeigeart && anzeigeart.toLowerCase() === 'digital') {
            this.datensatz.anzeige = 'digital';
        }
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMesswert = function (x, y, value) {
        this.datensatz.rollendurchmesser.messwerte[x][y] = value;
        this.berechneMittelwerteRolle();
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMittelwert = function (position, value) {
        if (position === 'links') {
            this.datensatz.rollendurchmesser.mittelwert.links = value;
        }
        if (position === 'rechts') {
            this.datensatz.rollendurchmesser.mittelwert.rechts = value;
        }
    };
    BpsReferenzkraftKalibrierungStore.prototype.setOberflaeche = function (value) {
        switch (value) {
            case 'beschichtet':
                this.datensatz.oberflaeche = 'beschichtet';
                break;
            case 'geschweisst':
                this.datensatz.oberflaeche = 'geschweisst';
                break;
            default:
                this.datensatz.oberflaeche = 'beschichtet';
        }
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMessart = function (value) {
        switch (value) {
            case 'durchmesser':
                this.datensatz.messart = 'durchmesser';
                break;
            case 'umfang':
                this.datensatz.messart = 'umfang';
                break;
            default:
                this.datensatz.messart = 'durchmesser';
        }
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMessbereich = function (value) {
        switch (value) {
            case 'klein':
                this.datensatz.messbereich = 'klein';
                break;
            case 'groß':
                this.datensatz.messbereich = 'groß';
                break;
            case 'kombiniert':
                this.datensatz.messbereich = 'kombiniert';
                break;
            default:
                this.datensatz.messbereich = undefined;
        }
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMessbereichKlein = function (value) {
        this.datensatz.messbereichKlein = value;
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMessbereichGross = function (value) {
        this.datensatz.messbereichGross = value;
    };
    BpsReferenzkraftKalibrierungStore.prototype.setJustage = function (value) {
        this.justage = value;
    };
    BpsReferenzkraftKalibrierungStore.prototype.setReadOnly = function (value) {
        this.readOnly = value;
    };
    BpsReferenzkraftKalibrierungStore.prototype.setMesswerte = function (value) {
        var datensatz = this.datensatz;
        // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
        // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
        if (value.version) {
            datensatz.version = value.version;
        }
        if (value.rollendurchmesser) {
            if (value.rollendurchmesser.messwerte) {
                datensatz.rollendurchmesser.messwerte = value.rollendurchmesser.messwerte;
            }
            if (value.rollendurchmesser.mittelwert) {
                datensatz.rollendurchmesser.mittelwert = value.rollendurchmesser.mittelwert;
            }
        }
        if (value.oberflaeche) {
            datensatz.oberflaeche = value.oberflaeche;
        }
        if (value.messart) {
            datensatz.messart = value.messart;
        }
        if (value.messbereich) {
            datensatz.messbereich = value.messbereich;
        }
        if (value.messbereichKlein) {
            datensatz.messbereichKlein = value.messbereichKlein;
        }
        if (value.messbereichGross) {
            datensatz.messbereichGross = value.messbereichGross;
        }
        if (value.rollensatz && value.rollensatz.links) {
            datensatz.rollensatz.links = value.rollensatz.links;
        }
        if (value.rollensatz && value.rollensatz.rechts) {
            datensatz.rollensatz.rechts = value.rollensatz.rechts;
        }
        if (value.pruefortparameter) {
            if (value.pruefortparameter.beginn) {
                datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn;
            }
            if (value.pruefortparameter.ende) {
                datensatz.pruefortparameter.ende = value.pruefortparameter.ende;
            }
        }
        if (value.waegezelle) {
            datensatz.waegezelle = value.waegezelle;
        }
        if (value.drehzahlschlupf) {
            if (value.drehzahlschlupf.links) {
                datensatz.drehzahlschlupf.links = value.drehzahlschlupf.links;
            }
            if (value.drehzahlschlupf.rechts) {
                datensatz.drehzahlschlupf.rechts = value.drehzahlschlupf.rechts;
            }
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftKalibrierungStore.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], BpsReferenzkraftKalibrierungStore.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], BpsReferenzkraftKalibrierungStore.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungStore.prototype, "objektVorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungStore.prototype, "kalibrierGegenstand", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], BpsReferenzkraftKalibrierungStore.prototype, "justage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], BpsReferenzkraftKalibrierungStore.prototype, "readOnly", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungStore.prototype, "datensatz", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "clear", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Number, Number, Number]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMesspunkt", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftKalibrierungStore.prototype, "beurteilungAbrufen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "beurteilungAbrufenGesamt", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "beurteilungMesspunktSetzen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Number]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "beurteilungMesspunktLoeschen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setObjektVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setKalibrierGegenstand", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMesswert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMittelwert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setOberflaeche", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMessart", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMessbereich", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMessbereichKlein", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMessbereichGross", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setJustage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setReadOnly", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungStore.prototype, "setMesswerte", null);
    BpsReferenzkraftKalibrierungStore = BpsReferenzkraftKalibrierungStore_1 = __decorate([
        decorators_1.provideSingleton(BpsReferenzkraftKalibrierungStore_1)
    ], BpsReferenzkraftKalibrierungStore);
    return BpsReferenzkraftKalibrierungStore;
    var BpsReferenzkraftKalibrierungStore_1;
}());
exports.BpsReferenzkraftKalibrierungStore = BpsReferenzkraftKalibrierungStore;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(47)
  , core      = __webpack_require__(39)
  , ctx       = __webpack_require__(116)
  , hide      = __webpack_require__(65)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(179)
  , defined = __webpack_require__(117);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(27);
var ERROR_MSGS = __webpack_require__(36);
function tagParameter(annotationTarget, propertyName, parameterIndex, metadata) {
    var metadataKey = METADATA_KEY.TAGGED;
    _tagParameterOrProperty(metadataKey, annotationTarget, propertyName, metadata, parameterIndex);
}
exports.tagParameter = tagParameter;
function tagProperty(annotationTarget, propertyName, metadata) {
    var metadataKey = METADATA_KEY.TAGGED_PROP;
    _tagParameterOrProperty(metadataKey, annotationTarget.constructor, propertyName, metadata);
}
exports.tagProperty = tagProperty;
function _tagParameterOrProperty(metadataKey, annotationTarget, propertyName, metadata, parameterIndex) {
    var paramsOrPropertiesMetadata = {};
    var isParameterDecorator = (typeof parameterIndex === "number");
    var key = (parameterIndex !== undefined && isParameterDecorator) ? parameterIndex.toString() : propertyName;
    if (isParameterDecorator === true && propertyName !== undefined) {
        throw new Error(ERROR_MSGS.INVALID_DECORATOR_OPERATION);
    }
    if (Reflect.hasOwnMetadata(metadataKey, annotationTarget) === true) {
        paramsOrPropertiesMetadata = Reflect.getMetadata(metadataKey, annotationTarget);
    }
    var paramOrPropertyMetadata = paramsOrPropertiesMetadata[key];
    if (Array.isArray(paramOrPropertyMetadata) !== true) {
        paramOrPropertyMetadata = [];
    }
    else {
        for (var i = 0; i < paramOrPropertyMetadata.length; i++) {
            var m = paramOrPropertyMetadata[i];
            if (m.key === metadata.key) {
                throw new Error(ERROR_MSGS.DUPLICATED_METADATA + " " + m.key);
            }
        }
    }
    paramOrPropertyMetadata.push(metadata);
    paramsOrPropertiesMetadata[key] = paramOrPropertyMetadata;
    Reflect.defineMetadata(metadataKey, paramsOrPropertiesMetadata, annotationTarget);
}
function _decorate(decorators, target) {
    Reflect.decorate(decorators, target);
}
function _param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
}
function decorate(decorator, target, parameterIndex) {
    if (typeof parameterIndex === "number") {
        _decorate([_param(parameterIndex, decorator)], target);
    }
    else if (typeof parameterIndex === "string") {
        Reflect.decorate([decorator], target, parameterIndex);
    }
    else {
        _decorate([decorator], target);
    }
}
exports.decorate = decorate;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BindingScopeEnum = {
    Singleton: "Singleton",
    Transient: "Transient"
};
exports.BindingScopeEnum = BindingScopeEnum;
var BindingTypeEnum = {
    ConstantValue: "ConstantValue",
    Constructor: "Constructor",
    DynamicValue: "DynamicValue",
    Factory: "Factory",
    Function: "Function",
    Instance: "Instance",
    Invalid: "Invalid",
    Provider: "Provider"
};
exports.BindingTypeEnum = BindingTypeEnum;
var TargetTypeEnum = {
    ClassProperty: "ClassProperty",
    ConstructorArgument: "ConstructorArgument",
    Variable: "Variable"
};
exports.TargetTypeEnum = TargetTypeEnum;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
/** Zeigt einen animierten Ladekreis mit anpassbarer Meldung an, z.B. wenn im Hintergrund Daten nachgeladen werden */
var LadeFortschritt = (function (_super) {
    __extends(LadeFortschritt, _super);
    function LadeFortschritt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LadeFortschritt.prototype.render = function () {
        return (React.createElement("div", { className: "loader-container" },
            React.createElement("div", { className: "loader-sm" }),
            React.createElement("div", { className: "loader-text" }, this.props.caption ? this.props.caption : 'Daten werden geladen...')));
    };
    return LadeFortschritt;
}(React.Component));
exports.default = LadeFortschritt;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** "Factory" zum Vorbelegen von Datenstrukturen */
exports.leereAdresse = function () { return ({
    adressid: undefined,
    name: '',
    zusatz: '',
    strasse: '',
    plz: '',
    tel1: '',
    bundesland: '',
    ort: '',
    untersuchungsstellenkennung: '',
    email: '',
    email2: ''
}); };
/** Datensatz mit vorbelegten Werten für die Kalibrierung von Rollenbremsprüfstanden nach 2021er Rili */
exports.leererDatensatzBPSReferenzkraftRili2021 = function () { return ({
    version: 2,
    richtlinie: '2021',
    rollendurchmesser: {
        messwerte: [
            /*links vorne*/
            [null, null, null],
            /*links hinten*/
            [null, null, null],
            /*rechts vorne*/
            [null, null, null],
            /*rechts hinten*/
            [null, null, null]
        ],
        mittelwert: {
            links: null,
            rechts: null
        },
        faktor: {
            links: null,
            rechts: null
        },
        grunddurchmesser: undefined
    },
    oberflaeche: 'beschichtet',
    messart: 'durchmesser',
    messbereich: undefined,
    messbereichKlein: undefined,
    messbereichGross: undefined,
    anzeige: undefined,
    justageInfo: 'keine',
    rollensatz: {
        links: {
            position: 'links',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        },
        rechts: {
            position: 'rechts',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        }
    },
    rollensatzJustage: {
        links: {
            position: 'links',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        },
        rechts: {
            position: 'rechts',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        },
        gesamtErgebnis: []
    },
    pruefortparameter: {
        beginn: {
            luftfeuchtigkeit: {
                wert: null,
                min: 0,
                max: 85
            },
            lufttemperatur: {
                wert: null,
                min: 5,
                max: 35
            }
        },
        ende: {
            luftfeuchtigkeit: {
                wert: null,
                min: 0,
                max: 85
            },
            lufttemperatur: {
                wert: null,
                min: 5,
                max: 35
            }
        }
    },
    gesamtErgebnis: [],
    waegezelle: {
        messwerte: [undefined, undefined, undefined],
        sollwert: 49,
        toleranz: 1
    },
    drehzahlschlupf: {
        links: {
            geschwindigkeit: [undefined, undefined],
            schlupf: null
        },
        rechts: {
            geschwindigkeit: [undefined, undefined],
            schlupf: null
        },
        mingeschwindigkeit: 2,
        maxschlupf: 30
    },
    kmg: '',
    objekt: ''
}); };
exports.leererBPSMesspunktPlatte = function () { return ({
    anzeige: 0,
    mittelwert: undefined,
    mittelwertabweichung: null,
    messunsicherheit: null,
    beurteilung: null,
    messwerte: [
        { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null },
        { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null },
        { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null }
    ]
}); };
/** Datensatz mit vorbelegten Werten für die Kalibrierung von Rollenbremsprüfstanden nach 2021er Rili */
exports.leererDatensatzBPSReferenzkraftPlatte = function () { return ({
    version: 1,
    richtlinie: '2021',
    messbereich: undefined,
    anzeige: undefined,
    justageInfo: 'keine',
    plattensatz: {
        links: {
            position: 'links',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        },
        rechts: {
            position: 'rechts',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        }
    },
    plattensatzJustage: {
        links: {
            position: 'links',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        },
        rechts: {
            position: 'rechts',
            messpunkte: [],
            vorbelastung: {
                messpunkte: [
                    { anzeige: null, normal: null },
                    { anzeige: null, normal: null }
                ]
            }
        },
        gesamtErgebnis: []
    },
    pruefortparameter: {
        beginn: {
            lufttemperatur: {
                wert: null,
                min: 5,
                max: 35
            }
        },
        ende: {
            lufttemperatur: {
                wert: null,
                min: 5,
                max: 35
            }
        }
    },
    waegezelle: {
        messwerte: [undefined, undefined, undefined],
        sollwert: 49,
        toleranz: 1
    },
    gesamtErgebnis: [],
    kmg: '',
    objekt: ''
}); };
exports.leererDmgMesspunkt = function () { return ({
    index: 0,
    nenndruck: 0,
    m1: {
        normal: null,
        anzeige: null
    },
    m2: {
        normal: null,
        anzeige: null
    }
}); };
exports.leererDatensatzDmgKalibrierung = function () { return ({
    version: 1,
    messpunkte: [],
    haltezeiteingehalten: false,
    vorbelastungbisendwert: false,
    zeigerart: '',
    kalibrierbereich: {
        von: null,
        bis: null
    },
    pruefortparameter: {
        beginn: {
            lufttemperatur: {
                wert: null,
                min: 18,
                max: 28
            },
            luftfeuchtigkeit: {
                wert: null,
                min: 25,
                max: 65
            }
        },
        ende: {
            lufttemperatur: {
                wert: null,
                min: 18,
                max: 28
            },
            luftfeuchtigkeit: {
                wert: null,
                min: 25,
                max: 65
            }
        }
    }
}); };
exports.leereMessreiheAgtPartikelzaehler = function (nennwert) { return ({
    nennwert: nennwert,
    partikelgroesse: [
        { zeitpunkt: 0, einheit: 's', wert: null },
        { zeitpunkt: 20, einheit: 's', wert: null }
    ],
    anzeigenormal: [
        { zeitpunkt: 0, einheit: '#/cm³', wert: null },
        { zeitpunkt: 20, einheit: '#/cm³', wert: null }
    ],
    anzeigegeraet: [
        { zeitpunkt: 0, einheit: '#/cm³', wert: null },
        { zeitpunkt: 5, einheit: '#/cm³', wert: null },
        { zeitpunkt: 10, einheit: '#/cm³', wert: null },
        { zeitpunkt: 15, einheit: '#/cm³', wert: null },
        { zeitpunkt: 20, einheit: '#/cm³', wert: null }
    ],
    beurteilung: null
}); };
exports.leererDatensatzAgtPartikelzaehlerMessung = function () { return ({
    version: 1,
    justage: false,
    pruefortparameter: {
        beginn: {
            lufttemperatur: {
                wert: null,
                min: 15,
                max: 35
            },
            luftfeuchtigkeit: {
                wert: null,
                min: 25,
                max: 90
            },
            umgebungsdruck: {
                wert: null,
                min: 860,
                max: 1060
            }
        },
        ende: {
            lufttemperatur: {
                wert: null,
                min: 15,
                max: 35
            },
            luftfeuchtigkeit: {
                wert: null,
                min: 25,
                max: 90
            },
            umgebungsdruck: {
                wert: null,
                min: 860,
                max: 1060
            }
        }
    },
    messreihen: [
        exports.leereMessreiheAgtPartikelzaehler(400000),
        exports.leereMessreiheAgtPartikelzaehler(250000),
        exports.leereMessreiheAgtPartikelzaehler(50000)
    ],
    messreihenJustage: [
        exports.leereMessreiheAgtPartikelzaehler(400000),
        exports.leereMessreiheAgtPartikelzaehler(250000),
        exports.leereMessreiheAgtPartikelzaehler(50000)
    ],
    pck: '',
    objekt: ''
}); };


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var KalibrierGegenstand_1 = __webpack_require__(112);
var round_1 = __webpack_require__(33);
var ApiTypesBps = __webpack_require__(280);
var ApiStore_1 = __webpack_require__(13);
var ApiTypeFactory = __webpack_require__(54);
var VorgangStore_1 = __webpack_require__(22);
/** Singleton für globale Eigenschaften zur BPS Kalibrierung mit Referenzkraft-Verfahren nach 2021er Richtlinie */
var BpsReferenzkraftKalibrierungRili2021Store = (function () {
    function BpsReferenzkraftKalibrierungRili2021Store() {
        this.objektVorlage = undefined;
        this.kalibrierGegenstand = undefined;
        this.readOnly = false;
        this.abrufTimeoutRef = 0;
        this.datensatz = ApiTypeFactory.leererDatensatzBPSReferenzkraftRili2021();
        this.messbereiche = [4, 5, 6, 7.5, 8, 12, 25, 30, 40];
    }
    BpsReferenzkraftKalibrierungRili2021Store_1 = BpsReferenzkraftKalibrierungRili2021Store;
    BpsReferenzkraftKalibrierungRili2021Store.prototype.clear = function () {
        this.datensatz = ApiTypeFactory.leererDatensatzBPSReferenzkraftRili2021();
    };
    /** Ruft mit der aktuellen Eingabe Sollwerte aus dem Back-End ab */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.messpunkteAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, datensatz, kalibrierGegenstand, messwerte, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
                        if (!(kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich && datensatz.rollendurchmesser.mittelwert.links && datensatz.rollendurchmesser.mittelwert.rechts)) return [3 /*break*/, 2];
                        if ((datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichKlein) {
                            return [2 /*return*/];
                        }
                        if ((datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichGross) {
                            return [2 /*return*/];
                        }
                        messwerte = {
                            mittelwerte: {
                                links: datensatz.rollendurchmesser.mittelwert.links,
                                rechts: datensatz.rollendurchmesser.mittelwert.rechts
                            },
                            messbereich: datensatz.messbereich,
                            messbereiche: {
                                klein: datensatz.messbereichKlein,
                                gross: datensatz.messbereichGross
                            },
                            objekt: kalibrierGegenstand.objekt.objektguid
                        };
                        return [4 /*yield*/, this.apiStore.bpsReferenzkraftMesspunkteRili2021(messwerte)];
                    case 1:
                        response = _b.sent();
                        if (response.ok) {
                            return [2 /*return*/, response];
                        }
                        _b.label = 2;
                    case 2: 
                    // @todo: Hinweis/Ergebnis bereinigen
                    return [2 /*return*/, undefined];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMesspunkt = function (ziel, anzeige) {
        if (ziel) {
            ziel.anzeige = anzeige;
        }
    };
    // @todo: naming, setzen wert im datensatz für beurteilung
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setKmg = function (kmgGuid) {
        this.datensatz.kmg = kmgGuid;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setBps = function (bpsGuid) {
        this.datensatz.objekt = bpsGuid;
    };
    /** Aktualisiert die Sollwerte für bereits angelegte Messpunkte */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.messpunkteAktualisieren = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, datensatz, messpunkte;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.messpunkteAbrufen()];
                    case 1:
                        response = _a.sent();
                        datensatz = this.datensatz;
                        if (response && response.ok) {
                            messpunkte = response.json;
                            messpunkte.forEach(function (mp, index) {
                                _this.setMesspunkt(datensatz.rollensatz.links.messpunkte[index], mp.anzeige);
                                _this.setMesspunkt(datensatz.rollensatz.rechts.messpunkte[index], mp.anzeige);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Anfang Beurteilungen abrufen */
    /** Ruft die Beurteilung der Messpunkte für die beiden Fahrspuren vom Backend ab */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.beurteilungAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var kmg, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        kmg = this.kraftMessGeraet();
                        if (!kmg) {
                            return [2 /*return*/];
                        }
                        // Im Vorgang gewählter Bremsprüfstand
                        this.setKmg(kmg.arbeitsmittelguid);
                        if (!this.kalibrierGegenstand || !this.kalibrierGegenstand.objekt) {
                            return [2 /*return*/];
                        }
                        this.setBps(this.kalibrierGegenstand.objekt.objektguid);
                        return [4 /*yield*/, this.apiStore.bpsReferenzkraftBeurteilungRili2021(this.datensatz)];
                    case 1:
                        response = _a.sent();
                        if (response && response.ok) {
                            this.setBeurteilung(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setBeurteilung = function (beurteilung) {
        var _this = this;
        beurteilung.links.forEach(function (e, index) {
            _this.datensatz.rollensatz.links.messpunkte[index].beurteilung = e.bewertung;
        });
        beurteilung.rechts.forEach(function (e, index) {
            _this.datensatz.rollensatz.rechts.messpunkte[index].beurteilung = e.bewertung;
        });
        this.datensatz.gesamtErgebnis.length = beurteilung.gesamt.length;
        beurteilung.gesamt.forEach(function (e, index) {
            _this.datensatz.gesamtErgebnis[index] = e;
        });
        // Nach Justage
        if (beurteilung.justage) {
            beurteilung.justage.links.forEach(function (e, index) {
                _this.datensatz.rollensatzJustage.links.messpunkte[index].beurteilung = e.bewertung;
            });
            beurteilung.justage.rechts.forEach(function (e, index) {
                _this.datensatz.rollensatzJustage.rechts.messpunkte[index].beurteilung = e.bewertung;
            });
            this.datensatz.rollensatzJustage.gesamtErgebnis.length = beurteilung.justage.gesamt.length;
            beurteilung.justage.gesamt.forEach(function (e, index) {
                _this.datensatz.rollensatzJustage.gesamtErgebnis[index] = e;
            });
        }
    };
    /** Ruft die Beurteilung der Messpunkte verzögert vom Back-End ab, um zu häufige Abrufe bei schnellen Änderungen zu vermeiden */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.beurteilungAbrufenDelayed = function () {
        var _this = this;
        if (this.abrufTimeoutRef > 0) {
            window.clearTimeout(this.abrufTimeoutRef);
            this.abrufTimeoutRef = 0;
        }
        var validateTimeoutInMs = 500;
        this.abrufTimeoutRef = window.setTimeout(function () {
            _this.beurteilungAbrufen();
        }, validateTimeoutInMs);
    };
    /** Ende Beurteilungen abrufen */
    /** Berechnet alle Referenzwerte neu, z.B. wenn ein Messwert oder der Rollendurchmesser verändert wurden */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.berechneReferenzWerte = function () {
        // Lambda für Berechnung der Werte zu einem gegebenen Messpunkt
        var mwb = function (mw, f) {
            if ((mw.sensor === null) || (mw.bps === null) || (isNaN(mw.sensor)) || (isNaN(mw.bps))) {
                mw.referenzwert = mw.messwertabweichung = null;
            }
            else {
                mw.referenzwert = round_1.round(mw.sensor * f, 0);
                mw.messwertabweichung = round_1.round(mw.bps - mw.referenzwert, 0);
            }
        };
        // Links
        var faktor = (this.datensatz.rollendurchmesser.faktor.links || 0);
        if (faktor !== 0) {
            this.datensatz.rollensatz.links.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw, faktor); }); });
            if (this.datensatz.justageInfo === 'justage') {
                this.datensatz.rollensatzJustage.links.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw, faktor); }); });
            }
        }
        // Rechts
        faktor = (this.datensatz.rollendurchmesser.faktor.rechts || 0);
        if (faktor !== 0) {
            this.datensatz.rollensatz.rechts.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw, faktor); }); });
            if (this.datensatz.justageInfo === 'justage') {
                this.datensatz.rollensatzJustage.rechts.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw, faktor); }); });
            }
        }
        if (this.datensatz.rollensatz.links.messpunkte.length === 0 || this.datensatz.rollensatz.rechts.messpunkte.length === 0) {
            return;
        }
        this.beurteilungAbrufenDelayed();
    };
    /** Berechnet die Mittelwerte für die Betrachtung des Rollendurchmessers über gewichtete Mittelwerte */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.berechneMittelwerteRolle = function () {
        var mwLiAlt = this.datensatz.rollendurchmesser.mittelwert.links;
        var mwReAlt = this.datensatz.rollendurchmesser.mittelwert.rechts;
        var _a = this, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
        var messwerte = this.datensatz.rollendurchmesser.messwerte;
        // Gewichtete Mittelwert für Links/Rechts und Vorne/Hinten werden gemittelt
        var mwLiVorne = (0.2 * (messwerte[0][0] || 0.0)) + 0.6 * (messwerte[0][1] || 0.0) + (0.2 * (messwerte[0][2] || 0.0));
        var mwLiHinten = (0.2 * (messwerte[1][0] || 0.0)) + 0.6 * (messwerte[1][1] || 0.0) + (0.2 * (messwerte[1][2] || 0.0));
        var mwReVorne = (0.2 * (messwerte[2][0] || 0.0)) + 0.6 * (messwerte[2][1] || 0.0) + (0.2 * (messwerte[2][2] || 0.0));
        var mwReHinten = (0.2 * (messwerte[3][0] || 0.0)) + 0.6 * (messwerte[3][1] || 0.0) + (0.2 * (messwerte[3][2] || 0.0));
        // Bei geschweissten Rollen wird der Grunddurchmesser mit einbezogen
        if (datensatz.oberflaeche === 'geschweisst') {
            mwLiVorne = (mwLiVorne + (datensatz.rollendurchmesser.grunddurchmesser || 0.0)) / 2.0;
            mwLiHinten = (mwLiHinten + (datensatz.rollendurchmesser.grunddurchmesser || 0.0)) / 2.0;
            mwReVorne = (mwReVorne + (datensatz.rollendurchmesser.grunddurchmesser || 0.0)) / 2.0;
            mwReHinten = (mwReHinten + (datensatz.rollendurchmesser.grunddurchmesser || 0.0)) / 2.0;
        }
        this.datensatz.rollendurchmesser.mittelwert.links = (mwLiVorne + mwLiHinten) / 2.0;
        this.datensatz.rollendurchmesser.mittelwert.rechts = (mwReVorne + mwReHinten) / 2.0;
        // Bei Rollenmessung über den Umfang, durch PI teilen
        if (datensatz.messart === 'umfang') {
            this.datensatz.rollendurchmesser.mittelwert.links /= Math.PI;
            this.datensatz.rollendurchmesser.mittelwert.rechts /= Math.PI;
        }
        // Korrekturfaktor für die Berechnung der Referenzwerte der Rollensätze ermitteln
        if (kalibrierGegenstand) {
            var kFLinks = 1.0;
            var kFRechts = 1.0;
            var hlm = kalibrierGegenstand.metaAsNumber('hebelarmlänge');
            var uz = kalibrierGegenstand.metaAsNumber('übersetzungsverhältnis_zähler');
            var un = kalibrierGegenstand.metaAsNumber('übersetzungsverhältnis_nenner');
            if (hlm && uz && un && this.datensatz.rollendurchmesser.mittelwert.links) {
                var uebersetzung = uz / un;
                kFLinks = hlm / (this.datensatz.rollendurchmesser.mittelwert.links / 2.0) * uebersetzung;
            }
            if (hlm && uz && un && this.datensatz.rollendurchmesser.mittelwert.rechts) {
                var uebersetzung = uz / un;
                kFRechts = hlm / (this.datensatz.rollendurchmesser.mittelwert.rechts / 2.0) * uebersetzung;
            }
            this.datensatz.rollendurchmesser.faktor.links = kFLinks;
            this.datensatz.rollendurchmesser.faktor.rechts = kFRechts;
        }
        // Bei einer Änderung des Mittelwerte müssen alle Referenzpunkte für die Messung der Rollen neu berechnet werden
        if ((mwLiAlt !== this.datensatz.rollendurchmesser.mittelwert.links) || (mwReAlt !== this.datensatz.rollendurchmesser.mittelwert.rechts)) {
            // @todo
            this.berechneReferenzWerte();
        }
    };
    /** Ermittelt das zu nutzende Kraftmessgerät aus den im Vorgang gewählten Arbeitsmitteln */
    BpsReferenzkraftKalibrierungRili2021Store.prototype.kraftMessGeraet = function () {
        if (!this.vorgangStore.vorgang) {
            return undefined;
        }
        for (var _i = 0, _a = this.vorgangStore.vorgang.arbeitsmittel; _i < _a.length; _i++) {
            var am = _a[_i];
            if (am.typ.toLowerCase() === 'bps_kmg') {
                return am;
            }
        }
        return undefined;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.messbereichGueltig = function () {
        var datensatz = this.datensatz;
        if ((datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichKlein) {
            return false;
        }
        if ((datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert') && !datensatz.messbereichGross) {
            return false;
        }
        return true;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setObjektVorlage = function (value) {
        this.objektVorlage = value;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setKalibrierGegenstand = function (value) {
        if (!value) {
            // Standardwerte setzen, falls noch kein Bremsenprüfstand gewählt wurde
            this.kalibrierGegenstand = undefined;
            this.datensatz.drehzahlschlupf.mingeschwindigkeit = 4;
            this.datensatz.anzeige = 'analog';
            return;
        }
        this.kalibrierGegenstand = new KalibrierGegenstand_1.default(value);
        // Die min. Geschwindigkeit für die Beurteilung von Drehzahl und Schlupf hängt von der Fz.Art. des Prüfstands ab
        // 4 km/h bei reinen PKW-Prüfständen, 2 km/h für alle anderen (LKW und PKW/LKW kombiniert)
        var fzart = this.kalibrierGegenstand.meta('fzart');
        if (fzart && fzart.toLowerCase() !== 'pkw') {
            this.datensatz.drehzahlschlupf.mingeschwindigkeit = 2;
        }
        else {
            this.datensatz.drehzahlschlupf.mingeschwindigkeit = 4;
        }
        // Art der Anzeige speichern, diese hat Auswirkungen auf die Auswertung
        this.datensatz.anzeige = 'analog';
        var anzeigeart = this.kalibrierGegenstand.meta('anzeigeart');
        if (anzeigeart && anzeigeart.toLowerCase() === 'digital') {
            this.datensatz.anzeige = 'digital';
        }
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMesswert = function (x, y, value) {
        this.datensatz.rollendurchmesser.messwerte[x][y] = value;
        this.berechneMittelwerteRolle();
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMittelwert = function (position, value) {
        if (position === 'links') {
            this.datensatz.rollendurchmesser.mittelwert.links = value;
        }
        if (position === 'rechts') {
            this.datensatz.rollendurchmesser.mittelwert.rechts = value;
        }
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setRollenFaktor = function (links, rechts) {
        this.datensatz.rollendurchmesser.faktor.links = links;
        this.datensatz.rollendurchmesser.faktor.rechts = rechts;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMesswertRollendurchmesser = function (x, y, value) {
        this.datensatz.rollendurchmesser.messwerte[x][y] = value;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.getMesswertRollendurchmesser = function (x, y) {
        return this.datensatz.rollendurchmesser.messwerte[x][y];
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setOberflaeche = function (value) {
        switch (value) {
            case 'beschichtet':
                this.datensatz.oberflaeche = 'beschichtet';
                break;
            case 'geschweisst':
                this.datensatz.oberflaeche = 'geschweisst';
                break;
            default:
                this.datensatz.oberflaeche = 'beschichtet';
        }
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMessart = function (value) {
        switch (value) {
            case 'durchmesser':
                this.datensatz.messart = 'durchmesser';
                break;
            case 'umfang':
                this.datensatz.messart = 'umfang';
                break;
            default:
                this.datensatz.messart = 'durchmesser';
        }
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setGrunddurchmesser = function (value) {
        this.datensatz.rollendurchmesser.grunddurchmesser = value;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMessbereich = function (value) {
        switch (value) {
            case 'klein':
                this.datensatz.messbereich = 'klein';
                break;
            case 'groß':
                this.datensatz.messbereich = 'groß';
                break;
            case 'kombiniert':
                this.datensatz.messbereich = 'kombiniert';
                break;
            default:
                this.datensatz.messbereich = undefined;
        }
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMessbereichKlein = function (value) {
        this.datensatz.messbereichKlein = value;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMessbereichGross = function (value) {
        this.datensatz.messbereichGross = value;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setReadOnly = function (value) {
        this.readOnly = value;
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setJustageInfo = function (value) {
        this.datensatz.justageInfo = value;
        // Bei aktiver Justage wird eine zweite Eingabe angezeigt, da die Auswahl des Messbereichs nur einmal erfolgt,
        // müssen die Messpunkte hier entsprechend der Eingabe vor der Justage dimensioniert werden
        if (this.datensatz.justageInfo === 'justage') {
            var quellen = [this.datensatz.rollensatz.links.messpunkte, this.datensatz.rollensatz.rechts.messpunkte];
            var ziele = [this.datensatz.rollensatzJustage.links.messpunkte, this.datensatz.rollensatzJustage.rechts.messpunkte];
            for (var i = 0; i < quellen.length; i++) {
                // Wenn im Ziel (Messwerte nach Justage) Messpunkte fehlen, werden diese hinzugefügt
                var quelle = quellen[i];
                var ziel = ziele[i];
                for (var j = ziel.length; j < quelle.length; j++) {
                    ziel.push({
                        anzeige: quelle[j].anzeige,
                        mittelwert: undefined,
                        mittelwertabweichung: null,
                        messunsicherheit: null,
                        beurteilung: null,
                        messwerte: [
                            { bps: quelle[j].anzeige, sensor: null, referenzwert: null, messwertabweichung: null },
                            { bps: quelle[j].anzeige, sensor: null, referenzwert: null, messwertabweichung: null },
                            { bps: quelle[j].anzeige, sensor: null, referenzwert: null, messwertabweichung: null }
                        ]
                    });
                }
            }
        }
    };
    BpsReferenzkraftKalibrierungRili2021Store.prototype.setMesswerte = function (value) {
        var datensatz = this.datensatz;
        // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
        // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
        if (value.version) {
            datensatz.version = value.version;
        }
        if (value.rollendurchmesser) {
            if (value.rollendurchmesser.messwerte) {
                datensatz.rollendurchmesser.messwerte = value.rollendurchmesser.messwerte;
            }
            if (value.rollendurchmesser.mittelwert) {
                datensatz.rollendurchmesser.mittelwert = value.rollendurchmesser.mittelwert;
            }
            if (value.rollendurchmesser.grunddurchmesser) {
                datensatz.rollendurchmesser.grunddurchmesser = value.rollendurchmesser.grunddurchmesser;
            }
            if (value.rollendurchmesser.faktor) {
                datensatz.rollendurchmesser.faktor = value.rollendurchmesser.faktor;
            }
        }
        if (value.oberflaeche) {
            datensatz.oberflaeche = value.oberflaeche;
        }
        if (value.messart) {
            datensatz.messart = value.messart;
        }
        if (value.messbereich) {
            datensatz.messbereich = value.messbereich;
        }
        if (value.messbereichKlein) {
            datensatz.messbereichKlein = value.messbereichKlein;
        }
        if (value.messbereichGross) {
            datensatz.messbereichGross = value.messbereichGross;
        }
        if (value.rollensatz && value.rollensatz.links) {
            datensatz.rollensatz.links = value.rollensatz.links;
        }
        if (value.rollensatz && value.rollensatz.rechts) {
            datensatz.rollensatz.rechts = value.rollensatz.rechts;
        }
        if (value.pruefortparameter) {
            if (value.pruefortparameter.beginn) {
                datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn;
            }
            if (value.pruefortparameter.ende) {
                datensatz.pruefortparameter.ende = value.pruefortparameter.ende;
            }
        }
        if (value.waegezelle) {
            datensatz.waegezelle = value.waegezelle;
        }
        if (value.drehzahlschlupf) {
            if (value.drehzahlschlupf.links) {
                datensatz.drehzahlschlupf.links = value.drehzahlschlupf.links;
            }
            if (value.drehzahlschlupf.rechts) {
                datensatz.drehzahlschlupf.rechts = value.drehzahlschlupf.rechts;
            }
        }
        if (value.kmg) {
            datensatz.kmg = value.kmg;
        }
        if (value.objekt) {
            datensatz.objekt = value.objekt;
        }
        if (value.justageInfo) {
            datensatz.justageInfo = value.justageInfo;
        }
        if (value.rollensatzJustage && value.rollensatzJustage.links) {
            datensatz.rollensatzJustage.links = value.rollensatzJustage.links;
        }
        if (value.rollensatzJustage && value.rollensatzJustage.rechts) {
            datensatz.rollensatzJustage.rechts = value.rollensatzJustage.rechts;
        }
        if (value.rollensatzJustage && value.rollensatzJustage.gesamtErgebnis) {
            datensatz.rollensatzJustage.gesamtErgebnis = value.rollensatzJustage.gesamtErgebnis;
        }
        if (value.gesamtErgebnis) {
            datensatz.gesamtErgebnis = value.gesamtErgebnis;
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "objektVorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "kalibrierGegenstand", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "readOnly", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "datensatz", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "clear", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Number]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMesspunkt", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setKmg", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setBps", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setBeurteilung", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setObjektVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setKalibrierGegenstand", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMesswert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMittelwert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setRollenFaktor", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMesswertRollendurchmesser", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setOberflaeche", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMessart", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setGrunddurchmesser", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMessbereich", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMessbereichKlein", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMessbereichGross", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setReadOnly", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setJustageInfo", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungRili2021Store.prototype, "setMesswerte", null);
    BpsReferenzkraftKalibrierungRili2021Store = BpsReferenzkraftKalibrierungRili2021Store_1 = __decorate([
        decorators_1.provideSingleton(BpsReferenzkraftKalibrierungRili2021Store_1)
    ], BpsReferenzkraftKalibrierungRili2021Store);
    return BpsReferenzkraftKalibrierungRili2021Store;
    var BpsReferenzkraftKalibrierungRili2021Store_1;
}());
exports.BpsReferenzkraftKalibrierungRili2021Store = BpsReferenzkraftKalibrierungRili2021Store;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gibt einen in das lokale Format (de-DE) umgewandelten Zahlenwert als string zurück
 */
function numberformat(value) {
    if (value !== undefined) {
        return value.toLocaleString('de-DE');
    }
    return undefined;
}
exports.numberformat = numberformat;
/**
 * Gibt einen in das lokale Format (de-DE) umgewandelten Zahlenwert mit fester Anzahl Nachkommastellen als string zurück
 */
function numberformatFixed(value, fractionDigits) {
    if (value !== undefined) {
        return value.toLocaleString('de-DE', { minimumFractionDigits: fractionDigits });
    }
    return undefined;
}
exports.numberformatFixed = numberformatFixed;
/**
 * Formatiert Geldbeträge in das lokale Format (de-DE) und limitert auf max. zwei Nachkommastellen
 * Notwendig, weil wir in der DB oft Fließkommazahlen
 */
function numberformatMoney(value) {
    if (value !== null) {
        return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return undefined;
}
exports.numberformatMoney = numberformatMoney;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(63)
  , IE8_DOM_DEFINE = __webpack_require__(178)
  , toPrimitive    = __webpack_require__(127)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(64) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
}
exports.guid = guid;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(300), __esModule: true };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(75)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(58)
  , createDesc = __webpack_require__(79);
module.exports = __webpack_require__(64) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(183)
  , enumBugKeys = __webpack_require__(118);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(146);
var setInnerHTML = __webpack_require__(103);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(154);
var setTextContent = __webpack_require__(247);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(519);
var ReactInstrumentation = __webpack_require__(38);

var warning = __webpack_require__(17);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var ReactBaseClasses = __webpack_require__(257);
var ReactChildren = __webpack_require__(577);
var ReactDOMFactories = __webpack_require__(578);
var ReactElement = __webpack_require__(73);
var ReactPropTypes = __webpack_require__(579);
var ReactVersion = __webpack_require__(580);

var createReactClass = __webpack_require__(581);
var onlyChild = __webpack_require__(585);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var ReactCurrentOwner = __webpack_require__(44);

var warning = __webpack_require__(17);
var canDefineProperty = __webpack_require__(261);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(259);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var KalibrierGegenstand_1 = __webpack_require__(112);
var round_1 = __webpack_require__(33);
var ApiTypesBps = __webpack_require__(281);
var ApiStore_1 = __webpack_require__(13);
var ApiTypeFactory = __webpack_require__(54);
var VorgangStore_1 = __webpack_require__(22);
/** Singleton für Kalibrierung Plattenbremsprüfstand mit Referenzkraft-Verfahren nach 2021er Richtlinie */
var BpsReferenzkraftKalibrierungPlatteStore = (function () {
    function BpsReferenzkraftKalibrierungPlatteStore() {
        this.objektVorlage = undefined;
        this.kalibrierGegenstand = undefined;
        this.kraftMessGeraet = undefined; // @todo: Eigene Wrapperklasse für AM wie für KalGegenstand?
        this.readOnly = false;
        this.abrufTimeout = 0;
        this.datensatz = ApiTypeFactory.leererDatensatzBPSReferenzkraftPlatte();
    }
    BpsReferenzkraftKalibrierungPlatteStore_1 = BpsReferenzkraftKalibrierungPlatteStore;
    BpsReferenzkraftKalibrierungPlatteStore.prototype.clear = function () {
        this.datensatz = ApiTypeFactory.leererDatensatzBPSReferenzkraftPlatte();
    };
    /** Ruft mit der aktuellen Eingabe Sollwerte aus dem Back-End ab */
    BpsReferenzkraftKalibrierungPlatteStore.prototype.messpunkteAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, datensatz, kalibrierGegenstand, messwerte, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
                        if (!(kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich)) return [3 /*break*/, 2];
                        messwerte = {
                            messbereich: datensatz.messbereich,
                            objekt: kalibrierGegenstand.objekt.objektguid
                        };
                        return [4 /*yield*/, this.apiStore.bpsReferenzkraftMesspunktePlatte(messwerte)];
                    case 1:
                        response = _b.sent();
                        if (response.ok) {
                            return [2 /*return*/, response];
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/, undefined];
                }
            });
        });
    };
    /** Ruft die Beurteilung der Messpunkte für die beiden Fahrspuren vom Backend ab */
    BpsReferenzkraftKalibrierungPlatteStore.prototype.beurteilungAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // @todo: prüfen was noch gebraucht wird und auswahl kmg ggf. in Back-End auslagern
                        if ((!this.kraftMessGeraet) || (!this.kalibrierGegenstand) || (!this.kalibrierGegenstand.objekt)) {
                            return [2 /*return*/];
                        }
                        this.datensatz.objekt = this.kalibrierGegenstand.objekt.objektguid;
                        this.datensatz.kmg = this.kraftMessGeraet.arbeitsmittelguid;
                        return [4 /*yield*/, this.apiStore.bpsReferenzkraftBeurteilungPlatte(this.datensatz)];
                    case 1:
                        response = _a.sent();
                        if (response && response.ok) {
                            this.setBeurteilung(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setBeurteilung = function (beurteilung) {
        var _a = this.datensatz, plattensatz = _a.plattensatz, plattensatzJustage = _a.plattensatzJustage, gesamtErgebnis = _a.gesamtErgebnis;
        beurteilung.links.forEach(function (e, index) { plattensatz.links.messpunkte[index].beurteilung = e.bewertung; });
        beurteilung.rechts.forEach(function (e, index) { plattensatz.rechts.messpunkte[index].beurteilung = e.bewertung; });
        gesamtErgebnis.length = beurteilung.gesamt.length;
        beurteilung.gesamt.forEach(function (e, index) { gesamtErgebnis[index] = e; });
        // Nach Justage
        if (beurteilung.justage) {
            beurteilung.justage.links.forEach(function (e, index) { plattensatzJustage.links.messpunkte[index].beurteilung = e.bewertung; });
            beurteilung.justage.rechts.forEach(function (e, index) { plattensatzJustage.rechts.messpunkte[index].beurteilung = e.bewertung; });
            plattensatzJustage.gesamtErgebnis.length = beurteilung.justage.gesamt.length;
            beurteilung.justage.gesamt.forEach(function (e, index) { plattensatzJustage.gesamtErgebnis[index] = e; });
        }
    };
    /** Berechnet alle Referenzwerte neu, z.B. wenn ein Messwert oder der Rollendurchmesser verändert wurden */
    BpsReferenzkraftKalibrierungPlatteStore.prototype.berechneReferenzWerte = function () {
        // @todo: umbenennen oder entfernen?
        var _this = this;
        var _a = this.datensatz, plattensatz = _a.plattensatz, plattensatzJustage = _a.plattensatzJustage, justageInfo = _a.justageInfo;
        if (plattensatz.links.messpunkte.length === 0 || plattensatz.rechts.messpunkte.length === 0) {
            return;
        }
        // Lambda für Berechnung der Werte zu einem gegebenen Messpunkt
        var mwb = function (mw) {
            if ((mw.sensor === null) || (mw.bps === null) || (isNaN(mw.sensor)) || (isNaN(mw.bps))) {
                mw.referenzwert = mw.messwertabweichung = null;
            }
            else {
                mw.referenzwert = round_1.round(mw.sensor, 0);
                mw.messwertabweichung = round_1.round(mw.bps - mw.referenzwert, 0);
            }
        };
        plattensatz.links.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw); }); });
        plattensatz.rechts.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw); }); });
        if (justageInfo === 'justage') {
            plattensatzJustage.links.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw); }); });
            plattensatzJustage.rechts.messpunkte.forEach(function (mp) { mp.messwerte.forEach(function (mw) { mwb(mw); }); });
        }
        // Um zu häufige Abrufe beu schnellen Änderungen zu vermeiden, wird die Beurteilung verzögert abgerufen
        if (this.abrufTimeout > 0) {
            window.clearTimeout(this.abrufTimeout);
            this.abrufTimeout = 0;
        }
        this.abrufTimeout = window.setTimeout(function () { _this.beurteilungAbrufen(); }, 500);
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.messbereichGueltig = function () {
        return (this.datensatz.messbereich && this.datensatz.messbereich > 0);
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setObjektVorlage = function (value) {
        this.objektVorlage = value;
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setKraftMessGeraet = function (kmg) {
        this.kraftMessGeraet = kmg;
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setKalibrierGegenstand = function (value) {
        if (!value) {
            // Standardwerte setzen, falls noch kein Bremsenprüfstand gewählt wurde
            this.kalibrierGegenstand = undefined;
            this.datensatz.anzeige = 'analog';
            return;
        }
        this.kalibrierGegenstand = new KalibrierGegenstand_1.default(value);
        // Art der Anzeige speichern, diese hat Auswirkungen auf die Auswertung
        this.datensatz.anzeige = 'analog';
        var anzeigeart = this.kalibrierGegenstand.meta('anzeigeart');
        if (anzeigeart && anzeigeart.toLowerCase() === 'digital') {
            this.datensatz.anzeige = 'digital';
        }
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setMessbereich = function (value) {
        this.datensatz.messbereich = value;
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setReadOnly = function (value) {
        this.readOnly = value;
    };
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setJustageInfo = function (value) {
        this.datensatz.justageInfo = value;
        // Bei aktiver Justage wird eine zweite Eingabe angezeigt, da die Auswahl des Messbereichs nur einmal erfolgt,
        // müssen die Messpunkte hier entsprechend der Eingabe vor der Justage dimensioniert werden
        if (this.datensatz.justageInfo === 'justage') {
            var quellen = [this.datensatz.plattensatz.links.messpunkte, this.datensatz.plattensatz.rechts.messpunkte];
            var ziele = [this.datensatz.plattensatzJustage.links.messpunkte, this.datensatz.plattensatzJustage.rechts.messpunkte];
            for (var i = 0; i < quellen.length; i++) {
                // Wenn im Ziel (Messwerte nach Justage) Messpunkte fehlen, werden diese hinzugefügt
                var quelle = quellen[i];
                var ziel = ziele[i];
                for (var j = ziel.length; j < quelle.length; j++) {
                    ziel.push({
                        anzeige: quelle[j].anzeige,
                        mittelwert: undefined,
                        mittelwertabweichung: null,
                        messunsicherheit: null,
                        beurteilung: null,
                        messwerte: [
                            { bps: quelle[j].anzeige, sensor: null, referenzwert: null, messwertabweichung: null },
                            { bps: quelle[j].anzeige, sensor: null, referenzwert: null, messwertabweichung: null },
                            { bps: quelle[j].anzeige, sensor: null, referenzwert: null, messwertabweichung: null }
                        ]
                    });
                }
            }
        }
    };
    // umbenennen
    BpsReferenzkraftKalibrierungPlatteStore.prototype.setMesswerte = function (value) {
        var datensatz = this.datensatz;
        // @todo
        // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
        // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
        if (value.version) {
            datensatz.version = value.version;
        }
        if (value.messbereich) {
            datensatz.messbereich = value.messbereich;
        }
        if (value.plattensatz && value.plattensatz.links) {
            datensatz.plattensatz.links = value.plattensatz.links;
        }
        if (value.plattensatz && value.plattensatz.rechts) {
            datensatz.plattensatz.rechts = value.plattensatz.rechts;
        }
        if (value.pruefortparameter) {
            if (value.pruefortparameter.beginn) {
                datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn;
            }
            if (value.pruefortparameter.ende) {
                datensatz.pruefortparameter.ende = value.pruefortparameter.ende;
            }
        }
        if (value.waegezelle) {
            datensatz.waegezelle = value.waegezelle;
        }
        if (value.kmg) {
            datensatz.kmg = value.kmg;
        }
        if (value.objekt) {
            datensatz.objekt = value.objekt;
        }
        if (value.justageInfo) {
            datensatz.justageInfo = value.justageInfo;
        }
        if (value.plattensatzJustage && value.plattensatzJustage.links) {
            datensatz.plattensatzJustage.links = value.plattensatzJustage.links;
        }
        if (value.plattensatzJustage && value.plattensatzJustage.rechts) {
            datensatz.plattensatzJustage.rechts = value.plattensatzJustage.rechts;
        }
        if (value.plattensatzJustage && value.plattensatzJustage.gesamtErgebnis) {
            datensatz.plattensatzJustage.gesamtErgebnis = value.plattensatzJustage.gesamtErgebnis;
        }
        if (value.gesamtErgebnis) {
            datensatz.gesamtErgebnis = value.gesamtErgebnis;
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "objektVorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "kalibrierGegenstand", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "kraftMessGeraet", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "readOnly", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "datensatz", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "beurteilungAbrufen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setBeurteilung", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setObjektVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setKraftMessGeraet", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setKalibrierGegenstand", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setMessbereich", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setReadOnly", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setJustageInfo", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftKalibrierungPlatteStore.prototype, "setMesswerte", null);
    BpsReferenzkraftKalibrierungPlatteStore = BpsReferenzkraftKalibrierungPlatteStore_1 = __decorate([
        decorators_1.provideSingleton(BpsReferenzkraftKalibrierungPlatteStore_1)
    ], BpsReferenzkraftKalibrierungPlatteStore);
    return BpsReferenzkraftKalibrierungPlatteStore;
    var BpsReferenzkraftKalibrierungPlatteStore_1;
}());
exports.BpsReferenzkraftKalibrierungPlatteStore = BpsReferenzkraftKalibrierungPlatteStore;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(36);
function getServiceIdentifierAsString(serviceIdentifier) {
    if (typeof serviceIdentifier === "function") {
        var _serviceIdentifier = serviceIdentifier;
        return _serviceIdentifier.name;
    }
    else if (typeof serviceIdentifier === "symbol") {
        return serviceIdentifier.toString();
    }
    else {
        var _serviceIdentifier = serviceIdentifier;
        return _serviceIdentifier;
    }
}
exports.getServiceIdentifierAsString = getServiceIdentifierAsString;
function listRegisteredBindingsForServiceIdentifier(container, serviceIdentifier, getBindings) {
    var registeredBindingsList = "";
    var registeredBindings = getBindings(container, serviceIdentifier);
    if (registeredBindings.length !== 0) {
        registeredBindingsList = "\nRegistered bindings:";
        registeredBindings.forEach(function (binding) {
            var name = "Object";
            if (binding.implementationType !== null) {
                name = getFunctionName(binding.implementationType);
            }
            registeredBindingsList = registeredBindingsList + "\n " + name;
            if (binding.constraint.metaData) {
                registeredBindingsList = registeredBindingsList + " - " + binding.constraint.metaData;
            }
        });
    }
    return registeredBindingsList;
}
exports.listRegisteredBindingsForServiceIdentifier = listRegisteredBindingsForServiceIdentifier;
function circularDependencyToException(request, previousServiceIdentifiers) {
    if (previousServiceIdentifiers === void 0) { previousServiceIdentifiers = []; }
    var parentServiceIdentifier = getServiceIdentifierAsString(request.serviceIdentifier);
    previousServiceIdentifiers.push(parentServiceIdentifier);
    request.childRequests.forEach(function (childRequest) {
        var childServiceIdentifier = getServiceIdentifierAsString(childRequest.serviceIdentifier);
        if (previousServiceIdentifiers.indexOf(childServiceIdentifier) === -1) {
            if (childRequest.childRequests.length > 0) {
                circularDependencyToException(childRequest, previousServiceIdentifiers);
            }
            else {
                previousServiceIdentifiers.push(childServiceIdentifier);
            }
        }
        else {
            previousServiceIdentifiers.push(childServiceIdentifier);
            var services = previousServiceIdentifiers.reduce(function (prev, curr) {
                return (prev !== "") ? prev + " -> " + curr : "" + curr;
            }, "");
            throw new Error(ERROR_MSGS.CIRCULAR_DEPENDENCY + " " + services);
        }
    });
}
exports.circularDependencyToException = circularDependencyToException;
function listMetadataForTarget(serviceIdentifierString, target) {
    if (target.isTagged() || target.isNamed()) {
        var m_1 = "";
        var namedTag = target.getNamedTag();
        var otherTags = target.getCustomTags();
        if (namedTag !== null) {
            m_1 += namedTag.toString() + "\n";
        }
        if (otherTags !== null) {
            otherTags.forEach(function (tag) {
                m_1 += tag.toString() + "\n";
            });
        }
        return " " + serviceIdentifierString + "\n " + serviceIdentifierString + " - " + m_1;
    }
    else {
        return " " + serviceIdentifierString;
    }
}
exports.listMetadataForTarget = listMetadataForTarget;
function getFunctionName(v) {
    if (v.name) {
        return v.name;
    }
    else {
        var name_1 = v.toString();
        var match = name_1.match(/^function\s*([^\s(]+)/);
        return match ? match[1] : "Anonymous function: " + name_1;
    }
}
exports.getFunctionName = getFunctionName;


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SafeAnchor__ = __webpack_require__(41);
















var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {
      active: active
    }, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'block')] = block, _extends2));
    var fullClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('btn', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].XSMALL], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsStyles"])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, Button))));

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var EventPluginRegistry = __webpack_require__(147);
var EventPluginUtils = __webpack_require__(148);
var ReactErrorUtils = __webpack_require__(152);

var accumulateInto = __webpack_require__(240);
var forEachAccumulated = __webpack_require__(241);
var invariant = __webpack_require__(15);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(83);
var EventPluginUtils = __webpack_require__(148);

var accumulateInto = __webpack_require__(240);
var forEachAccumulated = __webpack_require__(241);
var warning = __webpack_require__(17);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(43);

var getEventTarget = __webpack_require__(157);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(67);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
/** Standard Filterbox zur Suche in Listen */
var FilterBox = (function (_super) {
    __extends(FilterBox, _super);
    function FilterBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterBox.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.InputGroup, { className: "filter-group" },
            React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                React.createElement(FaIcon_1.default, { icon: "search" })),
            React.createElement(react_bootstrap_1.FormControl, { type: "text", maxLength: 64, onChange: this.props.onChange, placeholder: this.props.placeholder ? this.props.placeholder : 'Suchen', className: "filter-box" })));
    };
    return FilterBox;
}(React.Component));
exports.default = FilterBox;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(193);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(354);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(349);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(350);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(192);

var _isTransform = __webpack_require__(351);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(398);
exports.Container = container_1.Container;
var container_module_1 = __webpack_require__(399);
exports.ContainerModule = container_module_1.ContainerModule;
var injectable_1 = __webpack_require__(388);
exports.injectable = injectable_1.injectable;
var tagged_1 = __webpack_require__(393);
exports.tagged = tagged_1.tagged;
var named_1 = __webpack_require__(390);
exports.named = named_1.named;
var inject_1 = __webpack_require__(387);
exports.inject = inject_1.inject;
var optional_1 = __webpack_require__(391);
exports.optional = optional_1.optional;
var unmanaged_1 = __webpack_require__(395);
exports.unmanaged = unmanaged_1.unmanaged;
var multi_inject_1 = __webpack_require__(389);
exports.multiInject = multi_inject_1.multiInject;
var target_name_1 = __webpack_require__(394);
exports.targetName = target_name_1.targetName;
var post_construct_1 = __webpack_require__(392);
exports.postConstruct = post_construct_1.postConstruct;
var metadata_reader_1 = __webpack_require__(202);
exports.MetadataReader = metadata_reader_1.MetadataReader;
var guid_1 = __webpack_require__(60);
exports.guid = guid_1.guid;
var decorator_utils_1 = __webpack_require__(50);
exports.decorate = decorator_utils_1.decorate;
var constraint_helpers_1 = __webpack_require__(205);
exports.traverseAncerstors = constraint_helpers_1.traverseAncerstors;
exports.taggedConstraint = constraint_helpers_1.taggedConstraint;
exports.namedConstraint = constraint_helpers_1.namedConstraint;
exports.typeConstraint = constraint_helpers_1.typeConstraint;
var serialization_1 = __webpack_require__(81);
exports.getServiceIdentifierAsString = serialization_1.getServiceIdentifierAsString;


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_prop_types_lib_all__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_prop_types_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_prop_types_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_prop_types_lib_isRequiredForA11y__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_prop_types_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_prop_types_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__ = __webpack_require__(32);


























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_14_react_prop_types_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])),

  componentClass: __WEBPACK_IMPORTED_MODULE_13_react_prop_types_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_12_react_prop_types_lib_all___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["a" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["b" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__["a" /* default */]
};

var Dropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu lets return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this2 = this;

    var ref = function ref(c) {
      _this2.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      bsClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["prefix"])(props, 'toggle'),
      onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this3 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this3.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["prefix"])(props, 'menu'),
      onClose: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this3.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["bsClass"])('dropdown', Dropdown);

var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default()(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__);









var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  'in': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false
};

var Fade = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Fade, _React$Component);

  function Fade() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Fade);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(this.props.className, 'fade'),
      enteredClassName: 'in',
      enteringClassName: 'in'
    }));
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var EventPluginRegistry = __webpack_require__(147);
var ReactEventEmitterMixin = __webpack_require__(511);
var ViewportMetrics = __webpack_require__(239);

var getVendorPrefixedEventName = __webpack_require__(543);
var isEventSupported = __webpack_require__(158);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(86);
var ViewportMetrics = __webpack_require__(239);

var getEventModifierState = __webpack_require__(156);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);
var DOMNamespaces = __webpack_require__(146);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(154);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(9));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(evt) {
	      // allow the entire document to be a drag target
	      evt.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.setRefs = _this.setRefs.bind(_this);
	    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(evt) {
	      if (this.node.contains(evt.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      evt.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(evt) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(evt) {
	      evt.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(evt.target) === -1) {
	        this.dragTargets.push(evt.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(evt) {
	      // eslint-disable-line class-methods-use-this
	      evt.preventDefault();
	      evt.stopPropagation();
	      try {
	        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, evt);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== evt.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(evt) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(evt);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      evt.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, evt);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, evt);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        evt.stopPropagation();
	        this.open();
	        if (onClick) {
	          onClick.call(this, evt);
	        }
	      }
	    }
	  }, {
	    key: 'onInputElementClick',
	    value: function onInputElementClick(evt) {
	      evt.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onClick) {
	        this.props.inputProps.onClick();
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'setRefs',
	    value: function setRefs(ref) {
	      this.fileInputEl = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: this.setRefs,
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(107);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var decorators_2 = __webpack_require__(1);
var ApiTypeFactory = __webpack_require__(54);
var ApiTypes = __webpack_require__(21);
/** Basisklasse für Komponenten zum Anlegen von neuen Aufträgen - Nicht direkt verwenden */
var AuftragAnlegen = (function (_super) {
    __extends(AuftragAnlegen, _super);
    function AuftragAnlegen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Kopfdaten
        _this.lizenznehmer = '';
        _this.verantwortlicher = '';
        _this.referenzdatum = '';
        _this.bemerkung = '';
        _this.auftraggeber = ApiTypeFactory.leereAdresse();
        _this.untersuchungsort = ApiTypeFactory.leereAdresse();
        _this.untersuchungsortGleichAuftraggeber = false;
        _this.auftragskopfGeladen = false;
        return _this;
    }
    AuftragAnlegen.prototype.setAuftragskopfGeladen = function (wert) {
        this.auftragskopfGeladen = wert;
    };
    /** Gemeinsam genutzte Eventhandller für Eingabefelder */
    AuftragAnlegen.prototype.handleLizenznehmerChanged = function (event) {
        this.lizenznehmer = event.target.value;
    };
    AuftragAnlegen.prototype.handlePiChanged = function (event) {
        this.verantwortlicher = event.target.value;
    };
    AuftragAnlegen.prototype.handleDatumChanged = function (event) {
        this.referenzdatum = event.target.value;
    };
    AuftragAnlegen.prototype.handleBemerkungChanged = function (event) {
        this.bemerkung = event.target.value;
    };
    AuftragAnlegen.prototype.handleUntersuchungsortGleichAuftraggeberChange = function (event) {
        this.untersuchungsortGleichAuftraggeber = event.target.checked;
        if (!this.untersuchungsortGleichAuftraggeber) {
            this.untersuchungsort = ApiTypeFactory.leereAdresse();
        }
    };
    /** Gemeinsam genutzte Setter für Auftragseigenschaften */
    AuftragAnlegen.prototype.setVerantwortlicher = function (verantwortlicher) {
        this.verantwortlicher = verantwortlicher;
    };
    AuftragAnlegen.prototype.setLizenznehmer = function (lizenznehmer) {
        this.lizenznehmer = lizenznehmer;
    };
    AuftragAnlegen.prototype.setAuftraggeber = function (adresse) {
        this.auftraggeber = adresse;
    };
    AuftragAnlegen.prototype.setUntersuchungsort = function (adresse) {
        this.untersuchungsort = adresse;
    };
    /** Setzt das Referenzdatum für einen neuen Auftrag auf heute */
    AuftragAnlegen.prototype.setReferenzDatum = function () {
        var datum = new Date();
        var datumISO = datum.getFullYear() + '-' + ('0' + (datum.getMonth() + 1)).slice(-2) + '-' + ('0' + datum.getDate()).slice(-2);
        this.referenzdatum = datumISO;
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragAnlegen.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragAnlegen.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragAnlegen.prototype, "lizenznehmer", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragAnlegen.prototype, "verantwortlicher", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragAnlegen.prototype, "referenzdatum", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAnlegen.prototype, "bemerkung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAnlegen.prototype, "auftraggeber", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAnlegen.prototype, "untersuchungsort", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AuftragAnlegen.prototype, "untersuchungsortGleichAuftraggeber", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AuftragAnlegen.prototype, "auftragskopfGeladen", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "setAuftragskopfGeladen", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "handleLizenznehmerChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "handlePiChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "handleDatumChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "handleBemerkungChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "handleUntersuchungsortGleichAuftraggeberChange", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "setVerantwortlicher", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "setLizenznehmer", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "setAuftraggeber", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "setUntersuchungsort", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegen.prototype, "setReferenzDatum", null);
    AuftragAnlegen = __decorate([
        mobx_react_1.observer
    ], AuftragAnlegen);
    return AuftragAnlegen;
}(React.Component));
exports.default = AuftragAnlegen;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes = __webpack_require__(21);
var ApiFactory = __webpack_require__(54);
var decorators_1 = __webpack_require__(1);
var FaIcon_1 = __webpack_require__(20);
var UiStore_1 = __webpack_require__(14);
var AuftragAdresseUebernehmen_1 = __webpack_require__(266);
/** Komponente zur Eingabe einer Adresse für die Auftragsanlage, inkl. optionaler Möglichkeit zur Übernahme der Daten aus Adressen oder Untersuchungsstellen */
var AuftragAdresseErfassen = (function (_super) {
    __extends(AuftragAdresseErfassen, _super);
    function AuftragAdresseErfassen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.adresse = ApiFactory.leereAdresse();
        _this.modalVisible = false;
        return _this;
    }
    AuftragAdresseErfassen.prototype.showModal = function () {
        this.modalVisible = true;
    };
    AuftragAdresseErfassen.prototype.hideModal = function () {
        this.modalVisible = false;
    };
    AuftragAdresseErfassen.prototype.setAdresse = function (adresse) {
        this.adresse = adresse;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.uebernehmeAdresse = function (adresse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setAdresse(adresse);
                this.hideModal();
                return [2 /*return*/];
            });
        });
    };
    AuftragAdresseErfassen.prototype.handleNameChanged = function (event) {
        this.adresse.name = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleZusatzChanged = function (event) {
        this.adresse.zusatz = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleStrasseChanged = function (event) {
        this.adresse.strasse = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handlePlzChanged = function (event) {
        this.adresse.plz = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleOrtChanged = function (event) {
        this.adresse.ort = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleTelefonnummerChanged = function (event) {
        this.adresse.tel1 = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleEmailChanged = function (event) {
        this.adresse.email = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleEmail2Changed = function (event) {
        this.adresse.email2 = event.target.value;
        this.props.onUpdateAdresse(this.adresse);
    };
    AuftragAdresseErfassen.prototype.handleUstLoeschen = function (event) {
        this.adresse.untersuchungsstellenkennung = '';
        this.adresse.adressid = undefined;
    };
    AuftragAdresseErfassen.prototype.renderHeader = function () {
        var portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
        return (React.createElement("div", null,
            React.createElement("div", { className: "panel-title pull-left" }, this.props.caption),
            React.createElement("div", { className: "panel-title pull-right" },
                React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: this.showModal },
                    React.createElement(FaIcon_1.default, { icon: "address-book-o" }),
                    " ",
                    portalAdmin ? 'Aus Adresse' : 'Aus Untersuchungsstelle')),
            React.createElement("div", { className: "clearfix" })));
    };
    AuftragAdresseErfassen.prototype.render = function () {
        var portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
        return (React.createElement(react_bootstrap_1.Panel, { className: "panel-header-buttoned", header: this.renderHeader() },
            React.createElement(react_bootstrap_1.FormGroup, { validationState: this.adresse.name.trim() === '' ? 'error' : undefined, controlId: "Name" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Name"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Name", value: this.adresse.name || '', onChange: this.handleNameChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "Name" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zusatz"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Zusatz", value: this.adresse.zusatz || '', onChange: this.handleZusatzChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "Strasse" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Stra\u00DFe"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Strasse", value: this.adresse.strasse || '', onChange: this.handleStrasseChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "PLZ" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "PLZ"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "PLZ", value: this.adresse.plz || '', onChange: this.handlePlzChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "Ort" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Ort"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Ort", value: this.adresse.ort || '', onChange: this.handleOrtChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "telefonnummer" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Telefonnummer"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Telefonnummer", placeholder: "Optional", value: this.adresse.tel1 || '', onChange: this.handleTelefonnummerChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "email" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "E-Mail"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "E-Mail", placeholder: "Optional", value: this.adresse.email || '', onChange: this.handleEmailChanged }))),
            (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) &&
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "EmailBuchhaltung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "E-Mail Buchhaltung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "EmailBuchhaltung", placeholder: "Optional", value: this.adresse.email2 || '', onChange: this.handleEmail2Changed }))),
            this.adresse.untersuchungsstellenkennung &&
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "zugeordneteust" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zugeordnete USt."),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Untersuchungsstellenkennung", placeholder: "Optional", value: this.adresse.untersuchungsstellenkennung, readOnly: true }),
                            React.createElement(react_bootstrap_1.InputGroup.Button, null,
                                React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: "btn-group", onClick: this.handleUstLoeschen },
                                    React.createElement(FaIcon_1.default, { icon: "trash" })))))),
            React.createElement(react_bootstrap_1.Modal, { show: this.modalVisible, onHide: this.hideModal, className: "modal-vertical-centered", backdrop: 'static' },
                React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                    React.createElement(react_bootstrap_1.Modal.Title, null, "Adresse \u00FCbernehmen")),
                React.createElement(react_bootstrap_1.Modal.Body, null,
                    portalAdmin ?
                        React.createElement("div", null, "Adressdaten k\u00F6nnen entweder \u00FCber die Kennung einer \u00DCO oder \u00FCber eine Adress-ID in den Auftrag \u00FCbernommen werden.")
                        :
                            React.createElement("div", null, "Adressdaten k\u00F6nnen aus der Untersuchungsstellenkennung einer \u00DCO \u00FCbernommen werden. Der Auftrag wird dann dieser Untersuchungsstelle zugeordnet."),
                    React.createElement(AuftragAdresseUebernehmen_1.default, { onUebernehme: this.uebernehmeAdresse, adressArt: ApiTypes.AdressArt.Untersuchungsstelle }),
                    portalAdmin && React.createElement(AuftragAdresseUebernehmen_1.default, { onUebernehme: this.uebernehmeAdresse, adressArt: ApiTypes.AdressArt.Auftraggeber })),
                React.createElement(react_bootstrap_1.Modal.Footer, null,
                    React.createElement(react_bootstrap_1.Button, { onClick: this.hideModal, bsStyle: "default" }, "Abbrechen")))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragAdresseErfassen.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAdresseErfassen.prototype, "adresse", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AuftragAdresseErfassen.prototype, "modalVisible", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "showModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "hideModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "setAdresse", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAdresseErfassen.prototype, "uebernehmeAdresse", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleNameChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleZusatzChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleStrasseChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handlePlzChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleOrtChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleTelefonnummerChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleEmailChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleEmail2Changed", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseErfassen.prototype, "handleUstLoeschen", null);
    AuftragAdresseErfassen = __decorate([
        mobx_react_1.observer
    ], AuftragAdresseErfassen);
    return AuftragAdresseErfassen;
}(React.Component));
exports.default = AuftragAdresseErfassen;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
/** Header für das Panel zur Objektanlage mit Funktionen je nach Anwenderstufe  */
var ObjektAnlegenHeader = (function (_super) {
    __extends(ObjektAnlegenHeader, _super);
    function ObjektAnlegenHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjektAnlegenHeader.prototype.render = function () {
        var portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
        if (portalAdmin) {
            // Portaladministratoren (=interne Mitarbeiter) dürfen Daten aus ÜO Messmitteln übernehmen
            return (React.createElement("div", null,
                React.createElement("div", { className: "panel-title pull-left" }, this.props.caption),
                React.createElement("div", { className: "panel-title pull-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: this.props.showModal },
                        React.createElement(FaIcon_1.default, { icon: "wrench" }),
                        " Aus Messmittel")),
                React.createElement("div", { className: "clearfix" })));
        }
        else {
            return (React.createElement("div", null,
                React.createElement("div", { className: "panel-title pull-left" }, this.props.caption),
                React.createElement("div", { className: "clearfix" })));
        }
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ObjektAnlegenHeader.prototype, "uiStore", void 0);
    return ObjektAnlegenHeader;
}(React.Component));
exports.ObjektAnlegenHeader = ObjektAnlegenHeader;
/** Basisklasse für Komponenten zum Anlegen von neuen Objekte - Nicht direkt verwenden */
var ObjektAnlegen = (function (_super) {
    __extends(ObjektAnlegen, _super);
    function ObjektAnlegen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objektVorlagenHersteller = [];
        _this.modalVisible = false;
        return _this;
    }
    ObjektAnlegen.prototype.showModal = function () {
        this.modalVisible = true;
    };
    ObjektAnlegen.prototype.hideModal = function () {
        this.modalVisible = false;
    };
    ObjektAnlegen.prototype.setObjektVorlagen = function (objektVorlagen) {
        var _this = this;
        this.objektVorlagen = objektVorlagen;
        // Liste der Hersteller aus Vorlagen extrahieren
        this.objektVorlagenHersteller = [];
        if (this.objektVorlagen) {
            // Liste mit eindeutigen Herstellervorlagen
            this.objektVorlagen.forEach(function (element) {
                if (_this.objektVorlagenHersteller.indexOf(element.hersteller) === -1) {
                    _this.objektVorlagenHersteller.push(element.hersteller);
                }
            });
        }
    };
    // Liefert die Liste aller Typen für den angegebenen Hersteller zurück
    ObjektAnlegen.prototype.vorlagenZuHersteller = function (hersteller) {
        // Schreibweise vom Hersteller darf keine Rolle spielen, z.B. wegen Datenübernahme aus dem ÜO Umfeld
        if (hersteller) {
            return this.objektVorlagen.filter(function (vorlage) { return vorlage.hersteller.toLocaleLowerCase() === hersteller.toLocaleLowerCase(); });
        }
        else {
            return [];
        }
    };
    // Liefert eine Objektvorlage für den gegebenen Hersteller und Typbezeichner
    ObjektAnlegen.prototype.vorlageZuModell = function (hersteller, bezeichner) {
        if ((hersteller) && (bezeichner)) {
            return this.objektVorlagenTypen.find(function (el) { return ((el.hersteller.toLocaleLowerCase() === hersteller.toLocaleLowerCase()) && (el.modell.toLocaleLowerCase() === bezeichner.toLocaleLowerCase())); });
        }
        else {
            return null;
        }
    };
    // Liefert den Wert eines in der Vorlage hinterlegten Metadatums
    ObjektAnlegen.prototype.vorlageMetaDatum = function (vorlage, kategorie, detail) {
        if (vorlage) {
            var metadatum = vorlage.meta.find(function (meta) { return meta.kategorie === kategorie && (meta.detail === detail || meta.detail === ''); });
            if (metadatum) {
                return metadatum.wert;
            }
        }
        return '';
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ObjektAnlegen.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ObjektAnlegen.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ObjektAnlegen.prototype, "objektVorlagen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ObjektAnlegen.prototype, "objektVorlagenTypen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ObjektAnlegen.prototype, "objektVorlagenHersteller", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ObjektAnlegen.prototype, "modalVisible", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegen.prototype, "showModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegen.prototype, "hideModal", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegen.prototype, "setObjektVorlagen", null);
    ObjektAnlegen = __decorate([
        mobx_react_1.observer
    ], ObjektAnlegen);
    return ObjektAnlegen;
}(React.Component));
exports.default = ObjektAnlegen;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
/** Komponente zur Übernahme der Daten eines ÜO Messmittels in das Laborumfeld */
var ObjektMessmittelUebernehmen = (function (_super) {
    __extends(ObjektMessmittelUebernehmen, _super);
    function ObjektMessmittelUebernehmen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kennung = '';
        _this.messmittelVorhanden = false;
        _this.requestInProgress = false;
        _this.abrufTimeoutRef = 0;
        return _this;
    }
    ObjektMessmittelUebernehmen.prototype.setRequestInProgress = function (value) {
        this.requestInProgress = value;
    };
    ObjektMessmittelUebernehmen.prototype.pruefeMessmittelVorhandenDelayed = function () {
        var _this = this;
        if (this.abrufTimeoutRef > 0) {
            window.clearTimeout(this.abrufTimeoutRef);
            this.abrufTimeoutRef = 0;
        }
        var validateTimeoutInMs = 500;
        this.abrufTimeoutRef = window.setTimeout(function () { _this.pruefeMessmittelVorhanden(); }, validateTimeoutInMs);
    };
    ObjektMessmittelUebernehmen.prototype.pruefeMessmittelVorhanden = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.kennung !== '')) return [3 /*break*/, 2];
                        this.setRequestInProgress(true);
                        return [4 /*yield*/, this.apiStore.messmittelVorhanden(this.props.kategorie, this.kennung)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setMmVorhanden(response.json.vorhanden);
                        }
                        this.setRequestInProgress(false);
                        return [3 /*break*/, 3];
                    case 2:
                        this.setMmVorhanden(false);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ObjektMessmittelUebernehmen.prototype.setMmVorhanden = function (value) {
        this.messmittelVorhanden = value;
    };
    ObjektMessmittelUebernehmen.prototype.uebernehme = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.kennung !== '')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.messmittelDaten(this.props.kategorie, this.kennung)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.props.onUebernehme(response.json);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ObjektMessmittelUebernehmen.prototype.handleMmKennungChanged = function (event) {
        this.kennung = event.target.value;
        this.pruefeMessmittelVorhandenDelayed();
    };
    ObjektMessmittelUebernehmen.prototype.renderAbfrageStatus = function () {
        if (this.kennung === '') {
            return React.createElement("div", { style: { marginTop: '15px' } }, "\u00A0");
        }
        if (this.requestInProgress) {
            return React.createElement("div", { style: { marginTop: '15px' } },
                React.createElement(FaIcon_1.default, { icon: "spinner" }),
                "Daten werden abgerufen...");
        }
        if (this.messmittelVorhanden) {
            return React.createElement("div", { className: "value-success", style: { marginTop: '15px' } },
                React.createElement(FaIcon_1.default, { icon: "check" }),
                "Zu diesem Messmittel liegen Daten der \u00DCO vor");
        }
        if (this.messmittelVorhanden === false) {
            return React.createElement("div", { style: { marginTop: '15px' } },
                React.createElement(FaIcon_1.default, { icon: "question" }),
                "Zu diesem Messmittel liegen keine Daten der \u00DCO vor");
        }
        // @todo: Vorlage prüfen
        return React.createElement("div", { style: { marginTop: '15px' } }, "\u00A0");
    };
    ObjektMessmittelUebernehmen.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { marginTop: '15px' } },
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "MMKennung" },
                React.createElement(react_bootstrap_1.ControlLabel, null, "Kennung der \u00DCO"),
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Kennung", placeholder: "z.B. Kennung der ÜO", onChange: this.handleMmKennungChanged, value: this.kennung }),
                    React.createElement(react_bootstrap_1.InputGroup.Button, null,
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "success", className: "btn-group", disabled: !this.messmittelVorhanden, onClick: function () { return _this.uebernehme(); } }, "\u00DCbernehmen"))),
                this.renderAbfrageStatus())));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ObjektMessmittelUebernehmen.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ObjektMessmittelUebernehmen.prototype, "kennung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ObjektMessmittelUebernehmen.prototype, "messmittelVorhanden", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ObjektMessmittelUebernehmen.prototype, "requestInProgress", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ObjektMessmittelUebernehmen.prototype, "setRequestInProgress", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ObjektMessmittelUebernehmen.prototype, "pruefeMessmittelVorhanden", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ObjektMessmittelUebernehmen.prototype, "setMmVorhanden", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ObjektMessmittelUebernehmen.prototype, "uebernehme", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektMessmittelUebernehmen.prototype, "handleMmKennungChanged", null);
    ObjektMessmittelUebernehmen = __decorate([
        mobx_react_1.observer
    ], ObjektMessmittelUebernehmen);
    return ObjektMessmittelUebernehmen;
}(React.Component));
/** Modaler Dialog für Datenübernahme */
var ObjektMessmittelUebernehmenModal = (function (_super) {
    __extends(ObjektMessmittelUebernehmenModal, _super);
    function ObjektMessmittelUebernehmenModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjektMessmittelUebernehmenModal.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Modal, { show: this.props.show, onHide: this.props.onHideModal, className: "modal-vertical-centered", backdrop: 'static' },
            React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                React.createElement(react_bootstrap_1.Modal.Title, null, "Daten aus Messmittel \u00FCbernehmen")),
            React.createElement(react_bootstrap_1.Modal.Body, null,
                React.createElement("div", null, "Die Daten f\u00FCr das neue Objekt k\u00F6nnen \u00FCber die Messmittelkennung einer \u00DCO \u00FCbernommen werden."),
                React.createElement(ObjektMessmittelUebernehmen, { onUebernehme: this.props.onUebernehme, kategorie: this.props.kategorie })),
            React.createElement(react_bootstrap_1.Modal.Footer, null,
                React.createElement(react_bootstrap_1.Button, { onClick: this.props.onHideModal, bsStyle: "default" }, "Abbrechen"))));
    };
    ObjektMessmittelUebernehmenModal = __decorate([
        mobx_react_1.observer
    ], ObjektMessmittelUebernehmenModal);
    return ObjektMessmittelUebernehmenModal;
}(React.Component));
exports.default = ObjektMessmittelUebernehmenModal;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** Komponente für Zugriff auf Objekte als Kalibriergegenstände */
var KalibrierGegenstand = (function () {
    function KalibrierGegenstand(objekt) {
        this.objekt = undefined;
        this.objekt = objekt;
    }
    KalibrierGegenstand.prototype.meta = function (bezeichnung) {
        if (!this.objekt) {
            return;
        }
        if (this.objekt && this.objekt.meta) {
            var metaDatum = this.objekt.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
            return metaDatum && metaDatum.inhalt;
        }
        return undefined;
    };
    KalibrierGegenstand.prototype.metaAsNumber = function (bezeichnung) {
        if (!this.objekt) {
            return;
        }
        if (this.objekt && this.objekt.meta) {
            var metaDatum = this.objekt.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
            if (metaDatum) {
                return parseFloat(metaDatum.inhalt);
            }
        }
        return undefined;
    };
    return KalibrierGegenstand;
}());
exports.default = KalibrierGegenstand;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(690);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(294);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(293);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(303);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(63)
  , dPs         = __webpack_require__(319)
  , enumBugKeys = __webpack_require__(118)
  , IE_PROTO    = __webpack_require__(123)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(177)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(309).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(58).f
  , has = __webpack_require__(57)
  , TAG = __webpack_require__(40)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(124)('keys')
  , uid    = __webpack_require__(90);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(47)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(117);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(76);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(47)
  , core           = __webpack_require__(39)
  , LIBRARY        = __webpack_require__(119)
  , wksExt         = __webpack_require__(129)
  , defineProperty = __webpack_require__(58).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(40);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(588);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(695);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var provide_when_syntax_1 = __webpack_require__(135);
var ProvideOnSyntax = (function () {
    function ProvideOnSyntax(bindingOnSyntax, provideDoneSyntax) {
        this._bindingOnSyntax = bindingOnSyntax;
        this._provideDoneSyntax = provideDoneSyntax;
    }
    ProvideOnSyntax.prototype.onActivation = function (fn) {
        var bindingWhenSyntax = this._bindingOnSyntax.onActivation(fn);
        return new provide_when_syntax_1.default(bindingWhenSyntax, this._provideDoneSyntax);
    };
    ProvideOnSyntax.prototype.done = function () {
        return this._provideDoneSyntax.done();
    };
    return ProvideOnSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProvideOnSyntax;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var provide_on_syntax_1 = __webpack_require__(134);
var ProvideWhenSyntax = (function () {
    function ProvideWhenSyntax(bindingWhenSyntax, provideDoneSyntax) {
        this._bindingWhenSyntax = bindingWhenSyntax;
        this._provideDoneSyntax = provideDoneSyntax;
    }
    ProvideWhenSyntax.prototype.when = function (constraint) {
        var bindingOnSyntax = this._bindingWhenSyntax.when(constraint);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenTargetNamed = function (name) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenTargetNamed(name);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenTargetTagged = function (tag, value) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenTargetTagged(tag, value);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenInjectedInto = function (parent) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenInjectedInto(parent);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenParentNamed = function (name) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenParentNamed(name);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenParentTagged = function (tag, value) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenParentTagged(tag, value);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenAnyAncestorNamed = function (name) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenAnyAncestorNamed(name);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenNoAncestorNamed = function (name) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenNoAncestorNamed(name);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        var bindingOnSyntax = this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
        return new provide_on_syntax_1.default(bindingOnSyntax, this._provideDoneSyntax);
    };
    ProvideWhenSyntax.prototype.done = function () {
        return this._provideDoneSyntax.done();
    };
    return ProvideWhenSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProvideWhenSyntax;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_when_syntax_1 = __webpack_require__(137);
var BindingOnSyntax = (function () {
    function BindingOnSyntax(binding) {
        this._binding = binding;
    }
    BindingOnSyntax.prototype.onActivation = function (handler) {
        this._binding.onActivation = handler;
        return new binding_when_syntax_1.BindingWhenSyntax(this._binding);
    };
    return BindingOnSyntax;
}());
exports.BindingOnSyntax = BindingOnSyntax;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_on_syntax_1 = __webpack_require__(136);
var constraint_helpers_1 = __webpack_require__(205);
var BindingWhenSyntax = (function () {
    function BindingWhenSyntax(binding) {
        this._binding = binding;
    }
    BindingWhenSyntax.prototype.when = function (constraint) {
        this._binding.constraint = constraint;
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetNamed = function (name) {
        this._binding.constraint = constraint_helpers_1.namedConstraint(name);
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetIsDefault = function () {
        this._binding.constraint = function (request) {
            var targetIsDefault = (request.target !== null) &&
                (request.target.isNamed() === false) &&
                (request.target.isTagged() === false);
            return targetIsDefault;
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetTagged = function (tag, value) {
        this._binding.constraint = constraint_helpers_1.taggedConstraint(tag)(value);
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenInjectedInto = function (parent) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.typeConstraint(parent)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenParentNamed = function (name) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.namedConstraint(name)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenParentTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.taggedConstraint(tag)(value)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.typeConstraint(ancestor));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.typeConstraint(ancestor));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorNamed = function (name) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.namedConstraint(name));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorNamed = function (name) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.namedConstraint(name));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.taggedConstraint(tag)(value));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.taggedConstraint(tag)(value));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    return BindingWhenSyntax;
}());
exports.BindingWhenSyntax = BindingWhenSyntax;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 139 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(28);














var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[1]), 10);
}

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  'in': __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Collapse, _React$Component);

  function Collapse(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Collapse);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleEntered = _this.handleEntered.bind(_this);
    _this.handleExit = _this.handleExit.bind(_this);
    _this.handleExiting = _this.handleExiting.bind(_this);
    return _this;
  }

  /* -- Expanding -- */


  Collapse.prototype.handleEnter = function handleEnter(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype.handleEntering = function handleEntering(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
  };

  Collapse.prototype.handleEntered = function handleEntered(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = null;
  };

  /* -- Collapsing -- */


  Collapse.prototype.handleExit = function handleExit(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
    triggerBrowserReflow(elem);
  };

  Collapse.prototype.handleExiting = function handleExiting(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype._dimension = function _dimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)] + 'px';
  };

  Collapse.prototype.render = function render() {
    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);

    var classes = {
      width: this._dimension() === 'width'
    };

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      'aria-expanded': props.role ? props['in'] : null,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      exitedClassName: 'collapse',
      exitingClassName: 'collapsing',
      enteredClassName: 'collapse in',
      enteringClassName: 'collapsing',
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }));
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

var Glyphicon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Glyphicon, _React$Component);

  function Glyphicon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Glyphicon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['glyph', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Glyphicon.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('glyphicon', Glyphicon));

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaBody__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaHeading__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLeft__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaList__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MediaListItem__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MediaRight__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(12);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Media = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Media, _React$Component);

  function Media() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Media);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

Media.Heading = __WEBPACK_IMPORTED_MODULE_9__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_8__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_10__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_13__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_11__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_12__MediaListItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["bsClass"])('media', Media));

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);








var TAB = 'tab';
var PANE = 'pane';

var idPropType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var TabContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TabContainer, _React$Component);

  function TabContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TabContainer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(TabContainer, { activeKey: 'onSelect' }));

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or any
   * `<Transition>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
  })
};

var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('tab', TabContent));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(69);
var Danger = __webpack_require__(488);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactInstrumentation = __webpack_require__(38);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(154);
var setInnerHTML = __webpack_require__(103);
var setTextContent = __webpack_require__(247);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var ReactErrorUtils = __webpack_require__(152);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var ReactPropTypesSecret = __webpack_require__(517);
var propTypesFactory = __webpack_require__(206);

var React = __webpack_require__(72);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var ReactCurrentOwner = __webpack_require__(44);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(38);
var ReactUpdates = __webpack_require__(42);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var emptyFunction = __webpack_require__(34);
var warning = __webpack_require__(17);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContainer;

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(107);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict;

  var _compilePath = compilePath(path, { end: exact, strict: strict }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var ApiTypes_1 = __webpack_require__(21);
var FaIcon_1 = __webpack_require__(20);
var ObjektListe = (function (_super) {
    __extends(ObjektListe, _super);
    function ObjektListe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objektKuerzel = new Map([
            ['ses', 'Scheinwerfer-Einstellprüfgerät'],
            ['agt', 'Abgasmessgerät'],
            ['bps', 'Bremsprüfstand'],
            ['dmg', 'Druckmessgerät']
        ]);
        return _this;
    }
    ObjektListe.prototype.componentDidMount = function () {
        this.refresh();
    };
    ObjektListe.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objekte;
            return __generator(this, function (_a) {
                objekte = this.props.objekte;
                if (objekte) {
                    this.setObjekte(objekte);
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(ObjektListe.prototype, "objektBezeichner", {
        /** Liefert den zum Auftrag bzw. Vorgang passenden Objektbezeichner (SEP für SES, AGT für Kal. Abgasmessgerät, etc.) */
        get: function () {
            var _a = this.props, auftrag = _a.auftrag, vorgang = _a.vorgang;
            var kategorie = auftrag && auftrag.kategorie ? auftrag.kategorie : '';
            if (vorgang) {
                kategorie = vorgang.objekttyp;
            }
            return this.objektKuerzel.get(kategorie.toLocaleLowerCase()) || 'Objekt';
        },
        enumerable: true,
        configurable: true
    });
    ObjektListe.prototype.setObjekte = function (objekte) {
        this.objekte = objekte;
    };
    ObjektListe.prototype.render = function () {
        var _this = this;
        var _a = this.props, editable = _a.editable, onAuswahlAufheben = _a.onAuswahlAufheben, auftrag = _a.auftrag, vorgang = _a.vorgang;
        var kategorie = auftrag && auftrag.kategorie ? auftrag.kategorie : '';
        if (vorgang) {
            kategorie = vorgang.objekttyp;
        }
        var url = kategorie !== '' ? "objekte/anlegen/" + kategorie : '';
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.showTitle ? this.objektBezeichner : undefined, footer: editable && (React.createElement("div", { className: "text-right" },
                (url !== '') && React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo(url); }, bsStyle: "success" }, "Neu"),
                ((!this.objekte) || (this.objekte.length > 0)) && React.createElement(react_bootstrap_1.Button, { onClick: (onAuswahlAufheben) ? function () { return onAuswahlAufheben(); } : undefined, bsStyle: "danger" }, "Entfernen"),
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo('objekte'); } }, "Ausw\u00E4hlen"))) },
            React.createElement(react_bootstrap_1.ListGroup, { fill: true }, !this.objekte ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "lade Daten...")) : (this.objekte.length === 0) ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "Es wurde noch kein Objekt gew\u00E4hlt")) : this.objekte.map(function (objekt, index) { return (React.createElement(ObjektListItem, { key: index, objekt: objekt, zusatzinfo: true })); }))));
    };
    ObjektListe.defaultProps = {
        editable: true,
        showTitle: true
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ObjektListe.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ObjektListe.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ObjektListe.prototype, "objekte", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ObjektListe.prototype, "objektBezeichner", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektListe.prototype, "setObjekte", null);
    ObjektListe = __decorate([
        mobx_react_1.observer
    ], ObjektListe);
    return ObjektListe;
}(React.Component));
exports.default = ObjektListe;
/**
 * Zeigt zusätzliche Informationen aus den Meta-Daten eines Objektes anhand seiner Kategorie an
 * Z.B. Genauigkeitsklasse beim AGT, Übersetzungsverhältnis beim BPS
 */
var ObjektListItemZusatzInfo = (function (_super) {
    __extends(ObjektListItemZusatzInfo, _super);
    function ObjektListItemZusatzInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjektListItemZusatzInfo.prototype.findMeta = function (bezeichnung) {
        var objekt = this.props.objekt;
        if (!objekt.meta) {
            return undefined;
        }
        var metaDatum = objekt.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        if (metaDatum) {
            return metaDatum.inhalt;
        }
        return undefined;
    };
    ObjektListItemZusatzInfo.prototype.renderAGT4GasInfo = function () {
        var genauigkeitsKlasse = this.findMeta('agt_genauigkeitsklasse');
        return (React.createElement("span", { className: "text-muted" },
            React.createElement("b", null, "Genauigkeitsklasse: "),
            " ",
            genauigkeitsKlasse,
            React.createElement("br", null)));
    };
    ObjektListItemZusatzInfo.prototype.renderAGTOpazimeterInfo = function () {
        var fgKoeffizient = this.findMeta('agt_fehlergrenze');
        var messkammerLaenge = this.findMeta('agt_messkammerlänge');
        return (React.createElement("span", { className: "text-muted" },
            React.createElement("b", null, "Fehlergrenze: "),
            " \u00B1 ",
            fgKoeffizient,
            " m",
            React.createElement("sup", null, "-1"),
            React.createElement("br", null),
            React.createElement("b", null, "Messkammerl\u00E4nge: "),
            messkammerLaenge,
            " mm",
            React.createElement("br", null)));
    };
    ObjektListItemZusatzInfo.prototype.renderAGTInfo = function () {
        var art = this.props.objekt.art ? this.props.objekt.art.toLocaleLowerCase() : '';
        return (React.createElement("div", null,
            ((art === ApiTypes_1.AGT_4GAS) || (art === ApiTypes_1.AGT_KOMBI)) && this.renderAGT4GasInfo(),
            ((art === ApiTypes_1.AGT_OPAZIMETER) || (art === ApiTypes_1.AGT_KOMBI)) && this.renderAGTOpazimeterInfo()));
    };
    ObjektListItemZusatzInfo.prototype.renderBPSInfo = function () {
        var hebelArmLaenge = this.findMeta('hebelarmlänge');
        var nenndurchmesserRolle = this.findMeta('rollendurchmesser');
        var uebersetzungZaehler = this.findMeta('übersetzungsverhältnis_zähler');
        var uebersetzungNenner = this.findMeta('übersetzungsverhältnis_nenner');
        var anzeigeArt = this.findMeta('anzeigeart');
        var anzeigeAufloesung = this.findMeta('anzeigeaufloesung');
        return (React.createElement("span", null,
            React.createElement("b", null, "Art:"),
            " ",
            this.props.objekt.name,
            React.createElement("br", null),
            this.props.objekt.art === 'rolle' && React.createElement("div", null,
                React.createElement("b", null, "Hebelarml\u00E4nge:"),
                " ",
                hebelArmLaenge,
                " mm",
                React.createElement("br", null),
                React.createElement("b", null, "Nenndurchmesser Rolle:"),
                " ",
                nenndurchmesserRolle,
                " mm",
                React.createElement("br", null),
                React.createElement("b", null, "\u00DCbersetzung:"),
                " ",
                uebersetzungZaehler,
                " : ",
                uebersetzungNenner,
                React.createElement("br", null)),
            React.createElement("b", null, "Anzeige:"),
            " ",
            React.createElement("span", { className: "capitalize" }, anzeigeArt),
            " mit ",
            anzeigeAufloesung,
            " N Aufl\u00F6sung",
            React.createElement("br", null)));
    };
    ObjektListItemZusatzInfo.prototype.render = function () {
        var objekt = this.props.objekt;
        var typ = objekt.typ.toLocaleLowerCase();
        // Je nach Typ des Objektes sollen zusätzliche, spezifische Informationen angezeigt werden die direkt bei der Anzeige für den Nutzer relevant sind
        if (typ === 'agt') {
            return (React.createElement("span", { className: "text-muted" }, this.renderAGTInfo()));
        }
        if (typ === 'bps') {
            return (React.createElement("span", { className: "text-muted" }, this.renderBPSInfo()));
        }
        return null;
    };
    return ObjektListItemZusatzInfo;
}(React.Component));
var ObjektListItem = (function (_super) {
    __extends(ObjektListItem, _super);
    function ObjektListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjektListItem.prototype.render = function () {
        var _a = this.props, objekt = _a.objekt, onObjektAuswahl = _a.onObjektAuswahl, zusatzinfo = _a.zusatzinfo;
        return (React.createElement(react_bootstrap_1.ListGroupItem, { onClick: (onObjektAuswahl) ? function () { return onObjektAuswahl(objekt); } : undefined, header: React.createElement("span", null, objekt.objektid) },
            React.createElement("span", { className: "text-muted" },
                React.createElement("b", null, "Typ:"),
                " ",
                objekt.hersteller,
                " ",
                objekt.typbezeichnung,
                React.createElement("br", null),
                React.createElement("b", null, "S/N:"),
                " ",
                objekt.sernr,
                React.createElement("br", null),
                objekt.bemerkung && objekt.bemerkung !== '-' && React.createElement("div", null,
                    React.createElement(FaIcon_1.default, { icon: "file-text-o" }),
                    " ",
                    objekt.bemerkung)),
            zusatzinfo && React.createElement(ObjektListItemZusatzInfo, { objekt: objekt })));
    };
    return ObjektListItem;
}(React.Component));
exports.ObjektListItem = ObjektListItem;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
/** Basisklasse für Listen die Daten paginiert und gefiltert vom Back-End abrufen */
var PagedList = (function (_super) {
    __extends(PagedList, _super);
    function PagedList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Pagination und Filterung
        _this.currentPage = 1;
        _this.lastPage = 1;
        _this.filter = '';
        _this.total = 1;
        _this.filterDelay = 150;
        return _this;
    }
    PagedList.prototype.setLastPage = function (value) {
        this.lastPage = value;
    };
    PagedList.prototype.setFilter = function (value) {
        this.filter = value;
    };
    PagedList.prototype.setCurrentPage = function (value) {
        this.currentPage = value;
    };
    PagedList.prototype.setTotal = function (value) {
        this.total = value;
    };
    PagedList.prototype.handleFilterList = function (event) {
        var _this = this;
        this.setFilter(event.target.value);
        if (this.filterDelay > 0) {
            window.clearTimeout(this.filterDelay);
            this.filterDelay = 0;
        }
        this.filterDelay = window.setTimeout(function () { if (_this.paginate) {
            _this.paginate(1);
        } }, 500);
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], PagedList.prototype, "currentPage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], PagedList.prototype, "lastPage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], PagedList.prototype, "filter", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PagedList.prototype, "setLastPage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PagedList.prototype, "setFilter", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PagedList.prototype, "setCurrentPage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PagedList.prototype, "setTotal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PagedList.prototype, "handleFilterList", null);
    PagedList = __decorate([
        mobx_react_1.observer
    ], PagedList);
    return PagedList;
}(React.Component));
exports.default = PagedList;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Pager = (function (_super) {
    __extends(Pager, _super);
    function Pager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Max. Anzahl an Seiten die auf die Standardbreite passen
        _this.maxItems = 14;
        return _this;
    }
    Pager.prototype.renderPageButtons = function () {
        var _a = this.props, activePage = _a.activePage, items = _a.items, onSelect = _a.onSelect;
        var showEllipsis = items > this.maxItems;
        var buttons = [];
        var _loop_1 = function (i) {
            var className = (i + 1) === activePage ? 'active' : '';
            // Wenn es mehr Seiten gibt als in die Breite passen, wird mittig ein Button mit '...' angezeit, so wie in neuen Bootstrap Versionen
            if (showEllipsis && i === this_1.maxItems - 1) {
                var buttonCaption = ((activePage < this_1.maxItems) || (activePage === items)) ? '...' : activePage;
                buttons.push(React.createElement("li", { key: "pager-btn-ellipsis", className: "disabled" },
                    React.createElement("a", { role: "button", href: "#" }, buttonCaption)));
                buttons.push(React.createElement("li", { key: "pager-btn-ellipsis-end", className: activePage === items ? 'active' : '', onClick: function () { return onSelect(items); } },
                    React.createElement("a", { role: "button", href: "#" }, items)));
                return "break";
            }
            buttons.push(React.createElement("li", { key: "pager-btn-" + i, className: className, onClick: function () { return onSelect(i + 1); } },
                React.createElement("a", { role: "button", href: "#" }, i + 1)));
        };
        var this_1 = this;
        for (var i = 0; i < items; i++) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
        return buttons;
    };
    Pager.prototype.renderNavButtonsLeft = function () {
        var _this = this;
        // Buttons nur aktivieren wenn nicht am Anfang der Liste
        var enabled = this.props.activePage > 1;
        var buttons = [];
        if (enabled) {
            buttons.push(React.createElement("li", { key: "pager-btn-first", className: "" },
                React.createElement("a", { role: "button", href: "#", onClick: function () { return _this.props.onSelect(1); } },
                    React.createElement("span", { "aria-label": "First" }, "\u00AB"))));
            buttons.push(React.createElement("li", { key: "pager-btn-prev", className: "" },
                React.createElement("a", { role: "button", href: "#", onClick: function () { return _this.props.onSelect(_this.props.activePage - 1); } },
                    React.createElement("span", { "aria-label": "Previous" }, "\u2039"))));
        }
        else {
            buttons.push(React.createElement("li", { key: "pager-btn-first", className: "disabled" },
                React.createElement("a", { role: "button", href: "#" },
                    React.createElement("span", { "aria-label": "First" }, "\u00AB"))));
            buttons.push(React.createElement("li", { key: "pager-btn-prev", className: "disabled" },
                React.createElement("a", { role: "button", href: "#" },
                    React.createElement("span", { "aria-label": "Previous" }, "\u2039"))));
        }
        return buttons;
    };
    Pager.prototype.renderNavButtonsRight = function () {
        var _this = this;
        // Buttons nur aktivieren wenn nicht am Ende der Liste
        var enabled = this.props.activePage < this.props.items;
        var buttons = [];
        if (enabled) {
            buttons.push(React.createElement("li", { key: "pager-btn-next", className: "" },
                React.createElement("a", { role: "button", href: "#", onClick: function () { return _this.props.onSelect(_this.props.activePage + 1); } },
                    React.createElement("span", { "aria-label": "Next" }, "\u203A"))));
            buttons.push(React.createElement("li", { key: "pager-btn-last", className: "" },
                React.createElement("a", { role: "button", href: "#", onClick: function () { return _this.props.onSelect(_this.props.items); } },
                    React.createElement("span", { "aria-label": "Last" }, "\u00BB"))));
        }
        else {
            buttons.push(React.createElement("li", { key: "pager-btn-next", className: "disabled" },
                React.createElement("a", { role: "button", href: "#" },
                    React.createElement("span", { "aria-label": "Next" }, "\u203A"))));
            buttons.push(React.createElement("li", { key: "pager-btn-last", className: "disabled" },
                React.createElement("a", { role: "button", href: "#" },
                    React.createElement("span", { "aria-label": "Last" }, "\u00BB"))));
        }
        return buttons;
    };
    Pager.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("ul", { className: "pagination", style: { marginBottom: '15px', float: 'right' } },
                this.renderNavButtonsLeft(),
                this.renderPageButtons(),
                this.renderNavButtonsRight())));
    };
    return Pager;
}(React.Component));
exports.default = Pager;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(52);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var PrivateRoute = (function (_super) {
    __extends(PrivateRoute, _super);
    function PrivateRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivateRoute.prototype.render = function () {
        if (this.uiStore.isLoggedIn) {
            return (React.createElement(react_router_dom_1.Route, __assign({}, this.props)));
        }
        else {
            return (React.createElement(react_router_dom_1.Redirect, { to: {
                    pathname: '/login',
                    state: { from: this.props.location }
                } }));
        }
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], PrivateRoute.prototype, "uiStore", void 0);
    PrivateRoute = __decorate([
        mobx_react_1.observer
    ], PrivateRoute);
    return PrivateRoute;
}(React.Component));
exports.default = PrivateRoute;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var Callout_1 = __webpack_require__(16);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
/**
 * Komponente zur Anzeige der für die Kalibrierung relevanten Daten zum gewählten Kraftmessgerät
 */
var BpsReferenzkraftKMGInfo = (function (_super) {
    __extends(BpsReferenzkraftKMGInfo, _super);
    function BpsReferenzkraftKMGInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftKMGInfo.prototype.meta = function (bezeichnung) {
        var kmg = this.kalibrierungStore.kraftMessGeraet();
        if (kmg && kmg.meta) {
            var metaDatum = kmg.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
            return metaDatum && metaDatum.inhalt;
        }
        return undefined;
    };
    BpsReferenzkraftKMGInfo.prototype.render = function () {
        var kmg = this.kalibrierungStore.kraftMessGeraet();
        if (kmg) {
            return (React.createElement(react_bootstrap_1.Panel, { header: kmg.name, collapsible: true, defaultExpanded: false },
                React.createElement("b", null, "Kraftbereich:"),
                " ",
                this.meta('messbereich'),
                " N",
                React.createElement("br", null),
                React.createElement("b", null, "Max. Messunsicherheit:"),
                " ",
                this.meta('messunsicherheit_max'),
                React.createElement("br", null),
                React.createElement("b", null, "Skalenteilung:"),
                " ",
                this.meta('auflösung'),
                React.createElement("br", null),
                React.createElement("b", null, "Wiederholpr\u00E4zision:"),
                " ",
                this.meta('wiederholpräzision'),
                React.createElement("br", null)));
        }
        else {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Es wurde noch kein Kraftmessger\u00E4t ausgew\u00E4hlt!")));
        }
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], BpsReferenzkraftKMGInfo.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftKMGInfo.prototype, "kalibrierungStore", void 0);
    BpsReferenzkraftKMGInfo = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftKMGInfo);
    return BpsReferenzkraftKMGInfo;
}(React.Component));
exports.default = BpsReferenzkraftKMGInfo;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var Callout_1 = __webpack_require__(16);
/** Zeigt eine Liste mit Hinweisen zur Beurteilung der Aufstellfläche des Scheinwerfer-Einstell-Prüfsystems an */
var SesAuswertungFlaechenMesswertValidierung = (function (_super) {
    __extends(SesAuswertungFlaechenMesswertValidierung, _super);
    function SesAuswertungFlaechenMesswertValidierung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SesAuswertungFlaechenMesswertValidierung.prototype.render = function () {
        var _a = this.props, beurteilungsErgebnis = _a.beurteilungsErgebnis, aufstellflaechenTyp = _a.aufstellflaechenTyp;
        var beurteilungWirdAusgefuehrt = (beurteilungsErgebnis.beurteilung.length === 0);
        var hasErrors = beurteilungsErgebnis.beurteilung.some(function (beurteilung) { return !beurteilung.links.eingehalten || !beurteilung.rechts.eingehalten; });
        var bsStyle;
        var header;
        if (!this.props.vollstaendigAusgefuellt) {
            header = React.createElement("span", null, "Es wurden noch nicht alle Messwerte eingetragen");
            bsStyle = 'default';
        }
        else if (beurteilungWirdAusgefuehrt) {
            header = React.createElement("span", null, "Berechnung wird ausgef\u00FChrt...");
            bsStyle = 'info';
        }
        else if (hasErrors) {
            header = React.createElement("span", null, "Einige Werte liegen au\u00DFerhalb des Toleranzbereichs");
            bsStyle = 'danger';
        }
        else {
            header = React.createElement("span", null, "Alle Werte liegen innerhalb des Toleranzbereichs");
            bsStyle = 'success';
        }
        return (React.createElement(Callout_1.default, { bsStyle: bsStyle },
            header,
            hasErrors && (React.createElement(react_bootstrap_1.ListGroup, { className: "error-list-group" }, beurteilungsErgebnis.beurteilung.map(function (beurteilung, index) { return (React.createElement("span", { key: "LR" + index },
                !beurteilung.links.eingehalten && (React.createElement(react_bootstrap_1.ListGroupItem, { header: beurteilung.links.label, className: "error-list-item", href: "#" + aufstellflaechenTyp + "-" + beurteilung.links.label }, beurteilung.links.bemerkung.map(function (text, bIndex) { return React.createElement("span", { key: "L" + bIndex }, text); }))),
                !beurteilung.rechts.eingehalten && (React.createElement(react_bootstrap_1.ListGroupItem, { header: beurteilung.rechts.label, className: "error-list-item", href: "#" + aufstellflaechenTyp + "-" + beurteilung.rechts.label }, beurteilung.rechts.bemerkung.map(function (text, bIndex) { return React.createElement("span", { key: "R" + bIndex }, text); }))))); })))));
    };
    SesAuswertungFlaechenMesswertValidierung = __decorate([
        mobx_react_1.observer
    ], SesAuswertungFlaechenMesswertValidierung);
    return SesAuswertungFlaechenMesswertValidierung;
}(React.Component));
exports.default = SesAuswertungFlaechenMesswertValidierung;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
/** Zeigt die Systemneigungen des Gesamtsystems SES inkl. ihrer Beurteilung während der Erfassung der Messwerte an */
var SesAuswertungSystemneigung = (function (_super) {
    __extends(SesAuswertungSystemneigung, _super);
    function SesAuswertungSystemneigung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SesAuswertungSystemneigung.prototype.render = function () {
        var beurteilungStyle;
        var beurteilungText;
        var korrekturWertSEPohneNA;
        var korrekturWertSEPmitNA;
        var laengsneigungSEPio;
        var querneigungSEPio;
        var flaecheio;
        var neigungenio;
        var toleranzenio;
        var beurteilungio;
        // Korrekturwerte SEP für Ausführungen mit und ohne Niveauausgleich (NA) selektieren
        korrekturWertSEPohneNA = (this.props.neigungenFZ.laengs - this.props.neigungenSEP.quer).toLocaleString(undefined, { minimumFractionDigits: 1 });
        korrekturWertSEPmitNA = this.props.neigungenFZ.laengs.toLocaleString(undefined, { minimumFractionDigits: 1 });
        // Überprüfung der Gleichrichtiung der Flächen (nur für 2014er Rili)
        if (this.props.richtlinie === '2014') {
            // Korrektur nur möglich wenn Vorzeichen der Neigungen gleichgerichtet
            laengsneigungSEPio = ((this.props.neigungenFZ.laengs * this.props.neigungenSEP.quer) >= 0.0) ? true : false;
            querneigungSEPio = ((this.props.neigungenFZ.quer * this.props.neigungenSEP.laengs) >= 0.0) ? true : false;
        }
        else {
            laengsneigungSEPio = true;
            querneigungSEPio = true;
        }
        /*
          Beurteilung der Neigungen der Flächen zueinander
    
          Fläche in Ordnung wenn beide Kreuzvergleiche mit gleichem Vorzeichen
        */
        flaecheio = laengsneigungSEPio && querneigungSEPio;
        if (flaecheio) {
            beurteilungStyle = 'success';
            beurteilungText = (React.createElement("span", null,
                "Korrekturwert f\u00FCr SEP ",
                React.createElement("b", null, "ohne Niveauausgleich"),
                ": ",
                React.createElement("b", null,
                    korrekturWertSEPohneNA,
                    "%"),
                React.createElement("br", null),
                "Korrekturwert f\u00FCr SEP ",
                React.createElement("b", null, "mit Niveauausgleich"),
                ": ",
                React.createElement("b", null,
                    korrekturWertSEPmitNA,
                    "%")));
        }
        else {
            beurteilungStyle = 'danger';
            beurteilungText = (React.createElement("span", null,
                "Aufgrund der entgegengesetzten Neigungen Fahrzeug-Aufstellfl\u00E4che zu SEP Aufstellfl\u00E4che erf\u00FCllt diese Fl\u00E4che die Anforderungen nicht.",
                React.createElement("br", null),
                React.createElement("b", null, "Eine Korrektur des SEPs ist daher nicht m\u00F6glich!")));
        }
        /*
          Beurteilung der einzelnen Neigungen
    
          Alle Neigungen müssen im Bereich ±1,5% liegen
        */
        var maxNeigung = 1.5;
        neigungenio = ((Math.abs(this.props.neigungenFZ.laengs) <= maxNeigung) && (Math.abs(this.props.neigungenFZ.quer) <= maxNeigung)
            &&
                (Math.abs(this.props.neigungenSEP.laengs) <= maxNeigung) && (Math.abs(this.props.neigungenSEP.quer) <= maxNeigung));
        if (flaecheio && !neigungenio) {
            beurteilungStyle = 'danger';
            beurteilungText = (React.createElement("span", null,
                "Aufgrund der zu gro\u00DFen Neigungen (au\u00DFerhalb von \u00B11,5%) erf\u00FCllt diese Fl\u00E4che die Anforderungen nicht.",
                React.createElement("br", null),
                React.createElement("b", null, "Eine Korrektur des SEPs ist daher nicht m\u00F6glich!")));
        }
        /*
          Beurteilung der Toleranzen (Ebenheitsabweichungen und Unebenheiten) der beiden Flächen
        */
        var fehlerFz = this.props.beurteilungFZ.beurteilung.some(function (beurteilung) { return !beurteilung.links.eingehalten || !beurteilung.rechts.eingehalten; });
        var fehlerSep = this.props.beurteilungSEP.beurteilung.some(function (beurteilung) { return !beurteilung.links.eingehalten || !beurteilung.rechts.eingehalten; });
        toleranzenio = (!fehlerFz && !fehlerSep);
        if (!toleranzenio) {
            beurteilungStyle = 'danger';
            beurteilungText = (React.createElement("span", null,
                "Nicht alle Werte der Aufstellfl\u00E4chen liegen innerhalb der vorgeschriebenen Toleranzen, die Fl\u00E4che erf\u00FCllt die Anforderungen nicht.",
                React.createElement("br", null),
                React.createElement("b", null, "Eine Korrektur des SEPs ist daher nicht m\u00F6glich!")));
        }
        beurteilungio = flaecheio && neigungenio && toleranzenio;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Systemneigung", bsStyle: beurteilungStyle },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: true, condensed: false, hover: false, className: "auswertung-systemneigung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { width: "20%" }),
                        React.createElement("th", { width: "40%" }, "Fahrzeug"),
                        React.createElement("th", { width: "40%" }, "SEP"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "L\u00E4ngs"),
                        React.createElement("td", { className: (laengsneigungSEPio && Math.abs(this.props.neigungenFZ.laengs) <= maxNeigung) ? 'value-success' : 'value-error' },
                            this.props.neigungenFZ.laengs.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                            "%"),
                        React.createElement("td", { className: (querneigungSEPio && Math.abs(this.props.neigungenSEP.laengs) <= maxNeigung) ? 'value-success' : 'value-error' },
                            this.props.neigungenSEP.laengs.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                            "%")),
                    React.createElement("tr", null,
                        React.createElement("th", null, "Quer"),
                        React.createElement("td", { className: (querneigungSEPio && Math.abs(this.props.neigungenFZ.quer) <= maxNeigung) ? 'value-success' : 'value-error' },
                            this.props.neigungenFZ.quer.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                            "%"),
                        React.createElement("td", { className: (laengsneigungSEPio && Math.abs(this.props.neigungenSEP.quer) <= maxNeigung) ? 'value-success' : 'value-error' },
                            this.props.neigungenSEP.quer.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                            "%")))),
            React.createElement(Callout_1.default, { bsStyle: beurteilungStyle },
                beurteilungText,
                (beurteilungio) && (React.createElement("div", null, "Einzustellen an der Laser-Kalibriervorrichtung")))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungSystemneigung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], SesAuswertungSystemneigung.prototype, "uiStore", void 0);
    return SesAuswertungSystemneigung;
}(React.Component));
exports.default = SesAuswertungSystemneigung;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Singleton für globale Eigenschaften zur AGT 4-Gas Tester Kalibrierung
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var KalibrierungStore_1 = __webpack_require__(173);
var Agt4GasKalibrierungStore = (function (_super) {
    __extends(Agt4GasKalibrierungStore, _super);
    function Agt4GasKalibrierungStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messunsicherheitAnwenden = false;
        _this.objektVorlage = undefined;
        _this.justage = false;
        _this.genauigkeitsklasseUeberschreiben = false;
        return _this;
    }
    Agt4GasKalibrierungStore_1 = Agt4GasKalibrierungStore;
    Agt4GasKalibrierungStore.prototype.setMessunsicherheitAnwenden = function (value) {
        this.messunsicherheitAnwenden = value;
    };
    Agt4GasKalibrierungStore.prototype.setObjektVorlage = function (value) {
        this.objektVorlage = value;
    };
    Agt4GasKalibrierungStore.prototype.setJustage = function (value) {
        this.justage = value;
    };
    Agt4GasKalibrierungStore.prototype.setGenauigkeitsklasseUeberschreiben = function (value) {
        this.genauigkeitsklasseUeberschreiben = value;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasKalibrierungStore.prototype, "messunsicherheitAnwenden", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasKalibrierungStore.prototype, "objektVorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasKalibrierungStore.prototype, "justage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasKalibrierungStore.prototype, "genauigkeitsklasseUeberschreiben", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierungStore.prototype, "setMessunsicherheitAnwenden", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierungStore.prototype, "setObjektVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierungStore.prototype, "setJustage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierungStore.prototype, "setGenauigkeitsklasseUeberschreiben", null);
    Agt4GasKalibrierungStore = Agt4GasKalibrierungStore_1 = __decorate([
        decorators_1.provideSingleton(Agt4GasKalibrierungStore_1)
    ], Agt4GasKalibrierungStore);
    return Agt4GasKalibrierungStore;
    var Agt4GasKalibrierungStore_1;
}(KalibrierungStore_1.KalibrierungStore));
exports.Agt4GasKalibrierungStore = Agt4GasKalibrierungStore;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var decorators_1 = __webpack_require__(1);
var mobx_1 = __webpack_require__(3);
var AuftragStore_1 = __webpack_require__(25);
var VorgangStore_1 = __webpack_require__(22);
/**
 * Singleton Basisklasse für globale Eigenschaften zu einem Kalibrierverfahren
 */
var KalibrierungStore = (function () {
    function KalibrierungStore() {
        this.readOnly = false;
    }
    KalibrierungStore_1 = KalibrierungStore;
    KalibrierungStore.prototype.setReadOnly = function (value) {
        this.readOnly = value;
    };
    /**
     * Gibt den zu verwendenden Kalibriergegenstand (Objekt) zurück
     * Entweder aus dem Vorgang oder dem Auftrag, Objekte im Vorgang haben Priorität
     */
    KalibrierungStore.prototype.getKalibrierGegenstand = function () {
        var vorgang = this.vorgangStore.vorgang;
        var auftrag = this.auftragStore.auftrag;
        if (vorgang && vorgang.objekte && vorgang.objekte.length > 0) {
            return vorgang.objekte[0];
        }
        if (auftrag && auftrag.objekte && auftrag.objekte.length > 0) {
            return auftrag.objekte[0];
        }
        return undefined;
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], KalibrierungStore.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], KalibrierungStore.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], KalibrierungStore.prototype, "readOnly", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], KalibrierungStore.prototype, "setReadOnly", null);
    KalibrierungStore = KalibrierungStore_1 = __decorate([
        decorators_1.provideSingleton(KalibrierungStore_1)
    ], KalibrierungStore);
    return KalibrierungStore;
    var KalibrierungStore_1;
}());
exports.KalibrierungStore = KalibrierungStore;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(296), __esModule: true };

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(298), __esModule: true };

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76)
  , document = __webpack_require__(47).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(64) && !__webpack_require__(75)(function(){
  return Object.defineProperty(__webpack_require__(177)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(115);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(119)
  , $export        = __webpack_require__(46)
  , redefine       = __webpack_require__(185)
  , hide           = __webpack_require__(65)
  , has            = __webpack_require__(57)
  , Iterators      = __webpack_require__(77)
  , $iterCreate    = __webpack_require__(313)
  , setToStringTag = __webpack_require__(122)
  , getPrototypeOf = __webpack_require__(321)
  , ITERATOR       = __webpack_require__(40)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(78)
  , createDesc     = __webpack_require__(79)
  , toIObject      = __webpack_require__(48)
  , toPrimitive    = __webpack_require__(127)
  , has            = __webpack_require__(57)
  , IE8_DOM_DEFINE = __webpack_require__(178)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(64) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(183)
  , hiddenKeys = __webpack_require__(118).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(57)
  , toIObject    = __webpack_require__(48)
  , arrayIndexOf = __webpack_require__(305)(false)
  , IE_PROTO     = __webpack_require__(123)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(66)
  , toIObject = __webpack_require__(48)
  , isEnum    = __webpack_require__(78).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(65);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(125)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(323)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(180)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(67);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(68);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(92);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(67);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(92);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(352);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(34);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(59);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(132);

var _PathUtils = __webpack_require__(80);

var _createTransitionManager = __webpack_require__(133);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var provide_1 = __webpack_require__(378);
function makeProvideDecorator(container) {
    return provide_1.default(container);
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = makeProvideDecorator;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inversify_1 = __webpack_require__(95);
var ProvideDoneSyntax = (function () {
    function ProvideDoneSyntax(binding) {
        this._binding = binding;
    }
    ProvideDoneSyntax.prototype.done = function () {
        var _this = this;
        return function (target) {
            inversify_1.decorate(inversify_1.injectable(), target);
            _this._binding.implementationType = target;
            return target;
        };
    };
    return ProvideDoneSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProvideDoneSyntax;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(27);
var MetadataReader = (function () {
    function MetadataReader() {
    }
    MetadataReader.prototype.getConstructorMetadata = function (constructorFunc) {
        var compilerGeneratedMetadata = Reflect.getMetadata(METADATA_KEY.PARAM_TYPES, constructorFunc);
        var userGeneratedMetadata = Reflect.getMetadata(METADATA_KEY.TAGGED, constructorFunc);
        return {
            compilerGeneratedMetadata: compilerGeneratedMetadata,
            userGeneratedMetadata: userGeneratedMetadata || {}
        };
    };
    MetadataReader.prototype.getPropertiesMetadata = function (constructorFunc) {
        var userGeneratedMetadata = Reflect.getMetadata(METADATA_KEY.TAGGED_PROP, constructorFunc) || [];
        return userGeneratedMetadata;
    };
    return MetadataReader;
}());
exports.MetadataReader = MetadataReader;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var queryable_string_1 = __webpack_require__(405);
var guid_1 = __webpack_require__(60);
var METADATA_KEY = __webpack_require__(27);
var Target = (function () {
    function Target(type, name, serviceIdentifier, namedOrTagged) {
        this.guid = guid_1.guid();
        this.type = type;
        this.serviceIdentifier = serviceIdentifier;
        this.name = new queryable_string_1.QueryableString(name || "");
        this.metadata = new Array();
        var metadataItem = null;
        if (typeof namedOrTagged === "string") {
            metadataItem = new metadata_1.Metadata(METADATA_KEY.NAMED_TAG, namedOrTagged);
        }
        else if (namedOrTagged instanceof metadata_1.Metadata) {
            metadataItem = namedOrTagged;
        }
        if (metadataItem !== null) {
            this.metadata.push(metadataItem);
        }
    }
    Target.prototype.hasTag = function (key) {
        for (var i = 0; i < this.metadata.length; i++) {
            var m = this.metadata[i];
            if (m.key === key) {
                return true;
            }
        }
        return false;
    };
    Target.prototype.isArray = function () {
        return this.hasTag(METADATA_KEY.MULTI_INJECT_TAG);
    };
    Target.prototype.matchesArray = function (name) {
        return this.matchesTag(METADATA_KEY.MULTI_INJECT_TAG)(name);
    };
    Target.prototype.isNamed = function () {
        return this.hasTag(METADATA_KEY.NAMED_TAG);
    };
    Target.prototype.isTagged = function () {
        return this.metadata.some(function (m) {
            return (m.key !== METADATA_KEY.INJECT_TAG) &&
                (m.key !== METADATA_KEY.MULTI_INJECT_TAG) &&
                (m.key !== METADATA_KEY.NAME_TAG) &&
                (m.key !== METADATA_KEY.UNMANAGED_TAG) &&
                (m.key !== METADATA_KEY.NAMED_TAG);
        });
    };
    Target.prototype.isOptional = function () {
        return this.matchesTag(METADATA_KEY.OPTIONAL_TAG)(true);
    };
    Target.prototype.getNamedTag = function () {
        if (this.isNamed()) {
            return this.metadata.filter(function (m) { return m.key === METADATA_KEY.NAMED_TAG; })[0];
        }
        return null;
    };
    Target.prototype.getCustomTags = function () {
        if (this.isTagged()) {
            return this.metadata.filter(function (m) {
                return (m.key !== METADATA_KEY.INJECT_TAG) &&
                    (m.key !== METADATA_KEY.MULTI_INJECT_TAG) &&
                    (m.key !== METADATA_KEY.NAME_TAG) &&
                    (m.key !== METADATA_KEY.UNMANAGED_TAG) &&
                    (m.key !== METADATA_KEY.NAMED_TAG);
            });
        }
        return null;
    };
    Target.prototype.matchesNamedTag = function (name) {
        return this.matchesTag(METADATA_KEY.NAMED_TAG)(name);
    };
    Target.prototype.matchesTag = function (key) {
        var _this = this;
        return function (value) {
            for (var i = 0; i < _this.metadata.length; i++) {
                var m = _this.metadata[i];
                if (m.key === key && m.value === value) {
                    return true;
                }
            }
            return false;
        };
    };
    return Target;
}());
exports.Target = Target;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_when_syntax_1 = __webpack_require__(137);
var binding_on_syntax_1 = __webpack_require__(136);
var BindingWhenOnSyntax = (function () {
    function BindingWhenOnSyntax(binding) {
        this._binding = binding;
        this._bindingWhenSyntax = new binding_when_syntax_1.BindingWhenSyntax(this._binding);
        this._bindingOnSyntax = new binding_on_syntax_1.BindingOnSyntax(this._binding);
    }
    BindingWhenOnSyntax.prototype.when = function (constraint) {
        return this._bindingWhenSyntax.when(constraint);
    };
    BindingWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._bindingWhenSyntax.whenTargetNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenTargetIsDefault = function () {
        return this._bindingWhenSyntax.whenTargetIsDefault();
    };
    BindingWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenTargetTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._bindingWhenSyntax.whenInjectedInto(parent);
    };
    BindingWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._bindingWhenSyntax.whenParentNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenParentTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenAnyAncestorNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenNoAncestorNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
    };
    BindingWhenOnSyntax.prototype.onActivation = function (handler) {
        return this._bindingOnSyntax.onActivation(handler);
    };
    return BindingWhenOnSyntax;
}());
exports.BindingWhenOnSyntax = BindingWhenOnSyntax;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var METADATA_KEY = __webpack_require__(27);
var traverseAncerstors = function (request, constraint) {
    var parent = request.parentRequest;
    if (parent !== null) {
        return constraint(parent) ? true : traverseAncerstors(parent, constraint);
    }
    else {
        return false;
    }
};
exports.traverseAncerstors = traverseAncerstors;
var taggedConstraint = function (key) { return function (value) {
    var constraint = function (request) {
        return request !== null && request.target !== null && request.target.matchesTag(key)(value);
    };
    constraint.metaData = new metadata_1.Metadata(key, value);
    return constraint;
}; };
exports.taggedConstraint = taggedConstraint;
var namedConstraint = taggedConstraint(METADATA_KEY.NAMED_TAG);
exports.namedConstraint = namedConstraint;
var typeConstraint = function (type) { return function (request) {
    var binding = null;
    if (request !== null) {
        binding = request.bindings[0];
        if (typeof type === "string") {
            var serviceIdentifier = binding.serviceIdentifier;
            return serviceIdentifier === type;
        }
        else {
            var constructor = request.bindings[0].implementationType;
            return type === constructor;
        }
    }
    return false;
}; };
exports.typeConstraint = typeConstraint;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(419);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);











var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  active: false
};

var BreadcrumbItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }) },
      active ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', props) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);













var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps)] = !vertical, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'vertical')] = vertical, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'justified')] = justified, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('btn-group', ButtonGroup));

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__ = __webpack_require__(480);












// TODO: This should use a timeout instead of TransitionEvents, or else just
// not wait until transition end to trigger continuing animations.

var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__["a" /* default */].addEndEventListener(__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"].isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"]
};

var CloseButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloseButton, _React$Component);

  function CloseButton() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloseButton);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'button',
      {
        type: 'button',
        className: 'close',
        onClick: onClick
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CloseButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);













var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        role: 'button',
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

  function Grid() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, fluid && 'fluid');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('container', Grid));

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(29);













var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  listItem: false
};

var ListGroupItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListGroupItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'heading')),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'text') },
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('list-group-item', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsStyles"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), ListGroupItem)));

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalBody, _React$Component);

  function ModalBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-body', ModalBody));

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalFooter, _React$Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-footer', ModalFooter));

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(211);













// TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var ModalHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      closeButton && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
        label: closeLabel,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-header', ModalHeader));

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalTitle, _React$Component);

  function ModalTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-title', ModalTitle));

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_prop_types_lib_all__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_prop_types_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_prop_types_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(32);

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  justified: __WEBPACK_IMPORTED_MODULE_10_react_prop_types_lib_all___default()(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }),

  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
  })
};

var Nav = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'stacked')] = stacked, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(navbarProps, 'nav')] = true;

      pullRightClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(navbarProps, 'right');
      pullLeftClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: role,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('nav', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsStyles"])(['tabs', 'pills'], Nav)));

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(28);












var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavItem, _React$Component);

  function NavItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarBrand = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarBrand);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(97);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_9_react_prop_types_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['animation', 'children']);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : animation || null;

    var child = void 0;

    if (!transition) {
      child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        transition: transition
      }),
      child
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(28);












var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PagerItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (onSelect || disabled) {
      e.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(28);













// TODO: This should be `<Pagination.Item>`.

// TODO: This should use `componentClass` like other components.

var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */],
  active: false,
  disabled: false
};

var PaginationButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PaginationButton, _React$Component);

  function PaginationButton(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PaginationButton);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  PaginationButton.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  PaginationButton.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        active = _props2.active,
        disabled = _props2.disabled,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);

    if (Component === __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */]) {
      // Assume that custom components want `eventKey`.
      delete props.eventKey;
    }

    delete props.onSelect;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return PaginationButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PaginationButton);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(32);














var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  accordion: false
};

// TODO: Use uncontrollable.

var PanelGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PanelGroup, _React$Component);

  function PanelGroup(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PanelGroup);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);

    _this.state = {
      activeKey: props.defaultActiveKey
    };
    return _this;
  }

  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
    e.preventDefault();

    if (this.props.onSelect) {
      this.props.onSelect(key, e);
    }

    if (this.state.activeKey === key) {
      key = null;
    }

    this.setState({ activeKey: key });
  };

  PanelGroup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        accordion = _props.accordion,
        propsActiveKey = _props.activeKey,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['accordion', 'activeKey', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['defaultActiveKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeKey = void 0;
    if (accordion) {
      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var childProps = {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        };

        if (accordion) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(childProps, {
            headerRole: 'tab',
            panelRole: 'tabpanel',
            collapsible: true,
            expanded: child.props.eventKey === activeKey,
            onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(_this2.handleSelect, child.props.onSelect)
          });
        }

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, childProps);
      })
    );
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('panel-group', PanelGroup));

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fade__ = __webpack_require__(97);
















var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or any `<Transition>`
   * component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a]),

  /** @private **/
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /** @private **/
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
};

var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this['in'] = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this['in']) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this['in']) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this['in'] = false;
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_12__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(tabContent, 'pane');
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('tab-pane', TabPane));

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(61);

var invariant = __webpack_require__(15);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(70);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactInstrumentation = __webpack_require__(38);

var quoteAttributeValueForBrowser = __webpack_require__(544);
var warning = __webpack_require__(17);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var LinkedValueUtils = __webpack_require__(150);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactUpdates = __webpack_require__(42);

var warning = __webpack_require__(17);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(504);

var containsNode = __webpack_require__(363);
var focusNode = __webpack_require__(196);
var getActiveElement = __webpack_require__(197);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var DOMLazyTree = __webpack_require__(69);
var DOMProperty = __webpack_require__(70);
var React = __webpack_require__(72);
var ReactBrowserEventEmitter = __webpack_require__(99);
var ReactCurrentOwner = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactDOMContainerInfo = __webpack_require__(498);
var ReactDOMFeatureFlags = __webpack_require__(500);
var ReactFeatureFlags = __webpack_require__(234);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(38);
var ReactMarkupChecksum = __webpack_require__(514);
var ReactReconciler = __webpack_require__(71);
var ReactUpdateQueue = __webpack_require__(153);
var ReactUpdates = __webpack_require__(42);

var emptyObject = __webpack_require__(94);
var instantiateReactComponent = __webpack_require__(245);
var invariant = __webpack_require__(15);
var setInnerHTML = __webpack_require__(103);
var shouldUpdateReactComponent = __webpack_require__(159);
var warning = __webpack_require__(17);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var React = __webpack_require__(72);

var invariant = __webpack_require__(15);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(238);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(24);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var ReactCompositeComponent = __webpack_require__(495);
var ReactEmptyComponent = __webpack_require__(233);
var ReactHostComponent = __webpack_require__(235);

var getNextDebugID = __webpack_require__(583);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);
var escapeTextContentForBrowser = __webpack_require__(102);
var setInnerHTML = __webpack_require__(103);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var ReactCurrentOwner = __webpack_require__(44);
var REACT_ELEMENT_TYPE = __webpack_require__(510);

var getIteratorFn = __webpack_require__(541);
var invariant = __webpack_require__(15);
var KeyEscapeUtils = __webpack_require__(149);
var warning = __webpack_require__(17);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _componentOrElement = __webpack_require__(162);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _ownerDocument = __webpack_require__(87);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _getContainer = __webpack_require__(161);

var _getContainer2 = _interopRequireDefault(_getContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {

      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();
        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget);
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _this.getOverlayDOMNode = function () {
      if (!_this._isMounted) {
        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
      }

      if (_this._overlayInstance) {
        return _reactDom2.default.findDOMNode(_this._overlayInstance);
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this._renderOverlay();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._renderOverlay();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this._overlayTarget && nextProps.container !== this.props.container) {
        this._portalContainerNode.removeChild(this._overlayTarget);
        this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
        this._portalContainerNode.appendChild(this._overlayTarget);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this._unrenderOverlay();
      this._unmountOverlayTarget();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func])
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contains = __webpack_require__(68);

var _contains2 = _interopRequireDefault(_contains);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(252);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(87);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  _createClass(RootCloseWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.disabled) {
        this.addEventListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.disabled && prevProps.disabled) {
        this.addEventListeners();
      } else if (this.props.disabled && !prevProps.disabled) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.disabled) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _on = __webpack_require__(91);

var _on2 = _interopRequireDefault(_on);

var _properties = __webpack_require__(192);

var _properties2 = _interopRequireDefault(_properties);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2.default.end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * The Transition component lets you define and run css transitions with a simple declarative api.
 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
 * The extensive set of lifecycle callbacks means you have control over
 * the transitioning now at each step of the way.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));

    _this.updateStatus = function () {
      if (_this.nextStatus !== null) {
        (function () {
          // nextStatus will always be ENTERING or EXITING.
          _this.cancelNextCallback();
          var node = _reactDom2.default.findDOMNode(_this);

          if (_this.nextStatus === ENTERING) {
            _this.props.onEnter(node);

            _this.safeSetState({ status: ENTERING }, function () {
              _this.props.onEntering(node);

              _this.onTransitionEnd(node, function () {
                _this.safeSetState({ status: ENTERED }, function () {
                  _this.props.onEntered(node);
                });
              });
            });
          } else {
            _this.props.onExit(node);

            _this.safeSetState({ status: EXITING }, function () {
              _this.props.onExiting(node);

              _this.onTransitionEnd(node, function () {
                _this.safeSetState({ status: EXITED }, function () {
                  _this.props.onExited(node);
                });
              });
            });
          }

          _this.nextStatus = null;
        })();
      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
        _this.setState({ status: UNMOUNTED });
      }
    };

    _this.cancelNextCallback = function () {
      if (_this.nextCallback !== null) {
        _this.nextCallback.cancel();
        _this.nextCallback = null;
      }
    };

    _this.safeSetState = function (nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      _this.setState(nextState, _this.setNextCallback(callback));
    };

    _this.setNextCallback = function (callback) {
      var active = true;

      _this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this.nextCallback = null;

          callback(event);
        }
      };

      _this.nextCallback.cancel = function () {
        active = false;
      };

      return _this.nextCallback;
    };

    _this.onTransitionEnd = function (node, handler) {
      _this.setNextCallback(handler);

      if (node) {
        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
        setTimeout(_this.nextCallback, _this.props.timeout);
      } else {
        setTimeout(_this.nextCallback, 0);
      }
    };

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (props.transitionAppear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  _createClass(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateStatus();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var status = this.state.status;


      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateStatus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelNextCallback();
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;

      var childProps = _objectWithoutProperties(_props, ['children', 'className']);

      Object.keys(Transition.propTypes).forEach(function (key) {
        return delete childProps[key];
      });

      var transitionClassName = void 0;
      if (status === EXITED) {
        transitionClassName = this.props.exitedClassName;
      } else if (status === ENTERING) {
        transitionClassName = this.props.enteringClassName;
      } else if (status === ENTERED) {
        transitionClassName = this.props.enteredClassName;
      } else if (status === EXITING) {
        transitionClassName = this.props.exitingClassName;
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, _extends({}, childProps, {
        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
      }));
    }
  }]);

  return Transition;
}(_react2.default.Component);

Transition.propTypes = {
  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _propTypes2.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes2.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _propTypes2.default.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _propTypes2.default.bool,

  /**
   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
   * transition indefinately if the browser transitionEnd events are
   * canceled or interrupted.
   *
   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
   * setting this to the duration of your animation (or a bit above it).
   */
  timeout: _propTypes2.default.number,

  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied when the component is entered
   */
  enteredClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _propTypes2.default.string,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _propTypes2.default.func,
  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _propTypes2.default.func
};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.displayName = 'Transition';

Transition.defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,

  timeout: 5000,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

exports.default = Transition;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(91);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(130);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isOverflowing;

var _isWindow = __webpack_require__(92);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(67);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact;
    var route = _ref2.route;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    var pathname = (location || route.location).pathname;

    return path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        component = _props.component,
        render = _props.render,
        children = _props.children;


    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component,
        render = _props2.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(289);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(88),
    _assign = __webpack_require__(23);

var ReactNoopUpdateQueue = __webpack_require__(260);

var canDefineProperty = __webpack_require__(261);
var emptyObject = __webpack_require__(94);
var invariant = __webpack_require__(15);
var lowPriorityWarning = __webpack_require__(584);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(88);

var ReactCurrentOwner = __webpack_require__(44);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(17);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var ArbeitsmittelListe_1 = __webpack_require__(263);
var Callout_1 = __webpack_require__(16);
var FilterBox_1 = __webpack_require__(89);
/** Zeigt ein einzelnes Arbeitsmittelset mit einen Arbeitsmitel und optionaler Statusinformationen an */
var ArbeitsmittelSet = (function (_super) {
    __extends(ArbeitsmittelSet, _super);
    function ArbeitsmittelSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArbeitsmittelSet.prototype.render = function () {
        var _this = this;
        var _a = this.props, arbeitsmittelSet = _a.arbeitsmittelSet, onArbeitsmittelSetAuswahl = _a.onArbeitsmittelSetAuswahl;
        var inaktiv = arbeitsmittelSet.status.toLowerCase() === 'inaktiv';
        var amAbgelaufen = arbeitsmittelSet.arbeitsmittel.some(function (element) { return element.gueltigtage !== undefined && element.gueltigtage < 0; });
        var amAktiv = arbeitsmittelSet.arbeitsmittel.every(function (element) { return (element.amstatus.toLowerCase() === 'aktiv' || element.amstatus.toLowerCase() === 'qualifi'); });
        var selectable = amAktiv && !amAbgelaufen;
        var anzahlInQuali = arbeitsmittelSet.arbeitsmittel.filter(function (e) { return e.amstatus.toLowerCase() === 'qualifi'; }).length;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { collapsible: true, defaultExpanded: true, bsStyle: selectable ? 'success' : 'danger', header: arbeitsmittelSet.name + " (" + arbeitsmittelSet.lizenznehmer + ")", footer: onArbeitsmittelSetAuswahl ? (React.createElement("div", { className: "text-right" }, selectable && !inaktiv && React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: function () { return onArbeitsmittelSetAuswahl(arbeitsmittelSet); } }, "Ausw\u00E4hlen"))) : null },
                React.createElement(react_bootstrap_1.ListGroup, { fill: true }, arbeitsmittelSet.arbeitsmittel.map(function (arbeitsmittel, index) { return (React.createElement(ArbeitsmittelListe_1.ArbeitsmittelItem, { key: index, arbeitsmittel: arbeitsmittel, detailansicht: _this.props.uebersicht ? _this.props.uebersicht : false })); })),
                inaktiv && React.createElement(Callout_1.default, { bsStyle: "danger" }, "Dieses Set wurde nicht freigegeben."),
                !inaktiv && !selectable &&
                    React.createElement(Callout_1.default, { bsStyle: "danger" }, "Set kann nicht verwendet werden, nicht alle Arbeitsmittel sind freigegeben oder g\u00FCltig."),
                onArbeitsmittelSetAuswahl && !inaktiv && (anzahlInQuali > 0) &&
                    React.createElement(Callout_1.default, { bsStyle: "default" }, "In Qualifizierung befindliche Messmittel werden nicht in den Vorgang \u00FCbernommen."))));
    };
    return ArbeitsmittelSet;
}(React.Component));
/** Kapselt das Filtern der Arbeitsmittelliste  */
var ListFilter = (function () {
    function ListFilter() {
    }
    ListFilter.prototype.set = function (sets) {
        this.sets = sets;
    };
    Object.defineProperty(ListFilter.prototype, "filtered", {
        get: function () {
            var _this = this;
            if (this.filter) {
                return this.sets ? this.sets.filter(function (el) { return el.name.toLocaleLowerCase().includes(_this.filter); }) : [];
            }
            else {
                return this.sets;
            }
        },
        enumerable: true,
        configurable: true
    });
    ListFilter.prototype.setFilter = function (filter) {
        this.filter = filter.toLocaleLowerCase();
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ListFilter.prototype, "filter", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ListFilter.prototype, "sets", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ListFilter.prototype, "set", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ListFilter.prototype, "filtered", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ListFilter.prototype, "setFilter", null);
    return ListFilter;
}());
/** Zeigt die Liste der dem angemeldeten Nutzer freigeschalteten Arbeitsmittelsets an */
var ArbeitsmittelAuswahl = (function (_super) {
    __extends(ArbeitsmittelAuswahl, _super);
    function ArbeitsmittelAuswahl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.arbeitsmittelSets = new ListFilter();
        return _this;
    }
    ArbeitsmittelAuswahl.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.orte(this.props.kategorie ? this.props.kategorie : '')];
                    case 1:
                        sets = _a.sent();
                        if (sets.ok) {
                            this.arbeitsmittelSets.set(sets.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ArbeitsmittelAuswahl.prototype.handleFilterList = function (event) {
        var filterText = event.target.value;
        this.arbeitsmittelSets.setFilter(filterText);
    };
    ArbeitsmittelAuswahl.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h2", null, this.props.title ? this.props.title : 'Arbeitsmittel-Sets'),
            React.createElement(FilterBox_1.default, { onChange: this.handleFilterList }),
            !this.arbeitsmittelSets.filtered ? (React.createElement("div", null, "lade Arbeitsmittelsets...")) : (this.arbeitsmittelSets.filtered.length === 0) ? (React.createElement("div", null, "Keine Arbeitsmittelsets f\u00FCr dieses Verfahren vorhanden")) : this.arbeitsmittelSets.filtered.map(function (arbeitsmittelSet, index) { return (React.createElement(ArbeitsmittelSet, { key: index, arbeitsmittelSet: arbeitsmittelSet, uebersicht: _this.props.uebersicht, onArbeitsmittelSetAuswahl: _this.props.onArbeitsmittelSetAuswahl })); }),
            React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ArbeitsmittelAuswahl.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ArbeitsmittelAuswahl.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ArbeitsmittelAuswahl.prototype, "handleFilterList", null);
    ArbeitsmittelAuswahl = __decorate([
        mobx_react_1.observer
    ], ArbeitsmittelAuswahl);
    return ArbeitsmittelAuswahl;
}(React.Component));
exports.default = ArbeitsmittelAuswahl;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var FaIcon_1 = __webpack_require__(20);
var Callout_1 = __webpack_require__(16);
var ArbeitsmittelListe = (function (_super) {
    __extends(ArbeitsmittelListe, _super);
    function ArbeitsmittelListe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.arbeitsmittel = mobx_1.observable([]);
        return _this;
    }
    ArbeitsmittelListe.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, arbeitsmittel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangArbeitsmittel(vorgangId)];
                    case 1:
                        arbeitsmittel = _a.sent();
                        if (arbeitsmittel.ok) {
                            this.setArbeitsmittel(arbeitsmittel.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ArbeitsmittelListe.prototype.setArbeitsmittel = function (arbeitsmittel) {
        var _this = this;
        this.arbeitsmittel.clear();
        arbeitsmittel.forEach(function (item) {
            _this.arbeitsmittel.push(item);
        });
    };
    ArbeitsmittelListe.prototype.handleArbeitsmittelEntfernen = function (arbeitsmittel) {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangArbeitsmittelEntfernen(vorgangId, arbeitsmittel.arbeitsmittelguid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.success) {
                            this.removeItem(arbeitsmittel);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ArbeitsmittelListe.prototype.removeItem = function (arbeitsmittel) {
        this.arbeitsmittel.remove(arbeitsmittel);
    };
    ArbeitsmittelListe.prototype.render = function () {
        var _this = this;
        var isLoading = this.apiStore.isLoading;
        var editable = this.props.editable;
        return (React.createElement(react_bootstrap_1.Panel, { header: this.arbeitsmittel.length > 0 ? "Arbeitsmittel (" + this.arbeitsmittel.length + " gew\u00E4hlt)" : 'Arbeitsmittel', bsStyle: this.arbeitsmittel.length > 0 ? 'success' : 'danger', collapsible: true, defaultExpanded: true, footer: editable && (React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo('arbeitsmittel'); } }, "Ausw\u00E4hlen"))) },
            React.createElement(react_bootstrap_1.ListGroup, { fill: true }, (this.arbeitsmittel.length === 0) ? (React.createElement(react_bootstrap_1.ListGroupItem, null, isLoading ? 'lade Arbeitsmittel...' : 'Keine Arbeitsmittel ausgewählt')) : this.arbeitsmittel.map(function (arbeitsmittel, index) { return (React.createElement(ArbeitsmittelItem, { key: index, editable: editable, arbeitsmittel: arbeitsmittel, onArbeitsmittelEntfernen: _this.handleArbeitsmittelEntfernen })); }))));
    };
    ArbeitsmittelListe.defaultProps = {
        editable: true
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ArbeitsmittelListe.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ArbeitsmittelListe.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ArbeitsmittelListe.prototype, "setArbeitsmittel", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ArbeitsmittelListe.prototype, "handleArbeitsmittelEntfernen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ArbeitsmittelListe.prototype, "removeItem", null);
    ArbeitsmittelListe = __decorate([
        mobx_react_1.observer
    ], ArbeitsmittelListe);
    return ArbeitsmittelListe;
}(React.Component));
exports.default = ArbeitsmittelListe;
var ArbeitsmittelItem = (function (_super) {
    __extends(ArbeitsmittelItem, _super);
    function ArbeitsmittelItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArbeitsmittelItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, arbeitsmittel = _a.arbeitsmittel, onArbeitsmittelEntfernen = _a.onArbeitsmittelEntfernen, editable = _a.editable, detailansicht = _a.detailansicht;
        var statusText = arbeitsmittel.amstatus;
        var className;
        switch (arbeitsmittel.amstatus.toLowerCase()) {
            case 'aktiv':
                className = 'text-success';
                break;
            case 'qualifi':
                className = 'text-warning';
                statusText = 'In Qualifizierung';
                break;
            case 'gesperrt':
                className = 'text-danger';
                break;
            default:
                className = 'text-muted';
                break;
        }
        if (!detailansicht) {
            if (arbeitsmittel.gueltigtage && arbeitsmittel.gueltigtage < 0) {
                className = 'text-danger';
                statusText = 'Abgelaufen';
            }
        }
        var hinweis = React.createElement("div", null);
        if (arbeitsmittel.gueltigtage) {
            if (arbeitsmittel.gueltigtage <= 0) {
                hinweis = React.createElement(Callout_1.default, { bsStyle: "danger" },
                    "Seit ",
                    Math.abs(arbeitsmittel.gueltigtage),
                    " Tagen abgelaufen, bitte wenden Sie sich an die DIQ Zert GmbH.");
            }
            else {
                if (arbeitsmittel.gueltigtage < 90) {
                    hinweis = React.createElement(Callout_1.default, { bsStyle: "warning" },
                        "L\u00E4uft in ",
                        Math.abs(arbeitsmittel.gueltigtage),
                        " Tagen ab, bitte wenden Sie sich an die DIQ Zert GmbH.");
                }
            }
        }
        return (React.createElement(react_bootstrap_1.ListGroupItem, null,
            !detailansicht && (React.createElement("span", null,
                arbeitsmittel.arbeitsmittelnr,
                " - ",
                arbeitsmittel.name,
                " (",
                React.createElement("span", { className: className }, statusText),
                ")")),
            detailansicht && (React.createElement("span", null,
                React.createElement("b", null,
                    arbeitsmittel.arbeitsmittelnr,
                    " - ",
                    arbeitsmittel.name),
                React.createElement("span", { className: "pull-right" },
                    React.createElement(react_bootstrap_1.Button, { className: "btn-flat", title: "Rückmeldung zu diesem Arbeitsmittel verfassen", onClick: function () { return _this.uiStore.navigateTo("/arbeitsmittel/" + arbeitsmittel.arbeitsmittelguid + "/feedback"); } },
                        React.createElement(FaIcon_1.default, { icon: "envelope-o" }))),
                React.createElement("div", { className: "text-muted" },
                    React.createElement("span", { className: className }, arbeitsmittel.amstatus),
                    ", ",
                    arbeitsmittel.giltbis ? 'gültig bis: ' + arbeitsmittel.giltbis : 'unbefristet',
                    React.createElement("br", null),
                    hinweis))),
            onArbeitsmittelEntfernen && editable && (React.createElement(react_bootstrap_1.Button, { className: "btn-flat pull-right", onClick: function () { return onArbeitsmittelEntfernen(arbeitsmittel); }, title: "Arbeitsmittel entfernen" },
                React.createElement(FaIcon_1.default, { icon: "trash-o" })))));
    };
    ArbeitsmittelItem.defaultProps = {
        editable: true
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ArbeitsmittelItem.prototype, "uiStore", void 0);
    return ArbeitsmittelItem;
}(React.Component));
exports.ArbeitsmittelItem = ArbeitsmittelItem;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var Pager_1 = __webpack_require__(167);
var FilterBox_1 = __webpack_require__(89);
var PagedList_1 = __webpack_require__(166);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
var UiStore_1 = __webpack_require__(14);
/** Einzelnes Listenelement mit Auftragsinformationen */
var AuftragListItem = (function (_super) {
    __extends(AuftragListItem, _super);
    function AuftragListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragListItem.prototype.render = function () {
        var _this = this;
        var status = this.props.auftrag.auftragstatus.toLowerCase();
        return (React.createElement(react_bootstrap_1.ListGroupItem, { header: this.props.auftrag.auftrag_name, onClick: function () { return _this.uiStore.navigateTo("/auftrag/" + _this.props.auftrag.anr); } },
            React.createElement(react_bootstrap_1.Badge, { className: "auftrag-badge-" + status, style: { float: 'right' } }, this.props.auftrag.statustext),
            React.createElement("span", { className: "text-muted" },
                this.props.showLiDetails ? "Zugewiesen an " + this.props.auftrag.pivorname + " " + this.props.auftrag.piname : '',
                this.props.showLiDetails && React.createElement("br", null),
                this.props.auftrag.referenzdatum,
                " - ",
                this.props.auftrag.refnr)));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragListItem.prototype, "uiStore", void 0);
    return AuftragListItem;
}(React.Component));
/** Liste aller Aufträge mit Filter und Suchfunktionen */
var Auftraege = (function (_super) {
    __extends(Auftraege, _super);
    function Auftraege() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.auftragStatus = { kuerzel: '', text: '' };
        _this.auftraegeRuecksprache = 0;
        // Die Liste beinhaltet nur die Status die im Portal Sinn machen und diese in leicht abgeänderter Reihenfolge
        _this.auftragStatusListe = [
            { kuerzel: '', text: 'Alle Aufträge' },
            { kuerzel: 'inarbeit', text: 'in Arbeit' },
            { kuerzel: 'anfrage', text: 'Anfrage' },
            { kuerzel: 'angebot', text: 'Angebot versendet' },
            { kuerzel: 'auftert', text: 'Auftrag erteilt' },
            { kuerzel: 'termin', text: 'Terminiert' },
            { kuerzel: 'externab', text: 'Extern abgeschlossen' },
            { kuerzel: 'dokpruef', text: 'In Dokumentenprüfung' },
            { kuerzel: 'rueckspr', text: 'Rücksprache erforderlich' },
            { kuerzel: 'freigabe', text: 'Geprüft und freigegeben' },
            { kuerzel: 'abger', text: 'Abgerechnet' },
            { kuerzel: 'abgeschl', text: 'Abgeschlossen' },
            { kuerzel: 'auftnert', text: 'Auftrag nicht erteilt' },
            { kuerzel: 'sammelre', text: 'Sammelrechnung' },
            { kuerzel: 'zurueck', text: 'Zurückgestellt' }
        ];
        return _this;
    }
    Auftraege.prototype.componentDidMount = function () {
        this.auftragStatus = this.auftragStatusListe[1];
        this.ladeAuftraege();
    };
    Auftraege.prototype.ladeAuftraege = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftraege(this.currentPage, this.filter, this.auftragStatus.kuerzel, this.props.lizenzAuftraege)];
                    case 1:
                        res = _a.sent();
                        if (res.ok) {
                            this.setLastPage(res.json.last_page);
                            this.setTotal(res.json.total);
                            this.setAuftraege(res.json.data);
                        }
                        return [4 /*yield*/, this.apiStore.auftraegeanzahl('rueckspr')];
                    case 2:
                        res = _a.sent();
                        if (res.ok) {
                            this.setAuftraegeRuecksprache(res.json.anzahl);
                        }
                        else {
                            this.setAuftraegeRuecksprache(0);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Auftraege.prototype.setAuftraege = function (auftraege) {
        this.auftraege = auftraege;
    };
    Auftraege.prototype.paginate = function (pageNumber) {
        this.setCurrentPage(pageNumber);
        this.ladeAuftraege();
    };
    Auftraege.prototype.setAuftraegeRuecksprache = function (anzahl) {
        this.auftraegeRuecksprache = anzahl;
    };
    Auftraege.prototype.setAuftragStatus = function (value) {
        var status = this.auftragStatusListe.find(function (e) { return e.kuerzel === value; });
        if (status) {
            this.auftragStatus = status;
        }
        else {
            this.auftragStatus = { kuerzel: '', text: '' };
        }
        this.paginate(1);
    };
    Auftraege.prototype.handleAuftragStatusChanged = function (event) {
        var status = this.auftragStatusListe.find(function (e) { return e.kuerzel === event.target.value; });
        if (status) {
            this.auftragStatus = status;
        }
        else {
            this.auftragStatus = { kuerzel: '', text: '' };
        }
        this.paginate(1);
    };
    Auftraege.prototype.render = function () {
        var _this = this;
        var placeholder = 'Suchen (Name, Referenznr.)';
        if (this.props.lizenzAuftraege) {
            placeholder = 'Suchen (Name, Referenznr., Bearbeiter)';
        }
        return (React.createElement("div", { className: "auftraege" }, !this.auftraege ? React.createElement("div", { className: "maxwidth" }, "Lade Auftr\u00E4ge...") : (React.createElement("div", { className: "maxwidth" },
            this.auftraegeRuecksprache > 0 &&
                React.createElement(react_bootstrap_1.Alert, { bsStyle: "danger" },
                    "Sie haben ",
                    this.auftraegeRuecksprache,
                    " ",
                    this.auftraegeRuecksprache === 1 ? 'Auftrag der auf Rücksprache wartet' : 'Aufträge die auf Rücksprache warten',
                    ". Bitte ",
                    React.createElement("a", { href: "#", onClick: function () { return _this.setAuftragStatus('rueckspr'); } }, "klicken Sie hier"),
                    " um diese(n) anzuzeigen."),
            React.createElement(react_bootstrap_1.InputGroup, { className: "filter-group" },
                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                    React.createElement(FaIcon_1.default, { icon: "folder-open" })),
                React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", className: "filter-box", value: this.auftragStatus.kuerzel, onChange: this.handleAuftragStatusChanged },
                    this.auftragStatusListe.map(function (e) { return (React.createElement("option", { key: e.kuerzel, value: e.kuerzel }, e.text)); }),
                    ";")),
            React.createElement(FilterBox_1.default, { onChange: this.handleFilterList, placeholder: placeholder }),
            React.createElement(react_bootstrap_1.Panel, { header: this.auftragStatus.text + " (" + this.total + ")" },
                React.createElement(react_bootstrap_1.ListGroup, { fill: true, className: "auftragsliste" },
                    this.auftraege.length === 0 && (React.createElement(react_bootstrap_1.ListGroupItem, null, "keine Eintr\u00E4ge")),
                    this.auftraege.map(function (auftrag, index) { return React.createElement(AuftragListItem, { key: index, auftrag: auftrag, showLiDetails: _this.props.lizenzAuftraege }); }))),
            React.createElement(Pager_1.default, { items: this.lastPage, onSelect: this.paginate, activePage: this.currentPage })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Auftraege.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Auftraege.prototype, "auftraege", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Auftraege.prototype, "auftragStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], Auftraege.prototype, "auftraegeRuecksprache", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Auftraege.prototype, "setAuftraege", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], Auftraege.prototype, "paginate", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], Auftraege.prototype, "setAuftraegeRuecksprache", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Auftraege.prototype, "setAuftragStatus", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Auftraege.prototype, "handleAuftragStatusChanged", null);
    Auftraege = __decorate([
        mobx_react_1.observer
    ], Auftraege);
    return Auftraege;
}(PagedList_1.default));
exports.default = Auftraege;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes = __webpack_require__(21);
var ApiTypes_1 = __webpack_require__(21);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var AuftragAdresseErfassen_1 = __webpack_require__(109);
var LadeFortschritt_1 = __webpack_require__(53);
var AuftragAnlegen_1 = __webpack_require__(108);
/** Formular zum Anlegen eines neuen Auftrags für die Stückprüfung von Scheinwerfer-Eintellprüfsystemen */
var AuftragAnlegenSES = (function (_super) {
    __extends(AuftragAnlegenSES, _super);
    function AuftragAnlegenSES() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kategorie = 'ses';
        _this.meta = [
            { bezeichnung: ApiTypes_1.SES_TYP, inhalt: 'PKW' },
            { bezeichnung: ApiTypes_1.SES_BAHN, inhalt: '' }
        ];
        return _this;
    }
    AuftragAnlegenSES.prototype.setzeMetadatum = function (bezeichnung, inhalt) {
        var metadatum = this.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        if (metadatum) {
            metadatum.inhalt = inhalt;
        }
    };
    AuftragAnlegenSES.prototype.holeMetadatum = function (bezeichnung) {
        var metadatum = this.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        if (metadatum) {
            return metadatum.inhalt;
        }
        return '';
    };
    AuftragAnlegenSES.prototype.handleFzKategorieSelected = function (event) {
        this.setzeMetadatum(ApiTypes_1.SES_TYP, event.target.value);
    };
    AuftragAnlegenSES.prototype.handleBahnChanged = function (event) {
        this.setzeMetadatum(ApiTypes_1.SES_BAHN, event.target.value);
    };
    AuftragAnlegenSES.prototype.checkBahn = function () {
        if (this.holeMetadatum(ApiTypes_1.SES_BAHN) === '') {
            this.setzeMetadatum(ApiTypes_1.SES_BAHN, '(ohne)');
        }
    };
    AuftragAnlegenSES.prototype.handleAuftragAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var daten, auftragResponse, anr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.checkBahn();
                        daten = {
                            'auftragname': "SES " + this.auftraggeber.name + " (" + this.holeMetadatum(ApiTypes_1.SES_TYP) + " " + this.holeMetadatum(ApiTypes_1.SES_BAHN) + ")",
                            'pinummer': this.verantwortlicher,
                            'referenzdatum': this.referenzdatum,
                            'lizenznehmer': this.lizenznehmer,
                            'kategorie': this.kategorie,
                            'bemerkung': this.bemerkung,
                            'meta': this.meta,
                            'abweichenderuntersuchungsort': !this.untersuchungsortGleichAuftraggeber,
                            'auftraggeber': {
                                'name1': this.auftraggeber.name,
                                'name2': this.auftraggeber.zusatz,
                                'strasse': this.auftraggeber.strasse,
                                'plz': this.auftraggeber.plz,
                                'ort': this.auftraggeber.ort,
                                'tel': this.auftraggeber.tel1,
                                'email': this.auftraggeber.email,
                                'email2': this.auftraggeber.email2,
                                'adressid': this.auftraggeber.adressid
                            },
                            'beauftragter': {
                                'name1': this.untersuchungsort.name,
                                'name2': this.untersuchungsort.zusatz,
                                'strasse': this.untersuchungsort.strasse,
                                'plz': this.untersuchungsort.plz,
                                'ort': this.untersuchungsort.ort,
                                'tel': this.untersuchungsort.tel1,
                                'email': this.untersuchungsort.email,
                                'adressid': this.untersuchungsort.adressid
                            }
                        };
                        return [4 /*yield*/, this.apiStore.auftragAnlegen(daten)];
                    case 1:
                        auftragResponse = _a.sent();
                        if (auftragResponse.ok) {
                            anr = auftragResponse.json.success;
                            this.uiStore.navigateTo("/auftrag/" + anr);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenSES.prototype.setBefugnisse = function (befugnisse) {
        this.befugnisse = befugnisse;
    };
    AuftragAnlegenSES.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile, befugnisse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setAuftragskopfGeladen(false);
                        this.setReferenzDatum();
                        return [4 /*yield*/, this.uiStore.loadUserProfile()];
                    case 1:
                        _a.sent();
                        userProfile = this.uiStore.userProfile;
                        if (!(userProfile && userProfile.projektleiter)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uiStore.loadPersonallisteKategorie(this.kategorie)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.uiStore.loadFreigaben()];
                    case 4:
                        _a.sent();
                        if (this.uiStore.freigaben) {
                            if (this.uiStore.freigaben.length > 0) {
                                this.setLizenznehmer(this.uiStore.freigaben[0].lizenznehmer);
                            }
                        }
                        return [4 /*yield*/, this.apiStore.befugnisse()];
                    case 5:
                        befugnisse = _a.sent();
                        if (befugnisse.ok) {
                            this.setBefugnisse(befugnisse.json);
                        }
                        this.setAuftragskopfGeladen(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenSES.prototype.voraussetzungenErfuellt = function () {
        var result = (this.referenzdatum !== '') && (this.lizenznehmer) && (this.auftraggeber.name.trim() !== '');
        // Projektleiter dürfen den Auftrag anderen Personen zuweisen, in diesen Fällen muss zum speichern eine Person gewählt sein
        if (this.uiStore.userProfile && this.uiStore.userProfile.projektleiter) {
            result = result && (this.verantwortlicher !== '');
        }
        // Untersuchungsort nur validieren, wenn dieser vom Auftraggeber abweicht
        if (!this.untersuchungsortGleichAuftraggeber) {
            result = result && (this.untersuchungsort.name.trim() !== '');
        }
        return result;
    };
    AuftragAnlegenSES.prototype.render = function () {
        var _this = this;
        if (!this.auftragskopfGeladen) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        // Anlegen von SES Aufträgen darf nur möglich sein wenn der angemeldete Nutzer min. eine aktuell gültige SES-Kategorie besitzt
        var anlegenerlaubt = this.befugnisse.filter(function (befugnis) { return befugnis.gueltig === true; }).some(function (befugnis) { return befugnis.kategorie === 'ses'; });
        if (!anlegenerlaubt) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null,
                    "Sie besitzen keine aktiven Befugnisse f\u00FCr das Anlegen von Auftr\u00E4gen zur St\u00FCckpr\u00FCfung von Schweinwerfer-Einstellpr\u00FCfsystemen.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "Bitte wenden Sie sich bei R\u00FCckfragen an den ",
                    React.createElement("a", { href: "/kontakt" }, "Support"),
                    " der DIQ Zert GmbH.")));
        }
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleAuftragAnlegenSubmit },
            React.createElement("h3", null, "Neuen Auftrag f\u00FCr St\u00FCckpr\u00FCfung SES anlegen"),
            React.createElement(react_bootstrap_1.Panel, { header: "Auftragdetails" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.lizenznehmer === '' ? 'error' : undefined, controlId: "Anlegen für" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Anlegen f\u00FCr"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.lizenznehmer, onChange: this.handleLizenznehmerChanged }, this.uiStore.freigaben &&
                            this.uiStore.freigaben.map(function (freigabe) {
                                return React.createElement("option", { key: freigabe.lizenznehmer, value: freigabe.lizenznehmer },
                                    freigabe.name,
                                    " (",
                                    freigabe.lizenznehmer,
                                    ")");
                            })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.referenzdatum === '' ? 'error' : undefined, controlId: "Referenzdatum" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Referenzdatum"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "date", label: "Referenzdatum", value: this.referenzdatum, onChange: this.handleDatumChanged }))),
                this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                    (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.verantwortlicher === '' ? 'error' : undefined, controlId: "Zuweisung" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zuweisung"),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.verantwortlicher, onChange: this.handlePiChanged },
                                React.createElement("option", { value: "" }, "Bitte zust\u00E4ndige Person w\u00E4hlen..."),
                                this.uiStore.personalliste &&
                                    this.uiStore.personalliste.map(function (personal) {
                                        return React.createElement("option", { key: personal.pi, value: personal.pi },
                                            personal.vorname,
                                            " ",
                                            personal.name,
                                            " (",
                                            personal.pi,
                                            ")");
                                    })))))),
            React.createElement(AuftragAdresseErfassen_1.default, { caption: "Auftraggeber", adresse: this.auftraggeber, onUpdateAdresse: this.setAuftraggeber, adressArt: ApiTypes.AdressArt.Auftraggeber }),
            React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkboxSeparateOrtsEingabe", onChange: this.handleUntersuchungsortGleichAuftraggeberChange, defaultChecked: this.untersuchungsortGleichAuftraggeber }, "Untersuchungssort entspricht Auftraggeber")),
            !this.untersuchungsortGleichAuftraggeber &&
                React.createElement(AuftragAdresseErfassen_1.default, { caption: "Ort der Kalibrierung", adresse: this.untersuchungsort, onUpdateAdresse: this.setUntersuchungsort, adressArt: ApiTypes.AdressArt.Untersuchungsstelle }),
            React.createElement(react_bootstrap_1.Panel, { header: "Bemerkung" },
                React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", type: "text", label: "Bemerkung", placeholder: "Optional", value: this.bemerkung, onChange: this.handleBemerkungChanged })),
            React.createElement(react_bootstrap_1.Panel, { header: "SES" },
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Fahrzeugkategorie" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Fahrzeugkategorie"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.holeMetadatum(ApiTypes_1.SES_TYP), onChange: this.handleFzKategorieSelected },
                            React.createElement("option", { value: "PKW" }, "PKW"),
                            React.createElement("option", { value: "LKW" }, "LKW"),
                            React.createElement("option", { value: "KRAD" }, "KRAD")))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Pruefbahn" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Pr\u00FCfbahn"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Pruefbahn", placeholder: "Optional", value: this.holeMetadatum(ApiTypes_1.SES_BAHN), onChange: this.handleBahnChanged })))),
            !this.voraussetzungenErfuellt() && (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Es wurden noch nicht alle erforderlichen Felder ausgef\u00FCllt!"))),
            React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", disabled: !this.voraussetzungenErfuellt() }, "Auftrag anlegen"))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAnlegenSES.prototype, "befugnisse", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AuftragAnlegenSES.prototype, "meta", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegenSES.prototype, "setzeMetadatum", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegenSES.prototype, "holeMetadatum", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegenSES.prototype, "handleFzKategorieSelected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegenSES.prototype, "handleBahnChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegenSES.prototype, "checkBahn", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAnlegenSES.prototype, "handleAuftragAnlegenSubmit", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAnlegenSES.prototype, "setBefugnisse", null);
    AuftragAnlegenSES = __decorate([
        mobx_react_1.observer
    ], AuftragAnlegenSES);
    return AuftragAnlegenSES;
}(AuftragAnlegen_1.default));
exports.default = AuftragAnlegenSES;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var ApiStore_1 = __webpack_require__(13);
var ApiTypes = __webpack_require__(21);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
/** Komponente für Eingabe und Übernahme der Daten zu einer Adresse */
var AuftragAdresseUebernehmen = (function (_super) {
    __extends(AuftragAdresseUebernehmen, _super);
    function AuftragAdresseUebernehmen(props) {
        var _this = _super.call(this, props) || this;
        _this.kennung = '';
        _this.adresseVorhanden = undefined;
        _this.requestInProgress = false;
        _this.abrufTimeoutRef = 0;
        _this.bezeichner = '';
        _this.label = '';
        _this.platzhalter = '';
        if (_this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
            _this.bezeichner = 'Adresse';
            _this.label = 'Aus Adress-ID';
            _this.platzhalter = 'Nummer der Adresse';
        }
        else {
            _this.bezeichner = 'Untersuchungsstelle';
            _this.label = 'Aus Untersuchungsstelle';
            _this.platzhalter = 'Kennung der ÜO';
        }
        return _this;
    }
    AuftragAdresseUebernehmen.prototype.setRequestInProgress = function (value) {
        this.requestInProgress = value;
    };
    AuftragAdresseUebernehmen.prototype.pruefeAdresseVorhandenDelayed = function () {
        var _this = this;
        if (this.abrufTimeoutRef > 0) {
            window.clearTimeout(this.abrufTimeoutRef);
            this.abrufTimeoutRef = 0;
        }
        var validateTimeoutInMs = 500;
        this.abrufTimeoutRef = window.setTimeout(function () { _this.pruefeAdresseVorhanden(); }, validateTimeoutInMs);
    };
    AuftragAdresseUebernehmen.prototype.chk = function () {
        if (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
            return this.apiStore.adresseVorhanden(this.kennung);
        }
        else {
            return this.apiStore.untersuchungsstelleVorhanden(this.kennung);
        }
    };
    AuftragAdresseUebernehmen.prototype.apl = function () {
        if (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
            return this.apiStore.adresseDaten(this.kennung);
        }
        else {
            return this.apiStore.untersuchungsstelleAdresse(this.kennung);
        }
    };
    AuftragAdresseUebernehmen.prototype.pruefeAdresseVorhanden = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.kennung !== '')) return [3 /*break*/, 2];
                        this.setRequestInProgress(true);
                        return [4 /*yield*/, this.chk()];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setAdresseVorhanden(response.json.vorhanden);
                        }
                        this.setRequestInProgress(false);
                        return [3 /*break*/, 3];
                    case 2:
                        this.setAdresseVorhanden(false);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuftragAdresseUebernehmen.prototype.uebernehme = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.kennung !== '')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apl()];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.props.onUebernehme(response.json);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AuftragAdresseUebernehmen.prototype.setAdresseVorhanden = function (value) {
        this.adresseVorhanden = value;
    };
    AuftragAdresseUebernehmen.prototype.handleKennungChanged = function (event) {
        this.kennung = event.target.value;
        this.pruefeAdresseVorhandenDelayed();
    };
    AuftragAdresseUebernehmen.prototype.renderAbfrageStatus = function () {
        if (this.kennung === '') {
            return React.createElement("div", { style: { marginTop: '15px' } }, "\u00A0");
        }
        if (this.requestInProgress) {
            return React.createElement("div", { style: { marginTop: '15px' } },
                React.createElement(FaIcon_1.default, { icon: "spinner" }),
                "Daten werden abgerufen...");
        }
        if (this.adresseVorhanden) {
            return React.createElement("div", { className: "value-success", style: { marginTop: '15px' } },
                React.createElement(FaIcon_1.default, { icon: "check" }),
                "Zu dieser ",
                this.bezeichner,
                " liegen Adressinformationen vor");
        }
        if (this.adresseVorhanden === false) {
            return React.createElement("div", { style: { marginTop: '15px' } },
                React.createElement(FaIcon_1.default, { icon: "question" }),
                "Zu dieser ",
                this.bezeichner,
                " liegen keine Adressinformationen vor");
        }
        return React.createElement("div", { style: { marginTop: '15px' } }, "\u00A0");
    };
    AuftragAdresseUebernehmen.prototype.render = function () {
        var _this = this;
        // Art des HTML-Input Elements je nach Datentyp steuern, Adressen müssen immer numerisch sein
        var type = (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) ? 'number' : 'text';
        return (React.createElement("div", { style: { marginTop: '15px' } },
            React.createElement(react_bootstrap_1.FormGroup, null,
                React.createElement(react_bootstrap_1.ControlLabel, null, this.label),
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: type, label: "Kennung", placeholder: this.platzhalter, onChange: this.handleKennungChanged, value: this.kennung }),
                    React.createElement(react_bootstrap_1.InputGroup.Button, null,
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "success", className: "btn-group", disabled: !this.adresseVorhanden, onClick: function () { return _this.uebernehme(); } }, "\u00DCbernehmen"))),
                this.renderAbfrageStatus())));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragAdresseUebernehmen.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragAdresseUebernehmen.prototype, "kennung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAdresseUebernehmen.prototype, "adresseVorhanden", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AuftragAdresseUebernehmen.prototype, "requestInProgress", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseUebernehmen.prototype, "setRequestInProgress", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseUebernehmen.prototype, "chk", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseUebernehmen.prototype, "apl", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuftragAdresseUebernehmen.prototype, "pruefeAdresseVorhanden", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuftragAdresseUebernehmen.prototype, "uebernehme", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseUebernehmen.prototype, "setAdresseVorhanden", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseUebernehmen.prototype, "handleKennungChanged", null);
    AuftragAdresseUebernehmen = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AuftragAdresseUebernehmen);
    return AuftragAdresseUebernehmen;
}(React.Component));
exports.default = AuftragAdresseUebernehmen;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var FaIcon_1 = __webpack_require__(20);
var DocumentListItem = (function (_super) {
    __extends(DocumentListItem, _super);
    function DocumentListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalVisible = false;
        return _this;
    }
    DocumentListItem.prototype.showModal = function () {
        this.modalVisible = true;
    };
    DocumentListItem.prototype.hideModal = function () {
        this.modalVisible = false;
    };
    DocumentListItem.prototype.render = function () {
        var _a = this.props, document = _a.document, source = _a.source, id = _a.id;
        var downloadUrl;
        switch (source) {
            case 'auftrag':
                downloadUrl = this.apiStore.auftragDokumentDownloadUrl(id, document.eintrag_guid);
                break;
            case 'vorgang':
                downloadUrl = this.apiStore.vorgangDokumentDownloadUrl(id, document.eintrag_guid);
                break;
            default:
                throw new Error("Unknown Document-Source (" + source + ")");
        }
        var faIcon;
        switch (document.dateiendung.toLowerCase()) {
            case 'pdf':
                faIcon = 'file-pdf-o';
                break;
            case 'xls':
            case 'xlsx':
                faIcon = 'file-excel-o';
                break;
            case 'doc':
            case 'docx':
                faIcon = 'file-word-o';
                break;
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                faIcon = 'file-image-o';
                break;
            case 'msg':
                faIcon = 'envelope-o';
                break;
            default:
                faIcon = 'file';
                break;
        }
        var faIconStatus;
        var hintStatus;
        if (document.docstatus) {
            switch (document.docstatus.toLowerCase()) {
                case 'oeffentl':
                    faIconStatus = 'globe';
                    hintStatus = 'Dieses Dokument kann über den öffentlichen Link heruntergeladen werden';
                    break;
                case 'freigabe':
                    faIconStatus = 'download';
                    hintStatus = 'Dieses Dokument kann als angemeldeter Benutzer heruntergeladen werden';
                    break;
                case 'exterz':
                    faIconStatus = 'lock';
                    hintStatus = 'Dieses Dokument wurde erfolgreich übermittelt, kann aber nicht mehr heruntergeladen werden';
                    break;
                default:
                    faIconStatus = undefined;
                    hintStatus = undefined;
            }
        }
        var downloadErlaubt = document.downloadfreigegeben ? document.downloadfreigegeben : false;
        if (downloadErlaubt) {
            return (React.createElement(react_bootstrap_1.ListGroupItem, { target: "_blank", href: downloadUrl },
                React.createElement(FaIcon_1.default, { icon: faIcon }),
                " ",
                document.erfasstam,
                " - ",
                document.titel,
                " (",
                document.docid,
                ")",
                faIconStatus &&
                    React.createElement("span", { className: "pull-right", title: hintStatus },
                        React.createElement(FaIcon_1.default, { icon: faIconStatus }))));
        }
        else {
            return (React.createElement(react_bootstrap_1.ListGroupItem, { onClick: this.showModal, className: "dokument-kein-download" },
                React.createElement(react_bootstrap_1.Modal, { show: this.modalVisible, onHide: this.hideModal, className: "modal-vertical-centered" },
                    React.createElement(react_bootstrap_1.Modal.Header, null,
                        React.createElement(react_bootstrap_1.Modal.Title, null, "Dokument nicht freigegeben")),
                    React.createElement(react_bootstrap_1.Modal.Body, null,
                        "Das Dokument ",
                        React.createElement("b", null,
                            "\"",
                            document.titel,
                            "\""),
                        " (Aktenzeichen ",
                        document.docid,
                        ") wurde zur Bearbeitung \u00FCbermittelt.",
                        React.createElement("br", null),
                        "Die freigegebenen Dokumente finden Sie nach Pr\u00FCfung durch die DIQ Zert in der Auftrags\u00FCbersicht."),
                    React.createElement(react_bootstrap_1.Modal.Footer, null,
                        React.createElement(react_bootstrap_1.Button, { onClick: this.hideModal }, "Schlie\u00DFen"))),
                React.createElement(FaIcon_1.default, { icon: faIcon }),
                " ",
                document.erfasstam,
                " - ",
                document.titel,
                " (",
                document.docid,
                ")",
                faIconStatus &&
                    React.createElement("span", { className: "pull-right", title: hintStatus },
                        React.createElement(FaIcon_1.default, { icon: faIconStatus }))));
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], DocumentListItem.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], DocumentListItem.prototype, "modalVisible", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DocumentListItem.prototype, "showModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DocumentListItem.prototype, "hideModal", null);
    DocumentListItem = __decorate([
        mobx_react_1.observer
    ], DocumentListItem);
    return DocumentListItem;
}(React.Component));
exports.DocumentListItem = DocumentListItem;
var DocumentList = (function (_super) {
    __extends(DocumentList, _super);
    function DocumentList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.refresh();
                return [2 /*return*/];
            });
        });
    };
    DocumentList.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props.source;
                        switch (_a) {
                            case 'vorgang': return [3 /*break*/, 1];
                            case 'auftrag': return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, this.apiStore.vorgangDokumente(this.props.id)];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.apiStore.auftragDokumente(this.props.id)];
                    case 4:
                        response = _b.sent();
                        return [3 /*break*/, 6];
                    case 5: throw new Error("Unknown Document-Source (" + this.props.source + ")");
                    case 6:
                        if (response && response.ok) {
                            this.setDocs(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentList.prototype.setDocs = function (docs) {
        this.docs = docs;
    };
    DocumentList.prototype.stringToDate = function (datumDE) {
        var elemente = datumDE.match(/(\d+)/ig);
        if (elemente) {
            return new Date(parseInt(elemente[2], 10), parseInt(elemente[1], 10) - 1, parseInt(elemente[0], 10), parseInt(elemente[3], 10), parseInt(elemente[4], 10), parseInt(elemente[5], 10));
        }
        else {
            return undefined;
        }
    };
    DocumentList.prototype.datumsvergleich = function (a, b) {
        var d1 = this.stringToDate(a.erfasstam);
        var d2 = this.stringToDate(b.erfasstam);
        if (d1 && d2) {
            return d2.getTime() - d1.getTime();
        }
        else {
            return 0;
        }
    };
    DocumentList.prototype.render = function () {
        var _a = this.props, source = _a.source, id = _a.id, header = _a.header;
        var headlineText = 'Dokumente';
        return (React.createElement("div", null,
            header === 'headline' && React.createElement("h3", null, headlineText),
            React.createElement(react_bootstrap_1.Panel, { header: header === 'panel' && headlineText },
                React.createElement(react_bootstrap_1.ListGroup, { fill: true }, !this.docs ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "lade Dokumente...")) : (this.docs.length === 0) ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "Keine Dokumente vorhanden")) : this.docs.sort(this.datumsvergleich).map(function (doc, index) { return React.createElement(DocumentListItem, { key: index, document: doc, source: source, id: id }); })))));
    };
    DocumentList.defaultProps = {
        header: 'panel'
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], DocumentList.prototype, "docs", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], DocumentList.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DocumentList.prototype, "setDocs", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], DocumentList.prototype, "datumsvergleich", null);
    DocumentList = __decorate([
        mobx_react_1.observer
    ], DocumentList);
    return DocumentList;
}(React.Component));
exports.default = DocumentList;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiTypes = __webpack_require__(21);
var ObjektMessmittelUebernehmen_1 = __webpack_require__(111);
var ObjektAnlegen_1 = __webpack_require__(110);
/** Komponenten zum Erfassen eines neuen Objektes vom Typ Agbasmgessgerät (kurz AGT) */
var ObjektAnlegenAGT = (function (_super) {
    __extends(ObjektAnlegenAGT, _super);
    function ObjektAnlegenAGT() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objekt = {
            objektid: '',
            hersteller: '',
            name: '',
            sernr: '',
            typbezeichnung: '',
            typ: 'AGT',
            bemerkung: ''
        };
        _this.objektMeta = {
            messkammerlaenge: '',
            fehlergrenze: '',
            genauigkeitsklasse: '',
            baumuster: '',
            baujahr: '',
            salzrußäquivalent: ''
        };
        return _this;
    }
    ObjektAnlegenAGT.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objektVorlagen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.objektVorlagen('agt')];
                    case 1:
                        objektVorlagen = _a.sent();
                        if (objektVorlagen.ok) {
                            this.setObjektVorlagen(objektVorlagen.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ObjektAnlegenAGT.prototype.handleObjektAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var objekt;
            return __generator(this, function (_a) {
                event.preventDefault();
                objekt = Object.assign({}, this.objekt);
                objekt.meta = [];
                objekt.meta.push({ bezeichnung: 'agt_messkammerlänge', inhalt: this.objektMeta.messkammerlaenge });
                objekt.meta.push({ bezeichnung: 'agt_fehlergrenze', inhalt: this.objektMeta.fehlergrenze });
                objekt.meta.push({ bezeichnung: 'agt_genauigkeitsklasse', inhalt: this.objektMeta.genauigkeitsklasse });
                objekt.meta.push({ bezeichnung: 'agt_baujahr', inhalt: this.objektMeta.baujahr });
                objekt.meta.push({ bezeichnung: 'agt_baumuster', inhalt: this.objektMeta.baumuster });
                objekt.meta.push({ bezeichnung: 'agt_salz_ruß_äquivalent', inhalt: this.objektMeta.salzrußäquivalent });
                if (this.props.onAddObjekt) {
                    this.props.onAddObjekt(objekt);
                }
                return [2 /*return*/];
            });
        });
    };
    /** Übernimmt die Daten aus der gewählten Vorlage in das anzulegende Objekt */
    ObjektAnlegenAGT.prototype.uebernehmeObjektEigenschaften = function () {
        var vorlage = this.vorlageZuModell(this.objekt.hersteller, this.objekt.typbezeichnung);
        if (vorlage) {
            this.objekt.art = vorlage.art;
            // Klartextname setzen
            switch (this.objekt.art) {
                case ApiTypes.AGT_4GAS:
                    this.objekt.name = '4-Gas Tester';
                    break;
                case ApiTypes.AGT_OPAZIMETER:
                    this.objekt.name = 'Opazimeter';
                    break;
                case ApiTypes.AGT_KOMBI:
                    this.objekt.name = 'Kombigerät';
                    break;
                case ApiTypes.AGT_PARTIKEL_DC:
                    this.objekt.name = 'Partikelzähler (Diffusion Charging)';
                    break;
                case ApiTypes.AGT_PARTIKEL_CPC:
                    this.objekt.name = 'Partikelzähler (Condensation Particle Counter)';
                    break;
                default:
                    this.objekt.name = '';
            }
            // Einige der Objektdaten können in der Vorlage (für ein Objekt) vordefiniert werden
            // Diese werden direkt beim Anlagen übernommen
            if (this.objekt.art === ApiTypes.AGT_4GAS || this.objekt.art === ApiTypes.AGT_KOMBI) {
                var meta = this.vorlageMetaDatum(vorlage, 'agt_genauigkeitsklasse');
                this.objektMeta.genauigkeitsklasse = meta ? meta : '';
            }
            if (this.objekt.art === ApiTypes.AGT_OPAZIMETER || this.objekt.art === ApiTypes.AGT_KOMBI) {
                var meta = this.vorlageMetaDatum(vorlage, 'agt_fehlergrenze');
                this.objektMeta.fehlergrenze = meta ? meta : '';
                meta = this.vorlageMetaDatum(vorlage, 'agt_messkammerlänge');
                this.objektMeta.messkammerlaenge = meta ? meta : '';
            }
            if (this.objekt.art === ApiTypes.AGT_PARTIKEL_DC || this.objekt.art === ApiTypes.AGT_PARTIKEL_CPC) {
                var meta = this.vorlageMetaDatum(vorlage, 'agt_salz_ruß_äquivalent');
                this.objektMeta.salzrußäquivalent = meta ? meta : '';
            }
        }
        else {
            this.objekt.art = '';
        }
    };
    /** Übernimmt die Daten aus einem Messmittel der ÜO, soweit diese im ÜO Bereich vorhanden sind */
    ObjektAnlegenAGT.prototype.uebernehmeMessmittelDaten = function (messmittel) {
        this.objekt.objektid = messmittel.pmnummer;
        this.objekt.messmittelkennung = messmittel.pmnummer;
        var vorlageHersteller = this.objektVorlagen.find(function (el) { return el.hersteller.toLocaleLowerCase() === messmittel.hersteller.toLocaleLowerCase(); });
        if (vorlageHersteller) {
            this.objekt.hersteller = vorlageHersteller.hersteller;
        }
        this.objekt.sernr = messmittel.seriennummer;
        // Bei der Übernahme aus einem ÜO Messmittel passt der Modellbezeichner wegen der freien Eingabe u.U. nicht zur Vorlage
        this.objektVorlagenTypen = this.vorlagenZuHersteller(messmittel.hersteller);
        // Zum Messmittel passende Vorlage wählen, wegen freier Eingabemöglichkeit im ÜO Umfeld nicht auf die Schreibweise achten
        var vorlage = this.vorlageZuModell(messmittel.hersteller, messmittel.name);
        if (vorlage) {
            this.objekt.typbezeichnung = vorlage.modell;
            this.uebernehmeObjektEigenschaften();
        }
        this.objektMeta.baumuster = messmittel.baumusterpruefung ? messmittel.baumusterpruefung : '';
        // @todo: Nicht vorhandene Vorlage visualisieren
        this.hideModal();
    };
    ObjektAnlegenAGT.prototype.handleEditValueChanged = function (event) {
        var value = event.target.value;
        var id = event.target.id;
        if (id in this.objekt) {
            this.objekt[id] = value;
            // Beim Wechsel des Herstellers müssen bereits gewählte abhängige Daten gelöscht werden
            if (id === 'hersteller') {
                this.objekt.typbezeichnung = '';
                this.objekt.art = '';
                // Auswählbare Vorlagen auf die für den Hersteller verfügbaren einschränken
                this.objektVorlagenTypen = this.vorlagenZuHersteller(this.objekt.hersteller);
            }
            // Beim Wechsel des Typs (aka Modell) die in der Objektvorlage hinterlegten Eigenschaften in as anzulegende Objekt übernehmen
            if (id === 'typbezeichnung') {
                this.uebernehmeObjektEigenschaften();
            }
            return;
        }
        if (id in this.objektMeta) {
            this.objektMeta[id] = value;
        }
    };
    ObjektAnlegenAGT.prototype.validate = function () {
        var validated = (this.objekt.name && this.objekt.name.trim() !== '') && (this.objektMeta.baujahr.trim() !== '');
        // Validierung der Attribute hängt von der Art des Abgasmessgerätes ab, je nach Art müssen verschiedene Werte manuell hinterlegt werden
        if (((this.objekt.art === ApiTypes.AGT_4GAS) || (this.objekt.art === ApiTypes.AGT_KOMBI)) && (this.objektMeta.genauigkeitsklasse.trim() === '')) {
            validated = false;
        }
        if (((this.objekt.art === ApiTypes.AGT_OPAZIMETER) || (this.objekt.art === ApiTypes.AGT_KOMBI)) && ((this.objektMeta.fehlergrenze.trim() === '') || (this.objektMeta.messkammerlaenge.trim() === ''))) {
            validated = false;
        }
        console.debug(validated);
        return validated;
    };
    ObjektAnlegenAGT.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleObjektAnlegenSubmit },
            React.createElement(react_bootstrap_1.Panel, { className: "panel-header-buttoned", header: React.createElement(ObjektAnlegen_1.ObjektAnlegenHeader, { caption: "Neues Abgasmessgerät anlegen", showModal: this.showModal }), footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", disabled: !this.validate(), type: "submit" }, "Anlegen"))) },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.hersteller === '' ? 'error' : undefined, controlId: "hersteller" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Hersteller"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objekt.hersteller, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            this.objektVorlagenHersteller.map(function (name) { return React.createElement("option", { key: name, value: name }, name); })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.typbezeichnung === '' ? 'error' : undefined, controlId: "typbezeichnung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Typ"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objekt.typbezeichnung, onChange: this.handleEditValueChanged, readOnly: !this.objekt.hersteller, disabled: !this.objekt.hersteller },
                            React.createElement("option", { value: "" }, this.objekt.hersteller ? 'Bitte auswählen...' : 'Bitte Hersteller auswählen...'),
                            this.objektVorlagenTypen &&
                                this.objektVorlagenTypen.filter(function (vorlage) { return vorlage.hersteller === _this.objekt.hersteller; }).map(function (vorlage) { return React.createElement("option", { key: vorlage.modell, value: vorlage.modell }, vorlage.modell); }),
                            ") }"))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.art === '' ? 'error' : undefined, controlId: "name" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Art"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", type: "text", label: "Name", id: "name", value: this.objekt.art, onChange: this.handleEditValueChanged, readOnly: true, disabled: true },
                            React.createElement("option", { value: "" }, "Bitte Hersteller und Typ w\u00E4hlen..."),
                            React.createElement("option", { value: "4gas" }, "4-Gas Tester"),
                            React.createElement("option", { value: "opazimeter" }, "Opazimeter"),
                            React.createElement("option", { value: "kombi" }, "Kombiger\u00E4t"),
                            React.createElement("option", { value: "partikel_dc" }, "Partikelz\u00E4hler (Diffusion Charging)"),
                            React.createElement("option", { value: "partikel_cpc" }, "Partikelz\u00E4hler (Condensation Particle Counter)")))),
                ((this.objekt.art === ApiTypes.AGT_OPAZIMETER) || (this.objekt.art === ApiTypes.AGT_KOMBI)) && (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.messkammerlaenge === '' ? 'error' : undefined, controlId: "messkammerlaenge" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Messkammerl\u00E4nge"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", label: "Messkammerlänge", id: "messkammerlaenge", value: this.objektMeta.messkammerlaenge, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "mm"))))),
                ((this.objekt.art === ApiTypes.AGT_4GAS) || (this.objekt.art === ApiTypes.AGT_KOMBI)) && (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.genauigkeitsklasse === '' ? 'error' : undefined, controlId: "genauigkeitsklasse" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Genauigkeitsklasse"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", type: "text", label: "Genauigkeitsklasse", id: "genauigkeitsklasse", value: this.objektMeta.genauigkeitsklasse, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "00" }, "00"),
                            React.createElement("option", { value: "0" }, "0"),
                            React.createElement("option", { value: "1" }, "1"))))),
                ((this.objekt.art === ApiTypes.AGT_OPAZIMETER) || (this.objekt.art === ApiTypes.AGT_KOMBI)) && (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.fehlergrenze === '' ? 'error' : undefined, controlId: "fehlergrenze" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Fehlergrenze"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "\u00B1"),
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", type: "text", label: "Fehlergrenze", id: "fehlergrenze", value: this.objektMeta.fehlergrenze, onChange: this.handleEditValueChanged },
                                React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                                React.createElement("option", { value: "0,1" }, "0,1"),
                                React.createElement("option", { value: "0,3" }, "0,3")),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                "m",
                                React.createElement("sup", null, "-1")))))),
                (this.objekt.art === ApiTypes.AGT_PARTIKEL_DC || this.objekt.art === ApiTypes.AGT_PARTIKEL_CPC) && (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.salzrußäquivalent === '' ? 'error' : undefined, controlId: "fehlergrenze" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Salz/Ru\u00DF \u00C4quivalent"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", label: "Salz/Ruß Äquivalent", id: "salzrußäquivalent", value: this.objektMeta.salzrußäquivalent, onChange: this.handleEditValueChanged }))))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.sernr === '' ? 'error' : undefined, controlId: "sernr" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Seriennr."),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Seriennr.", id: "sernr", value: this.objekt.sernr, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.objektid === '' ? 'error' : undefined, controlId: "objektid" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Kennzeichnung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Kennzeichnung", id: "objektid", value: this.objekt.objektid, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.baumuster === '' ? 'error' : undefined, controlId: "baumuster" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Baumuster"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Baumuster", id: "baumuster", value: this.objektMeta.baumuster, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.baujahr === '' ? 'error' : undefined, controlId: "baujahr" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Baujahr"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Baujahr", id: "baujahr", placeholder: "JJJJ", value: this.objektMeta.baujahr, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "bemerkung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Bemerkung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Bemerkung", id: "bemerkung", value: this.objekt.bemerkung, onChange: this.handleEditValueChanged }))),
                React.createElement(ObjektMessmittelUebernehmen_1.default, { kategorie: "agt", onUebernehme: this.uebernehmeMessmittelDaten, show: this.modalVisible, onHideModal: this.hideModal }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenAGT.prototype, "objekt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenAGT.prototype, "objektMeta", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ObjektAnlegenAGT.prototype, "handleObjektAnlegenSubmit", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenAGT.prototype, "uebernehmeObjektEigenschaften", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenAGT.prototype, "uebernehmeMessmittelDaten", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenAGT.prototype, "handleEditValueChanged", null);
    ObjektAnlegenAGT = __decorate([
        mobx_react_1.observer
    ], ObjektAnlegenAGT);
    return ObjektAnlegenAGT;
}(ObjektAnlegen_1.default));
exports.default = ObjektAnlegenAGT;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiTypes = __webpack_require__(21);
var round_1 = __webpack_require__(33);
var ObjektMessmittelUebernehmen_1 = __webpack_require__(111);
var ObjektAnlegen_1 = __webpack_require__(110);
var ApiTypesBps = __webpack_require__(280);
/** Formular zum Anlegen eines neuen Bremsprüfstands (Kurz BPS) */
var ObjektAnlegenBPS = (function (_super) {
    __extends(ObjektAnlegenBPS, _super);
    function ObjektAnlegenBPS() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objekt = {
            objektid: '',
            hersteller: '',
            name: '',
            sernr: '',
            typbezeichnung: '',
            typ: 'BPS',
            bemerkung: ''
        };
        _this.objektMeta = {
            typzusatz: '',
            rollendurchmesser: '',
            hebelarmlaenge: '',
            uebersetzungzaehler: '',
            uebersetzungnenner: '',
            baujahr: '',
            inbetriebnahme: '',
            fzart: '',
            anzeigeart: '',
            anzeigeaufloesung: ''
        };
        return _this;
    }
    ObjektAnlegenBPS.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objektVorlagen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.objektVorlagen('bps')];
                    case 1:
                        objektVorlagen = _a.sent();
                        if (objektVorlagen.ok) {
                            this.setObjektVorlagen(objektVorlagen.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ObjektAnlegenBPS.prototype.handleObjektAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var objekt;
            return __generator(this, function (_a) {
                event.preventDefault();
                objekt = Object.assign({}, this.objekt);
                objekt.meta = [];
                objekt.meta.push({ bezeichnung: 'rollendurchmesser', inhalt: this.objektMeta.rollendurchmesser });
                objekt.meta.push({ bezeichnung: 'hebelarmlänge', inhalt: this.objektMeta.hebelarmlaenge });
                objekt.meta.push({ bezeichnung: 'übersetzungsverhältnis_zähler', inhalt: this.objektMeta.uebersetzungzaehler });
                objekt.meta.push({ bezeichnung: 'übersetzungsverhältnis_nenner', inhalt: this.objektMeta.uebersetzungnenner });
                objekt.meta.push({ bezeichnung: 'baujahr', inhalt: this.objektMeta.baujahr });
                objekt.meta.push({ bezeichnung: 'inbetriebnahme', inhalt: this.objektMeta.inbetriebnahme });
                objekt.meta.push({ bezeichnung: 'fzart', inhalt: this.objektMeta.fzart });
                objekt.meta.push({ bezeichnung: 'anzeigeart', inhalt: this.objektMeta.anzeigeart });
                objekt.meta.push({ bezeichnung: 'anzeigeaufloesung', inhalt: this.objektMeta.anzeigeaufloesung });
                if (this.props.onAddObjekt) {
                    this.props.onAddObjekt(objekt);
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(ObjektAnlegenBPS.prototype, "uebersetzungsVerhaeltnis", {
        get: function () {
            if (parseInt(this.objektMeta.uebersetzungzaehler, 10) === NaN || parseInt(this.objektMeta.uebersetzungnenner, 10) === NaN || parseInt(this.objektMeta.uebersetzungnenner, 10) === 0) {
                return undefined;
            }
            return round_1.round(parseInt(this.objektMeta.uebersetzungzaehler, 10) / parseInt(this.objektMeta.uebersetzungnenner, 10), 5);
        },
        enumerable: true,
        configurable: true
    });
    /** Übernimmt die Daten aus der gewählten Vorlage in das anzulegende Objekt */
    ObjektAnlegenBPS.prototype.uebernehmeObjektEigenschaften = function () {
        var vorlage = this.vorlageZuModell(this.objekt.hersteller, this.objekt.typbezeichnung);
        if (vorlage) {
            this.objekt.art = vorlage.art;
            // Klartextname setzen
            switch (this.objekt.art) {
                case 'rolle':
                    this.objekt.name = 'Rollenbremsprüfstand';
                    break;
                case 'platte':
                    this.objekt.name = 'Plattenbremsprüfstand';
                    break;
                default:
                    this.objekt.name = '';
            }
            // Eigenschaften aus Objektvorlage übernehmen
            this.objektMeta.rollendurchmesser = this.vorlageMetaDatum(vorlage, 'rollendurchmesser');
            this.objektMeta.hebelarmlaenge = this.vorlageMetaDatum(vorlage, 'hebelarmlänge');
            this.objektMeta.uebersetzungzaehler = this.vorlageMetaDatum(vorlage, 'übersetzungsverhältnis', 'zähler');
            this.objektMeta.uebersetzungnenner = this.vorlageMetaDatum(vorlage, 'übersetzungsverhältnis', 'nenner');
            this.objektMeta.fzart = '';
            this.objektMeta.anzeigeart = (this.objekt.art === ApiTypesBps.BpsArt.Platte) ? 'analog' : '';
            this.objektMeta.anzeigeaufloesung = '';
        }
        else {
            this.objekt.art = '';
            this.objekt.name = '';
            this.objektMeta.rollendurchmesser = '';
            this.objektMeta.hebelarmlaenge = '';
            this.objektMeta.uebersetzungzaehler = '';
            this.objektMeta.uebersetzungnenner = '';
            this.objektMeta.fzart = '';
            this.objektMeta.anzeigeart = '';
            this.objektMeta.anzeigeaufloesung = '';
        }
    };
    /** Übernimmt die Daten aus einem Messmittel der ÜO, soweit diese im ÜO Bereich vorhanden sind */
    ObjektAnlegenBPS.prototype.uebernehmeMessmittelDaten = function (messmittel) {
        this.objekt.objektid = messmittel.pmnummer;
        this.objekt.messmittelkennung = messmittel.pmnummer;
        var vorlageHersteller = this.objektVorlagen.find(function (el) { return el.hersteller.toLocaleLowerCase() === messmittel.hersteller.toLocaleLowerCase(); });
        if (vorlageHersteller) {
            this.objekt.hersteller = vorlageHersteller.hersteller;
        }
        this.objekt.sernr = messmittel.seriennummer;
        // Bei der Übernahme aus einem ÜO Messmittel passt der Modellbezeichner wegen der freien Eingabe u.U. nicht zur Vorlage
        this.objektVorlagenTypen = this.vorlagenZuHersteller(messmittel.hersteller);
        // Zum Messmittel passende Vorlage wählen, wegen freier Eingabemöglichkeit im ÜO Umfeld nicht auf die Schreibweise achten
        var vorlage = this.vorlageZuModell(messmittel.hersteller, messmittel.name);
        if (vorlage) {
            this.objekt.typbezeichnung = vorlage.modell;
            this.uebernehmeObjektEigenschaften();
        }
        // @todo: Nicht vorhandene Vorlage visualisieren
        this.hideModal();
    };
    ObjektAnlegenBPS.prototype.handleEditValueChanged = function (event) {
        var _this = this;
        var value = event.target.value;
        var id = event.target.id;
        if (id in this.objekt) {
            this.objekt[id] = value;
            // Beim Wechsel des Herstellers müssen bereits gewählte abhängige Daten gelöscht werden
            if (id === 'hersteller') {
                this.objekt.typbezeichnung = '';
                this.objekt.art = '';
                this.objektMeta.rollendurchmesser = '';
                this.objektMeta.hebelarmlaenge = '';
                this.objektMeta.uebersetzungzaehler = '';
                this.objektMeta.uebersetzungnenner = '';
                this.objektMeta.fzart = '';
                this.objektMeta.anzeigeart = '';
                this.objektMeta.anzeigeaufloesung = '';
                // Auswählbare Vorlagen auf die für den Hersteller verfügbaren einschränken
                this.objektVorlagenTypen = [];
                this.objektVorlagenTypen = this.objektVorlagen.filter(function (vorlage) { return vorlage.hersteller === _this.objekt.hersteller; });
            }
            // Beim Wechsel des Typs (aka Modell) die in der Objektvorlage hinterlegten Eigenschaften in das Formular übernehmen
            if (id === 'typbezeichnung') {
                this.uebernehmeObjektEigenschaften();
            }
            return;
        }
        if (id in this.objektMeta) {
            this.objektMeta[id] = value;
        }
    };
    ObjektAnlegenBPS.prototype.validateMeta = function () {
        var _a = this, objekt = _a.objekt, objektMeta = _a.objektMeta, uebersetzungsVerhaeltnis = _a.uebersetzungsVerhaeltnis;
        // Das Objekt darf sich nur anlegen lassen, wenn die Metadaten entsprechend der Art (Rolle oder Platte) ausgefüllt wurden
        if (objekt.art === ApiTypesBps.BpsArt.Rolle) {
            return ((objektMeta.rollendurchmesser.trim() !== '') && (objektMeta.hebelarmlaenge.trim() !== '') && (objektMeta.uebersetzungzaehler.trim() !== '') &&
                (objektMeta.uebersetzungnenner.trim() !== '') && (objektMeta.baujahr.trim() !== '') && (objektMeta.inbetriebnahme.trim() !== '') &&
                (objektMeta.anzeigeart.trim() !== '') && (objektMeta.anzeigeaufloesung !== '') && (objektMeta.fzart !== '') &&
                (uebersetzungsVerhaeltnis !== undefined));
        }
        if (objekt.art === ApiTypesBps.BpsArt.Platte) {
            return ((objektMeta.baujahr.trim() !== '') && (objektMeta.inbetriebnahme.trim() !== '') &&
                (objektMeta.anzeigeart.trim() !== '') && (objektMeta.anzeigeaufloesung !== '') &&
                (objektMeta.fzart !== ''));
        }
        return true;
    };
    ObjektAnlegenBPS.prototype.validate = function () {
        return (this.objekt.name && this.objekt.name.trim() !== '') && this.validateMeta();
    };
    ObjektAnlegenBPS.prototype.renderEigenschaften = function () {
        var _a = this, objekt = _a.objekt, objektMeta = _a.objektMeta;
        // Die Eingabe der Eigenschaften ist abhängig von der Art des Prfüstands, weshalb diese erst nach Auswahl einer gültigen Vorlage angezeigt werden soll
        if ((objekt.art !== ApiTypesBps.BpsArt.Rolle) && (objekt.art !== ApiTypesBps.BpsArt.Platte)) {
            return null;
        }
        return (React.createElement("div", null,
            this.objekt.art === ApiTypesBps.BpsArt.Rolle && React.createElement("div", null,
                React.createElement(react_bootstrap_1.FormGroup, { validationState: objektMeta.rollendurchmesser === '' ? 'error' : undefined, controlId: "rollendurchmesser" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Rollendurchmesser"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", label: "Rollendurchmesser", id: "rollendurchmesser", value: objektMeta.rollendurchmesser, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "mm")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: objektMeta.hebelarmlaenge === '' ? 'error' : undefined, controlId: "hebelarmlaenge" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Hebelarml\u00E4nge"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", label: "Hebelarmlänge", id: "hebelarmlaenge", value: objektMeta.hebelarmlaenge, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "mm")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (objektMeta.uebersetzungzaehler === '' || objektMeta.uebersetzungnenner === '') ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "\u00DCbersetzung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 3 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Rolle"),
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1", min: "1", id: "uebersetzungzaehler", value: objektMeta.uebersetzungzaehler, onChange: this.handleEditValueChanged }))),
                    React.createElement(react_bootstrap_1.Col, { sm: 3 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Motor"),
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1", min: "1", id: "uebersetzungnenner", value: objektMeta.uebersetzungnenner, onChange: this.handleEditValueChanged }))),
                    React.createElement(react_bootstrap_1.Col, { sm: 3 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, tabIndex: -1, value: this.uebersetzungsVerhaeltnis })))),
            React.createElement(react_bootstrap_1.FormGroup, { validationState: (objektMeta.anzeigeart === '' || objektMeta.anzeigeaufloesung === '') ? 'error' : undefined },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Anzeige"),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Art"),
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", id: "anzeigeart", value: objektMeta.anzeigeart, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "analog" }, "Analog"),
                            React.createElement("option", { value: "digital" }, "Digital")))),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Aufl\u00F6sung"),
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", id: "anzeigeaufloesung", value: objektMeta.anzeigeaufloesung, onChange: this.handleEditValueChanged }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N")))),
            React.createElement(react_bootstrap_1.FormGroup, { validationState: objekt.sernr === '' ? 'error' : undefined, controlId: "sernr" },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Seriennr."),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Seriennr.", id: "sernr", value: this.objekt.sernr, onChange: this.handleEditValueChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { validationState: objekt.objektid === '' ? 'error' : undefined, controlId: "objektid" },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Kennzeichnung"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Kennzeichnung", id: "objektid", value: this.objekt.objektid, onChange: this.handleEditValueChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { validationState: objektMeta.baujahr === '' ? 'error' : undefined, controlId: "baujahr" },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Baujahr"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Baujahr", id: "baujahr", placeholder: "JJJJ", value: this.objektMeta.baujahr, onChange: this.handleEditValueChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { validationState: objektMeta.inbetriebnahme === '' ? 'error' : undefined, controlId: "inbetriebnahme" },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Inbetriebnahme"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Inbetriebnahme", id: "inbetriebnahme", placeholder: "MM/JJJJ", value: this.objektMeta.inbetriebnahme, onChange: this.handleEditValueChanged }))),
            React.createElement(react_bootstrap_1.FormGroup, { validationState: objektMeta.fzart === '' ? 'error' : undefined, controlId: "fzart" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Art"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: objektMeta.fzart, onChange: this.handleEditValueChanged },
                        React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                        React.createElement("option", { value: "PKW" }, "PKW"),
                        React.createElement("option", { value: "LKW" }, "LKW"),
                        React.createElement("option", { value: "LKW_PKW" }, "LKW/PKW (kombiniert)")))),
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "bemerkung" },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Bemerkung"),
                React.createElement(react_bootstrap_1.Col, { sm: 9 },
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Bemerkung", id: "bemerkung", value: objekt.bemerkung, onChange: this.handleEditValueChanged })))));
    };
    ObjektAnlegenBPS.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleObjektAnlegenSubmit },
            React.createElement(react_bootstrap_1.Panel, { className: "panel-header-buttoned", header: React.createElement(ObjektAnlegen_1.ObjektAnlegenHeader, { caption: "Neuen Bremsprüfstand anlegen", showModal: this.showModal }), footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", disabled: !this.validate(), type: "submit" }, "Anlegen"))) },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.hersteller === '' ? 'error' : undefined, controlId: "hersteller" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Hersteller"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objekt.hersteller, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            this.objektVorlagenHersteller.map(function (name) { return React.createElement("option", { key: name, value: name }, name); })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.typbezeichnung === '' ? 'error' : undefined, controlId: "typbezeichnung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Typ"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objekt.typbezeichnung, onChange: this.handleEditValueChanged, readOnly: !this.objekt.hersteller, disabled: !this.objekt.hersteller },
                            React.createElement("option", { value: "" }, this.objekt.hersteller ? 'Bitte auswählen...' : 'Bitte Hersteller auswählen...'),
                            this.objektVorlagenTypen &&
                                this.objektVorlagenTypen.filter(function (vorlage) { return vorlage.hersteller === _this.objekt.hersteller; }).map(function (vorlage) { return React.createElement("option", { key: vorlage.modell, value: vorlage.modell }, vorlage.modell); }),
                            ") }"))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "typzusatz" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Zusatz"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", placeholder: "Optionaler Zusatz zum Typ des Prüfstands", label: "Zusatz", id: "typzusatz", value: this.objektMeta.typzusatz, onChange: this.handleEditValueChanged }))),
                this.renderEigenschaften(),
                React.createElement(ObjektMessmittelUebernehmen_1.default, { kategorie: "bps", onUebernehme: this.uebernehmeMessmittelDaten, show: this.modalVisible, onHideModal: this.hideModal }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenBPS.prototype, "objekt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenBPS.prototype, "objektMeta", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ObjektAnlegenBPS.prototype, "handleObjektAnlegenSubmit", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ObjektAnlegenBPS.prototype, "uebersetzungsVerhaeltnis", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenBPS.prototype, "uebernehmeObjektEigenschaften", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenBPS.prototype, "uebernehmeMessmittelDaten", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenBPS.prototype, "handleEditValueChanged", null);
    ObjektAnlegenBPS = __decorate([
        mobx_react_1.observer
    ], ObjektAnlegenBPS);
    return ObjektAnlegenBPS;
}(ObjektAnlegen_1.default));
exports.default = ObjektAnlegenBPS;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes = __webpack_require__(21);
var decorators_1 = __webpack_require__(1);
var ObjektMessmittelUebernehmen_1 = __webpack_require__(111);
var ObjektAnlegen_1 = __webpack_require__(110);
/** Komponenten zum Erfassen eines neuen Objektes vom Typ Scheinwerfer-Einstellprüfgerät (kurz SEP) */
var ObjektAnlegenSEP = (function (_super) {
    __extends(ObjektAnlegenSEP, _super);
    function ObjektAnlegenSEP() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objekt = {
            objektid: '',
            hersteller: '',
            name: 'Scheinwerfer-Einstell-Prüfgerät',
            sernr: '',
            typbezeichnung: '',
            typ: 'SEP',
            status: 'aktiv',
            bemerkung: '',
            messmittelkennung: undefined
        };
        _this.objektMeta = {
            art: '',
            bauform: '',
            baumuster: ''
        };
        return _this;
    }
    ObjektAnlegenSEP.prototype.handleObjektAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var objekt;
            return __generator(this, function (_a) {
                event.preventDefault();
                objekt = Object.assign({}, this.objekt);
                objekt.meta = [];
                objekt.meta.push({ bezeichnung: 'sep_art', inhalt: this.objektMeta.art });
                objekt.meta.push({ bezeichnung: 'sep_bauform', inhalt: this.objektMeta.bauform });
                objekt.meta.push({ bezeichnung: 'sep_baumuster', inhalt: this.objektMeta.baumuster });
                if (this.props.onAddObjekt) {
                    this.props.onAddObjekt(objekt);
                }
                return [2 /*return*/];
            });
        });
    };
    ObjektAnlegenSEP.prototype.handleEditValueChanged = function (event) {
        var value = event.target.value;
        var id = event.target.id;
        if (id in this.objekt) {
            this.objekt[id] = value;
            return;
        }
        if (id in this.objektMeta) {
            this.objektMeta[id] = value;
        }
    };
    /** Übernimmt die Daten aus einem Messmittel der ÜO, soweit diese im ÜO Bereich vorhanden sind */
    ObjektAnlegenSEP.prototype.uebernehmeMessmittelDaten = function (messmittel) {
        this.objekt.objektid = messmittel.pmnummer;
        this.objekt.messmittelkennung = messmittel.pmnummer;
        this.objekt.hersteller = messmittel.hersteller;
        this.objekt.sernr = messmittel.seriennummer;
        this.objekt.typbezeichnung = messmittel.name;
        this.objektMeta.baumuster = messmittel.baumusterpruefung;
        this.hideModal();
    };
    ObjektAnlegenSEP.prototype.validate = function () {
        return (this.objektMeta.art !== '') && (this.objektMeta.bauform !== '');
    };
    ObjektAnlegenSEP.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleObjektAnlegenSubmit },
            React.createElement(react_bootstrap_1.Panel, { className: "panel-header-buttoned", header: React.createElement(ObjektAnlegen_1.ObjektAnlegenHeader, { caption: "Neues Scheinwerfer-Einstell-Prüfgerät anlegen", showModal: this.showModal }), footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", disabled: !this.validate(), type: "submit" }, "SEP anlegen"))) },
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "objektid" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Kennzeichnung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Kennzeichnung", id: "objektid", value: this.objekt.objektid, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "hersteller" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Hersteller"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Hersteller", id: "hersteller", value: this.objekt.hersteller, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "name" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Name"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Name", id: "name", value: this.objekt.name, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "sernr" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Seriennr."),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Seriennr.", id: "sernr", value: this.objekt.sernr, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "typbezeichnung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Typbezeichnung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Typbezeichnung", id: "typbezeichnung", value: this.objekt.typbezeichnung, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "art", validationState: this.objektMeta.art === '' ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Art"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", type: "text", label: "Art", id: "art", value: this.objektMeta.art, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "Analog ohne Niveauausgleich" }, "Analog ohne Niveauausgleich"),
                            React.createElement("option", { value: "Digital ohne Niveauausgleich" }, "Digital ohne Niveauausgleich"),
                            React.createElement("option", { value: "Digital mit Niveauausgleich" }, "Digital mit Niveauausgleich")))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "bauform", validationState: this.objektMeta.bauform === '' ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Bauform"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", type: "text", label: "Bauform", id: "bauform", value: this.objektMeta.bauform, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "Frei verfahrbar" }, "Frei verfahrbar"),
                            React.createElement("option", { value: "Auf Schienensystem" }, "Auf Schienensystem"),
                            React.createElement("option", { value: "Sonderbauform" }, "Sonderbauform")))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "baumuster" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Baumuster"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Baumuster", id: "baumuster", value: this.objektMeta.baumuster, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "bemerkung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Bemerkung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Bemerkung", id: "bemerkung", value: this.objekt.bemerkung, onChange: this.handleEditValueChanged }))),
                React.createElement(ObjektMessmittelUebernehmen_1.default, { kategorie: "sep", onUebernehme: this.uebernehmeMessmittelDaten, show: this.modalVisible, onHideModal: this.hideModal }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenSEP.prototype, "objekt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenSEP.prototype, "objektMeta", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ObjektAnlegenSEP.prototype, "handleObjektAnlegenSubmit", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenSEP.prototype, "handleEditValueChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenSEP.prototype, "uebernehmeMessmittelDaten", null);
    ObjektAnlegenSEP = __decorate([
        mobx_react_1.observer
    ], ObjektAnlegenSEP);
    return ObjektAnlegenSEP;
}(ObjektAnlegen_1.default));
exports.default = ObjektAnlegenSEP;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var ObjektListe_1 = __webpack_require__(165);
var Pager_1 = __webpack_require__(167);
var FilterBox_1 = __webpack_require__(89);
var PagedList_1 = __webpack_require__(166);
var ObjektAuswahl = (function (_super) {
    __extends(ObjektAuswahl, _super);
    function ObjektAuswahl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjektAuswahl.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.ladeObjekte();
                return [2 /*return*/];
            });
        });
    };
    ObjektAuswahl.prototype.ladeObjekte = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.objekte(this.props.kategorie ? this.props.kategorie : 'alle', this.currentPage, this.filter)];
                    case 1:
                        res = _a.sent();
                        if (res.ok) {
                            this.setLastPage(res.json.last_page);
                            this.setObjekte(res.json.data);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ObjektAuswahl.prototype.setObjekte = function (objekte) {
        this.objekte = objekte;
    };
    ObjektAuswahl.prototype.paginate = function (pageNumber) {
        this.setCurrentPage(pageNumber);
        this.ladeObjekte();
    };
    Object.defineProperty(ObjektAuswahl.prototype, "objektBezeichner", {
        get: function () {
            var kategorie = this.props.kategorie ? this.props.kategorie : '';
            switch (kategorie.toLocaleLowerCase()) {
                case 'ses':
                    return 'Scheinwerfer-Einstellprüfgerät';
                case 'agt':
                    return 'Abgasmessgerät';
                default:
                    return 'Objekt';
            }
        },
        enumerable: true,
        configurable: true
    });
    ObjektAuswahl.prototype.render = function () {
        var _this = this;
        var url = this.props.kategorie ? "anlegen/" + this.props.kategorie : 'anlegen/';
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h3", null,
                this.objektBezeichner,
                " ausw\u00E4hlen"),
            React.createElement(FilterBox_1.default, { onChange: this.handleFilterList, placeholder: "Suchen (Kennung, Hersteller, Typbezeichnung, Bemerkung, Seriennr.)" }),
            React.createElement(react_bootstrap_1.Panel, { header: "Seite " + this.currentPage + " von " + (this.lastPage > 0 ? this.lastPage : 1), footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function () { return _this.uiStore.navigateTo(url); } }, "Neu"))) },
                React.createElement(react_bootstrap_1.ListGroup, { fill: true }, !this.objekte ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "Objekte werden geladen...")) : (this.objekte.length === 0) ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "Keine Daten")) : this.objekte.map(function (objekt) { return (React.createElement(ObjektListe_1.ObjektListItem, { key: objekt.objektguid, objekt: objekt, onObjektAuswahl: _this.props.onObjektAuswahl, zusatzinfo: false })); }))),
            this.objekte &&
                React.createElement("div", null,
                    React.createElement(Pager_1.default, { items: this.lastPage, onSelect: this.paginate, activePage: this.currentPage }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ObjektAuswahl.prototype, "objekte", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ObjektAuswahl.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ObjektAuswahl.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ObjektAuswahl.prototype, "setObjekte", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], ObjektAuswahl.prototype, "paginate", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ObjektAuswahl.prototype, "objektBezeichner", null);
    ObjektAuswahl = __decorate([
        mobx_react_1.observer
    ], ObjektAuswahl);
    return ObjektAuswahl;
}(PagedList_1.default));
exports.default = ObjektAuswahl;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var MailVorlageArt;
(function (MailVorlageArt) {
    MailVorlageArt[MailVorlageArt["Auftragsbest\u00E4tigung"] = 0] = "Auftragsbest\u00E4tigung";
})(MailVorlageArt = exports.MailVorlageArt || (exports.MailVorlageArt = {}));
var MailVorlage = (function (_super) {
    __extends(MailVorlage, _super);
    function MailVorlage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailVorlage.prototype.erzeugeMailVorlage = function () {
        var titel = '';
        var inhalt = '';
        if (this.auftragStore.auftrag) {
            if (this.props.vorlage === MailVorlageArt.Auftragsbestätigung) {
                var auftrag = this.auftragStore.auftrag;
                titel = "DIQ Zert GmbH: Auftragsbest\u00E4tigung zum Auftrag " + auftrag.auftrag_name;
                if (auftrag.refnrkunde) {
                    titel += " - Bestellung " + auftrag.refnrkunde + " vom " + auftrag.refdatumkunde;
                }
                titel = encodeURIComponent(titel);
                inhalt = "Sehr geehrte Damen und Herren,%0D%0A %0D%0A";
                if (auftrag.refnrkunde) {
                    inhalt += "als Anlage erhalten Sie die Auftragsbest\u00E4tigung zur Bestellung " + auftrag.refnrkunde + " vom " + auftrag.refdatumkunde + ".%0D%0A";
                }
                else {
                    inhalt += "als Anlage erhalten Sie die Auftragsbest\u00E4tigung%0D%0A";
                }
                inhalt += "Die erhaltenen Messmittel werden in unserem System im Auftrag mit der Referenznummer " + auftrag.refnr + " bearbeitet.%0D%0A %0D%0A";
            }
            if (titel !== '') {
                inhalt += "F\u00FCr eventuelle R\u00FCckfragen stehen wir sehr gerne zur Verf\u00FCgung.%0D%0A %0D%0AMit freundlichen Gr\u00FC\u00DFen%0D%0ATeam der DIQ Zert GmbH";
                var vorlage = "mailto:?subject=" + titel + "&body=" + inhalt;
                window.location.href = vorlage;
            }
        }
    };
    MailVorlage.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.caption, bsStyle: "success", footer: (React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: function () { return _this.erzeugeMailVorlage(); } },
                    React.createElement(FaIcon_1.default, { icon: "envelope-o" }),
                    " Mailvorlage"))) }, this.props.text));
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], MailVorlage.prototype, "auftragStore", void 0);
    return MailVorlage;
}(React.Component));
exports.default = MailVorlage;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
/**
 * Komponente die die im Auftrag erbrachten und für den Dienstleistungsnachweis relevanten Dienstleistungen inkl. Anzahl auflistet
 * Daran kann sich der Anwender beim Ausfüllen des Dienstleistungsnachweises orientieren
 */
var DienstleistungsUebersicht = (function (_super) {
    __extends(DienstleistungsUebersicht, _super);
    function DienstleistungsUebersicht() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DienstleistungsUebersicht.prototype.render = function () {
        var auftrag = this.props.auftrag;
        if (auftrag) {
            var dienstleistungsListe = {};
            var ausschlussBegriffe_1 = ['dienstleistungsnachweis', 'angebot'];
            auftrag.vorgaenge.forEach(function (element) {
                // Nicht alle Dienstleistungen sind für die Abrechnung relevant und werden über eine Ausschlußliste übersprungen
                var skip = false;
                ausschlussBegriffe_1.forEach(function (e) { return (skip = skip || element.kuerzel_dienstleistung.toLocaleLowerCase().indexOf(e) !== -1); });
                if (!skip) {
                    dienstleistungsListe[element.kuerzel_dienstleistung] = (dienstleistungsListe[element.kuerzel_dienstleistung] + 1) || 1;
                    // Einige Dienstleistungen wie die SES Vermessung bestehen aus mehreren Unterschritten, diese sollen nicht mehrfach gezählt werden
                    if ((auftrag.kategorie === 'ses') && (element.kuerzel_dienstleistung.toLocaleLowerCase().indexOf('vermessung') !== -1)) {
                        dienstleistungsListe[element.kuerzel_dienstleistung] = 1;
                    }
                }
            });
            if (Object.keys(dienstleistungsListe).length > 0) {
                return (React.createElement("div", null,
                    React.createElement("h3", null, "\u00DCbersicht"),
                    React.createElement("div", null, "Die folgenden Dienstleistungen wurden im Auftrag gew\u00E4hlt, nutzen Sie diese als Grundlage f\u00FCr den Dienstleistungsnachweis:"),
                    React.createElement("ul", null, Object.keys(dienstleistungsListe).map(function (key) { return React.createElement("li", null,
                        dienstleistungsListe[key],
                        " x ",
                        key); }))));
            }
        }
        return null;
    };
    return DienstleistungsUebersicht;
}(React.Component));
exports.default = DienstleistungsUebersicht;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
/** Komponente zur Anzeige einer einzelnen Rechnungsposition inkl. Auswahl der Anzahl und Vorschau des Gesamtpreises */
var Rechnungsposition = (function (_super) {
    __extends(Rechnungsposition, _super);
    function Rechnungsposition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Rechnungsposition.prototype.handleValueChanged = function (event) {
        var anzahl = parseInt(event.target.value, 10);
        this.props.setAnzahlHandler(anzahl, this.props.position);
    };
    Rechnungsposition.prototype.render = function () {
        var _a = this.props.position, bezeichnung = _a.bezeichnung, preis = _a.preis;
        return (React.createElement("tr", null,
            React.createElement("td", { width: "75%" }, "" + bezeichnung),
            React.createElement("td", { width: "10%" },
                React.createElement(react_bootstrap_1.FormGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { className: "text-right", onChange: this.handleValueChanged, type: "number", min: "0", step: "1", value: this.props.anzahl }))),
            this.props.preiseAnzeigen &&
                React.createElement("td", { width: "15%", className: "text-right" },
                    preis.toFixed(2).replace('.', ','),
                    " \u20AC")));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Rechnungsposition.prototype, "handleValueChanged", null);
    Rechnungsposition = __decorate([
        mobx_react_1.observer
    ], Rechnungsposition);
    return Rechnungsposition;
}(React.Component));
exports.default = Rechnungsposition;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Kapselkomponemnte für Eingabe und Validierung der Prüfortparameter Kalibrierung Abgasmessgerät
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var Komponente = (function () {
    function Komponente(editable, beschriftung, einheit, bezeichner, formdataprefix, bereich) {
        this.editable = editable !== undefined ? editable : true;
        this.beschriftung = beschriftung;
        this.einheit = einheit;
        this.bezeichner = bezeichner;
        this.formdataprefix = formdataprefix;
        this.min = bereich && bereich.min;
        this.max = bereich && bereich.max;
    }
    Komponente.prototype.handleIstWertChange = function (ev) {
        this.ist = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    Object.defineProperty(Komponente.prototype, "imToleranzbereich", {
        /**
         * Liefert true wenn der Ist-Wert sich im Bereich zwischen min und max befindet (jeweils nur wenn definiert)
         */
        get: function () {
            if ((this.min !== undefined) && (this.ist !== undefined) && (this.ist < this.min)) {
                return false;
            }
            if ((this.max !== undefined) && (this.ist !== undefined) && (this.ist > this.max)) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Komponente.prototype.render = function () {
        return (React.createElement("tr", { key: "tr_" + this.bezeichner },
            React.createElement("td", { style: { verticalAlign: 'middle' } }, this.beschriftung),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, name: this.formdataprefix + "[min]", value: this.min, tabIndex: -1 }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { minWidth: '76px' } }, this.einheit))),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.ist === undefined ? 'error' : undefined, style: { margin: '0px' } },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: !this.editable, name: this.formdataprefix + "[ist]", onChange: this.handleIstWertChange, value: this.ist, className: this.ist !== undefined && this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { minWidth: '76px' } }, this.einheit)))),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", readOnly: true, name: this.formdataprefix + "[max]", value: this.max, tabIndex: -1 }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { minWidth: '76px' } }, this.einheit),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataprefix + "[toleranzbereich]", value: this.imToleranzbereich ? 'true' : 'false' })))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Komponente.prototype, "ist", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Komponente.prototype, "min", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Komponente.prototype, "max", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Komponente.prototype, "handleIstWertChange", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Komponente.prototype, "imToleranzbereich", null);
    return Komponente;
}());
var AgtPruefortParameter = (function (_super) {
    __extends(AgtPruefortParameter, _super);
    function AgtPruefortParameter(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            lufttemperatur: new Komponente(props.editable, 'Lufttemperatur', '°C', 'komponente_temperatur', _this.props.formdataprefix + "[temperatur]", _this.props.bereichLufttemperatur),
            luftfeuchtigkeit: new Komponente(props.editable, 'Luftfeuchtigkeit', '%', 'komponente_feuchtigkeit', _this.props.formdataprefix + "[feuchtigkeit]", _this.props.bereichLuftfeuchtigkeit),
            umgebungsdruck: new Komponente(props.editable, 'Umgebungsdruck', 'mbar', 'komponente_druck', _this.props.formdataprefix + "[druck]", _this.props.bereichUmgebungsdruck)
        };
        // Vorhandene Werte übernehmen
        if (props.value) {
            var obj = JSON.parse(props.value);
            _this.state.lufttemperatur.ist = obj.temperatur && obj.temperatur.ist;
            _this.state.luftfeuchtigkeit.ist = obj.feuchtigkeit && obj.feuchtigkeit.ist;
            _this.state.umgebungsdruck.ist = obj.druck && obj.druck.ist;
        }
        return _this;
    }
    AgtPruefortParameter.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "pruefortparameter" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Min."),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Max."))),
                React.createElement("tbody", null,
                    this.state.lufttemperatur.render(),
                    this.state.luftfeuchtigkeit.render(),
                    this.state.umgebungsdruck.render()))));
    };
    AgtPruefortParameter = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AgtPruefortParameter);
    return AgtPruefortParameter;
}(React.Component));
exports.default = AgtPruefortParameter;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var numberformat_1 = __webpack_require__(56);
var BpsReferenzkraftGesamtBeurteilungMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftGesamtBeurteilungMesspunkt, _super);
    function BpsReferenzkraftGesamtBeurteilungMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftGesamtBeurteilungMesspunkt.prototype.render = function () {
        var messpunkt = this.props.messpunkt;
        var beurteilung = '-';
        var className = '';
        if (messpunkt.bewertung !== null) {
            beurteilung = messpunkt.bewertung ? 'i.O.' : 'n.i.O.';
            className = "beurteilung-" + beurteilung.replace(/\./g, '').toLowerCase();
        }
        return (React.createElement("tr", null,
            React.createElement("td", null, messpunkt.kraftstufe),
            React.createElement("td", null, messpunkt.absolut),
            React.createElement("td", null, messpunkt.relativ !== null ? numberformat_1.numberformat(messpunkt.relativ) : ''),
            React.createElement("td", null,
                React.createElement("div", { className: className }, beurteilung))));
    };
    return BpsReferenzkraftGesamtBeurteilungMesspunkt;
}(React.Component));
/** Komponente zum Anzeige der Gesamtbeurteilung der Messwerte (Abgleich Links/Rechts) für die Kalibrierung von Bremsprüfständen */
var BpsReferenzkraftGesamtBeurteilung = (function (_super) {
    __extends(BpsReferenzkraftGesamtBeurteilung, _super);
    function BpsReferenzkraftGesamtBeurteilung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftGesamtBeurteilung.prototype.render = function () {
        var header = 'Konformitätsbewertung - Abweichung Links/Rechts';
        if (this.props.nachJustage) {
            header += ' nach Justage';
        }
        if (this.props.ziel.length === 0) {
            return (React.createElement(react_bootstrap_1.Panel, { header: header, collapsible: true, defaultExpanded: true },
                React.createElement("div", null, "Es konnte noch kein Gesamtergebnis ermittelt werden")));
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: header, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-auswertung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Kraftstufe"),
                        React.createElement("th", null, "Abweichung [N]"),
                        React.createElement("th", null, "Abweichung [%]"),
                        React.createElement("th", { style: { width: '48px' } }))),
                React.createElement("tbody", null, this.props.ziel.map(function (mp, index) { return (React.createElement(BpsReferenzkraftGesamtBeurteilungMesspunkt, { messpunkt: mp, key: index })); })))));
    };
    BpsReferenzkraftGesamtBeurteilung = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftGesamtBeurteilung);
    return BpsReferenzkraftGesamtBeurteilung;
}(React.Component));
exports.default = BpsReferenzkraftGesamtBeurteilung;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes_1 = __webpack_require__(21);
var Callout_1 = __webpack_require__(16);
var decorators_1 = __webpack_require__(1);
var SesAuswertungFlaechenRili2014Store_1 = __webpack_require__(688);
var ApiStore_1 = __webpack_require__(13);
var VorgangStore_1 = __webpack_require__(22);
var UiStore_1 = __webpack_require__(14);
var SesAuswertungSystemneigung_1 = __webpack_require__(171);
var SesAuswertungFlaechenMesswertValidierung_1 = __webpack_require__(170);
/** Messwerteingabe und -auswertung für Scheinwerfer-Einstellprüfsysteme nach Richtlinie 2014 */
var SesAuswertungFlaechenRili2014 = (function (_super) {
    __extends(SesAuswertungFlaechenRili2014, _super);
    function SesAuswertungFlaechenRili2014() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maximaleSpurAnzahl = 0;
        _this.fahrzeugAusgefuellt = false;
        _this.sepAusgefuellt = false;
        return _this;
    }
    SesAuswertungFlaechenRili2014.prototype.componentWillMount = function () {
        this.store.eingabenLaden(this.props.vorgangId);
        this.store.setEditable(this.props.editable);
    };
    SesAuswertungFlaechenRili2014.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, auftrag, fahrzeugTypMeta;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.clear();
                        this.setAbfrageStatus('angefordert');
                        auftragId = this.props.auftragId;
                        return [4 /*yield*/, this.apiStore.auftragDetails(auftragId)];
                    case 1:
                        auftrag = _a.sent();
                        if (auftrag.ok) {
                            fahrzeugTypMeta = auftrag.json.meta.find(function (meta) { return meta.bezeichnung === ApiTypes_1.SES_TYP; });
                            if (fahrzeugTypMeta) {
                                this.handleSetFahrzeugTyp(fahrzeugTypMeta.inhalt);
                            }
                        }
                        this.setAbfrageStatus('abgeschlossen');
                        return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2014.prototype.setAbfrageStatus = function (status) {
        this.abfrageStatus = status;
    };
    SesAuswertungFlaechenRili2014.prototype.handleSetFahrzeugTyp = function (fahrzeugTyp) {
        this.store.messwerteFahrzeug.typ = fahrzeugTyp;
        this.setzeSpurAnzahl(fahrzeugTyp);
    };
    SesAuswertungFlaechenRili2014.prototype.handleAuswertungErzeugen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, messwerteFahrzeug, messung, error_1, response, downloadLink;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.vorgangId;
                        messwerteFahrzeug = this.store.messwerteFahrzeug;
                        if (!vorgangId) return [3 /*break*/, 7];
                        messung = {
                            messpunkte: messwerteFahrzeug.messpunkte,
                            messwerte: {
                                links: messwerteFahrzeug.messwerte.links,
                                rechts: messwerteFahrzeug.messwerte.rechts
                            },
                            fahrspur: messwerteFahrzeug.fahrspur,
                            flaeche: messwerteFahrzeug.flaeche,
                            typ: messwerteFahrzeug.typ,
                            sperrpunkte: [],
                            sperrflaechen: []
                        };
                        messung.messpunkte = messung.messpunkte.slice(0, this.maximaleSpurAnzahl);
                        messung.messwerte.links = messung.messwerte.links.slice(0, this.maximaleSpurAnzahl);
                        messung.messwerte.rechts = messung.messwerte.rechts.slice(0, this.maximaleSpurAnzahl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, messung, this.store.messwerteSep)];
                    case 2:
                        _a.sent();
                        console.log('Eingaben gespeichert');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('Eingaben konnten nicht zwischengespeichert werden');
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, this.apiStore.erzeugeMessergebnisAuswertung(vorgangId, messung, this.store.messwerteSep)];
                    case 5:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.apiStore.vorgangDokumentDownloadUrl(vorgangId, response.json.detail.entryid)];
                    case 6:
                        downloadLink = _a.sent();
                        window.open(downloadLink);
                        this.vorgangStore.loadVorgang(vorgangId);
                        if (this.props.onTriggerDocumentRefresh) {
                            this.props.onTriggerDocumentRefresh();
                        }
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2014.prototype.setzeSpurAnzahl = function (messTyp) {
        switch (messTyp) {
            case 'KRAD':
                this.maximaleSpurAnzahl = 4;
                break;
            case 'PKW':
                this.maximaleSpurAnzahl = 5;
                break;
            case 'LKW':
                this.maximaleSpurAnzahl = 7;
                break;
            default:
                this.maximaleSpurAnzahl = 0;
        }
    };
    SesAuswertungFlaechenRili2014.prototype.fahrzeugAusgefuelltHandler = function (wert) {
        this.fahrzeugAusgefuellt = wert;
        if (wert) {
            this.store.validateMesswerteDelayed('fahrzeug', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2014.prototype.sepAusgefuelltHandler = function (wert) {
        this.sepAusgefuellt = wert;
        if (wert) {
            this.store.validateMesswerteDelayed('sep', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2014.prototype.render = function () {
        var _this = this;
        var store = this.store;
        // Wenn die Auswertung read-only in einem abgeschlossenen Vorgang angezeigt werden soll, es aber keine gespeicherten Werte gibt (vor Einführung der Funktion) soll nichts angezeigt werden
        if (!this.store.editable && !this.store.gespeicherteEingabenVorhanden) {
            return React.createElement("div", null);
        }
        if (this.abfrageStatus !== 'abgeschlossen') {
            return React.createElement("div", { className: "maxwidth" }, "lade Messwerteingabe...");
        }
        if (this.maximaleSpurAnzahl === 0) {
            return (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Auswahl erforderlich!"),
                React.createElement("p", null,
                    "Bevor Sie fortfahren k\u00F6nnen, muss die ",
                    React.createElement("b", null, "Fahrzeugkategorie"),
                    " angegeben werden."),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "info", type: "submit", onClick: function () { return _this.uiStore.navigateTo("/auftrag/" + _this.props.auftragId + "/auftraggeber"); } }, "Fahrzeugkategorie \u00E4ndern"))));
        }
        return (React.createElement("div", { className: "auswertung-messwerte" },
            React.createElement(Aufstellflaeche, { aufstellflaechenTyp: "fahrzeug", messung: store.messwerteFahrzeug, beurteilungsErgebnis: store.beurteilungFahrzeug, maximaleSpurAnzahl: this.maximaleSpurAnzahl, vollstaendigAusgefuelltHandler: this.fahrzeugAusgefuelltHandler }),
            React.createElement(Aufstellflaeche, { aufstellflaechenTyp: "sep", beurteilungsErgebnis: store.beurteilungSep, messung: store.messwerteSep, maximaleSpurAnzahl: 11, vollstaendigAusgefuelltHandler: this.sepAusgefuelltHandler }),
            this.store.editable &&
                React.createElement(Callout_1.default, { bsStyle: "success" },
                    React.createElement("p", null, "Speichert die aktuell eingegebenen Daten. Bereits gespeicherte Daten k\u00F6nnen jederzeit, bis zum Erstellen der Auswertung, erg\u00E4nzt und korrigiert werden."),
                    React.createElement("div", { className: "text-right" },
                        this.store.zeitpunktGespeichert && React.createElement("span", { className: "text-hint-light" },
                            "Gespeichert am ",
                            this.store.zeitpunktGespeichert),
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function () { return _this.store.eingabenSpeichern(_this.props.vorgangId); } }, "Speichern"))),
            this.props.vorgangId && this.store.editable && ((this.fahrzeugAusgefuellt && this.sepAusgefuellt)
                ?
                    React.createElement("div", null,
                        React.createElement(SesAuswertungSystemneigung_1.default, { richtlinie: '2014', neigungenFZ: store.beurteilungFahrzeug.neigungen, neigungenSEP: store.beurteilungSep.neigungen, beurteilungFZ: store.beurteilungFahrzeug, beurteilungSEP: store.beurteilungSep }),
                        React.createElement(Callout_1.default, { bsStyle: "warning" },
                            React.createElement("h4", null,
                                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "warning-sign" }),
                                " Auswertung"),
                            React.createElement("p", null,
                                "Erzeugt auf Basis der Eingabedaten und errechneten Werte eine Auswertung der Fl\u00E4chen als PDF Dokument das im Vorgang hinterlegt wird.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Der Vorgang wird dadurch abgeschlossen, ein \u00C4ndern der Werte ist nachtr\u00E4glich nur \u00FCber einen Korrekturvorgang m\u00F6glich. Der Zugriff auf die erzeugte Auswertung als PDF ist weiterhin jederzeit m\u00F6glich."),
                            React.createElement("div", { className: "text-right" },
                                React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", type: "submit", onClick: this.handleAuswertungErzeugen }, "Auswertung erzeugen"))))
                :
                    React.createElement(Callout_1.default, { bsStyle: "danger" }, "Das Erzeugen der Auswertung ist erst m\u00F6glich wenn f\u00FCr beide Aufstellfl\u00E4chen alle ben\u00F6tigten Messwerte eingegeben wurden."))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store),
        __metadata("design:type", SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store)
    ], SesAuswertungFlaechenRili2014.prototype, "store", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungFlaechenRili2014.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], SesAuswertungFlaechenRili2014.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], SesAuswertungFlaechenRili2014.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], SesAuswertungFlaechenRili2014.prototype, "auswertungDownloadLink", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], SesAuswertungFlaechenRili2014.prototype, "maximaleSpurAnzahl", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2014.prototype, "fahrzeugAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2014.prototype, "sepAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2014.prototype, "abfrageStatus", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014.prototype, "setAbfrageStatus", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014.prototype, "handleSetFahrzeugTyp", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SesAuswertungFlaechenRili2014.prototype, "handleAuswertungErzeugen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014.prototype, "setzeSpurAnzahl", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014.prototype, "fahrzeugAusgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014.prototype, "sepAusgefuelltHandler", null);
    SesAuswertungFlaechenRili2014 = __decorate([
        mobx_react_1.observer
    ], SesAuswertungFlaechenRili2014);
    return SesAuswertungFlaechenRili2014;
}(React.Component));
exports.default = SesAuswertungFlaechenRili2014;
var Aufstellflaeche = (function (_super) {
    __extends(Aufstellflaeche, _super);
    function Aufstellflaeche() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messwerteAusgefuellt = false;
        _this.gesamtAusgefuellt = false;
        return _this;
    }
    Aufstellflaeche.prototype.setzeMesswerteAusgefuellt = function (wert) {
        this.messwerteAusgefuellt = wert;
        this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
    };
    Aufstellflaeche.prototype.setzeGesamtAusgefuellt = function (wert) {
        this.gesamtAusgefuellt = wert;
        this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
    };
    Aufstellflaeche.prototype.render = function () {
        var _a = this.props, aufstellflaechenTyp = _a.aufstellflaechenTyp, messung = _a.messung, beurteilungsErgebnis = _a.beurteilungsErgebnis;
        var label = '';
        var messunsicherheit;
        if (aufstellflaechenTyp === 'fahrzeug') {
            label = 'Messwerte: Fahrzeug-Aufstellfläche';
            if (messung.typ) {
                label += " " + messung.typ;
            }
            messunsicherheit = React.createElement("div", null,
                "Messunsicherheit U(k=2) = 0,3mm + 1 * 10",
                React.createElement("sup", null, "-4"),
                " * l");
        }
        else {
            label = 'Messwerte: SEP-Aufstellfläche';
            messunsicherheit = React.createElement("div", null, "Messunsicherheit U(k=2) = 0,15mm/m");
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: label, className: "messwerte-sep", collapsible: true, defaultExpanded: true, footer: (React.createElement("small", null, messunsicherheit)) },
            React.createElement(AufstellflaecheMesswerte, { messung: messung, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, maximaleSpurAnzahl: this.props.maximaleSpurAnzahl, vollstaendigAusgefuelltHandler: this.setzeMesswerteAusgefuellt }),
            React.createElement(AufstellflaecheGesamt, { fahrspur: messung.fahrspur, flaeche: messung.flaeche, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, vollstaendigAusgefuelltHandler: this.setzeGesamtAusgefuellt }),
            this.store.editable &&
                React.createElement(SesAuswertungFlaechenMesswertValidierung_1.default, { beurteilungsErgebnis: beurteilungsErgebnis, aufstellflaechenTyp: aufstellflaechenTyp, vollstaendigAusgefuellt: this.messwerteAusgefuellt && this.gesamtAusgefuellt })));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store),
        __metadata("design:type", SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store)
    ], Aufstellflaeche.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Aufstellflaeche.prototype, "messwerteAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Aufstellflaeche.prototype, "gesamtAusgefuellt", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Aufstellflaeche.prototype, "setzeMesswerteAusgefuellt", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Aufstellflaeche.prototype, "setzeGesamtAusgefuellt", null);
    Aufstellflaeche = __decorate([
        mobx_react_1.observer
    ], Aufstellflaeche);
    return Aufstellflaeche;
}(React.Component));
var AufstellflaecheMesswerte = (function (_super) {
    __extends(AufstellflaecheMesswerte, _super);
    function AufstellflaecheMesswerte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AufstellflaecheMesswerte.prototype.vollstaendigAusgefuellt = function () {
        var _this = this;
        var messung = this.props.messung;
        var ergebnis = (messung.messpunkte.length > 0) &&
            (messung.messpunkte.every(function (wert, index) { return (index >= _this.props.maximaleSpurAnzahl) || (wert !== ''); })) &&
            (messung.messpunkte.every(function (wert, index, werte) { return (index === 0) || (index >= _this.props.maximaleSpurAnzahl) || (parseFloat(wert) > parseFloat(werte[index - 1])); })) &&
            (messung.messwerte.links.every(function (wert, index) { return (index >= _this.props.maximaleSpurAnzahl) || (wert !== ''); })) &&
            (messung.messwerte.rechts.every(function (wert, index) { return (index >= _this.props.maximaleSpurAnzahl) || (wert !== ''); }));
        return ergebnis;
    };
    AufstellflaecheMesswerte.prototype.ausgefuelltHandler = function () {
        this.clearBeurteilung();
        var ergebnis = this.vollstaendigAusgefuellt();
        this.props.vollstaendigAusgefuelltHandler(ergebnis);
    };
    AufstellflaecheMesswerte.prototype.componentDidMount = function () {
        var ergebnis = this.vollstaendigAusgefuellt();
        if (ergebnis) {
            this.props.vollstaendigAusgefuelltHandler(ergebnis);
        }
    };
    AufstellflaecheMesswerte.prototype.clearBeurteilung = function () {
        this.props.beurteilungsErgebnis.beurteilung = [];
    };
    AufstellflaecheMesswerte.prototype.render = function () {
        var _a = this.props, aufstellflaechenTyp = _a.aufstellflaechenTyp, beurteilungsErgebnis = _a.beurteilungsErgebnis, messung = _a.messung;
        var spurMesspunkte = [];
        for (var i = 0; i < this.props.maximaleSpurAnzahl; i++) {
            spurMesspunkte.push(React.createElement(SpurMesspunkt, { key: i, index: i, labelLinks: "P" + i, labelRechts: "P" + (this.props.maximaleSpurAnzahl + i), messpunkte: messung.messpunkte, messwerte: messung.messwerte, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, onChange: this.ausgefuelltHandler }));
        }
        return (React.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, condensed: true, hover: true, className: "aufstellflaeche-punkte" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null,
                        "Abstand ",
                        React.createElement("small", null, "[mm]")),
                    React.createElement("th", null,
                        aufstellflaechenTyp === 'sep' ? 'Vordere' : 'Linke',
                        " Fahrspur H\u00F6hendiff. ",
                        React.createElement("small", null, "[mm]")),
                    React.createElement("th", null,
                        aufstellflaechenTyp === 'sep' ? 'Hintere' : 'Rechte',
                        " Fahrspur H\u00F6hendiff. ",
                        React.createElement("small", null, "[mm]")))),
            React.createElement("tbody", null, spurMesspunkte.map(function (punkt) { return punkt; }))));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheMesswerte.prototype, "ausgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheMesswerte.prototype, "clearBeurteilung", null);
    AufstellflaecheMesswerte = __decorate([
        mobx_react_1.observer
    ], AufstellflaecheMesswerte);
    return AufstellflaecheMesswerte;
}(React.Component));
var AufstellflaecheGesamt = (function (_super) {
    __extends(AufstellflaecheGesamt, _super);
    function AufstellflaecheGesamt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popoverErmittelteSteigung = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            "\u00DCbernimmt die automatisch anhand der Eingabewerte ermittelte mittlere ",
            _this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Längsneigung' : 'Querneigung',
            " als Steigung der Fl\u00E4che.",
            React.createElement("br", null),
            React.createElement("br", null),
            "Die automatische Ermittlung versucht eine Steigung zu errechnen bei der alle Werte innerhalb des Toleranzbereiches liegen."));
        _this.popoverSpurweite = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            "Tragen Sie hier die ",
            React.createElement("b", null, "gemessene Spurweite"),
            " der ",
            _this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Fahrzeug-Aufstellfläche' : 'SEP-Aufstellfläche',
            " ein.",
            _this.props.aufstellflaechenTyp === 'sep' ? React.createElement("span", null,
                React.createElement("br", null),
                React.createElement("br", null),
                "Die Spurweite der Aufstellfl\u00E4che muss ",
                React.createElement("b", null, "zwischen 400 und 1000 mm"),
                " liegen.") : ''));
        return _this;
    }
    AufstellflaecheGesamt.prototype.vollstandigAusgefuellt = function () {
        return (this.props.fahrspur.breite !== '') &&
            (parseInt(this.props.fahrspur.breite, 10) > 0) &&
            (this.props.fahrspur.laenge !== '') &&
            (parseInt(this.props.fahrspur.laenge, 10) > 0) &&
            (this.props.flaeche.steigung !== '');
    };
    AufstellflaecheGesamt.prototype.ubernehmeErmittelteSteigung = function () {
        if (this.props.beurteilungsErgebnis !== null) {
            this.props.flaeche.steigung = this.props.beurteilungsErgebnis.neigungen.ermittelt.toString();
            this.ausgefuelltHandler();
        }
    };
    AufstellflaecheGesamt.prototype.ausgefuelltHandler = function () {
        this.props.beurteilungsErgebnis.beurteilung = [];
        this.props.vollstaendigAusgefuelltHandler(this.vollstandigAusgefuellt());
    };
    AufstellflaecheGesamt.prototype.handleBreiteChanged = function (event) {
        var value = event.target.value;
        this.props.fahrspur.breite = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.handleLaengeChanged = function (event) {
        var value = event.target.value;
        this.props.fahrspur.laenge = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.handleSteigungChanged = function (event) {
        var value = event.target.value;
        this.props.flaeche.steigung = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.componentDidMount = function () {
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.render = function () {
        var laenge = this.props.fahrspur.laenge;
        var breite = this.props.fahrspur.breite;
        var steigung = this.props.flaeche.steigung;
        var optimaleNeigung = undefined;
        if (this.props.beurteilungsErgebnis) {
            optimaleNeigung = this.props.beurteilungsErgebnis.neigungen.ermittelt;
        }
        var validationStateSpurweite = undefined;
        if (((breite === '') || (parseInt(breite, 10) <= 0))) {
            validationStateSpurweite = 'warning';
        }
        // Wertebereich SEP-Aufstellfläche einschränken
        if (this.props.aufstellflaechenTyp === 'sep') {
            if ((parseInt(breite, 10) < 400) || (parseInt(breite, 10) > 1000)) {
                validationStateSpurweite = 'warning';
            }
        }
        return (React.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, condensed: true, hover: true, className: "aufstellflaeche-global" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Fahrspur"),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: validationStateSpurweite, controlId: 'breite' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "Spurweite")),
                                React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: this.popoverSpurweite },
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-fahrspurbreite", value: breite, onChange: this.handleBreiteChanged, readOnly: !this.store.editable })),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm"))))),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: ((laenge === '') || (parseInt(laenge, 10) <= 0)) ? 'warning' : undefined, controlId: 'laenge' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "L\u00E4nge")),
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: (this.props.aufstellflaechenTyp === 'sep') || !this.store.editable, step: "any", className: "input-fahrspurlaenge", value: laenge, onChange: this.handleLaengeChanged }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm")))))),
                React.createElement("tr", null,
                    React.createElement("th", null, "Steigung"),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: (steigung === '') ? 'warning' : undefined, controlId: 'steigung' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "Gemessen")),
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-flaechensteigung", value: steigung, onChange: this.handleSteigungChanged, readOnly: !this.store.editable }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm/m"))))),
                    React.createElement("td", null, this.store.editable &&
                        React.createElement(react_bootstrap_1.FormGroup, { controlId: 'steigung-optimal' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "Vorschlag")),
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-flaechensteigung", value: this.vollstandigAusgefuellt() ? optimaleNeigung : '', readOnly: true }),
                                React.createElement(react_bootstrap_1.InputGroup.Button, null,
                                    React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: this.popoverErmittelteSteigung },
                                        React.createElement(react_bootstrap_1.Button, { bsStyle: this.vollstandigAusgefuellt() ? 'success' : 'default', className: "btn-group", disabled: !this.vollstandigAusgefuellt(), onClick: this.ubernehmeErmittelteSteigung }, "\u00DCbernehmen"))))))))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store),
        __metadata("design:type", SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store)
    ], AufstellflaecheGesamt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "ubernehmeErmittelteSteigung", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "ausgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleBreiteChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleLaengeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleSteigungChanged", null);
    AufstellflaecheGesamt = __decorate([
        mobx_react_1.observer
    ], AufstellflaecheGesamt);
    return AufstellflaecheGesamt;
}(React.Component));
var SpurMesspunkt = (function (_super) {
    __extends(SpurMesspunkt, _super);
    function SpurMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpurMesspunkt.prototype.render = function () {
        var _a = this.props, index = _a.index, messpunkte = _a.messpunkte, messwerte = _a.messwerte, aufstellflaechenTyp = _a.aufstellflaechenTyp, beurteilungsErgebnis = _a.beurteilungsErgebnis, labelLinks = _a.labelLinks, labelRechts = _a.labelRechts;
        var beurteilungLinks;
        var beurteilungRechts;
        if (index < beurteilungsErgebnis.beurteilung.length && beurteilungsErgebnis.beurteilung[index]) {
            beurteilungLinks = beurteilungsErgebnis.beurteilung[index].links;
            beurteilungRechts = beurteilungsErgebnis.beurteilung[index].rechts;
        }
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(AbstandFeld, { values: messpunkte, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange })),
            React.createElement("td", null,
                React.createElement(HoehendifferenzFeld, { label: labelLinks, values: messwerte.links, beurteilung: beurteilungLinks, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange })),
            React.createElement("td", null,
                React.createElement(HoehendifferenzFeld, { label: labelRechts, values: messwerte.rechts, beurteilung: beurteilungRechts, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange }))));
    };
    SpurMesspunkt = __decorate([
        mobx_react_1.observer
    ], SpurMesspunkt);
    return SpurMesspunkt;
}(React.Component));
var AbstandFeld = (function (_super) {
    __extends(AbstandFeld, _super);
    function AbstandFeld() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstandFeld.prototype.handleValueChanged = function (event) {
        var _a = this.props, index = _a.index, values = _a.values;
        var value = event.target.value;
        values[index] = value;
        this.props.onChange();
    };
    AbstandFeld.prototype.render = function () {
        var _a = this.props, values = _a.values, index = _a.index, aufstellflaechenTyp = _a.aufstellflaechenTyp;
        var readOnly = (aufstellflaechenTyp === 'sep' || index === 0 || !this.store.editable);
        var validationState = undefined;
        if ((index > 0) && (parseFloat(values[index]) <= parseFloat(values[index - 1]))) {
            validationState = 'warning';
        }
        return (React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState },
            React.createElement(react_bootstrap_1.FormControl, { readOnly: readOnly, tabIndex: readOnly ? -1 : undefined, onChange: this.handleValueChanged, type: "number", step: "any", min: "0", className: "input-abstand", value: values[index] })));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store),
        __metadata("design:type", SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store)
    ], AbstandFeld.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AbstandFeld.prototype, "handleValueChanged", null);
    AbstandFeld = __decorate([
        mobx_react_1.observer
    ], AbstandFeld);
    return AbstandFeld;
}(React.Component));
var HoehendifferenzFeld = (function (_super) {
    __extends(HoehendifferenzFeld, _super);
    function HoehendifferenzFeld() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoehendifferenzFeld.prototype.handleValueChanged = function (event) {
        var _a = this.props, values = _a.values, index = _a.index;
        var value = event.target.value;
        values[index] = value;
        this.props.onChange();
    };
    HoehendifferenzFeld.prototype.render = function () {
        var _a = this.props, values = _a.values, index = _a.index, label = _a.label, beurteilung = _a.beurteilung, aufstellflaechenTyp = _a.aufstellflaechenTyp;
        var valueAtIndex = (index < values.length) ? values[index] : '';
        var validationState = undefined;
        if (valueAtIndex === '') {
            validationState = 'warning';
        }
        else if (beurteilung && !beurteilung.eingehalten) {
            validationState = 'error';
        }
        var id = aufstellflaechenTyp + "-" + label;
        return (React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState, controlId: id },
            React.createElement(react_bootstrap_1.InputGroup, null,
                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                    React.createElement(react_bootstrap_1.ControlLabel, null, label)),
                React.createElement(react_bootstrap_1.FormControl, { readOnly: label === 'P0' || !this.store.editable, type: "number", step: "any", onChange: this.handleValueChanged, className: "input-hoehendifferenz", value: valueAtIndex }))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store),
        __metadata("design:type", SesAuswertungFlaechenRili2014Store_1.SesAuswertungFlaechenRili2014Store)
    ], HoehendifferenzFeld.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HoehendifferenzFeld.prototype, "handleValueChanged", null);
    HoehendifferenzFeld = __decorate([
        mobx_react_1.observer
    ], HoehendifferenzFeld);
    return HoehendifferenzFeld;
}(React.Component));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes_1 = __webpack_require__(21);
var Callout_1 = __webpack_require__(16);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var VorgangStore_1 = __webpack_require__(22);
var UiStore_1 = __webpack_require__(14);
var SesAuswertungSystemneigung_1 = __webpack_require__(171);
var SesAuswertungFlaechenRili2018Store_1 = __webpack_require__(689);
var SesAuswertungFlaechenMesswertValidierung_1 = __webpack_require__(170);
/** Messwerteingabe und -auswertung für Scheinwerfer-Einstellprüfsysteme nach Richtlinie 2018 */
var SesAuswertungFlaechenRili2018 = (function (_super) {
    __extends(SesAuswertungFlaechenRili2018, _super);
    function SesAuswertungFlaechenRili2018() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maximaleSpurAnzahl = 0;
        _this.fahrzeugAusgefuellt = false;
        _this.sepAusgefuellt = false;
        return _this;
    }
    SesAuswertungFlaechenRili2018.prototype.componentWillMount = function () {
        this.store.eingabenLaden(this.props.vorgangId);
        this.store.setEditable(this.props.editable);
    };
    SesAuswertungFlaechenRili2018.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, auftrag, fahrzeugTypMeta;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.clear();
                        this.setAbfrageStatus('angefordert');
                        auftragId = this.props.auftragId;
                        return [4 /*yield*/, this.apiStore.auftragDetails(auftragId)];
                    case 1:
                        auftrag = _a.sent();
                        if (auftrag.ok) {
                            fahrzeugTypMeta = auftrag.json.meta.find(function (meta) { return meta.bezeichnung === ApiTypes_1.SES_TYP; });
                            if (fahrzeugTypMeta) {
                                this.handleSetFahrzeugTyp(fahrzeugTypMeta.inhalt);
                            }
                        }
                        this.setAbfrageStatus('abgeschlossen');
                        return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2018.prototype.setAbfrageStatus = function (status) {
        this.abfrageStatus = status;
    };
    SesAuswertungFlaechenRili2018.prototype.handleSetFahrzeugTyp = function (fahrzeugTyp) {
        this.store.messwerteFahrzeug.typ = fahrzeugTyp;
        this.setzeSpurAnzahl(fahrzeugTyp);
    };
    SesAuswertungFlaechenRili2018.prototype.handleAuswertungErzeugen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, messwerteFahrzeug, messung, error_1, response, downloadLink;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.vorgangId;
                        messwerteFahrzeug = this.store.messwerteFahrzeug;
                        if (!vorgangId) return [3 /*break*/, 7];
                        messung = {
                            messpunkte: messwerteFahrzeug.messpunkte,
                            messwerte: {
                                links: messwerteFahrzeug.messwerte.links,
                                rechts: messwerteFahrzeug.messwerte.rechts
                            },
                            fahrspur: messwerteFahrzeug.fahrspur,
                            flaeche: messwerteFahrzeug.flaeche,
                            typ: messwerteFahrzeug.typ,
                            sperrpunkte: messwerteFahrzeug.sperrpunkte,
                            sperrflaechen: []
                        };
                        messung.messpunkte = messung.messpunkte.slice(0, this.maximaleSpurAnzahl);
                        messung.messwerte.links = messung.messwerte.links.slice(0, this.maximaleSpurAnzahl);
                        messung.messwerte.rechts = messung.messwerte.rechts.slice(0, this.maximaleSpurAnzahl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, messung, this.store.messwerteSep)];
                    case 2:
                        _a.sent();
                        console.log('Eingaben gespeichert');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('Eingaben konnten nicht zwischengespeichert werden');
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, this.apiStore.erzeugeDokumentAuswertungRili2018(vorgangId, messung, this.store.messwerteSep)];
                    case 5:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.apiStore.vorgangDokumentDownloadUrl(vorgangId, response.json.detail.entryid)];
                    case 6:
                        downloadLink = _a.sent();
                        window.open(downloadLink);
                        this.vorgangStore.loadVorgang(vorgangId);
                        if (this.props.onTriggerDocumentRefresh) {
                            this.props.onTriggerDocumentRefresh();
                        }
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2018.prototype.setzeSpurAnzahl = function (messTyp) {
        // @todo: rework
        var laenge = 0;
        switch (messTyp) {
            case 'KRAD':
                laenge = 2500;
                this.maximaleSpurAnzahl = (2500 / this.store.messRaster) + 1;
                break;
            case 'PKW':
                laenge = 4000;
                this.maximaleSpurAnzahl = (4000 / this.store.messRaster) + 1;
                break;
            case 'LKW':
                laenge = 8000;
                break;
            default:
                laenge = 0;
                this.maximaleSpurAnzahl = 0;
        }
        if (laenge > 0) {
            this.maximaleSpurAnzahl = (laenge / this.store.messRaster) + 1;
            this.store.messwerteFahrzeug.fahrspur.laenge = laenge.toString();
        }
    };
    SesAuswertungFlaechenRili2018.prototype.fahrzeugAusgefuelltHandler = function (wert) {
        this.fahrzeugAusgefuellt = wert;
        if (wert) {
            this.store.validateMesswerteDelayed('fahrzeug', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2018.prototype.sepAusgefuelltHandler = function (wert) {
        this.sepAusgefuellt = wert;
        if (wert) {
            this.store.validateMesswerteDelayed('sep', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2018.prototype.render = function () {
        var _this = this;
        var store = this.store;
        // Wenn die Auswertung read-only in einem abgeschlossenen Vorgang angezeigt werden soll, es aber keine gespeicherten Werte gibt (vor Einführung der Funktion) soll nichts angezeigt werden
        if (!this.store.editable && !this.store.gespeicherteEingabenVorhanden) {
            return React.createElement("div", null);
        }
        if (this.abfrageStatus !== 'abgeschlossen') {
            return React.createElement("div", { className: "maxwidth" }, "lade Messwerteingabe...");
        }
        if (this.maximaleSpurAnzahl === 0) {
            return (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Auswahl erforderlich!"),
                React.createElement("p", null,
                    "Bevor Sie fortfahren k\u00F6nnen, muss die ",
                    React.createElement("b", null, "Fahrzeugkategorie"),
                    " angegeben werden."),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "info", type: "submit", onClick: function () { return _this.uiStore.navigateTo("/auftrag/" + _this.props.auftragId + "/auftraggeber"); } }, "Fahrzeugkategorie \u00E4ndern"))));
        }
        return (React.createElement("div", { className: "auswertung-messwerte" },
            React.createElement(Aufstellflaeche, { aufstellflaechenTyp: "fahrzeug", messung: store.messwerteFahrzeug, beurteilungsErgebnis: store.beurteilungFahrzeug, maximaleSpurAnzahl: this.maximaleSpurAnzahl, vollstaendigAusgefuelltHandler: this.fahrzeugAusgefuelltHandler }),
            React.createElement(Aufstellflaeche, { aufstellflaechenTyp: "sep", beurteilungsErgebnis: store.beurteilungSep, messung: store.messwerteSep, maximaleSpurAnzahl: 11, vollstaendigAusgefuelltHandler: this.sepAusgefuelltHandler }),
            this.store.editable &&
                React.createElement(Callout_1.default, { bsStyle: "success" },
                    React.createElement("p", null, "Speichert die aktuell eingegebenen Daten. Bereits gespeicherte Daten k\u00F6nnen jederzeit, bis zum Erstellen der Auswertung, erg\u00E4nzt und korrigiert werden."),
                    React.createElement("div", { className: "text-right" },
                        this.store.zeitpunktGespeichert && React.createElement("span", { className: "text-hint-light" },
                            "Gespeichert am ",
                            this.store.zeitpunktGespeichert),
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function () { return _this.store.eingabenSpeichern(_this.props.vorgangId); } }, "Speichern"))),
            this.props.vorgangId && this.store.editable && ((this.fahrzeugAusgefuellt && this.sepAusgefuellt)
                ?
                    React.createElement("div", null,
                        React.createElement(SesAuswertungSystemneigung_1.default, { richtlinie: '2018', neigungenFZ: store.beurteilungFahrzeug.neigungen, neigungenSEP: store.beurteilungSep.neigungen, beurteilungFZ: store.beurteilungFahrzeug, beurteilungSEP: store.beurteilungSep }),
                        React.createElement(Callout_1.default, { bsStyle: "warning" },
                            React.createElement("h4", null,
                                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "warning-sign" }),
                                " Auswertung"),
                            React.createElement("p", null,
                                "Erzeugt auf Basis der Eingabedaten und errechneten Werte eine Auswertung der Fl\u00E4chen als PDF Dokument das im Vorgang hinterlegt wird.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Der Vorgang wird dadurch abgeschlossen, ein \u00C4ndern der Werte ist nachtr\u00E4glich nur \u00FCber einen Korrekturvorgang m\u00F6glich. Der Zugriff auf die erzeugte Auswertung als PDF ist weiterhin jederzeit m\u00F6glich."),
                            React.createElement("div", { className: "text-right" },
                                React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", type: "submit", onClick: this.handleAuswertungErzeugen }, "Auswertung erzeugen"))))
                :
                    React.createElement(Callout_1.default, { bsStyle: "danger" }, "Das Erzeugen der Auswertung ist erst m\u00F6glich wenn f\u00FCr beide Aufstellfl\u00E4chen alle ben\u00F6tigten Messwerte eingegeben wurden."))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store),
        __metadata("design:type", SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store)
    ], SesAuswertungFlaechenRili2018.prototype, "store", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungFlaechenRili2018.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], SesAuswertungFlaechenRili2018.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], SesAuswertungFlaechenRili2018.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], SesAuswertungFlaechenRili2018.prototype, "auswertungDownloadLink", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], SesAuswertungFlaechenRili2018.prototype, "maximaleSpurAnzahl", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2018.prototype, "fahrzeugAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2018.prototype, "sepAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2018.prototype, "abfrageStatus", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018.prototype, "setAbfrageStatus", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018.prototype, "handleSetFahrzeugTyp", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SesAuswertungFlaechenRili2018.prototype, "handleAuswertungErzeugen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018.prototype, "setzeSpurAnzahl", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018.prototype, "fahrzeugAusgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018.prototype, "sepAusgefuelltHandler", null);
    SesAuswertungFlaechenRili2018 = __decorate([
        mobx_react_1.observer
    ], SesAuswertungFlaechenRili2018);
    return SesAuswertungFlaechenRili2018;
}(React.Component));
exports.default = SesAuswertungFlaechenRili2018;
var Aufstellflaeche = (function (_super) {
    __extends(Aufstellflaeche, _super);
    function Aufstellflaeche() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messwerteAusgefuellt = false;
        _this.gesamtAusgefuellt = false;
        return _this;
    }
    Aufstellflaeche.prototype.setzeMesswerteAusgefuellt = function (wert) {
        this.messwerteAusgefuellt = wert;
        this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
    };
    Aufstellflaeche.prototype.setzeGesamtAusgefuellt = function (wert) {
        this.gesamtAusgefuellt = wert;
        this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
    };
    Aufstellflaeche.prototype.render = function () {
        var _a = this.props, aufstellflaechenTyp = _a.aufstellflaechenTyp, messung = _a.messung, beurteilungsErgebnis = _a.beurteilungsErgebnis;
        var label = '';
        var messunsicherheit;
        if (aufstellflaechenTyp === 'fahrzeug') {
            label = 'Messwerte: Fahrzeug-Aufstellfläche';
            if (messung.typ) {
                label += " " + messung.typ;
            }
            messunsicherheit = React.createElement("div", null,
                "Messunsicherheit U(k=2) = 0,3mm + 1 * 10",
                React.createElement("sup", null, "-4"),
                " * l");
        }
        else {
            label = 'Messwerte: SEP-Aufstellfläche';
            messunsicherheit = React.createElement("div", null, "Messunsicherheit U(k=2) = 0,15mm/m");
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: label, className: "messwerte-sep", collapsible: true, defaultExpanded: true, footer: (React.createElement("small", null, messunsicherheit)) },
            React.createElement(AufstellflaecheMesswerte, { messung: messung, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, maximaleSpurAnzahl: this.props.maximaleSpurAnzahl, vollstaendigAusgefuelltHandler: this.setzeMesswerteAusgefuellt }),
            React.createElement(AufstellflaecheGesamt, { fahrspur: messung.fahrspur, flaeche: messung.flaeche, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, vollstaendigAusgefuelltHandler: this.setzeGesamtAusgefuellt }),
            this.store.editable &&
                React.createElement(SesAuswertungFlaechenMesswertValidierung_1.default, { beurteilungsErgebnis: beurteilungsErgebnis, aufstellflaechenTyp: aufstellflaechenTyp, vollstaendigAusgefuellt: this.messwerteAusgefuellt && this.gesamtAusgefuellt })));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store),
        __metadata("design:type", SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store)
    ], Aufstellflaeche.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Aufstellflaeche.prototype, "messwerteAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Aufstellflaeche.prototype, "gesamtAusgefuellt", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Aufstellflaeche.prototype, "setzeMesswerteAusgefuellt", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Aufstellflaeche.prototype, "setzeGesamtAusgefuellt", null);
    Aufstellflaeche = __decorate([
        mobx_react_1.observer
    ], Aufstellflaeche);
    return Aufstellflaeche;
}(React.Component));
var AufstellflaecheMesswerte = (function (_super) {
    __extends(AufstellflaecheMesswerte, _super);
    function AufstellflaecheMesswerte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AufstellflaecheMesswerte.prototype.vollstaendigAusgefuellt = function () {
        var _this = this;
        var messung = this.props.messung;
        var ergebnis = (messung.messpunkte.length > 0) &&
            (messung.messpunkte.every(function (wert, index) { return (index >= _this.props.maximaleSpurAnzahl) || (wert !== ''); })) &&
            (messung.messpunkte.every(function (wert, index, werte) { return (index === 0) || (index >= _this.props.maximaleSpurAnzahl) || (parseFloat(wert) > parseFloat(werte[index - 1])); })) &&
            (messung.messwerte.links.every(function (wert, index) { return (index >= _this.props.maximaleSpurAnzahl) || (wert !== '') || (messung.sperrpunkte[index] === true); })) &&
            (messung.messwerte.rechts.every(function (wert, index) { return (index >= _this.props.maximaleSpurAnzahl) || (wert !== '') || (messung.sperrpunkte[index] === true); }));
        return ergebnis;
    };
    AufstellflaecheMesswerte.prototype.ausgefuelltHandler = function () {
        this.clearBeurteilung();
        var ergebnis = this.vollstaendigAusgefuellt();
        this.props.vollstaendigAusgefuelltHandler(ergebnis);
    };
    AufstellflaecheMesswerte.prototype.componentDidMount = function () {
        var ergebnis = this.vollstaendigAusgefuellt();
        if (ergebnis) {
            this.props.vollstaendigAusgefuelltHandler(ergebnis);
        }
    };
    AufstellflaecheMesswerte.prototype.clearBeurteilung = function () {
        this.props.beurteilungsErgebnis.beurteilung = [];
    };
    AufstellflaecheMesswerte.prototype.render = function () {
        var _a = this.props, aufstellflaechenTyp = _a.aufstellflaechenTyp, beurteilungsErgebnis = _a.beurteilungsErgebnis, messung = _a.messung;
        var spurMesspunkte = [];
        for (var i = 0; i < this.props.maximaleSpurAnzahl; i++) {
            spurMesspunkte.push(React.createElement(SpurMesspunkt, { key: i, index: i, labelLinks: "P" + i, labelRechts: "P" + (this.props.maximaleSpurAnzahl + i), messpunkte: messung.messpunkte, messwerte: messung.messwerte, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, onChange: this.ausgefuelltHandler, sperrpunkte: messung.sperrpunkte }));
        }
        return (React.createElement(react_bootstrap_1.Table, { striped: false, bordered: true, condensed: true, hover: false, className: "aufstellflaeche-punkte" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { textAlign: 'center' } },
                        "Abstand ",
                        React.createElement("small", null, "[mm]")),
                    React.createElement("th", { style: { textAlign: 'center' } },
                        "H\u00F6hendifferenz",
                        React.createElement("br", null),
                        aufstellflaechenTyp === 'sep' ? 'Vordere' : 'Linke',
                        " Fahrspur ",
                        React.createElement("small", null, "[mm]")),
                    React.createElement("th", { style: { textAlign: 'center' } },
                        "H\u00F6hendifferenz",
                        React.createElement("br", null),
                        aufstellflaechenTyp === 'sep' ? 'Hintere' : 'Rechte',
                        " Fahrspur ",
                        React.createElement("small", null, "[mm]")),
                    aufstellflaechenTyp === 'fahrzeug' && React.createElement("th", null,
                        "Sperrfl\u00E4che",
                        React.createElement("br", null),
                        "vorhanden"))),
            React.createElement("tbody", null, spurMesspunkte.map(function (punkt) { return punkt; }))));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheMesswerte.prototype, "ausgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheMesswerte.prototype, "clearBeurteilung", null);
    AufstellflaecheMesswerte = __decorate([
        mobx_react_1.observer
    ], AufstellflaecheMesswerte);
    return AufstellflaecheMesswerte;
}(React.Component));
var AufstellflaecheGesamt = (function (_super) {
    __extends(AufstellflaecheGesamt, _super);
    function AufstellflaecheGesamt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popoverErmittelteSteigung = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            "\u00DCbernimmt die automatisch anhand der Eingabewerte ermittelte mittlere ",
            _this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Längsneigung' : 'Querneigung',
            " als Steigung der Fl\u00E4che.",
            React.createElement("br", null),
            React.createElement("br", null),
            "Die automatische Ermittlung versucht eine Steigung zu errechnen bei der alle Werte innerhalb des Toleranzbereiches liegen."));
        _this.popoverSpurweite = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            "Tragen Sie hier die ",
            React.createElement("b", null, "gemessene Spurweite"),
            " der ",
            _this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Fahrzeug-Aufstellfläche' : 'SEP-Aufstellfläche',
            " ein.",
            _this.props.aufstellflaechenTyp === 'sep' ? React.createElement("span", null,
                React.createElement("br", null),
                React.createElement("br", null),
                "Die Spurweite der Aufstellfl\u00E4che muss ",
                React.createElement("b", null, "zwischen 400 und 1000 mm"),
                " liegen.") : ''));
        return _this;
    }
    AufstellflaecheGesamt.prototype.vollstandigAusgefuellt = function () {
        var result = false;
        result = (this.props.fahrspur.breite !== '') && (parseInt(this.props.fahrspur.breite, 10) > 0) && (this.props.fahrspur.laenge !== '') && (parseInt(this.props.fahrspur.laenge, 10) > 0);
        if (this.props.aufstellflaechenTyp === 'sep') {
            result = result && (this.props.flaeche.steigung !== '');
        }
        return result;
    };
    AufstellflaecheGesamt.prototype.ubernehmeErmittelteSteigung = function () {
        if (this.props.beurteilungsErgebnis !== null) {
            this.props.flaeche.steigung = this.props.beurteilungsErgebnis.neigungen.ermittelt.toString();
            this.ausgefuelltHandler();
        }
    };
    AufstellflaecheGesamt.prototype.ausgefuelltHandler = function () {
        this.props.beurteilungsErgebnis.beurteilung = [];
        this.props.vollstaendigAusgefuelltHandler(this.vollstandigAusgefuellt());
    };
    AufstellflaecheGesamt.prototype.handleBreiteChanged = function (event) {
        var value = event.target.value;
        this.props.fahrspur.breite = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.handleLaengeChanged = function (event) {
        var value = event.target.value;
        this.props.fahrspur.laenge = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.handleSteigungChanged = function (event) {
        var value = event.target.value;
        this.props.flaeche.steigung = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.componentDidMount = function () {
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.render = function () {
        var laenge = this.props.fahrspur.laenge;
        var breite = this.props.fahrspur.breite;
        var steigung = this.props.flaeche.steigung;
        var optimaleNeigung = undefined;
        if (this.props.beurteilungsErgebnis) {
            optimaleNeigung = this.props.beurteilungsErgebnis.neigungen.ermittelt && this.props.beurteilungsErgebnis.neigungen.ermittelt;
        }
        var validationStateSpurweite = undefined;
        if (((breite === '') || (parseInt(breite, 10) <= 0))) {
            validationStateSpurweite = 'warning';
        }
        // Wertebereich SEP-Aufstellfläche einschränken
        if (this.props.aufstellflaechenTyp === 'sep') {
            if ((parseInt(breite, 10) < 400) || (parseInt(breite, 10) > 1000)) {
                validationStateSpurweite = 'warning';
            }
        }
        return (React.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, condensed: true, hover: true, className: "aufstellflaeche-global" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Fahrspur"),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: validationStateSpurweite, controlId: 'breite' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "Spurweite")),
                                React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: this.popoverSpurweite },
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-fahrspurbreite", value: breite, onChange: this.handleBreiteChanged, readOnly: !this.store.editable })),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm"))))),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: ((laenge === '') || (parseInt(laenge, 10) <= 0)) ? 'warning' : undefined, controlId: 'laenge' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "L\u00E4nge")),
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, step: "any", className: "input-fahrspurlaenge", value: laenge, onChange: this.handleLaengeChanged }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm")))))),
                this.props.aufstellflaechenTyp === 'sep' &&
                    React.createElement("tr", null,
                        React.createElement("th", null, "Steigung"),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.FormGroup, { validationState: (steigung === '') ? 'warning' : undefined, controlId: 'steigung' },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                        React.createElement(react_bootstrap_1.ControlLabel, null, "Gemessen")),
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-flaechensteigung", value: steigung, onChange: this.handleSteigungChanged, readOnly: !this.store.editable }),
                                    React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                        React.createElement("small", null, "mm/m"))))),
                        React.createElement("td", null, this.store.editable &&
                            React.createElement(react_bootstrap_1.FormGroup, { controlId: 'steigung-optimal' },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                        React.createElement(react_bootstrap_1.ControlLabel, null, "Vorschlag")),
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-flaechensteigung", value: this.vollstandigAusgefuellt() ? optimaleNeigung : '', readOnly: true }),
                                    React.createElement(react_bootstrap_1.InputGroup.Button, null,
                                        React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: this.popoverErmittelteSteigung },
                                            React.createElement(react_bootstrap_1.Button, { bsStyle: this.vollstandigAusgefuellt() ? 'success' : 'default', className: "btn-group", disabled: !this.vollstandigAusgefuellt(), onClick: this.ubernehmeErmittelteSteigung }, "\u00DCbernehmen"))))))))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store),
        __metadata("design:type", SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store)
    ], AufstellflaecheGesamt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "ubernehmeErmittelteSteigung", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "ausgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleBreiteChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleLaengeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleSteigungChanged", null);
    AufstellflaecheGesamt = __decorate([
        mobx_react_1.observer
    ], AufstellflaecheGesamt);
    return AufstellflaecheGesamt;
}(React.Component));
var SpurMesspunkt = (function (_super) {
    __extends(SpurMesspunkt, _super);
    function SpurMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpurMesspunkt.prototype.render = function () {
        var _a = this.props, index = _a.index, messpunkte = _a.messpunkte, messwerte = _a.messwerte, aufstellflaechenTyp = _a.aufstellflaechenTyp, beurteilungsErgebnis = _a.beurteilungsErgebnis, labelLinks = _a.labelLinks, labelRechts = _a.labelRechts, sperrpunkte = _a.sperrpunkte;
        var beurteilungLinks;
        var beurteilungRechts;
        if (index < beurteilungsErgebnis.beurteilung.length && beurteilungsErgebnis.beurteilung[index]) {
            beurteilungLinks = beurteilungsErgebnis.beurteilung[index].links;
            beurteilungRechts = beurteilungsErgebnis.beurteilung[index].rechts;
        }
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(AbstandFeld, { values: messpunkte, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange })),
            React.createElement("td", null,
                React.createElement(HoehendifferenzFeld, { label: labelLinks, values: messwerte.links, sperrpunkte: sperrpunkte, beurteilung: beurteilungLinks, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange })),
            React.createElement("td", null,
                React.createElement(HoehendifferenzFeld, { label: labelRechts, values: messwerte.rechts, sperrpunkte: sperrpunkte, beurteilung: beurteilungRechts, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange })),
            this.props.aufstellflaechenTyp === 'fahrzeug' && React.createElement("td", { style: { textAlign: 'center', verticalAlign: 'middle' } },
                React.createElement(SperrflaechenCheckbox, { abstand: parseInt(messpunkte[index], 10), sperrpunkte: sperrpunkte, messwerte: messwerte, index: index, onChange: this.props.onChange }))));
    };
    SpurMesspunkt = __decorate([
        mobx_react_1.observer
    ], SpurMesspunkt);
    return SpurMesspunkt;
}(React.Component));
var AbstandFeld = (function (_super) {
    __extends(AbstandFeld, _super);
    function AbstandFeld() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstandFeld.prototype.handleValueChanged = function (event) {
        var _a = this.props, index = _a.index, values = _a.values;
        var value = event.target.value;
        values[index] = value;
        this.props.onChange();
    };
    AbstandFeld.prototype.render = function () {
        var _a = this.props, values = _a.values, index = _a.index;
        var validationState = undefined;
        if ((index > 0) && (parseFloat(values[index]) <= parseFloat(values[index - 1]))) {
            validationState = 'warning';
        }
        return (React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState },
            React.createElement(react_bootstrap_1.FormControl, { readOnly: true, tabIndex: -1, onChange: this.handleValueChanged, type: "number", step: "any", min: "0", className: "input-abstand", value: values[index] })));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store),
        __metadata("design:type", SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store)
    ], AbstandFeld.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AbstandFeld.prototype, "handleValueChanged", null);
    AbstandFeld = __decorate([
        mobx_react_1.observer
    ], AbstandFeld);
    return AbstandFeld;
}(React.Component));
var HoehendifferenzFeld = (function (_super) {
    __extends(HoehendifferenzFeld, _super);
    function HoehendifferenzFeld() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoehendifferenzFeld.prototype.handleValueChanged = function (event) {
        var _a = this.props, values = _a.values, index = _a.index;
        var value = event.target.value;
        values[index] = value;
        this.props.onChange();
    };
    HoehendifferenzFeld.prototype.render = function () {
        var _a = this.props, values = _a.values, index = _a.index, label = _a.label, beurteilung = _a.beurteilung, aufstellflaechenTyp = _a.aufstellflaechenTyp, sperrpunkte = _a.sperrpunkte;
        // Nullpunkt und per Sperrfläche (Fahrzeug-Aufstellfläche) deaktivierte Messpunkte erfordern keine Eingabe
        var readOnly = label === 'P0' || !this.store.editable;
        if (aufstellflaechenTyp === 'fahrzeug') {
            readOnly = readOnly || (sperrpunkte[index] === true);
        }
        // Validierung nur bei Punkten die eingegeben werden müssen
        var validationState = undefined;
        var valueAtIndex = (index < values.length) ? values[index] : '';
        if (!readOnly) {
            if (valueAtIndex === '') {
                validationState = 'warning';
            }
            else if (beurteilung && !beurteilung.eingehalten) {
                validationState = 'error';
            }
        }
        else {
            if (beurteilung && !beurteilung.eingehalten) {
                validationState = 'error';
            }
        }
        var id = aufstellflaechenTyp + "-" + label;
        return (React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState, controlId: id },
            React.createElement(react_bootstrap_1.InputGroup, null,
                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                    React.createElement(react_bootstrap_1.ControlLabel, null, label)),
                React.createElement(react_bootstrap_1.FormControl, { readOnly: readOnly, type: "number", step: "any", onChange: this.handleValueChanged, className: "input-hoehendifferenz", value: valueAtIndex }))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store),
        __metadata("design:type", SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store)
    ], HoehendifferenzFeld.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HoehendifferenzFeld.prototype, "handleValueChanged", null);
    HoehendifferenzFeld = __decorate([
        mobx_react_1.observer
    ], HoehendifferenzFeld);
    return HoehendifferenzFeld;
}(React.Component));
/** Checkbox zum Markieren von Sperrflächen der Aufstellfläche */
var SperrflaechenCheckbox = (function (_super) {
    __extends(SperrflaechenCheckbox, _super);
    function SperrflaechenCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SperrflaechenCheckbox.prototype.handleValueChanged = function (event) {
        var _a = this.props, sperrpunkte = _a.sperrpunkte, messwerte = _a.messwerte, index = _a.index;
        sperrpunkte[index] = event.target.checked;
        // Wenn Messwerte eingegeben wurden, entfernen, da diese im Back-End bei der Berechnung interpoliert werden müssen
        if (messwerte.links[index] !== '') {
            messwerte.links[index] = '';
        }
        if (messwerte.rechts[index] !== '') {
            messwerte.rechts[index] = '';
        }
        this.props.onChange();
    };
    SperrflaechenCheckbox.prototype.render = function () {
        var _a = this.props, abstand = _a.abstand, sperrpunkte = _a.sperrpunkte, index = _a.index;
        // Sperrflächen sind nur zwischen 600 und 1900mm erlaubt
        var sperrflaecheErlaubt = (abstand >= 600) && (abstand <= 1900);
        return (sperrflaecheErlaubt ? (React.createElement(react_bootstrap_1.FormControl, { className: "checkbox-sperrpunkt", type: "checkbox", checked: sperrpunkte[index], onChange: this.handleValueChanged, disabled: !this.store.editable }))
            :
                null);
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store),
        __metadata("design:type", SesAuswertungFlaechenRili2018Store_1.SesAuswertungFlaechenRili2018Store)
    ], SperrflaechenCheckbox.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SperrflaechenCheckbox.prototype, "handleValueChanged", null);
    SperrflaechenCheckbox = __decorate([
        mobx_react_1.observer
    ], SperrflaechenCheckbox);
    return SperrflaechenCheckbox;
}(React.Component));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes_1 = __webpack_require__(21);
var Callout_1 = __webpack_require__(16);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var VorgangStore_1 = __webpack_require__(22);
var UiStore_1 = __webpack_require__(14);
var SesAuswertungSystemneigung_1 = __webpack_require__(171);
var SesAuswertungFlaechenRili2025Store_1 = __webpack_require__(285);
var SesAuswertungFlaechenMesswertValidierung_1 = __webpack_require__(170);
var SesAuswertungSperrflaechen_1 = __webpack_require__(684);
/** Messwerteingabe und -auswertung für Scheinwerfer-Einstellprüfsysteme nach Richtlinie 2018 mit Anpassungen aus dem Verkehrsblatt Mai 2025 */
var SesAuswertungFlaechenRili2025 = (function (_super) {
    __extends(SesAuswertungFlaechenRili2025, _super);
    function SesAuswertungFlaechenRili2025() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maximaleSpurAnzahl = 0;
        _this.fahrzeugAusgefuellt = false;
        _this.sepAusgefuellt = false;
        return _this;
    }
    SesAuswertungFlaechenRili2025.prototype.componentWillMount = function () {
        this.store.eingabenLaden(this.props.vorgangId);
        this.store.setEditable(this.props.editable);
    };
    SesAuswertungFlaechenRili2025.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, auftrag, fahrzeugTypMeta;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.clear();
                        this.setAbfrageStatus('angefordert');
                        auftragId = this.props.auftragId;
                        return [4 /*yield*/, this.apiStore.auftragDetails(auftragId)];
                    case 1:
                        auftrag = _a.sent();
                        if (auftrag.ok) {
                            fahrzeugTypMeta = auftrag.json.meta.find(function (meta) { return meta.bezeichnung === ApiTypes_1.SES_TYP; });
                            if (fahrzeugTypMeta) {
                                this.handleSetFahrzeugTyp(fahrzeugTypMeta.inhalt);
                            }
                        }
                        this.store.onSperrFlaecheGeaendert = this.sperrFlaecheGeandertHandler;
                        this.setAbfrageStatus('abgeschlossen');
                        return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2025.prototype.setAbfrageStatus = function (status) {
        this.abfrageStatus = status;
    };
    SesAuswertungFlaechenRili2025.prototype.handleSetFahrzeugTyp = function (fahrzeugTyp) {
        this.store.messwerteFahrzeug.typ = fahrzeugTyp;
        this.setzeSpurAnzahl(fahrzeugTyp);
    };
    SesAuswertungFlaechenRili2025.prototype.handleAuswertungErzeugen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, messwerteFahrzeug, messung, error_1, response, downloadLink;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.vorgangId;
                        messwerteFahrzeug = this.store.messwerteFahrzeug;
                        if (!vorgangId) return [3 /*break*/, 7];
                        messung = {
                            messpunkte: messwerteFahrzeug.messpunkte,
                            messwerte: {
                                links: messwerteFahrzeug.messwerte.links,
                                rechts: messwerteFahrzeug.messwerte.rechts
                            },
                            fahrspur: messwerteFahrzeug.fahrspur,
                            flaeche: messwerteFahrzeug.flaeche,
                            typ: messwerteFahrzeug.typ,
                            sperrpunkte: messwerteFahrzeug.sperrpunkte,
                            sperrflaechen: messwerteFahrzeug.sperrflaechen
                        };
                        messung.messpunkte = messung.messpunkte.slice(0, this.maximaleSpurAnzahl);
                        messung.messwerte.links = messung.messwerte.links.slice(0, this.maximaleSpurAnzahl);
                        messung.messwerte.rechts = messung.messwerte.rechts.slice(0, this.maximaleSpurAnzahl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, messung, this.store.messwerteSep)];
                    case 2:
                        _a.sent();
                        console.log('Eingaben gespeichert');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('Eingaben konnten nicht zwischengespeichert werden');
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, this.apiStore.erzeugeDokumentAuswertungRili2025(vorgangId, messung, this.store.messwerteSep)];
                    case 5:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.apiStore.vorgangDokumentDownloadUrl(vorgangId, response.json.detail.entryid)];
                    case 6:
                        downloadLink = _a.sent();
                        window.open(downloadLink);
                        this.vorgangStore.loadVorgang(vorgangId);
                        if (this.props.onTriggerDocumentRefresh) {
                            this.props.onTriggerDocumentRefresh();
                        }
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2025.prototype.setzeSpurAnzahl = function (messTyp) {
        var laenge = 0;
        switch (messTyp) {
            case 'KRAD':
                laenge = 2500;
                this.maximaleSpurAnzahl = (2500 / this.store.messRaster) + 1;
                break;
            case 'PKW':
                laenge = 4000;
                this.maximaleSpurAnzahl = (4000 / this.store.messRaster) + 1;
                break;
            case 'LKW':
                laenge = 8000;
                break;
            default:
                laenge = 0;
                this.maximaleSpurAnzahl = 0;
        }
        if (laenge > 0) {
            this.maximaleSpurAnzahl = (laenge / this.store.messRaster) + 1;
            this.store.messwerteFahrzeug.fahrspur.laenge = laenge.toString();
        }
    };
    SesAuswertungFlaechenRili2025.prototype.fahrzeugAusgefuelltHandler = function (wert) {
        this.fahrzeugAusgefuellt = wert;
        if (wert) {
            this.store.validateMesswerteDelayed('fahrzeug', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2025.prototype.sepAusgefuelltHandler = function (wert) {
        this.sepAusgefuellt = wert;
        if (wert) {
            this.store.validateMesswerteDelayed('sep', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2025.prototype.sperrFlaecheGeandertHandler = function () {
        // Die Auswertung muss neu erfolgen, wenn nach dem Ausfüllen aller Werte etwas an den Sperrflächen
        if (this.fahrzeugAusgefuellt) {
            this.store.validateMesswerteDelayed('fahrzeug', this.maximaleSpurAnzahl);
        }
    };
    SesAuswertungFlaechenRili2025.prototype.render = function () {
        var _this = this;
        var store = this.store;
        // Wenn die Auswertung read-only in einem abgeschlossenen Vorgang angezeigt werden soll, es aber keine gespeicherten Werte gibt (vor Einführung der Funktion) soll nichts angezeigt werden
        if (!this.store.editable && !this.store.gespeicherteEingabenVorhanden) {
            return React.createElement("div", null);
        }
        if (this.abfrageStatus !== 'abgeschlossen') {
            return React.createElement("div", { className: "maxwidth" }, "lade Messwerteingabe...");
        }
        if (this.maximaleSpurAnzahl === 0) {
            return (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Auswahl erforderlich!"),
                React.createElement("p", null,
                    "Bevor Sie fortfahren k\u00F6nnen, muss die ",
                    React.createElement("b", null, "Fahrzeugkategorie"),
                    " angegeben werden."),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "info", type: "submit", onClick: function () { return _this.uiStore.navigateTo("/auftrag/" + _this.props.auftragId + "/auftraggeber"); } }, "Fahrzeugkategorie \u00E4ndern"))));
        }
        return (React.createElement("div", { className: "auswertung-messwerte" },
            React.createElement(SesAuswertungSperrflaechen_1.default, null),
            React.createElement(Aufstellflaeche, { aufstellflaechenTyp: "fahrzeug", messung: store.messwerteFahrzeug, beurteilungsErgebnis: store.beurteilungFahrzeug, maximaleSpurAnzahl: this.maximaleSpurAnzahl, vollstaendigAusgefuelltHandler: this.fahrzeugAusgefuelltHandler }),
            React.createElement(Aufstellflaeche, { aufstellflaechenTyp: "sep", beurteilungsErgebnis: store.beurteilungSep, messung: store.messwerteSep, maximaleSpurAnzahl: 11, vollstaendigAusgefuelltHandler: this.sepAusgefuelltHandler }),
            this.store.editable &&
                React.createElement(Callout_1.default, { bsStyle: "success" },
                    React.createElement("p", null, "Speichert die aktuell eingegebenen Daten. Bereits gespeicherte Daten k\u00F6nnen jederzeit, bis zum Erstellen der Auswertung, erg\u00E4nzt und korrigiert werden."),
                    React.createElement("div", { className: "text-right" },
                        this.store.zeitpunktGespeichert && React.createElement("span", { className: "text-hint-light" },
                            "Gespeichert am ",
                            this.store.zeitpunktGespeichert),
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "success", onClick: function () { return _this.store.eingabenSpeichern(_this.props.vorgangId); } }, "Speichern"))),
            this.props.vorgangId && this.store.editable && ((this.fahrzeugAusgefuellt && this.sepAusgefuellt)
                ?
                    React.createElement("div", null,
                        React.createElement(SesAuswertungSystemneigung_1.default, { richtlinie: '2025', neigungenFZ: store.beurteilungFahrzeug.neigungen, neigungenSEP: store.beurteilungSep.neigungen, beurteilungFZ: store.beurteilungFahrzeug, beurteilungSEP: store.beurteilungSep }),
                        React.createElement(Callout_1.default, { bsStyle: "warning" },
                            React.createElement("h4", null,
                                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "warning-sign" }),
                                " Auswertung"),
                            React.createElement("p", null,
                                "Erzeugt auf Basis der Eingabedaten und errechneten Werte eine Auswertung der Fl\u00E4chen als PDF Dokument das im Vorgang hinterlegt wird.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Der Vorgang wird dadurch abgeschlossen, ein \u00C4ndern der Werte ist nachtr\u00E4glich nur \u00FCber einen Korrekturvorgang m\u00F6glich. Der Zugriff auf die erzeugte Auswertung als PDF ist weiterhin jederzeit m\u00F6glich."),
                            React.createElement("div", { className: "text-right" },
                                React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", type: "submit", onClick: this.handleAuswertungErzeugen }, "Auswertung erzeugen"))))
                :
                    React.createElement(Callout_1.default, { bsStyle: "danger" }, "Das Erzeugen der Auswertung ist erst m\u00F6glich wenn f\u00FCr beide Aufstellfl\u00E4chen alle ben\u00F6tigten Messwerte eingegeben wurden."))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], SesAuswertungFlaechenRili2025.prototype, "store", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungFlaechenRili2025.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], SesAuswertungFlaechenRili2025.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], SesAuswertungFlaechenRili2025.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], SesAuswertungFlaechenRili2025.prototype, "auswertungDownloadLink", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], SesAuswertungFlaechenRili2025.prototype, "maximaleSpurAnzahl", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2025.prototype, "fahrzeugAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2025.prototype, "sepAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2025.prototype, "abfrageStatus", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025.prototype, "setAbfrageStatus", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025.prototype, "handleSetFahrzeugTyp", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SesAuswertungFlaechenRili2025.prototype, "handleAuswertungErzeugen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025.prototype, "setzeSpurAnzahl", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025.prototype, "fahrzeugAusgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025.prototype, "sepAusgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025.prototype, "sperrFlaecheGeandertHandler", null);
    SesAuswertungFlaechenRili2025 = __decorate([
        mobx_react_1.observer
    ], SesAuswertungFlaechenRili2025);
    return SesAuswertungFlaechenRili2025;
}(React.Component));
exports.default = SesAuswertungFlaechenRili2025;
var Aufstellflaeche = (function (_super) {
    __extends(Aufstellflaeche, _super);
    function Aufstellflaeche() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messwerteAusgefuellt = false;
        _this.gesamtAusgefuellt = false;
        return _this;
    }
    Aufstellflaeche.prototype.setzeMesswerteAusgefuellt = function (wert) {
        this.messwerteAusgefuellt = wert;
        this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
    };
    Aufstellflaeche.prototype.setzeGesamtAusgefuellt = function (wert) {
        this.gesamtAusgefuellt = wert;
        this.props.vollstaendigAusgefuelltHandler(this.messwerteAusgefuellt && this.gesamtAusgefuellt);
    };
    Aufstellflaeche.prototype.render = function () {
        var _a = this.props, aufstellflaechenTyp = _a.aufstellflaechenTyp, messung = _a.messung, beurteilungsErgebnis = _a.beurteilungsErgebnis;
        var label = '';
        var messunsicherheit;
        if (aufstellflaechenTyp === 'fahrzeug') {
            label = 'Messwerte: Fahrzeug-Aufstellfläche';
            if (messung.typ) {
                label += " " + messung.typ;
            }
            messunsicherheit = React.createElement("div", null,
                "Messunsicherheit U(k=2) = 0,3mm + 1 * 10",
                React.createElement("sup", null, "-4"),
                " * l");
        }
        else {
            label = 'Messwerte: SEP-Aufstellfläche';
            messunsicherheit = React.createElement("div", null, "Messunsicherheit U(k=2) = 0,15mm/m");
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: label, className: "messwerte-sep", collapsible: true, defaultExpanded: true, footer: (React.createElement("small", null, messunsicherheit)) },
            React.createElement(AufstellflaecheMesswerte, { messung: messung, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, maximaleSpurAnzahl: this.props.maximaleSpurAnzahl, vollstaendigAusgefuelltHandler: this.setzeMesswerteAusgefuellt }),
            React.createElement(AufstellflaecheGesamt, { fahrspur: messung.fahrspur, flaeche: messung.flaeche, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, vollstaendigAusgefuelltHandler: this.setzeGesamtAusgefuellt }),
            this.store.editable &&
                React.createElement(SesAuswertungFlaechenMesswertValidierung_1.default, { beurteilungsErgebnis: beurteilungsErgebnis, aufstellflaechenTyp: aufstellflaechenTyp, vollstaendigAusgefuellt: this.messwerteAusgefuellt && this.gesamtAusgefuellt })));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], Aufstellflaeche.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Aufstellflaeche.prototype, "messwerteAusgefuellt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Aufstellflaeche.prototype, "gesamtAusgefuellt", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Aufstellflaeche.prototype, "setzeMesswerteAusgefuellt", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Aufstellflaeche.prototype, "setzeGesamtAusgefuellt", null);
    Aufstellflaeche = __decorate([
        mobx_react_1.observer
    ], Aufstellflaeche);
    return Aufstellflaeche;
}(React.Component));
var AufstellflaecheMesswerte = (function (_super) {
    __extends(AufstellflaecheMesswerte, _super);
    function AufstellflaecheMesswerte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AufstellflaecheMesswerte.prototype.vollstaendigAusgefuellt = function () {
        var messung = this.props.messung;
        var messwerte = messung.messwerte;
        var laenge = parseFloat(messung.fahrspur.laenge);
        for (var i = 0; i < messung.messpunkte.length; i++) {
            var messpunkt = messung.messpunkte[i];
            var abstand = parseFloat(messpunkt);
            if (abstand > laenge) {
                break;
            }
            // Messpunkte dürfen nicht von Kleinsteinbauten überdeckt sein
            for (var _i = 0, _a = messung.sperrflaechen; _i < _a.length; _i++) {
                var sperrflaeche = _a[_i];
                if (sperrflaeche.art === 'kleinsteinbau' && abstand >= sperrflaeche.start && abstand <= sperrflaeche.ende) {
                    return false;
                }
            }
            // Wenn der Messpunkt nicht in einer Sperrfläche liegt, müssen für beide Seiten Werte eingegeben werden
            var inSperrFlaeche = false;
            for (var _b = 0, _c = messung.sperrflaechen; _b < _c.length; _b++) {
                var sperrflaeche = _c[_b];
                if (sperrflaeche.art === 'sperrflaeche' && abstand >= sperrflaeche.start && abstand <= sperrflaeche.ende) {
                    inSperrFlaeche = true;
                    break;
                }
            }
            // Es müssen für alle Punkte die nicht in eine Sperrfläche fallen Messwerte eingetragen sein
            if ((!inSperrFlaeche) && (abstand > 0) && (messwerte.links[i] === '' || messwerte.rechts[i] === '')) {
                return false;
            }
        }
        return true;
    };
    AufstellflaecheMesswerte.prototype.ausgefuelltHandler = function () {
        this.clearBeurteilung();
        var ergebnis = this.vollstaendigAusgefuellt();
        this.props.vollstaendigAusgefuelltHandler(ergebnis);
    };
    AufstellflaecheMesswerte.prototype.componentDidMount = function () {
        var ergebnis = this.vollstaendigAusgefuellt();
        if (ergebnis) {
            this.props.vollstaendigAusgefuelltHandler(ergebnis);
        }
    };
    AufstellflaecheMesswerte.prototype.clearBeurteilung = function () {
        this.props.beurteilungsErgebnis.beurteilung = [];
    };
    AufstellflaecheMesswerte.prototype.render = function () {
        var _a = this.props, aufstellflaechenTyp = _a.aufstellflaechenTyp, beurteilungsErgebnis = _a.beurteilungsErgebnis, messung = _a.messung;
        var spurMesspunkte = [];
        for (var i = 0; i < this.props.maximaleSpurAnzahl; i++) {
            spurMesspunkte.push(React.createElement(SpurMesspunkt, { key: i, index: i, labelLinks: "P" + i, labelRechts: "P" + (this.props.maximaleSpurAnzahl + i), messpunkte: messung.messpunkte, messwerte: messung.messwerte, aufstellflaechenTyp: aufstellflaechenTyp, beurteilungsErgebnis: beurteilungsErgebnis, onChange: this.ausgefuelltHandler }));
        }
        return (React.createElement(react_bootstrap_1.Table, { striped: false, bordered: true, condensed: true, hover: false, className: "aufstellflaeche-punkte" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { textAlign: 'center' } },
                        "Abstand ",
                        React.createElement("small", null, "[mm]")),
                    React.createElement("th", { style: { textAlign: 'center' } },
                        "H\u00F6hendifferenz",
                        React.createElement("br", null),
                        aufstellflaechenTyp === 'sep' ? 'Vordere' : 'Linke',
                        " Fahrspur ",
                        React.createElement("small", null, "[mm]")),
                    React.createElement("th", { style: { textAlign: 'center' } },
                        "H\u00F6hendifferenz",
                        React.createElement("br", null),
                        aufstellflaechenTyp === 'sep' ? 'Hintere' : 'Rechte',
                        " Fahrspur ",
                        React.createElement("small", null, "[mm]")),
                    aufstellflaechenTyp === 'fahrzeug' && React.createElement("th", { style: { textAlign: 'center' } },
                        "In",
                        React.createElement("br", null),
                        "Sperrfl\u00E4che"))),
            React.createElement("tbody", null, spurMesspunkte.map(function (punkt) { return punkt; }))));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheMesswerte.prototype, "ausgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheMesswerte.prototype, "clearBeurteilung", null);
    AufstellflaecheMesswerte = __decorate([
        mobx_react_1.observer
    ], AufstellflaecheMesswerte);
    return AufstellflaecheMesswerte;
}(React.Component));
var AufstellflaecheGesamt = (function (_super) {
    __extends(AufstellflaecheGesamt, _super);
    function AufstellflaecheGesamt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popoverErmittelteSteigung = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            "\u00DCbernimmt die automatisch anhand der Eingabewerte ermittelte mittlere ",
            _this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Längsneigung' : 'Querneigung',
            " als Steigung der Fl\u00E4che.",
            React.createElement("br", null),
            React.createElement("br", null),
            "Die automatische Ermittlung versucht eine Steigung zu errechnen bei der alle Werte innerhalb des Toleranzbereiches liegen."));
        _this.popoverSpurweite = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            "Tragen Sie hier die ",
            React.createElement("b", null, "gemessene Spurweite"),
            " der ",
            _this.props.aufstellflaechenTyp === 'fahrzeug' ? 'Fahrzeug-Aufstellfläche' : 'SEP-Aufstellfläche',
            " ein.",
            _this.props.aufstellflaechenTyp === 'sep' ? React.createElement("span", null,
                React.createElement("br", null),
                React.createElement("br", null),
                "Die Spurweite der Aufstellfl\u00E4che muss ",
                React.createElement("b", null, "zwischen 400 und 1000 mm"),
                " liegen.") : ''));
        return _this;
    }
    AufstellflaecheGesamt.prototype.vollstandigAusgefuellt = function () {
        var result = false;
        result = (this.props.fahrspur.breite !== '') && (parseInt(this.props.fahrspur.breite, 10) > 0) && (this.props.fahrspur.laenge !== '') && (parseInt(this.props.fahrspur.laenge, 10) > 0);
        if (this.props.aufstellflaechenTyp === 'sep') {
            result = result && (this.props.flaeche.steigung !== '');
        }
        return result;
    };
    AufstellflaecheGesamt.prototype.ubernehmeErmittelteSteigung = function () {
        if (this.props.beurteilungsErgebnis !== null) {
            this.props.flaeche.steigung = this.props.beurteilungsErgebnis.neigungen.ermittelt.toString();
            this.ausgefuelltHandler();
        }
    };
    AufstellflaecheGesamt.prototype.ausgefuelltHandler = function () {
        this.props.beurteilungsErgebnis.beurteilung = [];
        this.props.vollstaendigAusgefuelltHandler(this.vollstandigAusgefuellt());
    };
    AufstellflaecheGesamt.prototype.handleBreiteChanged = function (event) {
        var value = event.target.value;
        this.props.fahrspur.breite = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.handleLaengeChanged = function (event) {
        var value = event.target.value;
        this.props.fahrspur.laenge = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.handleSteigungChanged = function (event) {
        var value = event.target.value;
        this.props.flaeche.steigung = value;
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.componentDidMount = function () {
        this.ausgefuelltHandler();
    };
    AufstellflaecheGesamt.prototype.render = function () {
        var laenge = this.props.fahrspur.laenge;
        var breite = this.props.fahrspur.breite;
        var steigung = this.props.flaeche.steigung;
        var optimaleNeigung = undefined;
        if (this.props.beurteilungsErgebnis) {
            optimaleNeigung = this.props.beurteilungsErgebnis.neigungen.ermittelt && this.props.beurteilungsErgebnis.neigungen.ermittelt;
        }
        var validationStateSpurweite = undefined;
        if (((breite === '') || (parseInt(breite, 10) <= 0))) {
            validationStateSpurweite = 'warning';
        }
        // Wertebereich SEP-Aufstellfläche einschränken
        if (this.props.aufstellflaechenTyp === 'sep') {
            if ((parseInt(breite, 10) < 400) || (parseInt(breite, 10) > 1000)) {
                validationStateSpurweite = 'warning';
            }
        }
        return (React.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, condensed: true, hover: true, className: "aufstellflaeche-global" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Fahrspur"),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: validationStateSpurweite, controlId: 'breite' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "Spurweite")),
                                React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: this.popoverSpurweite },
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-fahrspurbreite", value: breite, onChange: this.handleBreiteChanged, readOnly: !this.store.editable })),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm"))))),
                    React.createElement("td", null,
                        React.createElement(react_bootstrap_1.FormGroup, { validationState: ((laenge === '') || (parseInt(laenge, 10) <= 0)) ? 'warning' : undefined, controlId: 'laenge' },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                    React.createElement(react_bootstrap_1.ControlLabel, null, "L\u00E4nge")),
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, step: "any", className: "input-fahrspurlaenge", value: laenge, onChange: this.handleLaengeChanged }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                    React.createElement("small", null, "mm")))))),
                this.props.aufstellflaechenTyp === 'sep' &&
                    React.createElement("tr", null,
                        React.createElement("th", null, "Steigung"),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.FormGroup, { validationState: (steigung === '') ? 'warning' : undefined, controlId: 'steigung' },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                        React.createElement(react_bootstrap_1.ControlLabel, null, "Gemessen")),
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-flaechensteigung", value: steigung, onChange: this.handleSteigungChanged, readOnly: !this.store.editable }),
                                    React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { width: '62px' } },
                                        React.createElement("small", null, "mm/m"))))),
                        React.createElement("td", null, this.store.editable &&
                            React.createElement(react_bootstrap_1.FormGroup, { controlId: 'steigung-optimal' },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                        React.createElement(react_bootstrap_1.ControlLabel, null, "Vorschlag")),
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-flaechensteigung", value: this.vollstandigAusgefuellt() ? optimaleNeigung : '', readOnly: true }),
                                    React.createElement(react_bootstrap_1.InputGroup.Button, null,
                                        React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: this.popoverErmittelteSteigung },
                                            React.createElement(react_bootstrap_1.Button, { bsStyle: this.vollstandigAusgefuellt() ? 'success' : 'default', className: "btn-group", disabled: !this.vollstandigAusgefuellt(), onClick: this.ubernehmeErmittelteSteigung }, "\u00DCbernehmen"))))))))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], AufstellflaecheGesamt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "ubernehmeErmittelteSteigung", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "ausgefuelltHandler", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleBreiteChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleLaengeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AufstellflaecheGesamt.prototype, "handleSteigungChanged", null);
    AufstellflaecheGesamt = __decorate([
        mobx_react_1.observer
    ], AufstellflaecheGesamt);
    return AufstellflaecheGesamt;
}(React.Component));
var SpurMesspunkt = (function (_super) {
    __extends(SpurMesspunkt, _super);
    function SpurMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpurMesspunkt.prototype.render = function () {
        var _a = this.props, index = _a.index, messpunkte = _a.messpunkte, messwerte = _a.messwerte, aufstellflaechenTyp = _a.aufstellflaechenTyp, beurteilungsErgebnis = _a.beurteilungsErgebnis, labelLinks = _a.labelLinks, labelRechts = _a.labelRechts;
        var beurteilungLinks;
        var beurteilungRechts;
        if (index < beurteilungsErgebnis.beurteilung.length && beurteilungsErgebnis.beurteilung[index]) {
            beurteilungLinks = beurteilungsErgebnis.beurteilung[index].links;
            beurteilungRechts = beurteilungsErgebnis.beurteilung[index].rechts;
        }
        // Bei Fahrzeugaufstellflächen dürfen Messpunkte nicht auf einer Sperrfläche liegen
        // Dies soll anhand der dynamische Eingabe der Sperrflächen in Echtzeit visualisiert werden
        var inSperrFlaeche = false;
        if (aufstellflaechenTyp === 'fahrzeug') {
            var abstand = parseInt(messpunkte[index], 10);
            inSperrFlaeche = this.store.inSperrFlaeche(abstand);
        }
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(AbstandFeld, { values: messpunkte, index: index, aufstellflaechenTyp: aufstellflaechenTyp, onChange: this.props.onChange })),
            React.createElement("td", null,
                React.createElement(HoehendifferenzFeld, { label: labelLinks, values: messwerte.links, beurteilung: beurteilungLinks, index: index, aufstellflaechenTyp: aufstellflaechenTyp, readonly: inSperrFlaeche, onChange: this.props.onChange })),
            React.createElement("td", null,
                React.createElement(HoehendifferenzFeld, { label: labelRechts, values: messwerte.rechts, beurteilung: beurteilungRechts, index: index, aufstellflaechenTyp: aufstellflaechenTyp, readonly: inSperrFlaeche, onChange: this.props.onChange })),
            this.props.aufstellflaechenTyp === 'fahrzeug' && React.createElement("td", { style: { textAlign: 'center', verticalAlign: 'middle' } }, inSperrFlaeche ? '✔' : null)));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], SpurMesspunkt.prototype, "store", void 0);
    SpurMesspunkt = __decorate([
        mobx_react_1.observer
    ], SpurMesspunkt);
    return SpurMesspunkt;
}(React.Component));
var AbstandFeld = (function (_super) {
    __extends(AbstandFeld, _super);
    function AbstandFeld() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstandFeld.prototype.handleValueChanged = function (event) {
        var _a = this.props, index = _a.index, values = _a.values;
        var value = event.target.value;
        values[index] = value;
        this.props.onChange();
    };
    AbstandFeld.prototype.render = function () {
        var _a = this.props, values = _a.values, index = _a.index;
        var validationState = undefined;
        if ((index > 0) && (parseFloat(values[index]) <= parseFloat(values[index - 1]))) {
            validationState = 'warning';
        }
        return (React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState },
            React.createElement(react_bootstrap_1.FormControl, { readOnly: true, tabIndex: -1, onChange: this.handleValueChanged, type: "number", step: "any", min: "0", className: "input-abstand", value: values[index] })));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], AbstandFeld.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AbstandFeld.prototype, "handleValueChanged", null);
    AbstandFeld = __decorate([
        mobx_react_1.observer
    ], AbstandFeld);
    return AbstandFeld;
}(React.Component));
var HoehendifferenzFeld = (function (_super) {
    __extends(HoehendifferenzFeld, _super);
    function HoehendifferenzFeld() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoehendifferenzFeld.prototype.handleValueChanged = function (event) {
        var _a = this.props, values = _a.values, index = _a.index;
        var value = event.target.value;
        values[index] = value;
        this.props.onChange();
    };
    HoehendifferenzFeld.prototype.render = function () {
        var _a = this.props, values = _a.values, index = _a.index, label = _a.label, beurteilung = _a.beurteilung, aufstellflaechenTyp = _a.aufstellflaechenTyp;
        // Nullpunkt und per Sperrfläche (Fahrzeug-Aufstellfläche) deaktivierte Messpunkte erfordern keine Eingabe
        var readOnly = label === 'P0' || !this.store.editable;
        if (!readOnly) {
            readOnly = this.props.readonly;
        }
        // Validierung nur bei Punkten die eingegeben werden müssen
        var validationState = undefined;
        var valueAtIndex = (index < values.length) ? values[index] : '';
        if (!readOnly) {
            if (valueAtIndex === '') {
                validationState = 'warning';
            }
            else if (beurteilung && !beurteilung.eingehalten) {
                validationState = 'error';
            }
        }
        else {
            if (beurteilung && !beurteilung.eingehalten) {
                validationState = 'error';
            }
        }
        var id = aufstellflaechenTyp + "-" + label;
        return (React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState, controlId: id },
            React.createElement(react_bootstrap_1.InputGroup, null,
                React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                    React.createElement(react_bootstrap_1.ControlLabel, null, label)),
                React.createElement(react_bootstrap_1.FormControl, { readOnly: readOnly, type: "number", step: "any", onChange: this.handleValueChanged, className: "input-hoehendifferenz", value: valueAtIndex }))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], HoehendifferenzFeld.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HoehendifferenzFeld.prototype, "handleValueChanged", null);
    HoehendifferenzFeld = __decorate([
        mobx_react_1.observer
    ], HoehendifferenzFeld);
    return HoehendifferenzFeld;
}(React.Component));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BpsArt;
(function (BpsArt) {
    BpsArt["Rolle"] = "rolle";
    BpsArt["Platte"] = "platte";
})(BpsArt = exports.BpsArt || (exports.BpsArt = {}));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BpsArt;
(function (BpsArt) {
    BpsArt["Rolle"] = "rolle";
    BpsArt["Platte"] = "platte";
})(BpsArt = exports.BpsArt || (exports.BpsArt = {}));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Singleton für globale Eigenschaften zur AGT Opazimeter Kalibrierung
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var KalibrierungStore_1 = __webpack_require__(173);
var AgtOpazimeterKalibrierungStore = (function (_super) {
    __extends(AgtOpazimeterKalibrierungStore, _super);
    function AgtOpazimeterKalibrierungStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messunsicherheitAnwenden = false;
        _this.eingabeKorrigierterKoeffizient = false;
        _this.objektVorlage = undefined;
        _this.justage = false;
        return _this;
    }
    AgtOpazimeterKalibrierungStore_1 = AgtOpazimeterKalibrierungStore;
    AgtOpazimeterKalibrierungStore.prototype.setMessunsicherheitAnwenden = function (value) {
        this.messunsicherheitAnwenden = value;
    };
    AgtOpazimeterKalibrierungStore.prototype.setEingabeKorrigierterKoeffizient = function (value) {
        this.eingabeKorrigierterKoeffizient = value;
    };
    AgtOpazimeterKalibrierungStore.prototype.setObjektVorlage = function (value) {
        this.objektVorlage = value;
    };
    AgtOpazimeterKalibrierungStore.prototype.setJustage = function (value) {
        this.justage = value;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AgtOpazimeterKalibrierungStore.prototype, "messunsicherheitAnwenden", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AgtOpazimeterKalibrierungStore.prototype, "eingabeKorrigierterKoeffizient", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtOpazimeterKalibrierungStore.prototype, "objektVorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AgtOpazimeterKalibrierungStore.prototype, "justage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierungStore.prototype, "setMessunsicherheitAnwenden", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierungStore.prototype, "setEingabeKorrigierterKoeffizient", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierungStore.prototype, "setObjektVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierungStore.prototype, "setJustage", null);
    AgtOpazimeterKalibrierungStore = AgtOpazimeterKalibrierungStore_1 = __decorate([
        decorators_1.provideSingleton(AgtOpazimeterKalibrierungStore_1)
    ], AgtOpazimeterKalibrierungStore);
    return AgtOpazimeterKalibrierungStore;
    var AgtOpazimeterKalibrierungStore_1;
}(KalibrierungStore_1.KalibrierungStore));
exports.AgtOpazimeterKalibrierungStore = AgtOpazimeterKalibrierungStore;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var AuftragStore_1 = __webpack_require__(25);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var ApiTypeFactory = __webpack_require__(54);
var KalibrierungStore_1 = __webpack_require__(173);
/** Singleton für globale Eigenschaften zur Kalibrierung eines Partikelzählers */
var AgtPartikelzaehlerKalibrierungStore = (function (_super) {
    __extends(AgtPartikelzaehlerKalibrierungStore, _super);
    function AgtPartikelzaehlerKalibrierungStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.datensatz = ApiTypeFactory.leererDatensatzAgtPartikelzaehlerMessung();
        _this.objektVorlage = undefined;
        _this.normale = undefined;
        return _this;
    }
    AgtPartikelzaehlerKalibrierungStore_1 = AgtPartikelzaehlerKalibrierungStore;
    AgtPartikelzaehlerKalibrierungStore.prototype.clear = function () {
        this.datensatz = ApiTypeFactory.leererDatensatzAgtPartikelzaehlerMessung();
    };
    AgtPartikelzaehlerKalibrierungStore.prototype.setJustage = function (value) {
        this.datensatz.justage = value;
    };
    AgtPartikelzaehlerKalibrierungStore.prototype.setObjektVorlage = function (value) {
        this.objektVorlage = value;
    };
    AgtPartikelzaehlerKalibrierungStore.prototype.setObjekt = function (value) {
        if (value !== undefined) {
            this.datensatz.objekt = value.objektguid;
        }
        else {
            this.datensatz.objekt = '';
        }
    };
    /** Setzt das übergebene Arbeitsmittel als zu verwendende Normale */
    AgtPartikelzaehlerKalibrierungStore.prototype.setNormale = function (arbeitsmittel) {
        this.normale = arbeitsmittel;
        if (arbeitsmittel !== undefined) {
            this.datensatz.pck = arbeitsmittel.arbeitsmittelguid;
        }
        else {
            this.datensatz.pck = '';
        }
    };
    /** Übernimmt bereits gespeicherte Daten in den Datensatz des Stores */
    AgtPartikelzaehlerKalibrierungStore.prototype.setMesswerte = function (value) {
        var datensatz = this.datensatz;
        // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
        // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
        if (value.version) {
            datensatz.version = value.version;
        }
        if (value.pruefortparameter) {
            if (value.pruefortparameter.beginn) {
                datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn;
            }
            if (value.pruefortparameter.ende) {
                datensatz.pruefortparameter.ende = value.pruefortparameter.ende;
            }
        }
        if (value.justage) {
            datensatz.justage = value.justage;
        }
        if (value.messreihen) {
            datensatz.messreihen = value.messreihen;
        }
        if (value.messreihenJustage) {
            datensatz.messreihenJustage = value.messreihenJustage;
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "datensatz", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "objektVorlage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "normale", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "setJustage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "setObjektVorlage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "setObjekt", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "setNormale", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierungStore.prototype, "setMesswerte", null);
    AgtPartikelzaehlerKalibrierungStore = AgtPartikelzaehlerKalibrierungStore_1 = __decorate([
        decorators_1.provideSingleton(AgtPartikelzaehlerKalibrierungStore_1)
    ], AgtPartikelzaehlerKalibrierungStore);
    return AgtPartikelzaehlerKalibrierungStore;
    var AgtPartikelzaehlerKalibrierungStore_1;
}(KalibrierungStore_1.KalibrierungStore));
exports.AgtPartikelzaehlerKalibrierungStore = AgtPartikelzaehlerKalibrierungStore;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var round_1 = __webpack_require__(33);
var ApiTypeFactory = __webpack_require__(54);
var ApiTypes = __webpack_require__(687);
/** Singleton für globale Eigenschaften zur Kalibrierung von Druckmessgeräten */
var DmgKalibrierungStore = (function () {
    function DmgKalibrierungStore() {
        this.readOnly = false;
        this.datensatz = ApiTypeFactory.leererDatensatzDmgKalibrierung();
    }
    DmgKalibrierungStore_1 = DmgKalibrierungStore;
    DmgKalibrierungStore.prototype.clear = function () {
        this.datensatz = ApiTypeFactory.leererDatensatzDmgKalibrierung();
    };
    /** Schaltet den Store und alle damit verbundenen Eingaben in den Nur-Lesen Modus */
    DmgKalibrierungStore.prototype.setReadOnly = function (value) {
        this.readOnly = value;
    };
    /** Übernimmt bereits gespeicherte Werte wieder in die Eingabe */
    DmgKalibrierungStore.prototype.setMesswerte = function (value) {
        var datensatz = this.datensatz;
        // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
        // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
        if (value.version) {
            datensatz.version = value.version;
        }
        if (value.haltezeiteingehalten) {
            datensatz.haltezeiteingehalten = value.haltezeiteingehalten;
        }
        if (value.vorbelastungbisendwert) {
            datensatz.vorbelastungbisendwert = value.vorbelastungbisendwert;
        }
        if (value.zeigerart) {
            datensatz.zeigerart = value.zeigerart;
        }
        if (value.pruefortparameter) {
            if (value.pruefortparameter.beginn) {
                datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn;
            }
            if (value.pruefortparameter.ende) {
                datensatz.pruefortparameter.ende = value.pruefortparameter.ende;
            }
        }
        if (value.messpunkte) {
            datensatz.messpunkte = value.messpunkte;
        }
        if (value.kalibrierbereich) {
            datensatz.kalibrierbereich = value.kalibrierbereich;
        }
    };
    DmgKalibrierungStore.prototype.setHalteZeitEingehalten = function (value) {
        this.datensatz.haltezeiteingehalten = value;
    };
    DmgKalibrierungStore.prototype.setVorbelastungBisEndwert = function (value) {
        this.datensatz.vorbelastungbisendwert = value;
    };
    /** Passt den Kalibrierbereich für die Auswertung an, der u.a. die Anzahl der Messpunkte vorgibt */
    DmgKalibrierungStore.prototype.setKalibrierbereich = function (von, bis) {
        this.datensatz.kalibrierbereich.von = von;
        this.datensatz.kalibrierbereich.bis = bis;
        if (von === null || bis === null) {
            return;
        }
        // Der gewählte Kalibrierbereich definiert die Anzahl der Schritte und die Schrittweite aus denen die Messpunkte erzeugt werden
        var schritte = (round_1.round(bis, 0) % 4) === 0 ? 5 : 6;
        var schrittweite = round_1.round(bis, 0) / (schritte - 1);
        if (schritte > this.datensatz.messpunkte.length) {
            for (var i = this.datensatz.messpunkte.length; i < schritte; i++) {
                var mp = ApiTypeFactory.leererDmgMesspunkt();
                mp.index = i + 1;
                this.datensatz.messpunkte.push(mp);
            }
        }
        if (schritte < this.datensatz.messpunkte.length) {
            this.datensatz.messpunkte = this.datensatz.messpunkte.slice(0, schritte);
        }
        // Nenndrücke berechnen
        for (var i = 0; i < this.datensatz.messpunkte.length; i++) {
            var mp = this.datensatz.messpunkte[i];
            mp.index = i + 1;
            mp.nenndruck = round_1.round(i * schrittweite, 1);
            if (i === schritte - 1) {
                // Letzten Messpunkt auf Ende des Kalibrierbereichs deckeln
                mp.nenndruck = round_1.round(bis, 1);
            }
        }
        // Bereits eingegebene Messwerte löschen
        for (var i = 0; i < this.datensatz.messpunkte.length; i++) {
            this.datensatz.messpunkte[i].m1.normal = null;
            this.datensatz.messpunkte[i].m2.normal = null;
            this.datensatz.messpunkte[i].m1.anzeige = null;
            this.datensatz.messpunkte[i].m2.anzeige = null;
        }
    };
    DmgKalibrierungStore.prototype.setZeigerArt = function (value) {
        this.datensatz.zeigerart = value;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], DmgKalibrierungStore.prototype, "readOnly", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DmgKalibrierungStore.prototype, "datensatz", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "setReadOnly", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "setMesswerte", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "setHalteZeitEingehalten", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "setVorbelastungBisEndwert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "setKalibrierbereich", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungStore.prototype, "setZeigerArt", null);
    DmgKalibrierungStore = DmgKalibrierungStore_1 = __decorate([
        decorators_1.provideSingleton(DmgKalibrierungStore_1)
    ], DmgKalibrierungStore);
    return DmgKalibrierungStore;
    var DmgKalibrierungStore_1;
}());
exports.DmgKalibrierungStore = DmgKalibrierungStore;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var SesAuswertungFlaechenRili2025Store = (function () {
    function SesAuswertungFlaechenRili2025Store() {
        this.messRaster = 250;
        this.messwerteFahrzeug = {
            messpunkte: [],
            sperrpunkte: [],
            sperrflaechen: [],
            messwerte: {
                links: [],
                rechts: []
            },
            fahrspur: {
                breite: '',
                laenge: ''
            },
            flaeche: {
                steigung: '',
                achsenabschnitt: '0'
            },
            typ: undefined
        };
        this.messwerteSep = {
            messpunkte: ['0', '250', '500', '750', '1000', '1250', '1500', '1750', '2000', '2250', '2500'],
            sperrpunkte: [],
            sperrflaechen: [],
            messwerte: {
                links: ['0', '', '', '', '', '', '', '', '', '', ''],
                rechts: ['', '', '', '', '', '', '', '', '', '', '']
            },
            fahrspur: {
                breite: '',
                laenge: '2500'
            },
            flaeche: {
                steigung: '',
                achsenabschnitt: '0'
            },
            typ: undefined,
            richtlinie: '2025'
        };
        this.beurteilungFahrzeug = {
            beurteilung: [],
            neigungen: {
                quer: 0,
                laengs: 0,
                ermittelt: 0
            }
        };
        this.beurteilungSep = {
            beurteilung: [],
            neigungen: {
                quer: 0,
                laengs: 0,
                ermittelt: 0
            }
        };
        this.zeitpunktGespeichert = undefined;
        this.gespeicherteEingabenVorhanden = false;
        this.editable = true;
        this.validateTimeoutRef = 0;
        this.validateTimeOutTyp = undefined;
    }
    SesAuswertungFlaechenRili2025Store_1 = SesAuswertungFlaechenRili2025Store;
    SesAuswertungFlaechenRili2025Store.prototype.validateMesswerteDelayed = function (aufstellflaechenTyp, maximaleSpurAnzahl) {
        var _this = this;
        if ((this.validateTimeoutRef > 0) && (this.validateTimeOutTyp === aufstellflaechenTyp)) {
            window.clearTimeout(this.validateTimeoutRef);
            this.validateTimeoutRef = 0;
        }
        var validateTimeoutInMs = 400;
        this.validateTimeOutTyp = aufstellflaechenTyp;
        this.validateTimeoutRef = window.setTimeout(function () {
            _this.validateMesswerte(aufstellflaechenTyp, maximaleSpurAnzahl);
        }, validateTimeoutInMs);
    };
    // @todo: Für Sperrflächen anpassen
    SesAuswertungFlaechenRili2025Store.prototype.validateMesswerte = function (aufstellflaechenTyp, maximaleSpurAnzahl) {
        return __awaiter(this, void 0, void 0, function () {
            var messung, response, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(aufstellflaechenTyp === 'fahrzeug')) return [3 /*break*/, 2];
                        messung = {
                            messpunkte: this.messwerteFahrzeug.messpunkte,
                            messwerte: {
                                links: this.messwerteFahrzeug.messwerte.links,
                                rechts: this.messwerteFahrzeug.messwerte.rechts
                            },
                            fahrspur: this.messwerteFahrzeug.fahrspur,
                            flaeche: this.messwerteFahrzeug.flaeche,
                            typ: this.messwerteFahrzeug.typ,
                            sperrpunkte: [],
                            sperrflaechen: this.messwerteFahrzeug.sperrflaechen
                        };
                        messung.messpunkte = messung.messpunkte.slice(0, maximaleSpurAnzahl);
                        messung.messwerte.links = messung.messwerte.links.slice(0, maximaleSpurAnzahl);
                        messung.messwerte.rechts = messung.messwerte.rechts.slice(0, maximaleSpurAnzahl);
                        return [4 /*yield*/, this.apiStore.beurteilungFahrzeugAufstellflaecheRili2025(messung)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setBeurteilungFahrzeug(response.json);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(aufstellflaechenTyp === 'sep')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiStore.beurteilungSepAufstellflaeche(this.messwerteSep)];
                    case 3:
                        response = _a.sent();
                        if (response.ok) {
                            this.setBeurteilungSep(response.json);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2025Store.prototype.clear = function () {
        this.messwerteFahrzeug.messpunkte = [];
        this.messwerteFahrzeug.messwerte.links = [];
        this.messwerteFahrzeug.messwerte.rechts = [];
        this.messwerteFahrzeug.sperrpunkte = [];
        for (var i = 0; i < (8000 / this.messRaster) + 1; i++) {
            this.messwerteFahrzeug.messpunkte.push((i * this.messRaster).toString());
            this.messwerteFahrzeug.messwerte.links.push(i === 0 ? '0' : '');
            this.messwerteFahrzeug.messwerte.rechts.push('');
        }
        this.messwerteFahrzeug.fahrspur.breite = '';
        this.messwerteFahrzeug.fahrspur.laenge = '';
        this.messwerteFahrzeug.flaeche.steigung = '';
        this.messwerteFahrzeug.flaeche.achsenabschnitt = '0';
        this.messwerteFahrzeug.typ = undefined;
        this.messwerteFahrzeug.sperrflaechen = [];
        this.messwerteSep.messpunkte = ['0', '250', '500', '750', '1000', '1250', '1500', '1750', '2000', '2250', '2500'];
        this.messwerteSep.messwerte.links = ['0', '', '', '', '', '', '', '', '', '', ''];
        this.messwerteSep.messwerte.rechts = ['', '', '', '', '', '', '', '', '', '', ''];
        this.messwerteSep.fahrspur.breite = '';
        this.messwerteSep.fahrspur.laenge = '2500';
        this.messwerteSep.flaeche.steigung = '';
        this.messwerteSep.flaeche.achsenabschnitt = '0';
        this.messwerteSep.typ = undefined;
        this.messwerteSep.richtlinie = '2025';
        this.messwerteSep.sperrflaechen = [];
        this.beurteilungFahrzeug.beurteilung = [];
        this.beurteilungSep.beurteilung = [];
    };
    SesAuswertungFlaechenRili2025Store.prototype.setBeurteilungFahrzeug = function (ergebnis) {
        this.beurteilungFahrzeug = ergebnis;
    };
    SesAuswertungFlaechenRili2025Store.prototype.setBeurteilungSep = function (ergebnis) {
        this.beurteilungSep = ergebnis;
    };
    SesAuswertungFlaechenRili2025Store.prototype.setZeitpunktGespeichert = function (value) {
        this.zeitpunktGespeichert = value;
    };
    SesAuswertungFlaechenRili2025Store.prototype.setEditable = function (value) {
        this.editable = value;
    };
    SesAuswertungFlaechenRili2025Store.prototype.inSperrFlaeche = function (abstand) {
        var ergebnis = false;
        for (var _i = 0, _a = this.messwerteFahrzeug.sperrflaechen; _i < _a.length; _i++) {
            var sperrflaeche = _a[_i];
            if (sperrflaeche.art === 'sperrflaeche' && abstand >= sperrflaeche.start && abstand <= sperrflaeche.ende) {
                ergebnis = true;
                break;
            }
        }
        return ergebnis;
    };
    SesAuswertungFlaechenRili2025Store.prototype.uebernehmeMessung = function (quelle, ziel) {
        // Im JSON werden leere Felder als null gespeichert, Inputs erwarten dann aber einen Leerstring, also übernehmen wir nur wirklich zwischengespeicherte Werte
        for (var i = 0; i < quelle.messwerte.links.length; i++) {
            if (quelle.messwerte.links[i] !== null) {
                ziel.messwerte.links[i] = quelle.messwerte.links[i];
            }
        }
        for (var i = 0; i < quelle.messwerte.rechts.length; i++) {
            if (quelle.messwerte.rechts[i] !== null) {
                ziel.messwerte.rechts[i] = quelle.messwerte.rechts[i];
            }
        }
        for (var i = 0; i < quelle.sperrflaechen.length; i++) {
            if (quelle.sperrflaechen[i] !== null) {
                ziel.sperrflaechen[i] = quelle.sperrflaechen[i];
            }
        }
        if (quelle.fahrspur.breite !== null) {
            ziel.fahrspur.breite = quelle.fahrspur.breite;
        }
        if (quelle.fahrspur.laenge !== null) {
            ziel.fahrspur.laenge = quelle.fahrspur.laenge;
        }
        if (quelle.flaeche.steigung !== null) {
            ziel.flaeche.steigung = quelle.flaeche.steigung;
        }
        if (quelle.flaeche.achsenabschnitt !== null) {
            ziel.flaeche.achsenabschnitt = quelle.flaeche.achsenabschnitt;
        }
    };
    SesAuswertungFlaechenRili2025Store.prototype.setMesswerteFahrzeug = function (messwerte) {
        this.uebernehmeMessung(messwerte, this.messwerteFahrzeug);
    };
    SesAuswertungFlaechenRili2025Store.prototype.setMesswerteSep = function (messwerte) {
        this.uebernehmeMessung(messwerte, this.messwerteSep);
    };
    SesAuswertungFlaechenRili2025Store.prototype.setGespeicherteEingabenVorhanden = function (wert) {
        this.gespeicherteEingabenVorhanden = wert;
    };
    SesAuswertungFlaechenRili2025Store.prototype.eingabenSpeichern = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, zeitpunkt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, this.messwerteFahrzeug, this.messwerteSep)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            zeitpunkt = new Date();
                            this.setZeitpunktGespeichert(zeitpunkt.toLocaleDateString() + ' ' + zeitpunkt.toLocaleTimeString());
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2025Store.prototype.eingabenLaden = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, mw;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.eingabenAuswertungSesLaden(vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (response.json.wert) {
                                try {
                                    mw = JSON.parse(response.json.wert);
                                    this.setMesswerteFahrzeug(mw.messdaten.fahrzeug);
                                    this.setMesswerteSep(mw.messdaten.sep);
                                    this.setGespeicherteEingabenVorhanden(true);
                                }
                                catch (e) {
                                    console.log('Eingabedaten konnten nicht geladen werden');
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungFlaechenRili2025Store.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2025Store.prototype, "messwerteFahrzeug", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2025Store.prototype, "messwerteSep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2025Store.prototype, "beurteilungFahrzeug", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2025Store.prototype, "beurteilungSep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2025Store.prototype, "zeitpunktGespeichert", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2025Store.prototype, "gespeicherteEingabenVorhanden", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setBeurteilungFahrzeug", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setBeurteilungSep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setZeitpunktGespeichert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setEditable", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setMesswerteFahrzeug", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setMesswerteSep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2025Store.prototype, "setGespeicherteEingabenVorhanden", null);
    SesAuswertungFlaechenRili2025Store = SesAuswertungFlaechenRili2025Store_1 = __decorate([
        decorators_1.provideSingleton(SesAuswertungFlaechenRili2025Store_1)
    ], SesAuswertungFlaechenRili2025Store);
    return SesAuswertungFlaechenRili2025Store;
    var SesAuswertungFlaechenRili2025Store_1;
}());
exports.SesAuswertungFlaechenRili2025Store = SesAuswertungFlaechenRili2025Store;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var ToastStore = (function () {
    function ToastStore() {
        this.notifications = mobx_1.observable([]);
    }
    ToastStore_1 = ToastStore;
    ToastStore.prototype.show = function (notification) {
        this.notifications.push(notification);
    };
    ToastStore.prototype.hide = function (notification) {
        this.notifications.remove(notification);
    };
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ToastStore.prototype, "show", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ToastStore.prototype, "hide", null);
    ToastStore = ToastStore_1 = __decorate([
        decorators_1.provideSingleton(ToastStore_1)
    ], ToastStore);
    return ToastStore;
    var ToastStore_1;
}());
exports.ToastStore = ToastStore;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(573).enable();
  window.Promise = __webpack_require__(572);
}

// fetch() polyfill for making API calls.
__webpack_require__(696);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(23);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(30);
var App_1 = __webpack_require__(589);
__webpack_require__(355);
__webpack_require__(360);
__webpack_require__(359);
__webpack_require__(358);
__webpack_require__(357);
ReactDOM.render(React.createElement(App_1.default, null), document.getElementById('root'));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(174)))

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(295), __esModule: true };

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(297), __esModule: true };

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(299), __esModule: true };

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(301), __esModule: true };

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(302), __esModule: true };

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(187);
__webpack_require__(326);
module.exports = __webpack_require__(39).Array.from;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(328);
module.exports = __webpack_require__(39).Object.assign;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(329);
var $Object = __webpack_require__(39).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(333);
module.exports = __webpack_require__(39).Object.entries;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(330);
module.exports = __webpack_require__(39).Object.setPrototypeOf;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(334);
module.exports = __webpack_require__(39).Object.values;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(332);
__webpack_require__(331);
__webpack_require__(335);
__webpack_require__(336);
module.exports = __webpack_require__(39).Symbol;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(187);
__webpack_require__(337);
module.exports = __webpack_require__(129).f('iterator');

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(48)
  , toLength  = __webpack_require__(186)
  , toIndex   = __webpack_require__(324);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(115)
  , TAG = __webpack_require__(40)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(58)
  , createDesc      = __webpack_require__(79);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(66)
  , gOPS    = __webpack_require__(121)
  , pIE     = __webpack_require__(78);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(47).document && document.documentElement;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(77)
  , ITERATOR   = __webpack_require__(40)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(115);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(63);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(120)
  , descriptor     = __webpack_require__(79)
  , setToStringTag = __webpack_require__(122)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(65)(IteratorPrototype, __webpack_require__(40)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(40)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(66)
  , toIObject = __webpack_require__(48);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(90)('meta')
  , isObject = __webpack_require__(76)
  , has      = __webpack_require__(57)
  , setDesc  = __webpack_require__(58).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(75)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(66)
  , gOPS     = __webpack_require__(121)
  , pIE      = __webpack_require__(78)
  , toObject = __webpack_require__(126)
  , IObject  = __webpack_require__(179)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(75)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(58)
  , anObject = __webpack_require__(63)
  , getKeys  = __webpack_require__(66);

module.exports = __webpack_require__(64) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(48)
  , gOPN      = __webpack_require__(182).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(57)
  , toObject    = __webpack_require__(126)
  , IE_PROTO    = __webpack_require__(123)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(76)
  , anObject = __webpack_require__(63);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(116)(Function.call, __webpack_require__(181).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(125)
  , defined   = __webpack_require__(117);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(125)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(306)
  , ITERATOR  = __webpack_require__(40)('iterator')
  , Iterators = __webpack_require__(77);
module.exports = __webpack_require__(39).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(116)
  , $export        = __webpack_require__(46)
  , toObject       = __webpack_require__(126)
  , call           = __webpack_require__(312)
  , isArrayIter    = __webpack_require__(310)
  , toLength       = __webpack_require__(186)
  , createProperty = __webpack_require__(307)
  , getIterFn      = __webpack_require__(325);

$export($export.S + $export.F * !__webpack_require__(314)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(304)
  , step             = __webpack_require__(315)
  , Iterators        = __webpack_require__(77)
  , toIObject        = __webpack_require__(48);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(180)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(46);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(318)});

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(46)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(120)});

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(46);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(322).set});

/***/ }),
/* 331 */
/***/ (function(module, exports) {



/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(47)
  , has            = __webpack_require__(57)
  , DESCRIPTORS    = __webpack_require__(64)
  , $export        = __webpack_require__(46)
  , redefine       = __webpack_require__(185)
  , META           = __webpack_require__(317).KEY
  , $fails         = __webpack_require__(75)
  , shared         = __webpack_require__(124)
  , setToStringTag = __webpack_require__(122)
  , uid            = __webpack_require__(90)
  , wks            = __webpack_require__(40)
  , wksExt         = __webpack_require__(129)
  , wksDefine      = __webpack_require__(128)
  , keyOf          = __webpack_require__(316)
  , enumKeys       = __webpack_require__(308)
  , isArray        = __webpack_require__(311)
  , anObject       = __webpack_require__(63)
  , toIObject      = __webpack_require__(48)
  , toPrimitive    = __webpack_require__(127)
  , createDesc     = __webpack_require__(79)
  , _create        = __webpack_require__(120)
  , gOPNExt        = __webpack_require__(320)
  , $GOPD          = __webpack_require__(181)
  , $DP            = __webpack_require__(58)
  , $keys          = __webpack_require__(66)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(182).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(78).f  = $propertyIsEnumerable;
  __webpack_require__(121).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(119)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(65)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(46)
  , $entries = __webpack_require__(184)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(46)
  , $values = __webpack_require__(184)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128)('asyncIterator');

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128)('observable');

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(327);
var global        = __webpack_require__(47)
  , hide          = __webpack_require__(65)
  , Iterators     = __webpack_require__(77)
  , TO_STRING_TAG = __webpack_require__(40)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var emptyObject = __webpack_require__(94);
var _invariant = __webpack_require__(15);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(189);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(339);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(341);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(189);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterEvents;

var _contains = __webpack_require__(68);

var _contains2 = _interopRequireDefault(_contains);

var _querySelectorAll = __webpack_require__(347);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll2.default)(top, selector);

    if (matches.some(function (match) {
      return (0, _contains2.default)(match, target);
    })) handler.call(this, e);
  };
}
module.exports = exports['default'];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = __webpack_require__(91);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(130);

var _off2 = _interopRequireDefault(_off);

var _filter = __webpack_require__(342);

var _filter2 = _interopRequireDefault(_filter);

var _listen = __webpack_require__(344);

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _on = __webpack_require__(91);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(130);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listen = function listen() {};

if (_inDOM2.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on2.default)(node, eventName, handler, capture);
    return function () {
      (0, _off2.default)(node, eventName, handler, capture);
    };
  };
}

exports.default = listen;
module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(67);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(93);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = position;

var _offset = __webpack_require__(190);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(345);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(191);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(348);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(93);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));

    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}
module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(92);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(193);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(353);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(361);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(371);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(15);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(31);

var createArrayFromMixed = __webpack_require__(364);
var getMarkupWrap = __webpack_require__(366);
var invariant = __webpack_require__(15);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(31);

var invariant = __webpack_require__(15);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(368);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(370);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// get successful control from form and assemble into object
// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2

// types which indicate a submit action and are not successful controls
// these will be ignored
var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;

// node names which could be successful controls
var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;

// Matches bracket notation.
var brackets = /(\[[^\[\]]*\])/g;

// serializes form fields
// @param form MUST be an HTMLForm element
// @param options is an optional argument to configure the serialization. Default output
// with no options specified is a url encoded string
//    - hash: [true | false] Configure the output type. If true, the output will
//    be a js object.
//    - serializer: [function] Optional serializer function to override the default one.
//    The function takes 3 arguments (result, key, value) and should return new result
//    hash and url encoded str serializers are provided with this module
//    - disabled: [true | false]. If true serialize disabled fields.
//    - empty: [true | false]. If true serialize empty fields
function serialize(form, options) {
    if (typeof options != 'object') {
        options = { hash: !!options };
    }
    else if (options.hash === undefined) {
        options.hash = true;
    }

    var result = (options.hash) ? {} : '';
    var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);

    var elements = form && form.elements ? form.elements : [];

    //Object store each radio and set if it's empty or not
    var radio_store = Object.create(null);

    for (var i=0 ; i<elements.length ; ++i) {
        var element = elements[i];

        // ingore disabled fields
        if ((!options.disabled && element.disabled) || !element.name) {
            continue;
        }
        // ignore anyhting that is not considered a success field
        if (!k_r_success_contrls.test(element.nodeName) ||
            k_r_submitter.test(element.type)) {
            continue;
        }

        var key = element.name;
        var val = element.value;

        // we can't just use element.value for checkboxes cause some browsers lie to us
        // they say "on" for value when the box isn't checked
        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
            val = undefined;
        }

        // If we want empty elements
        if (options.empty) {
            // for checkbox
            if (element.type === 'checkbox' && !element.checked) {
                val = '';
            }

            // for radio
            if (element.type === 'radio') {
                if (!radio_store[element.name] && !element.checked) {
                    radio_store[element.name] = false;
                }
                else if (element.checked) {
                    radio_store[element.name] = true;
                }
            }

            // if options empty is true, continue only if its radio
            if (val == undefined && element.type == 'radio') {
                continue;
            }
        }
        else {
            // value-less fields are ignored unless options.empty is true
            if (!val) {
                continue;
            }
        }

        // multi select boxes
        if (element.type === 'select-multiple') {
            val = [];

            var selectOptions = element.options;
            var isSelectedOptions = false;
            for (var j=0 ; j<selectOptions.length ; ++j) {
                var option = selectOptions[j];
                var allowedEmpty = options.empty && !option.value;
                var hasValue = (option.value || allowedEmpty);
                if (option.selected && hasValue) {
                    isSelectedOptions = true;

                    // If using a hash serializer be sure to add the
                    // correct notation for an array in the multi-select
                    // context. Here the name attribute on the select element
                    // might be missing the trailing bracket pair. Both names
                    // "foo" and "foo[]" should be arrays.
                    if (options.hash && key.slice(key.length - 2) !== '[]') {
                        result = serializer(result, key + '[]', option.value);
                    }
                    else {
                        result = serializer(result, key, option.value);
                    }
                }
            }

            // Serialize if no selected options and options.empty is true
            if (!isSelectedOptions && options.empty) {
                result = serializer(result, key, '');
            }

            continue;
        }

        result = serializer(result, key, val);
    }

    // Check for all empty radio buttons and serialize them with key=""
    if (options.empty) {
        for (var key in radio_store) {
            if (!radio_store[key]) {
                result = serializer(result, key, '');
            }
        }
    }

    return result;
}

function parse_keys(string) {
    var keys = [];
    var prefix = /^([^\[\]]*)/;
    var children = new RegExp(brackets);
    var match = prefix.exec(string);

    if (match[1]) {
        keys.push(match[1]);
    }

    while ((match = children.exec(string)) !== null) {
        keys.push(match[1]);
    }

    return keys;
}

function hash_assign(result, keys, value) {
    if (keys.length === 0) {
        result = value;
        return result;
    }

    var key = keys.shift();
    var between = key.match(/^\[(.+?)\]$/);

    if (key === '[]') {
        result = result || [];

        if (Array.isArray(result)) {
            result.push(hash_assign(null, keys, value));
        }
        else {
            // This might be the result of bad name attributes like "[][foo]",
            // in this case the original `result` object will already be
            // assigned to an object literal. Rather than coerce the object to
            // an array, or cause an exception the attribute "_values" is
            // assigned as an array.
            result._values = result._values || [];
            result._values.push(hash_assign(null, keys, value));
        }

        return result;
    }

    // Key is an attribute name and can be assigned directly.
    if (!between) {
        result[key] = hash_assign(result[key], keys, value);
    }
    else {
        var string = between[1];
        // +var converts the variable into a number
        // better than parseInt because it doesn't truncate away trailing
        // letters and actually fails if whole thing is not a number
        var index = +string;

        // If the characters between the brackets is not a number it is an
        // attribute name and can be assigned directly.
        if (isNaN(index)) {
            result = result || {};
            result[string] = hash_assign(result[string], keys, value);
        }
        else {
            result = result || [];
            result[index] = hash_assign(result[index], keys, value);
        }
    }

    return result;
}

// Object/hash encoding serializer.
function hash_serializer(result, key, value) {
    var matches = key.match(brackets);

    // Has brackets? Use the recursive assignment function to walk the keys,
    // construct any missing objects in the result tree and make the assignment
    // at the end of the chain.
    if (matches) {
        var keys = parse_keys(key);
        hash_assign(result, keys, value);
    }
    else {
        // Non bracket notation can make assignments directly.
        var existing = result[key];

        // If the value has been assigned already (for instance when a radio and
        // a checkbox have the same name attribute) convert the previous value
        // into an array before pushing into it.
        //
        // NOTE: If this requirement were removed all hash creation and
        // assignment could go through `hash_assign`.
        if (existing) {
            if (!Array.isArray(existing)) {
                result[key] = [ existing ];
            }

            result[key].push(value);
        }
        else {
            result[key] = value;
        }
    }

    return result;
}

// urlform encoding serializer
function str_serialize(result, key, value) {
    // encode newlines as \r\n cause the html spec says so
    value = value.replace(/(\r)?\n/g, '\r\n');
    value = encodeURIComponent(value);

    // spaces should be '+' rather than '%20'.
    value = value.replace(/%20/g, '+');
    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
}

module.exports = serialize;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(59);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(132);

var _PathUtils = __webpack_require__(80);

var _createTransitionManager = __webpack_require__(133);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(80);

var _LocationUtils = __webpack_require__(132);

var _createTransitionManager = __webpack_require__(133);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var provide_in_when_on_syntax_1 = __webpack_require__(382);
var provide_when_syntax_1 = __webpack_require__(135);
var provide_on_syntax_1 = __webpack_require__(134);
var provide_in_syntax_1 = __webpack_require__(381);
var provide_done_syntax_1 = __webpack_require__(201);
function fluentProvide(container) {
    // function is named for testing
    return function _fluentProvide(serviceIdentifier) {
        var bindingWhenOnSyntax = container.bind(serviceIdentifier).to(null);
        var binding = bindingWhenOnSyntax._binding;
        var provideDoneSyntax = new provide_done_syntax_1.default(binding);
        var provideInWhenOnSyntax = new provide_in_when_on_syntax_1.default(new provide_in_syntax_1.default(bindingWhenOnSyntax, provideDoneSyntax), new provide_when_syntax_1.default(bindingWhenOnSyntax, provideDoneSyntax), new provide_on_syntax_1.default(bindingWhenOnSyntax, provideDoneSyntax));
        return provideInWhenOnSyntax;
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = fluentProvide;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inversify_1 = __webpack_require__(95);
function provide(container) {
    // function is named for testing
    return function _provide(serviceIdentifier) {
        var bindingWhenOnSyntax = container.bind(serviceIdentifier).to(null);
        return function (target) {
            inversify_1.decorate(inversify_1.injectable(), target);
            var binding = bindingWhenOnSyntax._binding;
            binding.implementationType = target;
            return target;
        };
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = provide;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fluent_provide_1 = __webpack_require__(377);
function makeFluentProvideDecorator(container) {
    var result = fluent_provide_1.default(container);
    return result;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = makeFluentProvideDecorator;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var provide_decorator_factory_1 = __webpack_require__(200);
exports.makeProvideDecorator = provide_decorator_factory_1.default;
var fluent_provide_decorator_factory_1 = __webpack_require__(379);
exports.makeFluentProvideDecorator = fluent_provide_decorator_factory_1.default;
var auto_wire_1 = __webpack_require__(384);
exports.autoProvide = auto_wire_1.default;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var provide_when_on_syntax_1 = __webpack_require__(383);
var provide_when_syntax_1 = __webpack_require__(135);
var provide_on_syntax_1 = __webpack_require__(134);
var provide_done_syntax_1 = __webpack_require__(201);
var ProvideInSyntax = (function () {
    function ProvideInSyntax(bindingInSyntax, provideDoneSyntax) {
        this._bindingInSyntax = bindingInSyntax;
        this._provideDoneSyntax = provideDoneSyntax;
    }
    ProvideInSyntax.prototype.inSingletonScope = function () {
        var bindingWhenOnSyntax = this._bindingInSyntax.inSingletonScope();
        var provideWhenSyntax = new provide_when_syntax_1.default(bindingWhenOnSyntax, this._provideDoneSyntax);
        var provideOnSyntax = new provide_on_syntax_1.default(bindingWhenOnSyntax, this._provideDoneSyntax);
        return new provide_when_on_syntax_1.default(provideWhenSyntax, provideOnSyntax);
    };
    ProvideInSyntax.prototype.inTransientScope = function () {
        var bindingWhenOnSyntax = this._bindingInSyntax.inTransientScope();
        var provideWhenSyntax = new provide_when_syntax_1.default(bindingWhenOnSyntax, this._provideDoneSyntax);
        var provideOnSyntax = new provide_on_syntax_1.default(bindingWhenOnSyntax, this._provideDoneSyntax);
        return new provide_when_on_syntax_1.default(provideWhenSyntax, provideOnSyntax);
    };
    ProvideInSyntax.prototype.done = function () {
        var binding = this._bindingInSyntax._binding;
        var provideDoneSyntax = new provide_done_syntax_1.default(binding);
        return provideDoneSyntax.done();
    };
    return ProvideInSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProvideInSyntax;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ProvideInWhenOnSyntax = (function () {
    function ProvideInWhenOnSyntax(provideInSyntax, provideWhenSyntax, provideOnSyntax) {
        this._provideInSyntax = provideInSyntax;
        this._provideWhenSyntax = provideWhenSyntax;
        this._provideOnSyntax = provideOnSyntax;
    }
    ProvideInWhenOnSyntax.prototype.when = function (constraint) {
        return this._provideWhenSyntax.when(constraint);
    };
    ProvideInWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._provideWhenSyntax.whenTargetNamed(name);
    };
    ProvideInWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._provideWhenSyntax.whenTargetTagged(tag, value);
    };
    ProvideInWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._provideWhenSyntax.whenInjectedInto(parent);
    };
    ProvideInWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._provideWhenSyntax.whenParentNamed(name);
    };
    ProvideInWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._provideWhenSyntax.whenParentTagged(tag, value);
    };
    ProvideInWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._provideWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    ProvideInWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._provideWhenSyntax.whenNoAncestorIs(ancestor);
    };
    ProvideInWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._provideWhenSyntax.whenAnyAncestorNamed(name);
    };
    ProvideInWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._provideWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    ProvideInWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._provideWhenSyntax.whenNoAncestorNamed(name);
    };
    ProvideInWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._provideWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    ProvideInWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._provideWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    ProvideInWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._provideWhenSyntax.whenNoAncestorMatches(constraint);
    };
    ProvideInWhenOnSyntax.prototype.onActivation = function (fn) {
        return this._provideOnSyntax.onActivation(fn);
    };
    ProvideInWhenOnSyntax.prototype.inSingletonScope = function () {
        return this._provideInSyntax.inSingletonScope();
    };
    ProvideInWhenOnSyntax.prototype.inTransientScope = function () {
        return this._provideInSyntax.inTransientScope();
    };
    ProvideInWhenOnSyntax.prototype.done = function () {
        return this._provideInSyntax.done();
    };
    return ProvideInWhenOnSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProvideInWhenOnSyntax;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ProvideWhenOnSyntax = (function () {
    function ProvideWhenOnSyntax(provideWhenSyntax, provideOnSyntax) {
        this._provideWhenSyntax = provideWhenSyntax;
        this._provideOnSyntax = provideOnSyntax;
    }
    ProvideWhenOnSyntax.prototype.when = function (constraint) {
        return this._provideWhenSyntax.when(constraint);
    };
    ProvideWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._provideWhenSyntax.whenTargetNamed(name);
    };
    ProvideWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._provideWhenSyntax.whenTargetTagged(tag, value);
    };
    ProvideWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._provideWhenSyntax.whenInjectedInto(parent);
    };
    ProvideWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._provideWhenSyntax.whenParentNamed(name);
    };
    ProvideWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._provideWhenSyntax.whenParentTagged(tag, value);
    };
    ProvideWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._provideWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    ProvideWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._provideWhenSyntax.whenNoAncestorIs(ancestor);
    };
    ProvideWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._provideWhenSyntax.whenAnyAncestorNamed(name);
    };
    ProvideWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._provideWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    ProvideWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._provideWhenSyntax.whenNoAncestorNamed(name);
    };
    ProvideWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._provideWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    ProvideWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._provideWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    ProvideWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._provideWhenSyntax.whenNoAncestorMatches(constraint);
    };
    ProvideWhenOnSyntax.prototype.onActivation = function (fn) {
        return this._provideOnSyntax.onActivation(fn);
    };
    ProvideWhenOnSyntax.prototype.done = function () {
        return this._provideWhenSyntax.done();
    };
    return ProvideWhenOnSyntax;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProvideWhenOnSyntax;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inversify_1 = __webpack_require__(95);
var provide_decorator_factory_1 = __webpack_require__(200);
function autoProvide(container) {
    var modules = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        modules[_i - 1] = arguments[_i];
    }
    var provide = provide_decorator_factory_1.default(container);
    modules.forEach(function (module) {
        Object.keys(module).forEach(function (key) {
            var entity = module[key];
            var decorator = provide(entity);
            inversify_1.decorate(decorator, entity);
        });
    });
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = autoProvide;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var INJECTION = Symbol();
function _proxyGetter(proto, key, resolve) {
    function getter() {
        if (!Reflect.hasMetadata(INJECTION, this, key)) {
            Reflect.defineMetadata(INJECTION, resolve(), this, key);
        }
        return Reflect.getMetadata(INJECTION, this, key);
    }
    function setter(newVal) {
        Reflect.defineMetadata(INJECTION, newVal, this, key);
    }
    Object.defineProperty(proto, key, {
        configurable: true,
        enumerable: true,
        get: getter,
        set: setter
    });
}
function makePropertyInjectDecorator(container) {
    return function (serviceIdentifier) {
        return function (proto, key) {
            var resolve = function () {
                return container.get(serviceIdentifier);
            };
            _proxyGetter(proto, key, resolve);
        };
    };
}
exports.makePropertyInjectDecorator = makePropertyInjectDecorator;
function makePropertyInjectNamedDecorator(container) {
    return function (serviceIdentifier, named) {
        return function (proto, key) {
            var resolve = function () {
                return container.getNamed(serviceIdentifier, named);
            };
            _proxyGetter(proto, key, resolve);
        };
    };
}
exports.makePropertyInjectNamedDecorator = makePropertyInjectNamedDecorator;
function makePropertyInjectTaggedDecorator(container) {
    return function (serviceIdentifier, key, value) {
        return function (proto, propertyName) {
            var resolve = function () {
                return container.getTagged(serviceIdentifier, key, value);
            };
            _proxyGetter(proto, propertyName, resolve);
        };
    };
}
exports.makePropertyInjectTaggedDecorator = makePropertyInjectTaggedDecorator;
function makePropertyMultiInjectDecorator(container) {
    return function (serviceIdentifier) {
        return function (proto, key) {
            var resolve = function () {
                return container.getAll(serviceIdentifier);
            };
            _proxyGetter(proto, key, resolve);
        };
    };
}
exports.makePropertyMultiInjectDecorator = makePropertyMultiInjectDecorator;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var decorators_1 = __webpack_require__(385);
function getDecorators(container) {
    var lazyInject = decorators_1.makePropertyInjectDecorator(container);
    var lazyInjectNamed = decorators_1.makePropertyInjectNamedDecorator(container);
    var lazyInjectTagged = decorators_1.makePropertyInjectTaggedDecorator(container);
    var lazyMultiInject = decorators_1.makePropertyMultiInjectDecorator(container);
    return {
        lazyInject: lazyInject,
        lazyInjectNamed: lazyInjectNamed,
        lazyInjectTagged: lazyInjectTagged,
        lazyMultiInject: lazyMultiInject
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getDecorators;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
var METADATA_KEY = __webpack_require__(27);
function inject(serviceIdentifier) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.INJECT_TAG, serviceIdentifier);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.inject = inject;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(27);
var ERRORS_MSGS = __webpack_require__(36);
function injectable() {
    return function (target) {
        if (Reflect.hasOwnMetadata(METADATA_KEY.PARAM_TYPES, target) === true) {
            throw new Error(ERRORS_MSGS.DUPLICATED_INJECTABLE_DECORATOR);
        }
        var types = Reflect.getMetadata(METADATA_KEY.DESIGN_PARAM_TYPES, target) || [];
        Reflect.defineMetadata(METADATA_KEY.PARAM_TYPES, types, target);
        return target;
    };
}
exports.injectable = injectable;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
var METADATA_KEY = __webpack_require__(27);
function multiInject(serviceIdentifier) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.MULTI_INJECT_TAG, serviceIdentifier);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.multiInject = multiInject;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
var METADATA_KEY = __webpack_require__(27);
function named(name) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.NAMED_TAG, name);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.named = named;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
var METADATA_KEY = __webpack_require__(27);
function optional() {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.OPTIONAL_TAG, true);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.optional = optional;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var METADATA_KEY = __webpack_require__(27);
var ERRORS_MSGS = __webpack_require__(36);
function postConstruct() {
    return function (target, propertyKey, descriptor) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.POST_CONSTRUCT, propertyKey);
        if (Reflect.hasOwnMetadata(METADATA_KEY.POST_CONSTRUCT, target.constructor)) {
            throw new Error(ERRORS_MSGS.MULTIPLE_POST_CONSTRUCT_METHODS);
        }
        Reflect.defineMetadata(METADATA_KEY.POST_CONSTRUCT, metadata, target.constructor);
    };
}
exports.postConstruct = postConstruct;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
function tagged(metadataKey, metadataValue) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(metadataKey, metadataValue);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.tagged = tagged;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
var METADATA_KEY = __webpack_require__(27);
function targetName(name) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.NAME_TAG, name);
        decorator_utils_1.tagParameter(target, targetKey, index, metadata);
    };
}
exports.targetName = targetName;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(37);
var decorator_utils_1 = __webpack_require__(50);
var METADATA_KEY = __webpack_require__(27);
function unmanaged() {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.UNMANAGED_TAG, true);
        decorator_utils_1.tagParameter(target, targetKey, index, metadata);
    };
}
exports.unmanaged = unmanaged;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(60);
var literal_types_1 = __webpack_require__(51);
var Binding = (function () {
    function Binding(serviceIdentifier, defaultScope) {
        this.guid = guid_1.guid();
        this.activated = false;
        this.serviceIdentifier = serviceIdentifier;
        this.scope = defaultScope;
        this.type = literal_types_1.BindingTypeEnum.Invalid;
        this.constraint = function (request) { return true; };
        this.implementationType = null;
        this.cache = null;
        this.factory = null;
        this.provider = null;
        this.onActivation = null;
        this.dynamicValue = null;
    }
    Binding.prototype.clone = function () {
        var clone = new Binding(this.serviceIdentifier, this.scope);
        clone.activated = false;
        clone.implementationType = this.implementationType;
        clone.dynamicValue = this.dynamicValue;
        clone.scope = this.scope;
        clone.type = this.type;
        clone.factory = this.factory;
        clone.provider = this.provider;
        clone.constraint = this.constraint;
        clone.onActivation = this.onActivation;
        clone.cache = this.cache;
        return clone;
    };
    return Binding;
}());
exports.Binding = Binding;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BindingCount = {
    MultipleBindingsAvailable: 2,
    NoBindingsAvailable: 0,
    OnlyOneBindingAvailable: 1
};
exports.BindingCount = BindingCount;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_1 = __webpack_require__(396);
var lookup_1 = __webpack_require__(401);
var planner_1 = __webpack_require__(404);
var resolver_1 = __webpack_require__(409);
var binding_to_syntax_1 = __webpack_require__(412);
var serialization_1 = __webpack_require__(81);
var container_snapshot_1 = __webpack_require__(400);
var guid_1 = __webpack_require__(60);
var ERROR_MSGS = __webpack_require__(36);
var METADATA_KEY = __webpack_require__(27);
var literal_types_1 = __webpack_require__(51);
var metadata_reader_1 = __webpack_require__(202);
var Container = (function () {
    function Container(containerOptions) {
        if (containerOptions !== undefined) {
            if (typeof containerOptions !== "object") {
                throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_MUST_BE_AN_OBJECT);
            }
            else if (containerOptions.defaultScope === undefined) {
                throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE);
            }
            else if (containerOptions.defaultScope !== literal_types_1.BindingScopeEnum.Singleton &&
                containerOptions.defaultScope !== literal_types_1.BindingScopeEnum.Transient) {
                throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE);
            }
            this.options = {
                defaultScope: containerOptions.defaultScope
            };
        }
        else {
            this.options = {
                defaultScope: literal_types_1.BindingScopeEnum.Transient
            };
        }
        this.guid = guid_1.guid();
        this._bindingDictionary = new lookup_1.Lookup();
        this._snapshots = [];
        this._middleware = null;
        this.parent = null;
        this._metadataReader = new metadata_reader_1.MetadataReader();
    }
    Container.merge = function (container1, container2) {
        var container = new Container();
        var bindingDictionary = planner_1.getBindingDictionary(container);
        var bindingDictionary1 = planner_1.getBindingDictionary(container1);
        var bindingDictionary2 = planner_1.getBindingDictionary(container2);
        function copyDictionary(origing, destination) {
            origing.traverse(function (key, value) {
                value.forEach(function (binding) {
                    destination.add(binding.serviceIdentifier, binding.clone());
                });
            });
        }
        copyDictionary(bindingDictionary1, bindingDictionary);
        copyDictionary(bindingDictionary2, bindingDictionary);
        return container;
    };
    Container.prototype.load = function () {
        var _this = this;
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var setModuleId = function (bindingToSyntax, moduleId) {
            bindingToSyntax._binding.moduleId = moduleId;
        };
        var getBindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var bindingToSyntax = _this.bind.call(_this, serviceIdentifier);
                setModuleId(bindingToSyntax, moduleId);
                return bindingToSyntax;
            };
        };
        var getUnbindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _unbind = _this.unbind.bind(_this);
                _unbind(serviceIdentifier);
            };
        };
        var getIsboundFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _isBound = _this.isBound.bind(_this);
                return _isBound(serviceIdentifier);
            };
        };
        var getRebindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var bindingToSyntax = _this.rebind.call(_this, serviceIdentifier);
                setModuleId(bindingToSyntax, moduleId);
                return bindingToSyntax;
            };
        };
        modules.forEach(function (module) {
            var bindFunction = getBindFunction(module.guid);
            var unbindFunction = getUnbindFunction(module.guid);
            var isboundFunction = getIsboundFunction(module.guid);
            var rebindFunction = getRebindFunction(module.guid);
            module.registry(bindFunction, unbindFunction, isboundFunction, rebindFunction);
        });
    };
    Container.prototype.unload = function () {
        var _this = this;
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var conditionFactory = function (expected) { return function (item) {
            return item.moduleId === expected;
        }; };
        modules.forEach(function (module) {
            var condition = conditionFactory(module.guid);
            _this._bindingDictionary.removeByCondition(condition);
        });
    };
    Container.prototype.bind = function (serviceIdentifier) {
        var defaultScope = literal_types_1.BindingScopeEnum.Transient;
        defaultScope = (this.options.defaultScope === defaultScope) ? defaultScope : literal_types_1.BindingScopeEnum.Singleton;
        var binding = new binding_1.Binding(serviceIdentifier, defaultScope);
        this._bindingDictionary.add(serviceIdentifier, binding);
        return new binding_to_syntax_1.BindingToSyntax(binding);
    };
    Container.prototype.rebind = function (serviceIdentifier) {
        this.unbind(serviceIdentifier);
        return this.bind(serviceIdentifier);
    };
    Container.prototype.unbind = function (serviceIdentifier) {
        try {
            this._bindingDictionary.remove(serviceIdentifier);
        }
        catch (e) {
            throw new Error(ERROR_MSGS.CANNOT_UNBIND + " " + serialization_1.getServiceIdentifierAsString(serviceIdentifier));
        }
    };
    Container.prototype.unbindAll = function () {
        this._bindingDictionary = new lookup_1.Lookup();
    };
    Container.prototype.isBound = function (serviceIdentifier) {
        return this._bindingDictionary.hasKey(serviceIdentifier);
    };
    Container.prototype.isBoundNamed = function (serviceIdentifier, named) {
        return this.isBoundTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.isBoundTagged = function (serviceIdentifier, key, value) {
        var bindings = this._bindingDictionary.get(serviceIdentifier);
        var request = planner_1.createMockRequest(this, serviceIdentifier, key, value);
        return bindings.some(function (b) { return b.constraint(request); });
    };
    Container.prototype.snapshot = function () {
        this._snapshots.push(container_snapshot_1.ContainerSnapshot.of(this._bindingDictionary.clone(), this._middleware));
    };
    Container.prototype.restore = function () {
        var snapshot = this._snapshots.pop();
        if (snapshot === undefined) {
            throw new Error(ERROR_MSGS.NO_MORE_SNAPSHOTS_AVAILABLE);
        }
        this._bindingDictionary = snapshot.bindings;
        this._middleware = snapshot.middleware;
    };
    Container.prototype.createChild = function () {
        var child = new Container();
        child.parent = this;
        return child;
    };
    Container.prototype.applyMiddleware = function () {
        var middlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            middlewares[_i] = arguments[_i];
        }
        var initial = (this._middleware) ? this._middleware : this._planAndResolve();
        this._middleware = middlewares.reduce(function (prev, curr) {
            return curr(prev);
        }, initial);
    };
    Container.prototype.applyCustomMetadataReader = function (metadataReader) {
        this._metadataReader = metadataReader;
    };
    Container.prototype.get = function (serviceIdentifier) {
        return this._get(false, false, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier);
    };
    Container.prototype.getTagged = function (serviceIdentifier, key, value) {
        return this._get(false, false, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier, key, value);
    };
    Container.prototype.getNamed = function (serviceIdentifier, named) {
        return this.getTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.getAll = function (serviceIdentifier) {
        return this._get(true, true, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier);
    };
    Container.prototype.getAllTagged = function (serviceIdentifier, key, value) {
        return this._get(false, true, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier, key, value);
    };
    Container.prototype.getAllNamed = function (serviceIdentifier, named) {
        return this.getAllTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.resolve = function (constructorFunction) {
        var tempContainer = new Container();
        tempContainer.bind(constructorFunction).toSelf();
        tempContainer.parent = this;
        return tempContainer.get(constructorFunction);
    };
    Container.prototype._get = function (avoidConstraints, isMultiInject, targetType, serviceIdentifier, key, value) {
        var result = null;
        var defaultArgs = {
            avoidConstraints: avoidConstraints,
            contextInterceptor: function (context) { return context; },
            isMultiInject: isMultiInject,
            key: key,
            serviceIdentifier: serviceIdentifier,
            targetType: targetType,
            value: value
        };
        if (this._middleware) {
            result = this._middleware(defaultArgs);
            if (result === undefined || result === null) {
                throw new Error(ERROR_MSGS.INVALID_MIDDLEWARE_RETURN);
            }
        }
        else {
            result = this._planAndResolve()(defaultArgs);
        }
        return result;
    };
    Container.prototype._planAndResolve = function () {
        var _this = this;
        return function (args) {
            var context = planner_1.plan(_this._metadataReader, _this, args.isMultiInject, args.targetType, args.serviceIdentifier, args.key, args.value, args.avoidConstraints);
            context = args.contextInterceptor(context);
            var result = resolver_1.resolve(context);
            return result;
        };
    };
    return Container;
}());
exports.Container = Container;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(60);
var ContainerModule = (function () {
    function ContainerModule(registry) {
        this.guid = guid_1.guid();
        this.registry = registry;
    }
    return ContainerModule;
}());
exports.ContainerModule = ContainerModule;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContainerSnapshot = (function () {
    function ContainerSnapshot() {
    }
    ContainerSnapshot.of = function (bindings, middleware) {
        var snapshot = new ContainerSnapshot();
        snapshot.bindings = bindings;
        snapshot.middleware = middleware;
        return snapshot;
    };
    return ContainerSnapshot;
}());
exports.ContainerSnapshot = ContainerSnapshot;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(36);
var Lookup = (function () {
    function Lookup() {
        this._map = new Map();
    }
    Lookup.prototype.getMap = function () {
        return this._map;
    };
    Lookup.prototype.add = function (serviceIdentifier, value) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        if (value === null || value === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        var entry = this._map.get(serviceIdentifier);
        if (entry !== undefined) {
            entry.push(value);
            this._map.set(serviceIdentifier, entry);
        }
        else {
            this._map.set(serviceIdentifier, [value]);
        }
    };
    Lookup.prototype.get = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        var entry = this._map.get(serviceIdentifier);
        if (entry !== undefined) {
            return entry;
        }
        else {
            throw new Error(ERROR_MSGS.KEY_NOT_FOUND);
        }
    };
    Lookup.prototype.remove = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        if (!this._map.delete(serviceIdentifier)) {
            throw new Error(ERROR_MSGS.KEY_NOT_FOUND);
        }
    };
    Lookup.prototype.removeByCondition = function (condition) {
        var _this = this;
        this._map.forEach(function (entries, key) {
            var updatedEntries = entries.filter(function (entry) { return !condition(entry); });
            if (updatedEntries.length > 0) {
                _this._map.set(key, updatedEntries);
            }
            else {
                _this._map.delete(key);
            }
        });
    };
    Lookup.prototype.hasKey = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        return this._map.has(serviceIdentifier);
    };
    Lookup.prototype.clone = function () {
        var copy = new Lookup();
        this._map.forEach(function (value, key) {
            value.forEach(function (b) { return copy.add(key, b.clone()); });
        });
        return copy;
    };
    Lookup.prototype.traverse = function (func) {
        this._map.forEach(function (value, key) {
            func(key, value);
        });
    };
    return Lookup;
}());
exports.Lookup = Lookup;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(60);
var Context = (function () {
    function Context(container) {
        this.guid = guid_1.guid();
        this.container = container;
    }
    Context.prototype.addPlan = function (plan) {
        this.plan = plan;
    };
    return Context;
}());
exports.Context = Context;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Plan = (function () {
    function Plan(parentContext, rootRequest) {
        this.parentContext = parentContext;
        this.rootRequest = rootRequest;
    }
    return Plan;
}());
exports.Plan = Plan;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var plan_1 = __webpack_require__(403);
var context_1 = __webpack_require__(402);
var request_1 = __webpack_require__(407);
var target_1 = __webpack_require__(203);
var binding_count_1 = __webpack_require__(397);
var reflection_utils_1 = __webpack_require__(406);
var metadata_1 = __webpack_require__(37);
var ERROR_MSGS = __webpack_require__(36);
var METADATA_KEY = __webpack_require__(27);
var literal_types_1 = __webpack_require__(51);
var serialization_1 = __webpack_require__(81);
function getBindingDictionary(cntnr) {
    return cntnr._bindingDictionary;
}
exports.getBindingDictionary = getBindingDictionary;
function _createTarget(isMultiInject, targetType, serviceIdentifier, name, key, value) {
    var metadataKey = isMultiInject ? METADATA_KEY.MULTI_INJECT_TAG : METADATA_KEY.INJECT_TAG;
    var injectMetadata = new metadata_1.Metadata(metadataKey, serviceIdentifier);
    var target = new target_1.Target(targetType, name, serviceIdentifier, injectMetadata);
    if (key !== undefined) {
        var tagMetadata = new metadata_1.Metadata(key, value);
        target.metadata.push(tagMetadata);
    }
    return target;
}
function _getActiveBindings(avoidConstraints, context, parentRequest, target) {
    var bindings = getBindings(context.container, target.serviceIdentifier);
    var activeBindings = [];
    if (avoidConstraints === false) {
        activeBindings = bindings.filter(function (binding) {
            var request = new request_1.Request(binding.serviceIdentifier, context, parentRequest, binding, target);
            return binding.constraint(request);
        });
    }
    else {
        activeBindings = bindings;
    }
    _validateActiveBindingCount(target.serviceIdentifier, activeBindings, target, context.container);
    return activeBindings;
}
function _validateActiveBindingCount(serviceIdentifier, bindings, target, container) {
    switch (bindings.length) {
        case binding_count_1.BindingCount.NoBindingsAvailable:
            if (target.isOptional() === true) {
                return bindings;
            }
            else {
                var serviceIdentifierString = serialization_1.getServiceIdentifierAsString(serviceIdentifier);
                var msg = ERROR_MSGS.NOT_REGISTERED;
                msg += serialization_1.listMetadataForTarget(serviceIdentifierString, target);
                msg += serialization_1.listRegisteredBindingsForServiceIdentifier(container, serviceIdentifierString, getBindings);
                throw new Error(msg);
            }
        case binding_count_1.BindingCount.OnlyOneBindingAvailable:
            if (target.isArray() === false) {
                return bindings;
            }
        case binding_count_1.BindingCount.MultipleBindingsAvailable:
        default:
            if (target.isArray() === false) {
                var serviceIdentifierString = serialization_1.getServiceIdentifierAsString(serviceIdentifier), msg = ERROR_MSGS.AMBIGUOUS_MATCH + " " + serviceIdentifierString;
                msg += serialization_1.listRegisteredBindingsForServiceIdentifier(container, serviceIdentifierString, getBindings);
                throw new Error(msg);
            }
            else {
                return bindings;
            }
    }
}
function _createSubRequests(metadataReader, avoidConstraints, serviceIdentifier, context, parentRequest, target) {
    try {
        var activeBindings = void 0;
        var childRequest_1;
        if (parentRequest === null) {
            activeBindings = _getActiveBindings(avoidConstraints, context, null, target);
            childRequest_1 = new request_1.Request(serviceIdentifier, context, null, activeBindings, target);
            var plan_2 = new plan_1.Plan(context, childRequest_1);
            context.addPlan(plan_2);
        }
        else {
            activeBindings = _getActiveBindings(avoidConstraints, context, parentRequest, target);
            childRequest_1 = parentRequest.addChildRequest(target.serviceIdentifier, activeBindings, target);
        }
        activeBindings.forEach(function (binding) {
            var subChildRequest = null;
            if (target.isArray()) {
                subChildRequest = childRequest_1.addChildRequest(binding.serviceIdentifier, binding, target);
            }
            else {
                subChildRequest = childRequest_1;
            }
            if (binding.type === literal_types_1.BindingTypeEnum.Instance && binding.implementationType !== null) {
                var dependencies = reflection_utils_1.getDependencies(metadataReader, binding.implementationType);
                dependencies.forEach(function (dependency) {
                    _createSubRequests(metadataReader, false, dependency.serviceIdentifier, context, subChildRequest, dependency);
                });
            }
        });
    }
    catch (error) {
        if (error instanceof RangeError && parentRequest !== null) {
            serialization_1.circularDependencyToException(parentRequest.parentContext.plan.rootRequest);
        }
        else {
            throw new Error(error.message);
        }
    }
}
function getBindings(container, serviceIdentifier) {
    var bindings = [];
    var bindingDictionary = getBindingDictionary(container);
    if (bindingDictionary.hasKey(serviceIdentifier)) {
        bindings = bindingDictionary.get(serviceIdentifier);
    }
    else if (container.parent !== null) {
        bindings = getBindings(container.parent, serviceIdentifier);
    }
    return bindings;
}
function plan(metadataReader, container, isMultiInject, targetType, serviceIdentifier, key, value, avoidConstraints) {
    if (avoidConstraints === void 0) { avoidConstraints = false; }
    var context = new context_1.Context(container);
    var target = _createTarget(isMultiInject, targetType, serviceIdentifier, "", key, value);
    _createSubRequests(metadataReader, avoidConstraints, serviceIdentifier, context, null, target);
    return context;
}
exports.plan = plan;
function createMockRequest(container, serviceIdentifier, key, value) {
    var target = new target_1.Target(literal_types_1.TargetTypeEnum.Variable, "", serviceIdentifier, new metadata_1.Metadata(key, value));
    var context = new context_1.Context(container);
    var request = new request_1.Request(serviceIdentifier, context, null, [], target);
    return request;
}
exports.createMockRequest = createMockRequest;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QueryableString = (function () {
    function QueryableString(str) {
        this.str = str;
    }
    QueryableString.prototype.startsWith = function (searchString) {
        return this.str.indexOf(searchString) === 0;
    };
    QueryableString.prototype.endsWith = function (searchString) {
        var reverseString = "";
        var reverseSearchString = searchString.split("").reverse().join("");
        reverseString = this.str.split("").reverse().join("");
        return this.startsWith.call({ str: reverseString }, reverseSearchString);
    };
    QueryableString.prototype.contains = function (searchString) {
        return (this.str.indexOf(searchString) !== -1);
    };
    QueryableString.prototype.equals = function (compareString) {
        return this.str === compareString;
    };
    QueryableString.prototype.value = function () {
        return this.str;
    };
    return QueryableString;
}());
exports.QueryableString = QueryableString;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var serialization_1 = __webpack_require__(81);
var target_1 = __webpack_require__(203);
var ERROR_MSGS = __webpack_require__(36);
var METADATA_KEY = __webpack_require__(27);
var literal_types_1 = __webpack_require__(51);
function getDependencies(metadataReader, func) {
    var constructorName = serialization_1.getFunctionName(func);
    var targets = getTargets(metadataReader, constructorName, func, false);
    return targets;
}
exports.getDependencies = getDependencies;
function getTargets(metadataReader, constructorName, func, isBaseClass) {
    var metadata = metadataReader.getConstructorMetadata(func);
    var serviceIdentifiers = metadata.compilerGeneratedMetadata;
    if (serviceIdentifiers === undefined) {
        var msg = ERROR_MSGS.MISSING_INJECTABLE_ANNOTATION + " " + constructorName + ".";
        throw new Error(msg);
    }
    var constructorArgsMetadata = metadata.userGeneratedMetadata;
    var keys = Object.keys(constructorArgsMetadata);
    var hasUserDeclaredUnknownInjections = (func.length === 0 && keys.length > 0);
    var iterations = (hasUserDeclaredUnknownInjections) ? keys.length : func.length;
    var constructorTargets = getConstructorArgsAsTargets(isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata, iterations);
    var propertyTargets = getClassPropsAsTargets(metadataReader, func);
    var targets = constructorTargets.concat(propertyTargets);
    var baseClassDepencencyCount = getBaseClassDepencencyCount(metadataReader, func);
    if (targets.length < baseClassDepencencyCount) {
        var error = ERROR_MSGS.ARGUMENTS_LENGTH_MISMATCH_1 +
            constructorName + ERROR_MSGS.ARGUMENTS_LENGTH_MISMATCH_2;
        throw new Error(error);
    }
    return targets;
}
function getConstructorArgsAsTarget(index, isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata) {
    var targetMetadata = constructorArgsMetadata[index.toString()] || [];
    var metadata = formatTargetMetadata(targetMetadata);
    var isManaged = metadata.unmanaged !== true;
    var serviceIndentifier = serviceIdentifiers[index];
    var injectIndentifier = (metadata.inject || metadata.multiInject);
    serviceIndentifier = (injectIndentifier) ? (injectIndentifier) : serviceIndentifier;
    if (isManaged === true) {
        var isObject = serviceIndentifier === Object;
        var isFunction = serviceIndentifier === Function;
        var isUndefined = serviceIndentifier === undefined;
        var isUnknownType = (isObject || isFunction || isUndefined);
        if (isBaseClass === false && isUnknownType) {
            var msg = ERROR_MSGS.MISSING_INJECT_ANNOTATION + " argument " + index + " in class " + constructorName + ".";
            throw new Error(msg);
        }
        var target = new target_1.Target(literal_types_1.TargetTypeEnum.ConstructorArgument, metadata.targetName, serviceIndentifier);
        target.metadata = targetMetadata;
        return target;
    }
    return null;
}
function getConstructorArgsAsTargets(isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata, iterations) {
    var targets = [];
    for (var i = 0; i < iterations; i++) {
        var index = i;
        var target = getConstructorArgsAsTarget(index, isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata);
        if (target !== null) {
            targets.push(target);
        }
    }
    return targets;
}
function getClassPropsAsTargets(metadataReader, constructorFunc) {
    var classPropsMetadata = metadataReader.getPropertiesMetadata(constructorFunc);
    var targets = [];
    var keys = Object.keys(classPropsMetadata);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var targetMetadata = classPropsMetadata[key];
        var metadata = formatTargetMetadata(classPropsMetadata[key]);
        var targetName = metadata.targetName || key;
        var serviceIndentifier = (metadata.inject || metadata.multiInject);
        var target = new target_1.Target(literal_types_1.TargetTypeEnum.ClassProperty, targetName, serviceIndentifier);
        target.metadata = targetMetadata;
        targets.push(target);
    }
    var baseConstructor = Object.getPrototypeOf(constructorFunc.prototype).constructor;
    if (baseConstructor !== Object) {
        var baseTargets = getClassPropsAsTargets(metadataReader, baseConstructor);
        targets = targets.concat(baseTargets);
    }
    return targets;
}
function getBaseClassDepencencyCount(metadataReader, func) {
    var baseConstructor = Object.getPrototypeOf(func.prototype).constructor;
    if (baseConstructor !== Object) {
        var baseConstructorName = serialization_1.getFunctionName(baseConstructor);
        var targets = getTargets(metadataReader, baseConstructorName, baseConstructor, true);
        var metadata = targets.map(function (t) {
            return t.metadata.filter(function (m) {
                return m.key === METADATA_KEY.UNMANAGED_TAG;
            });
        });
        var unmanagedCount = [].concat.apply([], metadata).length;
        var dependencyCount = targets.length - unmanagedCount;
        if (dependencyCount > 0) {
            return dependencyCount;
        }
        else {
            return getBaseClassDepencencyCount(metadataReader, baseConstructor);
        }
    }
    else {
        return 0;
    }
}
function formatTargetMetadata(targetMetadata) {
    var targetMetadataMap = {};
    targetMetadata.forEach(function (m) {
        targetMetadataMap[m.key.toString()] = m.value;
    });
    return {
        inject: targetMetadataMap[METADATA_KEY.INJECT_TAG],
        multiInject: targetMetadataMap[METADATA_KEY.MULTI_INJECT_TAG],
        targetName: targetMetadataMap[METADATA_KEY.NAME_TAG],
        unmanaged: targetMetadataMap[METADATA_KEY.UNMANAGED_TAG]
    };
}


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(60);
var Request = (function () {
    function Request(serviceIdentifier, parentContext, parentRequest, bindings, target) {
        this.guid = guid_1.guid();
        this.serviceIdentifier = serviceIdentifier;
        this.parentContext = parentContext;
        this.parentRequest = parentRequest;
        this.target = target;
        this.childRequests = [];
        this.bindings = (Array.isArray(bindings) ? bindings : [bindings]);
    }
    Request.prototype.addChildRequest = function (serviceIdentifier, bindings, target) {
        var child = new Request(serviceIdentifier, this.parentContext, this, bindings, target);
        this.childRequests.push(child);
        return child;
    };
    return Request;
}());
exports.Request = Request;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var literal_types_1 = __webpack_require__(51);
var METADATA_KEY = __webpack_require__(27);
var error_msgs_1 = __webpack_require__(36);
function _injectProperties(instance, childRequests, resolveRequest) {
    var propertyInjectionsRequests = childRequests.filter(function (childRequest) {
        return (childRequest.target !== null && childRequest.target.type === literal_types_1.TargetTypeEnum.ClassProperty);
    });
    var propertyInjections = propertyInjectionsRequests.map(function (childRequest) {
        return resolveRequest(childRequest);
    });
    propertyInjectionsRequests.forEach(function (r, index) {
        var propertyName = "";
        propertyName = r.target.name.value();
        var injection = propertyInjections[index];
        instance[propertyName] = injection;
    });
    return instance;
}
function _createInstance(Func, injections) {
    return new (Func.bind.apply(Func, [void 0].concat(injections)))();
}
function _postConstruct(constr, result) {
    if (Reflect.hasOwnMetadata(METADATA_KEY.POST_CONSTRUCT, constr)) {
        var data = Reflect.getMetadata(METADATA_KEY.POST_CONSTRUCT, constr);
        try {
            result[data.value]();
        }
        catch (e) {
            throw new Error(error_msgs_1.POST_CONSTRUCT_ERROR(constr.name, e.message));
        }
    }
}
function resolveInstance(constr, childRequests, resolveRequest) {
    var result = null;
    if (childRequests.length > 0) {
        var constructorInjectionsRequests = childRequests.filter(function (childRequest) {
            return (childRequest.target !== null && childRequest.target.type === literal_types_1.TargetTypeEnum.ConstructorArgument);
        });
        var constructorInjections = constructorInjectionsRequests.map(function (childRequest) {
            return resolveRequest(childRequest);
        });
        result = _createInstance(constr, constructorInjections);
        result = _injectProperties(result, childRequests, resolveRequest);
    }
    else {
        result = new constr();
    }
    _postConstruct(constr, result);
    return result;
}
exports.resolveInstance = resolveInstance;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var literal_types_1 = __webpack_require__(51);
var serialization_1 = __webpack_require__(81);
var instantiation_1 = __webpack_require__(408);
var ERROR_MSGS = __webpack_require__(36);
function _resolveRequest(request) {
    var bindings = request.bindings;
    var childRequests = request.childRequests;
    var targetIsAnAray = request.target && request.target.isArray();
    var targetParentIsNotAnArray = !request.parentRequest ||
        !request.parentRequest.target ||
        !request.target ||
        !request.parentRequest.target.matchesArray(request.target.serviceIdentifier);
    if (targetIsAnAray && targetParentIsNotAnArray) {
        return childRequests.map(function (childRequest) {
            return _resolveRequest(childRequest);
        });
    }
    else {
        var result = null;
        if (request.target.isOptional() === true && bindings.length === 0) {
            return undefined;
        }
        var binding = bindings[0];
        var isSingleton = binding.scope === literal_types_1.BindingScopeEnum.Singleton;
        if (isSingleton && binding.activated === true) {
            return binding.cache;
        }
        if (binding.type === literal_types_1.BindingTypeEnum.ConstantValue) {
            result = binding.cache;
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Function) {
            result = binding.cache;
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Constructor) {
            result = binding.implementationType;
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.DynamicValue && binding.dynamicValue !== null) {
            result = binding.dynamicValue(request.parentContext);
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Factory && binding.factory !== null) {
            result = binding.factory(request.parentContext);
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Provider && binding.provider !== null) {
            result = binding.provider(request.parentContext);
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Instance && binding.implementationType !== null) {
            result = instantiation_1.resolveInstance(binding.implementationType, childRequests, _resolveRequest);
        }
        else {
            var serviceIdentifier = serialization_1.getServiceIdentifierAsString(request.serviceIdentifier);
            throw new Error(ERROR_MSGS.INVALID_BINDING_TYPE + " " + serviceIdentifier);
        }
        if (typeof binding.onActivation === "function") {
            result = binding.onActivation(request.parentContext, result);
        }
        if (isSingleton) {
            binding.cache = result;
            binding.activated = true;
        }
        return result;
    }
}
function resolve(context) {
    return _resolveRequest(context.plan.rootRequest);
}
exports.resolve = resolve;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var literal_types_1 = __webpack_require__(51);
var binding_when_on_syntax_1 = __webpack_require__(204);
var BindingInSyntax = (function () {
    function BindingInSyntax(binding) {
        this._binding = binding;
    }
    BindingInSyntax.prototype.inSingletonScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Singleton;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingInSyntax.prototype.inTransientScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Transient;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    return BindingInSyntax;
}());
exports.BindingInSyntax = BindingInSyntax;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_in_syntax_1 = __webpack_require__(410);
var binding_when_syntax_1 = __webpack_require__(137);
var binding_on_syntax_1 = __webpack_require__(136);
var BindingInWhenOnSyntax = (function () {
    function BindingInWhenOnSyntax(binding) {
        this._binding = binding;
        this._bindingWhenSyntax = new binding_when_syntax_1.BindingWhenSyntax(this._binding);
        this._bindingOnSyntax = new binding_on_syntax_1.BindingOnSyntax(this._binding);
        this._bindingInSyntax = new binding_in_syntax_1.BindingInSyntax(binding);
    }
    BindingInWhenOnSyntax.prototype.inSingletonScope = function () {
        return this._bindingInSyntax.inSingletonScope();
    };
    BindingInWhenOnSyntax.prototype.inTransientScope = function () {
        return this._bindingInSyntax.inTransientScope();
    };
    BindingInWhenOnSyntax.prototype.when = function (constraint) {
        return this._bindingWhenSyntax.when(constraint);
    };
    BindingInWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._bindingWhenSyntax.whenTargetNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenTargetIsDefault = function () {
        return this._bindingWhenSyntax.whenTargetIsDefault();
    };
    BindingInWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenTargetTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._bindingWhenSyntax.whenInjectedInto(parent);
    };
    BindingInWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._bindingWhenSyntax.whenParentNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenParentTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenAnyAncestorNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenNoAncestorNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
    };
    BindingInWhenOnSyntax.prototype.onActivation = function (handler) {
        return this._bindingOnSyntax.onActivation(handler);
    };
    return BindingInWhenOnSyntax;
}());
exports.BindingInWhenOnSyntax = BindingInWhenOnSyntax;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_in_when_on_syntax_1 = __webpack_require__(411);
var binding_when_on_syntax_1 = __webpack_require__(204);
var literal_types_1 = __webpack_require__(51);
var ERROR_MSGS = __webpack_require__(36);
var BindingToSyntax = (function () {
    function BindingToSyntax(binding) {
        this._binding = binding;
    }
    BindingToSyntax.prototype.to = function (constructor) {
        this._binding.type = literal_types_1.BindingTypeEnum.Instance;
        this._binding.implementationType = constructor;
        return new binding_in_when_on_syntax_1.BindingInWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toSelf = function () {
        if (typeof this._binding.serviceIdentifier !== "function") {
            throw new Error("" + ERROR_MSGS.INVALID_TO_SELF_VALUE);
        }
        var self = this._binding.serviceIdentifier;
        return this.to(self);
    };
    BindingToSyntax.prototype.toConstantValue = function (value) {
        this._binding.type = literal_types_1.BindingTypeEnum.ConstantValue;
        this._binding.cache = value;
        this._binding.dynamicValue = null;
        this._binding.implementationType = null;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toDynamicValue = function (func) {
        this._binding.type = literal_types_1.BindingTypeEnum.DynamicValue;
        this._binding.cache = null;
        this._binding.dynamicValue = func;
        this._binding.implementationType = null;
        return new binding_in_when_on_syntax_1.BindingInWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toConstructor = function (constructor) {
        this._binding.type = literal_types_1.BindingTypeEnum.Constructor;
        this._binding.implementationType = constructor;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toFactory = function (factory) {
        this._binding.type = literal_types_1.BindingTypeEnum.Factory;
        this._binding.factory = factory;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toFunction = function (func) {
        if (typeof func !== "function") {
            throw new Error(ERROR_MSGS.INVALID_FUNCTION_BINDING);
        }
        var bindingWhenOnSyntax = this.toConstantValue(func);
        this._binding.type = literal_types_1.BindingTypeEnum.Function;
        return bindingWhenOnSyntax;
    };
    BindingToSyntax.prototype.toAutoFactory = function (serviceIdentifier) {
        this._binding.type = literal_types_1.BindingTypeEnum.Factory;
        this._binding.factory = function (context) {
            return function () {
                return context.container.get(serviceIdentifier);
            };
        };
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toProvider = function (provider) {
        this._binding.type = literal_types_1.BindingTypeEnum.Provider;
        this._binding.provider = provider;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    return BindingToSyntax;
}());
exports.BindingToSyntax = BindingToSyntax;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function template(strings) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return (function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var result = [strings[0]];
        keys.forEach(function (key, i) {
            var value = Number.isInteger(key) ? values[key] : values[keys.indexOf(key)];
            result.push(value, strings[i + 1]);
        });
        return result.join("");
    });
}
exports.template = template;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(3));
	else if(typeof define === 'function' && define.amd)
		define("MobxReactRouter", ["mobx"], factory);
	else if(typeof exports === 'object')
		exports["MobxReactRouter"] = factory(require("mobx"));
	else
		root["MobxReactRouter"] = factory(root["Mobx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(2);

Object.keys(_store).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _store[key];
    }
  });
});

var _sync = __webpack_require__(3);

Object.keys(_sync).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sync[key];
    }
  });
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouterStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor;

var _mobx = __webpack_require__(0);

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RouterStore = exports.RouterStore = (_class = function () {
  function RouterStore() {
    _classCallCheck(this, RouterStore);

    _initDefineProp(this, 'location', _descriptor, this);

    this.history = null;

    this.push = this.push.bind(this);
    this.replace = this.replace.bind(this);
    this.go = this.go.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goForward = this.goForward.bind(this);
  }

  _createClass(RouterStore, [{
    key: '_updateLocation',
    value: function _updateLocation(newState) {
      this.location = newState;
    }

    /*
     * History methods
     */

  }, {
    key: 'push',
    value: function push(location) {
      this.history.push(location);
    }
  }, {
    key: 'replace',
    value: function replace(location) {
      this.history.replace(location);
    }
  }, {
    key: 'go',
    value: function go(n) {
      this.history.go(n);
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      this.history.goBack();
    }
  }, {
    key: 'goForward',
    value: function goForward() {
      this.history.goForward();
    }
  }]);

  return RouterStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'location', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, '_updateLocation', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, '_updateLocation'), _class.prototype)), _class);
;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncHistoryWithStore = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mobx = __webpack_require__(0);

var syncHistoryWithStore = exports.syncHistoryWithStore = function syncHistoryWithStore(history, store) {
  // Initialise store
  store.history = history;

  // Handle update from history object
  var handleLocationChange = function handleLocationChange(location) {
    store._updateLocation(location);
  };

  var unsubscribeFromHistory = history.listen(handleLocationChange);
  handleLocationChange(history.location);

  var subscribe = function subscribe(listener) {
    var onStoreChange = function onStoreChange(change) {
      var rawLocation = _extends({}, store.location);
      listener(rawLocation, history.action);
    };

    // Listen for changes to location state in store
    var unsubscribeFromStore = (0, _mobx.observe)(store, 'location', onStoreChange);

    listener(store.location, history.action);

    return function () {
      unsubscribeFromStore();
    };
  };
  var unsubscribe = function unsubscribe() {
    return unsubscribeFromHistory();
  };

  history.subscribe = subscribe;
  history.unsubscribe = unsubscribe;

  return history;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ })
/******/ ]);
});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(414)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(34);
var invariant = __webpack_require__(15);
var ReactPropTypesSecret = __webpack_require__(207);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(34);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

var ReactPropTypesSecret = __webpack_require__(207);
var checkPropTypes = __webpack_require__(417);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelGroup__ = __webpack_require__(225);








var Accordion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Accordion, _React$Component);

  function Accordion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Accordion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__PanelGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloseButton__ = __webpack_require__(211);














var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Alert, _React$Component);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'alert',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      dismissable && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CloseButton__["a" /* default */], {
        onClick: onDismiss,
        label: closeLabel
      }),
      children
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsStyles"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */].INFO, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('alert', Alert)));

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  pullRight: false
};

var Badge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('badge', Badge));

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var Breadcrumb = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Breadcrumb);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ol', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('breadcrumb', Breadcrumb));

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var ButtonToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonToolbar);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'toolbar',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('btn-toolbar', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsSizes"])(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].SIZES, ButtonToolbar)));

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Glyphicon__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(32);
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  interval: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any) => any | (eventKey: any, event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

  function Carousel(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }
  };

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ol',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(children);

    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'prev',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'next',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'inner') },
        __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

Carousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('carousel', Carousel));

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselCaption);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('carousel-caption', CarouselCaption));

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        null,
        input,
        children
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('checkbox', Checkbox));

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(29);














var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div'
};

var Clearfix = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Clearfix, _React$Component);

  function Clearfix() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Clearfix);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = 'visible' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('clearfix', Clearfix));

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(29);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  componentClass: 'div'
};

var Col = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Col, _React$Component);

  function Col() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Col);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('col', Col));

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var ControlLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ControlLabel, _React$Component);

  function ControlLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlLabel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('control-label', ControlLabel));

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(98);











var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var DropdownButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownButton, _React$Component);

  function DropdownButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (DropdownButton);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(32);

















var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
          role: 'menu',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('dropdown-menu', DropdownMenu));

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Form);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('form', Form));

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__ = __webpack_require__(29);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControl, _React$Component);

  function FormControl() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["a" /* SIZE_MAP */][bsSize] || bsSize;
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])({ bsClass: 'input' }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('form-control', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* Size */].LARGE], FormControl)));

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Glyphicon__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControlFeedback = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlFeedback);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Glyphicon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlStatic);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('form-control-static', FormControlStatic));

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(32);













var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};

var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var FormGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormGroup, _React$Component);

  function FormGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('form-group', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var HelpBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HelpBlock, _React$Component);

  function HelpBlock() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HelpBlock);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('help-block', HelpBlock));

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'responsive')] = responsive, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'rounded')] = rounded, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'circle')] = circle, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'thumbnail')] = thumbnail, _classes);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('img', Image));

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(29);













var InputGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroup, _React$Component);

  function InputGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('input-group', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["b" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var InputGroupAddon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupAddon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('input-group-addon', InputGroupAddon));

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var InputGroupButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('input-group-btn', InputGroupButton));

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Jumbotron = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Jumbotron, _React$Component);

  function Jumbotron() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Jumbotron);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('jumbotron', Jumbotron));

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(29);












var Label = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Label, _React$Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('label', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsStyles"])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].DEFAULT, Label)));

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(32);













var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListGroup, _React$Component);

  function ListGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      useListItem ? __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListGroup.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('list-group', ListGroup));

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var MediaBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaBody, _React$Component);

  function MediaBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('media-body', MediaBody));

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaHeading, _React$Component);

  function MediaHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('media-heading', MediaHeading));

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaLeft, _React$Component);

  function MediaLeft() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaLeft);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaLeft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('media-left', MediaLeft));

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var MediaList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaList, _React$Component);

  function MediaList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('media-list', MediaList));

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var MediaListItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaListItem, _React$Component);

  function MediaListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('media', MediaListItem));

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaRight, _React$Component);

  function MediaRight() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaRight);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaRight.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('media-right', MediaRight));

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(28);














var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'separator',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'heading',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('dropdown', MenuItem));

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fade__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalBody__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDialog__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFooter__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalTitle__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__ = __webpack_require__(29);




























var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */].propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_15_react_prop_types_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  })
};

var Modal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

  function Modal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        backdrop = _props.backdrop,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseModalProps, {
        ref: function ref(c) {
          _this2._modal = c;
        },
        show: show,
        onEntering: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
        onExited: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited),
        backdrop: backdrop,
        backdropClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["prefix"])(props, 'backdrop'), inClassName),
        containerClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["prefix"])(props, 'open'),
        transition: animation ? __WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */] : undefined,
        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
      }),
      __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        Dialog,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dialogProps, {
          style: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.state.style, style),
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;

Modal.Body = __WEBPACK_IMPORTED_MODULE_17__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_21__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_19__ModalFooter__["a" /* default */];

Modal.Dialog = __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */];

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["bsClass"])('modal', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["b" /* Size */].SMALL], Modal)));

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(29);












var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ModalDialog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalDialog, _React$Component);

  function ModalDialog() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalDialog);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps);

    var modalStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ display: 'block' }, style);

    var dialogClasses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dialogClassName, dialogClasses) },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalDialog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(32);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

var NavDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NavDropdown, _React$Component);

  function NavDropdown() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavDropdown);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        componentClass: 'li',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }),
        style: style
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavDropdown.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavDropdown);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__ = __webpack_require__(28);





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
   * boolean value.
   *
   * @controllable navExpanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var Navbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navbar, _React$Component);

  function Navbar(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Navbar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].INVERSE;
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(bsProps, 'fixed-top')] = fixedTop, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Grid__["a" /* default */],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["bsClass"])('navbar', Navbar);

var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(navbarProps, suffix), pullRight && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(navbarProps, 'right'), pullLeft && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__["a" /* default */];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["bsStyles"])([__WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var NavbarCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarCollapse);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'collapse');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': navbarProps.expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'header');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(28);












var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      type: 'button'
    }, props, {
      onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'button',
      buttonProps,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(28);















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {

  /**
  * Specify which action or actions trigger Overlay visibility
  */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
  * @private
  */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this2 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this2._hoverShowDelay = null;
      _this2.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this3 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this3._hoverHideDelay = null;
      _this3.hide();
    }, delay);
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent.toElement;

    if (!related || related !== target && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var PageHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PageHeader, _React$Component);

  function PageHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('page-header', PageHeader));

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(481);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PagerItem__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(32);














var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Pager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pager, _React$Component);

  function Pager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pager);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pager.propTypes = propTypes;

Pager.Item = __WEBPACK_IMPORTED_MODULE_8__PagerItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('pager', Pager));

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaginationButton__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);













var propTypes = {
  activePage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  items: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  maxButtons: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * When `true`, will display the first and the last button page when
   * displaying ellipsis.
   */
  boundaryLinks: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * When `true`, will display the default node value ('&hellip;').
   * Otherwise, will display provided node (when specified).
   */
  ellipsis: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&laquo;').
   * Otherwise, will display provided node (when specified).
   */
  first: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&raquo;').
   * Otherwise, will display provided node (when specified).
   */
  last: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&lsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  prev: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&rsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * You can use a custom element for the buttons
   */
  buttonComponentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  activePage: 1,
  items: 1,
  maxButtons: 0,
  first: false,
  last: false,
  prev: false,
  next: false,
  ellipsis: true,
  boundaryLinks: false
};

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
    var pageButtons = [];

    var startPage = void 0;
    var endPage = void 0;

    if (maxButtons && maxButtons < items) {
      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
      endPage = startPage + maxButtons - 1;
    } else {
      startPage = 1;
      endPage = items;
    }

    for (var page = startPage; page <= endPage; ++page) {
      pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: page,
          eventKey: page,
          active: page === activePage
        }),
        page
      ));
    }

    if (ellipsis && boundaryLinks && startPage > 1) {
      if (startPage > 2) {
        pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsisFirst',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: 1,
          eventKey: 1,
          active: false
        }),
        '1'
      ));
    }

    if (ellipsis && endPage < items) {
      if (!boundaryLinks || endPage < items - 1) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsis',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      if (boundaryLinks) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
            key: items,
            eventKey: items,
            active: false
          }),
          items
        ));
      }
    }

    return pageButtons;
  };

  Pagination.prototype.render = function render() {
    var _props = this.props,
        activePage = _props.activePage,
        items = _props.items,
        maxButtons = _props.maxButtons,
        boundaryLinks = _props.boundaryLinks,
        ellipsis = _props.ellipsis,
        first = _props.first,
        last = _props.last,
        prev = _props.prev,
        next = _props.next,
        onSelect = _props.onSelect,
        buttonComponentClass = _props.buttonComponentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps);

    var buttonProps = {
      onSelect: onSelect,
      componentClass: buttonComponentClass
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      first && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'First' },
          first === true ? '\xAB' : first
        )
      ),
      prev && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage - 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Previous' },
          prev === true ? '\u2039' : prev
        )
      ),
      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
      next && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage + 1,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Next' },
          next === true ? '\u203A' : next
        )
      ),
      last && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: items,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Last' },
          last === true ? '\xBB' : last
        )
      )
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('pagination', Pagination));

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(29);














// TODO: Use uncontrollable.

var propTypes = {
  collapsible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  footer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  defaultExpanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  expanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  eventKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  headerRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  panelRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  // From Collapse.
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};

var defaultProps = {
  defaultExpanded: false
};

var Panel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Panel, _React$Component);

  function Panel(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Panel);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClickTitle = _this.handleClickTitle.bind(_this);

    _this.state = {
      expanded: _this.props.defaultExpanded
    };
    return _this;
  }

  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
    // FIXME: What the heck? This API is horrible. This needs to go away!
    e.persist();
    e.selected = true;

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    } else {
      e.preventDefault();
    }

    if (e.selected) {
      this.setState({ expanded: !this.state.expanded });
    }
  };

  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
    var titleClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'title');

    if (!collapsible) {
      if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
        return header;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName)
      });
    }

    if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'h4',
        { role: 'presentation', className: titleClassName },
        this.renderAnchor(header, id, role, expanded)
      );
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName),
      children: this.renderAnchor(header.props.children, id, role, expanded)
    });
  };

  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'a',
      {
        role: role,
        href: id && '#' + id,
        onClick: this.handleClickTitle,
        'aria-controls': id,
        'aria-expanded': expanded,
        'aria-selected': expanded,
        className: expanded ? null : 'collapsed'
      },
      header
    );
  };

  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ 'in': expanded }, animationHooks),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        {
          id: id,
          role: role,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'collapse'),
          'aria-hidden': !expanded
        },
        this.renderBody(children, bsProps)
      )
    );
  };

  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
    var children = [];
    var bodyChildren = [];

    var bodyClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'body');

    function maybeAddBody() {
      if (!bodyChildren.length) {
        return;
      }

      // Derive the key from the index here, since we need to make one up.
      children.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { key: children.length, className: bodyClassName },
        bodyChildren
      ));

      bodyChildren = [];
    }

    // Convert to array so we can re-use keys.
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.toArray(rawChildren).forEach(function (child) {
      if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) && child.props.fill) {
        maybeAddBody();

        // Remove the child's unknown `fill` prop.
        children.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { fill: undefined }));

        return;
      }

      bodyChildren.push(child);
    });

    maybeAddBody();

    return children;
  };

  Panel.prototype.render = function render() {
    var _props = this.props,
        collapsible = _props.collapsible,
        header = _props.header,
        id = _props.id,
        footer = _props.footer,
        propsExpanded = _props.expanded,
        headerRole = _props.headerRole,
        panelRole = _props.panelRole,
        className = _props.className,
        children = _props.children,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['defaultExpanded', 'eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        id: collapsible ? null : id
      }),
      header && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'heading') },
        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
      ),
      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
      footer && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'footer') },
        footer
      )
    );
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('panel', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsStyles"])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, Panel)));

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Popover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h3',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'title') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('popover', Popover));

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(32);














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    if (child.type === ProgressBar) {
      // eslint-disable-line no-use-before-define
      return;
    }

    var childIdentifier = __WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {
      active: active
    }, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'progressbar',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wrapperProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'progress')
      }),
      children ? __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('progress-bar', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsStyles"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), ProgressBar)));

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false
};

var Radio = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Radio, _React$Component);

  function Radio() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Radio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        null,
        input,
        children
      )
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('radio', Radio));

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












// TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponsiveEmbed);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, '16by9')] = a16by9, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes) },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Row = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Row, _React$Component);

  function Row() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Row);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('row', Row));

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitToggle__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__ = __webpack_require__(98);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var SplitButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitButton, _React$Component);

  function SplitButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */], {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SplitButton.propTypes = propTypes;

SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SplitButton);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__ = __webpack_require__(212);








var SplitToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitToggle, _React$Component);

  function SplitToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitToggle);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */].defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabContainer__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabContent__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabPane__ = __webpack_require__(226);











var propTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */].propTypes, {

  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});

var Tab = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Tab, _React$Component);

  function Tab() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tab.propTypes = propTypes;

Tab.Container = __WEBPACK_IMPORTED_MODULE_6__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_7__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'striped')] = striped, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'bordered')] = bordered, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'condensed')] = condensed, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('table', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('table', Table));

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_isRequiredForA11y__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Nav__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContainer__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabContent__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(32);

















var TabContainer = __WEBPACK_IMPORTED_MODULE_11__TabContainer__["a" /* default */].ControlledComponent;

var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['tabs', 'pills']),

  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  id: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */],
      {
        eventKey: eventKey,
        disabled: disabled,
        className: tabClassName
      },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Nav__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
            role: 'tablist'
          }),
          __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__TabContent__["a" /* default */],
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__["bsClass"])('tab', Tabs);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Tabs, { activeKey: 'onSelect' }));

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  alt: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var Thumbnail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['src', 'alt', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */] : 'div';
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: src, alt: alt }),
      children && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Thumbnail.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('thumbnail', Thumbnail));

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'arrow'), style: arrowStyle }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('tooltip', Tooltip));

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(29);











var Well = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Well, _React$Component);

  function Well() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Well);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('well', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["b" /* Size */].SMALL], Well)));

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["b"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_prop_types_lib_utils_createChainableTypeChecker__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_prop_types_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_prop_types_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__ = __webpack_require__(32);




function requiredRoles() {
  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
    roles[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react_prop_types_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react_prop_types_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 *
 * This file contains a modified version of:
 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
 *
 * This source code is licensed under the BSD-style license found here:
 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
 * An additional grant of patent rights can be found here:
 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
 */

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    // eslint-disable-line guard-for-in
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ReactTransitionEvents);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeprecatedComponent);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(12);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "bootstrapUtils", function() { return __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createChainedFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ValidComponentChildren", function() { return __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a"]; });







/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(24);

var focusNode = __webpack_require__(196);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(31);
var FallbackCompositionState = __webpack_require__(491);
var SyntheticCompositionEvent = __webpack_require__(528);
var SyntheticInputEvent = __webpack_require__(531);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(228);
var ExecutionEnvironment = __webpack_require__(31);
var ReactInstrumentation = __webpack_require__(38);

var camelizeStyleName = __webpack_require__(362);
var dangerousStyleValue = __webpack_require__(537);
var hyphenateStyleName = __webpack_require__(369);
var memoizeStringOnly = __webpack_require__(372);
var warning = __webpack_require__(17);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(83);
var EventPropagators = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactUpdates = __webpack_require__(42);
var SyntheticEvent = __webpack_require__(43);

var inputValueTracking = __webpack_require__(244);
var getEventTarget = __webpack_require__(157);
var isEventSupported = __webpack_require__(158);
var isTextInputElement = __webpack_require__(246);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var DOMLazyTree = __webpack_require__(69);
var ExecutionEnvironment = __webpack_require__(31);

var createNodesFromMarkup = __webpack_require__(365);
var emptyFunction = __webpack_require__(34);
var invariant = __webpack_require__(15);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(24);
var SyntheticMouseEvent = __webpack_require__(100);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var PooledClass = __webpack_require__(61);

var getTextContentAccessor = __webpack_require__(243);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(70);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(71);

var instantiateReactComponent = __webpack_require__(245);
var KeyEscapeUtils = __webpack_require__(149);
var shouldUpdateReactComponent = __webpack_require__(159);
var traverseAllChildren = __webpack_require__(248);
var warning = __webpack_require__(17);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(258);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(145);
var ReactDOMIDOperations = __webpack_require__(501);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var React = __webpack_require__(72);
var ReactComponentEnvironment = __webpack_require__(151);
var ReactCurrentOwner = __webpack_require__(44);
var ReactErrorUtils = __webpack_require__(152);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(38);
var ReactNodeTypes = __webpack_require__(238);
var ReactReconciler = __webpack_require__(71);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(94);
var invariant = __webpack_require__(15);
var shallowEqual = __webpack_require__(131);
var shouldUpdateReactComponent = __webpack_require__(159);
var warning = __webpack_require__(17);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(24);
var ReactDefaultInjection = __webpack_require__(509);
var ReactMount = __webpack_require__(237);
var ReactReconciler = __webpack_require__(71);
var ReactUpdates = __webpack_require__(42);
var ReactVersion = __webpack_require__(522);

var findDOMNode = __webpack_require__(538);
var getHostComponentFromComposite = __webpack_require__(242);
var renderSubtreeIntoContainer = __webpack_require__(545);
var warning = __webpack_require__(17);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var AutoFocusUtils = __webpack_require__(484);
var CSSPropertyOperations = __webpack_require__(486);
var DOMLazyTree = __webpack_require__(69);
var DOMNamespaces = __webpack_require__(146);
var DOMProperty = __webpack_require__(70);
var DOMPropertyOperations = __webpack_require__(230);
var EventPluginHub = __webpack_require__(83);
var EventPluginRegistry = __webpack_require__(147);
var ReactBrowserEventEmitter = __webpack_require__(99);
var ReactDOMComponentFlags = __webpack_require__(231);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactDOMInput = __webpack_require__(502);
var ReactDOMOption = __webpack_require__(503);
var ReactDOMSelect = __webpack_require__(232);
var ReactDOMTextarea = __webpack_require__(506);
var ReactInstrumentation = __webpack_require__(38);
var ReactMultiChild = __webpack_require__(515);
var ReactServerRenderingTransaction = __webpack_require__(520);

var emptyFunction = __webpack_require__(34);
var escapeTextContentForBrowser = __webpack_require__(102);
var invariant = __webpack_require__(15);
var isEventSupported = __webpack_require__(158);
var shallowEqual = __webpack_require__(131);
var inputValueTracking = __webpack_require__(244);
var validateDOMNesting = __webpack_require__(160);
var warning = __webpack_require__(17);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(160);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var DOMLazyTree = __webpack_require__(69);
var ReactDOMComponentTree = __webpack_require__(24);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(145);
var ReactDOMComponentTree = __webpack_require__(24);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var DOMPropertyOperations = __webpack_require__(230);
var LinkedValueUtils = __webpack_require__(150);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactUpdates = __webpack_require__(42);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var React = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactDOMSelect = __webpack_require__(232);

var warning = __webpack_require__(17);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var getNodeForCharacterOffset = __webpack_require__(542);
var getTextContentAccessor = __webpack_require__(243);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var DOMChildrenOperations = __webpack_require__(145);
var DOMLazyTree = __webpack_require__(69);
var ReactDOMComponentTree = __webpack_require__(24);

var escapeTextContentForBrowser = __webpack_require__(102);
var invariant = __webpack_require__(15);
var validateDOMNesting = __webpack_require__(160);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18),
    _assign = __webpack_require__(23);

var LinkedValueUtils = __webpack_require__(150);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactUpdates = __webpack_require__(42);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var ReactUpdates = __webpack_require__(42);
var Transaction = __webpack_require__(101);

var emptyFunction = __webpack_require__(34);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(483);
var BeforeInputEventPlugin = __webpack_require__(485);
var ChangeEventPlugin = __webpack_require__(487);
var DefaultEventPluginOrder = __webpack_require__(489);
var EnterLeaveEventPlugin = __webpack_require__(490);
var HTMLDOMPropertyConfig = __webpack_require__(492);
var ReactComponentBrowserEnvironment = __webpack_require__(494);
var ReactDOMComponent = __webpack_require__(497);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactDOMEmptyComponent = __webpack_require__(499);
var ReactDOMTreeTraversal = __webpack_require__(507);
var ReactDOMTextComponent = __webpack_require__(505);
var ReactDefaultBatchingStrategy = __webpack_require__(508);
var ReactEventListener = __webpack_require__(512);
var ReactInjection = __webpack_require__(513);
var ReactReconcileTransaction = __webpack_require__(518);
var SVGDOMPropertyConfig = __webpack_require__(523);
var SelectEventPlugin = __webpack_require__(524);
var SimpleEventPlugin = __webpack_require__(525);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(83);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var EventListener = __webpack_require__(195);
var ExecutionEnvironment = __webpack_require__(31);
var PooledClass = __webpack_require__(61);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactUpdates = __webpack_require__(42);

var getEventTarget = __webpack_require__(157);
var getUnboundedScrollPosition = __webpack_require__(367);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(70);
var EventPluginHub = __webpack_require__(83);
var EventPluginUtils = __webpack_require__(148);
var ReactComponentEnvironment = __webpack_require__(151);
var ReactEmptyComponent = __webpack_require__(233);
var ReactBrowserEventEmitter = __webpack_require__(99);
var ReactHostComponent = __webpack_require__(235);
var ReactUpdates = __webpack_require__(42);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(536);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var ReactComponentEnvironment = __webpack_require__(151);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(44);
var ReactReconciler = __webpack_require__(71);
var ReactChildReconciler = __webpack_require__(493);

var emptyFunction = __webpack_require__(34);
var flattenChildren = __webpack_require__(539);
var invariant = __webpack_require__(15);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var invariant = __webpack_require__(15);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var CallbackQueue = __webpack_require__(229);
var PooledClass = __webpack_require__(61);
var ReactBrowserEventEmitter = __webpack_require__(99);
var ReactInputSelection = __webpack_require__(236);
var ReactInstrumentation = __webpack_require__(38);
var Transaction = __webpack_require__(101);
var ReactUpdateQueue = __webpack_require__(153);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(516);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(23);

var PooledClass = __webpack_require__(61);
var Transaction = __webpack_require__(101);
var ReactInstrumentation = __webpack_require__(38);
var ReactServerUpdateQueue = __webpack_require__(521);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(153);

var warning = __webpack_require__(17);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactInputSelection = __webpack_require__(236);
var SyntheticEvent = __webpack_require__(43);

var getActiveElement = __webpack_require__(197);
var isTextInputElement = __webpack_require__(246);
var shallowEqual = __webpack_require__(131);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(18);

var EventListener = __webpack_require__(195);
var EventPropagators = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(24);
var SyntheticAnimationEvent = __webpack_require__(526);
var SyntheticClipboardEvent = __webpack_require__(527);
var SyntheticEvent = __webpack_require__(43);
var SyntheticFocusEvent = __webpack_require__(530);
var SyntheticKeyboardEvent = __webpack_require__(532);
var SyntheticMouseEvent = __webpack_require__(100);
var SyntheticDragEvent = __webpack_require__(529);
var SyntheticTouchEvent = __webpack_require__(533);
var SyntheticTransitionEvent = __webpack_require__(534);
var SyntheticUIEvent = __webpack_require__(86);
var SyntheticWheelEvent = __webpack_require__(535);

var emptyFunction = __webpack_require__(34);
var getEventCharCode = __webpack_require__(155);
var invariant = __webpack_require__(15);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(43);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(43);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(43);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(100);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(86);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(43);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(86);

var getEventCharCode = __webpack_require__(155);
var getEventKey = __webpack_require__(540);
var getEventModifierState = __webpack_require__(156);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(86);

var getEventModifierState = __webpack_require__(156);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(43);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(100);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(228);
var warning = __webpack_require__(17);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(18);

var ReactCurrentOwner = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(24);
var ReactInstanceMap = __webpack_require__(85);

var getHostComponentFromComposite = __webpack_require__(242);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(17);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(149);
var traverseAllChildren = __webpack_require__(248);
var warning = __webpack_require__(17);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(258);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139)))

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(155);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(102);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(237);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(26);

var _warning2 = _interopRequireDefault(_warning);

var _componentOrElement = __webpack_require__(162);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _elementType = __webpack_require__(19);

var _elementType2 = _interopRequireDefault(_elementType);

var _Portal = __webpack_require__(249);

var _Portal2 = _interopRequireDefault(_Portal);

var _ModalManager = __webpack_require__(548);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _ownerDocument = __webpack_require__(87);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _addEventListener = __webpack_require__(252);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(551);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _inDOM = __webpack_require__(49);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _activeElement = __webpack_require__(188);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(68);

var _contains2 = _interopRequireDefault(_contains);

var _getContainer = __webpack_require__(161);

var _getContainer2 = _interopRequireDefault(_getContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/prop-types */


var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'omitProps',
    value: function omitProps(props, propTypes) {

      var keys = Object.keys(props);
      var newProps = {};
      keys.map(function (prop) {
        if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
          newProps[prop] = props[prop];
        }
      });

      return newProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var show = _props.show;
      var container = _props.container;
      var children = _props.children;
      var Transition = _props.transition;
      var backdrop = _props.backdrop;
      var dialogTransitionTimeout = _props.dialogTransitionTimeout;
      var className = _props.className;
      var style = _props.style;
      var onExit = _props.onExit;
      var onExiting = _props.onExiting;
      var onEnter = _props.onEnter;
      var onEntering = _props.onEntering;
      var onEntered = _props.onEntered;


      var dialog = _react2.default.Children.only(children);
      var filteredProps = this.omitProps(this.props, Modal.propTypes);

      var mountModal = show || Transition && !this.state.exited;
      if (!mountModal) {
        return null;
      }

      var _dialog$props = dialog.props;
      var role = _dialog$props.role;
      var tabIndex = _dialog$props.tabIndex;


      if (role === undefined || tabIndex === undefined) {
        dialog = (0, _react.cloneElement)(dialog, {
          role: role === undefined ? 'document' : role,
          tabIndex: tabIndex == null ? '-1' : tabIndex
        });
      }

      if (Transition) {
        dialog = _react2.default.createElement(
          Transition,
          {
            transitionAppear: true,
            unmountOnExit: true,
            'in': show,
            timeout: dialogTransitionTimeout,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
          },
          dialog
        );
      }

      return _react2.default.createElement(
        _Portal2.default,
        {
          ref: this.setMountNode,
          container: container
        },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setModalNode,
            role: role || 'dialog'
          }, filteredProps, {
            style: style,
            className: className
          }),
          backdrop && this.renderBackdrop(),
          dialog
        )
      );
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({ exited: false });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (!this.props.show && nextProps.show) {
        this.checkForFocus();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      if (this.props.show) {
        this.onShow();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var transition = this.props.transition;


      if (prevProps.show && !this.props.show && !transition) {
        // Otherwise handleHidden will call this.
        this.onHide();
      } else if (!prevProps.show && this.props.show) {
        this.onShow();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props;
      var show = _props2.show;
      var transition = _props2.transition;


      this._isMounted = false;

      if (show || transition && !this.state.exited) {
        this.onHide();
      }
    }

    //instead of a ref, which might conflict with one the parent applied.

  }]);

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyUp: _propTypes2.default.func,

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `<Transition/>` component to use for the dialog and backdrop components.
   */
  transition: _elementType2.default,

  /**
   * The `timeout` of the dialog transition if specified. This number is used to ensure that
   * transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  dialogTransitionTimeout: _propTypes2.default.number,

  /**
   * The `timeout` of the backdrop transition if specified. This number is used to
   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  backdropTransitionTimeout: _propTypes2.default.number,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props;
    var backdropStyle = _props3.backdropStyle;
    var backdropClassName = _props3.backdropClassName;
    var renderBackdrop = _props3.renderBackdrop;
    var Transition = _props3.transition;
    var backdropTransitionTimeout = _props3.backdropTransitionTimeout;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        { transitionAppear: true,
          'in': _this2.props.show,
          timeout: backdropTransitionTimeout
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);

    _this2.focus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNode = function (ref) {
    _this2.modalNode = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
      _this2.props.onHide();
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.focus = function () {
    var autoFocus = _this2.props.autoFocus;
    var modalContent = _this2.getDialogElement();
    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
    var focusInModal = current && (0, _contains2.default)(modalContent, current);

    if (modalContent && autoFocus && !focusInModal) {
      _this2.lastFocus = current;

      if (!modalContent.hasAttribute('tabIndex')) {
        modalContent.setAttribute('tabIndex', -1);
        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
      }

      modalContent.focus();
    }
  };

  this.restoreLastFocus = function () {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (_this2.lastFocus && _this2.lastFocus.focus) {
      _this2.lastFocus.focus();
      _this2.lastFocus = null;
    }
  };

  this.enforceFocus = function () {
    var enforceFocus = _this2.props.enforceFocus;


    if (!enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
    var modal = _this2.getDialogElement();

    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
      modal.focus();
    }
  };

  this.getDialogElement = function () {
    var node = _this2.modalNode;
    return node && node.lastChild;
  };

  this.isTopModal = function () {
    return _this2.props.manager.isTopModal(_this2);
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(93);

var _style2 = _interopRequireDefault(_style);

var _class = __webpack_require__(340);

var _class2 = _interopRequireDefault(_class);

var _scrollbarSize = __webpack_require__(194);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(253);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _ref2$hideSiblingNode = _ref2.hideSiblingNodes;
  var hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode;
  var _ref2$handleContainer = _ref2.handleContainerOverflow;
  var handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Portal = __webpack_require__(249);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(550);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(250);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

var _elementType = __webpack_require__(19);

var _elementType2 = _interopRequireDefault(_elementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  _createClass(Overlay, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({ exited: false });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var container = _props.container;
      var containerPadding = _props.containerPadding;
      var target = _props.target;
      var placement = _props.placement;
      var shouldUpdatePosition = _props.shouldUpdatePosition;
      var rootClose = _props.rootClose;
      var children = _props.children;
      var Transition = _props.transition;

      var props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

      // Don't un-render the overlay while it's transitioning out.


      var mountOverlay = props.show || Transition && !this.state.exited;
      if (!mountOverlay) {
        // Don't bother showing anything if we don't have to.
        return null;
      }

      var child = children;

      // Position is be inner-most because it adds inline styles into the child,
      // which the other wrappers don't forward correctly.
      child = _react2.default.createElement(
        _Position2.default,
        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
        child
      );

      if (Transition) {
        var onExit = props.onExit;
        var onExiting = props.onExiting;
        var onEnter = props.onEnter;
        var onEntering = props.onEntering;
        var onEntered = props.onEntered;

        // This animates the child node by injecting props, so it must precede
        // anything that adds a wrapping div.

        child = _react2.default.createElement(
          Transition,
          {
            'in': props.show,
            transitionAppear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.onHiddenListener,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
          },
          child
        );
      }

      // This goes after everything else because it adds a wrapping div.
      if (rootClose) {
        child = _react2.default.createElement(
          _RootCloseWrapper2.default,
          { onRootClose: props.onHide },
          child
        );
      }

      return _react2.default.createElement(
        _Portal2.default,
        { container: container },
        child
      );
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _componentOrElement = __webpack_require__(162);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _calculatePosition = __webpack_require__(552);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(161);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(87);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  _createClass(Position, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updatePosition(this.getTarget());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needsFlush = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this._needsFlush) {
        this._needsFlush = false;
        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var className = _props.className;

      var props = _objectWithoutProperties(_props, ['children', 'className']);

      var _state = this.state;
      var positionLeft = _state.positionLeft;
      var positionTop = _state.positionTop;

      var arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

      // These should not be forwarded to the child.


      delete props.target;
      delete props.container;
      delete props.containerPadding;
      delete props.shouldUpdatePosition;

      var child = _react2.default.Children.only(children);
      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
        // and `props.style`.
        positionLeft: positionLeft,
        positionTop: positionTop,
        className: (0, _classnames2.default)(className, child.props.className),
        style: _extends({}, child.props.style, {
          left: positionLeft,
          top: positionTop
        })
      }));
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition(target) {
      this._lastTarget = target;

      if (!target) {
        this.setState({
          positionLeft: 0,
          positionTop: 0,
          arrowOffsetLeft: null,
          arrowOffsetTop: null
        });

        return;
      }

      var overlay = _reactDom2.default.findDOMNode(this);
      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
    }
  }]);

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePosition;

var _offset = __webpack_require__(190);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(346);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(191);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(87);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode);

  var overlayHeight = _getOffset2.height;
  var overlayWidth = _getOffset2.width;


  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType;
  var tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(35);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* Router */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(35);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* Router */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["i"]; });


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(254);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["f" /* Route */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["h"]; });


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["f"]; });


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(163);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for updating the location programatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(164);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(255);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(256);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(256);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				className: className,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(88);

var invariant = __webpack_require__(15);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(576);
var ReactElement = __webpack_require__(73);

var emptyFunction = __webpack_require__(34);
var traverseAllChildren = __webpack_require__(586);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(73);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(73),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(206);

module.exports = factory(isValidElement);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(257),
    Component = _require.Component;

var _require2 = __webpack_require__(73),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(260);
var factory = __webpack_require__(338);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(88);

var ReactElement = __webpack_require__(73);

var invariant = __webpack_require__(15);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(88);

var ReactCurrentOwner = __webpack_require__(44);
var REACT_ELEMENT_TYPE = __webpack_require__(259);

var getIteratorFn = __webpack_require__(582);
var invariant = __webpack_require__(15);
var KeyEscapeUtils = __webpack_require__(575);
var warning = __webpack_require__(17);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    "use strict";
    var hasOwn = Object.prototype.hasOwnProperty;
    // feature test for Symbol support
    var supportsSymbol = typeof Symbol === "function";
    var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
    var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
    var HashMap;
    (function (HashMap) {
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        // create an object in dictionary mode (a.k.a. "slow" mode in v8)
        HashMap.create = supportsCreate
            ? function () { return MakeDictionary(Object.create(null)); }
            : supportsProto
                ? function () { return MakeDictionary({ __proto__: null }); }
                : function () { return MakeDictionary({}); };
        HashMap.has = downLevel
            ? function (map, key) { return hasOwn.call(map, key); }
            : function (map, key) { return key in map; };
        HashMap.get = downLevel
            ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
            : function (map, key) { return map[key]; };
    })(HashMap || (HashMap = {}));
    // Load global or shim versions of Map, Set, and WeakMap
    var functionPrototype = Object.getPrototypeOf(Function);
    var usePolyfill = typeof process === "object" && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""})["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
    var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
    var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
    var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
    // [[Metadata]] internal slot
    // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
    var Metadata = new _WeakMap();
    /**
      * Applies a set of decorators to a property of a target object.
      * @param decorators An array of decorators.
      * @param target The target object.
      * @param propertyKey (Optional) The property key to decorate.
      * @param attributes (Optional) The property descriptor for the target key.
      * @remarks Decorators are applied in reverse order.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     Example = Reflect.decorate(decoratorsArray, Example);
      *
      *     // property (on constructor)
      *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
      *
      *     // property (on prototype)
      *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
      *
      *     // method (on constructor)
      *     Object.defineProperty(Example, "staticMethod",
      *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
      *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
      *
      *     // method (on prototype)
      *     Object.defineProperty(Example.prototype, "method",
      *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
      *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
      *
      */
    function decorate(decorators, target, propertyKey, attributes) {
        if (!IsUndefined(propertyKey)) {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsObject(target))
                throw new TypeError();
            if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                throw new TypeError();
            if (IsNull(attributes))
                attributes = undefined;
            propertyKey = ToPropertyKey(propertyKey);
            return DecorateProperty(decorators, target, propertyKey, attributes);
        }
        else {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsConstructor(target))
                throw new TypeError();
            return DecorateConstructor(decorators, target);
        }
    }
    Reflect.decorate = decorate;
    // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
    // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
    /**
      * A default metadata decorator factory that can be used on a class, class member, or parameter.
      * @param metadataKey The key for the metadata entry.
      * @param metadataValue The value for the metadata entry.
      * @returns A decorator function.
      * @remarks
      * If `metadataKey` is already defined for the target and target key, the
      * metadataValue for that key will be overwritten.
      * @example
      *
      *     // constructor
      *     @Reflect.metadata(key, value)
      *     class Example {
      *     }
      *
      *     // property (on constructor, TypeScript only)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         static staticProperty;
      *     }
      *
      *     // property (on prototype, TypeScript only)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         property;
      *     }
      *
      *     // method (on constructor)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         static staticMethod() { }
      *     }
      *
      *     // method (on prototype)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         method() { }
      *     }
      *
      */
    function metadata(metadataKey, metadataValue) {
        function decorator(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                throw new TypeError();
            OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        return decorator;
    }
    Reflect.metadata = metadata;
    /**
      * Define a unique metadata entry on the target.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param metadataValue A value that contains attached metadata.
      * @param target The target object on which to define metadata.
      * @param propertyKey (Optional) The property key for the target.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     Reflect.defineMetadata("custom:annotation", options, Example);
      *
      *     // property (on constructor)
      *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
      *
      *     // property (on prototype)
      *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
      *
      *     // method (on constructor)
      *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
      *
      *     // method (on prototype)
      *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
      *
      *     // decorator factory as metadata-producing annotation.
      *     function MyAnnotation(options): Decorator {
      *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
      *     }
      *
      */
    function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
    }
    Reflect.defineMetadata = defineMetadata;
    /**
      * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.hasMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function hasMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryHasMetadata(metadataKey, target, propertyKey);
    }
    Reflect.hasMetadata = hasMetadata;
    /**
      * Gets a value indicating whether the target object has the provided metadata key defined.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function hasOwnMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
    }
    Reflect.hasOwnMetadata = hasOwnMetadata;
    /**
      * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function getMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryGetMetadata(metadataKey, target, propertyKey);
    }
    Reflect.getMetadata = getMetadata;
    /**
      * Gets the metadata value for the provided metadata key on the target object.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getOwnMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function getOwnMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
    }
    Reflect.getOwnMetadata = getOwnMetadata;
    /**
      * Gets the metadata keys defined on the target object or its prototype chain.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns An array of unique metadata keys.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getMetadataKeys(Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getMetadataKeys(Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getMetadataKeys(Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getMetadataKeys(Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getMetadataKeys(Example.prototype, "method");
      *
      */
    function getMetadataKeys(target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryMetadataKeys(target, propertyKey);
    }
    Reflect.getMetadataKeys = getMetadataKeys;
    /**
      * Gets the unique metadata keys defined on the target object.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns An array of unique metadata keys.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getOwnMetadataKeys(Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
      *
      */
    function getOwnMetadataKeys(target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        return OrdinaryOwnMetadataKeys(target, propertyKey);
    }
    Reflect.getOwnMetadataKeys = getOwnMetadataKeys;
    /**
      * Deletes the metadata entry from the target object with the provided key.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param propertyKey (Optional) The property key for the target.
      * @returns `true` if the metadata entry was found and deleted; otherwise, false.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.deleteMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function deleteMetadata(metadataKey, target, propertyKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(propertyKey))
            propertyKey = ToPropertyKey(propertyKey);
        var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return false;
        if (!metadataMap.delete(metadataKey))
            return false;
        if (metadataMap.size > 0)
            return true;
        var targetMetadata = Metadata.get(target);
        targetMetadata.delete(propertyKey);
        if (targetMetadata.size > 0)
            return true;
        Metadata.delete(target);
        return true;
    }
    Reflect.deleteMetadata = deleteMetadata;
    function DecorateConstructor(decorators, target) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            var decorated = decorator(target);
            if (!IsUndefined(decorated) && !IsNull(decorated)) {
                if (!IsConstructor(decorated))
                    throw new TypeError();
                target = decorated;
            }
        }
        return target;
    }
    function DecorateProperty(decorators, target, propertyKey, descriptor) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            var decorated = decorator(target, propertyKey, descriptor);
            if (!IsUndefined(decorated) && !IsNull(decorated)) {
                if (!IsObject(decorated))
                    throw new TypeError();
                descriptor = decorated;
            }
        }
        return descriptor;
    }
    function GetOrCreateMetadataMap(O, P, Create) {
        var targetMetadata = Metadata.get(O);
        if (IsUndefined(targetMetadata)) {
            if (!Create)
                return undefined;
            targetMetadata = new _Map();
            Metadata.set(O, targetMetadata);
        }
        var metadataMap = targetMetadata.get(P);
        if (IsUndefined(metadataMap)) {
            if (!Create)
                return undefined;
            metadataMap = new _Map();
            targetMetadata.set(P, metadataMap);
        }
        return metadataMap;
    }
    // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
    function OrdinaryHasMetadata(MetadataKey, O, P) {
        var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn)
            return true;
        var parent = OrdinaryGetPrototypeOf(O);
        if (!IsNull(parent))
            return OrdinaryHasMetadata(MetadataKey, parent, P);
        return false;
    }
    // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
    function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return false;
        return ToBoolean(metadataMap.has(MetadataKey));
    }
    // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
    function OrdinaryGetMetadata(MetadataKey, O, P) {
        var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn)
            return OrdinaryGetOwnMetadata(MetadataKey, O, P);
        var parent = OrdinaryGetPrototypeOf(O);
        if (!IsNull(parent))
            return OrdinaryGetMetadata(MetadataKey, parent, P);
        return undefined;
    }
    // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
    function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return undefined;
        return metadataMap.get(MetadataKey);
    }
    // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
    function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
        metadataMap.set(MetadataKey, MetadataValue);
    }
    // 3.1.6.1 OrdinaryMetadataKeys(O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
    function OrdinaryMetadataKeys(O, P) {
        var ownKeys = OrdinaryOwnMetadataKeys(O, P);
        var parent = OrdinaryGetPrototypeOf(O);
        if (parent === null)
            return ownKeys;
        var parentKeys = OrdinaryMetadataKeys(parent, P);
        if (parentKeys.length <= 0)
            return ownKeys;
        if (ownKeys.length <= 0)
            return parentKeys;
        var set = new _Set();
        var keys = [];
        for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
            var key = ownKeys_1[_i];
            var hasKey = set.has(key);
            if (!hasKey) {
                set.add(key);
                keys.push(key);
            }
        }
        for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
            var key = parentKeys_1[_a];
            var hasKey = set.has(key);
            if (!hasKey) {
                set.add(key);
                keys.push(key);
            }
        }
        return keys;
    }
    // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
    // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
    function OrdinaryOwnMetadataKeys(O, P) {
        var keys = [];
        var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
        if (IsUndefined(metadataMap))
            return keys;
        var keysObj = metadataMap.keys();
        var iterator = GetIterator(keysObj);
        var k = 0;
        while (true) {
            var next = IteratorStep(iterator);
            if (!next) {
                keys.length = k;
                return keys;
            }
            var nextValue = IteratorValue(next);
            try {
                keys[k] = nextValue;
            }
            catch (e) {
                try {
                    IteratorClose(iterator);
                }
                finally {
                    throw e;
                }
            }
            k++;
        }
    }
    // 6 ECMAScript Data Typ0es and Values
    // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
    function Type(x) {
        if (x === null)
            return 1 /* Null */;
        switch (typeof x) {
            case "undefined": return 0 /* Undefined */;
            case "boolean": return 2 /* Boolean */;
            case "string": return 3 /* String */;
            case "symbol": return 4 /* Symbol */;
            case "number": return 5 /* Number */;
            case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
            default: return 6 /* Object */;
        }
    }
    // 6.1.1 The Undefined Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
    function IsUndefined(x) {
        return x === undefined;
    }
    // 6.1.2 The Null Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
    function IsNull(x) {
        return x === null;
    }
    // 6.1.5 The Symbol Type
    // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
    function IsSymbol(x) {
        return typeof x === "symbol";
    }
    // 6.1.7 The Object Type
    // https://tc39.github.io/ecma262/#sec-object-type
    function IsObject(x) {
        return typeof x === "object" ? x !== null : typeof x === "function";
    }
    // 7.1 Type Conversion
    // https://tc39.github.io/ecma262/#sec-type-conversion
    // 7.1.1 ToPrimitive(input [, PreferredType])
    // https://tc39.github.io/ecma262/#sec-toprimitive
    function ToPrimitive(input, PreferredType) {
        switch (Type(input)) {
            case 0 /* Undefined */: return input;
            case 1 /* Null */: return input;
            case 2 /* Boolean */: return input;
            case 3 /* String */: return input;
            case 4 /* Symbol */: return input;
            case 5 /* Number */: return input;
        }
        var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
        var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
        if (exoticToPrim !== undefined) {
            var result = exoticToPrim.call(input, hint);
            if (IsObject(result))
                throw new TypeError();
            return result;
        }
        return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
    }
    // 7.1.1.1 OrdinaryToPrimitive(O, hint)
    // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
    function OrdinaryToPrimitive(O, hint) {
        if (hint === "string") {
            var toString_1 = O.toString;
            if (IsCallable(toString_1)) {
                var result = toString_1.call(O);
                if (!IsObject(result))
                    return result;
            }
            var valueOf = O.valueOf;
            if (IsCallable(valueOf)) {
                var result = valueOf.call(O);
                if (!IsObject(result))
                    return result;
            }
        }
        else {
            var valueOf = O.valueOf;
            if (IsCallable(valueOf)) {
                var result = valueOf.call(O);
                if (!IsObject(result))
                    return result;
            }
            var toString_2 = O.toString;
            if (IsCallable(toString_2)) {
                var result = toString_2.call(O);
                if (!IsObject(result))
                    return result;
            }
        }
        throw new TypeError();
    }
    // 7.1.2 ToBoolean(argument)
    // https://tc39.github.io/ecma262/2016/#sec-toboolean
    function ToBoolean(argument) {
        return !!argument;
    }
    // 7.1.12 ToString(argument)
    // https://tc39.github.io/ecma262/#sec-tostring
    function ToString(argument) {
        return "" + argument;
    }
    // 7.1.14 ToPropertyKey(argument)
    // https://tc39.github.io/ecma262/#sec-topropertykey
    function ToPropertyKey(argument) {
        var key = ToPrimitive(argument, 3 /* String */);
        if (IsSymbol(key))
            return key;
        return ToString(key);
    }
    // 7.2 Testing and Comparison Operations
    // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
    // 7.2.2 IsArray(argument)
    // https://tc39.github.io/ecma262/#sec-isarray
    function IsArray(argument) {
        return Array.isArray
            ? Array.isArray(argument)
            : argument instanceof Object
                ? argument instanceof Array
                : Object.prototype.toString.call(argument) === "[object Array]";
    }
    // 7.2.3 IsCallable(argument)
    // https://tc39.github.io/ecma262/#sec-iscallable
    function IsCallable(argument) {
        // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
        return typeof argument === "function";
    }
    // 7.2.4 IsConstructor(argument)
    // https://tc39.github.io/ecma262/#sec-isconstructor
    function IsConstructor(argument) {
        // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
        return typeof argument === "function";
    }
    // 7.2.7 IsPropertyKey(argument)
    // https://tc39.github.io/ecma262/#sec-ispropertykey
    function IsPropertyKey(argument) {
        switch (Type(argument)) {
            case 3 /* String */: return true;
            case 4 /* Symbol */: return true;
            default: return false;
        }
    }
    // 7.3 Operations on Objects
    // https://tc39.github.io/ecma262/#sec-operations-on-objects
    // 7.3.9 GetMethod(V, P)
    // https://tc39.github.io/ecma262/#sec-getmethod
    function GetMethod(V, P) {
        var func = V[P];
        if (func === undefined || func === null)
            return undefined;
        if (!IsCallable(func))
            throw new TypeError();
        return func;
    }
    // 7.4 Operations on Iterator Objects
    // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
    function GetIterator(obj) {
        var method = GetMethod(obj, iteratorSymbol);
        if (!IsCallable(method))
            throw new TypeError(); // from Call
        var iterator = method.call(obj);
        if (!IsObject(iterator))
            throw new TypeError();
        return iterator;
    }
    // 7.4.4 IteratorValue(iterResult)
    // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
    function IteratorValue(iterResult) {
        return iterResult.value;
    }
    // 7.4.5 IteratorStep(iterator)
    // https://tc39.github.io/ecma262/#sec-iteratorstep
    function IteratorStep(iterator) {
        var result = iterator.next();
        return result.done ? false : result;
    }
    // 7.4.6 IteratorClose(iterator, completion)
    // https://tc39.github.io/ecma262/#sec-iteratorclose
    function IteratorClose(iterator) {
        var f = iterator["return"];
        if (f)
            f.call(iterator);
    }
    // 9.1 Ordinary Object Internal Methods and Internal Slots
    // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
    // 9.1.1.1 OrdinaryGetPrototypeOf(O)
    // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
    function OrdinaryGetPrototypeOf(O) {
        var proto = Object.getPrototypeOf(O);
        if (typeof O !== "function" || O === functionPrototype)
            return proto;
        // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
        // Try to determine the superclass constructor. Compatible implementations
        // must either set __proto__ on a subclass constructor to the superclass constructor,
        // or ensure each class has a valid `constructor` property on its prototype that
        // points back to the constructor.
        // If this is not the same as Function.[[Prototype]], then this is definately inherited.
        // This is the case when in ES6 or when using __proto__ in a compatible browser.
        if (proto !== functionPrototype)
            return proto;
        // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
        var prototype = O.prototype;
        var prototypeProto = prototype && Object.getPrototypeOf(prototype);
        if (prototypeProto == null || prototypeProto === Object.prototype)
            return proto;
        // If the constructor was not a function, then we cannot determine the heritage.
        var constructor = prototypeProto.constructor;
        if (typeof constructor !== "function")
            return proto;
        // If we have some kind of self-reference, then we cannot determine the heritage.
        if (constructor === O)
            return proto;
        // we have a pretty good guess at the heritage.
        return constructor;
    }
    // naive Map shim
    function CreateMapPolyfill() {
        var cacheSentinel = {};
        var arraySentinel = [];
        var MapIterator = (function () {
            function MapIterator(keys, values, selector) {
                this._index = 0;
                this._keys = keys;
                this._values = values;
                this._selector = selector;
            }
            MapIterator.prototype["@@iterator"] = function () { return this; };
            MapIterator.prototype[iteratorSymbol] = function () { return this; };
            MapIterator.prototype.next = function () {
                var index = this._index;
                if (index >= 0 && index < this._keys.length) {
                    var result = this._selector(this._keys[index], this._values[index]);
                    if (index + 1 >= this._keys.length) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    else {
                        this._index++;
                    }
                    return { value: result, done: false };
                }
                return { value: undefined, done: true };
            };
            MapIterator.prototype.throw = function (error) {
                if (this._index >= 0) {
                    this._index = -1;
                    this._keys = arraySentinel;
                    this._values = arraySentinel;
                }
                throw error;
            };
            MapIterator.prototype.return = function (value) {
                if (this._index >= 0) {
                    this._index = -1;
                    this._keys = arraySentinel;
                    this._values = arraySentinel;
                }
                return { value: value, done: true };
            };
            return MapIterator;
        }());
        return (function () {
            function Map() {
                this._keys = [];
                this._values = [];
                this._cacheKey = cacheSentinel;
                this._cacheIndex = -2;
            }
            Object.defineProperty(Map.prototype, "size", {
                get: function () { return this._keys.length; },
                enumerable: true,
                configurable: true
            });
            Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
            Map.prototype.get = function (key) {
                var index = this._find(key, /*insert*/ false);
                return index >= 0 ? this._values[index] : undefined;
            };
            Map.prototype.set = function (key, value) {
                var index = this._find(key, /*insert*/ true);
                this._values[index] = value;
                return this;
            };
            Map.prototype.delete = function (key) {
                var index = this._find(key, /*insert*/ false);
                if (index >= 0) {
                    var size = this._keys.length;
                    for (var i = index + 1; i < size; i++) {
                        this._keys[i - 1] = this._keys[i];
                        this._values[i - 1] = this._values[i];
                    }
                    this._keys.length--;
                    this._values.length--;
                    if (key === this._cacheKey) {
                        this._cacheKey = cacheSentinel;
                        this._cacheIndex = -2;
                    }
                    return true;
                }
                return false;
            };
            Map.prototype.clear = function () {
                this._keys.length = 0;
                this._values.length = 0;
                this._cacheKey = cacheSentinel;
                this._cacheIndex = -2;
            };
            Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
            Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
            Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
            Map.prototype["@@iterator"] = function () { return this.entries(); };
            Map.prototype[iteratorSymbol] = function () { return this.entries(); };
            Map.prototype._find = function (key, insert) {
                if (this._cacheKey !== key) {
                    this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                }
                if (this._cacheIndex < 0 && insert) {
                    this._cacheIndex = this._keys.length;
                    this._keys.push(key);
                    this._values.push(undefined);
                }
                return this._cacheIndex;
            };
            return Map;
        }());
        function getKey(key, _) {
            return key;
        }
        function getValue(_, value) {
            return value;
        }
        function getEntry(key, value) {
            return [key, value];
        }
    }
    // naive Set shim
    function CreateSetPolyfill() {
        return (function () {
            function Set() {
                this._map = new _Map();
            }
            Object.defineProperty(Set.prototype, "size", {
                get: function () { return this._map.size; },
                enumerable: true,
                configurable: true
            });
            Set.prototype.has = function (value) { return this._map.has(value); };
            Set.prototype.add = function (value) { return this._map.set(value, value), this; };
            Set.prototype.delete = function (value) { return this._map.delete(value); };
            Set.prototype.clear = function () { this._map.clear(); };
            Set.prototype.keys = function () { return this._map.keys(); };
            Set.prototype.values = function () { return this._map.values(); };
            Set.prototype.entries = function () { return this._map.entries(); };
            Set.prototype["@@iterator"] = function () { return this.keys(); };
            Set.prototype[iteratorSymbol] = function () { return this.keys(); };
            return Set;
        }());
    }
    // naive WeakMap shim
    function CreateWeakMapPolyfill() {
        var UUID_SIZE = 16;
        var keys = HashMap.create();
        var rootKey = CreateUniqueKey();
        return (function () {
            function WeakMap() {
                this._key = CreateUniqueKey();
            }
            WeakMap.prototype.has = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? HashMap.has(table, this._key) : false;
            };
            WeakMap.prototype.get = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? HashMap.get(table, this._key) : undefined;
            };
            WeakMap.prototype.set = function (target, value) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                table[this._key] = value;
                return this;
            };
            WeakMap.prototype.delete = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? delete table[this._key] : false;
            };
            WeakMap.prototype.clear = function () {
                // NOTE: not a real clear, just makes the previous data unreachable
                this._key = CreateUniqueKey();
            };
            return WeakMap;
        }());
        function CreateUniqueKey() {
            var key;
            do
                key = "@@WeakMap@@" + CreateUUID();
            while (HashMap.has(keys, key));
            keys[key] = true;
            return key;
        }
        function GetOrCreateWeakMapTable(target, create) {
            if (!hasOwn.call(target, rootKey)) {
                if (!create)
                    return undefined;
                Object.defineProperty(target, rootKey, { value: HashMap.create() });
            }
            return target[rootKey];
        }
        function FillRandomBytes(buffer, size) {
            for (var i = 0; i < size; ++i)
                buffer[i] = Math.random() * 0xff | 0;
            return buffer;
        }
        function GenRandomBytes(size) {
            if (typeof Uint8Array === "function") {
                if (typeof crypto !== "undefined")
                    return crypto.getRandomValues(new Uint8Array(size));
                if (typeof msCrypto !== "undefined")
                    return msCrypto.getRandomValues(new Uint8Array(size));
                return FillRandomBytes(new Uint8Array(size), size);
            }
            return FillRandomBytes(new Array(size), size);
        }
        function CreateUUID() {
            var data = GenRandomBytes(UUID_SIZE);
            // mark as random - RFC 4122 § 4.4
            data[6] = data[6] & 0x4f | 0x40;
            data[8] = data[8] & 0xbf | 0x80;
            var result = "";
            for (var offset = 0; offset < UUID_SIZE; ++offset) {
                var byte = data[offset];
                if (offset === 4 || offset === 6 || offset === 8)
                    result += "-";
                if (byte < 16)
                    result += "0";
                result += byte.toString(16).toLowerCase();
            }
            return result;
        }
    }
    // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
    function MakeDictionary(obj) {
        obj.__ = undefined;
        delete obj.__;
        return obj;
    }
    // patch global Reflect
    (function (__global) {
        if (typeof __global.Reflect !== "undefined") {
            if (__global.Reflect !== Reflect) {
                for (var p in Reflect) {
                    if (hasOwn.call(Reflect, p)) {
                        __global.Reflect[p] = Reflect[p];
                    }
                }
            }
        }
        else {
            __global.Reflect = Reflect;
        }
    })(typeof global !== "undefined" ? global :
        typeof self !== "undefined" ? self :
            Function("return this;")());
})(Reflect || (Reflect = {}));
//# sourceMappingURL=Reflect.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(139), __webpack_require__(174)))

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsolute = function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
};

// About 1.5x faster than the two-arg version of Array#splice()
var spliceOne = function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }list.pop();
};

// This implementation is based heavily on node's url.parse
var resolvePathname = function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
};

module.exports = resolvePathname;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
mobx_1.useStrict(true);
var mobx_react_1 = __webpack_require__(4);
var react_router_dom_1 = __webpack_require__(52);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var PrivateRoute_1 = __webpack_require__(168);
var Header_1 = __webpack_require__(614);
var Footer_1 = __webpack_require__(613);
var Content_1 = __webpack_require__(611);
var Login_1 = __webpack_require__(621);
var Profile_1 = __webpack_require__(622);
var ToastContainer_1 = __webpack_require__(618);
var AuftragDetailRouter_1 = __webpack_require__(594);
var AuftragAnlegenSES_1 = __webpack_require__(265);
var AuftragAnlegenAGT_1 = __webpack_require__(590);
var AuftragAnlegenDMG_1 = __webpack_require__(592);
var QmDokumentation_1 = __webpack_require__(623);
var Kontakt_1 = __webpack_require__(615);
var Portalinfos_1 = __webpack_require__(616);
var FeedbackForm_1 = __webpack_require__(612);
var ArbeitsmittelAuswahl_1 = __webpack_require__(262);
var AuftragUebersichtLizenz_1 = __webpack_require__(600);
var Benachrichtigung_1 = __webpack_require__(609);
var AuftragUebersichtEigene_1 = __webpack_require__(599);
var AuftragNeu_1 = __webpack_require__(598);
var AuftragAnlegenBPS_1 = __webpack_require__(591);
var DokumentePublic_1 = __webpack_require__(607);
var HeaderPublic_1 = __webpack_require__(608);
var Belege_1 = __webpack_require__(604);
var BelegDetails_1 = __webpack_require__(603);
var PublicLayout = (function (_super) {
    __extends(PublicLayout, _super);
    function PublicLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicLayout.prototype.render = function () {
        return (React.createElement("div", { className: "App" },
            React.createElement(HeaderPublic_1.default, null),
            React.createElement(Content_1.default, null,
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Route, { path: "/public/docs/:guid", component: DokumentePublic_1.default }),
                    React.createElement(react_router_dom_1.Redirect, { to: "/login" }))),
            React.createElement(Footer_1.default, null)));
    };
    return PublicLayout;
}(React.Component));
exports.PublicLayout = PublicLayout;
var ProtectedLayout = (function (_super) {
    __extends(ProtectedLayout, _super);
    function ProtectedLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProtectedLayout.prototype.render = function () {
        return (React.createElement("div", { className: "App" },
            React.createElement(Header_1.default, null),
            React.createElement(Benachrichtigung_1.default, null),
            React.createElement(Content_1.default, null,
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Route, { path: "/login", component: Login_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/profile", component: Profile_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/kontakt", component: Kontakt_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/portal", component: Portalinfos_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftraege", exact: true, render: function () { return React.createElement(AuftragUebersichtEigene_1.default, null); } }),
                    this.uiStore.userProfile && this.uiStore.userProfile.projektleiter && React.createElement(PrivateRoute_1.default, { path: "/auftraege/lizenz", exact: true, render: function () { return React.createElement(AuftragUebersichtLizenz_1.default, null); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftrag/neu", exact: true, render: function () { return React.createElement(AuftragNeu_1.default, null); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftrag/neu/ses", exact: true, render: function () { return React.createElement(AuftragAnlegenSES_1.default, null); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftrag/neu/agt", exact: true, render: function () { return React.createElement(AuftragAnlegenAGT_1.default, null); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftrag/neu/bps", exact: true, render: function () { return React.createElement(AuftragAnlegenBPS_1.default, null); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftrag/neu/dmg", exact: true, render: function () { return React.createElement(AuftragAnlegenDMG_1.default, null); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/auftrag/:auftragId", component: AuftragDetailRouter_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/qm", component: QmDokumentation_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/arbeitsmittel", exact: true, render: function () { return React.createElement(ArbeitsmittelAuswahl_1.default, { title: 'Arbeitsmittel-Sets', uebersicht: true }); } }),
                    React.createElement(PrivateRoute_1.default, { path: "/arbeitsmittel/:arbeitsmittelId/feedback", component: FeedbackForm_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/belege", component: Belege_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: "/beleg/:renr", component: BelegDetails_1.default }),
                    React.createElement(react_router_dom_1.Redirect, { to: "/auftraege" }))),
            React.createElement(ToastContainer_1.default, null),
            React.createElement(Footer_1.default, null)));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ProtectedLayout.prototype, "uiStore", void 0);
    return ProtectedLayout;
}(React.Component));
exports.ProtectedLayout = ProtectedLayout;
var App = (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        return (React.createElement(react_router_dom_1.Router, { history: this.uiStore.history },
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { path: "/public/", component: PublicLayout }),
                React.createElement(react_router_dom_1.Route, { path: "/", component: ProtectedLayout }))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], App.prototype, "uiStore", void 0);
    App = __decorate([
        mobx_react_1.observer
    ], App);
    return App;
}(React.Component));
exports.default = App;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes = __webpack_require__(21);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var AuftragAdresseErfassen_1 = __webpack_require__(109);
var LadeFortschritt_1 = __webpack_require__(53);
var AuftragAnlegen_1 = __webpack_require__(108);
/** Formular zum Anlegen eines neuen Auftrags für die Kalibrierung von Abgasmessgeräten (AGT) */
var AuftragAnlegenAGT = (function (_super) {
    __extends(AuftragAnlegenAGT, _super);
    function AuftragAnlegenAGT() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kategorie = 'agt';
        return _this;
    }
    AuftragAnlegenAGT.prototype.handleAuftragAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var daten, auftragResponse, anr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        daten = {
                            'auftragname': "AGT " + this.auftraggeber.name,
                            'pinummer': this.verantwortlicher,
                            'referenzdatum': this.referenzdatum,
                            'lizenznehmer': this.lizenznehmer,
                            'kategorie': this.kategorie,
                            'bemerkung': this.bemerkung,
                            'abweichenderuntersuchungsort': !this.untersuchungsortGleichAuftraggeber,
                            'auftraggeber': {
                                'name1': this.auftraggeber.name,
                                'name2': this.auftraggeber.zusatz,
                                'strasse': this.auftraggeber.strasse,
                                'plz': this.auftraggeber.plz,
                                'ort': this.auftraggeber.ort,
                                'tel': this.auftraggeber.tel1,
                                'email': this.auftraggeber.email,
                                'email2': this.auftraggeber.email2,
                                'adressid': this.auftraggeber.adressid
                            },
                            'beauftragter': {
                                'name1': this.untersuchungsort.name,
                                'name2': this.untersuchungsort.zusatz,
                                'strasse': this.untersuchungsort.strasse,
                                'plz': this.untersuchungsort.plz,
                                'ort': this.untersuchungsort.ort,
                                'tel': this.untersuchungsort.tel1,
                                'email': this.untersuchungsort.email,
                                'adressid': this.untersuchungsort.adressid
                            }
                        };
                        return [4 /*yield*/, this.apiStore.auftragAnlegen(daten)];
                    case 1:
                        auftragResponse = _a.sent();
                        if (auftragResponse.ok) {
                            anr = auftragResponse.json.success;
                            this.uiStore.navigateTo("/auftrag/" + anr);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenAGT.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setAuftragskopfGeladen(false);
                        this.setReferenzDatum();
                        return [4 /*yield*/, this.uiStore.loadUserProfile()];
                    case 1:
                        _a.sent();
                        userProfile = this.uiStore.userProfile;
                        if (!(userProfile && userProfile.projektleiter)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uiStore.loadPersonallisteKategorie(this.kategorie)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.uiStore.loadFreigaben()];
                    case 4:
                        _a.sent();
                        if (this.uiStore.freigaben) {
                            if (this.uiStore.freigaben.length > 0) {
                                this.setLizenznehmer(this.uiStore.freigaben[0].lizenznehmer);
                            }
                        }
                        this.setAuftragskopfGeladen(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenAGT.prototype.voraussetzungenErfuellt = function () {
        var result = (this.referenzdatum.trim() !== '') && (this.lizenznehmer) && (this.auftraggeber.name.trim() !== '');
        // Projektleiter dürfen den Auftrag anderen Personen zuweisen, in diesen Fällen muss zum speichern eine Person gewählt sein
        if (this.uiStore.userProfile && this.uiStore.userProfile.projektleiter) {
            result = result && (this.verantwortlicher !== '');
        }
        // Untersuchungsort nur validieren, wenn dieser vom Auftraggeber abweicht
        if (!this.untersuchungsortGleichAuftraggeber) {
            result = result && (this.untersuchungsort.name.trim() !== '');
        }
        return result;
    };
    AuftragAnlegenAGT.prototype.render = function () {
        var _this = this;
        if (!this.auftragskopfGeladen) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleAuftragAnlegenSubmit },
            React.createElement("h3", null, "Neuen Auftrag f\u00FCr Kalibrierung Abgasmessger\u00E4t anlegen"),
            React.createElement(react_bootstrap_1.Panel, { header: "Auftragdetails" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.lizenznehmer === '' ? 'error' : undefined, controlId: "Anlegen für" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Anlegen f\u00FCr"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.lizenznehmer, onChange: this.handleLizenznehmerChanged }, this.uiStore.freigaben &&
                            this.uiStore.freigaben.map(function (freigabe) {
                                return React.createElement("option", { key: freigabe.lizenznehmer, value: freigabe.lizenznehmer },
                                    freigabe.name,
                                    " (",
                                    freigabe.lizenznehmer,
                                    ")");
                            })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.referenzdatum === '' ? 'error' : undefined, controlId: "Referenzdatum" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Referenzdatum"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "date", label: "Referenzdatum", value: this.referenzdatum, onChange: this.handleDatumChanged }))),
                this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                    (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.verantwortlicher === '' ? 'error' : undefined, controlId: "Zuweisung" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zuweisung"),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.verantwortlicher, onChange: this.handlePiChanged },
                                React.createElement("option", { value: "" }, "Bitte zust\u00E4ndige Person w\u00E4hlen..."),
                                this.uiStore.personalliste &&
                                    this.uiStore.personalliste.map(function (personal) {
                                        return React.createElement("option", { key: personal.pi, value: personal.pi },
                                            personal.vorname,
                                            " ",
                                            personal.name,
                                            " (",
                                            personal.pi,
                                            ")");
                                    })))))),
            React.createElement(AuftragAdresseErfassen_1.default, { caption: "Auftraggeber", adresse: this.auftraggeber, onUpdateAdresse: this.setAuftraggeber, adressArt: ApiTypes.AdressArt.Auftraggeber }),
            React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkboxSeparateOrtsEingabe", onChange: this.handleUntersuchungsortGleichAuftraggeberChange, defaultChecked: this.untersuchungsortGleichAuftraggeber }, "Untersuchungssort entspricht Auftraggeber")),
            !this.untersuchungsortGleichAuftraggeber &&
                React.createElement(AuftragAdresseErfassen_1.default, { caption: "Ort der Kalibrierung", adresse: this.untersuchungsort, onUpdateAdresse: this.setUntersuchungsort, adressArt: ApiTypes.AdressArt.Untersuchungsstelle }),
            React.createElement(react_bootstrap_1.Panel, { header: "Bemerkung" },
                React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", type: "text", label: "Bemerkung", placeholder: "Optional", value: this.bemerkung, onChange: this.handleBemerkungChanged })),
            !this.voraussetzungenErfuellt() && (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Es wurden noch nicht alle erforderlichen Felder ausgef\u00FCllt!"))),
            React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", disabled: !this.voraussetzungenErfuellt() }, "Auftrag anlegen"))));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAnlegenAGT.prototype, "handleAuftragAnlegenSubmit", null);
    AuftragAnlegenAGT = __decorate([
        mobx_react_1.observer
    ], AuftragAnlegenAGT);
    return AuftragAnlegenAGT;
}(AuftragAnlegen_1.default));
exports.default = AuftragAnlegenAGT;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes = __webpack_require__(21);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var AuftragAdresseErfassen_1 = __webpack_require__(109);
var LadeFortschritt_1 = __webpack_require__(53);
var AuftragAnlegen_1 = __webpack_require__(108);
/** Formular zum Anlegen eines neuen Auftrags für die Kalibrierung von Bremsprüfständen (BPS)  */
var AuftragAnlegenBPS = (function (_super) {
    __extends(AuftragAnlegenBPS, _super);
    function AuftragAnlegenBPS() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kategorie = 'bps';
        return _this;
    }
    AuftragAnlegenBPS.prototype.handleAuftragAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var daten, auftragResponse, anr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        daten = {
                            'auftragname': "BPS " + this.auftraggeber.name,
                            'pinummer': this.verantwortlicher,
                            'referenzdatum': this.referenzdatum,
                            'lizenznehmer': this.lizenznehmer,
                            'kategorie': this.kategorie,
                            'bemerkung': this.bemerkung,
                            'abweichenderuntersuchungsort': !this.untersuchungsortGleichAuftraggeber,
                            'auftraggeber': {
                                'name1': this.auftraggeber.name,
                                'name2': this.auftraggeber.zusatz,
                                'strasse': this.auftraggeber.strasse,
                                'plz': this.auftraggeber.plz,
                                'ort': this.auftraggeber.ort,
                                'tel': this.auftraggeber.tel1,
                                'email': this.auftraggeber.email,
                                'email2': this.auftraggeber.email2,
                                'adressid': this.auftraggeber.adressid
                            },
                            'beauftragter': {
                                'name1': this.untersuchungsort.name,
                                'name2': this.untersuchungsort.zusatz,
                                'strasse': this.untersuchungsort.strasse,
                                'plz': this.untersuchungsort.plz,
                                'ort': this.untersuchungsort.ort,
                                'tel': this.untersuchungsort.tel1,
                                'email': this.untersuchungsort.email,
                                'adressid': this.untersuchungsort.adressid
                            }
                        };
                        return [4 /*yield*/, this.apiStore.auftragAnlegen(daten)];
                    case 1:
                        auftragResponse = _a.sent();
                        if (auftragResponse.ok) {
                            anr = auftragResponse.json.success;
                            this.uiStore.navigateTo("/auftrag/" + anr);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenBPS.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setAuftragskopfGeladen(false);
                        this.setReferenzDatum();
                        return [4 /*yield*/, this.uiStore.loadUserProfile()];
                    case 1:
                        _a.sent();
                        userProfile = this.uiStore.userProfile;
                        if (!(userProfile && userProfile.projektleiter)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uiStore.loadPersonallisteKategorie(this.kategorie)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.uiStore.loadFreigaben()];
                    case 4:
                        _a.sent();
                        if (this.uiStore.freigaben) {
                            if (this.uiStore.freigaben.length > 0) {
                                this.setLizenznehmer(this.uiStore.freigaben[0].lizenznehmer);
                            }
                        }
                        this.setAuftragskopfGeladen(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenBPS.prototype.voraussetzungenErfuellt = function () {
        var result = (this.referenzdatum.trim() !== '') && (this.lizenznehmer) && (this.auftraggeber.name.trim() !== '');
        // Projektleiter dürfen den Auftrag anderen Personen zuweisen, in diesen Fällen muss zum speichern eine Person gewählt sein
        if (this.uiStore.userProfile && this.uiStore.userProfile.projektleiter) {
            result = result && (this.verantwortlicher !== '');
        }
        // Untersuchungsort nur validieren, wenn dieser vom Auftraggeber abweicht
        if (!this.untersuchungsortGleichAuftraggeber) {
            result = result && (this.untersuchungsort.name.trim() !== '');
        }
        return result;
    };
    AuftragAnlegenBPS.prototype.render = function () {
        var _this = this;
        if (!this.auftragskopfGeladen) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleAuftragAnlegenSubmit },
            React.createElement("h3", null, "Neuen Auftrag f\u00FCr Kalibrierung Bremspr\u00FCfstand anlegen"),
            React.createElement(react_bootstrap_1.Panel, { header: "Auftragdetails" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.lizenznehmer === '' ? 'error' : undefined, controlId: "Anlegen für" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Anlegen f\u00FCr"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.lizenznehmer, onChange: this.handleLizenznehmerChanged }, this.uiStore.freigaben &&
                            this.uiStore.freigaben.map(function (freigabe) {
                                return React.createElement("option", { key: freigabe.lizenznehmer, value: freigabe.lizenznehmer },
                                    freigabe.name,
                                    " (",
                                    freigabe.lizenznehmer,
                                    ")");
                            })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.referenzdatum === '' ? 'error' : undefined, controlId: "Referenzdatum" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Referenzdatum"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "date", label: "Referenzdatum", value: this.referenzdatum, onChange: this.handleDatumChanged }))),
                this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                    (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.verantwortlicher === '' ? 'error' : undefined, controlId: "Zuweisung" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zuweisung"),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.verantwortlicher, onChange: this.handlePiChanged },
                                React.createElement("option", { value: "" }, "Bitte zust\u00E4ndige Person w\u00E4hlen..."),
                                this.uiStore.personalliste &&
                                    this.uiStore.personalliste.map(function (personal) {
                                        return React.createElement("option", { key: personal.pi, value: personal.pi },
                                            personal.vorname,
                                            " ",
                                            personal.name,
                                            " (",
                                            personal.pi,
                                            ")");
                                    })))))),
            React.createElement(AuftragAdresseErfassen_1.default, { caption: "Auftraggeber", adresse: this.auftraggeber, onUpdateAdresse: this.setAuftraggeber, adressArt: ApiTypes.AdressArt.Auftraggeber }),
            React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkboxSeparateOrtsEingabe", onChange: this.handleUntersuchungsortGleichAuftraggeberChange, defaultChecked: this.untersuchungsortGleichAuftraggeber }, "Untersuchungssort entspricht Auftraggeber")),
            !this.untersuchungsortGleichAuftraggeber &&
                React.createElement(AuftragAdresseErfassen_1.default, { caption: "Ort der Kalibrierung", adresse: this.untersuchungsort, onUpdateAdresse: this.setUntersuchungsort, adressArt: ApiTypes.AdressArt.Untersuchungsstelle }),
            React.createElement(react_bootstrap_1.Panel, { header: "Bemerkung" },
                React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", type: "text", label: "Bemerkung", placeholder: "Optional", value: this.bemerkung, onChange: this.handleBemerkungChanged })),
            !this.voraussetzungenErfuellt() && (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Es wurden noch nicht alle erforderlichen Felder ausgef\u00FCllt!"))),
            React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", disabled: !this.voraussetzungenErfuellt() }, "Auftrag anlegen"))));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAnlegenBPS.prototype, "handleAuftragAnlegenSubmit", null);
    AuftragAnlegenBPS = __decorate([
        mobx_react_1.observer
    ], AuftragAnlegenBPS);
    return AuftragAnlegenBPS;
}(AuftragAnlegen_1.default));
exports.default = AuftragAnlegenBPS;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var ApiTypes = __webpack_require__(21);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var AuftragAdresseErfassen_1 = __webpack_require__(109);
var LadeFortschritt_1 = __webpack_require__(53);
var AuftragAnlegen_1 = __webpack_require__(108);
/** Formular zum Anlegen eines neuen Auftrags für die Kalibrierung von Druckmessgeräten (DMG) */
var AuftragAnlegenDMG = (function (_super) {
    __extends(AuftragAnlegenDMG, _super);
    function AuftragAnlegenDMG() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kategorie = 'dmg';
        return _this;
    }
    AuftragAnlegenDMG.prototype.handleAuftragAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var daten, auftragResponse, anr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        daten = {
                            'auftragname': "DMG " + this.auftraggeber.name,
                            'pinummer': this.verantwortlicher,
                            'referenzdatum': this.referenzdatum,
                            'lizenznehmer': this.lizenznehmer,
                            'kategorie': this.kategorie,
                            'bemerkung': this.bemerkung,
                            'abweichenderuntersuchungsort': !this.untersuchungsortGleichAuftraggeber,
                            'auftraggeber': {
                                'name1': this.auftraggeber.name,
                                'name2': this.auftraggeber.zusatz,
                                'strasse': this.auftraggeber.strasse,
                                'plz': this.auftraggeber.plz,
                                'ort': this.auftraggeber.ort,
                                'tel': this.auftraggeber.tel1,
                                'email': this.auftraggeber.email,
                                'email2': this.auftraggeber.email2,
                                'adressid': this.auftraggeber.adressid
                            },
                            'beauftragter': {
                                'name1': this.untersuchungsort.name,
                                'name2': this.untersuchungsort.zusatz,
                                'strasse': this.untersuchungsort.strasse,
                                'plz': this.untersuchungsort.plz,
                                'ort': this.untersuchungsort.ort,
                                'tel': this.untersuchungsort.tel1,
                                'email': this.untersuchungsort.email,
                                'adressid': this.untersuchungsort.adressid
                            }
                        };
                        return [4 /*yield*/, this.apiStore.auftragAnlegen(daten)];
                    case 1:
                        auftragResponse = _a.sent();
                        if (auftragResponse.ok) {
                            anr = auftragResponse.json.success;
                            this.uiStore.navigateTo("/auftrag/" + anr);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenDMG.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setAuftragskopfGeladen(false);
                        this.setReferenzDatum();
                        return [4 /*yield*/, this.uiStore.loadUserProfile()];
                    case 1:
                        _a.sent();
                        userProfile = this.uiStore.userProfile;
                        if (!(userProfile && userProfile.projektleiter)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uiStore.loadPersonallisteKategorie(this.kategorie)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.uiStore.loadFreigaben()];
                    case 4:
                        _a.sent();
                        if (this.uiStore.freigaben) {
                            if (this.uiStore.freigaben.length > 0) {
                                this.setLizenznehmer(this.uiStore.freigaben[0].lizenznehmer);
                            }
                        }
                        this.setAuftragskopfGeladen(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragAnlegenDMG.prototype.voraussetzungenErfuellt = function () {
        var result = (this.referenzdatum.trim() !== '') && (this.lizenznehmer) && (this.auftraggeber.name.trim() !== '');
        // Projektleiter dürfen den Auftrag anderen Personen zuweisen, in diesen Fällen muss zum speichern eine Person gewählt sein
        if (this.uiStore.userProfile && this.uiStore.userProfile.projektleiter) {
            result = result && (this.verantwortlicher !== '');
        }
        // Untersuchungsort nur validieren, wenn dieser vom Auftraggeber abweicht
        if (!this.untersuchungsortGleichAuftraggeber) {
            result = result && (this.untersuchungsort.name.trim() !== '');
        }
        return result;
    };
    AuftragAnlegenDMG.prototype.render = function () {
        var _this = this;
        if (!this.auftragskopfGeladen) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleAuftragAnlegenSubmit },
            React.createElement("h3", null, "Neuen Auftrag f\u00FCr Kalibrierung Druckmessger\u00E4t anlegen"),
            React.createElement(react_bootstrap_1.Panel, { header: "Auftragdetails" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.lizenznehmer === '' ? 'error' : undefined, controlId: "Anlegen für" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Anlegen f\u00FCr"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.lizenznehmer, onChange: this.handleLizenznehmerChanged }, this.uiStore.freigaben &&
                            this.uiStore.freigaben.map(function (freigabe) {
                                return React.createElement("option", { key: freigabe.lizenznehmer, value: freigabe.lizenznehmer },
                                    freigabe.name,
                                    " (",
                                    freigabe.lizenznehmer,
                                    ")");
                            })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.referenzdatum === '' ? 'error' : undefined, controlId: "Referenzdatum" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Referenzdatum"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "date", label: "Referenzdatum", value: this.referenzdatum, onChange: this.handleDatumChanged }))),
                this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                    (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.verantwortlicher === '' ? 'error' : undefined, controlId: "Zuweisung" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zuweisung"),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.verantwortlicher, onChange: this.handlePiChanged },
                                React.createElement("option", { value: "" }, "Bitte zust\u00E4ndige Person w\u00E4hlen..."),
                                this.uiStore.personalliste &&
                                    this.uiStore.personalliste.map(function (personal) {
                                        return React.createElement("option", { key: personal.pi, value: personal.pi },
                                            personal.vorname,
                                            " ",
                                            personal.name,
                                            " (",
                                            personal.pi,
                                            ")");
                                    })))))),
            React.createElement(AuftragAdresseErfassen_1.default, { caption: "Auftraggeber", adresse: this.auftraggeber, onUpdateAdresse: this.setAuftraggeber, adressArt: ApiTypes.AdressArt.Auftraggeber }),
            React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkboxSeparateOrtsEingabe", onChange: this.handleUntersuchungsortGleichAuftraggeberChange, defaultChecked: this.untersuchungsortGleichAuftraggeber }, "Untersuchungssort entspricht Auftraggeber")),
            !this.untersuchungsortGleichAuftraggeber &&
                React.createElement(AuftragAdresseErfassen_1.default, { caption: "Ort der Kalibrierung", adresse: this.untersuchungsort, onUpdateAdresse: this.setUntersuchungsort, adressArt: ApiTypes.AdressArt.Untersuchungsstelle }),
            React.createElement(react_bootstrap_1.Panel, { header: "Bemerkung" },
                React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", type: "text", label: "Bemerkung", placeholder: "Optional", value: this.bemerkung, onChange: this.handleBemerkungChanged })),
            !this.voraussetzungenErfuellt() && (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Es wurden noch nicht alle erforderlichen Felder ausgef\u00FCllt!"))),
            React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", disabled: !this.voraussetzungenErfuellt() }, "Auftrag anlegen"))));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAnlegenDMG.prototype, "handleAuftragAnlegenSubmit", null);
    AuftragAnlegenDMG = __decorate([
        mobx_react_1.observer
    ], AuftragAnlegenDMG);
    return AuftragAnlegenDMG;
}(AuftragAnlegen_1.default));
exports.default = AuftragAnlegenDMG;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var UiStore_1 = __webpack_require__(14);
var numberformat_1 = __webpack_require__(56);
var FaIcon_1 = __webpack_require__(20);
/** Einzelnes Listenelement mit Kopfinformationen zu Rechnung/Gutschrift */
var AuftragBelegListItem = (function (_super) {
    __extends(AuftragBelegListItem, _super);
    function AuftragBelegListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragBelegListItem.prototype.render = function () {
        var _this = this;
        var rechnung = this.props.rechnung;
        return (React.createElement(react_bootstrap_1.ListGroupItem, { onClick: function () { return _this.uiStore.navigateTo("/beleg/" + rechnung.renr); } },
            React.createElement("div", null,
                rechnung.datum,
                " - ",
                rechnung.art,
                " Nr. ",
                rechnung.renr,
                rechnung.netto && React.createElement("span", null,
                    " - ",
                    numberformat_1.numberformatMoney(rechnung.netto),
                    " \u20AC"),
                " - ",
                rechnung.statustext,
                React.createElement("span", { className: "pull-right", title: "Details zu diesem Beleg einsehen" },
                    React.createElement(FaIcon_1.default, { icon: "eye" })))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragBelegListItem.prototype, "uiStore", void 0);
    return AuftragBelegListItem;
}(React.Component));
var AuftragBelegListe = (function (_super) {
    __extends(AuftragBelegListe, _super);
    function AuftragBelegListe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragBelegListe.prototype.setRechnungen = function (rechnungen) {
        this.rechnungen = rechnungen;
    };
    AuftragBelegListe.prototype.ladeRechnungen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.rechnungenAuftrag(this.props.anr)];
                    case 1:
                        response = _a.sent();
                        if (response && response.ok) {
                            this.setRechnungen(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragBelegListe.prototype.componentDidMount = function () {
        this.ladeRechnungen();
    };
    AuftragBelegListe.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h3", null, "Belege"),
            React.createElement(react_bootstrap_1.Panel, null,
                React.createElement(react_bootstrap_1.ListGroup, { fill: true, className: "auftragsliste" },
                    this.rechnungen && this.rechnungen.length === 0 && (React.createElement(react_bootstrap_1.ListGroupItem, null, "keine Eintr\u00E4ge")),
                    this.rechnungen && this.rechnungen.map(function (rechnung, index) { return React.createElement(AuftragBelegListItem, { key: index, rechnung: rechnung }); })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragBelegListe.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AuftragBelegListe.prototype, "rechnungen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragBelegListe.prototype, "setRechnungen", null);
    AuftragBelegListe = __decorate([
        mobx_react_1.observer
    ], AuftragBelegListe);
    return AuftragBelegListe;
}(React.Component));
exports.default = AuftragBelegListe;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(52);
var mobx_react_1 = __webpack_require__(4);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var decorators_1 = __webpack_require__(1);
var AuftragDetails_1 = __webpack_require__(595);
var VorgangDetailRouter_1 = __webpack_require__(626);
var PrivateRoute_1 = __webpack_require__(168);
var AuftragAnlegenSES_1 = __webpack_require__(265);
var AuftragDienstleistungAnlegen_1 = __webpack_require__(597);
var AuftragStore_1 = __webpack_require__(25);
var ObjektAuswahl_1 = __webpack_require__(271);
var ObjektAnlegenSEP_1 = __webpack_require__(270);
var ApiTypes_1 = __webpack_require__(21);
var ObjektAnlegenAGT_1 = __webpack_require__(268);
var BreadCrumbs_1 = __webpack_require__(610);
var AuftragAdresseAendern_1 = __webpack_require__(602);
var ObjektAnlegenBPS_1 = __webpack_require__(269);
var LadeFortschritt_1 = __webpack_require__(53);
var AuftragDetailsAendern_1 = __webpack_require__(596);
var AuftragDetailRouter = (function (_super) {
    __extends(AuftragDetailRouter, _super);
    function AuftragDetailRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragDetailRouter.prototype.componentDidMount = function () {
        this.loadAuftrag();
    };
    AuftragDetailRouter.prototype.loadAuftrag = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId;
            return __generator(this, function (_a) {
                auftragId = this.props.match.params.auftragId;
                this.auftragStore.loadAuftrag(auftragId);
                return [2 /*return*/];
            });
        });
    };
    AuftragDetailRouter.prototype.handleAuftragNeuladen = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadAuftrag();
                return [2 /*return*/];
            });
        });
    };
    AuftragDetailRouter.prototype.handleAddDienstleistung = function (dienstleistung) {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auftragId = this.props.match.params.auftragId;
                        return [4 /*yield*/, this.apiStore.auftragDienstleistungAnlegen(auftragId, dienstleistung)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.uiStore.navigateTo(this.props.match.url);
                            this.loadAuftrag();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleFolgeAuftragAnlegen = function (auftrag) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragFolgeaAuftragAnlegen(auftrag.anr)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.uiStore.navigateTo("/auftrag/" + response.json.success, true);
                            // Der Router lädt den Auftrag nicht automatisch neu, deshalb manuellen Reload forcieren
                            // @todo: Besseren/saubereren Weg finden. History ist trotzdem falsch.
                            location.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleAuftragAbschliessen = function (auftrag) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragAbschliessen(auftrag.anr)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.loadAuftrag();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleAuftragZurueckstellen = function (auftrag) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragZurueckstellen(auftrag.anr)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.loadAuftrag();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleAuftragInArbeit = function (auftrag) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragInArbeit(auftrag.anr)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.loadAuftrag();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleObjektAuswahl = function (objekt) {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auftragId = this.props.match.params.auftragId;
                        return [4 /*yield*/, this.apiStore.auftragObjektSetzen(auftragId, objekt.objektguid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.success) {
                            this.loadAuftrag();
                            this.uiStore.navigateTo(this.props.match.url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleAddObjekt = function (objekt) {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auftragId = this.props.match.params.auftragId;
                        return [4 /*yield*/, this.apiStore.objektAnlegen(objekt, auftragId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.success) {
                            this.loadAuftrag();
                            this.uiStore.navigateTo(this.props.match.url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.handleObjektAuswahlAufheben = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auftragId, i, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auftragId = this.props.match.params.auftragId;
                        if (!((this.auftragStore.auftrag) && (this.auftragStore.auftrag.objekte))) return [3 /*break*/, 5];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.auftragStore.auftrag.objekte.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiStore.auftragObjektEntfernen(auftragId, this.auftragStore.auftrag.objekte[i].objektguid)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            return [3 /*break*/, 4];
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.loadAuftrag();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailRouter.prototype.render = function () {
        var _this = this;
        var url = this.props.match.url;
        var auftrag = this.auftragStore.auftrag;
        return (React.createElement("div", { className: "auftrag-details" },
            React.createElement(BreadCrumbs_1.default, null),
            !auftrag ? React.createElement(LadeFortschritt_1.default, null) : (React.createElement("div", null,
                React.createElement("h2", null, auftrag.auftrag_name),
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(PrivateRoute_1.default, { path: url + "/vorgang/:vorgangId", component: VorgangDetailRouter_1.default }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/auftraggeber", render: function () {
                            return React.createElement(AuftragAnlegenSES_1.default, null);
                        } }),
                    "/>",
                    React.createElement(PrivateRoute_1.default, { path: url + "/details/aendern", render: function () { return (React.createElement(AuftragDetailsAendern_1.default, { auftrag: auftrag, onAuftragNeuladen: _this.handleAuftragNeuladen })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/adresse/auftraggeber", render: function () { return (React.createElement(AuftragAdresseAendern_1.default, { auftrag: auftrag, caption: "Auftraggeber ändern", adressArt: ApiTypes_1.AdressArt.Auftraggeber, onAuftragNeuladen: _this.handleAuftragNeuladen })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/adresse/untersuchungsort", render: function () { return (React.createElement(AuftragAdresseAendern_1.default, { auftrag: auftrag, caption: "Untersuchungsort ändern", adressArt: ApiTypes_1.AdressArt.Beauftragter, onAuftragNeuladen: _this.handleAuftragNeuladen })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/adresse/kalibrierort", render: function () { return (React.createElement(AuftragAdresseAendern_1.default, { auftrag: auftrag, caption: "Ort der Kalibrierung ändern", adressArt: ApiTypes_1.AdressArt.Beauftragter, onAuftragNeuladen: _this.handleAuftragNeuladen })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/objekte", exact: true, render: function () { return (React.createElement(ObjektAuswahl_1.default, { kategorie: auftrag.kategorie, onObjektAuswahl: _this.handleObjektAuswahl })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/ses", exact: true, render: function () { return (React.createElement(ObjektAnlegenSEP_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/agt", exact: true, render: function () { return (React.createElement(ObjektAnlegenAGT_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/bps", exact: true, render: function () { return (React.createElement(ObjektAnlegenBPS_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                    React.createElement(PrivateRoute_1.default, { path: url + "/neuedienstleistung", render: function () {
                            return React.createElement(AuftragDienstleistungAnlegen_1.default, { auftragId: auftrag.anr, auftragKategorie: auftrag.kategorie ? auftrag.kategorie : '', onAddDienstleistung: _this.handleAddDienstleistung });
                        } }),
                    React.createElement(PrivateRoute_1.default, { render: function () {
                            return React.createElement(AuftragDetails_1.default, { auftragId: auftrag.anr, onAuftragAbschliessen: _this.handleAuftragAbschliessen, onAuftragZurueckstellen: _this.handleAuftragZurueckstellen, onAuftragInArbeit: _this.handleAuftragInArbeit, onAuftragObjektAuswahlAufheben: _this.handleObjektAuswahlAufheben, onFolgeAuftragAnlegen: _this.handleFolgeAuftragAnlegen });
                        } }))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragDetailRouter.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], AuftragDetailRouter.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragDetailRouter.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleAuftragNeuladen", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleAddDienstleistung", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleFolgeAuftragAnlegen", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleAuftragAbschliessen", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleAuftragZurueckstellen", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleAuftragInArbeit", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleObjektAuswahl", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleAddObjekt", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuftragDetailRouter.prototype, "handleObjektAuswahlAufheben", null);
    AuftragDetailRouter = __decorate([
        mobx_react_1.observer
    ], AuftragDetailRouter);
    return AuftragDetailRouter;
}(React.Component));
exports.default = AuftragDetailRouter;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiTypes_1 = __webpack_require__(21);
var AuftragAdesse_1 = __webpack_require__(601);
var VorgangListe_1 = __webpack_require__(629);
var DocumentList_1 = __webpack_require__(267);
var ObjektListe_1 = __webpack_require__(165);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
var FaIcon_1 = __webpack_require__(20);
var LadeFortschritt_1 = __webpack_require__(53);
var AuftragBelegListe_1 = __webpack_require__(593);
var AuftragDetails = (function (_super) {
    __extends(AuftragDetails, _super);
    function AuftragDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragDetails.prototype.componentDidMount = function () {
        this.refreshAuftrag();
    };
    AuftragDetails.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.auftragId !== this.props.auftragId) {
            this.loadAuftrag(nextProps.auftragId);
        }
    };
    AuftragDetails.prototype.loadAuftrag = function (auftragId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uiStore.apiStore.auftragDetails(auftragId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setAuftrag(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetails.prototype.setAuftrag = function (auftrag) {
        this.auftrag = auftrag;
    };
    AuftragDetails.prototype.refreshAuftrag = function () {
        this.loadAuftrag(this.props.auftragId);
    };
    Object.defineProperty(AuftragDetails.prototype, "objektBezeichner", {
        // Liefert den zur Auftragskategorie passenden Objektbezeichner
        // SEP für SES, AGT für Kal. Abgasmessgerät
        get: function () {
            var kategorie = this.auftrag.kategorie ? this.auftrag.kategorie : '';
            switch (kategorie.toLocaleLowerCase()) {
                case 'ses':
                    return 'Scheinwerfer-Einstellprüfgerät';
                case 'agt':
                    return 'Abgasmessgerät';
                case 'bps':
                    return 'Bremsenprüfstand';
                default:
                    return 'Objekt';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuftragDetails.prototype, "objektAuswahl", {
        /**
         * Liefert true wenn die Objektauswahl im Auftrag angezeigt werden soll
         * Hängt von der Kategorie des Auftrags bzw. dem Verfahren ab
         */
        get: function () {
            if (!this.auftrag.kategorie) {
                return true;
            }
            switch (this.auftrag.kategorie.toLocaleLowerCase()) {
                case 'agt':
                    return false;
                case 'dmg':
                    return false;
                default:
                    return true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuftragDetails.prototype, "mailToLinkOeffentlicheFreigabe", {
        /** Erzeugt einen "MailTo"-HTML Link der eine Mail-Vorlage im installierten Mail-Programm öffnet */
        get: function () {
            var titel = encodeURIComponent("Ihre DIQ Zert Dokumente zu Auftrag " + this.auftrag.auftrag_name);
            var body = "Sehr geehrte Damen und Herren,%0D%0A%0D%0Adie Dokumente zu Ihrem Auftrag finden Sie nach Freigabe durch die DIQ Zert GmbH unter folgendem Link:%0D%0A" + this.auftrag.oeffentlicherlink;
            return "mailto:?subject=" + titel + "&body=" + body;
        },
        enumerable: true,
        configurable: true
    });
    AuftragDetails.prototype.render = function () {
        var _this = this;
        var _a = this.props, onAuftragAbschliessen = _a.onAuftragAbschliessen, onAuftragInArbeit = _a.onAuftragInArbeit, onAuftragZurueckstellen = _a.onAuftragZurueckstellen, onAuftragObjektAuswahlAufheben = _a.onAuftragObjektAuswahlAufheben, onFolgeAuftragAnlegen = _a.onFolgeAuftragAnlegen;
        var auftrag = this.auftrag;
        if (!auftrag) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        var portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("div", null,
                "Referenznummer: ",
                auftrag.refnr,
                " ",
                React.createElement("br", null),
                this.uiStore.userProfile && this.uiStore.userProfile.projektleiter && (React.createElement("span", null,
                    "Zugewiesen an: ",
                    auftrag.pi.vorname,
                    " ",
                    auftrag.pi.name,
                    " (",
                    auftrag.pi.nummer,
                    ")",
                    React.createElement("br", null))),
                auftrag.bemerkung && auftrag.bemerkung !== '-' && React.createElement("div", null,
                    React.createElement(FaIcon_1.default, { icon: "file-text-o" }),
                    " ",
                    auftrag.bemerkung),
                auftrag.referenzdatum,
                " - ",
                React.createElement("span", { className: "auftrag-" + auftrag.auftragstatus.toLowerCase() }, auftrag.statustext),
                !auftrag.abgeschlossen && (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo("details/aendern"); } }, "Angaben \u00E4ndern")))),
            auftrag.abgeschlossen && (React.createElement("div", null,
                React.createElement(Callout_1.default, { bsStyle: "info" },
                    React.createElement("h4", null,
                        React.createElement(FaIcon_1.default, { icon: "info-circle" }),
                        " Dieser Auftrag ist bereits abgeschlossen"),
                    React.createElement("p", null, "Ein \u00C4ndern der Daten ist erst nach erneuter Freigabe eines Mitarbeiters der DIQ Zert GmbH m\u00F6glich.")),
                portalAdmin &&
                    React.createElement(Callout_1.default, { bsStyle: "success" },
                        React.createElement("h4", null,
                            React.createElement(FaIcon_1.default, { icon: "clone" }),
                            " Folgeauftrag anlegen"),
                        React.createElement("p", null, "Auf Basis der in diesem Auftrag erfassten Daten kann ein Folgeauftrag mit Daten\u00FCbernahme angelegt werden."),
                        React.createElement("div", { className: "text-right" },
                            React.createElement(react_bootstrap_1.Button, { bsStyle: "success", type: "submit", className: "btn-group", onClick: function () { return onFolgeAuftragAnlegen(auftrag); } }, "Folgeauftrag anlegen"))))),
            auftrag.oeffentlicherlink &&
                React.createElement("div", null,
                    React.createElement("h3", null, "\u00D6ffentliche Dokumentenfreigabe"),
                    React.createElement("div", null,
                        "Nach Pr\u00FCfung durch die DIQ Zert freigegebene Dokumente k\u00F6nnen \u00FCber ",
                        React.createElement("a", { href: auftrag.oeffentlicherlink, target: "_blank" }, "diesen Link"),
                        " (",
                        React.createElement("a", { title: "Per Mail versenden (Vorlage in Mail-Programm öffnen)", href: this.mailToLinkOeffentlicheFreigabe },
                            React.createElement(FaIcon_1.default, { icon: "envelope-o" }),
                            " Mailvorlage"),
                        ") ohne Zugangsdaten heruntergeladen werden.")),
            React.createElement("h3", null, "Auftraggeber"),
            React.createElement(AuftragAdesse_1.default, { auftrag: auftrag, adressArt: ApiTypes_1.AdressArt.Auftraggeber }),
            !auftrag.abgeschlossen && (React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo("adresse/auftraggeber"); } }, "Angaben \u00E4ndern"))),
            React.createElement("h3", null, "Ort der Kalibrierung"),
            React.createElement(AuftragAdesse_1.default, { auftrag: auftrag, adressArt: ApiTypes_1.AdressArt.Beauftragter }),
            !auftrag.abgeschlossen && (React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo("adresse/kalibrierort"); } }, "Angaben \u00E4ndern"))),
            this.objektAuswahl &&
                React.createElement("div", null,
                    React.createElement("h3", null, this.objektBezeichner),
                    React.createElement(ObjektListe_1.default, { showTitle: false, objekte: auftrag.objekte, editable: !auftrag.abgeschlossen, auftrag: auftrag, onAuswahlAufheben: function () { return onAuftragObjektAuswahlAufheben(auftrag); } })),
            React.createElement("h3", null, "Dienstleistungen"),
            auftrag.dienstleistungen.map(function (dienstleistung, index) { return (React.createElement(VorgangListe_1.default, { key: index, dienstleistung: dienstleistung, vorgaenge: auftrag.vorgaenge })); }),
            !auftrag.abgeschlossen && auftrag.inarbeit && (React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateTo("neuedienstleistung"); } }, "Neue Dienstleistung"))),
            React.createElement("h3", null, "Workflow"),
            !auftrag.abgeschlossen && auftrag.inarbeit && (React.createElement(Callout_1.default, { bsStyle: "warning" },
                React.createElement("h4", null, "Auftrag abschlie\u00DFen"),
                React.createElement("p", null, "Durch das Abschlie\u00DFen wird ein Mitarbeiter des DIQ Zert GmbH informiert und der Auftrag f\u00FCr weitere Bearbeitungen gesperrt."),
                ((!auftrag.auftraggeber_strasse) || (!auftrag.auftraggeber_plz) || (!auftrag.auftraggeber_ort)) &&
                    React.createElement("p", null,
                        React.createElement("b", null, "Damit der Auftrag abgeschlossen werden kann, m\u00FCssen noch folgende Angaben zum Auftraggeber gemacht werden:")),
                React.createElement("ul", null,
                    (!auftrag.auftraggeber_strasse) && React.createElement("li", null, "Stra\u00DFe"),
                    (!auftrag.auftraggeber_plz) && React.createElement("li", null, "PLZ"),
                    (!auftrag.auftraggeber_ort) && React.createElement("li", null, "Ort")),
                (auftrag.auftraggeber_strasse) && (auftrag.auftraggeber_plz) && (auftrag.auftraggeber_ort) &&
                    React.createElement("div", { className: "text-right" },
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", className: "btn-group", type: "submit", onClick: function () { return onAuftragAbschliessen(auftrag); } }, "Auftrag abschlie\u00DFen")))),
            !auftrag.abgeschlossen && (auftrag.auftragstatus === 'zurueck') && (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Auftrag weiterbearbeiten"),
                React.createElement("p", null, "Der Auftrag wird f\u00FCr die erneute Bearbeitung freigeschaltet."),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "info", className: "btn-group", type: "submit", onClick: function () { return onAuftragInArbeit(auftrag); } }, "Auftrag weiterbearbeiten")))),
            !auftrag.abgeschlossen && (['angebot', 'auftert', 'auftbest', 'geplant', 'termin'].indexOf(auftrag.auftragstatus) >= 0) && (React.createElement(Callout_1.default, { bsStyle: "success" },
                React.createElement("h4", null, "Bearbeitung starten"),
                React.createElement("p", null, "\u00C4ndert den Status des Auftrags auf \"in Arbeit\", es k\u00F6nnen weitere Dienstleistungen eingef\u00FCgt und abgearbeitet werden."),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "success", className: "btn-group", type: "submit", onClick: function () { return onAuftragInArbeit(auftrag); } }, "Bearbeitung starten")))),
            !auftrag.abgeschlossen && auftrag.inarbeit && (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Auftrag zur\u00FCckstellen"),
                React.createElement("p", null, "Durch das Zur\u00FCckstellen kann der Auftrag zu einem sp\u00E4teren Zeitpunkt weiterbearbeitet werden."),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "info", className: "btn-group", type: "submit", onClick: function () { return onAuftragZurueckstellen(auftrag); } }, "Auftrag zur\u00FCckstellen")))),
            React.createElement(DocumentList_1.default, { header: "headline", source: "auftrag", id: auftrag.anr }),
            React.createElement(AuftragBelegListe_1.default, { anr: auftrag.anr })));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragDetails.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragDetails.prototype, "auftrag", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetails.prototype, "setAuftrag", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragDetails.prototype, "refreshAuftrag", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AuftragDetails.prototype, "objektBezeichner", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AuftragDetails.prototype, "objektAuswahl", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AuftragDetails.prototype, "mailToLinkOeffentlicheFreigabe", null);
    AuftragDetails = __decorate([
        mobx_react_1.observer
    ], AuftragDetails);
    return AuftragDetails;
}(React.Component));
exports.default = AuftragDetails;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var decorators_2 = __webpack_require__(1);
var ApiTypes = __webpack_require__(21);
var LadeFortschritt_1 = __webpack_require__(53);
/** Komponente zum nachträglichen Ändern der Kopfdaten eines Auftrags */
var AuftragDetailsAendern = (function (_super) {
    __extends(AuftragDetailsAendern, _super);
    function AuftragDetailsAendern(props) {
        var _this = _super.call(this, props) || this;
        _this.datenGeladen = false;
        // Kopfdaten
        _this.auftragname = '';
        _this.lizenznehmer = '';
        _this.verantwortlicher = '';
        _this.referenzdatum = '';
        _this.bemerkung = '';
        // Spezifische Eigenschaften (je nach Auftragstyp) werden als Meta-Daten verwaltet
        _this.meta = [
            { bezeichnung: ApiTypes.SES_TYP, inhalt: 'PKW' },
            { bezeichnung: ApiTypes.SES_BAHN, inhalt: '' }
        ];
        _this.auftragname = _this.props.auftrag.auftrag_name;
        _this.lizenznehmer = _this.props.auftrag.lizenznehmer;
        _this.verantwortlicher = _this.props.auftrag.verantwortlicher;
        _this.bemerkung = _this.props.auftrag.bemerkung ? _this.props.auftrag.bemerkung : '';
        // Für die Übernahme in den Datepicker muss das Datum vom Deutschen Format (des Backends) in das ISO-Format konvertiert werden
        var datumTeile = _this.props.auftrag.referenzdatum.split('.');
        _this.referenzdatum = datumTeile[2] + "-" + datumTeile[1] + "-" + datumTeile[0];
        // SES Aufträge speichern spezifische Eigenschaften als Metaden, die aus der entspr. Tabelle wiederhergestellt werden
        if (_this.props.auftrag.kategorie.toLocaleLowerCase() === 'ses') {
            _this.ladeMetaDatum(ApiTypes.SES_TYP);
            _this.ladeMetaDatum(ApiTypes.SES_BAHN);
        }
        return _this;
    }
    AuftragDetailsAendern.prototype.setDatenGeladen = function (value) {
        this.datenGeladen = value;
    };
    AuftragDetailsAendern.prototype.ladeMetaDatum = function (bezeichnung) {
        var metaDatum = this.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        var metaDatumAuftrag = this.props.auftrag.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        if (metaDatum && metaDatumAuftrag) {
            metaDatum.inhalt = metaDatumAuftrag.inhalt;
            console.table(metaDatum);
        }
    };
    AuftragDetailsAendern.prototype.holeMetadatum = function (bezeichnung) {
        var metadatum = this.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        if (metadatum) {
            return metadatum.inhalt;
        }
        return '';
    };
    AuftragDetailsAendern.prototype.setzeMetadatum = function (bezeichnung, inhalt) {
        var metadatum = this.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; });
        if (metadatum) {
            metadatum.inhalt = inhalt;
        }
    };
    AuftragDetailsAendern.prototype.handleSesFzKategorieSelected = function (event) {
        this.setzeMetadatum(ApiTypes.SES_TYP, event.target.value);
    };
    AuftragDetailsAendern.prototype.handleSesBahnChanged = function (event) {
        this.setzeMetadatum(ApiTypes.SES_BAHN, event.target.value);
    };
    AuftragDetailsAendern.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setDatenGeladen(false);
                        return [4 /*yield*/, this.uiStore.loadUserProfile()];
                    case 1:
                        _a.sent();
                        userProfile = this.uiStore.userProfile;
                        if (!(userProfile && userProfile.projektleiter)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uiStore.loadPersonallisteKategorie(this.props.auftrag.kategorie)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.uiStore.loadFreigaben()];
                    case 4:
                        _a.sent();
                        if (this.uiStore.freigaben) {
                            if (this.uiStore.freigaben.length > 0) {
                                this.setLizenznehmer(this.uiStore.freigaben[0].lizenznehmer);
                            }
                        }
                        this.setDatenGeladen(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Gemeinsam genutzte Eventhandller für Eingabefelder */
    AuftragDetailsAendern.prototype.handleAuftragnameChanged = function (event) {
        this.auftragname = event.target.value;
    };
    AuftragDetailsAendern.prototype.handleLizenznehmerChanged = function (event) {
        this.lizenznehmer = event.target.value;
    };
    AuftragDetailsAendern.prototype.handlePiChanged = function (event) {
        this.verantwortlicher = event.target.value;
    };
    AuftragDetailsAendern.prototype.handleDatumChanged = function (event) {
        this.referenzdatum = event.target.value;
    };
    AuftragDetailsAendern.prototype.handleBemerkungChanged = function (event) {
        this.bemerkung = event.target.value;
    };
    /** Gemeinsam genutzte Setter für Auftragseigenschaften */
    AuftragDetailsAendern.prototype.setVerantwortlicher = function (verantwortlicher) {
        this.verantwortlicher = verantwortlicher;
    };
    AuftragDetailsAendern.prototype.setLizenznehmer = function (lizenznehmer) {
        this.lizenznehmer = lizenznehmer;
    };
    AuftragDetailsAendern.prototype.validate = function () {
        var result = (this.auftragname !== '') && (this.referenzdatum !== '') && (this.lizenznehmer);
        // Projektleiter dürfen den Auftrag anderen Personen zuweisen, in diesen Fällen muss zum speichern eine Person gewählt sein
        if (this.uiStore.userProfile && this.uiStore.userProfile.projektleiter) {
            result = result && (this.verantwortlicher !== '');
        }
        return result;
    };
    AuftragDetailsAendern.prototype.handleSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var daten, auftragResponse, anr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        daten = {
                            'auftragname': this.auftragname,
                            'verantwortlicher': this.verantwortlicher,
                            'referenzdatum': this.referenzdatum,
                            'lizenznehmer': this.lizenznehmer,
                            'bemerkung': this.bemerkung,
                            'meta': []
                        };
                        if (this.props.auftrag.kategorie.toLocaleLowerCase() === 'ses') {
                            /* tslint:disable:no-string-literal */
                            daten['meta'] = this.meta;
                            /* tslint:enable:no-string-literal */
                        }
                        return [4 /*yield*/, this.apiStore.auftragDetailsAaendern(this.props.auftrag.anr, daten)];
                    case 1:
                        auftragResponse = _a.sent();
                        if (!auftragResponse.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onAuftragNeuladen()];
                    case 2:
                        _a.sent();
                        anr = auftragResponse.json.success;
                        this.uiStore.navigateTo("/auftrag/" + anr);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuftragDetailsAendern.prototype.render = function () {
        var _this = this;
        if (!this.datenGeladen) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleSubmit },
            React.createElement(react_bootstrap_1.Panel, { header: "Auftragdetails ändern", footer: React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", disabled: !this.validate() }, "\u00C4nderungen speichern")) },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.validate() ? undefined : 'error', controlId: "Name" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Name"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Name", value: this.auftragname, onChange: this.handleAuftragnameChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.lizenznehmer === '' ? 'error' : undefined, controlId: "Anlegen für" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Anlegen f\u00FCr"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.lizenznehmer, onChange: this.handleLizenznehmerChanged }, this.uiStore.freigaben &&
                            this.uiStore.freigaben.map(function (freigabe) {
                                return React.createElement("option", { key: freigabe.lizenznehmer, value: freigabe.lizenznehmer },
                                    freigabe.name,
                                    " (",
                                    freigabe.lizenznehmer,
                                    ")");
                            })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.referenzdatum === '' ? 'error' : undefined, controlId: "Referenzdatum" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Referenzdatum"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "date", label: "Referenzdatum", value: this.referenzdatum, onChange: this.handleDatumChanged }))),
                this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                    (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.verantwortlicher === '' ? 'error' : undefined, controlId: "Zuweisung" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zuweisung"),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.verantwortlicher, onChange: this.handlePiChanged },
                                React.createElement("option", { value: "" }, "Bitte zust\u00E4ndige Person w\u00E4hlen..."),
                                this.uiStore.personalliste &&
                                    this.uiStore.personalliste.map(function (personal) {
                                        return React.createElement("option", { key: personal.pi, value: personal.pi },
                                            personal.vorname,
                                            " ",
                                            personal.name,
                                            " (",
                                            personal.pi,
                                            ")");
                                    }))))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Bemerkung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Bemerkung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", type: "text", label: "Bemerkung", placeholder: "Optional", value: this.bemerkung, onChange: this.handleBemerkungChanged }))),
                this.props.auftrag.kategorie.toLocaleLowerCase() === 'ses' &&
                    React.createElement("div", null,
                        React.createElement(react_bootstrap_1.FormGroup, { controlId: "Fahrzeugkategorie" },
                            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Fahrzeugkategorie"),
                            React.createElement(react_bootstrap_1.Col, { sm: 9 },
                                React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.holeMetadatum(ApiTypes.SES_TYP), onChange: this.handleSesFzKategorieSelected },
                                    React.createElement("option", { value: "PKW" }, "PKW"),
                                    React.createElement("option", { value: "LKW" }, "LKW"),
                                    React.createElement("option", { value: "KRAD" }, "KRAD")))),
                        React.createElement(react_bootstrap_1.FormGroup, { controlId: "Pruefbahn" },
                            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Pr\u00FCfbahn"),
                            React.createElement(react_bootstrap_1.Col, { sm: 9 },
                                React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Pruefbahn", placeholder: "Optional", value: this.holeMetadatum(ApiTypes.SES_BAHN), onChange: this.handleSesBahnChanged })))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragDetailsAendern.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragDetailsAendern.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AuftragDetailsAendern.prototype, "datenGeladen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragDetailsAendern.prototype, "auftragname", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragDetailsAendern.prototype, "lizenznehmer", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragDetailsAendern.prototype, "verantwortlicher", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AuftragDetailsAendern.prototype, "referenzdatum", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragDetailsAendern.prototype, "bemerkung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AuftragDetailsAendern.prototype, "meta", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "setDatenGeladen", null);
    __decorate([
        decorators_2.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "ladeMetaDatum", null);
    __decorate([
        decorators_2.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "holeMetadatum", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "setzeMetadatum", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handleSesFzKategorieSelected", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handleSesBahnChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handleAuftragnameChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handleLizenznehmerChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handlePiChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handleDatumChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "handleBemerkungChanged", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "setVerantwortlicher", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuftragDetailsAendern.prototype, "setLizenznehmer", null);
    __decorate([
        decorators_2.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragDetailsAendern.prototype, "handleSubmit", null);
    AuftragDetailsAendern = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AuftragDetailsAendern);
    return AuftragDetailsAendern;
}(React.Component));
exports.default = AuftragDetailsAendern;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var FilterBox_1 = __webpack_require__(89);
var ListFilter = (function () {
    function ListFilter() {
    }
    ListFilter.prototype.set = function (dienstleistungen, auftragDetails) {
        this.dienstleistungen = [];
        var _loop_1 = function (dienstleistung) {
            // Gültige Dienstleistungen sollen nur einmal aufgelistet werden, auch wenn diese mehrfach über unterschiedliche Befugnisse für den angemeldeten Benutzer freigeschaltet
            if (!dienstleistung.gueltig || this_1.dienstleistungen.some(function (d) { return d.dienstleistung.kuerzel_dienstleistung === dienstleistung.kuerzel_dienstleistung; })) {
                return "continue";
            }
            this_1.dienstleistungen.push({
                dienstleistung: dienstleistung,
                benutzt: auftragDetails.dienstleistungen.some(function (ad) { return ad.kuerzel_dienstleistung.toLowerCase() === dienstleistung.kuerzel_dienstleistung.toLowerCase(); }),
                // Bestimmte Vorgänge wie z.B. Dienstleistungsnachweise dürfen nur einmal im Auftrag eingefügt werden
                einmalig: dienstleistung.kuerzel_dienstleistung.toLocaleLowerCase().indexOf('dienstleistungsnachweis') > -1,
                // Bezeichnungen (als Beschreibung) anzeigen wenn ungleich Kürzel
                zeigebezeichnung: dienstleistung.bezeichnung !== dienstleistung.kuerzel_befugnis
            });
        };
        var this_1 = this;
        for (var _i = 0, dienstleistungen_1 = dienstleistungen; _i < dienstleistungen_1.length; _i++) {
            var dienstleistung = dienstleistungen_1[_i];
            _loop_1(dienstleistung);
        }
    };
    Object.defineProperty(ListFilter.prototype, "filtered", {
        get: function () {
            var _this = this;
            if (this.filter) {
                return this.dienstleistungen ? this.dienstleistungen.filter(function (el) { return el.dienstleistung.kuerzel_dienstleistung.toLocaleLowerCase().includes(_this.filter); }) : [];
            }
            else {
                return this.dienstleistungen;
            }
        },
        enumerable: true,
        configurable: true
    });
    ListFilter.prototype.setFilter = function (filter) {
        this.filter = filter.toLocaleLowerCase();
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ListFilter.prototype, "filter", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ListFilter.prototype, "dienstleistungen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ListFilter.prototype, "set", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ListFilter.prototype, "filtered", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ListFilter.prototype, "setFilter", null);
    return ListFilter;
}());
var AuftragDienstleistungAnlegen = (function (_super) {
    __extends(AuftragDienstleistungAnlegen, _super);
    function AuftragDienstleistungAnlegen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dienstleistungsliste = new ListFilter();
        return _this;
    }
    AuftragDienstleistungAnlegen.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dienstleistungen, auftragDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.dienstleistungen(this.props.auftragKategorie)];
                    case 1:
                        dienstleistungen = _a.sent();
                        return [4 /*yield*/, this.apiStore.auftragDetails(this.props.auftragId)];
                    case 2:
                        auftragDetails = _a.sent();
                        if (dienstleistungen.ok && auftragDetails.ok) {
                            this.dienstleistungsliste.set(dienstleistungen.json, auftragDetails.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuftragDienstleistungAnlegen.prototype.handleFilterList = function (event) {
        var filterText = event.target.value;
        this.dienstleistungsliste.setFilter(filterText);
    };
    AuftragDienstleistungAnlegen.prototype.render = function () {
        var _this = this;
        var onAddDienstleistung = this.props.onAddDienstleistung;
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h2", null, "Neue Dienstleistung hinzuf\u00FCgen"),
            React.createElement(FilterBox_1.default, { onChange: this.handleFilterList }),
            React.createElement(react_bootstrap_1.Panel, { header: "Verfügbare Dienstleistungen", footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"))) },
                React.createElement(react_bootstrap_1.ListGroup, { fill: true }, !this.dienstleistungsliste.filtered ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "Lade Dienstleistungen...")) : (this.dienstleistungsliste.filtered.length === 0) ? (React.createElement(react_bootstrap_1.ListGroupItem, null, "Es sind keine Dienstleistungen f\u00FCr diesen Auftragstyp verf\u00FCgbar")) : this.dienstleistungsliste.filtered.map(function (dienstleistung, index) { return (React.createElement(react_bootstrap_1.ListGroupItem, { key: index, className: (dienstleistung.benutzt && dienstleistung.dienstleistung.kuerzel_dienstleistung.toLocaleLowerCase().indexOf('dienstleistungsnachweis') > -1) ? 'dienstleistung-benutzt' : 'dienstleistung-neu' },
                    React.createElement(react_bootstrap_1.Row, null,
                        React.createElement(react_bootstrap_1.Col, { xs: 10, sm: 11, md: 11 },
                            dienstleistung.dienstleistung.kuerzel_dienstleistung,
                            dienstleistung.zeigebezeichnung && React.createElement("div", null,
                                React.createElement("small", null, dienstleistung.dienstleistung.bezeichnung)),
                            dienstleistung.benutzt && dienstleistung.einmalig &&
                                React.createElement("div", null,
                                    React.createElement("small", null, "Kann nur einmal eingef\u00FCgt werden, und wird im Auftrag bereits verwendet."))),
                        React.createElement(react_bootstrap_1.Col, { xs: 2, sm: 1, md: 1 }, onAddDienstleistung && (!dienstleistung.benutzt || !dienstleistung.einmalig) && (React.createElement(react_bootstrap_1.Button, { className: "btn-flat btn-success pull-right", title: "Dienstleistung hinzufügen", onClick: function () { return onAddDienstleistung(dienstleistung.dienstleistung.kuerzel_dienstleistung); } },
                            React.createElement(react_bootstrap_1.Glyphicon, { glyph: "plus" }))))))); })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragDienstleistungAnlegen.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragDienstleistungAnlegen.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragDienstleistungAnlegen.prototype, "handleFilterList", null);
    AuftragDienstleistungAnlegen = __decorate([
        mobx_react_1.observer
    ], AuftragDienstleistungAnlegen);
    return AuftragDienstleistungAnlegen;
}(React.Component));
exports.default = AuftragDienstleistungAnlegen;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Auflistung der Auftragskategorien die der angemeldete Bentutzer entsprechend seiner freigeschalteten
 * Laborfunktionen anlegen darf
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
var AuftragNeuItem = (function (_super) {
    __extends(AuftragNeuItem, _super);
    function AuftragNeuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragNeuItem.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.ListGroupItem, { header: this.props.header, onClick: this.props.onClick }, this.props.description));
    };
    return AuftragNeuItem;
}(React.Component));
var AuftragNeu = (function (_super) {
    __extends(AuftragNeu, _super);
    function AuftragNeu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragNeu.prototype.auftragsButtons = function () {
        var _this = this;
        var ses = false;
        var agt = false;
        var bps = false;
        var dmg = false;
        if (this.uiStore.userProfile && this.uiStore.userProfile.laborfunktionen) {
            ses = this.uiStore.userProfile.laborfunktionen.indexOf('ses') > -1;
            agt = this.uiStore.userProfile.laborfunktionen.indexOf('agt') > -1;
            bps = this.uiStore.userProfile.laborfunktionen.indexOf('bps') > -1;
            dmg = this.uiStore.userProfile.laborfunktionen.indexOf('dmg') > -1;
        }
        if (agt || ses || bps) {
            return (React.createElement(react_bootstrap_1.Panel, { collapsible: false, defaultExpanded: true, header: "Verfügbare Auftragstypen" },
                React.createElement(react_bootstrap_1.ListGroup, { fill: true },
                    ses &&
                        React.createElement(AuftragNeuItem, { header: "Scheinwerfer-Einstell-Prüfsystem", description: "Kalibrierung und Stückprüfung eines Scheinwerfer-Einstell-Prüfsystems bestehend aus Einstellplatz und -gerät.", onClick: function () { return _this.uiStore.navigateTo('/auftrag/neu/ses'); } }),
                    agt &&
                        React.createElement(AuftragNeuItem, { header: "Abgastester", description: "Kalibrierung von Abgastestern für Fremdzündungs- oder Kompressionszündungsmotoren, sowie Kombi-Geräte und Partikelzähler.", onClick: function () { return _this.uiStore.navigateTo('/auftrag/neu/agt'); } }),
                    bps &&
                        React.createElement(AuftragNeuItem, { header: "Bremsenprüfstand", description: "Kalibrierung eines Bremsenprüfstands.", onClick: function () { return _this.uiStore.navigateTo('/auftrag/neu/bps'); } }),
                    dmg &&
                        React.createElement(AuftragNeuItem, { header: "Druckmessgerät", description: "Kalibrierung eines Druckmessgeräts.", onClick: function () { return _this.uiStore.navigateTo('/auftrag/neu/dmg'); } }))));
        }
        else {
            return (this.uiStore.userProfile && this.uiStore.userProfile.laborfunktionen && (React.createElement(Callout_1.default, { bsStyle: "default" },
                React.createElement("p", null,
                    "Ihnen wurden bisher noch keine Verfahren zum Anlegen von Auftr\u00E4gen freigeschaltet.",
                    React.createElement("br", null),
                    "Bitte wenden Sie sich an den ",
                    React.createElement("a", { href: "/kontakt" }, "Support"),
                    " der DIQ Zert GmbH."))));
        }
    };
    AuftragNeu.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h2", null, "Neuen Auftrag anlegen"),
            this.auftragsButtons()));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragNeu.prototype, "uiStore", void 0);
    return AuftragNeu;
}(React.Component));
exports.default = AuftragNeu;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Auftraege_1 = __webpack_require__(264);
var AuftragUebersichtEigene = (function (_super) {
    __extends(AuftragUebersichtEigene, _super);
    function AuftragUebersichtEigene() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragUebersichtEigene.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h2", null, "Meine Auftr\u00E4ge"),
            React.createElement(Auftraege_1.default, { lizenzAuftraege: false })));
    };
    return AuftragUebersichtEigene;
}(React.Component));
exports.default = AuftragUebersichtEigene;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Auftraege_1 = __webpack_require__(264);
var AuftragUebersichtLizenz = (function (_super) {
    __extends(AuftragUebersichtLizenz, _super);
    function AuftragUebersichtLizenz() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragUebersichtLizenz.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h2", null, "Auftr\u00E4ge meiner Lizenz"),
            React.createElement(Auftraege_1.default, { lizenzAuftraege: true })));
    };
    return AuftragUebersichtLizenz;
}(React.Component));
exports.default = AuftragUebersichtLizenz;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiTypes = __webpack_require__(21);
var react_bootstrap_1 = __webpack_require__(2);
/** Komponente zur Anzeige einer im Auftrag hinterlegten Adresse */
var AuftragAdesse = (function (_super) {
    __extends(AuftragAdesse, _super);
    function AuftragAdesse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragAdesse.prototype.renderAdresseAuftraggeber = function () {
        var auftrag = this.props.auftrag;
        var ort = (this.props.auftrag.auftraggeber_plz || '') + " " + (this.props.auftrag.auftraggeber_ort || '');
        // Anzeige der Untersuchungsstelle als Meta-Datum für alte SES-Aufträge vor Umstellung auf explizite Adressen
        // @todo: kann nach Übergangsphase weg
        var ust;
        if (auftrag.kategorie === ApiTypes.AUFTRAG_KATEGORIE_SES) {
            if (auftrag.meta) {
                var metadatum = auftrag.meta.find(function (meta) { return meta.bezeichnung === ApiTypes.SES_UST; });
                if (metadatum) {
                    var inhalt = metadatum.inhalt.trim();
                    if ((inhalt.length > 0) && (inhalt !== '(ohne)')) {
                        ust = metadatum.inhalt;
                    }
                }
            }
        }
        return (React.createElement("div", { className: "auftraggeber" },
            React.createElement("div", { className: "auftraggeber-links" },
                (auftrag.auftraggeber_name1) && (React.createElement("div", null, auftrag.auftraggeber_name1)),
                (auftrag.auftraggeber_name2) && (React.createElement("div", null, auftrag.auftraggeber_name2)),
                (auftrag.auftraggeber_strasse) && (React.createElement("div", null, auftrag.auftraggeber_strasse)),
                (ort.trim().length > 0) && (React.createElement("div", null, ort)),
                (auftrag.auftraggeber_tel) && (auftrag.auftraggeber_tel.trim().length > 0) && (React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "earphone" }),
                    " ",
                    auftrag.auftraggeber_tel)),
                (auftrag.auftraggeber_email) && (auftrag.auftraggeber_email.trim().length > 0) && (React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "envelope" }),
                    " ",
                    auftrag.auftraggeber_email))),
            React.createElement("div", { className: "auftraggeber-rechts" }, (ust) && (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "map-marker" }),
                " ",
                ust)))));
    };
    /** Die Adresse des Beauftragten wird im Laborumfeld für den Ort der Untersuchung verwendet */
    AuftragAdesse.prototype.renderAdresseBeauftragter = function () {
        var auftrag = this.props.auftrag;
        var ort = (auftrag.beauftragter_plz || '') + " " + (auftrag.beauftragter_ort || '');
        return (React.createElement("div", { className: "auftraggeber" },
            React.createElement("div", { className: "auftraggeber-links" },
                (auftrag.beauftragter_name1) && (React.createElement("div", null, auftrag.beauftragter_name1)),
                (auftrag.beauftragter_name2) && (React.createElement("div", null, auftrag.beauftragter_name2)),
                (auftrag.beauftragter_strasse) && (React.createElement("div", null, auftrag.beauftragter_strasse)),
                (ort.trim().length > 0) && (React.createElement("div", null, ort)),
                (auftrag.beauftragter_tel) && (auftrag.beauftragter_tel.trim().length > 0) && (React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "earphone" }),
                    " ",
                    auftrag.beauftragter_tel)),
                (auftrag.beauftragter_email) && (auftrag.beauftragter_email.trim().length > 0) && (React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "envelope" }),
                    " ",
                    auftrag.beauftragter_email))),
            auftrag.untersuchungsstellenkennung &&
                React.createElement("div", { className: "auftraggeber-rechts" },
                    React.createElement("div", null,
                        React.createElement(react_bootstrap_1.Glyphicon, { glyph: "map-marker" }),
                        " ",
                        auftrag.untersuchungsstellenkennung))));
    };
    AuftragAdesse.prototype.render = function () {
        switch (this.props.adressArt) {
            case ApiTypes.AdressArt.Auftraggeber:
                return this.renderAdresseAuftraggeber();
            case ApiTypes.AdressArt.Beauftragter:
                return this.renderAdresseBeauftragter();
            default:
                return React.createElement("div", null);
        }
    };
    return AuftragAdesse;
}(React.Component));
exports.default = AuftragAdesse;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_react_1 = __webpack_require__(4);
var ApiStore_1 = __webpack_require__(13);
var ApiTypes = __webpack_require__(21);
var ApiFactory = __webpack_require__(54);
var FaIcon_1 = __webpack_require__(20);
var AuftragAdresseUebernehmen_1 = __webpack_require__(266);
/** Header für das Panel zur Adressänderungen mit Funktionen je nach Anwenderstufe  */
var AuftragAdresseAendernHeader = (function (_super) {
    __extends(AuftragAdresseAendernHeader, _super);
    function AuftragAdresseAendernHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuftragAdresseAendernHeader.prototype.render = function () {
        var portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
        return (React.createElement("div", null,
            React.createElement("div", { className: "panel-title pull-left" }, this.props.caption),
            React.createElement("div", { className: "panel-title pull-right" },
                React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: this.props.showModal },
                    React.createElement(FaIcon_1.default, { icon: "address-book-o" }),
                    " ",
                    portalAdmin ? 'Aus Adresse' : 'Aus Untersuchungsstelle')),
            React.createElement("div", { className: "clearfix" })));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragAdresseAendernHeader.prototype, "uiStore", void 0);
    return AuftragAdresseAendernHeader;
}(React.Component));
exports.AuftragAdresseAendernHeader = AuftragAdresseAendernHeader;
/** Komponente zum nachträglichen Ändern einer im Auftrag erfassten Adresse */
var AuftragAdresseAendern = (function (_super) {
    __extends(AuftragAdresseAendern, _super);
    function AuftragAdresseAendern(props) {
        var _this = _super.call(this, props) || this;
        _this.adresse = ApiFactory.leereAdresse();
        _this.modalVisible = false;
        // Daten aus Auftrag übernehmen
        var auftrag = _this.props.auftrag;
        if (_this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
            _this.adresse.name = auftrag.auftraggeber_name1;
            if (auftrag.auftraggeber_name2) {
                _this.adresse.zusatz = auftrag.auftraggeber_name2;
            }
            _this.adresse.strasse = auftrag.auftraggeber_strasse;
            _this.adresse.plz = auftrag.auftraggeber_plz;
            _this.adresse.ort = auftrag.auftraggeber_ort;
            if (auftrag.auftraggeber_tel) {
                _this.adresse.tel1 = auftrag.auftraggeber_tel;
            }
            if (auftrag.auftraggeber_email) {
                _this.adresse.email = auftrag.auftraggeber_email;
            }
            if (auftrag.auftraggeber_email2) {
                _this.adresse.email2 = auftrag.auftraggeber_email2;
            }
            if (auftrag.auftraggeber_adressid) {
                _this.adresse.adressid = auftrag.auftraggeber_adressid;
            }
        }
        if (_this.props.adressArt === ApiTypes.AdressArt.Beauftragter) {
            if (auftrag.beauftragter_name1) {
                _this.adresse.name = auftrag.beauftragter_name1;
            }
            if (auftrag.beauftragter_name2) {
                _this.adresse.zusatz = auftrag.beauftragter_name2;
            }
            if (auftrag.beauftragter_strasse) {
                _this.adresse.strasse = auftrag.beauftragter_strasse;
            }
            if (auftrag.beauftragter_plz) {
                _this.adresse.plz = auftrag.beauftragter_plz;
            }
            if (auftrag.beauftragter_ort) {
                _this.adresse.ort = auftrag.beauftragter_ort;
            }
            if (auftrag.beauftragter_tel) {
                _this.adresse.tel1 = auftrag.beauftragter_tel;
            }
            if (auftrag.beauftragter_email) {
                _this.adresse.email = auftrag.beauftragter_email;
            }
            if (auftrag.beauftragter_adressid) {
                _this.adresse.adressid = auftrag.beauftragter_adressid;
            }
            // Eine Änderung der Untersuchungsstellenkennung macht nur im Ort der Kalibrierung Sinn
            if (auftrag.untersuchungsstellenkennung && auftrag.beauftragter_adressid) {
                _this.adresse.untersuchungsstellenkennung = auftrag.untersuchungsstellenkennung;
            }
        }
        return _this;
    }
    AuftragAdresseAendern.prototype.showModal = function () {
        this.modalVisible = true;
    };
    AuftragAdresseAendern.prototype.hideModal = function () {
        this.modalVisible = false;
    };
    AuftragAdresseAendern.prototype.setAdresse = function (adresse) {
        this.adresse = adresse;
    };
    AuftragAdresseAendern.prototype.uebernehmeAdresse = function (adresse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setAdresse(adresse);
                this.hideModal();
                return [2 /*return*/];
            });
        });
    };
    AuftragAdresseAendern.prototype.validate = function () {
        return (this.adresse.name.trim() !== '');
    };
    AuftragAdresseAendern.prototype.handleSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.apiStore.auftragAdresseAendern(this.props.auftrag.anr, this.props.adressArt, this.adresse)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onAuftragNeuladen()];
                    case 2:
                        _a.sent();
                        this.uiStore.navigateTo("/auftrag/" + this.props.auftrag.anr);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuftragAdresseAendern.prototype.handleNameChanged = function (event) {
        this.adresse.name = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleZusatzChanged = function (event) {
        this.adresse.zusatz = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleStrasseChanged = function (event) {
        this.adresse.strasse = event.target.value;
    };
    AuftragAdresseAendern.prototype.handlePlzChanged = function (event) {
        this.adresse.plz = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleOrtChanged = function (event) {
        this.adresse.ort = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleTelefonChanged = function (event) {
        this.adresse.tel1 = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleEMailChanged = function (event) {
        this.adresse.email = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleEMail2Changed = function (event) {
        this.adresse.email2 = event.target.value;
    };
    AuftragAdresseAendern.prototype.handleUstLoeschen = function (event) {
        this.adresse.untersuchungsstellenkennung = '';
        this.adresse.adressid = undefined;
    };
    AuftragAdresseAendern.prototype.render = function () {
        var _this = this;
        var portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleSubmit },
            React.createElement(react_bootstrap_1.Panel, { className: "panel-header-buttoned", header: React.createElement(AuftragAdresseAendernHeader, { caption: this.props.caption, showModal: this.showModal }), footer: React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", disabled: !this.validate() }, "\u00C4nderungen speichern")) },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.validate() ? undefined : 'error', controlId: "Name" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Name"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Name", value: this.adresse.name || '', onChange: this.handleNameChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.validate() ? undefined : 'error', controlId: "Name" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zusatz"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Zusatz", value: this.adresse.zusatz || '', onChange: this.handleZusatzChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Strasse" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Stra\u00DFe"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Strasse", value: this.adresse.strasse || '', onChange: this.handleStrasseChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "PLZ" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "PLZ"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "PLZ", value: this.adresse.plz || '', onChange: this.handlePlzChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Ort" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Ort"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Ort", value: this.adresse.ort || '', onChange: this.handleOrtChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Telefonnummer" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Telefonnummer"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Telefonnummer", placeholder: "Optional", value: this.adresse.tel1 || '', onChange: this.handleTelefonChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Email" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "E-Mail"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Email", placeholder: "Optional", value: this.adresse.email || '', onChange: this.handleEMailChanged }))),
                (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) &&
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: "EmailBuchhaltung" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "E-Mail Buchhaltung"),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "EmailBuchhaltung", placeholder: "Optional", value: this.adresse.email2 || '', onChange: this.handleEMail2Changed }))),
                (this.props.adressArt === ApiTypes.AdressArt.Beauftragter) && this.adresse.untersuchungsstellenkennung &&
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: "zugeordneteust" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zugeordnete USt."),
                        React.createElement(react_bootstrap_1.Col, { sm: 9 },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Untersuchungsstellenkennung", placeholder: "Optional", value: this.adresse.untersuchungsstellenkennung, readOnly: true }),
                                React.createElement(react_bootstrap_1.InputGroup.Button, null,
                                    React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: "btn-group", onClick: this.handleUstLoeschen },
                                        React.createElement(FaIcon_1.default, { icon: "trash" }))))))),
            React.createElement(react_bootstrap_1.Modal, { show: this.modalVisible, onHide: this.hideModal, className: "modal-vertical-centered", backdrop: 'static' },
                React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                    React.createElement(react_bootstrap_1.Modal.Title, null, "Adresse \u00FCbernehmen")),
                React.createElement(react_bootstrap_1.Modal.Body, null,
                    portalAdmin ?
                        React.createElement("div", null, "Adressdaten k\u00F6nnen entweder \u00FCber die Kennung einer \u00DCO oder \u00FCber eine Adress-ID in den Auftrag \u00FCbernommen werden.")
                        :
                            React.createElement("div", null, "Adressdaten k\u00F6nnen aus der Untersuchungsstellenkennung einer \u00DCO \u00FCbernommen werden. Der Auftrag wird dann dieser Untersuchungsstelle zugeordnet."),
                    React.createElement(AuftragAdresseUebernehmen_1.default, { onUebernehme: this.uebernehmeAdresse, adressArt: ApiTypes.AdressArt.Untersuchungsstelle }),
                    portalAdmin && React.createElement(AuftragAdresseUebernehmen_1.default, { onUebernehme: this.uebernehmeAdresse, adressArt: ApiTypes.AdressArt.Auftraggeber })),
                React.createElement(react_bootstrap_1.Modal.Footer, null,
                    React.createElement(react_bootstrap_1.Button, { onClick: this.hideModal, bsStyle: "default" }, "Abbrechen")))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AuftragAdresseAendern.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AuftragAdresseAendern.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AuftragAdresseAendern.prototype, "adresse", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], AuftragAdresseAendern.prototype, "modalVisible", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "showModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "hideModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "setAdresse", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAdresseAendern.prototype, "uebernehmeAdresse", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuftragAdresseAendern.prototype, "handleSubmit", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleNameChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleZusatzChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleStrasseChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handlePlzChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleOrtChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleTelefonChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleEMailChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleEMail2Changed", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AuftragAdresseAendern.prototype, "handleUstLoeschen", null);
    AuftragAdresseAendern = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AuftragAdresseAendern);
    return AuftragAdresseAendern;
}(React.Component));
exports.default = AuftragAdresseAendern;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var LadeFortschritt_1 = __webpack_require__(53);
var react_bootstrap_1 = __webpack_require__(2);
var numberformat_1 = __webpack_require__(56);
var BelegPositionItem = (function (_super) {
    __extends(BelegPositionItem, _super);
    function BelegPositionItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BelegPositionItem.prototype.render = function () {
        var position = this.props.position;
        return (React.createElement("tr", null,
            React.createElement("td", { style: { textAlign: 'left' } }, position.lfdnr),
            React.createElement("td", { style: { textAlign: 'left' } }, position.anzahl),
            React.createElement("td", null,
                position.rechnungstext,
                position.text !== '' && React.createElement("div", null, position.text)),
            React.createElement("td", { style: { textAlign: 'right', whiteSpace: 'nowrap' } },
                numberformat_1.numberformatMoney(position.gesamtpreis),
                " \u20AC")));
    };
    return BelegPositionItem;
}(React.Component));
var BelegDetails = (function (_super) {
    __extends(BelegDetails, _super);
    function BelegDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BelegDetails.prototype.setRechnung = function (rechnung) {
        this.rechnung = rechnung;
    };
    BelegDetails.prototype.ladeRechnung = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.rechnungDetail(this.props.match.params.renr)];
                    case 1:
                        res = _a.sent();
                        if (res.ok) {
                            this.setRechnung(res.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BelegDetails.prototype.componentDidMount = function () {
        this.ladeRechnung();
    };
    BelegDetails.prototype.render = function () {
        var rechnung = this.rechnung;
        if (!rechnung) {
            return React.createElement(LadeFortschritt_1.default, null);
        }
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h2", null,
                rechnung.art,
                " Nr. ",
                rechnung.renr,
                React.createElement(react_bootstrap_1.Badge, { className: "rechnung-badge-" + rechnung.statustext, style: { float: 'right' } }, rechnung.statustext)),
            React.createElement("div", null,
                "Belegdatum: ",
                rechnung.datum,
                " ",
                React.createElement("br", null),
                rechnung.refnr && React.createElement("div", null,
                    "Zu Auftrag: ",
                    rechnung.refnr),
                rechnung.typtext !== '' && React.createElement("div", null, rechnung.typtext)),
            React.createElement("h2", null, "Positionen"),
            React.createElement("div", null,
                React.createElement(react_bootstrap_1.Table, { striped: true, bordered: false, condensed: true, hover: true },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Pos."),
                            React.createElement("th", null, "Anz."),
                            React.createElement("th", null, "Text."),
                            React.createElement("th", null, "Gesamt"))),
                    React.createElement("tbody", null, this.rechnung && this.rechnung.positionen.map(function (position, index) { return React.createElement(BelegPositionItem, { key: index, position: position }); })),
                    React.createElement("tfoot", null,
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 4, style: { textAlign: 'right' } },
                                React.createElement("b", null, "Netto"),
                                ": ",
                                rechnung.netto && numberformat_1.numberformatMoney(rechnung.netto),
                                " \u20AC")),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 4, style: { textAlign: 'right' } },
                                React.createElement("b", null, "Brutto"),
                                ": ",
                                rechnung.brutto && numberformat_1.numberformatMoney(rechnung.brutto),
                                " \u20AC")))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BelegDetails.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BelegDetails.prototype, "rechnung", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BelegDetails.prototype, "setRechnung", null);
    BelegDetails = __decorate([
        mobx_react_1.observer
    ], BelegDetails);
    return BelegDetails;
}(React.Component));
exports.default = BelegDetails;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var PagedList_1 = __webpack_require__(166);
var Pager_1 = __webpack_require__(167);
var FilterBox_1 = __webpack_require__(89);
var react_bootstrap_1 = __webpack_require__(2);
var UiStore_1 = __webpack_require__(14);
var numberformat_1 = __webpack_require__(56);
var FaIcon_1 = __webpack_require__(20);
/** Einzelnes Listenelement mit Kopfinformationen zu Rechnung/Gutschrift */
var BelegListItem = (function (_super) {
    __extends(BelegListItem, _super);
    function BelegListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BelegListItem.prototype.render = function () {
        var _this = this;
        var rechnung = this.props.rechnung;
        return (React.createElement(react_bootstrap_1.ListGroupItem, { header: React.createElement("div", null,
                rechnung.art,
                " Nr. ",
                rechnung.renr,
                React.createElement(react_bootstrap_1.Badge, { className: "rechnung-badge-" + rechnung.statustext, style: { float: 'right' } }, rechnung.statustext)), onClick: function () { return _this.uiStore.navigateTo("/beleg/" + rechnung.renr); } },
            React.createElement("div", null,
                rechnung.datum,
                rechnung.typtext !== '' && React.createElement("span", null,
                    " - Zu ",
                    rechnung.typtext),
                rechnung.refnr && React.createElement("span", null,
                    " - Zu Auftrag ",
                    rechnung.refnr),
                rechnung.netto && React.createElement("span", { className: "pull-right" },
                    numberformat_1.numberformatMoney(rechnung.netto),
                    " \u20AC"))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], BelegListItem.prototype, "uiStore", void 0);
    return BelegListItem;
}(React.Component));
var Belege = (function (_super) {
    __extends(Belege, _super);
    function Belege() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Die Liste beinhaltet nur die Status die im Portal Sinn machen
        _this.rechnungStatusListe = [
            { wert: -999, text: 'Alle Status' },
            { wert: 0, text: 'Nur offen' },
            { wert: 2, text: 'Nur bezahlt' },
            { wert: 1, text: 'Nur teilbezahlt' }
        ];
        // Die Liste beinhaltet nur die Arten die im Portal Sinn machen
        _this.rechnungArtListe = [
            { kuerzel: '', text: 'Alle Arten' },
            { kuerzel: 'R', text: 'Nur Rechnungen' },
            { kuerzel: 'G', text: 'Nur Gutschriften' },
            { kuerzel: 'K', text: 'Nur Korrekturen' }
        ];
        _this.filterRechnungStatus = _this.rechnungStatusListe[0];
        _this.filterRechnungArt = _this.rechnungArtListe[0];
        return _this;
    }
    Belege.prototype.setRechnungen = function (rechnungen) {
        this.rechnungen = rechnungen;
    };
    Belege.prototype.paginate = function (pageNumber) {
        this.setCurrentPage(pageNumber);
        this.ladeRechnungen();
    };
    Belege.prototype.ladeRechnungen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.rechnungsuebersicht(this.currentPage, this.filter, this.filterRechnungStatus.wert >= 0 ? this.filterRechnungStatus.wert : null, this.filterRechnungArt.kuerzel !== '' ? this.filterRechnungArt.kuerzel : null)];
                    case 1:
                        res = _a.sent();
                        if (res.ok) {
                            this.setLastPage(res.json.last_page);
                            this.setTotal(res.json.total);
                            this.setRechnungen(res.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Belege.prototype.componentDidMount = function () {
        this.ladeRechnungen();
    };
    Belege.prototype.handleRechnungStatusChanged = function (event) {
        var status = this.rechnungStatusListe.find(function (e) { return e.wert === parseInt(event.target.value, 10); });
        this.filterRechnungStatus = status ? status : this.rechnungStatusListe[0];
        this.paginate(1);
    };
    Belege.prototype.handleRechnungArtChanged = function (event) {
        var status = this.rechnungArtListe.find(function (e) { return e.kuerzel === event.target.value; });
        this.filterRechnungArt = status ? status : this.rechnungArtListe[0];
        this.paginate(1);
    };
    Belege.prototype.render = function () {
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h2", null, "Beleg\u00FCbersicht"),
            !this.rechnungen ? React.createElement("div", { className: "maxwidth" }, "Lade Belege...") : (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { md: 6 },
                        React.createElement(react_bootstrap_1.InputGroup, { className: "filter-group" },
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                React.createElement(FaIcon_1.default, { icon: "folder-open" })),
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", className: "filter-box", value: this.filterRechnungStatus.wert, onChange: this.handleRechnungStatusChanged },
                                this.rechnungStatusListe.map(function (e) { return (React.createElement("option", { key: e.wert, value: e.wert }, e.text)); }),
                                ";"))),
                    React.createElement(react_bootstrap_1.Col, { md: 6 },
                        React.createElement(react_bootstrap_1.InputGroup, { className: "filter-group" },
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                                React.createElement(FaIcon_1.default, { icon: "folder-open" })),
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", className: "filter-box", value: this.filterRechnungArt.kuerzel, onChange: this.handleRechnungArtChanged },
                                this.rechnungArtListe.map(function (e) { return (React.createElement("option", { key: e.kuerzel, value: e.kuerzel }, e.text)); }),
                                ";")))),
                React.createElement(FilterBox_1.default, { onChange: this.handleFilterList, placeholder: "Suchen (Belegnr., Auftrag)" }),
                React.createElement(react_bootstrap_1.Panel, null,
                    React.createElement(react_bootstrap_1.ListGroup, { fill: true, className: "auftragsliste" },
                        this.rechnungen && this.rechnungen.data.length === 0 && (React.createElement(react_bootstrap_1.ListGroupItem, null, "keine Eintr\u00E4ge")),
                        this.rechnungen && this.rechnungen.data.map(function (rechnung, index) { return React.createElement(BelegListItem, { key: index, rechnung: rechnung }); }))),
                React.createElement(Pager_1.default, { items: this.lastPage, onSelect: this.paginate, activePage: this.currentPage })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Belege.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Belege.prototype, "rechnungen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Belege.prototype, "filterRechnungStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Belege.prototype, "filterRechnungArt", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Belege.prototype, "setRechnungen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], Belege.prototype, "paginate", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Belege.prototype, "handleRechnungStatusChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Belege.prototype, "handleRechnungArtChanged", null);
    Belege = __decorate([
        mobx_react_1.observer
    ], Belege);
    return Belege;
}(PagedList_1.default));
exports.default = Belege;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Anzeigenbereich für Thumbnails aller freigegebenen Bilder zu einem Vorgang
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var ThumbnailItem = (function (_super) {
    __extends(ThumbnailItem, _super);
    function ThumbnailItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbnailItem.prototype.render = function () {
        var _a = this.props, thumbnail = _a.thumbnail, id = _a.id;
        var downloadUrl = this.apiStore.vorgangDokumentDownloadUrl(id, thumbnail.eintrag_guid);
        var previewUrl = this.apiStore.vorgangThumbnailPreviewUrl(id, thumbnail.eintrag_guid);
        return (React.createElement("a", { href: downloadUrl, target: "_blank" },
            React.createElement("img", { src: previewUrl, className: "img-thumbnail foto-thumb" })));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ThumbnailItem.prototype, "apiStore", void 0);
    return ThumbnailItem;
}(React.Component));
exports.ThumbnailItem = ThumbnailItem;
var ThumbnailList = (function (_super) {
    __extends(ThumbnailList, _super);
    function ThumbnailList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbnailList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.refresh();
                return [2 /*return*/];
            });
        });
    };
    ThumbnailList.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.vorgangThumbnails(this.props.id)];
                    case 1:
                        response = _a.sent();
                        if (response && response.ok) {
                            this.setThumbnails(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ThumbnailList.prototype.setThumbnails = function (thumbnails) {
        this.thumbnails = thumbnails;
    };
    ThumbnailList.prototype.stringToDate = function (datumDE) {
        var elemente = datumDE.match(/(\d+)/ig);
        if (elemente) {
            return new Date(parseInt(elemente[2], 10), parseInt(elemente[1], 10) - 1, parseInt(elemente[0], 10), parseInt(elemente[3], 10), parseInt(elemente[4], 10), parseInt(elemente[5], 10));
        }
        else {
            return undefined;
        }
    };
    ThumbnailList.prototype.datumsvergleich = function (a, b) {
        var d1 = this.stringToDate(a.erfasstam);
        var d2 = this.stringToDate(b.erfasstam);
        if (d1 && d2) {
            return d2.getTime() - d1.getTime();
        }
        else {
            return 0;
        }
    };
    ThumbnailList.prototype.render = function () {
        var _a = this.props, id = _a.id, header = _a.header;
        var headlineText = 'Hochgeladene Fotos';
        return (React.createElement("div", null,
            header === 'headline' && React.createElement("h3", null, headlineText),
            React.createElement(react_bootstrap_1.Panel, { header: header === 'panel' && headlineText },
                React.createElement("div", { style: { textAlign: 'center' } }, !this.thumbnails ? (React.createElement("span", null, "Lade Bilder...")) : (this.thumbnails.length === 0) ? (React.createElement("span", null, "Noch keine Bilder hochgeladen")) : this.thumbnails.sort(this.datumsvergleich).map(function (thumbnail, index) { return React.createElement(ThumbnailItem, { key: index, id: id, thumbnail: thumbnail }); })))));
    };
    ThumbnailList.defaultProps = {
        header: 'panel'
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ThumbnailList.prototype, "thumbnails", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ThumbnailList.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThumbnailList.prototype, "setThumbnails", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThumbnailList.prototype, "datumsvergleich", null);
    ThumbnailList = __decorate([
        mobx_react_1.observer
    ], ThumbnailList);
    return ThumbnailList;
}(React.Component));
exports.default = ThumbnailList;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiTypes = __webpack_require__(21);
var ObjektMessmittelUebernehmen_1 = __webpack_require__(111);
var ObjektAnlegen_1 = __webpack_require__(110);
var round_1 = __webpack_require__(33);
/** Formular zum Anlegen eines neuen Druckmessgerätes (Kurz DMG) */
var ObjektAnlegenDMG = (function (_super) {
    __extends(ObjektAnlegenDMG, _super);
    function ObjektAnlegenDMG() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objekt = {
            objektid: '',
            hersteller: '',
            name: '',
            sernr: '',
            typbezeichnung: '',
            typ: 'DMG',
            bemerkung: ''
        };
        _this.objektMeta = {
            anzeige: '',
            messbereichvon: '',
            messbereichbis: '',
            genauigkeitsklasse: '',
            maxfehlergrenze: '',
            skalenteilung: '',
            ablesegenauigkeit: '',
            einbaulage: '',
            bezugsebene: '',
            sernrbps: ''
        };
        return _this;
    }
    ObjektAnlegenDMG.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objektVorlagen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.objektVorlagen('dmg')];
                    case 1:
                        objektVorlagen = _a.sent();
                        if (objektVorlagen.ok) {
                            this.setObjektVorlagen(objektVorlagen.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ObjektAnlegenDMG.prototype.handleObjektAnlegenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var objekt, _i, _a, key;
            return __generator(this, function (_b) {
                event.preventDefault();
                objekt = Object.assign({}, this.objekt);
                objekt.meta = [];
                for (_i = 0, _a = Object.keys(this.objektMeta); _i < _a.length; _i++) {
                    key = _a[_i];
                    objekt.meta.push({ bezeichnung: key, inhalt: this.objektMeta[key] });
                }
                console.log(objekt);
                if (this.props.onAddObjekt) {
                    this.props.onAddObjekt(objekt);
                }
                return [2 /*return*/];
            });
        });
    };
    /** Übernimmt die Daten aus der gewählten Vorlage in das anzulegende Objekt */
    ObjektAnlegenDMG.prototype.uebernehmeObjektEigenschaften = function () {
        var vorlage = this.vorlageZuModell(this.objekt.hersteller, this.objekt.typbezeichnung);
        if (vorlage) {
            this.objekt.art = vorlage.art;
            if (vorlage.arttext) {
                this.objekt.name = vorlage.arttext;
            }
        }
        else {
            this.objekt.art = '';
            this.objekt.name = '';
            // @todo
        }
    };
    /** Übernimmt die Daten aus einem Messmittel der ÜO, soweit diese im ÜO Bereich vorhanden sind */
    ObjektAnlegenDMG.prototype.uebernehmeMessmittelDaten = function (messmittel) {
        this.objekt.objektid = messmittel.pmnummer;
        this.objekt.messmittelkennung = messmittel.pmnummer;
        var vorlageHersteller = this.objektVorlagen.find(function (el) { return el.hersteller.toLocaleLowerCase() === messmittel.hersteller.toLocaleLowerCase(); });
        if (vorlageHersteller) {
            this.objekt.hersteller = vorlageHersteller.hersteller;
        }
        this.objekt.sernr = messmittel.seriennummer;
        // Bei der Übernahme aus einem ÜO Messmittel passt der Modellbezeichner wegen der freien Eingabe u.U. nicht zur Vorlage
        this.objektVorlagenTypen = this.vorlagenZuHersteller(messmittel.hersteller);
        // Zum Messmittel passende Vorlage wählen, wegen freier Eingabemöglichkeit im ÜO Umfeld nicht auf die Schreibweise achten
        var vorlage = this.vorlageZuModell(messmittel.hersteller, messmittel.name);
        if (vorlage) {
            this.objekt.typbezeichnung = vorlage.modell;
            this.uebernehmeObjektEigenschaften();
        }
        // @todo: Nicht vorhandene Vorlage visualisieren
        this.hideModal();
    };
    ObjektAnlegenDMG.prototype.handleEditValueChanged = function (event) {
        var _this = this;
        var value = event.target.value;
        var id = event.target.id;
        if (id in this.objekt) {
            this.objekt[id] = value;
            // Beim Wechsel des Herstellers müssen bereits gewählte abhängige Daten gelöscht werden
            if (id === 'hersteller') {
                this.objekt.typbezeichnung = '';
                this.objekt.art = '';
                // @todo
                // Auswählbare Vorlagen auf die für den Hersteller verfügbaren einschränken
                this.objektVorlagenTypen = [];
                this.objektVorlagenTypen = this.objektVorlagen.filter(function (vorlage) { return vorlage.hersteller === _this.objekt.hersteller; });
            }
            // Beim Wechsel des Typs (aka Modell) die in der Objektvorlage hinterlegten Eigenschaften in das Formular übernehmen
            if (id === 'typbezeichnung') {
                this.uebernehmeObjektEigenschaften();
            }
            // Bei Druckaufnehmern wird keine Genauigkeitsklasse erfasst
            if ((id === 'name') && (['Druckaufnehmer', 'Funk-Druckaufnehmer'].indexOf(value) > -1)) {
                this.objektMeta.genauigkeitsklasse = '-';
                this.objektMeta.maxfehlergrenze = '0.1';
            }
            return;
        }
        if (id in this.objektMeta) {
            this.objektMeta[id] = value;
            if ((id === 'messbereichbis') || (id === 'genauigkeitsklasse')) {
                if (this.objektMeta.genauigkeitsklasse === '-') {
                    // Bei Druckaufnehmern ist keine Genauigkeitsklasse anzugeben, dort wird die Fehlergrenze fest auf 0,1 gesetzt
                    this.objektMeta.maxfehlergrenze = '0.1';
                }
                else {
                    // Beim Setzen des Messbereichs kann die Fehlergrenze berechnet werden
                    if ((!isNaN(parseFloat(this.objektMeta.messbereichvon))) && (!isNaN(parseFloat(this.objektMeta.messbereichbis))) && (!isNaN(parseFloat(this.objektMeta.genauigkeitsklasse)))) {
                        var delta = parseFloat(this.objektMeta.messbereichbis) - parseFloat(this.objektMeta.messbereichvon);
                        var gk = parseFloat(this.objektMeta.genauigkeitsklasse);
                        this.objektMeta.maxfehlergrenze = round_1.round(delta * (gk / 100.0), 3).toString();
                    }
                }
            }
            // Ablesegenauigkeit aus Skalenteilung ermittel
            if ((id === 'skalenteilung') || (id === 'anzeige')) {
                if (this.objektMeta.anzeige.toLowerCase().indexOf('digital') > -1) {
                    this.objektMeta.ablesegenauigkeit = this.objektMeta.skalenteilung;
                }
                else {
                    var floatVal = parseFloat(this.objektMeta.skalenteilung);
                    if (floatVal) {
                        this.objektMeta.ablesegenauigkeit = (floatVal / 5.0).toString();
                    }
                }
            }
        }
    };
    ObjektAnlegenDMG.prototype.validate = function () {
        // Alle Objekteigenschaften außer der Bemerkung und Art (bisher noch nicht vom DIQZ definiert) müssen ausgefüllt sein
        for (var _i = 0, _a = Object.keys(this.objekt); _i < _a.length; _i++) {
            var key = _a[_i];
            if (((key !== 'bemerkung') && (key !== 'art') && (this.objekt[key] === ''))) {
                return false;
            }
        }
        // Alle Metaeigenschaften des Objekts müssen ausgefüllt sein
        for (var _b = 0, _c = Object.keys(this.objektMeta); _b < _c.length; _b++) {
            var key = _c[_b];
            if ((key !== 'sernrbps')) {
                if (this.objektMeta[key] === '') {
                    return false;
                }
            }
        }
        return true;
    };
    ObjektAnlegenDMG.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleObjektAnlegenSubmit },
            React.createElement(react_bootstrap_1.Panel, { className: "panel-header-buttoned", 
                // @todo: Übernahme aus Messmittel der ÜO bei DMG sinnvoll?
                header: React.createElement(ObjektAnlegen_1.ObjektAnlegenHeader, { caption: "Neues Druckmessgerät anlegen", showModal: this.showModal }), footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", disabled: !this.validate(), type: "submit" }, "Anlegen"))) },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.hersteller === '' ? 'error' : undefined, controlId: "hersteller" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Hersteller"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", list: "herstellerListe", value: this.objekt.hersteller, onChange: this.handleEditValueChanged }),
                        React.createElement("datalist", { id: "herstellerListe" }, this.objektVorlagenHersteller.map(function (name) { return React.createElement("option", { key: name, value: name }, name); })))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.typbezeichnung === '' ? 'error' : undefined, controlId: "typbezeichnung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Typ"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", value: this.objekt.typbezeichnung, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.name === '' ? 'error' : undefined, controlId: "name" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Kalibriergegenstand"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objekt.name, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "Manometer" }, "Manometer"),
                            React.createElement("option", { value: "Doppelmanometer" }, "Doppelmanometer"),
                            React.createElement("option", { value: "Bremsdruckprüfgerät" }, "Bremsdruckpr\u00FCfger\u00E4t"),
                            React.createElement("option", { value: "Druckaufnehmer" }, "Druckaufnehmer"),
                            React.createElement("option", { value: "Funk-Druckaufnehmer" }, "Funk-Druckaufnehmer")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.sernr === '' ? 'error' : undefined, controlId: "sernr" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Seriennr."),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Seriennr.", id: "sernr", value: this.objekt.sernr, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objekt.objektid === '' ? 'error' : undefined, controlId: "objektid" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Kennzeichnung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Kennzeichnung", id: "objektid", value: this.objekt.objektid, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.objektMeta.anzeige === '') ? 'error' : undefined, controlId: "anzeige" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Anzeige"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objektMeta.anzeige, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "digital" }, "Digital"),
                            React.createElement("option", { value: "analog" }, "Analog"),
                            React.createElement("option", { value: "strichskala" }, "Strichskala"),
                            React.createElement("option", { value: "digitalbps" }, "Digital, Bremspr\u00FCfstand SN"))),
                    this.objektMeta.anzeige === 'digitalbps' &&
                        React.createElement(react_bootstrap_1.Col, { sm: 4 },
                            React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Sernrbps", id: "sernrbps", placeholder: "Sernr. des BPS", value: this.objektMeta.sernrbps, onChange: this.handleEditValueChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.objektMeta.messbereichvon === '' || this.objektMeta.messbereichbis === '') ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Messbereich"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Von"),
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1", id: "messbereichvon", value: this.objektMeta.messbereichvon, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar"))),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Bis"),
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1", id: "messbereichbis", value: this.objektMeta.messbereichbis, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.objektMeta.genauigkeitsklasse === '') ? 'error' : undefined, controlId: "genauigkeitsklasse" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Genauigkeitsklasse"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objektMeta.genauigkeitsklasse, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "0.1" }, "0,1"),
                            React.createElement("option", { value: "0.25" }, "0,25"),
                            React.createElement("option", { value: "0.6" }, "0,6"),
                            React.createElement("option", { value: "1.0" }, "1,0"),
                            React.createElement("option", { value: "1.6" }, "1,6"),
                            React.createElement("option", { value: "2.5" }, "2,5"),
                            React.createElement("option", { value: "4.0" }, "4,0"),
                            React.createElement("option", { value: "-" }, "Nicht erforderlich")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.objektMeta.maxfehlergrenze === '') ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Max. Fehlergrenze"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", id: "maxfehlergrenze", value: this.objektMeta.maxfehlergrenze, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.objektMeta.skalenteilung === '') ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Skalenteilung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", id: "skalenteilung", value: this.objektMeta.skalenteilung, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.objektMeta.ablesegenauigkeit === '') ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Ablesegenauigkeit"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: true, id: "ablesegenauigkeit", value: this.objektMeta.ablesegenauigkeit, onChange: this.handleEditValueChanged }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.einbaulage === '' ? 'error' : undefined, controlId: "einbaulage" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Einbaulage"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objektMeta.einbaulage, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "0" }, "liegend (0\u00B0)"),
                            React.createElement("option", { value: "90" }, "senkrecht (90\u00B0)"),
                            React.createElement("option", { value: "30" }, "30\u00B0"),
                            React.createElement("option", { value: "45" }, "45\u00B0"),
                            React.createElement("option", { value: "60" }, "60\u00B0"),
                            React.createElement("option", { value: "120" }, "120\u00B0"),
                            React.createElement("option", { value: "135" }, "135\u00B0"),
                            React.createElement("option", { value: "150" }, "150\u00B0"),
                            React.createElement("option", { value: "180" }, "180\u00B0")))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.objektMeta.bezugsebene === '' ? 'error' : undefined, controlId: "bezugsebene" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Bezugsebene"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.objektMeta.bezugsebene, onChange: this.handleEditValueChanged },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            React.createElement("option", { value: "Mitte Druckanschluss" }, "Mitte Druckanschluss"),
                            React.createElement("option", { value: "Zeigerachse" }, "Zeigerachse"),
                            React.createElement("option", { value: "Dichtfläche Druckanschluss" }, "Dichtfl\u00E4che Druckanschluss\u00B0")))),
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "bemerkung" },
                    React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Bemerkung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 9 },
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Bemerkung", id: "bemerkung", value: this.objekt.bemerkung, onChange: this.handleEditValueChanged }))),
                React.createElement(ObjektMessmittelUebernehmen_1.default, { kategorie: "bps", onUebernehme: this.uebernehmeMessmittelDaten, show: this.modalVisible, onHideModal: this.hideModal }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenDMG.prototype, "objekt", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ObjektAnlegenDMG.prototype, "objektMeta", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ObjektAnlegenDMG.prototype, "handleObjektAnlegenSubmit", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenDMG.prototype, "uebernehmeObjektEigenschaften", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenDMG.prototype, "uebernehmeMessmittelDaten", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjektAnlegenDMG.prototype, "handleEditValueChanged", null);
    ObjektAnlegenDMG = __decorate([
        mobx_react_1.observer
    ], ObjektAnlegenDMG);
    return ObjektAnlegenDMG;
}(ObjektAnlegen_1.default));
exports.default = ObjektAnlegenDMG;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var FaIcon_1 = __webpack_require__(20);
var Callout_1 = __webpack_require__(16);
var react_bootstrap_1 = __webpack_require__(2);
/**
 * Komponente für den Zugriff auf öffentlich freigegebene Dokumente zu einem Auftrag
 */
var DokumentePublic = (function (_super) {
    __extends(DokumentePublic, _super);
    function DokumentePublic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refnr = '';
        _this.error = undefined;
        _this.ergebnisAnfrage = undefined;
        _this.email = '';
        return _this;
    }
    DokumentePublic.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var guid, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        guid = this.props.match.params.guid;
                        return [4 /*yield*/, this.apiStore.publicAuftragDokumente(guid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setData(response.json);
                        }
                        else {
                            this.setError('Es konnte kein Auftrag mit der angegebenen Referenznummer gefunden werden!');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DokumentePublic.prototype.handleButtonFolgeAuftragClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var guid, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        guid = this.props.match.params.guid;
                        return [4 /*yield*/, this.apiStore.publicAuftragAnfrageFolgeAuftrag(guid)];
                    case 1:
                        response = _a.sent();
                        this.setErgebnisAnfrage(response.ok);
                        return [2 /*return*/];
                }
            });
        });
    };
    DokumentePublic.prototype.setData = function (response) {
        this.docs = response.dokumente;
        this.refnr = response.refnr;
        this.error = undefined;
    };
    DokumentePublic.prototype.setError = function (error) {
        this.error = error;
    };
    DokumentePublic.prototype.setErgebnisAnfrage = function (ergebnis) {
        this.ergebnisAnfrage = ergebnis;
    };
    DokumentePublic.prototype.render = function () {
        var _this = this;
        var guid = this.props.match.params.guid;
        return (React.createElement("div", { className: "kontakt" }, this.error !== undefined ?
            (React.createElement(Callout_1.default, { bsStyle: "danger" }, this.error))
            :
                this.docs &&
                    (this.docs.length === 0 ?
                        (React.createElement(Callout_1.default, { bsStyle: "default" },
                            React.createElement("p", null, "F\u00FCr diesen Auftrag wurden keine Qualifizierungsdokumente freigegeben."),
                            React.createElement("p", { className: "text-hint-light" },
                                "Referenz: ",
                                guid)))
                        :
                            (React.createElement("div", { className: "maxwidth" },
                                React.createElement("h2", null,
                                    "Freigegebene Dokumente zu Auftrag ",
                                    this.refnr),
                                React.createElement(react_bootstrap_1.Panel, { header: "Verfügbare Dokumente" },
                                    React.createElement(react_bootstrap_1.ListGroup, { fill: true }, this.docs.map(function (doc, index) {
                                        return React.createElement(react_bootstrap_1.ListGroupItem, { key: index, href: _this.apiStore.publicAuftragDokumentDownloadUrl(guid, doc.eintrag_guid), target: "_blank" },
                                            React.createElement(FaIcon_1.default, { icon: "file-pdf-o" }),
                                            doc.titel,
                                            React.createElement("span", { className: "pull-right text-hint-light" }, doc.datum));
                                    }))))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], DokumentePublic.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], DokumentePublic.prototype, "docs", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], DokumentePublic.prototype, "refnr", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DokumentePublic.prototype, "error", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DokumentePublic.prototype, "ergebnisAnfrage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], DokumentePublic.prototype, "email", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], DokumentePublic.prototype, "handleButtonFolgeAuftragClick", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DokumentePublic.prototype, "setData", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DokumentePublic.prototype, "setError", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DokumentePublic.prototype, "setErgebnisAnfrage", null);
    DokumentePublic = __decorate([
        mobx_react_1.observer
    ], DokumentePublic);
    return DokumentePublic;
}(React.Component));
exports.default = DokumentePublic;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var HeadferPublic = (function (_super) {
    __extends(HeadferPublic, _super);
    function HeadferPublic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeadferPublic.prototype.render = function () {
        return (React.createElement("header", { className: "header", role: "banner" },
            React.createElement("div", { className: "border-bottom" },
                React.createElement("div", { className: "container" },
                    React.createElement(react_bootstrap_1.PageHeader, null,
                        React.createElement("a", { href: "https://www.diq-zert.de" },
                            React.createElement(react_bootstrap_1.Image, { src: __webpack_require__(694), className: "header-logo-extern" })))))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], HeadferPublic.prototype, "uiStore", void 0);
    HeadferPublic = __decorate([
        mobx_react_1.observer
    ], HeadferPublic);
    return HeadferPublic;
}(React.Component));
exports.default = HeadferPublic;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Komponente zum Anzeigen einer ansichtsübergreifenden Benachrichtigungsleiste mit Hinweis aus Back-End
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var Benachrichtigung = (function (_super) {
    __extends(Benachrichtigung, _super);
    function Benachrichtigung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Benachrichtigung.prototype.setBenachrichtigung = function (value) {
        this.uiStore.benachrichtigung = value;
    };
    Benachrichtigung.prototype.closeBenachrichtigung = function () {
        this.setBenachrichtigung('');
    };
    Benachrichtigung.prototype.render = function () {
        return (React.createElement("div", null, this.uiStore.isLoggedIn && this.uiStore.benachrichtigung && React.createElement(react_bootstrap_1.Alert, { bsStyle: "warning", onDismiss: this.closeBenachrichtigung, style: { textAlign: 'center' } },
            React.createElement("b", null, "Hinweis:"),
            " ",
            this.uiStore.benachrichtigung)));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], Benachrichtigung.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Benachrichtigung.prototype, "setBenachrichtigung", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Benachrichtigung.prototype, "closeBenachrichtigung", null);
    Benachrichtigung = __decorate([
        mobx_react_1.observer
    ], Benachrichtigung);
    return Benachrichtigung;
}(React.Component));
exports.default = Benachrichtigung;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(52);
var react_bootstrap_1 = __webpack_require__(2);
var BreadCrumbs = (function (_super) {
    __extends(BreadCrumbs, _super);
    function BreadCrumbs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreadCrumbs.prototype.render = function () {
        return (React.createElement("ol", { className: "breadcrumb maxwidth" },
            React.createElement(BreadCrumbItem, { label: "Home", to: "/" }),
            React.createElement(react_router_dom_1.Route, { path: "/login", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Login", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/profile", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Benutzerprofil", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/kontakt", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Kontakt", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/portal", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Portal", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/qm", render: function (props) { return React.createElement(BreadCrumbItem, { label: "QM-Dokumentation", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/arbeitsmittel", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Arbeitsmittel", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftraege", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Aufträge", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftrag/:auftragId", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Auftrag", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftrag/neu", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Neu", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftrag/:auftragId/vorgang/:vorgangId", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Vorgang", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftrag/:auftragId/objekte", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Objekt", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftrag/:auftragId/objekte/anlegen", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Neu", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/auftrag/:auftragId/vorgang/:vorgangId/arbeitsmittel", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Arbeitsmittel", to: props.match.url }); } }),
            React.createElement(react_router_dom_1.Route, { path: "/belege", render: function (props) { return React.createElement(BreadCrumbItem, { label: "Belege", to: props.match.url }); } })));
    };
    return BreadCrumbs;
}(React.Component));
exports.default = BreadCrumbs;
var BreadCrumbItem = (function (_super) {
    __extends(BreadCrumbItem, _super);
    function BreadCrumbItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreadCrumbItem.prototype.render = function () {
        var _a = this.props, label = _a.label, to = _a.to;
        return (React.createElement("li", { className: "breadcrumb-item" },
            React.createElement(react_router_dom_1.Link, { to: to }, label === 'Home' ? React.createElement(react_bootstrap_1.Glyphicon, { glyph: "home" }) : label)));
    };
    return BreadCrumbItem;
}(React.Component));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var Content = (function (_super) {
    __extends(Content, _super);
    function Content() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Content.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Grid, { className: "content" },
            React.createElement(react_bootstrap_1.Row, null,
                React.createElement(react_bootstrap_1.Col, { md: 12, sm: 12, xs: 12, role: "main", className: "main" }, this.props.children))));
    };
    return Content;
}(React.Component));
exports.default = Content;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Formular zum Absenden einer Rückmeldung an die DIQ Zert GmbH
 * Das Absenden der Rückmeldung selbst läuft über das Back-End
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
var FeedbackForm = (function (_super) {
    __extends(FeedbackForm, _super);
    function FeedbackForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nachricht = '';
        _this.betreff = '';
        _this.betreffReadOnly = false;
        _this.submitted = false;
        return _this;
    }
    FeedbackForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var arbeitsmittel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.match.params.arbeitsmittelId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.arbeitsmittelDetail(this.props.match.params.arbeitsmittelId)];
                    case 1:
                        arbeitsmittel = _a.sent();
                        if (arbeitsmittel.ok) {
                            this.setBetreff("R\u00FCckmeldung zu \"" + arbeitsmittel.json.name + "\" (" + arbeitsmittel.json.arbeitsmittelnr + ")");
                            this.setBetreffReadOnly(true);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FeedbackForm.prototype.handleFormSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.apiStore.rueckmeldung(this.betreff, this.nachricht)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setSubmitted(true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FeedbackForm.prototype.setBetreff = function (value) {
        this.betreff = value;
    };
    FeedbackForm.prototype.setBetreffReadOnly = function (value) {
        this.betreffReadOnly = value;
    };
    FeedbackForm.prototype.setSubmitted = function (value) {
        this.submitted = value;
    };
    FeedbackForm.prototype.handlBetreffChanged = function (event) {
        this.betreff = event.target.value;
    };
    FeedbackForm.prototype.handleNachrichtChanged = function (event) {
        this.nachricht = event.target.value;
    };
    FeedbackForm.prototype.validate = function () {
        return (this.nachricht.trim() !== '') && (this.betreff.trim() !== '');
    };
    FeedbackForm.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h2", null, "R\u00FCckmeldung"),
            React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleFormSubmit },
                React.createElement("h4", null, "Betreff"),
                React.createElement(react_bootstrap_1.FormControl, { type: "text", value: this.betreff, onChange: this.handlBetreffChanged, readOnly: this.betreffReadOnly }),
                React.createElement("h4", null, "Ihre Nachricht"),
                React.createElement(react_bootstrap_1.FormControl, { componentClass: "textarea", type: "text", rows: 8, value: this.nachricht, onChange: this.handleNachrichtChanged }),
                React.createElement("div", { className: "text-muted", style: { paddingTop: '15px', fontSize: '10pt', lineHeight: '16px' } },
                    "Mit Klick auf \u00ABAbsenden\u00BB erkl\u00E4ren Sie sich mit der Erhebung, der \u00DCbermittlung der Daten per E-Mail sowie einer elektronischen Verarbeitung und Speicherung einverstanden. (Dieses Einverst\u00E4ndnis ist jederzeit widerrufbar)",
                    React.createElement("br", null),
                    "Bitte beachten Sie auch die ",
                    React.createElement("a", { href: "https://www.diq-zert.de/de/datenschutz", target: "_blank" }, "Datenschutzerkl\u00E4rung"),
                    "."),
                this.submitted ?
                    (React.createElement(Callout_1.default, { bsStyle: "success" },
                        React.createElement("p", null, "Ihre R\u00FCckmeldung wurde erfolgreich an die DIQ Zert GmbH \u00FCbermittelt."),
                        React.createElement("div", { className: "text-right" },
                            React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Zur\u00FCck"))))
                    :
                        (React.createElement("div", { className: "text-right", style: { paddingTop: '15px' } },
                            React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.uiStore.navigateBack(); } }, "Abbrechen"),
                            React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", disabled: !this.validate(), type: "submit" }, "Absenden"))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FeedbackForm.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], FeedbackForm.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FeedbackForm.prototype, "nachricht", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FeedbackForm.prototype, "betreff", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FeedbackForm.prototype, "betreffReadOnly", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FeedbackForm.prototype, "submitted", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FeedbackForm.prototype, "handleFormSubmit", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], FeedbackForm.prototype, "setBetreff", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FeedbackForm.prototype, "setBetreffReadOnly", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FeedbackForm.prototype, "setSubmitted", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FeedbackForm.prototype, "handlBetreffChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FeedbackForm.prototype, "handleNachrichtChanged", null);
    FeedbackForm = __decorate([
        mobx_react_1.observer
    ], FeedbackForm);
    return FeedbackForm;
}(React.Component));
exports.default = FeedbackForm;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var Footer = (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (React.createElement("div", { className: "footer" },
            React.createElement(react_bootstrap_1.Grid, null,
                React.createElement("a", { href: "http://diq-zert.de/de/impressum/" }, "Impressum"),
                "\u00A0|\u00A0",
                React.createElement("a", { href: "http://diq-zert.de/de/agb/" }, "AGB"),
                "\u00A0|\u00A0",
                React.createElement("a", { href: "http://diq-zert.de/de/datenschutz/" }, "Datenschutzerkl\u00E4rung"))));
    };
    return Footer;
}(React.Component));
exports.default = Footer;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var react_router_dom_1 = __webpack_require__(52);
var mobx_react_1 = __webpack_require__(4);
var TopBar_1 = __webpack_require__(619);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var ProgressBar_1 = __webpack_require__(617);
var FaIcon_1 = __webpack_require__(20);
var Header = (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        var _this = this;
        return (React.createElement("header", { className: "header", role: "banner" },
            !this.uiStore.isLoggedIn &&
                React.createElement(react_bootstrap_1.Navbar, { className: "topbar", inverse: true, collapseOnSelect: true, default: true, staticTop: true },
                    React.createElement(react_bootstrap_1.Nav, { pullRight: true },
                        React.createElement(react_bootstrap_1.NavItem, { onClick: function () { return _this.uiStore.navigateTo('/login'); } },
                            React.createElement(FaIcon_1.default, { icon: "sign-in" }),
                            " Login"))),
            React.createElement(ProgressBar_1.default, null),
            React.createElement("div", { className: "border-bottom" },
                React.createElement("div", { className: "container" },
                    React.createElement(react_bootstrap_1.PageHeader, null,
                        React.createElement(react_router_dom_1.Link, { to: "/auftraege" },
                            React.createElement(react_bootstrap_1.Image, { src: __webpack_require__(693), className: "header-logo" }))))),
            this.uiStore.isLoggedIn && React.createElement(TopBar_1.default, null)));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], Header.prototype, "uiStore", void 0);
    Header = __decorate([
        mobx_react_1.observer
    ], Header);
    return Header;
}(React.Component));
exports.default = Header;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var Kontakt = (function (_super) {
    __extends(Kontakt, _super);
    function Kontakt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Kontakt.prototype.render = function () {
        return (React.createElement("div", { className: "kontakt maxwidth" },
            React.createElement("h2", null, "Kontakt"),
            React.createElement("p", null, "Bei technischen Fragen oder Problemen erreichen Sie uns wie folgt:"),
            React.createElement("ul", { className: "list-unstyled" },
                React.createElement("li", null,
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "earphone" }),
                    " 0681 9987-777"),
                React.createElement("li", null,
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "envelope" }),
                    " ",
                    React.createElement("a", { href: "mailto:laborportal@diq-zert.de" }, "laborportal@diq-zert.de")))));
    };
    return Kontakt;
}(React.Component));
exports.default = Kontakt;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var Portalinfos = (function (_super) {
    __extends(Portalinfos, _super);
    function Portalinfos() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.versionsinfo = [];
        return _this;
    }
    Portalinfos.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var versionsinfo, feVersionInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.versionsinfo()];
                    case 1:
                        versionsinfo = _a.sent();
                        if (versionsinfo.ok) {
                            this.setVersionsinfo(versionsinfo.json);
                        }
                        return [4 /*yield*/, this.apiStore.feVersionsInfo()];
                    case 2:
                        feVersionInfo = _a.sent();
                        if (feVersionInfo.ok) {
                            this.setFeVersionTag(feVersionInfo.json.tag);
                            if (feVersionInfo.json.tag === '' || feVersionInfo.json.tag === '-') {
                                this.setFeBranch(feVersionInfo.json.branch, feVersionInfo.json.hash, feVersionInfo.json.date);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Portalinfos.prototype.setVersionsinfo = function (versionsinfo) {
        this.versionsinfo = versionsinfo;
    };
    Portalinfos.prototype.setFeVersionTag = function (versionTag) {
        this.versionsinfo.push({
            Komponente: 'Oberfläche',
            Version: versionTag
        });
    };
    // Auf nicht getaggten Versionen (Preproduction/Entwicklung) Infos zum Branch anzeigen
    Portalinfos.prototype.setFeBranch = function (branch, hash, date) {
        this.versionsinfo.push({
            Komponente: 'Branch',
            Version: branch
        });
        this.versionsinfo.push({
            Komponente: 'Hash',
            Version: hash
        });
        this.versionsinfo.push({
            Komponente: 'Datum',
            Version: date ? date : '-'
        });
    };
    Portalinfos.prototype.render = function () {
        if (!this.versionsinfo || this.versionsinfo.length === 0) {
            return React.createElement("div", { className: "maxwidth" }, "lade Versionsinformationen...");
        }
        return (React.createElement("div", { className: "portalinfo maxwidth" },
            React.createElement("h2", null, "Aktuelle Versionen"),
            this.versionsinfo.map(function (eintrag, index) {
                return React.createElement("div", { key: index },
                    React.createElement("b", null,
                        eintrag.Komponente,
                        ":"),
                    " ",
                    eintrag.Version);
            })));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Portalinfos.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Portalinfos.prototype, "versionsinfo", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Portalinfos.prototype, "setVersionsinfo", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Portalinfos.prototype, "setFeVersionTag", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, Object]),
        __metadata("design:returntype", void 0)
    ], Portalinfos.prototype, "setFeBranch", null);
    Portalinfos = __decorate([
        mobx_react_1.observer
    ], Portalinfos);
    return Portalinfos;
}(React.Component));
exports.default = Portalinfos;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var ProgressBar = (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.firstRender = true;
        return _this;
    }
    ProgressBar.prototype.render = function () {
        return React.createElement(LoadingIndicator, { show: this.apiStore.isLoading, width: 3, background: "#008ac1" });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ProgressBar.prototype, "apiStore", void 0);
    ProgressBar = __decorate([
        mobx_react_1.observer
    ], ProgressBar);
    return ProgressBar;
}(React.Component));
exports.default = ProgressBar;
var LoadingIndicator = (function (_super) {
    __extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingState = 'end';
        return _this;
    }
    LoadingIndicator.prototype.setLoadingState = function (state) {
        this.loadingState = state;
    };
    LoadingIndicator.prototype.componentWillReceiveProps = function (props) {
        if (this.props.show === props.show) {
            return;
        }
        var newLoadintState = (props.show) ? 'show' : 'hide';
        this.setLoadingState(newLoadintState);
    };
    LoadingIndicator.prototype.handleTransitionEnd = function () {
        this.setLoadingState('end');
    };
    LoadingIndicator.prototype.render = function () {
        var _a = this.props, show = _a.show, width = _a.width, background = _a.background, zIndex = _a.zIndex, children = _a.children, props = __rest(_a, ["show", "width", "background", "zIndex", "children"]);
        var style = {
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            margin: '',
            zIndex: this.props.zIndex,
            height: this.props.width + "px",
            background: this.props.background,
            boxShadow: this.props.background + ' 0px 0px 10px'
        };
        switch (this.loadingState) {
            case 'show':
                style.width = '70%';
                style.transition = 'width 10s cubic-bezier(0, 1, 0.3, 1)';
                break;
            case 'hide':
                style.width = '100%';
                style.transition = 'width 400ms ease';
                break;
            case 'end':
                style.width = '0';
                style.transition = 'width 0ms';
                break;
            default:
                break;
        }
        return (React.createElement("div", __assign({}, props, { style: style, onTransitionEnd: this.handleTransitionEnd })));
    };
    LoadingIndicator.defaultProps = {
        show: false,
        width: 2,
        background: '#77b6ff',
        zIndex: 1200
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], LoadingIndicator.prototype, "loadingState", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], LoadingIndicator.prototype, "setLoadingState", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LoadingIndicator.prototype, "handleTransitionEnd", null);
    LoadingIndicator = __decorate([
        mobx_react_1.observer
    ], LoadingIndicator);
    return LoadingIndicator;
}(React.Component));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var ToastStore_1 = __webpack_require__(286);
var Toast = (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.detailsShown = false;
        return _this;
    }
    Toast.prototype.componentDidMount = function () {
        var _a = this.props, toast = _a.toast, onDismiss = _a.onDismiss;
        setTimeout(function () { return onDismiss(toast); }, 5000);
    };
    Toast.prototype.handleDetailsShown = function () {
        this.detailsShown = true;
    };
    Toast.prototype.handleDismiss = function (event) {
        event.preventDefault();
        var _a = this.props, toast = _a.toast, onDismiss = _a.onDismiss;
        if (onDismiss) {
            onDismiss(toast);
        }
    };
    Toast.prototype.render = function () {
        var _a = this.props.toast, kind = _a.kind, message = _a.message, details = _a.details;
        var icon = undefined;
        switch (kind) {
            case 'success':
                icon = React.createElement(react_bootstrap_1.Glyphicon, { glyph: "ok" });
                break;
            case 'error':
                icon = React.createElement(react_bootstrap_1.Glyphicon, { glyph: "exclamation-sign" });
                message = 'Ein Fehler ist aufgetreten.';
                break;
            case 'info':
                icon = React.createElement(react_bootstrap_1.Glyphicon, { glyph: "info-sign" });
                break;
            case 'warning':
                icon = React.createElement(react_bootstrap_1.Glyphicon, { glyph: "warning-sign" });
                break;
            default:
                throw new Error('Unknown Notification kind');
        }
        var detailLink = undefined;
        if (details) {
            detailLink = (React.createElement("a", { className: "toast-more-btn", onClick: this.handleDetailsShown },
                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "triangle-bottom" })));
        }
        else {
            this.handleDetailsShown();
        }
        return (React.createElement("div", { className: "toast toast-" + kind },
            icon && React.createElement("div", { className: "toast-icon" }, icon),
            React.createElement("div", { className: "toast-message" },
                message,
                this.detailsShown && React.createElement("div", null, details)),
            React.createElement("div", { className: "toast-buttons" },
                React.createElement("a", { className: "toast-btn", onClick: this.handleDismiss },
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "remove" })),
                !this.detailsShown && (React.createElement("a", { className: "toast-btn", onClick: this.handleDetailsShown },
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "triangle-bottom" }))))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Toast.prototype, "detailsShown", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Toast.prototype, "handleDetailsShown", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Toast.prototype, "handleDismiss", null);
    Toast = __decorate([
        mobx_react_1.observer
    ], Toast);
    return Toast;
}(React.Component));
var ToastContainer = (function (_super) {
    __extends(ToastContainer, _super);
    function ToastContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastContainer.prototype.handleAlertDismiss = function (toast) {
        this.toastStore.hide(toast);
    };
    ToastContainer.prototype.render = function () {
        var _this = this;
        if (this.toastStore.notifications.length > 0) {
            return (React.createElement("div", { className: "toast-container" }, this.toastStore.notifications.map(function (toast, index) {
                return React.createElement(Toast, { key: index, toast: toast, onDismiss: _this.handleAlertDismiss });
            })));
        }
        return null;
    };
    __decorate([
        decorators_1.inject(ToastStore_1.ToastStore),
        __metadata("design:type", ToastStore_1.ToastStore)
    ], ToastContainer.prototype, "toastStore", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ToastContainer.prototype, "handleAlertDismiss", null);
    ToastContainer = __decorate([
        mobx_react_1.observer
    ], ToastContainer);
    return ToastContainer;
}(React.Component));
exports.default = ToastContainer;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var ApiStore_1 = __webpack_require__(13);
var FaIcon_1 = __webpack_require__(20);
var UserDisplayName_1 = __webpack_require__(625);
var NavDivider = (function (_super) {
    __extends(NavDivider, _super);
    function NavDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavDivider.prototype.render = function () {
        return React.createElement("li", { className: "divider-vertical" });
    };
    return NavDivider;
}(React.Component));
var TopBar = (function (_super) {
    __extends(TopBar, _super);
    function TopBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userDisplayName = '';
        return _this;
    }
    TopBar.prototype.handleLogoutClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uiStore.logout()];
                    case 1:
                        _a.sent();
                        this.uiStore.navigateTo('/login');
                        return [2 /*return*/];
                }
            });
        });
    };
    TopBar.prototype.render = function () {
        var _this = this;
        return (this.uiStore.isLoggedIn ? (React.createElement(react_bootstrap_1.Navbar, { className: "navbar", inverse: true, collapseOnSelect: true, default: true, staticTop: true },
            React.createElement(react_bootstrap_1.Navbar.Toggle, null),
            React.createElement(react_bootstrap_1.Navbar.Collapse, null,
                React.createElement(react_bootstrap_1.Nav, { style: { marginLeft: '-10px' } },
                    React.createElement(NavDivider, null),
                    React.createElement(react_bootstrap_1.NavItem, { eventKey: 1, className: "nav-auftraege", onClick: function () { return _this.uiStore.navigateTo('/auftraege'); } },
                        React.createElement(react_bootstrap_1.Glyphicon, { glyph: "list", style: { color: '#008ac1' } }),
                        " Auftr\u00E4ge"),
                    React.createElement(NavDivider, null),
                    this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                        React.createElement(react_bootstrap_1.NavItem, { eventKey: 2, className: "nav-auftraege", onClick: function () { return _this.uiStore.navigateTo('/auftraege/lizenz'); } },
                            React.createElement(FaIcon_1.default, { icon: "folder-open" }),
                            " Auftr\u00E4ge (Lizenz)"),
                    this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
                        React.createElement(NavDivider, null),
                    React.createElement(react_bootstrap_1.NavItem, { eventKey: 3, className: "nav-auftraege", onClick: function () { return _this.uiStore.navigateTo("/auftrag/neu"); } },
                        React.createElement(react_bootstrap_1.Glyphicon, { glyph: "plus", style: { color: '#5cb85c' } }),
                        " Neuer Auftrag"),
                    React.createElement(NavDivider, null)),
                React.createElement(react_bootstrap_1.Nav, { pullRight: true },
                    React.createElement(react_bootstrap_1.NavDropdown
                    // tslint:disable-next-line:no-any
                    , { 
                        // tslint:disable-next-line:no-any
                        title: React.createElement(UserDisplayName_1.default, null), id: "usermenu" },
                        React.createElement(react_bootstrap_1.MenuItem, { onClick: function () { return _this.uiStore.navigateTo('/profile'); } },
                            React.createElement(FaIcon_1.default, { icon: "gear" }),
                            " Meine Daten"),
                        React.createElement(react_bootstrap_1.MenuItem, { divider: true }),
                        React.createElement(react_bootstrap_1.MenuItem, { onClick: function () { return _this.uiStore.navigateTo('/arbeitsmittel'); } },
                            React.createElement(FaIcon_1.default, { icon: "briefcase" }),
                            " Meine Arbeitsmittel"),
                        React.createElement(react_bootstrap_1.MenuItem, { divider: true }),
                        React.createElement(react_bootstrap_1.MenuItem, { onClick: function () { return _this.uiStore.navigateTo('/qm'); } },
                            React.createElement(FaIcon_1.default, { icon: "file-text-o" }),
                            " QM-Dokumentation"),
                        React.createElement(react_bootstrap_1.MenuItem, { divider: true }),
                        React.createElement(react_bootstrap_1.MenuItem, { onClick: function () { return _this.uiStore.navigateTo('/kontakt'); } },
                            React.createElement(FaIcon_1.default, { icon: "phone" }),
                            " Kontakt"),
                        React.createElement(react_bootstrap_1.MenuItem, { divider: true }),
                        React.createElement(react_bootstrap_1.MenuItem, { onClick: function () { return _this.uiStore.navigateTo('/portal'); } },
                            React.createElement(FaIcon_1.default, { icon: "info" }),
                            " \u00DCber das Portal"),
                        React.createElement(react_bootstrap_1.MenuItem, { divider: true }),
                        React.createElement(react_bootstrap_1.MenuItem, { onClick: this.handleLogoutClick },
                            React.createElement(FaIcon_1.default, { icon: "sign-out" }),
                            " Logout")))))) : React.createElement("div", null));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], TopBar.prototype, "userDisplayName", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], TopBar.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], TopBar.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TopBar.prototype, "handleLogoutClick", null);
    TopBar = __decorate([
        mobx_react_1.observer
    ], TopBar);
    return TopBar;
}(React.Component));
exports.default = TopBar;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Befugnis = function (props) {
    var status;
    if (props.befugnis.gueltig) {
        status = React.createElement("span", { className: "text-success" }, (props.befugnis.ablaufdatum) ? "g\u00FCltig bis " + props.befugnis.ablaufdatum : 'unbefristet');
    }
    else {
        status = React.createElement("span", { className: "text-danger" }, "abgelaufen seit " + props.befugnis.ablaufdatum);
    }
    return (React.createElement("div", null,
        props.befugnis.kuerzel,
        " - ",
        status));
};
exports.default = Befugnis;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_router_dom_1 = __webpack_require__(52);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var ApiStore_1 = __webpack_require__(13);
var Login = (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loginUser = '';
        _this.loginPass = '';
        _this.loginError = false;
        _this.loginSuccess = false;
        _this.loginErrorText = '';
        return _this;
    }
    Login.prototype.setLoginSuccess = function () {
        this.loginSuccess = true;
    };
    Login.prototype.setLoginError = function (loginErrorText) {
        this.loginError = true;
        this.loginPass = '';
        this.loginErrorText = loginErrorText;
    };
    Login.prototype.handleLoginRequest = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var loginResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.uiStore.login(this.loginUser, this.loginPass)];
                    case 1:
                        loginResponse = _a.sent();
                        if (loginResponse.ok) {
                            this.setLoginSuccess();
                        }
                        else {
                            this.setLoginError(loginResponse.error);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Login.prototype.handleUserNameChanged = function (event) {
        this.loginUser = event.target.value;
    };
    Login.prototype.handlePasswordChanged = function (event) {
        this.loginPass = event.target.value;
    };
    Login.prototype.render = function () {
        var validationState = (this.loginError) ? 'error' : undefined;
        if (this.loginSuccess) {
            var from = { pathname: '/auftraege' };
            if (this.uiStore.currentLocation.state && this.uiStore.currentLocation.state.from) {
                from = this.uiStore.currentLocation.state.from;
            }
            return React.createElement(react_router_dom_1.Redirect, { to: from });
        }
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleLoginRequest, className: "login" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState },
                    React.createElement("h2", null, "Login"),
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                            React.createElement(react_bootstrap_1.Glyphicon, { glyph: "user" })),
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", placeholder: "Benutzername", name: "loginUser", value: this.loginUser, onChange: this.handleUserNameChanged }))),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: validationState },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                            React.createElement(react_bootstrap_1.Glyphicon, { glyph: "lock" })),
                        React.createElement(react_bootstrap_1.FormControl, { type: "password", placeholder: "Kennwort", name: "loginPass", value: this.loginPass, onChange: this.handlePasswordChanged })),
                    this.loginError && React.createElement(react_bootstrap_1.HelpBlock, { className: "login-helpblock" }, this.loginErrorText),
                    (this.apiStore.sessionMessage !== '') &&
                        React.createElement(react_bootstrap_1.HelpBlock, { className: "login-helpblock" }, this.apiStore.sessionMessage)),
                React.createElement(react_bootstrap_1.FormGroup, null,
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", type: "submit", block: true }, "Anmelden")))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], Login.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Login.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Login.prototype, "loginUser", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Login.prototype, "loginPass", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Login.prototype, "loginError", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Login.prototype, "loginSuccess", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Login.prototype, "loginErrorText", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Login.prototype, "setLoginSuccess", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Login.prototype, "setLoginError", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], Login.prototype, "handleLoginRequest", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Login.prototype, "handleUserNameChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Login.prototype, "handlePasswordChanged", null);
    Login = __decorate([
        mobx_react_1.observer
    ], Login);
    return Login;
}(React.Component));
exports.default = Login;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var UiStore_1 = __webpack_require__(14);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var Befugnis_1 = __webpack_require__(620);
var Callout_1 = __webpack_require__(16);
var Profile = (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Profile.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var befugnisse, dienstleistungen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.uiStore.loadFreigaben();
                        return [4 /*yield*/, this.apiStore.befugnisse()];
                    case 1:
                        befugnisse = _a.sent();
                        if (befugnisse.ok) {
                            this.setBefugnisse(befugnisse.json);
                        }
                        return [4 /*yield*/, this.apiStore.dienstleistungen('')];
                    case 2:
                        dienstleistungen = _a.sent();
                        if (dienstleistungen.ok) {
                            this.setDienstleistungen(dienstleistungen.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Profile.prototype.setDienstleistungen = function (dienstleistungen) {
        this.dienstleistungen = dienstleistungen.sort(function (a, b) { return (a.kuerzel_dienstleistung.localeCompare(b.kuerzel_dienstleistung)); });
    };
    Profile.prototype.setBefugnisse = function (befugnisse) {
        this.befugnisse = befugnisse.sort(function (a, b) { return a.kuerzel.localeCompare(b.kuerzel); });
    };
    Profile.prototype.render = function () {
        // Gefilterte Liste mit zum aktuellen Zeitpunkt gültigen Dienstleistungen erstellen
        var dienstleistungenAktiv = undefined;
        if (this.dienstleistungen) {
            dienstleistungenAktiv = this.dienstleistungen.filter(function (dienstleistung) { return dienstleistung.gueltig === true; });
            var dldis_1 = [];
            dienstleistungenAktiv.forEach(function (dienstleistung) {
                if (dldis_1.indexOf(dienstleistung.kuerzel_dienstleistung) === -1) {
                    dldis_1.push(dienstleistung.kuerzel_dienstleistung);
                }
            });
            dienstleistungenAktiv = dldis_1;
        }
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement("h2", null, "Profil"),
            !this.uiStore.userProfile ? React.createElement("div", { className: "maxwidth" }, "lade Benutzerprofil...") : (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { md: 3, xs: 3 }, "Name"),
                    React.createElement(react_bootstrap_1.Col, { md: 9, xs: 9 },
                        this.uiStore.userProfile.anrede,
                        " ",
                        this.uiStore.userProfile.vorname,
                        " ",
                        this.uiStore.userProfile.nachname)),
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { md: 3, xs: 3 }, "Benutzername"),
                    React.createElement(react_bootstrap_1.Col, { md: 9, xs: 9 }, this.uiStore.userProfile.username)),
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { md: 3, xs: 3 }, "E-Mail"),
                    React.createElement(react_bootstrap_1.Col, { md: 9, xs: 9 }, this.uiStore.userProfile.email)),
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { md: 3, xs: 3 }, "Kennung"),
                    React.createElement(react_bootstrap_1.Col, { md: 9, xs: 9 }, this.uiStore.userProfile.pinummer)))),
            this.uiStore.userProfile && this.uiStore.userProfile.portaladmin ? (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "glyphicon glyphicon-user" }),
                " ",
                React.createElement("b", null, "Portaladministrator"))) : (null),
            React.createElement("h2", null, "Auftraggeber"),
            !this.uiStore.freigaben ? React.createElement("div", null, "lade Auftraggeber...") : this.uiStore.freigaben.map(function (freigabe, index) { return (React.createElement("div", { key: index },
                freigabe.name,
                " (",
                freigabe.lizenznehmer,
                ")")); }),
            React.createElement("h2", null, "Befugnisse"),
            !this.befugnisse ? React.createElement("div", null, "lade Befugnisse...") : this.befugnisse.map(function (befugnis, index) { return (React.createElement(Befugnis_1.default, { key: index, befugnis: befugnis })); }),
            React.createElement("h2", null, "Dienstleistungen"),
            dienstleistungenAktiv ?
                React.createElement("div", null,
                    dienstleistungenAktiv.sort().map(function (dienstleistung, index) { return (React.createElement("div", { key: index }, dienstleistung)); }),
                    dienstleistungenAktiv.length === 0 && (React.createElement(Callout_1.default, { bsStyle: "warning" },
                        React.createElement("p", null,
                            "Sie k\u00F6nnen aktuell keine Dienstleistungen anlegen, ggf. sind Ihre Befugnisse abgelaufen.",
                            React.createElement("br", null),
                            "Bitte wenden Sie sich bei R\u00FCckfragen an den ",
                            React.createElement("a", { href: "/kontakt" }, "Support"),
                            " der DIQ Zert GmbH."))))
                :
                    React.createElement("div", null, "lade Daten")));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], Profile.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Profile.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Profile.prototype, "befugnisse", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Profile.prototype, "dienstleistungen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Profile.prototype, "setDienstleistungen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Profile.prototype, "setBefugnisse", null);
    Profile = __decorate([
        mobx_react_1.observer
    ], Profile);
    return Profile;
}(React.Component));
exports.default = Profile;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var QmListe_1 = __webpack_require__(624);
var QmDokumentation = (function (_super) {
    __extends(QmDokumentation, _super);
    function QmDokumentation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QmDokumentation.prototype.setQmDoku = function (qmDoku) {
        this.qmDoku = qmDoku;
    };
    QmDokumentation.prototype.clearAuftraege = function () {
        this.qmDoku = undefined;
    };
    QmDokumentation.prototype.componentDidMount = function () {
        this.ladeQmDokumentation();
    };
    QmDokumentation.prototype.ladeQmDokumentation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var qmDoku;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.qmdokumentation()];
                    case 1:
                        qmDoku = _a.sent();
                        if (qmDoku.ok) {
                            this.setQmDoku(qmDoku.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    QmDokumentation.prototype.handleDokumentClick = function (befugnis, dateiname) {
        return __awaiter(this, void 0, void 0, function () {
            var downloadLink;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.qmDokumentDownloadUrl(befugnis, dateiname)];
                    case 1:
                        downloadLink = _a.sent();
                        window.open(downloadLink);
                        return [2 /*return*/];
                }
            });
        });
    };
    QmDokumentation.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "qm-dokumentation maxwidth" },
            React.createElement("h2", null, "Freigegebene QM-Dokumente"),
            !this.qmDoku ? React.createElement("div", null, "lade QM-Dokumentation...") : (React.createElement("div", null, (this.qmDoku.length === 0) ?
                React.createElement("div", null, "Es wurden noch keine QM-Dokumente freigegeben") :
                this.qmDoku.map(function (element, index) {
                    return React.createElement(QmListe_1.QmListe, { key: index, expanded: true, befugnis: element.befugnis, dokumente: element.dokumente, handleEintragClick: _this.handleDokumentClick });
                })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], QmDokumentation.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], QmDokumentation.prototype, "qmDoku", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], QmDokumentation.prototype, "setQmDoku", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], QmDokumentation.prototype, "clearAuftraege", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], QmDokumentation.prototype, "handleDokumentClick", null);
    QmDokumentation = __decorate([
        mobx_react_1.observer
    ], QmDokumentation);
    return QmDokumentation;
}(React.Component));
exports.default = QmDokumentation;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var QmListe = (function (_super) {
    __extends(QmListe, _super);
    function QmListe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QmListe.prototype.handleDokumentClick = function (dokument) {
        this.props.handleEintragClick(this.props.befugnis, dokument.dateiname);
    };
    QmListe.prototype.render = function () {
        var _this = this;
        if (this.props.dokumente.length === 0) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("h3", null, this.props.befugnis),
            this.props.dokumente.map(function (dokument, index) { return React.createElement(QmDokuListItem, { key: index, qmDokument: dokument, handleDokumentClick: _this.handleDokumentClick }); })));
    };
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], QmListe.prototype, "handleDokumentClick", null);
    return QmListe;
}(React.Component));
exports.QmListe = QmListe;
var QmDokuListItem = (function (_super) {
    __extends(QmDokuListItem, _super);
    function QmDokuListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QmDokuListItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.ListGroupItem, { className: 'qm-listeneintrag', onClick: function () { return _this.props.handleDokumentClick(_this.props.qmDokument); } },
            React.createElement("span", { className: "text-primary" }, this.props.qmDokument.titel)));
    };
    return QmDokuListItem;
}(React.Component));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var UserDisplayName = (function (_super) {
    __extends(UserDisplayName, _super);
    function UserDisplayName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserDisplayName.prototype.componentDidMount = function () {
        if (!this.uiStore.userProfile) {
            this.uiStore.loadUserProfile();
        }
    };
    UserDisplayName.prototype.render = function () {
        return (React.createElement("span", null, this.uiStore.userDisplayName));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], UserDisplayName.prototype, "uiStore", void 0);
    UserDisplayName = __decorate([
        mobx_react_1.observer
    ], UserDisplayName);
    return UserDisplayName;
}(React.Component));
exports.default = UserDisplayName;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_router_dom_1 = __webpack_require__(52);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var VorgangStore_1 = __webpack_require__(22);
var VorgangDetails_1 = __webpack_require__(627);
var PrivateRoute_1 = __webpack_require__(168);
var ArbeitsmittelAuswahl_1 = __webpack_require__(262);
var ObjektAuswahl_1 = __webpack_require__(271);
var ObjektAnlegenSEP_1 = __webpack_require__(270);
var react_bootstrap_1 = __webpack_require__(2);
var AuftragStore_1 = __webpack_require__(25);
var ObjektAnlegenAGT_1 = __webpack_require__(268);
var ObjektAnlegenBPS_1 = __webpack_require__(269);
var ObjektAnlegenDMG_1 = __webpack_require__(606);
var VorgangDetailRouter = (function (_super) {
    __extends(VorgangDetailRouter, _super);
    function VorgangDetailRouter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.vorlageAbgefragt = false;
        return _this;
    }
    VorgangDetailRouter.prototype.componentDidMount = function () {
        this.refreshVorgang();
    };
    VorgangDetailRouter.prototype.vorlageAbgefragtHandler = function (abgefragt) {
        this.vorlageAbgefragt = abgefragt;
    };
    VorgangDetailRouter.prototype.refreshVorgang = function () {
        this.vorgangStore.loadVorgang(this.props.match.params.vorgangId, this.vorlageAbgefragtHandler);
    };
    VorgangDetailRouter.prototype.componentWillReceiveProps = function (nextProps) {
        this.vorgangStore.loadVorgang(nextProps.match.params.vorgangId, this.vorlageAbgefragtHandler);
    };
    VorgangDetailRouter.prototype.handleArbeitsmittelSetAuswahl = function (ort) {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.match.params.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangOrtSetzen(vorgangId, ort.ortguid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.success) {
                            this.uiStore.navigateTo(this.props.match.url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangDetailRouter.prototype.handleObjektAuswahl = function (objekt) {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.match.params.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangObjektSetzen(vorgangId, objekt.objektguid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.success) {
                            this.uiStore.navigateTo(this.props.match.url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangDetailRouter.prototype.handleAddObjekt = function (objekt) {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.match.params.vorgangId;
                        return [4 /*yield*/, this.apiStore.objektAnlegen(objekt, undefined, vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && response.json.success) {
                            this.refreshVorgang();
                            this.uiStore.navigateTo(this.props.match.url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangDetailRouter.prototype.handleObjektAuswahlAufheben = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, i, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.match.params.vorgangId;
                        if (!((this.vorgangStore.vorgang) && (this.vorgangStore.vorgang.objekte))) return [3 /*break*/, 5];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.vorgangStore.vorgang.objekte.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiStore.vorgangObjektEntfernen(vorgangId, this.vorgangStore.vorgang.objekte[i].objektguid)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            return [3 /*break*/, 4];
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.refreshVorgang();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VorgangDetailRouter.prototype.handleKorrekturvorgangAnlegen = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.vorgangKorrigieren(vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok && this.vorgangStore.vorgang) {
                            this.uiStore.navigateTo("/auftrag/" + this.vorgangStore.vorgang.anr + "/vorgang/" + response.json.success);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangDetailRouter.prototype.render = function () {
        var _this = this;
        var url = this.props.match.url;
        var _a = this.vorgangStore, vorgang = _a.vorgang, vorlage = _a.vorlage, objekte = _a.objekte;
        return (React.createElement("div", { className: "vorgang-details" }, !(vorgang && this.vorlageAbgefragt && objekte) ? React.createElement("div", { className: "maxwidth" }, "lade Dienstleistung...") : (React.createElement("div", null,
            React.createElement("h3", null,
                "Dienstleistung ",
                vorlage ? vorlage.dienstleistung : vorgang.kuerzel_dienstleistung),
            React.createElement("h3", null,
                "Vorgang Nr. ",
                vorgang.sortierung,
                ": ",
                vorgang.name,
                vorgang.korrekturvorgang && (React.createElement("span", null,
                    " (",
                    React.createElement(react_bootstrap_1.Glyphicon, { glyph: "pencil" }),
                    " Korrektur) "))),
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(PrivateRoute_1.default, { path: url + "/arbeitsmittel", render: function () { return (React.createElement(ArbeitsmittelAuswahl_1.default, { title: 'Auswahl des Arbeitsmittel-Sets', kategorie: vorgang.arbeitsmitteltyp, onArbeitsmittelSetAuswahl: _this.handleArbeitsmittelSetAuswahl })); } }),
                React.createElement(PrivateRoute_1.default, { path: url + "/objekte", exact: true, render: function () { return (React.createElement(ObjektAuswahl_1.default, { kategorie: vorgang.objekttyp, onObjektAuswahl: _this.handleObjektAuswahl })); } }),
                React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/ses", exact: true, render: function () { return (React.createElement(ObjektAnlegenSEP_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/agt", exact: true, render: function () { return (React.createElement(ObjektAnlegenAGT_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/bps", exact: true, render: function () { return (React.createElement(ObjektAnlegenBPS_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                React.createElement(PrivateRoute_1.default, { path: url + "/objekte/anlegen/dmg", exact: true, render: function () { return (React.createElement(ObjektAnlegenDMG_1.default, { onAddObjekt: _this.handleAddObjekt })); } }),
                React.createElement(PrivateRoute_1.default, { render: function () { return (React.createElement(VorgangDetails_1.default, { vorgang: vorgang, vorlage: vorlage, objekte: objekte, onKorrekturvorgangAnlegen: _this.handleKorrekturvorgangAnlegen, onObjektAuswahlAufheben: _this.handleObjektAuswahlAufheben })); } }))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorgangDetailRouter.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], VorgangDetailRouter.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], VorgangDetailRouter.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], VorgangDetailRouter.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangDetailRouter.prototype, "vorlageAbgefragt", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], VorgangDetailRouter.prototype, "vorlageAbgefragtHandler", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorgangDetailRouter.prototype, "refreshVorgang", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], VorgangDetailRouter.prototype, "handleArbeitsmittelSetAuswahl", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], VorgangDetailRouter.prototype, "handleObjektAuswahl", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], VorgangDetailRouter.prototype, "handleAddObjekt", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VorgangDetailRouter.prototype, "handleObjektAuswahlAufheben", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], VorgangDetailRouter.prototype, "handleKorrekturvorgangAnlegen", null);
    VorgangDetailRouter = __decorate([
        mobx_react_1.observer
    ], VorgangDetailRouter);
    return VorgangDetailRouter;
}(React.Component));
exports.default = VorgangDetailRouter;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var UiStore_1 = __webpack_require__(14);
var decorators_1 = __webpack_require__(1);
var ArbeitsmittelListe_1 = __webpack_require__(263);
var Callout_1 = __webpack_require__(16);
var DocumentList_1 = __webpack_require__(267);
var VorlagenBereich_1 = __webpack_require__(640);
var AuftragStore_1 = __webpack_require__(25);
var ObjektListe_1 = __webpack_require__(165);
var SesAnzeigeSystemneigung_1 = __webpack_require__(683);
var ThumbnailList_1 = __webpack_require__(605);
var VorgangFormularEingaben_1 = __webpack_require__(628);
var ApiStore_1 = __webpack_require__(13);
var react_router_dom_1 = __webpack_require__(52);
var VorgangUebermittlungInfo_1 = __webpack_require__(636);
var VorlagenBereichReadOnly_1 = __webpack_require__(641);
var VorgangDetails = (function (_super) {
    __extends(VorgangDetails, _super);
    function VorgangDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // True wenn auf der Datenbank alle zum Vorgang einzugebenden Formulardaten hinterlegt sind
        _this.formulardatenVollstaendig = false;
        _this.formulardatenHinweise = [];
        return _this;
    }
    VorgangDetails.prototype.componentDidMount = function () {
        this.refreshFormulardatenVollstaendig();
    };
    Object.defineProperty(VorgangDetails.prototype, "auftragAbgeschlossen", {
        get: function () {
            return (this.auftragStore.auftrag && this.auftragStore.auftrag.abgeschlossen);
        },
        enumerable: true,
        configurable: true
    });
    VorgangDetails.prototype.setArbeitsmittelListe = function (arbeitsmittelListe) {
        if (arbeitsmittelListe) {
            this.arbeitsmittelListe = arbeitsmittelListe;
        }
    };
    VorgangDetails.prototype.setDocumentList = function (docList) {
        if (docList) {
            this.docList = docList;
        }
    };
    // Wird von der Komponente für die FormularEingaben aufgerufen
    // Entscheidet ob die Funktionen zum Erzeugen und Hochladen der Dokumente sichtbar sind
    VorgangDetails.prototype.handleFormDataSubmitted = function () {
        this.refreshFormulardatenVollstaendig();
    };
    VorgangDetails.prototype.setFormulardatenVollstaendig = function (value) {
        this.formulardatenVollstaendig = value;
    };
    VorgangDetails.prototype.setFormulardatenHinweise = function (value) {
        this.formulardatenHinweise = value;
    };
    // Prüft ob alle erforderlichen Formulardaten auf Datenbank hinterlegt sind
    VorgangDetails.prototype.refreshFormulardatenVollstaendig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.props.vorgang.abgeschlossen) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.vorgangFormularEingabenVollstaendig(this.props.vorgang.vorgangguid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setFormulardatenVollstaendig(response.json.success === true);
                            this.setFormulardatenHinweise(response.json.hinweise);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.setFormulardatenVollstaendig(true);
                        this.setFormulardatenHinweise([]);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VorgangDetails.prototype.handleDocumentRefresh = function () {
        if (this.docList) {
            this.docList.refresh();
        }
    };
    Object.defineProperty(VorgangDetails.prototype, "requirementsFulfilled", {
        get: function () {
            var vorlage = this.props.vorlage;
            if (vorlage && vorlage.formular_kategorien && vorlage.formular_kategorien.length > 0 && !this.formulardatenVollstaendig) {
                return false;
            }
            return (vorlage && (vorlage.auswahl_arbeitsmittel === 0 || (this.arbeitsmittelListe && this.arbeitsmittelListe.arbeitsmittel.length !== 0)));
        },
        enumerable: true,
        configurable: true
    });
    VorgangDetails.prototype.render = function () {
        var _a = this.props, vorgang = _a.vorgang, vorlage = _a.vorlage, objekte = _a.objekte, onKorrekturvorgangAnlegen = _a.onKorrekturvorgangAnlegen, onObjektAuswahlAufheben = _a.onObjektAuswahlAufheben;
        var abgeschlossen = vorgang.abgeschlossen, vorgangguid = vorgang.vorgangguid;
        if (!(vorlage && vorlage.vorlage)) {
            return (React.createElement("div", { className: "maxwidth" },
                React.createElement(react_bootstrap_1.Well, null, "Dieser Vorgang kann nicht bearbeitet werden."),
                React.createElement(DocumentList_1.default, { source: "vorgang", id: vorgangguid })));
        }
        var vorlageBezeichnung = vorlage.vorlage.toLocaleLowerCase();
        var istDienstleistungsnachweis = (vorlage.vorlage.toLocaleLowerCase().indexOf('nachweis_dienstleistung') > -1);
        var vorgangSesVermessung = (vorlageBezeichnung === 'ses_auswertung_messwerte') || (vorlageBezeichnung === 'ses_uebernahme_messwerte') || (vorlageBezeichnung === 'ses_auswertung_messwerte_rili_2018');
        var documentListThumbnails = (vorlageBezeichnung.indexOf('foto_dokumentation') > -1);
        // Für diese Vorlagen wird ein separate Hinweis bzgl. der Freigabe durch die DIQ Zert angezeigt
        var vorlagenVorlaeufigeDatenUebermittlung = [
            'dakks_ses_stückprüfung_protokoll',
            'dakks_sep_kalibrierung_kalibrierschein',
            'dakks_ses_vermessung_kalibrierschein',
            'dakks_ses_vermessung_kalibrierschein_rili_2018',
            'dakks_ses_vermessung_kalibrierschein_rili_2018_2025',
            'bps_referenzkraft_kalibrierschein',
            'dakks_agt_4gas_kalibrierschein',
            'dakks_agt_opazimeter_kalibrierschein',
            'dakks_agt_partikelzaehler_kalibrierschein'
        ];
        return (React.createElement("div", { className: "vorgang-details" },
            vorlage.auswahl_arbeitsmittel === 1 && (React.createElement(ArbeitsmittelListe_1.default, { ref: this.setArbeitsmittelListe, vorgangId: vorgangguid, editable: !abgeschlossen })),
            vorlage.auswahl_objekte === 1 && (React.createElement(ObjektListe_1.default, { objekte: objekte, auftrag: this.auftragStore.auftrag, vorgang: vorgang, editable: !abgeschlossen, onAuswahlAufheben: function () { return onObjektAuswahlAufheben(vorgang); } })),
            vorlage && vorlage.formular_kategorien && vorlage.formular_kategorien.length > 0 && (React.createElement(VorgangFormularEingaben_1.default, { vorgangId: vorgangguid, formular_kategorien: vorlage.formular_kategorien, formulardaten: vorgang.formulardaten, handleDocumentRefresh: this.handleDocumentRefresh, handleFormDataSubmitted: this.handleFormDataSubmitted, editable: !abgeschlossen })),
            !abgeschlossen && !this.requirementsFulfilled && (React.createElement(RequirementsInfo, { arbeitsmittel: (vorlage && vorlage.auswahl_arbeitsmittel > 0) ? (this.arbeitsmittelListe && this.arbeitsmittelListe.arbeitsmittel.length > 0) : true, formulareingaben: (vorlage.formular_kategorien && vorlage.formular_kategorien.length > 0) ? this.formulardatenVollstaendig : true, hinweise: this.formulardatenHinweise })),
            !abgeschlossen && this.requirementsFulfilled && (React.createElement(VorlagenBereich_1.default, { vorlagenTyp: vorlage.vorlage.toLowerCase(), vorgang: vorgang, handleDocumentRefresh: this.handleDocumentRefresh })),
            abgeschlossen && React.createElement(VorlagenBereichReadOnly_1.default, { vorlagenTyp: vorlage.vorlage.toLowerCase(), vorgang: vorgang }),
            istDienstleistungsnachweis && abgeschlossen && (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Vorgang abgeschlossen"),
                React.createElement("p", null, "Die Informationen zu den von Ihnen erbrachten Dienstleistungen wurden an die DIQ Zert GmbH \u00FCbermittelt."),
                React.createElement("p", null, "Die Rechnung an den Auftraggeber sowie Ihre Gutschrift (nach Abzug der Abgaben) werden nach Pr\u00FCfung postalisch versendet."))),
            abgeschlossen && vorlagenVorlaeufigeDatenUebermittlung.indexOf(vorlageBezeichnung) > -1 && (React.createElement(VorgangUebermittlungInfo_1.default, { vorgang: vorgang })),
            vorgangSesVermessung && abgeschlossen && (React.createElement("div", null,
                React.createElement(SesAnzeigeSystemneigung_1.default, { vorgangId: vorgangguid }))),
            !istDienstleistungsnachweis && (React.createElement("div", null,
                !documentListThumbnails && React.createElement(DocumentList_1.default, { ref: this.setDocumentList, source: "vorgang", id: vorgangguid }),
                documentListThumbnails && (React.createElement(ThumbnailList_1.default, { id: vorgangguid })),
                !this.auftragAbgeschlossen && abgeschlossen && onKorrekturvorgangAnlegen && (React.createElement(Callout_1.default, { bsStyle: "info" },
                    React.createElement("h4", null, "Dieser Vorgang ist abgeschlossen, ein \u00C4ndern der Daten ist nicht mehr m\u00F6glich."),
                    React.createElement("p", null, "Die Daten k\u00F6nnen jedoch \u00FCber einen Korrekturvorgang erneut (in korrigierter Form) erfasst werden."),
                    React.createElement("div", { className: "text-right" },
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "info", type: "submit", onClick: function () { return onKorrekturvorgangAnlegen(vorgangguid); } }, "Korrekturvorgang anlegen"))))))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", DocumentList_1.default)
    ], VorgangDetails.prototype, "docList", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", ArbeitsmittelListe_1.default)
    ], VorgangDetails.prototype, "arbeitsmittelListe", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorgangDetails.prototype, "formulardatenVollstaendig", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], VorgangDetails.prototype, "formulardatenHinweise", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], VorgangDetails.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], VorgangDetails.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorgangDetails.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], VorgangDetails.prototype, "auftragAbgeschlossen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangDetails.prototype, "setArbeitsmittelListe", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangDetails.prototype, "setDocumentList", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorgangDetails.prototype, "handleFormDataSubmitted", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], VorgangDetails.prototype, "setFormulardatenVollstaendig", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], VorgangDetails.prototype, "setFormulardatenHinweise", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorgangDetails.prototype, "handleDocumentRefresh", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], VorgangDetails.prototype, "requirementsFulfilled", null);
    VorgangDetails = __decorate([
        mobx_react_1.observer
    ], VorgangDetails);
    return VorgangDetails;
}(React.Component));
exports.default = VorgangDetails;
var RequirementsInfo = (function (_super) {
    __extends(RequirementsInfo, _super);
    function RequirementsInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RequirementsInfo.prototype.render = function () {
        var _a = this.props, arbeitsmittel = _a.arbeitsmittel, formulareingaben = _a.formulareingaben, hinweise = _a.hinweise;
        return (React.createElement("div", null,
            !formulareingaben && (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Eingabedaten unvollst\u00E4ndig"),
                React.createElement("p", null, "Es wurden noch nicht alle zum Erzeugen der Dokumente notwendigen Eingabedaten erfasst. Sobald die fehlenden Eingaben erg\u00E4nzt und gespeichert wurden, k\u00F6nnen die Dokumente zu diesem Vorgang erzeugt werden."),
                hinweise && React.createElement("div", null, hinweise.map(function (hinweis, index) { return React.createElement("p", { key: "req-hinweis-" + index }, hinweis); })))),
            !arbeitsmittel && (React.createElement(Callout_1.default, { bsStyle: "info" },
                React.createElement("h4", null, "Keine Arbeitsmittel gew\u00E4hlt"),
                React.createElement("p", null,
                    "Zum Erzeugen der Dokumente ist eine Auswahl der verwendeten Arbeitsmittel notwendig. Bitte ",
                    React.createElement(react_router_dom_1.Link, { to: this.uiStore.currentLocation.pathname + "/arbeitsmittel" }, "w\u00E4hlen Sie hier"),
                    " die f\u00FCr den Vorgang genutzten Arbeitsmittel aus.")))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], RequirementsInfo.prototype, "uiStore", void 0);
    return RequirementsInfo;
}(React.Component));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Auflistung der Formulareingaben zu einem Vorgang (über Vorlage)
 */
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var VorgangFormularKategorie_1 = __webpack_require__(634);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var ApiStore_1 = __webpack_require__(13);
var decorators_2 = __webpack_require__(1);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var VorgangStore_1 = __webpack_require__(22);
var serialize = __webpack_require__(373);
var VorgangFormularEingaben = (function (_super) {
    __extends(VorgangFormularEingaben, _super);
    function VorgangFormularEingaben(props) {
        var _this = _super.call(this, props) || this;
        _this.requestInProgress = false;
        _this.validationstate = 'error';
        _this.zeitpunktGespeichert = undefined;
        _this.handleValidationStateChange = function (e) {
            // Validierungsstatus in State übernehmen
            if (_this.state.kategorien) {
                for (var _i = 0, _a = _this.state.kategorien; _i < _a.length; _i++) {
                    var kategorie = _a[_i];
                    if (kategorie.props.kategorieguid === e.props.kategorieguid) {
                        kategorie.validationstate = e.validationstate;
                    }
                }
            }
            // Validierung über alle Kategorien des Formulars
            _this.validationstate = 'success';
            for (var _b = 0, _c = _this.state.kategorien; _b < _c.length; _b++) {
                var kategorie = _c[_b];
                if (kategorie.validationstate === 'error') {
                    _this.validationstate = 'error';
                    break;
                }
            }
        };
        _this.state = { kategorien: new Array() };
        if (_this.props.formular_kategorien) {
            _this.props.formular_kategorien.forEach(function (item) {
                var kategorie = new VorgangFormularKategorie_1.default(__assign({}, item));
                _this.state.kategorien.push(kategorie);
            });
        }
        return _this;
    }
    VorgangFormularEingaben.prototype.componentDidMount = function () {
        this.setValidationState('success');
        for (var _i = 0, _a = this.state.kategorien; _i < _a.length; _i++) {
            var kategorie = _a[_i];
            if (kategorie.validationstate === 'error') {
                this.setValidationState('error');
            }
        }
    };
    VorgangFormularEingaben.prototype.setValidationState = function (state) {
        if (state === void 0) { state = 'error'; }
        this.validationstate = state;
    };
    VorgangFormularEingaben.prototype.setZeitpunktGespeichert = function (value) {
        this.zeitpunktGespeichert = value;
    };
    VorgangFormularEingaben.prototype.handleFormularEingabenSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var serialized, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.setRequesInProgress(true);
                        serialized = serialize(event.currentTarget, { hash: true });
                        return [4 /*yield*/, this.apiStore.vorgangFormularEingaben(this.props.vorgangId, serialized)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (response.json.date) {
                                this.setZeitpunktGespeichert(response.json.date);
                            }
                            this.props.handleDocumentRefresh();
                        }
                        this.props.handleFormDataSubmitted();
                        this.setRequesInProgress(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    VorgangFormularEingaben.prototype.setRequesInProgress = function (value) {
        this.requestInProgress = value;
    };
    VorgangFormularEingaben.prototype.render = function () {
        var _this = this;
        var _a = this.props, formular_kategorien = _a.formular_kategorien, formulardaten = _a.formulardaten, editable = _a.editable;
        var vorgang = this.vorgangStore.vorgang;
        if (this.zeitpunktGespeichert === undefined) {
            var metaZeitpunktGespeichert = vorgang && vorgang.meta && vorgang.meta.find(function (meta) { return meta.bezeichnung === 'formulardaten_gespeichert'; });
            if (metaZeitpunktGespeichert) {
                this.setZeitpunktGespeichert(metaZeitpunktGespeichert.zeitpunkt);
            }
        }
        var formularKategorien = formular_kategorien.map(function (element) { return (React.createElement(VorgangFormularKategorie_1.default, __assign({ key: element.kategorieguid, editable: editable, formulardaten: formulardaten, onHandleValidationStateChange: _this.handleValidationStateChange, vorgangId: vorgang && vorgang.vorgangguid }, element))); });
        return (React.createElement(react_bootstrap_1.Form, { horizontal: true, onSubmit: this.handleFormularEingabenSubmit },
            formularKategorien,
            this.zeitpunktGespeichert &&
                React.createElement(Callout_1.default, { bsStyle: "default" },
                    React.createElement("p", null,
                        "Eingabedaten zuletzt gespeichert am ",
                        this.zeitpunktGespeichert)),
            editable &&
                React.createElement(Callout_1.default, { bsStyle: "success" },
                    React.createElement("p", null, "Speichert die bisher eingegebenen Daten im aktuellen Vorgang. Bereits gespeicherte Daten k\u00F6nnen jederzeit, bis zum Abschlu\u00DF des Vorgangs, erg\u00E4nzt und korrigiert werden."),
                    React.createElement("div", { className: "text-right" },
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "success", type: "submit", disabled: this.requestInProgress }, "Speichern")))));
    };
    __decorate([
        decorators_2.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorgangFormularEingaben.prototype, "apiStore", void 0);
    __decorate([
        decorators_2.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], VorgangFormularEingaben.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorgangFormularEingaben.prototype, "requestInProgress", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangFormularEingaben.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangFormularEingaben.prototype, "zeitpunktGespeichert", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularEingaben.prototype, "setValidationState", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularEingaben.prototype, "setZeitpunktGespeichert", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], VorgangFormularEingaben.prototype, "handleFormularEingabenSubmit", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularEingaben.prototype, "setRequesInProgress", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], VorgangFormularEingaben.prototype, "handleValidationStateChange", void 0);
    VorgangFormularEingaben = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], VorgangFormularEingaben);
    return VorgangFormularEingaben;
}(React.Component));
exports.default = VorgangFormularEingaben;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var VorgangListe = (function (_super) {
    __extends(VorgangListe, _super);
    function VorgangListe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorgangListe.prototype.render = function () {
        var _a = this.props, dienstleistung = _a.dienstleistung, vorgaenge = _a.vorgaenge;
        var vorgaengeZuDienstleistung = vorgaenge.filter(function (vorgang) { return vorgang.kuerzel_dienstleistung === dienstleistung.kuerzel_dienstleistung; });
        return (React.createElement(react_bootstrap_1.Panel, { header: dienstleistung.sortierung + ". " + dienstleistung.kuerzel_dienstleistung },
            React.createElement(react_bootstrap_1.ListGroup, { fill: true }, vorgaengeZuDienstleistung.map(function (vorgang, index) { return React.createElement(VorgangListItem, { key: index, vorgang: vorgang }); }))));
    };
    return VorgangListe;
}(React.Component));
exports.default = VorgangListe;
var VorgangListItem = (function (_super) {
    __extends(VorgangListItem, _super);
    function VorgangListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorgangListItem.prototype.render = function () {
        var _this = this;
        var vorgang = this.props.vorgang;
        var header = (React.createElement("span", null,
            vorgang.sortierung,
            ". ",
            vorgang.name,
            " ",
            vorgang.korrekturvorgang && (React.createElement("span", null,
                "(",
                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "pencil" }),
                " Korrektur)"))));
        var statusClass = undefined;
        if (vorgang.vgstatus) {
            statusClass = 'vorgang-' + vorgang.vgstatus.toLowerCase();
        }
        var objekt = undefined;
        if (vorgang.objekte && vorgang.objekte.length > 0) {
            objekt = vorgang.objekte[0];
        }
        return (React.createElement(react_bootstrap_1.ListGroupItem, { onClick: function () { return _this.uiStore.navigateTo("vorgang/" + vorgang.vorgangguid); }, header: header },
            objekt && React.createElement("span", null,
                "Objekt im Vorgang: ",
                objekt.objektid,
                " (S/N: ",
                objekt.sernr,
                ")",
                React.createElement("br", null)),
            React.createElement("span", { className: statusClass }, vorgang.statustext)));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], VorgangListItem.prototype, "uiStore", void 0);
    return VorgangListItem;
}(React.Component));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var ErteilungAngebot = (function (_super) {
    __extends(ErteilungAngebot, _super);
    function ErteilungAngebot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErteilungAngebot.prototype.setzeAuftragNichtErteilt = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragNichtErteilt(this.props.auftragId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.uiStore.navigateTo('/auftraege');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ErteilungAngebot.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Auftrag zurückstellen ", bsStyle: "info", footer: (React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.setzeAuftragNichtErteilt(); } }, "Zur\u00FCckstellen"))) }, "Der Auftrag kam nicht zustande (z.B. weil das Angebot abgelehnt wurde). Er kann dann zur\u00FCckgestellt werden und wird nicht mehr unter den aktiven Auftr\u00E4gen gelistet."));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], ErteilungAngebot.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], ErteilungAngebot.prototype, "uiStore", void 0);
    return ErteilungAngebot;
}(React.Component));
exports.default = ErteilungAngebot;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Vorlagenbereich für den Upload mehrerer Bilder zu einem Vorgang
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var Dropzone = __webpack_require__(104);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var FaIcon_1 = __webpack_require__(20);
var FotoUpload = (function (_super) {
    __extends(FotoUpload, _super);
    function FotoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragging = false;
        return _this;
    }
    FotoUpload.prototype.componentDidMount = function () {
        this.kategorie = this.props.kategorie;
    };
    FotoUpload.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.kategorie !== this.props.kategorie) {
            this.kategorie = nextProps.kategorie;
        }
    };
    Object.defineProperty(FotoUpload.prototype, "filesSelected", {
        get: function () {
            return ((this.acceptedFiles !== undefined) && this.acceptedFiles.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    FotoUpload.prototype.handleFileDrop = function (accepted) {
        if (accepted.length > 0) {
            this.acceptedFiles = Array.from(accepted);
        }
        this.handleSetDragging(false);
    };
    FotoUpload.prototype.handleFileDropRejected = function (rejected) {
        this.handleClearAcceptedFile();
        this.handleSetDragging(false);
    };
    FotoUpload.prototype.handleClearAcceptedFile = function () {
        this.acceptedFiles = undefined;
    };
    FotoUpload.prototype.handleSetDragging = function (dragging) {
        this.dragging = dragging;
    };
    FotoUpload.prototype.handleUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.acceptedFiles && this.kategorie)) return [3 /*break*/, 2];
                        vorgangId = this.props.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangFotoUpload(vorgangId, this.kategorie, this.acceptedFiles)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.handleClearAcceptedFile();
                            this.vorgangStore.loadVorgang(vorgangId);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FotoUpload.prototype.handleKategorieChanged = function (event) {
        this.kategorie = event.target.value;
    };
    FotoUpload.prototype.render = function () {
        var _this = this;
        // tslint:disable-next-line:no-any
        var dropZone;
        return (React.createElement(react_bootstrap_1.Panel, { header: 'Fotos auswählen', bsStyle: "info", footer: (React.createElement("div", { className: "text-right" }, this.filesSelected ? (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Button, { onClick: this.handleClearAcceptedFile }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: this.handleUpload, disabled: !this.kategorie }, "Ausgew\u00E4hlte Datei hochladen"))) : (React.createElement(react_bootstrap_1.Button, { onClick: function () { return dropZone.open(); } }, "Dateien ausw\u00E4hlen")))) },
            React.createElement(Dropzone, { accept: ".jpg,.jpeg,.png", ref: function (ref) { return dropZone = ref; }, multiple: true, disableClick: true, style: {}, className: "upload-dropzone " + (this.dragging ? 'upload-dropzone-dragging' : ''), onDragEnter: function () { return _this.handleSetDragging(true); }, onDragLeave: function () { return _this.handleSetDragging(false); }, onDropAccepted: this.handleFileDrop, onDropRejected: this.handleFileDropRejected }, this.filesSelected ? (React.createElement("div", null,
                this.acceptedFiles ?
                    React.createElement("div", null,
                        React.createElement("h4", null,
                            this.acceptedFiles.length,
                            " Datei(en) ausgew\u00E4hlt:"),
                        React.createElement("div", null,
                            React.createElement("ul", null, this.acceptedFiles.map(function (file, index) { return React.createElement("li", { key: index },
                                file.name,
                                " (",
                                Math.ceil(10 * file.size / 1024 / 1024) / 10,
                                " MB) "); })))) : null,
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Kategorie" },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                            React.createElement(react_bootstrap_1.ControlLabel, null, "Kategorie")),
                        React.createElement(react_bootstrap_1.FormGroup, { controlId: "auswahlKategorie" },
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "Foto-Kategorie wählen", onChange: this.handleKategorieChanged },
                                React.createElement("option", { value: "" }, "Fotokategorie ausw\u00E4hlen..."),
                                this.props.kategorien.map(function (kategorie, index) {
                                    return React.createElement("option", { key: kategorie, value: kategorie }, kategorie);
                                }))))))) : (React.createElement("div", null,
                React.createElement("div", { className: "text-center" },
                    React.createElement("div", { style: { fontSize: '4em' } },
                        React.createElement(FaIcon_1.default, { icon: "cloud-upload" })),
                    React.createElement("div", null,
                        "Dateien ausw\u00E4hlen oder per Drag&Drop auf die Fl\u00E4che fallen lassen.",
                        React.createElement("br", null),
                        "Unterst\u00FCtzte Formate: jpg, jpeg, png")))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FotoUpload.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], FotoUpload.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FotoUpload.prototype, "dragging", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], FotoUpload.prototype, "acceptedFiles", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FotoUpload.prototype, "kategorie", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FotoUpload.prototype, "filesSelected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FotoUpload.prototype, "handleFileDrop", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FotoUpload.prototype, "handleFileDropRejected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FotoUpload.prototype, "handleClearAcceptedFile", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FotoUpload.prototype, "handleSetDragging", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], FotoUpload.prototype, "handleUpload", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FotoUpload.prototype, "handleKategorieChanged", null);
    FotoUpload = __decorate([
        mobx_react_1.observer
    ], FotoUpload);
    return FotoUpload;
}(React.Component));
exports.default = FotoUpload;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var ApiTypes = __webpack_require__(21);
var AuftragStore_1 = __webpack_require__(25);
var react_bootstrap_1 = __webpack_require__(2);
/** Komponente zur Anzeige einer im Auftrag hinterlegten Adresse innerhalb eines Vorgangs (zu Anzeigezwecken, kein Bearbeiten möglich) */
var VorgangAuftragAdresse = (function (_super) {
    __extends(VorgangAuftragAdresse, _super);
    function VorgangAuftragAdresse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorgangAuftragAdresse.prototype.render = function () {
        var auftrag = this.auftragStore.auftrag;
        if (!auftrag) {
            return (React.createElement("div", null, "Keine Adressdaten vorhanden"));
        }
        var strasse = '';
        var name = '';
        var ort = '';
        var caption = '';
        switch (this.props.adressArt) {
            case ApiTypes.AdressArt.Auftraggeber:
                caption = 'Auftraggeber';
                strasse = auftrag.auftraggeber_strasse;
                name = (auftrag.auftraggeber_name1 || '') + " " + (auftrag.auftraggeber_name2 || '') + " " + (auftrag.auftraggeber_name3 || '');
                ort = (auftrag.auftraggeber_plz || '') + " " + (auftrag.auftraggeber_ort || '');
                break;
            case ApiTypes.AdressArt.Beauftragter:
                caption = 'Ort der Kalibrierung';
                strasse = auftrag.beauftragter_strasse ? auftrag.beauftragter_strasse : '';
                name = (auftrag.beauftragter_name1 || '') + " " + (auftrag.beauftragter_name2 || '') + " " + (auftrag.beauftragter_name3 || '');
                ort = (auftrag.beauftragter_plz || '') + " " + (auftrag.beauftragter_ort || '');
                break;
            // Letztendlich nur ein Alias damit die Anzeige angepasst werden kann
            case ApiTypes.AdressArt.Lieferadresse:
                caption = 'Lieferadresse';
                strasse = auftrag.beauftragter_strasse ? auftrag.beauftragter_strasse : '';
                name = (auftrag.beauftragter_name1 || '') + " " + (auftrag.beauftragter_name2 || '') + " " + (auftrag.beauftragter_name3 || '');
                ort = (auftrag.beauftragter_plz || '') + " " + (auftrag.beauftragter_ort || '');
                break;
            default:
                strasse = '';
                name = '';
                ort = '';
        }
        // Hinweistext bei komplett leerer Adresse anzeigen
        if ((strasse === '') && (name === '') && (ort === '')) {
            return (React.createElement(react_bootstrap_1.Panel, { header: caption },
                React.createElement("p", null,
                    "Im Auftrag wurde noch ",
                    React.createElement("b", null, "keine Adresse"),
                    " f\u00FCr ",
                    caption,
                    " hinterlegt."),
                React.createElement("p", null, "Wenn Adressinformationen in die Vorlage \u00FCbernommen werden sollen, erg\u00E4nzen Sie diese bitte im Auftrag.")));
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: caption },
            React.createElement("p", null, "Die im Auftrag hinterlegte Adresse wird in die Vorlage \u00FCbernommen:"),
            React.createElement("div", { className: "auftraggeber adress-daten-auftrag" },
                React.createElement("div", { className: "auftraggeber-links" },
                    React.createElement(react_bootstrap_1.Row, null,
                        React.createElement(react_bootstrap_1.Col, { sm: 1 }, "Name:"),
                        React.createElement(react_bootstrap_1.Col, { sm: 11 }, name)),
                    React.createElement(react_bootstrap_1.Row, null,
                        React.createElement(react_bootstrap_1.Col, { sm: 1 }, "Stra\u00DFe:"),
                        React.createElement(react_bootstrap_1.Col, { sm: 11 }, strasse)),
                    React.createElement(react_bootstrap_1.Row, null,
                        React.createElement(react_bootstrap_1.Col, { sm: 1 }, "Ort:"),
                        React.createElement(react_bootstrap_1.Col, { sm: 11 }, ort))))));
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], VorgangAuftragAdresse.prototype, "auftragStore", void 0);
    return VorgangAuftragAdresse;
}(React.Component));
exports.default = VorgangAuftragAdresse;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Einzelnes Vorlagen-Formularelement
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiTypes_1 = __webpack_require__(21);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var AuftragStore_1 = __webpack_require__(25);
var ApiStore_1 = __webpack_require__(13);
var SepHellDunkelGrenze_1 = __webpack_require__(682);
var SepBeurteilungSaeule_1 = __webpack_require__(681);
var Agt4GasKalibrierung_1 = __webpack_require__(644);
var AgtOpazimeterKalibrierung_1 = __webpack_require__(647);
var AgtPartikelzaehlerKalibrierung_1 = __webpack_require__(649);
var BpsReferenzkraftKalibrierung_1 = __webpack_require__(654);
var BpsReferenzkraftKalibrierungRili2021_1 = __webpack_require__(669);
var DmgKalibrierung_1 = __webpack_require__(674);
var FaIcon_1 = __webpack_require__(20);
var FormularElementUrl_1 = __webpack_require__(680);
var FormularElementFileUpload_1 = __webpack_require__(677);
var FormularElementDocId_1 = __webpack_require__(676);
var FormularElementTextUebernahme_1 = __webpack_require__(679);
var FormularElementFotoUpload_1 = __webpack_require__(678);
var BpsReferenzkraftKalibrierungPlatteRili2021_1 = __webpack_require__(662);
/** Rendert angepasstes nicht-standard Formularelemente aus einem Platzhalter, z.B. Messwerteingaben */
var VorgangFormularElement = (function (_super) {
    __extends(VorgangFormularElement, _super);
    function VorgangFormularElement(props) {
        var _this = _super.call(this, props) || this;
        _this.value = _this.props.wert ? _this.props.wert : '';
        _this.checked = false;
        _this.visible = _this.props.visible;
        // Standard Validierungsstatus für Felder mit Eingabemöglichkeit setzen
        if (_this.requiresValidation()) {
            if (_this.props.wert) {
                // Sind zu diesem Element Werte hinterlegt muss z.B. die Validierung manuell ausgelöst werden
                _this.validationstate = _this.props.wert === '' ? 'error' : undefined;
            }
            else {
                _this.validationstate = 'error';
            }
        }
        return _this;
    }
    VorgangFormularElement.prototype.handleValueChanged = function (event) {
        // TODO: Validierung nur bei optionalen Feldern
        this.validationstate = (event.target.value === '') ? 'error' : 'success';
        this.value = event.target.value;
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this);
        }
    };
    VorgangFormularElement.prototype.handleRadioChanged = function (valueIndex, value) {
        this.validationstate = (value === '') ? 'error' : undefined;
        this.value = value;
        this.checked = (value === this.props.werte[1]);
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this);
        }
    };
    VorgangFormularElement.prototype.handleCustomValidation = function (validationstate) {
        this.validationstate = validationstate;
        // Änderung nach oben propagieren
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this);
        }
    };
    /**
     * Gibt an ob dieses Element validiert werden muss, abhängig vom Typ des Elements und davon ob es optional ist
     *
     * @returns boolean Gibt true zurück wenn das Element validiert werden muss, ansonsten false
     */
    VorgangFormularElement.prototype.requiresValidation = function () {
        return ((['checkbox', 'select', 'text', 'textarea', 'date', 'number', 'number_int', 'fileupload', 'fotoupload', 'docid', 'text_uebernahme'].indexOf(this.props.typ) >= 0) && (this.props.optional === false));
    };
    VorgangFormularElement.prototype.getValidationState = function () {
        return (this.props.editable) ? this.validationstate : undefined;
    };
    // Gibt anhand der in der Kategorie hinterlegten Vorlage die passende React-Komponente zurück
    VorgangFormularElement.prototype.renderVorlage = function () {
        switch (this.props.vorlage) {
            // Tabelle für Eingabe der Messwerte zur Beurteilung der Hell/Dunkel-Grenze des SEPs
            case 'sep_messwerte_helldunkelgrenze': {
                var fahrzeugTyp = 'PKW';
                if (this.auftragStore.auftrag) {
                    var fahrzeugTypMeta = this.auftragStore.auftrag.meta.find(function (meta) { return meta.bezeichnung === ApiTypes_1.SES_TYP; });
                    if (fahrzeugTypMeta) {
                        fahrzeugTyp = fahrzeugTypMeta.inhalt;
                    }
                }
                return (React.createElement(SepHellDunkelGrenze_1.default, { typ: fahrzeugTyp, kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this, onHandleChange: this.props.onHandleChange }));
            }
            // Tabelle für Eingabe der Messwerte zur Beurteilung der Gradheit der Säule des SEPs
            case 'sep_messwerte_beurteilungsäule': {
                return (React.createElement(SepBeurteilungSaeule_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this, onHandleChange: this.props.onHandleChange }));
            }
            // Messwerteingabe 4-Gas Abgasmessgerät
            case 'agt_4gas_kalibrierung': {
                return (React.createElement(Agt4GasKalibrierung_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this }));
            }
            // Messwerteingabe Opazimeter Abgasmessgerät
            case 'agt_opazimeter_kalibrierung': {
                return (React.createElement(AgtOpazimeterKalibrierung_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this }));
            }
            // Messwerteingabe Abgasmessgerät Partikelzähler
            case 'agt_partikel_dc_kalibrierung': {
                return (React.createElement(AgtPartikelzaehlerKalibrierung_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this }));
            }
            // Kalibrierung Bremsenprüfstand mit Referenzkraft-Verfahren
            case 'bps_referenzkraft_kalibrierung': {
                return (React.createElement(BpsReferenzkraftKalibrierung_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this }));
            }
            // Messwerteingabe Druckmessgerät
            case 'dmg_handpumpe_kalibrierschein': {
                return (React.createElement(DmgKalibrierung_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this }));
            }
            case 'bps_referenzkraft_kalibrierung_rili_2021': {
                return (React.createElement(BpsReferenzkraftKalibrierungRili2021_1.default, { kategorieguid: this.props.kategorieguid, elementguid: this.props.elementguid, editable: this.props.editable, value: this.value, element: this }));
            }
            case 'bps_referenzkraft_kalibrierung_platte_rili_2021': {
                return (React.createElement(BpsReferenzkraftKalibrierungPlatteRili2021_1.default, __assign({}, this.props, { value: this.value })));
            }
            default:
                return (React.createElement("div", { className: "maxwidth", style: { color: 'red' } }, "Unbekannte Vorlage \"" + this.props.vorlage + "\""));
        }
    };
    VorgangFormularElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, kategorieguid = _a.kategorieguid, elementguid = _a.elementguid, typ = _a.typ, text = _a.text, werte = _a.werte, editable = _a.editable, wert = _a.wert, platzhalter = _a.platzhalter;
        var rowClass = 'formular-element-row';
        if (this.props.abhaengigvon !== null) {
            rowClass = 'formular-element-abhaengig';
        }
        switch (typ) {
            case 'checkbox':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 7, className: "formular-element-caption" }, text),
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 5, className: "formular-element" }, editable ?
                            React.createElement("div", { className: "pull-right" },
                                React.createElement("div", { className: "radio radio-success radio-inline" },
                                    React.createElement("input", { type: "radio", name: kategorieguid + "[" + elementguid + "]", id: "1_" + kategorieguid + "[" + elementguid + "]", checked: this.value === werte[1], onChange: function (e) { _this.handleRadioChanged(1, werte[1]); }, value: werte[1] }),
                                    React.createElement("label", { htmlFor: "1_" + kategorieguid + "[" + elementguid + "]" }, werte[1])),
                                React.createElement("div", { className: "radio radio radio-inline" },
                                    React.createElement("input", { type: "radio", name: kategorieguid + "[" + elementguid + "]", id: "0_" + kategorieguid + "[" + elementguid + "]", checked: this.value === werte[0], onChange: function (e) { _this.handleRadioChanged(0, werte[0]); }, value: werte[0] }),
                                    React.createElement("label", { htmlFor: "0_" + kategorieguid + "[" + elementguid + "]" }, werte[0])))
                            :
                                React.createElement("p", { className: "pull-right" }, wert)))));
            case 'select':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 7, className: "formular-element-caption" }, text),
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 5, className: "formular-element" }, editable ?
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, componentClass: "select", placeholder: "select", onChange: this.handleValueChanged, type: "text", name: kategorieguid + "[" + elementguid + "]", value: this.value },
                                React.createElement("option", { value: undefined }),
                                werte.map(function (val) {
                                    return React.createElement("option", { key: val, value: val }, val);
                                }))
                            :
                                React.createElement("p", null, wert)))));
            case 'text':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, text),
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3, className: "formular-element" },
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, onChange: this.handleValueChanged, type: "text", name: kategorieguid + "[" + elementguid + "]", value: this.value, placeholder: platzhalter })))));
            case 'textarea':
                return (React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                    React.createElement(react_bootstrap_1.Row, { className: rowClass },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, text)),
                    React.createElement(react_bootstrap_1.Row, { className: rowClass },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 12, className: "formular-element" },
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, onChange: this.handleValueChanged, type: "textarea", name: kategorieguid + "[" + elementguid + "]", value: this.value, placeholder: platzhalter })))));
            case 'textblock':
                return (React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                    text.trim() !== '' &&
                        React.createElement(react_bootstrap_1.Row, { className: rowClass },
                            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, text)),
                    React.createElement(react_bootstrap_1.Row, { className: rowClass },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 12, className: "formular-element" },
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, onChange: this.handleValueChanged, componentClass: "textarea", type: "text", name: kategorieguid + "[" + elementguid + "]", value: this.value, placeholder: platzhalter, rows: 5, style: { height: 'auto !important' } })))));
            case 'date':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, text),
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3, className: "formular-element" },
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, onChange: this.handleValueChanged, type: "date", name: kategorieguid + "[" + elementguid + "]", value: this.value })))));
            case 'number':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, text),
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3, className: "formular-element" },
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, step: 0.01, onChange: this.handleValueChanged, type: "number", name: kategorieguid + "[" + elementguid + "]", value: this.value, placeholder: platzhalter })))));
            case 'number_int':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: text, validationState: this.getValidationState(), className: "formular-element-row" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, text),
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3, className: "formular-element" },
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !editable, step: 1, onChange: this.handleValueChanged, type: "number", name: kategorieguid + "[" + elementguid + "]", value: this.value, placeholder: platzhalter })))));
            case 'helptext':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.Col, { sm: 12 },
                        React.createElement(react_bootstrap_1.Panel, { className: "formular-element-helptext" },
                            React.createElement("table", { style: { border: '0px' } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement(FaIcon_1.default, { icon: "lightbulb-o", style: { fontSize: '22px', paddingRight: '10px' } })),
                                    React.createElement("td", null, text)))))));
            case 'image':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement("img", { src: this.apiStore.vorlagenElementImageUrl(elementguid), title: text, alt: text, className: "formular-element-image" })));
            case 'url':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.Col, { sm: 12 },
                        React.createElement(FormularElementUrl_1.default, { text: text, url: werte[0], icon: werte.length > 1 ? werte[1] : undefined, target: "_blank", tokenErfoderlich: true }))));
            case 'fileupload':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.Col, { sm: 12 },
                        React.createElement(FormularElementFileUpload_1.default, { vorgangId: this.props.vorgangId, text: text, dokumentenBezeichnung: werte[0], dokumentTitel: werte[0], element: this, name: kategorieguid + "[" + elementguid + "]", wert: wert, onHandleValidation: this.handleCustomValidation }))));
            case 'fotoupload':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.Col, { sm: 12 }, this.props.vorgangId &&
                        React.createElement(FormularElementFotoUpload_1.default, { vorgangId: this.props.vorgangId, kategorie: werte[0], name: kategorieguid + "[" + elementguid + "]", onHandleValidation: this.handleCustomValidation }))));
            case 'docid':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(FormularElementDocId_1.default, { editable: editable, kategorieguid: kategorieguid, elementguid: elementguid, value: wert, platzhalter: platzhalter, text: text, werte: werte[0], anr: this.auftragStore.auftrag ? this.auftragStore.auftrag.anr : undefined, onHandleValidation: this.handleCustomValidation })));
            case 'text_uebernahme':
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(FormularElementTextUebernahme_1.default, { editable: editable, kategorieguid: kategorieguid, elementguid: elementguid, value: wert, platzhalter: platzhalter, text: text, werte: werte[0], anr: this.auftragStore.auftrag ? this.auftragStore.auftrag.anr : undefined, onHandleValidation: this.handleCustomValidation })));
            case 'vorlage':
                return (React.createElement(react_bootstrap_1.Row, { className: "formular-element-vorlage" }, this.renderVorlage()));
            default:
                return (React.createElement(react_bootstrap_1.Row, { className: rowClass },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 12, className: "formular-element-caption" }, text),
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 0 })));
        }
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], VorgangFormularElement.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorgangFormularElement.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangFormularElement.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], VorgangFormularElement.prototype, "value", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorgangFormularElement.prototype, "checked", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorgangFormularElement.prototype, "visible", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularElement.prototype, "handleValueChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, String]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularElement.prototype, "handleRadioChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularElement.prototype, "handleCustomValidation", null);
    VorgangFormularElement = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], VorgangFormularElement);
    return VorgangFormularElement;
}(React.Component));
exports.default = VorgangFormularElement;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Einzelne Vorlagen-Formulakategorie
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VorgangFormularElement_1 = __webpack_require__(633);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var VorgangFormularKategorie = (function (_super) {
    __extends(VorgangFormularKategorie, _super);
    function VorgangFormularKategorie(props) {
        var _this = _super.call(this, props) || this;
        _this.handleElementChange = function (e) {
            // Elemente können innerhalb einer Kategorie andere Elemente ein-/ausblenden, z.B. wenn eine Checkbox angehakt ist
            if (_this.state.elemente) {
                // Sichtbarkeit aller abhängigen Formularelemente umschalten
                _this.state.elemente.forEach(function (item) {
                    if (item.props.abhaengigvon === e.props.elementguid) {
                        // Die Sichtbarkeit des abhängigen Elements kann über einen festgelegten Wert geschaltet werden (z.B. Auswahl = "In Ordnung")
                        // Wenn dieser nicht angegeben ist, wird über die Positiv-Auswahl der Checkbox geschaltet (wert[1])
                        item.visible = ((item.props.abhaengigvon_auswahl !== null) && (item.props.abhaengigvon_auswahl !== '')) ? (e.value === item.props.abhaengigvon_auswahl) : (e.checked);
                    }
                });
            }
            // Validierung der gesamten Kategorie
            var lastValidationState = _this.validationstate;
            _this.validationstate = 'success';
            if (_this.state.elemente) {
                // Status für aktuelles Element setzen
                for (var _i = 0, _a = _this.state.elemente; _i < _a.length; _i++) {
                    var element = _a[_i];
                    if (element.props.elementguid === e.props.elementguid) {
                        element.validationstate = e.validationstate;
                    }
                }
                // Validierung über alle Elemente der Kategorie
                for (var _b = 0, _c = _this.state.elemente; _b < _c.length; _b++) {
                    var element = _c[_b];
                    if (element.visible && element.validationstate === 'error') {
                        _this.validationstate = 'error';
                        break;
                    }
                }
                // Änderung des Validierungsstatus über Callback propagieren
                if ((lastValidationState !== _this.validationstate) && (_this.props.onHandleValidationStateChange)) {
                    _this.props.onHandleValidationStateChange(_this);
                }
            }
        };
        _this.state = { elemente: new Array() };
        _this.validationstate = 'success';
        if (_this.props.formular_elemente) {
            // Elemente als Objekte speichern
            _this.props.formular_elemente.forEach(function (item) {
                var element = new VorgangFormularElement_1.default(__assign({}, item, { visible: (!item.abhaengigvon), vorgangId: _this.props.vorgangId, onHandleChange: _this.handleElementChange }));
                // Wenn zu diesem Element im Vorgang bereits Daten hinterlegt wurden, diese als aktuellen Wert für Formularelement übernehmen
                if (_this.props.formulardaten && _this.props.formulardaten.length > 0) {
                    var formulardatum = _this.props.formulardaten.find(function (datum) { return datum.elementguid === item.elementguid; });
                    if (formulardatum) {
                        element.value = formulardatum.wert;
                        if (formulardatum.wert !== null) {
                            element.validationstate = 'success';
                        }
                    }
                }
                _this.state.elemente.push(element);
            });
            // Initiale Sichtbarkeiten schalten
            _this.state.elemente.forEach(function (item) {
                if (item.props.abhaengigvon) {
                    _this.state.elemente.forEach(function (parentItem) {
                        if ((parentItem.value) && (item.props.abhaengigvon === parentItem.props.elementguid)) {
                            // Die Sichtbarkeit des abhängigen Elements kann über einen festgelegten Wert geschaltet werden (z.B. Auswahl = "In Ordnung")
                            // Wenn dieser nicht angegeben ist, wird über die Positiv-Auswahl der Checkbox geschaltet (wert[1])
                            item.visible = ((item.props.abhaengigvon_auswahl !== null) && (item.props.abhaengigvon_auswahl !== '')) ? (parentItem.value === item.props.abhaengigvon_auswahl) : (parentItem.value === parentItem.props.werte[1]);
                        }
                    });
                }
            });
        }
        return _this;
    }
    VorgangFormularKategorie.prototype.componentDidMount = function () {
        // Validierbare Felder ohne vorbelegte Daten setzen Validierung der Gesamtkategorie auf negativ
        for (var _i = 0, _a = this.state.elemente; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element.requiresValidation() && element.visible && element.value === '') {
                this.setValidationState('error');
                break;
            }
            if (element.props.typ === 'vorlage') {
                if ((element.validationstate === undefined) || (element.validationstate === 'error')) {
                    this.setValidationState('error');
                    break;
                }
            }
        }
    };
    VorgangFormularKategorie.prototype.setValidationState = function (state) {
        this.validationstate = state;
        if (this.props.onHandleValidationStateChange) {
            this.props.onHandleValidationStateChange(this);
        }
    };
    VorgangFormularKategorie.prototype.render = function () {
        var _a = this.props, text = _a.text, editable = _a.editable;
        // Sichtbare Elemente für Rendern der Kategorie sammeln
        var sichtbareElemente = [];
        for (var i = 0; i < this.state.elemente.length; i++) {
            if (this.state.elemente[i].visible === true) {
                sichtbareElemente.push(React.createElement(VorgangFormularElement_1.default, __assign({ visible: this.state.elemente[i].visible, key: this.state.elemente[i].props.elementguid, onHandleChange: this.handleElementChange, editable: editable, wert: this.state.elemente[i].value, vorgangId: this.state.elemente[i].props.vorgangId }, this.state.elemente[i].props)));
            }
        }
        if (sichtbareElemente && sichtbareElemente.length > 0) {
            if (!text) {
                return (React.createElement("div", null, sichtbareElemente));
            }
            return (React.createElement(react_bootstrap_1.Panel, { header: text, collapsible: true, defaultExpanded: true, bsStyle: this.validationstate === 'error' ? 'danger' : 'success' }, sichtbareElemente));
        }
        else {
            // Eine Kategorie ohne Vorlage oder untergeordnete Elemente wird nicht gerendert
            return null;
        }
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], VorgangFormularKategorie.prototype, "auftragStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorgangFormularKategorie.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorgangFormularKategorie.prototype, "setValidationState", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], VorgangFormularKategorie.prototype, "handleElementChange", void 0);
    VorgangFormularKategorie = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], VorgangFormularKategorie);
    return VorgangFormularKategorie;
}(React.Component));
exports.default = VorgangFormularKategorie;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
var VorgangStatus = (function (_super) {
    __extends(VorgangStatus, _super);
    function VorgangStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorgangStatus.prototype.setzeStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props.status;
                        switch (_a) {
                            case 'abgeschl': return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.apiStore.vorgangAbschliessen(this.props.vorgangId)];
                    case 2:
                        response = _b.sent();
                        if (response.ok) {
                            this.uiStore.navigateTo("/auftrag/" + this.props.auftragId);
                        }
                        return [3 /*break*/, 4];
                    case 3: throw new Error('Ungültiger Status');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VorgangStatus.prototype.render = function () {
        var _this = this;
        var _a = this.props, bsStyle = _a.bsStyle, caption = _a.caption, text = _a.text, buttonCaption = _a.buttonCaption;
        return (React.createElement(Callout_1.default, { bsStyle: bsStyle },
            React.createElement("h4", null, caption),
            React.createElement("p", null, text),
            React.createElement("div", { className: "text-right" },
                React.createElement(react_bootstrap_1.Button, { bsStyle: bsStyle, type: "submit", onClick: function () { return _this.setzeStatus(); } }, buttonCaption))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorgangStatus.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], VorgangStatus.prototype, "uiStore", void 0);
    return VorgangStatus;
}(React.Component));
exports.default = VorgangStatus;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(16);
var VorgangUebermittlungInfo = (function (_super) {
    __extends(VorgangUebermittlungInfo, _super);
    function VorgangUebermittlungInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorgangUebermittlungInfo.prototype.getMeta = function (bezeichnung) {
        var vorgang = this.props.vorgang;
        return (vorgang && vorgang.meta && vorgang.meta.find(function (meta) { return meta.bezeichnung === bezeichnung; }));
    };
    VorgangUebermittlungInfo.prototype.render = function () {
        // Wenn die Daten übermittelt wurden, wird im Vorgang ein Metadatum mit DocID als Markierung gespeichert
        var metaDatenuebermittlung = this.getMeta('letzte_docid');
        return (React.createElement(Callout_1.default, { bsStyle: "success" },
            React.createElement("h4", { style: { marginBottom: 'inherit' } }, "Daten wurden \u00FCbermittelt"),
            metaDatenuebermittlung && React.createElement("p", null,
                "Die von Ihnen erfassten Daten wurden erfolgreich am ",
                React.createElement("b", null, metaDatenuebermittlung.zeitpunkt),
                " unter dem Aktenzeichen ",
                React.createElement("b", null, metaDatenuebermittlung.inhalt),
                " an die DIQ Zert GmbH \u00FCbermittelt."),
            !metaDatenuebermittlung && React.createElement("p", null, "Die von Ihnen erfassten Daten wurden erfolgreich an die DIQ Zert GmbH \u00FCbermittelt."),
            React.createElement("p", null, "Die g\u00FCltigen Dokumente werden nach Pr\u00FCfung im Auftrag als freigegebene Dokumente zur Verf\u00FCgung gestellt.")));
    };
    return VorgangUebermittlungInfo;
}(React.Component));
exports.default = VorgangUebermittlungInfo;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var VorlageErzeugen = (function (_super) {
    __extends(VorlageErzeugen, _super);
    function VorlageErzeugen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dokumentStatus = 'nichtVorhanden';
        return _this;
    }
    VorlageErzeugen.prototype.setzeDokumentStatus = function (status) {
        this.dokumentStatus = status;
    };
    VorlageErzeugen.prototype.handleVorlageErzeugenClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, auftragId, vorgangId, vorlage, response, _b, downloadLink;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.setzeDokumentStatus('angefordert');
                        _a = this.props, auftragId = _a.auftragId, vorgangId = _a.vorgangId, vorlage = _a.vorlage;
                        if (!(vorlage.indexOf('vermessung_kalibrierschein') > -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.beurteilungaufstellflaecheKalibrierschein(vorgangId, auftragId)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.apiStore.vorgangVorlageErzeugen(vorgangId, vorlage)];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        response = _b;
                        if (!response.ok) return [3 /*break*/, 6];
                        if (this.props.onTriggerDocumentRefresh) {
                            this.props.onTriggerDocumentRefresh();
                        }
                        return [4 /*yield*/, this.apiStore.vorgangDokumentDownloadUrl(vorgangId, response.json.detail.entryid)];
                    case 5:
                        downloadLink = _c.sent();
                        this.dokumentUrl = downloadLink;
                        window.open(downloadLink);
                        this.setzeDokumentStatus('erzeugt');
                        _c.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    VorlageErzeugen.prototype.render = function () {
        var caption = this.props.zeigeCaption ? this.props.zeigeCaption : false;
        return (React.createElement("div", null,
            caption && React.createElement("h3", null,
                React.createElement("a", { name: "#dokumente" }),
                "Dokumente erzeugen"),
            React.createElement(react_bootstrap_1.Panel, { header: this.props.titel ? this.props.titel : 'Vorlage erzeugen', bsStyle: "success", footer: (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: this.handleVorlageErzeugenClick, disabled: this.dokumentStatus === 'angefordert' }, "Vorlage erzeugen"))) },
                (this.props.text == null) && React.createElement("p", null, "Erzeugt eine ausf\u00FCllbare Vorlage mit den zum Vorgang hinterlegten Daten. Diese muss nach dem Ausf\u00FCllen hochgeladen werden."),
                (this.props.text != null) && React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.text } }),
                this.dokumentStatus === 'angefordert' &&
                    React.createElement(react_bootstrap_1.Well, { bsSize: "small", bsStyle: "info" }, "Dokument wird erzeugt..."),
                this.dokumentStatus === 'erzeugt' &&
                    React.createElement(react_bootstrap_1.Well, { bsSize: "small", bsStyle: "success" },
                        "Die Vorlage wurde erzeugt, falls diese nicht in einem neuen Fenster ge\u00F6ffnet wurde, ",
                        React.createElement("a", { href: this.dokumentUrl, target: "_blank" }, "bitte hier klicken"),
                        "."))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorlageErzeugen.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], VorlageErzeugen.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], VorlageErzeugen.prototype, "dokumentStatus", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], VorlageErzeugen.prototype, "setzeDokumentStatus", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VorlageErzeugen.prototype, "handleVorlageErzeugenClick", null);
    VorlageErzeugen = __decorate([
        mobx_react_1.observer
    ], VorlageErzeugen);
    return VorlageErzeugen;
}(React.Component));
exports.default = VorlageErzeugen;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
var VorgangStore_1 = __webpack_require__(22);
var VorlageUebermitteln = (function (_super) {
    __extends(VorlageUebermitteln, _super);
    function VorlageUebermitteln() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dokumentStatus = 'nichtVorhanden';
        _this.modalVisible = false;
        _this.error = '';
        return _this;
    }
    VorlageUebermitteln.prototype.showModal = function () {
        this.modalVisible = true;
    };
    VorlageUebermitteln.prototype.hideModal = function () {
        this.modalVisible = false;
    };
    VorlageUebermitteln.prototype.setError = function (value) {
        this.error = value;
    };
    VorlageUebermitteln.prototype.setzeDokumentStatus = function (status) {
        this.dokumentStatus = status;
    };
    VorlageUebermitteln.prototype.vorgangAbschliessen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.vorgangAbschliessen(this.props.vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    VorlageUebermitteln.prototype.handleVorlageUebermittelnClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, auftragId, vorgangId, vorlage, response, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.setzeDokumentStatus('angefordert');
                        _a = this.props, auftragId = _a.auftragId, vorgangId = _a.vorgangId, vorlage = _a.vorlage;
                        if (!(vorlage.indexOf('vermessung_kalibrierschein') > -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.beurteilungaufstellflaecheKalibrierschein(vorgangId, auftragId)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.apiStore.vorgangVorlageErzeugen(vorgangId, vorlage)];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        response = _b;
                        if (!response.ok) return [3 /*break*/, 8];
                        // Optional kann der Vorgang nach dem erfolgreichen Erzeugen des Dokuments direkt abgeschlossen werden
                        this.setzeDokumentStatus('erzeugt');
                        if (!this.props.vorgangAbschliessen) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.vorgangAbschliessen()];
                    case 5:
                        _c.sent();
                        this.uiStore.navigateTo("vorgang/" + this.props.vorgangId);
                        return [3 /*break*/, 7];
                    case 6:
                        // Wenn der Vorgang nicht abgeschlossen werden soll, wird die Liste der Dokumente im Vorgang aktualisiert
                        if (this.props.onTriggerDocumentRefresh) {
                            this.props.onTriggerDocumentRefresh();
                        }
                        _c.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        if (response.error) {
                            this.setzeDokumentStatus('fehler');
                            this.setError(response.error);
                            this.showModal();
                        }
                        _c.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    VorlageUebermitteln.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h3", null,
                React.createElement("a", { name: "#dokumente" }),
                "Daten \u00FCbermitteln"),
            React.createElement(Callout_1.default, { bsStyle: "warning" },
                React.createElement("h4", null, this.props.titel ? this.props.titel : 'Vorlage erzeugen'),
                React.createElement("div", null,
                    (this.props.text == null) && React.createElement("p", null, "\u00DCbermittelt die gespeicherten Daten zur Bearbeitung an die DIQ Zert."),
                    (this.props.text != null) && React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.text } }),
                    this.dokumentStatus === 'angefordert' &&
                        React.createElement(react_bootstrap_1.Well, { bsSize: "small", bsStyle: "info" }, "Daten werden \u00FCbermittelt..."),
                    this.dokumentStatus === 'erzeugt' &&
                        React.createElement(react_bootstrap_1.Well, { bsSize: "small", bsStyle: "success" },
                            "Das vorl\u00E4ufige Dokument wurde \u00FCbermittelt.",
                            this.props.uploadText && React.createElement("div", null, this.props.uploadText))),
                React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: this.handleVorlageUebermittelnClick, disabled: this.dokumentStatus === 'angefordert' }, "Daten \u00FCbermitteln"))),
            React.createElement(react_bootstrap_1.Modal, { show: this.modalVisible, onHide: this.hideModal, className: "modal-vertical-centered error", backdrop: 'static' },
                React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                    React.createElement(react_bootstrap_1.Modal.Title, null, "Fehler")),
                React.createElement(react_bootstrap_1.Modal.Body, null,
                    React.createElement("div", null, "Beim \u00DCbermitteln der Daten ist ein Fehler aufgetreten:"),
                    React.createElement("div", { className: "modal-error-msg" }, this.error),
                    React.createElement("div", null, "Bitte \u00FCbermitteln Sie die Daten erneut. Sollte der Fehler weiterhin auftreten, wenden Sie sich bitte mit obiger Fehlermeldung an die DIQ Zert.")),
                React.createElement(react_bootstrap_1.Modal.Footer, null,
                    React.createElement(react_bootstrap_1.Button, { onClick: this.hideModal, bsStyle: "default" }, "Schlie\u00DFen")))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorlageUebermitteln.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], VorlageUebermitteln.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], VorlageUebermitteln.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], VorlageUebermitteln.prototype, "dokumentStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorlageUebermitteln.prototype, "modalVisible", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], VorlageUebermitteln.prototype, "error", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorlageUebermitteln.prototype, "showModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorlageUebermitteln.prototype, "hideModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], VorlageUebermitteln.prototype, "setError", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], VorlageUebermitteln.prototype, "setzeDokumentStatus", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VorlageUebermitteln.prototype, "vorgangAbschliessen", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VorlageUebermitteln.prototype, "handleVorlageUebermittelnClick", null);
    VorlageUebermitteln = __decorate([
        mobx_react_1.observer
    ], VorlageUebermitteln);
    return VorlageUebermitteln;
}(React.Component));
exports.default = VorlageUebermitteln;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var Dropzone = __webpack_require__(104);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var FaIcon_1 = __webpack_require__(20);
var VorlageUpload = (function (_super) {
    __extends(VorlageUpload, _super);
    function VorlageUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragging = false;
        _this.dokumentTitel = '';
        return _this;
    }
    VorlageUpload.prototype.componentDidMount = function () {
        this.dokumentTitel = this.props.dokumentTitel ? this.props.dokumentTitel : '';
    };
    VorlageUpload.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.dokumentTitel !== this.props.dokumentTitel) {
            this.dokumentTitel = nextProps.dokumentTitel ? nextProps.dokumentTitel : '';
        }
    };
    Object.defineProperty(VorlageUpload.prototype, "fileSelected", {
        get: function () {
            return this.acceptedFile !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VorlageUpload.prototype, "fileSize", {
        get: function () {
            return (this.acceptedFile && this.acceptedFile.size && !isNaN(this.acceptedFile.size))
                ? "(~" + Math.ceil(10 * this.acceptedFile.size / 1024 / 1024) / 10 + " MB)"
                : '';
        },
        enumerable: true,
        configurable: true
    });
    VorlageUpload.prototype.handleFileDrop = function (accepted) {
        if (accepted.length > 0) {
            this.acceptedFile = accepted.shift();
        }
        this.handleSetDragging(false);
    };
    VorlageUpload.prototype.handleFileDropRejected = function (rejected) {
        this.handleClearAcceptedFile();
        this.handleSetDragging(false);
    };
    VorlageUpload.prototype.handleClearAcceptedFile = function () {
        this.acceptedFile = undefined;
    };
    VorlageUpload.prototype.handleSetDragging = function (dragging) {
        this.dragging = dragging;
    };
    VorlageUpload.prototype.handleUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.acceptedFile && (this.dokumentTitel !== ''))) return [3 /*break*/, 2];
                        vorgangId = this.props.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangProtokollUpload(vorgangId, this.dokumentTitel, this.acceptedFile, this.props.abschliessen)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.handleClearAcceptedFile();
                            this.vorgangStore.loadVorgang(vorgangId);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VorlageUpload.prototype.handleDokumenttitelChanged = function (event) {
        this.dokumentTitel = event.target.value;
        this.dokumentTitel = this.dokumentTitel.replace(/[\\\/:\*\?"<>|]/ig, '_');
    };
    Object.defineProperty(VorlageUpload.prototype, "validiereDokumenttitel", {
        get: function () {
            return (this.dokumentTitel === '') ? 'error' : undefined;
        },
        enumerable: true,
        configurable: true
    });
    VorlageUpload.prototype.render = function () {
        var _this = this;
        // tslint:disable-next-line:no-any
        var dropZone;
        var fileName = (this.acceptedFile) ? this.acceptedFile.name : '';
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.dokumentenBezeichnung + " hochladen", bsStyle: "warning", footer: (React.createElement("div", { className: "text-right" }, this.fileSelected ? (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Button, { onClick: this.handleClearAcceptedFile }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: this.handleUpload }, "Ausgew\u00E4hlte Datei hochladen"))) : (React.createElement(react_bootstrap_1.Button, { onClick: function () { return dropZone.open(); } }, "Datei ausw\u00E4hlen")))) },
            React.createElement(Dropzone, { accept: ".pdf,.docx,.tif,.tiff,.xlsx,.jpg,.jpeg,.msg", ref: function (ref) { return dropZone = ref; }, disableClick: true, style: {}, className: "upload-dropzone " + (this.dragging ? 'upload-dropzone-dragging' : ''), onDragEnter: function () { return _this.handleSetDragging(true); }, onDragLeave: function () { return _this.handleSetDragging(false); }, onDropAccepted: this.handleFileDrop, onDropRejected: this.handleFileDropRejected }, this.fileSelected ? (React.createElement("div", null,
                React.createElement("h4", null,
                    "Ausgew\u00E4hlt: ",
                    fileName,
                    " ",
                    this.fileSize),
                React.createElement("p", null, "Das Hochladen eines ausgef\u00FCllten Dokumentes markiert den Vorgang als abgeschlossen. Ein erneutes Hochladen ist erst nach Freigabe durch einen Mitarbeiter der DIQ Zert GmbH wieder m\u00F6glich."),
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.validiereDokumenttitel, controlId: "Dokumenttitel" },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null,
                            React.createElement(react_bootstrap_1.ControlLabel, null, "Dokumenttitel")),
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "Dokumenttitel", value: this.dokumentTitel, maxLength: 255, onChange: this.handleDokumenttitelChanged }))))) : (React.createElement("div", null,
                React.createElement("p", null,
                    (this.props.text == null) && React.createElement("span", null,
                        "Klicken Sie auf ",
                        React.createElement("b", null, "Ausw\u00E4hlen"),
                        " oder ziehen Sie die von Ihnen ausgef\u00FCllte Vorlage per Drag&Drop auf diese Fl\u00E4che, um den Upload vorzubereiten."),
                    (this.props.text != null) && React.createElement("span", null, this.props.text),
                    React.createElement("br", null),
                    "Unterst\u00FCtzte Formate: ",
                    React.createElement(FaIcon_1.default, { icon: "file-word-o" }),
                    "docx, ",
                    React.createElement(FaIcon_1.default, { icon: "file-pdf-o" }),
                    "pdf, ",
                    React.createElement(FaIcon_1.default, { icon: "file-image-o" }),
                    "jp(e)g und ",
                    React.createElement(FaIcon_1.default, { icon: "file-text-o" }),
                    "tif(f)"))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], VorlageUpload.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], VorlageUpload.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", File)
    ], VorlageUpload.prototype, "acceptedFile", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorlageUpload.prototype, "dragging", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], VorlageUpload.prototype, "dokumentTitel", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], VorlageUpload.prototype, "fileSelected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], VorlageUpload.prototype, "fileSize", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], VorlageUpload.prototype, "handleFileDrop", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], VorlageUpload.prototype, "handleFileDropRejected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VorlageUpload.prototype, "handleClearAcceptedFile", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], VorlageUpload.prototype, "handleSetDragging", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VorlageUpload.prototype, "handleUpload", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorlageUpload.prototype, "handleDokumenttitelChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], VorlageUpload.prototype, "validiereDokumenttitel", null);
    VorlageUpload = __decorate([
        mobx_react_1.observer
    ], VorlageUpload);
    return VorlageUpload;
}(React.Component));
exports.default = VorlageUpload;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var SesAuswertungFlaechenRili2025_1 = __webpack_require__(279);
var SesAuswertungFlaechenRili2018_1 = __webpack_require__(278);
var SesAuswertungFlaechenRili2014_1 = __webpack_require__(277);
var VorlageErzeugen_1 = __webpack_require__(637);
var VorlageUpload_1 = __webpack_require__(639);
var VorgangStore_1 = __webpack_require__(22);
var decorators_1 = __webpack_require__(1);
var ErteilungAngebot_1 = __webpack_require__(630);
var Dienstleistungsnachweis_1 = __webpack_require__(642);
var DienstleistungsnachweisSammelrechnung_1 = __webpack_require__(643);
var Callout_1 = __webpack_require__(16);
var SesUebernahmeMesswerte_1 = __webpack_require__(685);
var FotoUpload_1 = __webpack_require__(631);
var VorgangStatus_1 = __webpack_require__(635);
var VorlageUebermitteln_1 = __webpack_require__(638);
var VorgangAuftragAdresse_1 = __webpack_require__(632);
var MailVorlage_1 = __webpack_require__(272);
var MailVorlage_2 = __webpack_require__(272);
var ApiTypes = __webpack_require__(21);
var VorlagenBereich = (function (_super) {
    __extends(VorlagenBereich, _super);
    function VorlagenBereich() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorlagenBereich.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangguid, messwerteVorhanden, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setAbfrageStatus('angefordert');
                        vorgangguid = this.props.vorgang.vorgangguid;
                        messwerteVorhanden = true;
                        _a = this.props.vorlagenTyp;
                        switch (_a) {
                            case 'ses_stückprüfung_protokoll': return [3 /*break*/, 1];
                            case 'dakks_ses_stückprüfung_protokoll': return [3 /*break*/, 1];
                            case 'intern_ses_stückprüfung_protokoll': return [3 /*break*/, 1];
                            case 'ses_vermessung_kalibrierschein': return [3 /*break*/, 1];
                            case 'dakks_ses_vermessung_kalibrierschein': return [3 /*break*/, 1];
                            case 'dakks_ses_vermessung_kalibrierschein_rili_2018': return [3 /*break*/, 1];
                            case 'dakks_ses_vermessung_kalibrierschein_rili_2018_2025': return [3 /*break*/, 1];
                            case 'intern_ses_vermessung_kalibrierschein': return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, (this.vorgangStore.messwerteSesVorhanden(vorgangguid))];
                    case 2:
                        messwerteVorhanden = _b.sent();
                        return [3 /*break*/, 3];
                    case 3:
                        this.setMesswerteVorhanden(messwerteVorhanden);
                        this.setAbfrageStatus('abgeschlossen');
                        return [2 /*return*/];
                }
            });
        });
    };
    VorlagenBereich.prototype.setMesswerteVorhanden = function (vorlagenAnzeigen) {
        this.messwerteVorhanden = vorlagenAnzeigen;
    };
    VorlagenBereich.prototype.setAbfrageStatus = function (status) {
        this.abfrageStatus = status;
    };
    VorlagenBereich.prototype.render = function () {
        if (this.abfrageStatus !== 'abgeschlossen') {
            return React.createElement("div", null, "lade Messwertdaten...");
        }
        if (!this.messwerteVorhanden) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Der Vorgang kann erst weiter bearbeitet werden wenn Messwerte erfasst wurden."),
                React.createElement("p", null, "Bitte f\u00FChren Sie dazu die Auswertung der Messwerte durch.")));
        }
        var vorlagenTyp = this.props.vorlagenTyp;
        var vorgangguid = this.props.vorgang.vorgangguid;
        var auftragId = this.props.vorgang.anr;
        var handleDocumentRefresh = this.props.handleDocumentRefresh;
        // @TODO: Flexibler gestalten, viel zu überfrachtet und viel zu unübersichtlich
        switch (vorlagenTyp) {
            case 'sep_kalibrierung_protokoll':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Protokoll", dokumentTitel: "Protokoll Kalibrierung" })));
            case 'ses_vermessung_protokoll':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Protokoll", dokumentTitel: "Protokoll Vermessung" })));
            case 'ses_stückprüfung_protokoll':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Protokoll", dokumentTitel: "Protokoll Stückprüfung" })));
            case 'sep_kalibrierung_ergebnisbericht':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Ergebnisbericht", dokumentTitel: "Ergebnisbericht Kalibrierung" })));
            case 'ses_vermessung_kalibrierschein':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Kalibrierschein", dokumentTitel: "Kalibrierschein Flächen" })));
            case 'sep_kalibrierung_kalibrierschein':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Kalibrierschein", dokumentTitel: "Kalibrierschein" })));
            // Interne Rückführung SES
            // @todo: Kann nach Komplettumstellung auf DAkkS-Akkreditiv entfernt werden
            case 'intern_ses_stückprüfung_protokoll':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, titel: "Vorläufiges Stückprüfungsprotokoll erzeugen", text: 'Erzeugt das ausgefüllte vorläufige Stückprüfungsprotokoll mit den oben erfassten Eingabedaten.<br/><br/> \
              Die Vorlage dient primär der Kontrolle, nachträgliche Korrekturen bitte über Anpassungen der Eingabedaten und erneutes Erzeugen einer Vorlage durchführen.' }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Protokoll", dokumentTitel: "Protokoll Stückprüfung" })));
            case 'intern_sep_kalibrierung_kalibrierschein':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Vorläufigen Kalibrierschein erzeugen", text: 'Erzeugt den ausgefüllten vorläufigen Kalibrierschein mit den oben erfassten Eingabedaten.<br/><br/> \
              Die Vorlage dient primär der Kontrolle, nachträgliche Korrekturen bitte über Anpassungen der Eingabedaten und erneutes Erzeugen einer Vorlage durchführen.' }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, text: "Klicken Sie auf Auswählen oder ziehen Sie den von Ihnen unterschriebenen Kalibrierschein per Drag&Drop auf diese Fläche, um den Upload vorzubereiten.", dokumentenBezeichnung: "Kalibrierschein", dokumentTitel: "Kalibrierschein SEP" })));
            case 'intern_ses_vermessung_kalibrierschein':
                return (React.createElement("div", null,
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Vorläufigen Kalibrierschein erzeugen", text: 'Erzeugt den ausgefüllten vorläufigen Kalibrierschein mit den oben erfassten Eingabedaten.<br/><br/> \
              Die Vorlage dient primär der Kontrolle, nachträgliche Korrekturen bitte über Anpassungen der Eingabedaten und erneutes Erzeugen einer Vorlage durchführen.<br/><br/> \
              <b>In der Vorlage selbst bitte nur Informationen zu Sperrflächen und Referenzpunkt vor dem Hochladen manuell ergänzen.</b>' }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, text: "Klicken Sie auf Auswählen oder ziehen Sie den von Ihnen unterschriebenen Kalibrierschein per Drag&Drop auf diese Fläche, um den Upload vorzubereiten.", dokumentenBezeichnung: "Kalibrierschein", dokumentTitel: "Kalibrierschein Flächen" })));
            // DAkkS SES
            case 'dakks_ses_stückprüfung_protokoll':
                return (React.createElement(VorlageUebermitteln_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Daten zum Stückprüfungsprotokoll übermitteln", text: 'Übermittelt die gespeicherten Daten als vorläufiges Stückprüfungsprotokoll an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.', vorgangAbschliessen: true }));
            case 'dakks_sep_kalibrierung_kalibrierschein':
            case 'sep_kalibrierung_kalibrierschein_luxemburg':
                return (React.createElement(VorlageUebermitteln_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Daten zum Kalibrierschein übermitteln", text: 'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.', uploadText: 'Bitte verwenden Sie dieses Aktenzeichen für das Stückprüfungsprotokoll.', vorgangAbschliessen: true }));
            case 'dakks_ses_vermessung_kalibrierschein':
            case 'dakks_ses_vermessung_kalibrierschein_rili_2018':
            case 'dakks_ses_vermessung_kalibrierschein_rili_2018_2025':
                return (React.createElement(VorlageUebermitteln_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Daten zum Kalibrierschein übermitteln", text: 'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.', uploadText: 'Bitte verwenden Sie dieses Aktenzeichen für das Stückprüfungsprotokoll.', vorgangAbschliessen: true }));
            case 'sep_kalibrierung_extern':
                return (React.createElement("div", null,
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Kalibrierschein (Extern)", dokumentTitel: "Kalibrierschein (Extern)", text: "Für den Nachweis einer gültigen Kalibrierung können Sie hier einen extern erzeugten Kalibrierschein hochladen (Über \x22Datei auswählen\x22 oder per Drag&Drop)." })));
            case 'ses_auswertung_messwerte':
                return React.createElement(SesAuswertungFlaechenRili2014_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgangguid, onTriggerDocumentRefresh: handleDocumentRefresh, editable: true });
            // @todo: In Vorlagensystem einbetten!
            case 'ses_auswertung_messwerte_rili_2018':
                return React.createElement(SesAuswertungFlaechenRili2018_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgangguid, onTriggerDocumentRefresh: handleDocumentRefresh, editable: true });
            case 'ses_auswertung_messwerte_rili_2018_2025':
                return React.createElement(SesAuswertungFlaechenRili2025_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgangguid, onTriggerDocumentRefresh: handleDocumentRefresh, editable: true });
            case 'ses_uebernahme_messwerte':
                return React.createElement(SesUebernahmeMesswerte_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgangguid });
            case 'ses_angebotserstellung':
            case 'sep_angebotserstellung_luxemburg':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Auftraggeber }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragserteilung", dokumentTitel: "Auftragserteilung" }),
                    React.createElement(ErteilungAngebot_1.default, { auftragId: auftragId })));
            case 'ses_auftragsbestaetigung':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Beauftragter }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, text: "Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen.", zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragsbestätigung", dokumentTitel: "Auftragsbestätigung", text: "Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Vermessung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)." })));
            case 'sep_auftragsbestaetigung_luxemburg':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Beauftragter }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, text: "Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen.", zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragsbestätigung", dokumentTitel: "Auftragsbestätigung", text: "Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Kalibrierung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)." })));
            case 'ses_foto_dokumentation':
                return (React.createElement("div", null,
                    React.createElement(FotoUpload_1.default, { vorgangId: vorgangguid, kategorien: ['Gerät', 'Fläche', 'Sonstiges'] }),
                    React.createElement(VorgangStatus_1.default, { auftragId: auftragId, vorgangId: vorgangguid, status: "abgeschl", caption: "Fotodokumentation abschließen", text: "Markiert die Fotodokumentation des Systems als abgeschlossen, ein Hochladen von weiteren Fotos ist danach nicht mehr möglich.", buttonCaption: "Abschließen", bsStyle: "success" })));
            // Dienstleistungsnachweis zur Rechnungserstellung
            case 'agt_nachweis_sammel_dienstleistung':
            case 'bps_nachweis_sammel_dienstleistung':
            case 'ses_nachweis_sammel_dienstleistung':
            case 'labor_nachweis_sammel_dienstleistung':
                return (React.createElement("div", null,
                    React.createElement(DienstleistungsnachweisSammelrechnung_1.default, { vorgangId: vorgangguid, onTriggerDocumentRefresh: handleDocumentRefresh })));
            case 'ses_nachweis_dienstleistung':
            case 'sep_nachweis_dienstleistung_luxemburg':
            case 'agt_nachweis_dienstleistung':
            case 'bps_nachweis_dienstleistung':
            case 'labor_nachweis_dienstleistung':
                return (React.createElement("div", null,
                    React.createElement(Dienstleistungsnachweis_1.default, { vorgangId: vorgangguid, onTriggerDocumentRefresh: handleDocumentRefresh })));
            // Kalibrierung Abgasmessgeräte
            case 'agt_4gas_kalibrierschein':
            case 'dakks_agt_4gas_kalibrierschein':
            case 'agt_opazimeter_kalibrierschein':
            case 'dakks_agt_opazimeter_kalibrierschein':
            case 'dakks_agt_partikelzaehler_kalibrierschein':
                return (React.createElement(VorlageUebermitteln_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Daten zum Kalibrierschein übermitteln", text: 'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.', uploadText: 'Bitte verwenden Sie dieses Aktenzeichen für das Stückprüfungsprotokoll.', vorgangAbschliessen: true }));
            case 'agt_angebotserstellung':
            case 'agt_angebotserstellung_luxemburg':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Auftraggeber }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, titel: "Angebotsvorlage erzeugen", text: "Erzeugt eine vorausgefüllte Angebotsvorlage für die Vor-Ort Kalibrierung eines Abgasmessgerätes inkl. Auftragserteilung.", zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragserteilung", dokumentTitel: "Auftragserteilung" }),
                    React.createElement(ErteilungAngebot_1.default, { auftragId: auftragId })));
            case 'agt_auftragsbestaetigung':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Beauftragter }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, text: "Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen.", zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragsbestätigung", dokumentTitel: "Auftragsbestätigung", text: "Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Vermessung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)." })));
            case 'agt_foto_dokumentation':
                return (React.createElement("div", null,
                    React.createElement(FotoUpload_1.default, { vorgangId: vorgangguid, kategorien: ['Gerät', 'Typschild', 'Sonstiges'] }),
                    React.createElement(VorgangStatus_1.default, { auftragId: auftragId, vorgangId: vorgangguid, status: "abgeschl", caption: "Fotodokumentation abschließen", text: "Markiert die Fotodokumentation des Gerätes als abgeschlossen, ein Hochladen von weiteren Fotos ist danach nicht mehr möglich.", buttonCaption: "Abschließen", bsStyle: "success" })));
            // Kalibrierung Bremsenprüfstände (DAkkS)
            case 'bps_referenzkraft_kalibrierschein':
            case 'bps_referenzkraft_kalibrierschein_rili_2021':
            case 'bps_referenzkraft_kalibrierschein_platte_rili_2021':
                return (React.createElement(VorlageUebermitteln_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Daten zum Kalibrierschein übermitteln", text: 'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.', vorgangAbschliessen: true }));
            // Kalibrierung Druckmessgeräte (DMG)
            case 'dmg_handpumpe_kalibrierschein':
                return (React.createElement(VorlageUebermitteln_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, auftragId: this.props.vorgang.anr, titel: "Daten zum Kalibrierschein übermitteln", text: 'Übermittelt die gespeicherten Daten als vorläufigen Kalibrierschein an die DIQ Zert.<br/> \
            <b>Der Vorgang wird durch diese Aktion abgeschlossen.</b> Änderungen der Daten sind erst nach Freischaltung wieder möglich.', vorgangAbschliessen: true }));
            // Angebot Bremsprüfstand
            case 'bps_angebotserstellung':
            case 'bps_angebotserstellung_luxemburg':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Auftraggeber }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragserteilung", dokumentTitel: "Auftragserteilung" }),
                    React.createElement(ErteilungAngebot_1.default, { auftragId: auftragId })));
            case 'bps_auftragsbestaetigung':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Beauftragter }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, text: "Erzeugt eine vorausgefüllte Vorlage für die Auftragsbestätigung im Word-Format.\ Passen Sie diese ggf. an und lassen Sie sie dem Auftraggeber als Bestätigung zukommen.", zeigeCaption: false }),
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, dokumentenBezeichnung: "Auftragsbestätigung", dokumentTitel: "Auftragsbestätigung", text: "Laden Sie hier die unterschriebene Auftragsbestätigung als Nachweis über die Terminierung der Vermessung hoch (Über \x22Datei auswählen\x22 oder per Drag&Drop)." })));
            // Allgemeine Kalibrierung
            case 'kal_auftragsbestätigung':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Auftraggeber }),
                    React.createElement(MailVorlage_1.default, { caption: "Versand der Auftragsbestätigung", text: "Erzeugt eine vorausgefüllte Mailvorlage zum Versand der Auftragsbestägigung an den Auftraggeber.", vorlage: MailVorlage_2.MailVorlageArt.Auftragsbestätigung }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, text: "Erzeugt eine vorausgefüllte Vorlage im Word-Format.\ Diese kann vor der Übermittlung an den Kunden oder Auftraggeber angepasst werden.", zeigeCaption: false })));
            case 'kal_lieferschein':
                return (React.createElement("div", null,
                    React.createElement("h3", null,
                        React.createElement("a", { name: "#dokumente" }),
                        "Dokumente erzeugen"),
                    React.createElement(VorgangAuftragAdresse_1.default, { adressArt: ApiTypes.AdressArt.Lieferadresse }),
                    React.createElement(VorlageErzeugen_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, onTriggerDocumentRefresh: handleDocumentRefresh, text: "Erzeugt eine vorausgefüllte Vorlage im Word-Format.\ Diese kann vor der Übermittlung an den Kunden oder Auftraggeber angepasst werden.", zeigeCaption: false })));
            // Freier Upload Anzahl beliebiger Dokumente, z.B. für interne Workflows
            case 'dokumenten_upload':
                return (React.createElement("div", null,
                    React.createElement(VorlageUpload_1.default, { vorgangId: vorgangguid, vorlage: vorlagenTyp, text: 'Klicken Sie auf \"Datei auswählen\" oder ziehen Sie das hochzuladende Dokument per Drag&Drop auf diese Fläche.', dokumentenBezeichnung: "Dokument", abschliessen: false })));
            default:
                return React.createElement("div", null);
        }
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], VorlagenBereich.prototype, "messwerteVorhanden", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], VorlagenBereich.prototype, "abfrageStatus", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], VorlagenBereich.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], VorlagenBereich.prototype, "setMesswerteVorhanden", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VorlagenBereich.prototype, "setAbfrageStatus", null);
    VorlagenBereich = __decorate([
        mobx_react_1.observer
    ], VorlagenBereich);
    return VorlagenBereich;
}(React.Component));
exports.default = VorlagenBereich;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var SesAuswertungFlaechenRili2025_1 = __webpack_require__(279);
var SesAuswertungFlaechenRili2018_1 = __webpack_require__(278);
var SesAuswertungFlaechenRili2014_1 = __webpack_require__(277);
var VorgangStore_1 = __webpack_require__(22);
var decorators_1 = __webpack_require__(1);
var VorlagenBereichReadOnly = (function (_super) {
    __extends(VorlagenBereichReadOnly, _super);
    function VorlagenBereichReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VorlagenBereichReadOnly.prototype.render = function () {
        var _a = this.props, vorlagenTyp = _a.vorlagenTyp, vorgang = _a.vorgang;
        switch (vorlagenTyp) {
            case 'ses_auswertung_messwerte':
                return React.createElement(SesAuswertungFlaechenRili2014_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgang.vorgangguid, editable: false });
            case 'ses_auswertung_messwerte_rili_2018':
                return React.createElement(SesAuswertungFlaechenRili2018_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgang.vorgangguid, editable: false });
            case 'ses_auswertung_messwerte_rili_2018_2025':
                return React.createElement(SesAuswertungFlaechenRili2025_1.default, { auftragId: this.props.vorgang.anr, vorgangId: vorgang.vorgangguid, editable: false });
            default:
                return React.createElement("div", null);
        }
    };
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], VorlagenBereichReadOnly.prototype, "vorgangStore", void 0);
    VorlagenBereichReadOnly = __decorate([
        mobx_react_1.observer
    ], VorlagenBereichReadOnly);
    return VorlagenBereichReadOnly;
}(React.Component));
exports.default = VorlagenBereichReadOnly;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var Callout_1 = __webpack_require__(16);
var FaIcon_1 = __webpack_require__(20);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var AuftragStore_1 = __webpack_require__(25);
var Rechnungsposition_1 = __webpack_require__(274);
var DienstleistungsUebersicht_1 = __webpack_require__(273);
var Dienstleistungsnachweis = (function (_super) {
    __extends(Dienstleistungsnachweis, _super);
    function Dienstleistungsnachweis() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dokumentStatus = 'nichtVorhanden';
        _this.gewaehltePositionen = [];
        _this.mailRechnung = '';
        _this.rechnungVersandArt = 'digital';
        return _this;
    }
    Dienstleistungsnachweis.prototype.componentDidMount = function () {
        this.loadDienstleistungsnachweis();
        if (this.auftragStore.auftrag && this.auftragStore.auftrag.auftraggeber_email2) {
            this.setMailRechnung(this.auftragStore.auftrag.auftraggeber_email2);
        }
    };
    Dienstleistungsnachweis.prototype.loadDienstleistungsnachweis = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dienstleistung, rechnungspositionen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dienstleistung = '';
                        if (this.vorgangStore.vorgang) {
                            dienstleistung = this.vorgangStore.vorgang.kuerzel_dienstleistung;
                        }
                        return [4 /*yield*/, this.apiStore.rechnungspositionenDienstleistung(dienstleistung)];
                    case 1:
                        rechnungspositionen = _a.sent();
                        if (rechnungspositionen.ok) {
                            this.setRechnungspositionen(rechnungspositionen.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Dienstleistungsnachweis.prototype.setzeDokumentStatus = function (status) {
        this.dokumentStatus = status;
    };
    Dienstleistungsnachweis.prototype.setRechnungspositionen = function (rechnungspositionen) {
        this.vorhandenePositionen = rechnungspositionen;
    };
    Dienstleistungsnachweis.prototype.setMailRechnung = function (mail) {
        this.mailRechnung = mail;
    };
    Dienstleistungsnachweis.prototype.handleMailRechnungChanged = function (event) {
        this.mailRechnung = event.target.value;
    };
    Dienstleistungsnachweis.prototype.handleMailRechnungAusAuftraggeber = function (event) {
        if (this.auftragStore.auftrag && this.auftragStore.auftrag.auftraggeber_email) {
            this.setMailRechnung(this.auftragStore.auftrag.auftraggeber_email);
        }
    };
    Dienstleistungsnachweis.prototype.handleRechnungVersandArtChanged = function (event) {
        if (event.target.value === 'digital') {
            this.rechnungVersandArt = 'digital';
        }
        if (event.target.value === 'post') {
            this.rechnungVersandArt = 'post';
        }
    };
    Object.defineProperty(Dienstleistungsnachweis.prototype, "eingabenVollstaendig", {
        get: function () {
            var vollstaendig = this.gewaehltePositionen.length > 0;
            if (this.rechnungVersandArt === 'digital' && this.mailRechnung.trim() === '') {
                vollstaendig = false;
            }
            return vollstaendig;
        },
        enumerable: true,
        configurable: true
    });
    Dienstleistungsnachweis.prototype.rechnungErzeugen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setzeDokumentStatus('angefordert');
                        // TODO: Anzahl direkt setzen
                        // TODO: Unschöner Code, Kategorie + Sortierung u.U. nicht eindeutig
                        this.vorhandenePositionen.forEach(function (position) { return position.anzahl = _this.gewaehltePositionen.filter(function (el) { return el.kuerzel_dienstleistung === position.kuerzel_dienstleistung && el.sortierung === position.sortierung; }).length; });
                        return [4 /*yield*/, this.apiStore.rechnungErzeugen(this.props.vorgangId, this.vorhandenePositionen, this.mailRechnung, this.rechnungVersandArt === 'post')];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (this.props.onTriggerDocumentRefresh) {
                                this.props.onTriggerDocumentRefresh();
                            }
                            this.vorgangStore.loadVorgang(this.props.vorgangId);
                            this.setzeDokumentStatus('erzeugt');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Dienstleistungsnachweis.prototype.setAnzahlHandler = function (anzahl, position) {
        // Alle bestehenden Einträge der geänderten Position entfernen...
        this.gewaehltePositionen = this.gewaehltePositionen.filter(function (element) { return element.bezeichnung !== position.bezeichnung; });
        // und die neue Position so oft wie gefordert hinzufügen.
        var neuePositionen = [];
        for (var i = 0; i < anzahl; ++i) {
            neuePositionen.push(position);
        }
        this.gewaehltePositionen = this.gewaehltePositionen.concat(neuePositionen);
    };
    /** Zeigt den Übermittlungsbereich mit Hinweis zu ggf. noch zu erfassenden Daten an */
    Dienstleistungsnachweis.prototype.renderUebermittlung = function () {
        if (!this.eingabenVollstaendig) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("h4", null, "Daten unvollst\u00E4ndig"),
                React.createElement("div", null,
                    "Es wurden noch nicht alle erforderlichen Daten gew\u00E4hlt ausgef\u00FCllt:",
                    React.createElement("ul", null,
                        this.gewaehltePositionen.length === 0 && React.createElement("li", null, "Rechnungspositionen"),
                        this.rechnungVersandArt === 'digital' && this.mailRechnung.trim() === '' && React.createElement("li", null, "E-Mail Adresse f\u00FCr digitalen Rechnungsempfang")))));
        }
        return (React.createElement(Callout_1.default, { bsStyle: "warning" },
            React.createElement("h4", null, "Auswahl best\u00E4tigen"),
            React.createElement("p", null,
                "\u00DCbermittelt die ausgew\u00E4hlten Positionen. Der Vorgang wird dadurch abgeschlossen, ",
                React.createElement("b", null, "eine nachtr\u00E4gliche Korrektur ist nicht mehr m\u00F6glich!")),
            React.createElement("div", null,
                this.dokumentStatus === 'nichtVorhanden' && (React.createElement("div", { className: "text-right" },
                    React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", onClick: this.rechnungErzeugen, disabled: this.gewaehltePositionen.length === 0 }, "Best\u00E4tigen"))),
                this.dokumentStatus === 'angefordert' && React.createElement("p", null, "Die Daten werden \u00FCbermittelt..."))));
    };
    Dienstleistungsnachweis.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement(Callout_1.default, { bsStyle: "success" },
                React.createElement("p", null, "Bitte w\u00E4hlen Sie hier die Dienstleistungen aus die Sie in diesem Auftrag erbracht haben."),
                React.createElement("p", null, "Nach abschliessender Pr\u00FCfung des Auftrags erstellt die DIQ Zert GmbH dann:"),
                React.createElement("ul", null,
                    React.createElement("li", null, "Eine Rechnung die an den Auftraggeber \u00FCbermittelt wird"),
                    React.createElement("li", null, "Eine Gutschrift die an Sie \u00FCbermittelt wird")),
                React.createElement("p", null,
                    "Es gelten dabei die ",
                    React.createElement("a", { href: "https://diq-zert.de/de/agb/" }, "Allgemeinen Gesch\u00E4ftsbedingungen der DIQ Zert GmbH (AGB)"),
                    ".")),
            React.createElement(DienstleistungsUebersicht_1.default, { auftrag: this.auftragStore.auftrag }),
            React.createElement("h3", null, "Rechnungsversand"),
            React.createElement("p", null, "Hier k\u00F6nnen Sie angeben, wie die Rechnung durch die DIQ Zert an den Auftraggeber \u00FCbermittelt werden soll. Der digtiale Rechnungsversand ist zu bevorzugen."),
            React.createElement(react_bootstrap_1.Form, { horizontal: true },
                React.createElement(react_bootstrap_1.FormGroup, null,
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Rechnungsversand"),
                    React.createElement(react_bootstrap_1.Col, { sm: 6 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: this.rechnungVersandArt, onChange: this.handleRechnungVersandArtChanged },
                            React.createElement("option", { value: "digital" }, " Digital (per Mail)"),
                            React.createElement("option", { value: "post" }, "Per Post (an Adress des Auftraggebers)")))),
                this.rechnungVersandArt === 'digital' &&
                    React.createElement(react_bootstrap_1.FormGroup, { validationState: this.mailRechnung === '' ? 'error' : undefined },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "E-Mail Empf\u00E4nger"),
                        React.createElement(react_bootstrap_1.Col, { sm: 6 },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "text", label: "rechnungmail", value: this.mailRechnung || '', onChange: this.handleMailRechnungChanged }),
                                React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus'], placement: "bottom", overlay: React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" }, "\u00DCbernimmt die E-Mail aus der Adresse des Auftraggebers") },
                                    React.createElement(react_bootstrap_1.InputGroup.Button, null,
                                        React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: "btn-group", onClick: this.handleMailRechnungAusAuftraggeber },
                                            React.createElement(FaIcon_1.default, { icon: "files-o" })))))))),
            React.createElement("h3", null, "Auswahl der Dienstleistungen"),
            !this.vorhandenePositionen ?
                React.createElement("div", null, "lade Positionen...") :
                React.createElement("div", { className: "dienstleistungsnachweis" },
                    React.createElement(react_bootstrap_1.Table, { striped: true, bordered: false, condensed: true, hover: true, className: "dienstleistungsnachweis-eingabe" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Position"),
                                React.createElement("th", { className: "text-center" }, "Anzahl"),
                                React.createElement("th", { className: "text-right" }, "Preis"))),
                        React.createElement("tfoot", null,
                            React.createElement("tr", null,
                                React.createElement("td", null),
                                React.createElement("td", { className: "text-center" },
                                    React.createElement("b", null, "Summe")),
                                React.createElement("td", { className: "text-right" },
                                    React.createElement("b", null,
                                        this.gewaehltePositionen.reduce(function (a, b) { return a + b.preis; }, 0).toFixed(2).replace('.', ','),
                                        " \u20AC")))),
                        React.createElement("tbody", null, this.vorhandenePositionen.map(function (position, index) {
                            return React.createElement(Rechnungsposition_1.default, { key: index, position: position, anzahl: _this.gewaehltePositionen.filter(function (filterposition) { return (filterposition.bezeichnung === position.bezeichnung); }).length, setAnzahlHandler: _this.setAnzahlHandler, preiseAnzeigen: true });
                        })))),
            this.renderUebermittlung()));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Dienstleistungsnachweis.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], Dienstleistungsnachweis.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], Dienstleistungsnachweis.prototype, "auftragStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Dienstleistungsnachweis.prototype, "dokumentStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Dienstleistungsnachweis.prototype, "vorhandenePositionen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Dienstleistungsnachweis.prototype, "gewaehltePositionen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Dienstleistungsnachweis.prototype, "mailRechnung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Dienstleistungsnachweis.prototype, "rechnungVersandArt", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "setzeDokumentStatus", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "setRechnungspositionen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "setMailRechnung", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "handleMailRechnungChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "handleMailRechnungAusAuftraggeber", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "handleRechnungVersandArtChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Dienstleistungsnachweis.prototype, "eingabenVollstaendig", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], Dienstleistungsnachweis.prototype, "rechnungErzeugen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], Dienstleistungsnachweis.prototype, "setAnzahlHandler", null);
    Dienstleistungsnachweis = __decorate([
        mobx_react_1.observer
    ], Dienstleistungsnachweis);
    return Dienstleistungsnachweis;
}(React.Component));
exports.default = Dienstleistungsnachweis;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiTypes_1 = __webpack_require__(21);
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var Callout_1 = __webpack_require__(16);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var AuftragStore_1 = __webpack_require__(25);
var Rechnungsposition_1 = __webpack_require__(274);
var DienstleistungsUebersicht_1 = __webpack_require__(273);
/**
 * Komponente zur Auswahl der im Auftrag abzurechnenden Positionen als Basis für die Sammelabrechnung
 * Anders als beim normalen Dienstleistungsnachweis, wird dieser nur von bestimmten an die DIQ Zert angebundenen Nutzern verwendet
 * Die hier erfassten Daten bilden später die Grundlage für die z.B. monatliche
 */
var DienstleistungsnachweisSammelrechnung = (function (_super) {
    __extends(DienstleistungsnachweisSammelrechnung, _super);
    function DienstleistungsnachweisSammelrechnung() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dokumentStatus = ApiTypes_1.DokumentenStatus.NichtVorhanden;
        _this.gewaehltePositionen = [];
        return _this;
    }
    DienstleistungsnachweisSammelrechnung.prototype.componentDidMount = function () {
        this.loadDienstleistungsnachweis();
    };
    DienstleistungsnachweisSammelrechnung.prototype.loadDienstleistungsnachweis = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dienstleistung, rechnungspositionen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dienstleistung = '';
                        if (this.vorgangStore.vorgang) {
                            dienstleistung = this.vorgangStore.vorgang.kuerzel_dienstleistung;
                        }
                        return [4 /*yield*/, this.apiStore.rechnungspositionenDienstleistung(dienstleistung)];
                    case 1:
                        rechnungspositionen = _a.sent();
                        if (rechnungspositionen.ok) {
                            this.setRechnungspositionen(rechnungspositionen.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DienstleistungsnachweisSammelrechnung.prototype.setzeDokumentStatus = function (status) {
        this.dokumentStatus = status;
    };
    DienstleistungsnachweisSammelrechnung.prototype.setRechnungspositionen = function (rechnungspositionen) {
        this.vorhandenePositionen = rechnungspositionen;
    };
    DienstleistungsnachweisSammelrechnung.prototype.rechnungErzeugen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setzeDokumentStatus(ApiTypes_1.DokumentenStatus.Angefordert);
                        // TODO: Anzahl direkt setzen
                        // TODO: Unschöner Code, Kategorie + Sortierung u.U. nicht eindeutig
                        this.vorhandenePositionen.forEach(function (position) { return position.anzahl = _this.gewaehltePositionen.filter(function (el) { return el.kuerzel_dienstleistung === position.kuerzel_dienstleistung && el.sortierung === position.sortierung; }).length; });
                        return [4 /*yield*/, this.apiStore.sammelRechnungErzeugen(this.props.vorgangId, this.vorhandenePositionen)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (this.props.onTriggerDocumentRefresh) {
                                this.props.onTriggerDocumentRefresh();
                            }
                            this.vorgangStore.loadVorgang(this.props.vorgangId);
                            this.setzeDokumentStatus(ApiTypes_1.DokumentenStatus.Erzeugt);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DienstleistungsnachweisSammelrechnung.prototype.setAnzahlHandler = function (anzahl, position) {
        // Alle bestehenden Einträge der geänderten Position entfernen...
        this.gewaehltePositionen = this.gewaehltePositionen.filter(function (element) { return element.bezeichnung !== position.bezeichnung; });
        // und die neue Position so oft wie gefordert hinzufügen.
        var neuePositionen = [];
        for (var i = 0; i < anzahl; ++i) {
            neuePositionen.push(position);
        }
        this.gewaehltePositionen = this.gewaehltePositionen.concat(neuePositionen);
    };
    DienstleistungsnachweisSammelrechnung.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "maxwidth" },
            React.createElement(Callout_1.default, { bsStyle: "success" },
                React.createElement("p", null, "Bitte w\u00E4hlen Sie hier die Dienstleistungen aus die Sie in diesem Auftrag erbracht haben."),
                React.createElement("p", null, "Diese Auswahl ist Grundlage f\u00FCr die Erstellung einer Sammelrechnung durch die DIQ Zert GmbH"),
                React.createElement("p", null,
                    "Es gelten dabei die ",
                    React.createElement("a", { href: "https://diq-zert.de/de/agb/" }, "Allgemeinen Gesch\u00E4ftsbedingungen der DIQ Zert GmbH (AGB)"),
                    ".")),
            React.createElement(DienstleistungsUebersicht_1.default, { auftrag: this.auftragStore.auftrag }),
            React.createElement("h3", null, "Auswahl der Dienstleistungen"),
            !this.vorhandenePositionen ?
                React.createElement("div", null, "lade Positionen...") :
                React.createElement("div", { className: "dienstleistungsnachweis" },
                    React.createElement(react_bootstrap_1.Table, { striped: true, bordered: false, condensed: true, hover: true, className: "dienstleistungsnachweis-eingabe" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Position"),
                                React.createElement("th", { className: "text-center" }, "Anzahl"))),
                        React.createElement("tbody", null, this.vorhandenePositionen.map(function (position, index) {
                            return React.createElement(Rechnungsposition_1.default, { key: index, position: position, anzahl: _this.gewaehltePositionen.filter(function (filterposition) { return (filterposition.bezeichnung === position.bezeichnung); }).length, setAnzahlHandler: _this.setAnzahlHandler, preiseAnzeigen: false });
                        })))),
            React.createElement(Callout_1.default, { bsStyle: "warning" },
                React.createElement("h4", null, "Auswahl best\u00E4tigen"),
                React.createElement("p", null,
                    "\u00DCbermittelt die ausgew\u00E4hlten Positionen. Der Vorgang wird dadurch abgeschlossen, ",
                    React.createElement("b", null, "eine nachtr\u00E4gliche Korrektur ist nicht mehr m\u00F6glich!")),
                React.createElement("div", null,
                    this.dokumentStatus === ApiTypes_1.DokumentenStatus.NichtVorhanden && this.vorhandenePositionen && (React.createElement("div", { className: "text-right" },
                        React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", onClick: this.rechnungErzeugen, disabled: this.gewaehltePositionen.length === 0 }, "Best\u00E4tigen"))),
                    this.dokumentStatus === ApiTypes_1.DokumentenStatus.Angefordert && React.createElement("p", null, "Die Daten werden \u00FCbermittelt...")))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], DienstleistungsnachweisSammelrechnung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], DienstleistungsnachweisSammelrechnung.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], DienstleistungsnachweisSammelrechnung.prototype, "auftragStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], DienstleistungsnachweisSammelrechnung.prototype, "dokumentStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DienstleistungsnachweisSammelrechnung.prototype, "vorhandenePositionen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DienstleistungsnachweisSammelrechnung.prototype, "gewaehltePositionen", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], DienstleistungsnachweisSammelrechnung.prototype, "setzeDokumentStatus", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DienstleistungsnachweisSammelrechnung.prototype, "setRechnungspositionen", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], DienstleistungsnachweisSammelrechnung.prototype, "rechnungErzeugen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], DienstleistungsnachweisSammelrechnung.prototype, "setAnzahlHandler", null);
    DienstleistungsnachweisSammelrechnung = __decorate([
        mobx_react_1.observer
    ], DienstleistungsnachweisSammelrechnung);
    return DienstleistungsnachweisSammelrechnung;
}(React.Component));
exports.default = DienstleistungsnachweisSammelrechnung;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Kapselkomponemnte für Messwerteingabe der Kalibrierung eines 4-Gas Abgastesters
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var Agt4GasKalibrierungStore_1 = __webpack_require__(172);
var UiStore_1 = __webpack_require__(14);
var Agt4GasMessung_1 = __webpack_require__(645);
var Callout_1 = __webpack_require__(16);
var AgtPruefortParameter_1 = __webpack_require__(275);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_2 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var ApiTypes_1 = __webpack_require__(21);
var Agt4GasKalibrierung = (function (_super) {
    __extends(Agt4GasKalibrierung, _super);
    function Agt4GasKalibrierung(props) {
        var _this = _super.call(this, props) || this;
        // Datenübernahme aus dem im Auftrag gesetzten Opazimeter
        var kalGegenstand = _this.kalibrierungStore.getKalibrierGegenstand();
        if (kalGegenstand && (kalGegenstand.art === ApiTypes_1.AGT_4GAS || kalGegenstand.art === ApiTypes_1.AGT_KOMBI)) {
            _this.abgastester = kalGegenstand;
        }
        if (_this.props.value) {
            var obj = JSON.parse(_this.props.value);
            // Gespeicherte Optionen
            if (obj.optionen) {
                if (obj.optionen.justage) {
                    _this.kalibrierungStore.setJustage(obj.optionen.justage === 'on');
                }
                if (obj.optionen.messunsicherheitanwenden) {
                    _this.kalibrierungStore.setMessunsicherheitAnwenden(obj.optionen.messunsicherheitanwenden === 'on');
                }
                if (obj.optionen.genauigkeitsklasseueberschreiben) {
                    _this.kalibrierungStore.setGenauigkeitsklasseUeberschreiben(obj.optionen.genauigkeitsklasseueberschreiben === 'on');
                }
            }
        }
        _this.kalibrierungStore.setReadOnly(_this.props.editable ? !_this.props.editable : true);
        return _this;
    }
    Agt4GasKalibrierung.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var kalibrierGegenstand, objektVorlage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        kalibrierGegenstand = this.kalibrierungStore.getKalibrierGegenstand();
                        if (!kalibrierGegenstand) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.objektVorlage(kalibrierGegenstand.objektguid)];
                    case 1:
                        objektVorlage = _a.sent();
                        if (objektVorlage.ok) {
                            this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Agt4GasKalibrierung.prototype, "genauigkeitsklasseAGTGeraet", {
        /** Liefert die im AGT (als Objekt des Auftrags) hinterlegte Genauigkeitsklasse zurück */
        get: function () {
            var kalibrierGegenstand = this.kalibrierungStore.getKalibrierGegenstand();
            if (kalibrierGegenstand) {
                if (kalibrierGegenstand && kalibrierGegenstand.meta) {
                    var fehlergrenze = kalibrierGegenstand.meta.find(function (meta) { return meta.bezeichnung === 'agt_genauigkeitsklasse'; });
                    if (fehlergrenze) {
                        return fehlergrenze.inhalt;
                    }
                }
            }
            // Wenn keine Genauigkeitsklasse hinterlegt wurde (Objekt z.B. im QIT angelegt oder nachträglich verändert) maximale Genauigkeitsklasse zurückgeben
            return '00';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasKalibrierung.prototype, "genauigkeitsklasseAGT", {
        /** Die aktuelle Richtlinie erlaubt es, Geräte mit Genauigkeitsklasse 1 wie solche mit Klasse 0 zu behandeln, dies muss dann mit einbezogen werden */
        get: function () {
            var genauigkeitsKlasseBasis = this.genauigkeitsklasseAGTGeraet;
            if (genauigkeitsKlasseBasis === '1' && this.kalibrierungStore.genauigkeitsklasseUeberschreiben) {
                return '0';
            }
            return genauigkeitsKlasseBasis;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasKalibrierung.prototype, "formdataprefix", {
        /**
         * JSON-Key Prefix für an Back-End übergebene
         */
        get: function () {
            return this.props.kategorieguid + "[" + this.props.elementguid + "]";
        },
        enumerable: true,
        configurable: true
    });
    Agt4GasKalibrierung.prototype.handleMessunsicherheitAnwendenChange = function (ev) {
        this.kalibrierungStore.setMessunsicherheitAnwenden(ev.target.checked);
    };
    Agt4GasKalibrierung.prototype.handleJustageChange = function (ev) {
        this.kalibrierungStore.setJustage(ev.target.checked);
    };
    Agt4GasKalibrierung.prototype.handleGenauigkeitsklasseUeberschreibenChange = function (ev) {
        this.kalibrierungStore.setGenauigkeitsklasseUeberschreiben(ev.target.checked);
    };
    Agt4GasKalibrierung.prototype.renderMessReihe = function (nachJustage) {
        // Wenn bereits Werte erfasst wurden, in jeweiligen Komponenten übernehmen
        var messungen = undefined;
        if (this.props.value) {
            var obj = JSON.parse(this.props.value);
            if (nachJustage) {
                if (obj.nachjustage) {
                    messungen = obj.nachjustage.messungen;
                }
            }
            else {
                messungen = obj.messungen;
            }
        }
        var prefix = this.formdataprefix;
        if (nachJustage) {
            prefix = prefix + '[nachjustage]';
        }
        return (React.createElement("div", null,
            React.createElement(Agt4GasMessung_1.default, { pruefgasArt: Agt4GasMessung_1.PruefgasArt.O2, genauigkeitsklasse: this.genauigkeitsklasseAGT, formdataprefix: prefix + "[messungen][0]", value: messungen && messungen[0] ? JSON.stringify(messungen[0]) : undefined, nachjustage: nachJustage }),
            React.createElement(Agt4GasMessung_1.default, { pruefgasArt: Agt4GasMessung_1.PruefgasArt.A, genauigkeitsklasse: this.genauigkeitsklasseAGT, formdataprefix: prefix + "[messungen][1]", value: messungen && messungen[1] ? JSON.stringify(messungen[1]) : undefined, nachjustage: nachJustage }),
            React.createElement(Agt4GasMessung_1.default
            // Die für die zweite Messung zu verwendende Prüfgasart hängt von der Genauigkeitsklasse des AGTs ab
            // Bei 1 Prüfgas B
            // Bei 0 und 00 Prüfgas C
            , { 
                // Die für die zweite Messung zu verwendende Prüfgasart hängt von der Genauigkeitsklasse des AGTs ab
                // Bei 1 Prüfgas B
                // Bei 0 und 00 Prüfgas C
                pruefgasArt: this.genauigkeitsklasseAGT === '1' ? Agt4GasMessung_1.PruefgasArt.B : Agt4GasMessung_1.PruefgasArt.C, genauigkeitsklasse: this.genauigkeitsklasseAGT, formdataprefix: prefix + "[messungen][2]", value: messungen && messungen[2] ? JSON.stringify(messungen[2]) : undefined, nachjustage: nachJustage })));
    };
    Agt4GasKalibrierung.prototype.render = function () {
        // Wenn bereits Werte erfasst wurden, in jeweiligen Komponenten übernehmen
        var parameter = undefined;
        if (this.props.value) {
            var obj = JSON.parse(this.props.value);
            if (obj.parameter) {
                parameter = obj.parameter;
            }
        }
        return (React.createElement("div", null, this.abgastester !== undefined ?
            React.createElement("div", null,
                this.uiStore.userProfile && this.uiStore.userProfile.portaladmin &&
                    React.createElement(Callout_1.default, { bsStyle: "warning" },
                        React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_mu_anwenden", name: this.formdataprefix + "[optionen][messunsicherheitanwenden]", disabled: !this.props.editable, onChange: this.props.editable ? this.handleMessunsicherheitAnwendenChange : undefined, defaultChecked: this.kalibrierungStore.messunsicherheitAnwenden }, "Messunsicherheit f\u00FCr Berechnung Toleranzbereich nutzen"),
                        React.createElement("div", { className: "text-hint-light" },
                            React.createElement("b", null, "Hinweis:"),
                            " Diese Auswahl steht nur internen Nutzern zur Verf\u00FCgung.")),
                React.createElement(AgtPruefortParameter_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", formdataprefix: this.formdataprefix + "[parameter][0]", bereichLuftfeuchtigkeit: { min: 0, max: 85 }, bereichUmgebungsdruck: { min: 860, max: 1060 }, bereichLufttemperatur: { min: 10, max: 30 }, editable: this.props.editable, value: parameter && parameter[0] ? JSON.stringify(parameter[0]) : undefined }),
                this.genauigkeitsklasseAGTGeraet === '1' &&
                    React.createElement(Callout_1.default, { bsStyle: "warning" },
                        React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_genauigkeitsklasseueberschreiben", name: this.formdataprefix + "[optionen][genauigkeitsklasseueberschreiben]", disabled: !this.props.editable, onChange: this.props.editable ? this.handleGenauigkeitsklasseUeberschreibenChange : undefined, defaultChecked: this.kalibrierungStore.genauigkeitsklasseUeberschreiben }, "Wie Ger\u00E4t mit Genauigkeitsklasse 0 behandeln"),
                        React.createElement("div", { className: "text-hint-light" }, "Das Ger\u00E4t wird wie ein Ger\u00E4t der Genauigkeitsklasse 0 behandelt.")),
                this.renderMessReihe(false),
                React.createElement(Callout_1.default, { bsStyle: "default" },
                    React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_justage", name: this.formdataprefix + "[optionen][justage]", disabled: !this.props.editable, onChange: this.props.editable ? this.handleJustageChange : undefined, defaultChecked: this.kalibrierungStore.justage }, "Justage durchgef\u00FChrt"),
                    React.createElement("div", { className: "text-hint-light" }, "Zeigt eine zweite Messwerteingabe f\u00FCr die Erfassung der Daten nach Durchf\u00FChrung einer Justage an. Beim Erzeugen des Kalibrierscheins werden diese Messwerte \u00FCbernommen.")),
                this.kalibrierungStore.justage &&
                    this.renderMessReihe(true),
                React.createElement(AgtPruefortParameter_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", formdataprefix: this.formdataprefix + "[parameter][1]", bereichLuftfeuchtigkeit: { min: 0, max: 85 }, bereichUmgebungsdruck: { min: 860, max: 1060 }, bereichLufttemperatur: { min: 10, max: 30 }, editable: this.props.editable, value: parameter && parameter[1] ? JSON.stringify(parameter[1]) : undefined }))
            :
                React.createElement(Callout_1.default, { bsStyle: "danger" },
                    React.createElement("p", null, "F\u00FCr die Erstellung der Auswertung muss ein 4-Gas Tester oder Kombiger\u00E4t ausgew\u00E4hlt werden."))));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], Agt4GasKalibrierung.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], Agt4GasKalibrierung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore),
        __metadata("design:type", Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore)
    ], Agt4GasKalibrierung.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasKalibrierung.prototype, "genauigkeitsklasseAGTGeraet", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasKalibrierung.prototype, "genauigkeitsklasseAGT", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasKalibrierung.prototype, "formdataprefix", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierung.prototype, "handleMessunsicherheitAnwendenChange", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierung.prototype, "handleJustageChange", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasKalibrierung.prototype, "handleGenauigkeitsklasseUeberschreibenChange", null);
    Agt4GasKalibrierung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Agt4GasKalibrierung);
    return Agt4GasKalibrierung;
}(React.Component));
exports.default = Agt4GasKalibrierung;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Messwerteingabe für die Kalibrierung eines 4-Gas Abgastesters
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_2 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var Agt4GasKalibrierungStore_1 = __webpack_require__(172);
var Agt4GasMessungKomponente_1 = __webpack_require__(646);
var PruefgasArt;
(function (PruefgasArt) {
    PruefgasArt["A"] = "AGT_GEMISCH_A";
    PruefgasArt["B"] = "AGT_GEMISCH_B";
    PruefgasArt["C"] = "AGT_GEMISCH_C";
    PruefgasArt["O2"] = "AGT_GEMISCH_O2";
})(PruefgasArt = exports.PruefgasArt || (exports.PruefgasArt = {}));
var Agt4GasHintIcon = (function (_super) {
    __extends(Agt4GasHintIcon, _super);
    function Agt4GasHintIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Agt4GasHintIcon.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus', 'click'], placement: "bottom", overlay: React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" }, this.props.hint) },
            React.createElement("div", null,
                React.createElement(react_bootstrap_1.Glyphicon, { glyph: "question-sign", width: "36px", height: "36px", style: { verticalAlign: 'bottom' } }))));
    };
    return Agt4GasHintIcon;
}(React.Component));
var Agt4GasRadioGroup = (function (_super) {
    __extends(Agt4GasRadioGroup, _super);
    function Agt4GasRadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.checked = _this.props.checked;
        return _this;
    }
    Agt4GasRadioGroup.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: "radio radio-success radio-inline" },
                React.createElement("input", { type: "radio", name: this.props.name, id: "1_" + this.props.name, checked: this.props.checked, disabled: this.kalibrierungStore.readOnly, onChange: function (e) { _this.props.onHandleChange(1); }, value: "on" }),
                React.createElement("label", { htmlFor: "1_" + this.props.name }, "in Ordnung")),
            React.createElement("div", { className: "radio radio radio-inline" },
                React.createElement("input", { type: "radio", name: this.props.name, id: "0_" + this.props.name, checked: !this.props.checked, disabled: this.kalibrierungStore.readOnly, onChange: function (e) { _this.props.onHandleChange(0); }, value: "off" }),
                React.createElement("label", { htmlFor: "0_" + this.props.name }, "nicht in Ordnung"))));
    };
    __decorate([
        decorators_2.inject(Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore),
        __metadata("design:type", Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore)
    ], Agt4GasRadioGroup.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasRadioGroup.prototype, "checked", void 0);
    Agt4GasRadioGroup = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Agt4GasRadioGroup);
    return Agt4GasRadioGroup;
}(React.Component));
var Agt4GasMessung = (function (_super) {
    __extends(Agt4GasMessung, _super);
    function Agt4GasMessung(props) {
        var _this = _super.call(this, props) || this;
        _this.validationstate = 'error';
        _this.propanhexanfaktor = undefined;
        _this.propanwertverwenden = false;
        _this.arbeitsmittel = undefined;
        _this.ansprechzeitO2 = false;
        _this.ansprechzeitCO = false;
        _this.handleAnsprechzeitO2Changed = function (value) {
            _this.ansprechzeitO2 = (value === 1);
        };
        // @bind @action handleAnsprechzeitCOChanged(value: number) {
        _this.handleAnsprechzeitCOChanged = function (value) {
            _this.ansprechzeitCO = (value === 1);
        };
        // Vorhandene Werte übernehmen
        if (props.value) {
            var obj = JSON.parse(props.value);
            if (obj.pef) {
                _this.propanhexanfaktor = obj.pef;
            }
            if (obj.propanwertverwenden) {
                _this.propanwertverwenden = obj.propanwertverwenden === 'on';
            }
            if (obj.ansprechzeito2) {
                _this.ansprechzeitO2 = obj.ansprechzeito2 === 'on';
            }
            if (obj.ansprechzeitco) {
                _this.ansprechzeitCO = obj.ansprechzeitco === 'on';
            }
            if (obj.arbeitsmittel) {
                if (obj.arbeitsmittel) {
                    _this.setGespeichertesArbeitsmittel(obj.arbeitsmittel.guid);
                }
            }
        }
        return _this;
    }
    Agt4GasMessung.prototype.pruefgasKuerzel = function (art) {
        switch (art) {
            case PruefgasArt.A:
                return 'A';
            case PruefgasArt.B:
                return 'B';
            case PruefgasArt.C:
                return 'C';
            case PruefgasArt.O2:
                return 'O\u2082';
            default:
                return '';
        }
    };
    Object.defineProperty(Agt4GasMessung.prototype, "titel", {
        get: function () {
            var text = 'Messung mit Prüfgas ' + this.pruefgasKuerzel(this.props.pruefgasArt);
            if (this.props.nachjustage) {
                text += ' nach Justage';
            }
            return text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasMessung.prototype, "formdataName", {
        get: function () {
            return "" + this.props.formdataprefix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasMessung.prototype, "eingabePEF", {
        /**
         * Gibt an, ob die Eingabe des Propan/Hexan-Faktors anhand der gesetzten Prüfgasarten notwendig ist
         * @returns true wenn die Eingabe des PEFs notwendig ist
         */
        get: function () {
            return this.props.pruefgasArt !== PruefgasArt.O2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasMessung.prototype, "eingabeAnsprechzeiten", {
        /**
         * Gibt an, ob die Angabe der Ansprechzeiten für O2 und CO bei einer der gesetzten Prüfgasarten notwendig ist
         * @returns true wenn die Angabe notwendig ist
         */
        get: function () {
            return this.props.pruefgasArt === PruefgasArt.A;
        },
        enumerable: true,
        configurable: true
    });
    Agt4GasMessung.prototype.setArbeitsmittel = function (arbeitsmittel) {
        this.arbeitsmittel = arbeitsmittel;
    };
    Agt4GasMessung.prototype.setGespeichertesArbeitsmittel = function (arbeitsmittelguid) {
        this.gespeichertesArbeitsmittel = arbeitsmittelguid;
        if (arbeitsmittelguid) {
            // Gespeichertes Arbeitsmittel im aktuellen Vorgang suchen und als Interface in Auswertung übernehmen
            if (this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
                var arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.find(function (am) { return (am.arbeitsmittelguid === arbeitsmittelguid); });
                if (arbeitsmittel) {
                    this.setArbeitsmittel(arbeitsmittel);
                }
            }
        }
    };
    Agt4GasMessung.prototype.handlePEFChange = function (ev) {
        this.propanhexanfaktor = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    Agt4GasMessung.prototype.handlePropanUmrechnungChange = function (ev) {
        this.propanwertverwenden = ev.target.checked;
    };
    Agt4GasMessung.prototype.handleArbeitsmittelChanged = function (ev) {
        var arbeitsmittelguid = ev.target.value !== '' ? ev.target.value : undefined;
        if (arbeitsmittelguid && this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
            var arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.find(function (am) { return am.arbeitsmittelguid === arbeitsmittelguid; });
            this.setArbeitsmittel(arbeitsmittel);
        }
        else {
            this.setArbeitsmittel(undefined);
        }
    };
    Agt4GasMessung.prototype.renderArbeitsmittelAuswahl = function () {
        var _this = this;
        var arbeitsmittel = [];
        // Zur Art des Prüfgases der Komponente passenden Arbeitsmittel aus aktuell gewähltem Set ermitteln
        if (this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
            arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.filter(function (am) {
                if (_this.props.pruefgasArt === am.typ) {
                    return true;
                }
                return false;
            });
            return (React.createElement("div", null,
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.arbeitsmittel !== undefined ? undefined : 'error', controlId: "Verwendetes Prüfgas" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Verwendetes Pr\u00FCfgas"),
                    React.createElement(react_bootstrap_1.Col, { sm: 8 },
                        !this.kalibrierungStore.readOnly ?
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleArbeitsmittelChanged, defaultValue: this.gespeichertesArbeitsmittel, name: this.formdataName + "[arbeitsmittel][guid]" },
                                React.createElement("option", { value: undefined }),
                                arbeitsmittel.map(function (am) { return React.createElement("option", { key: am.arbeitsmittelguid, value: am.arbeitsmittelguid },
                                    am.name,
                                    " (",
                                    am.arbeitsmittelnr,
                                    ")"); }))
                            :
                                React.createElement(react_bootstrap_1.FormControl, { type: "text", value: this.arbeitsmittel && this.arbeitsmittel.name + " (" + this.arbeitsmittel.arbeitsmittelnr + ")", readOnly: true, disabled: true }),
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[arbeitsmittel][nr]", value: this.arbeitsmittel ? this.arbeitsmittel.arbeitsmittelnr : '' }),
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[arbeitsmittel][name]", value: this.arbeitsmittel ? this.arbeitsmittel.name : '' })))));
        }
        return (React.createElement("div", null, "Keine Arbeitsmittel im Vorgang hinterlegt!!!"));
    };
    Agt4GasMessung.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.titel, collapsible: true, defaultExpanded: true },
            this.renderArbeitsmittelAuswahl(),
            this.eingabePEF && (React.createElement(react_bootstrap_1.FormGroup, { validationState: this.propanhexanfaktor !== undefined ? undefined : 'error', controlId: "Propan/Hexanfaktor" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Propan/Hexanfaktor"),
                React.createElement(react_bootstrap_1.Col, { sm: 4 }, !this.kalibrierungStore.readOnly ?
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", value: this.propanhexanfaktor, name: this.formdataName + "[pef]", onChange: this.handlePEFChange })
                    :
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", value: this.propanhexanfaktor, readOnly: true, disabled: true })),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.Checkbox, { inline: true, name: this.formdataName + "[propanwertverwenden]", disabled: this.kalibrierungStore.readOnly, onChange: !this.kalibrierungStore.readOnly ? this.handlePropanUmrechnungChange : undefined, defaultChecked: this.propanwertverwenden }, "Propanwert berechnen")))),
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "agt-auswertung", style: { maxWidth: '80%', margin: 'auto', marginBottom: '20px' } },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Sollwert"),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Toleranzbereich"))),
                React.createElement("tbody", null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[messunsicherheitanwenden]", value: this.kalibrierungStore.messunsicherheitAnwenden ? 'true' : 'false' }),
                    this.props.pruefgasArt !== PruefgasArt.O2 &&
                        React.createElement(Agt4GasMessungKomponente_1.default, { genauigkeitsklasse: this.props.genauigkeitsklasse, beschriftung: "CO", einheit: "%vol", bezeichner: "komponente_co", propanwertverwenden: this.propanwertverwenden, propanhexanfaktor: this.propanhexanfaktor, formdataprefix: this.props.formdataprefix + "[co]", value: this.props.value, arbeitsmittel: this.arbeitsmittel }),
                    this.props.pruefgasArt !== PruefgasArt.O2 &&
                        React.createElement(Agt4GasMessungKomponente_1.default, { genauigkeitsklasse: this.props.genauigkeitsklasse, beschriftung: "CO\u2082", einheit: "%vol", bezeichner: "komponente_co2", propanwertverwenden: this.propanwertverwenden, propanhexanfaktor: this.propanhexanfaktor, formdataprefix: this.props.formdataprefix + "[co2]", value: this.props.value, arbeitsmittel: this.arbeitsmittel }),
                    this.props.pruefgasArt !== PruefgasArt.O2 &&
                        React.createElement(Agt4GasMessungKomponente_1.default, { genauigkeitsklasse: this.props.genauigkeitsklasse, beschriftung: "HC", einheit: "ppm vol", bezeichner: "komponente_hc", propanwertverwenden: this.propanwertverwenden, propanhexanfaktor: this.propanhexanfaktor, formdataprefix: this.props.formdataprefix + "[hc]", value: this.props.value, arbeitsmittel: this.arbeitsmittel }),
                    React.createElement(Agt4GasMessungKomponente_1.default, { genauigkeitsklasse: this.props.genauigkeitsklasse, beschriftung: "O\u2082", einheit: "%vol", bezeichner: "komponente_o2", 
                        // @TODO: Für O2 eigentlich nicht nötig, evtl. als optionale Props deklarieren
                        propanwertverwenden: this.propanwertverwenden, propanhexanfaktor: this.propanhexanfaktor, formdataprefix: this.props.formdataprefix + "[o2]", value: this.props.value, arbeitsmittel: this.arbeitsmittel }))),
            this.eingabeAnsprechzeiten &&
                React.createElement("div", null,
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: "ansprechzeitO2" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 },
                            "O",
                            React.createElement("sub", null, "2"),
                            "-Ansprechzeit"),
                        React.createElement(react_bootstrap_1.Col, { sm: 8 },
                            React.createElement(Agt4GasRadioGroup, { name: this.formdataName + "[ansprechzeito2]", checked: this.ansprechzeitO2, onHandleChange: this.handleAnsprechzeitO2Changed })),
                        React.createElement(react_bootstrap_1.Col, { sm: 1 },
                            React.createElement(Agt4GasHintIcon, { hint: "Beim Wechsel von 20,9 %vol auf 0 %vol O2 in 60 Sekunden einen Wert von weniger als 0,1 %vol anzeigen." }))),
                    React.createElement(react_bootstrap_1.FormGroup, { controlId: "ansprechZeitCO" },
                        React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "CO-Ansprechzeit"),
                        React.createElement(react_bootstrap_1.Col, { sm: 8 },
                            React.createElement(Agt4GasRadioGroup, { name: this.formdataName + "[ansprechzeitco]", checked: this.ansprechzeitCO, onHandleChange: this.handleAnsprechzeitCOChanged })),
                        React.createElement(react_bootstrap_1.Col, { sm: 1 },
                            React.createElement(Agt4GasHintIcon, { hint: "Beim Einleiten eines CO-haltigen Gases muss der CO-Wert auf mind. 95 % des Endwertes innerhalb von 15 Sekunden ansteigen." }))))));
    };
    __decorate([
        decorators_2.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], Agt4GasMessung.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_2.inject(Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore),
        __metadata("design:type", Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore)
    ], Agt4GasMessung.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasMessung.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasMessung.prototype, "propanhexanfaktor", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasMessung.prototype, "propanwertverwenden", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasMessung.prototype, "arbeitsmittel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasMessung.prototype, "gespeichertesArbeitsmittel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasMessung.prototype, "ansprechzeitO2", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Agt4GasMessung.prototype, "ansprechzeitCO", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasMessung.prototype, "titel", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasMessung.prototype, "formdataName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasMessung.prototype, "eingabePEF", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasMessung.prototype, "eingabeAnsprechzeiten", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasMessung.prototype, "setArbeitsmittel", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasMessung.prototype, "setGespeichertesArbeitsmittel", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasMessung.prototype, "handlePEFChange", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasMessung.prototype, "handlePropanUmrechnungChange", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Agt4GasMessung.prototype, "handleAnsprechzeitO2Changed", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Agt4GasMessung.prototype, "handleAnsprechzeitCOChanged", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasMessung.prototype, "handleArbeitsmittelChanged", null);
    Agt4GasMessung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Agt4GasMessung);
    return Agt4GasMessung;
}(React.Component));
exports.default = Agt4GasMessung;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Komponente für Eingabe und Auswertung einer Gas-Komponente für die Kalibrierung eines 4-Gas Testers
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var Agt4GasKalibrierungStore_1 = __webpack_require__(172);
var round_1 = __webpack_require__(33);
var numberformat_1 = __webpack_require__(56);
var Agt4GasxMessungKomponente = (function (_super) {
    __extends(Agt4GasxMessungKomponente, _super);
    function Agt4GasxMessungKomponente(props) {
        var _this = _super.call(this, props) || this;
        _this.fehlergrenzen = {};
        // Abbildung der absoluten und relativen Fehlergrenzen aus OIML R99
        switch (_this.props.bezeichner) {
            case 'komponente_co':
                _this.fehlergrenzen['00'] = { absolut: 0.02, relativ: 5 };
                _this.fehlergrenzen['0'] = { absolut: 0.03, relativ: 5 };
                _this.fehlergrenzen['1'] = { absolut: 0.06, relativ: 5 };
                break;
            case 'komponente_co2':
                _this.fehlergrenzen['00'] = { absolut: 0.3, relativ: 5 };
                _this.fehlergrenzen['0'] = { absolut: 0.5, relativ: 5 };
                _this.fehlergrenzen['1'] = { absolut: 0.5, relativ: 5 };
                break;
            case 'komponente_hc':
                _this.fehlergrenzen['00'] = { absolut: 4, relativ: 5 };
                _this.fehlergrenzen['0'] = { absolut: 10, relativ: 5 };
                _this.fehlergrenzen['1'] = { absolut: 12, relativ: 5 };
                break;
            case 'komponente_o2':
                _this.fehlergrenzen['00'] = { absolut: 0.1, relativ: 5 };
                _this.fehlergrenzen['0'] = { absolut: 0.1, relativ: 5 };
                _this.fehlergrenzen['1'] = { absolut: 0.1, relativ: 5 };
                break;
            default:
                _this.fehlergrenzen['00'] = { absolut: 0, relativ: 0 };
                _this.fehlergrenzen['0'] = { absolut: 0, relativ: 0 };
                _this.fehlergrenzen['1'] = { absolut: 0, relativ: 0 };
                break;
        }
        // Im Vorgang bereits hinterlegte Werte übernehmen
        if (_this.props.value) {
            if (props.value) {
                var obj = JSON.parse(props.value);
                if (_this.props.bezeichner === 'komponente_co' && obj.co) {
                    _this.setWerte(obj.co.soll && obj.co.soll, obj.co.ist && obj.co.ist);
                }
                if (_this.props.bezeichner === 'komponente_co2' && obj.co2) {
                    _this.setWerte(obj.co2.soll && obj.co2.soll, obj.co2.ist && obj.co2.ist);
                }
                if (_this.props.bezeichner === 'komponente_hc' && obj.hc) {
                    _this.setWerte(obj.hc.soll && obj.hc.soll, obj.hc.ist && obj.hc.ist);
                }
                if (_this.props.bezeichner === 'komponente_o2' && obj.o2) {
                    _this.setWerte(obj.o2.soll && obj.o2.soll, obj.o2.ist && obj.o2.ist);
                }
            }
        }
        return _this;
    }
    Agt4GasxMessungKomponente.prototype.findMeta = function (bezeichnung) {
        if (this.props.arbeitsmittel && this.props.arbeitsmittel.meta) {
            var metadatum = this.props.arbeitsmittel.meta.find(function (meta) { return meta.bezeichnung.toLocaleLowerCase() === bezeichnung; });
            if (metadatum) {
                return metadatum.inhalt;
            }
        }
        return undefined;
    };
    Agt4GasxMessungKomponente.prototype.setWerte = function (soll, ist) {
        this.istEingabe = ist ? ist : undefined;
        this.sollwertGespeichert = soll;
    };
    Agt4GasxMessungKomponente.prototype.handleIstWertChange = function (ev) {
        if (ev.target.value) {
            var match = ev.target.value.match(/-?(\d{0,}.)?(\d{0,},)?\d{0,}/g);
            this.istEingabe = match ? match.join('') : undefined;
        }
        else {
            this.istEingabe = undefined;
        }
    };
    /**
     * Der Event Handler für das Verlassen des Eingabefeldes Istwert kümmert sich um die Verlängerung oder Verkürzung
     * des Ist-Wertes entsprechend der im Sollwert definierten Nachkommastellen
     */
    Agt4GasxMessungKomponente.prototype.handleIstWertOnBlur = function () {
        var trenner = '.';
        if (this.istwert !== undefined && this.nachkommaGenauigkeit !== undefined) {
            if (this.istEingabe) {
                var nachkommaTeil = this.istEingabe.indexOf(trenner) > -1 ? this.istEingabe.split(trenner).pop() : '';
                var nachkommaLen = nachkommaTeil ? nachkommaTeil.length : 0;
                if (nachkommaLen < this.nachkommaGenauigkeit) {
                    if (this.istEingabe.indexOf(trenner) === -1) {
                        this.istEingabe += trenner;
                    }
                    this.istEingabe = this.istEingabe + '0'.repeat(this.nachkommaGenauigkeit - nachkommaLen);
                }
                if (this.istwert && nachkommaLen > this.nachkommaGenauigkeit) {
                    this.istEingabe = round_1.round(parseFloat(this.istEingabe), this.nachkommaGenauigkeit).toString();
                }
            }
        }
    };
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "fehlergrenze", {
        /**
         * Berechnet die für die gesetzte Genauigkeitsklasse des AGT anzuwendende Fehlergrenze
         */
        get: function () {
            var fehlergrenze = this.fehlergrenzen[this.props.genauigkeitsklasse];
            return fehlergrenze;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "istwert", {
        /**
         * Berechnet den anzuwendenden Ist-Wert aus der Nutzer-Eingabe
         */
        get: function () {
            if (this.istEingabe === undefined) {
                return undefined;
            }
            var floatVal = parseFloat(this.istEingabe.replace(',', '.'));
            if (floatVal === NaN) {
                return undefined;
            }
            if ((this.props.bezeichner === 'komponente_hc') && (this.props.propanwertverwenden)) {
                // Bei Hexan/Propan je nachdem ob Umrechnung aktiv ist, Ist-Wert durch PEF teilen
                return floatVal / (this.props.propanhexanfaktor ? this.props.propanhexanfaktor : 1.0);
            }
            else {
                return floatVal;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "messunsicherheit", {
        /**
         * Berechnet die zu der chemischen Komponente passende Messunsicherheit anhand der in der Objektvorlage hinterlegten Eigenschaften
         */
        get: function () {
            var arbeitsmittel = this.props.arbeitsmittel;
            var objektvorlage = this.kalibrierungStore.objektVorlage;
            if (arbeitsmittel && objektvorlage) {
                var bezeichner = this.props.bezeichner === 'komponente_hc' ? 'komponente_propan' : this.props.bezeichner.toLowerCase();
                for (var _i = 0, _a = objektvorlage.meta; _i < _a.length; _i++) {
                    var meta = _a[_i];
                    if (meta.kategorie === 'messunsicherheit' && meta.detail === arbeitsmittel.typ.toLocaleLowerCase() && meta.eigenschaft === bezeichner) {
                        return parseFloat(meta.wert);
                    }
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "toleranzbereich", {
        /**
         * Berechnet den Toleranzbereich für die Komponente aus der OIMLR R99 Tabelle, optional unter Einbezug der Messunsicherheit
         */
        get: function () {
            if (this.sollwert === undefined) {
                return 0.0;
            }
            // Zur Genauigkeitsklasse des AGT passende Fehlergrenze ermitteln
            var zutreffendeFehlergrenze = this.fehlergrenzen[this.props.genauigkeitsklasse];
            if (zutreffendeFehlergrenze) {
                // Lt. Richtilinie gilt immer der jeweils größere Wert zwischen relativer und absoluter Toleranzgrenze
                var bereich = 0.0;
                var toleranzRelativ = this.sollwert * (zutreffendeFehlergrenze.relativ / 100.0);
                bereich = toleranzRelativ > zutreffendeFehlergrenze.absolut ? toleranzRelativ : zutreffendeFehlergrenze.absolut;
                // Die Nutzung der Messunsicherheit ist optional, und wird nur auf den Toleranzbereich angewendet wenn explizit gewünscht
                if (this.kalibrierungStore.messunsicherheitAnwenden && this.messunsicherheit) {
                    bereich -= this.messunsicherheit;
                }
                return bereich;
            }
            else {
                return 0.0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "sollwert", {
        /**
         * Berechnet den zu der chemischen Komponenten passenden Sollwert aus dem gewählten Arbeitsmittel
         */
        get: function () {
            var bezeichner = this.props.bezeichner === 'komponente_hc' ? 'komponente_propan' : this.props.bezeichner.toLowerCase();
            var metaSoll = this.findMeta('gemisch_' + bezeichner);
            if (metaSoll) {
                return parseFloat(metaSoll);
            }
            // Bei Prüfgasen != O2 muss die Komponente O2 immer 0,00% betragen, es ist also u.U. kein passendes Meta-Datum vorhanden
            if (this.props.arbeitsmittel && (this.props.bezeichner === 'komponente_o2')) {
                return 0.0;
            }
            // Wenn kein Arbeitsmittel (mehr) gewählt, wird, falls vorhanden, der im Datensatz gespeicherte Sollwert zurückgegeben
            return this.sollwertGespeichert;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "nachkommaGenauigkeit", {
        /**
         * Nachkomma-Anteil Sollwert für DAkkS-konforme Betrachtung der Messwerte
         * @todo: Elegantere Lösung (evtl. durch Umstellung auf zentralen Store wie beim Verfahren BPS)
         */
        get: function () {
            var bezeichner = this.props.bezeichner === 'komponente_hc' ? 'komponente_propan' : this.props.bezeichner.toLowerCase();
            var metaSoll = this.findMeta('gemisch_' + bezeichner);
            if (metaSoll) {
                var nachkommaTeil = metaSoll.indexOf('.') > -1 ? metaSoll.split('.').pop() : '';
                if (nachkommaTeil) {
                    return nachkommaTeil.length;
                }
            }
            // Bei Prüfgasen != O2 muss die Komponente O2 immer 0,00% betragen, es ist also u.U. kein passendes Meta-Datum vorhanden
            if (this.props.bezeichner === 'komponente_o2') {
                return 2;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Agt4GasxMessungKomponente.prototype, "imToleranzbereich", {
        /**
         * Berechnet ob der anzuwendende Ist-Wert im über Fehlergrenze und Messunsucherheit ermitteltem Toleranzbereich liegt
         */
        get: function () {
            if (this.istwert !== undefined && this.sollwert !== undefined) {
                return (this.istwert >= this.sollwert - this.toleranzbereich) && (this.istwert <= this.sollwert + this.toleranzbereich);
            }
            else {
                return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Agt4GasxMessungKomponente.prototype.render = function () {
        var zeigeHCKorrigiert = this.props.bezeichner === 'komponente_hc' && this.props.propanwertverwenden;
        return (React.createElement("tr", { key: "tr_" + this.props.bezeichner },
            React.createElement("td", { className: "komponente", style: { minWidth: '64px' } }, this.props.beschriftung),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", readOnly: true, value: numberformat_1.numberformatFixed(this.sollwert, this.nachkommaGenauigkeit), tabIndex: -1 }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, { style: { minWidth: '76px' } }, this.props.einheit),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[soll]", value: this.sollwert }),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[genauigkeit]", value: this.nachkommaGenauigkeit })),
                zeigeHCKorrigiert && React.createElement("div", { style: { verticalAlign: 'inherit', fontSize: '14px', marginTop: '14px', textAlign: 'right' } }, "Propan")),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", name: this.props.formdataprefix + "[ist]", onChange: this.handleIstWertChange, onBlur: this.handleIstWertOnBlur, readOnly: this.kalibrierungStore.readOnly, value: this.istEingabe ? this.istEingabe.replace(',', '.') : '', className: this.imToleranzbereich === true ? 'text-success' : 'text-danger', autoComplete: "off" }),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[fehlergrenze][eingehalten]", value: this.imToleranzbereich ? 'true' : 'false' })),
                zeigeHCKorrigiert &&
                    React.createElement("div", { style: { marginTop: '8px' } },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, tabIndex: -1, value: this.istwert ? round_1.round(this.istwert, 3) : '', className: this.imToleranzbereich === true ? 'text-success' : 'text-danger', style: { border: '0px', backgroundColor: 'inherit' } }),
                            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[ist_korrigiert]", value: this.istwert })))),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.InputGroup.Addon, null, "\u00B1"),
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, value: round_1.round(this.toleranzbereich, 3), tabIndex: -1 }),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", readOnly: true, name: this.props.formdataprefix + "[toleranzbreich]", value: this.toleranzbereich }),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", readOnly: true, name: this.props.formdataprefix + "[mu]", value: this.messunsicherheit }),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[fehlergrenze][absolut]", value: this.fehlergrenze.absolut }),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[fehlergrenze][relativ]", value: this.fehlergrenze.relativ })))));
    };
    __decorate([
        decorators_1.inject(Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore),
        __metadata("design:type", Agt4GasKalibrierungStore_1.Agt4GasKalibrierungStore)
    ], Agt4GasxMessungKomponente.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasxMessungKomponente.prototype, "istEingabe", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Agt4GasxMessungKomponente.prototype, "sollwertGespeichert", void 0);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasxMessungKomponente.prototype, "setWerte", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Agt4GasxMessungKomponente.prototype, "handleIstWertChange", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Agt4GasxMessungKomponente.prototype, "handleIstWertOnBlur", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "fehlergrenze", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "istwert", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "messunsicherheit", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "toleranzbereich", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "sollwert", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "nachkommaGenauigkeit", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Agt4GasxMessungKomponente.prototype, "imToleranzbereich", null);
    Agt4GasxMessungKomponente = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Agt4GasxMessungKomponente);
    return Agt4GasxMessungKomponente;
}(React.Component));
exports.default = Agt4GasxMessungKomponente;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Kapselkomponente für Messwerteingabe der Kalibrierung eines Opazimeters (Abgastester für Kompressionszünder)
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var Callout_1 = __webpack_require__(16);
var AgtPruefortParameter_1 = __webpack_require__(275);
var AgtOpazimeterMessung_1 = __webpack_require__(648);
var react_bootstrap_1 = __webpack_require__(2);
var round_1 = __webpack_require__(33);
var decorators_2 = __webpack_require__(1);
var ApiTypes_1 = __webpack_require__(21);
var AgtOpazimeterKalibrierungStore_1 = __webpack_require__(282);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var AgtOpazimeterKalibrierung = (function (_super) {
    __extends(AgtOpazimeterKalibrierung, _super);
    function AgtOpazimeterKalibrierung(props) {
        var _this = _super.call(this, props) || this;
        // Datenübernahme aus dem im Auftrag gesetzten Opazimeter
        var kalGegenstand = _this.kalibrierungStore.getKalibrierGegenstand();
        if (kalGegenstand && (kalGegenstand.art === ApiTypes_1.AGT_OPAZIMETER || kalGegenstand.art === ApiTypes_1.AGT_KOMBI)) {
            _this.abgastester = kalGegenstand;
        }
        // Fehlergrenze Koeffizient aus den Meta-Daten
        // Gerät wird bei Anlage über den Koeffizienten klassifiziert
        _this.fehlerGrenzeGeraet = 0.1;
        if (_this.abgastester) {
            if (_this.abgastester && _this.abgastester.meta) {
                var metadatum = _this.abgastester.meta.find(function (meta) { return meta.bezeichnung === 'agt_fehlergrenze'; });
                if (metadatum) {
                    _this.fehlerGrenzeGeraet = round_1.round(parseFloat(metadatum.inhalt.replace(',', '.')), 1);
                }
            }
        }
        // Die zu verwendenden Filtertypen ergeben sich aus der Fehlergrenze des Gerätes und sind im Verfahren definiert
        switch (_this.fehlerGrenzeGeraet) {
            // Geräte mit Fehlergrenze ±0,1 m^-1
            case 0.1:
                _this.filterTypen = [0, 1, 2];
                break;
            // Geräte mit Fehlergrenze ±0,3 m^-1
            case 0.3:
                _this.filterTypen = [1, 2, 3];
                break;
            default:
                // Vorgabewerte wenn keine Fehlergrenze zum Objekt hinterlegt wurde
                _this.filterTypen = [0, 1, 2];
        }
        // Die Messkammerlänge wird für die Berechnung benötigt und aus den Meta-Daten ermittelt
        _this.messkammerLaenge = 430;
        if (_this.abgastester) {
            if (_this.abgastester.meta) {
                var metadatum = _this.abgastester.meta.find(function (meta) { return meta.bezeichnung === 'agt_messkammerlänge'; });
                if (metadatum) {
                    _this.messkammerLaenge = parseInt(metadatum.inhalt, 10);
                }
            }
        }
        // Gespeicherte Optionen
        if (_this.props.value) {
            var obj = JSON.parse(_this.props.value);
            if (obj.optionen) {
                // Eingabe des korrigierten Trübungskoeffizienten
                if (obj.optionen.eingabekorrigierterkoeffizient) {
                    _this.kalibrierungStore.setEingabeKorrigierterKoeffizient(obj.optionen.eingabekorrigierterkoeffizient === 'on');
                }
                // Justage durchgeführt
                if (obj.optionen.justage) {
                    _this.kalibrierungStore.setJustage(obj.optionen.justage === 'on');
                }
                // Messunsicherheit anwenden
                if (obj.optionen.messunsicherheitanwenden) {
                    _this.kalibrierungStore.setMessunsicherheitAnwenden(obj.optionen.messunsicherheitanwenden === 'on');
                }
            }
        }
        _this.kalibrierungStore.setReadOnly(_this.props.editable ? !_this.props.editable : true);
        return _this;
    }
    AgtOpazimeterKalibrierung.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objektVorlage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.abgastester) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.objektVorlage(this.abgastester.objektguid)];
                    case 1:
                        objektVorlage = _a.sent();
                        if (objektVorlage.ok) {
                            this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AgtOpazimeterKalibrierung.prototype, "formdataprefix", {
        /**
         * JSON-Key Prefix für an Back-End übergebene Daten
         */
        get: function () {
            return this.props.kategorieguid + "[" + this.props.elementguid + "]";
        },
        enumerable: true,
        configurable: true
    });
    AgtOpazimeterKalibrierung.prototype.handleEingabeKorrigierterKoeffizientChange = function (ev) {
        this.kalibrierungStore.setEingabeKorrigierterKoeffizient(ev.target.checked);
    };
    AgtOpazimeterKalibrierung.prototype.handleMessunsicherheitAnwendenChange = function (ev) {
        this.kalibrierungStore.setMessunsicherheitAnwenden(ev.target.checked);
    };
    AgtOpazimeterKalibrierung.prototype.handleJustageChange = function (ev) {
        this.kalibrierungStore.setJustage(ev.target.checked);
    };
    AgtOpazimeterKalibrierung.prototype.renderMessReihe = function (nachJustage) {
        // Wenn bereits Werte erfasst wurden, in jeweiligen Komponenten übernehmen
        var parameter = undefined;
        var messungen = undefined;
        if (this.props.value) {
            var obj = JSON.parse(this.props.value);
            if (nachJustage) {
                if (obj.nachjustage) {
                    messungen = obj.nachjustage.messungen;
                }
            }
            else {
                messungen = obj.messungen;
            }
            if (obj.parameter) {
                parameter = obj.parameter;
            }
        }
        var prefix = this.formdataprefix;
        if (nachJustage) {
            prefix = prefix + '[nachjustage]';
        }
        return (React.createElement("div", null,
            React.createElement(AgtOpazimeterMessung_1.default, { filterTyp: this.filterTypen[0], fehlergrenzeGeraet: this.fehlerGrenzeGeraet, messkammerlaenge: this.messkammerLaenge, formdataprefix: prefix + "[messungen][0]", value: messungen && messungen[0] ? JSON.stringify(messungen[0]) : undefined, nachjustage: nachJustage }),
            React.createElement(AgtOpazimeterMessung_1.default, { filterTyp: this.filterTypen[1], fehlergrenzeGeraet: this.fehlerGrenzeGeraet, messkammerlaenge: this.messkammerLaenge, formdataprefix: prefix + "[messungen][1]", value: messungen && messungen[1] ? JSON.stringify(messungen[1]) : undefined, nachjustage: nachJustage }),
            React.createElement(AgtOpazimeterMessung_1.default, { filterTyp: this.filterTypen[2], fehlergrenzeGeraet: this.fehlerGrenzeGeraet, messkammerlaenge: this.messkammerLaenge, formdataprefix: prefix + "[messungen][2]", value: messungen && messungen[2] ? JSON.stringify(messungen[2]) : undefined, nachjustage: nachJustage })));
    };
    AgtOpazimeterKalibrierung.prototype.render = function () {
        // Wenn bereits Werte erfasst wurden, in jeweiligen Komponenten übernehmen
        var parameter = undefined;
        var messungen = undefined;
        if (this.props.value) {
            var obj = JSON.parse(this.props.value);
            if (obj.parameter) {
                parameter = obj.parameter;
            }
            if (obj.messungen) {
                messungen = obj.messungen;
            }
        }
        return (React.createElement("div", null, this.abgastester !== undefined ?
            React.createElement("div", null,
                React.createElement(Callout_1.default, { bsStyle: "warning" },
                    React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_anzeige_korrigierter_koeffizient", name: this.formdataprefix + "[optionen][eingabekorrigierterkoeffizient]", disabled: this.kalibrierungStore.readOnly, onChange: !this.kalibrierungStore.readOnly ? this.handleEingabeKorrigierterKoeffizientChange : undefined, defaultChecked: this.kalibrierungStore.eingabeKorrigierterKoeffizient }, "Ger\u00E4t zeigt den korrigierten Tr\u00FCbungskoeffizienten an"),
                    React.createElement("div", { className: "text-hint-light" },
                        React.createElement("b", null, "Hinweis:"),
                        " Wenn diese Option aktiviert ist, findet keine automatische Korrektur des Tr\u00FCbungskoeffizienten \u00FCber die Messkammerl\u00E4nge statt.")),
                this.uiStore.userProfile && this.uiStore.userProfile.portaladmin &&
                    React.createElement(Callout_1.default, { bsStyle: "warning" },
                        React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_mu_anwenden", name: this.formdataprefix + "[optionen][messunsicherheitanwenden]", disabled: this.kalibrierungStore.readOnly, onChange: !this.kalibrierungStore.readOnly ? this.handleMessunsicherheitAnwendenChange : undefined, defaultChecked: this.kalibrierungStore.messunsicherheitAnwenden }, "Messunsicherheit f\u00FCr Berechnung Toleranzbereich nutzen"),
                        React.createElement("div", { className: "text-hint-light" },
                            React.createElement("b", null, "Hinweis:"),
                            " Diese Auswahl steht nur internen Nutzern zur Verf\u00FCgung.")),
                React.createElement(AgtPruefortParameter_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", formdataprefix: this.formdataprefix + "[parameter][0]", bereichLuftfeuchtigkeit: { min: 0, max: 85 }, bereichUmgebungsdruck: { min: 860, max: 1060 }, bereichLufttemperatur: { min: 10, max: 30 }, editable: this.props.editable, value: parameter && parameter[0] ? JSON.stringify(parameter[0]) : undefined }),
                this.renderMessReihe(false),
                React.createElement(Callout_1.default, { bsStyle: "default" },
                    React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_justage", name: this.formdataprefix + "[optionen][justage]", disabled: this.kalibrierungStore.readOnly, onChange: !this.kalibrierungStore.readOnly ? this.handleJustageChange : undefined, defaultChecked: this.kalibrierungStore.justage }, "Justage durchgef\u00FChrt"),
                    React.createElement("div", { className: "text-hint-light" }, "Zeigt eine zweite Messwerteingabe f\u00FCr die Erfassung der Daten nach Durchf\u00FChrung einer Justage an. Beim Erzeugen des Kalibrierscheins werden diese Messwerte \u00FCbernommen.")),
                this.kalibrierungStore.justage &&
                    this.renderMessReihe(true),
                React.createElement(AgtPruefortParameter_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", formdataprefix: this.formdataprefix + "[parameter][1]", bereichLuftfeuchtigkeit: { min: 0, max: 85 }, bereichUmgebungsdruck: { min: 860, max: 1060 }, bereichLufttemperatur: { min: 10, max: 30 }, editable: this.props.editable, value: parameter && parameter[1] ? JSON.stringify(parameter[1]) : undefined }))
            :
                React.createElement(Callout_1.default, { bsStyle: "danger" },
                    React.createElement("p", null, "F\u00FCr die Erstellung der Auswertung muss ein Opazimeter oder Kombiger\u00E4t ausgew\u00E4hlt werden."))));
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], AgtOpazimeterKalibrierung.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AgtOpazimeterKalibrierung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AgtOpazimeterKalibrierung.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(AgtOpazimeterKalibrierungStore_1.AgtOpazimeterKalibrierungStore),
        __metadata("design:type", AgtOpazimeterKalibrierungStore_1.AgtOpazimeterKalibrierungStore)
    ], AgtOpazimeterKalibrierung.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterKalibrierung.prototype, "formdataprefix", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierung.prototype, "handleEingabeKorrigierterKoeffizientChange", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierung.prototype, "handleMessunsicherheitAnwendenChange", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterKalibrierung.prototype, "handleJustageChange", null);
    AgtOpazimeterKalibrierung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AgtOpazimeterKalibrierung);
    return AgtOpazimeterKalibrierung;
}(React.Component));
exports.default = AgtOpazimeterKalibrierung;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_2 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var round_1 = __webpack_require__(33);
var AgtOpazimeterKalibrierungStore_1 = __webpack_require__(282);
var FaIcon_1 = __webpack_require__(20);
var numberformat_1 = __webpack_require__(56);
/**
 * Messwerteingabe für eine Messreihe mti einen definierten Opazimeter Filtertyp
 */
var AgtOpazimeterMessung = (function (_super) {
    __extends(AgtOpazimeterMessung, _super);
    function AgtOpazimeterMessung(props) {
        var _this = _super.call(this, props) || this;
        _this.validationstate = 'error';
        _this.arbeitsmittel = undefined;
        _this.truebungsGrad = {
            soll: undefined,
            istEingabe: [undefined, undefined],
            ist: [undefined, undefined],
            genauigkeit: undefined,
            fehlergrenze: undefined
        };
        _this.truebungsKoeffizient = {
            soll: undefined,
            istEingabe: [undefined, undefined],
            ist: [undefined, undefined],
            korrigiert: [undefined, undefined],
            genauigkeit: undefined,
            fehlergrenze: undefined
        };
        _this.popoverUmrechnungGradKoeffizient = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            React.createElement("b", null, "Tr\u00FCbungskoeffizient"),
            " aus diesem Tr\u00FCbungsgrad berechnen und nach unten \u00FCbernehmen."));
        _this.popoverUmrechnungKoeffizientGrad = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" },
            React.createElement("b", null, "Tr\u00FCbungsgrad"),
            " aus diesem Tr\u00FCbungskoeffizient berechnen und nach oben \u00FCbernehmen."));
        // Vorhandene Werte übernehmen
        if (props.value) {
            var obj = JSON.parse(props.value);
            if (obj.truebungsgrad) {
                _this.setTruebungsGrad(0, obj.truebungsgrad.messung && obj.truebungsgrad.messung[0]);
                _this.setTruebungsGrad(1, obj.truebungsgrad.messung && obj.truebungsgrad.messung[1]);
            }
            if (obj.truebungskoeffizient) {
                _this.setTruebungsKoeffizient(0, obj.truebungskoeffizient.messung && obj.truebungskoeffizient.messung[0] && obj.truebungskoeffizient.messung[0].ist);
                _this.setTruebungsKoeffizient(1, obj.truebungskoeffizient.messung && obj.truebungskoeffizient.messung[1] && obj.truebungskoeffizient.messung[1].ist);
                // @todo: Direkt in obige Funktion?
                for (var i = 0; i < _this.truebungsKoeffizient.ist.length; i++) {
                    var koeffizient = _this.truebungsKoeffizient.ist[i];
                    _this.setTruebungsKoeffizientKorrigiert(i, koeffizient ? round_1.round(koeffizient * (_this.props.messkammerlaenge / 430.0), 3) : undefined);
                }
            }
            if (obj.arbeitsmittel) {
                if (obj.arbeitsmittel) {
                    _this.setGespeichertesArbeitsmittel(obj.arbeitsmittel.guid);
                }
            }
        }
        _this.setFehlergrenzen();
        return _this;
    }
    AgtOpazimeterMessung.prototype.setTruebungsGrad = function (index, wert) {
        this.truebungsGrad.istEingabe[index] = wert;
        this.truebungsGrad.ist[index] = wert !== undefined ? parseFloat(wert) : undefined;
    };
    AgtOpazimeterMessung.prototype.setTruebungsKoeffizient = function (index, wert) {
        this.truebungsKoeffizient.istEingabe[index] = wert;
        this.truebungsKoeffizient.ist[index] = wert !== undefined ? parseFloat(wert) : undefined;
    };
    // @todo: In obige Funktion integrieren?
    // @todo: Nachkommastellen direkt korrigieren, da keine manuelle Eingabe?
    AgtOpazimeterMessung.prototype.setTruebungsKoeffizientKorrigiert = function (index, wert) {
        this.truebungsKoeffizient.korrigiert[index] = wert !== undefined ? wert.toString() : undefined;
        if (wert !== undefined && this.truebungsKoeffizient.genauigkeit) {
            var corrVal = this.nachkommaKorrektur(wert, this.truebungsKoeffizient.genauigkeit);
            this.truebungsKoeffizient.korrigiert[index] = corrVal;
        }
    };
    // Die Fehlergrenzen für einen Filter, die den Toleranzbereich definieren, hängen von der Klasse des Filters und der Fehlerklasse des Gerätes ab
    AgtOpazimeterMessung.prototype.setFehlergrenzen = function () {
        // Entsprechend der Tabelle aus der Vorschrift sind die Fehlergrenzen immer gleich, außer beim Filtertyp 0 für Geräte mit Fehlergrenze ±0,1 m^-1
        this.truebungsGrad.fehlergrenze = 5;
        this.truebungsKoeffizient.fehlergrenze = 0.3;
        if (this.props.fehlergrenzeGeraet === 0.1 && this.props.filterTyp === 0) {
            this.truebungsGrad.fehlergrenze = undefined;
            this.truebungsKoeffizient.fehlergrenze = 0.1;
        }
    };
    Object.defineProperty(AgtOpazimeterMessung.prototype, "titel", {
        get: function () {
            var text = 'Messung mit Filtertyp ' + this.props.filterTyp.toString();
            if (this.props.nachjustage) {
                text += ' nach Justage';
            }
            return text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgtOpazimeterMessung.prototype, "formdataName", {
        get: function () {
            return "" + this.props.formdataprefix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgtOpazimeterMessung.prototype, "messunsicherheitTruebungsgrad", {
        /**
         * Ermittelt die zum Trübungsgrad gehörende Messunsicherheit für den gewählten Filtertyp anhand der in der Objektvorlage hinterlegten Eigenschaften
         */
        get: function () {
            var arbeitsmittel = this.arbeitsmittel;
            var objektvorlage = this.kalibrierungStore.objektVorlage;
            if (arbeitsmittel && objektvorlage) {
                for (var _i = 0, _a = objektvorlage.meta; _i < _a.length; _i++) {
                    var meta = _a[_i];
                    if (meta.kategorie === 'messunsicherheit' && meta.detail === arbeitsmittel.typ.toLocaleLowerCase() && meta.eigenschaft === 'truebungsgrad') {
                        return parseFloat(meta.wert);
                    }
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgtOpazimeterMessung.prototype, "truebungsGradToleranzbereich", {
        /**
         * Berechnet den Toleranzbereich für den Trübungsgrad, optional unter Einbezug der Messunsicherheit
         */
        get: function () {
            var toleranzBereich = undefined;
            for (var i = 0; i < this.truebungsGrad.ist.length; i++) {
                if (this.truebungsGrad.soll && this.truebungsGrad.fehlergrenze) {
                    toleranzBereich = round_1.round(this.truebungsGrad.fehlergrenze, 3);
                    // Messunsicherheit kann optional von Fehlergrenze abgezogen werden
                    if (this.kalibrierungStore.messunsicherheitAnwenden && this.messunsicherheitTruebungsgrad) {
                        toleranzBereich -= round_1.round(this.messunsicherheitTruebungsgrad, 3);
                    }
                }
            }
            return toleranzBereich;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgtOpazimeterMessung.prototype, "truebungsGradImToleranzbereich", {
        /**
         * Ermittelt ob der anzuwendende Ist-Wert für den Trübungsgrad im über Fehlergrenze und (optional) Messunsucherheit ermitteltem Toleranzbereich liegt
         * @note: Wenn es keine Fehlergrenze für den Trübungsgrad gibt (Geräte mit Fehlergrenze 0,1), keine Toleranzbetrachtung durchführen
         */
        get: function () {
            var toleranzEingehalten = [undefined, undefined];
            for (var i = 0; i < this.truebungsGrad.ist.length; i++) {
                if (this.truebungsGrad.fehlergrenze) {
                    var messwert = this.truebungsGrad.ist[i];
                    if (messwert !== undefined && this.truebungsGrad.soll !== undefined && this.truebungsGradToleranzbereich) {
                        toleranzEingehalten[i] = (messwert >= this.truebungsGrad.soll - this.truebungsGradToleranzbereich) && (messwert <= this.truebungsGrad.soll + this.truebungsGradToleranzbereich);
                    }
                }
                else {
                    toleranzEingehalten[i] = true;
                }
            }
            return toleranzEingehalten;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgtOpazimeterMessung.prototype, "truebungsKoeffizientToleranzbereich", {
        /**
         * Berechnet den Toleranzbereich für den Trübungkoeffizienten
         */
        get: function () {
            var toleranzBereich = undefined;
            if (this.truebungsKoeffizient.soll && this.truebungsKoeffizient.fehlergrenze) {
                // Fehlergrenze Trübungskoeffizient ist absolut
                toleranzBereich = round_1.round(this.truebungsKoeffizient.fehlergrenze, 3);
            }
            return toleranzBereich;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgtOpazimeterMessung.prototype, "truebungsKoeffizientImToleranzbereich", {
        /**
         * Ermittelt ob der anzuwendende Ist-Wert für den Trübungkoeffizienten im über die Fehlergrenze ermitteltem Toleranzbereich liegt
         */
        get: function () {
            var toleranzEingehalten = [undefined, undefined];
            for (var i = 0; i < this.truebungsKoeffizient.ist.length; i++) {
                var messwert = this.kalibrierungStore.eingabeKorrigierterKoeffizient ? this.truebungsKoeffizient.ist[i] : this.truebungsKoeffizient.korrigiert[i];
                if (messwert !== undefined && this.truebungsKoeffizient.soll !== undefined && this.truebungsKoeffizientToleranzbereich) {
                    toleranzEingehalten[i] = (messwert >= this.truebungsKoeffizient.soll - this.truebungsKoeffizientToleranzbereich) && (messwert <= this.truebungsKoeffizient.soll + this.truebungsKoeffizientToleranzbereich);
                }
                else {
                    toleranzEingehalten[i] = undefined;
                }
            }
            return toleranzEingehalten;
        },
        enumerable: true,
        configurable: true
    });
    AgtOpazimeterMessung.prototype.nachkommaStellen = function (value) {
        var nachkommaTeil = value.indexOf('.') > -1 ? value.split('.').pop() : '';
        return nachkommaTeil ? nachkommaTeil.length : 0;
    };
    /**
     * Übernimmt die im aktuell gewählten Filter (Arbeitsmittel) hinterlegten Sollwerte (inkl. Messunsicherheit) aus den Meta-Daten des Arbeitsmittels
     */
    AgtOpazimeterMessung.prototype.uebernehmeSollwerte = function () {
        var arbeitsmittel = this.arbeitsmittel;
        if (arbeitsmittel) {
            var l = arbeitsmittel.meta ? arbeitsmittel.meta.length : 0;
            for (var i = 0; i < l; i++) {
                if (arbeitsmittel && arbeitsmittel.meta && arbeitsmittel.meta[i] !== undefined) {
                    var metadatum = arbeitsmittel.meta[i];
                    if (metadatum.bezeichnung === 'filter_truebungsgrad') {
                        this.truebungsGrad.soll = parseFloat(metadatum.inhalt);
                        this.truebungsGrad.genauigkeit = this.nachkommaStellen(metadatum.inhalt);
                    }
                    if (metadatum.bezeichnung === 'filter_truebungskoeffizient') {
                        this.truebungsKoeffizient.soll = parseFloat(metadatum.inhalt);
                        this.truebungsKoeffizient.genauigkeit = this.nachkommaStellen(metadatum.inhalt);
                    }
                }
            }
        }
        else {
            this.truebungsGrad.soll = undefined;
            this.truebungsKoeffizient.soll = undefined;
            this.truebungsGrad.genauigkeit = undefined;
            this.truebungsKoeffizient.genauigkeit = undefined;
        }
    };
    AgtOpazimeterMessung.prototype.setArbeitsmittel = function (arbeitsmittel) {
        this.arbeitsmittel = arbeitsmittel;
        this.uebernehmeSollwerte();
    };
    AgtOpazimeterMessung.prototype.setGespeichertesArbeitsmittel = function (arbeitsmittelguid) {
        this.gespeichertesArbeitsmittel = arbeitsmittelguid;
        if (arbeitsmittelguid) {
            // Gespeichertes Arbeitsmittel im aktuellen Vorgang suchen und als Interface in Auswertung übernehmen
            if (this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
                var arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.find(function (am) { return (am.arbeitsmittelguid === arbeitsmittelguid); });
                if (arbeitsmittel) {
                    this.setArbeitsmittel(arbeitsmittel);
                }
            }
        }
    };
    AgtOpazimeterMessung.prototype.handleArbeitsmittelChanged = function (ev) {
        var arbeitsmittelguid = ev.target.value !== '' ? ev.target.value : undefined;
        if (arbeitsmittelguid && this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
            var arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.find(function (am) { return am.arbeitsmittelguid === arbeitsmittelguid; });
            this.setArbeitsmittel(arbeitsmittel);
        }
        else {
            this.setArbeitsmittel(undefined);
        }
    };
    AgtOpazimeterMessung.prototype.handleKoeffizientChange = function (index, ev) {
        // @todo: rework, Text und Regex
        this.setTruebungsKoeffizient(index, (ev.target.value !== '' ? ev.target.value : undefined));
        // Der korrigierte Trübungskoeffizient wird über die im AGT hinterlegte Messskammerlänge ermittelt
        // @todo: in obige Funktione
        var koeffizient = this.truebungsKoeffizient.ist[index];
        this.setTruebungsKoeffizientKorrigiert(index, koeffizient ? round_1.round(koeffizient * (this.props.messkammerlaenge / 430.0), 3) : undefined);
    };
    AgtOpazimeterMessung.prototype.handleGradChange = function (index, ev) {
        // @todo: rework, Text und Regex
        this.setTruebungsGrad(index, (ev.target.value !== '' ? ev.target.value : undefined));
    };
    /**
     * @todo: comment
     */
    AgtOpazimeterMessung.prototype.nachkommaKorrektur = function (wert, nachkommastellen) {
        var strVal = wert.toString();
        var trenner = '.';
        var tstVal = strVal;
        var nachkommaTeil = strVal.indexOf(trenner) > -1 ? strVal.split(trenner).pop() : '';
        var nachkommaLen = nachkommaTeil ? nachkommaTeil.length : 0;
        if (nachkommaLen < nachkommastellen) {
            if (strVal.indexOf(trenner) === -1) {
                tstVal += trenner;
            }
            tstVal = tstVal + '0'.repeat(nachkommastellen - nachkommaLen);
        }
        if (tstVal && nachkommaLen > nachkommastellen) {
            tstVal = round_1.round(parseFloat(tstVal), nachkommastellen).toString();
        }
        return tstVal;
    };
    /**
     * Der Event Handler für das Verlassen des Eingabefeldes Istwert kümmert sich um die Verlängerung oder Verkürzung
     * des Ist-Wertes entsprechend der im Sollwert definierten Nachkommastellen
     */
    AgtOpazimeterMessung.prototype.handleGradBlur = function (index, ev) {
        var val = this.truebungsGrad.ist[index];
        if (val !== undefined && this.truebungsGrad.genauigkeit !== undefined) {
            var corrVal = this.nachkommaKorrektur(val, this.truebungsGrad.genauigkeit);
            this.setTruebungsGrad(index, corrVal);
        }
    };
    AgtOpazimeterMessung.prototype.handleKoeffizientBlur = function (index, ev) {
        var val = this.truebungsKoeffizient.ist[index];
        if (val !== undefined && this.truebungsKoeffizient.genauigkeit !== undefined) {
            var corrVal = this.nachkommaKorrektur(val, this.truebungsKoeffizient.genauigkeit);
            this.setTruebungsKoeffizient(index, corrVal);
            var koeffizient = this.truebungsKoeffizient.ist[index];
            this.setTruebungsKoeffizientKorrigiert(index, koeffizient ? round_1.round(koeffizient * (this.props.messkammerlaenge / 430.0), 3) : undefined);
        }
    };
    /**
     * Rechnet den Trübungsgrad anhand der PTB-Formel in den Trübungskoeffizienten um
     */
    AgtOpazimeterMessung.prototype.berechneKoeffizientAusTruebungsgrad = function (index) {
        if (!this.truebungsGrad.ist[index]) {
            return;
        }
        if (this.truebungsGrad.ist && this.truebungsGrad.ist[index]) {
            var N = this.truebungsGrad.ist[index] !== undefined ? this.truebungsGrad.ist[index] : undefined;
            if (N) {
                // Wenn das Gerät bereits korrigierte Koeffizienten anzeigt immer auf 430mm als Messkammerlänge beziehen
                var mk = (this.kalibrierungStore.eingabeKorrigierterKoeffizient ? 430.0 : this.props.messkammerlaenge) * 0.001;
                var k = -Math.log(1.0 - (N / 100.0)) * (1.0 / mk);
                // this.truebungskoeffizient[index] = round(k, 3);
                // @todo: über setter
                this.setTruebungsKoeffizientKorrigiert(index, round_1.round(k * (this.props.messkammerlaenge / 430.0), 3));
                // @todo: K korrigiert
                var corrVal = this.nachkommaKorrektur(k, this.truebungsKoeffizient.genauigkeit ? this.truebungsKoeffizient.genauigkeit : 3);
                this.setTruebungsKoeffizient(index, corrVal);
            }
        }
    };
    /**
     * Rechnet den Trübungskoeffizienten anhand der umgestellten PTB-Formel in den Trübungsgrad um
     */
    AgtOpazimeterMessung.prototype.berechneTruebungsgradAusKoeffizient = function (index) {
        if (!this.truebungsKoeffizient.ist[index]) {
            return;
        }
        if (this.truebungsKoeffizient.ist[index]) {
            var k = this.truebungsKoeffizient.ist[index] !== undefined ? this.truebungsKoeffizient.ist[index] : undefined;
            if (k) {
                // Wenn das Gerät bereits korrigierte Koeffizienten anzeigt immer auf 430mm als Messkammerlänge beziehen
                var mk = (this.kalibrierungStore.eingabeKorrigierterKoeffizient ? 430.0 : this.props.messkammerlaenge) * 0.001;
                var fmk = 1.0 / mk;
                var N = -(Math.exp(-(k / fmk)) - 1.0) * 100.0;
                // this.truebungsGrad.ist[index] = round(N, 3);
                var corrVal = this.nachkommaKorrektur(N, this.truebungsGrad.genauigkeit ? this.truebungsGrad.genauigkeit : 3);
                this.setTruebungsGrad(index, corrVal);
            }
        }
    };
    AgtOpazimeterMessung.prototype.renderArbeitsmittelAuswahl = function () {
        var _this = this;
        var arbeitsmittel = [];
        // Zur Art des Prüfgases der Komponente passenden Arbeitsmittel aus aktuell gewähltem Set ermitteln
        if (this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
            arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.filter(function (am) {
                if (am.typ === 'AGT_FILTER_' + _this.props.filterTyp.toString()) {
                    return true;
                }
                return false;
            });
            return (React.createElement("div", null,
                React.createElement(react_bootstrap_1.FormGroup, { validationState: this.arbeitsmittel !== undefined ? undefined : 'error', controlId: "Verwendeter Filter" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Verwendeter Filter"),
                    React.createElement(react_bootstrap_1.Col, { sm: 8 },
                        !this.kalibrierungStore.readOnly ?
                            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleArbeitsmittelChanged, defaultValue: this.gespeichertesArbeitsmittel, name: this.formdataName + "[arbeitsmittel][guid]" },
                                React.createElement("option", { value: undefined }),
                                arbeitsmittel.map(function (am) { return React.createElement("option", { key: am.arbeitsmittelguid, value: am.arbeitsmittelguid },
                                    " ",
                                    am.name,
                                    " (",
                                    am.arbeitsmittelnr,
                                    ")"); }))
                            :
                                React.createElement(react_bootstrap_1.FormControl, { type: "text", value: this.arbeitsmittel && this.arbeitsmittel.name + " (" + this.arbeitsmittel.arbeitsmittelnr + ")", readOnly: true, disabled: true }),
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[arbeitsmittel][nr]", value: this.arbeitsmittel ? this.arbeitsmittel.arbeitsmittelnr : '' }),
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[arbeitsmittel][name]", value: this.arbeitsmittel ? this.arbeitsmittel.name : '' }),
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[arbeitsmittel][typ]", value: this.arbeitsmittel ? this.arbeitsmittel.typ : '' }),
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.formdataName + "[arbeitsmittel][messunsicherheit][truebungsgrad]", value: this.messunsicherheitTruebungsgrad ? this.messunsicherheitTruebungsgrad : '' })))));
        }
        return (React.createElement("div", null, "Keine Arbeitsmittel im Vorgang hinterlegt!!!"));
    };
    AgtOpazimeterMessung.prototype.renderToleranzBereich = function (wert, bereich) {
        return (React.createElement(react_bootstrap_1.InputGroup, null,
            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "\u00B1"),
            React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, tabIndex: -1, value: round_1.round(bereich, 3) })));
    };
    AgtOpazimeterMessung.prototype.renderTruebungsGrad = function () {
        var _this = this;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "komponente" }, "Grad"),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "text", readOnly: true, tabIndex: -1, name: this.props.formdataprefix + "[truebungsgrad][soll]", value: numberformat_1.numberformatFixed(this.truebungsGrad.soll, this.truebungsGrad.genauigkeit ? this.truebungsGrad.genauigkeit : 3) }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, { className: "komponenteEinheit" }, "%"))),
            [0, 1].map(function (index) { return (React.createElement("td", { key: index },
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", name: _this.props.formdataprefix + "[truebungsgrad][messung][" + index + "]", onChange: function (e) { return _this.handleGradChange(index, e); }, onBlur: function (e) { return _this.handleGradBlur(index, e); }, readOnly: _this.kalibrierungStore.readOnly, value: _this.truebungsGrad.istEingabe[index] !== undefined ? _this.truebungsGrad.istEingabe[index] : '', className: _this.truebungsGradImToleranzbereich[index] === true ? 'text-success' : 'text-danger', autoComplete: "off" }),
                    React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus', 'click'], placement: "top", overlay: _this.popoverUmrechnungGradKoeffizient },
                        React.createElement(react_bootstrap_1.InputGroup.Button, { style: { width: '28px' } },
                            React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: "btn-group", disabled: _this.kalibrierungStore.readOnly, onClick: function () { return _this.berechneKoeffizientAusTruebungsgrad(index); } },
                                React.createElement(FaIcon_1.default, { icon: "level-down" })))),
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: _this.props.formdataprefix + "[truebungsgrad][fehlergrenze][" + index + "]", value: _this.truebungsGradImToleranzbereich[index] === true ? 'true' : 'false' })),
                React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: _this.props.formdataprefix + "[truebungsgrad][genauigkeit]", value: _this.truebungsGrad.genauigkeit }))); }),
            React.createElement("td", null, this.truebungsGradToleranzbereich !== undefined && this.truebungsGrad.soll &&
                this.renderToleranzBereich(this.truebungsGrad.soll, this.truebungsGradToleranzbereich))));
    };
    AgtOpazimeterMessung.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Panel, { header: this.titel, collapsible: true, defaultExpanded: true },
            this.renderArbeitsmittelAuswahl(),
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "agt-auswertung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Filterwert"),
                        React.createElement("th", null, "Messung 1"),
                        React.createElement("th", null, "Messung 2"),
                        React.createElement("th", null, "Toleranzbereich"))),
                React.createElement("tbody", null,
                    this.renderTruebungsGrad(),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "komponente" }, "Koeffizient"),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, tabIndex: -1, name: this.props.formdataprefix + "[truebungskoeffizient][soll]", value: this.truebungsKoeffizient.soll }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, { className: "komponenteEinheit" },
                                    "m",
                                    React.createElement("sup", null, "-1")))),
                        [0, 1].map(function (index) { return (React.createElement("td", { key: index },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", name: _this.props.formdataprefix + "[truebungskoeffizient][messung][" + index + "][ist]", onChange: function (e) { return _this.handleKoeffizientChange(index, e); }, onBlur: function (e) { return _this.handleKoeffizientBlur(index, e); }, readOnly: _this.kalibrierungStore.readOnly, value: _this.truebungsKoeffizient.istEingabe[index] !== undefined ? _this.truebungsKoeffizient.istEingabe[index] : '', className: _this.kalibrierungStore.eingabeKorrigierterKoeffizient ? (_this.truebungsKoeffizientImToleranzbereich[index] === true ? 'text-success' : 'text-danger') : undefined }),
                                React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus', 'click'], placement: "bottom", overlay: _this.popoverUmrechnungKoeffizientGrad },
                                    React.createElement(react_bootstrap_1.InputGroup.Button, { style: { width: '28px' } },
                                        React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: "btn-group", disabled: _this.kalibrierungStore.readOnly, onClick: function () { return _this.berechneTruebungsgradAusKoeffizient(index); } },
                                            React.createElement(FaIcon_1.default, { icon: "level-up" })))),
                                React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: _this.props.formdataprefix + "[truebungskoeffizient][messung][" + index + "][korrigiert]", value: _this.truebungsKoeffizient.korrigiert[index] }),
                                React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: _this.props.formdataprefix + "[truebungskoeffizient][fehlergrenze][" + index + "]", value: _this.truebungsKoeffizientImToleranzbereich[index] === true ? 'true' : 'false' })),
                            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: _this.props.formdataprefix + "[truebungskoeffizient][genauigkeit]", value: _this.truebungsKoeffizient.genauigkeit }))); }),
                        React.createElement("td", null, this.truebungsKoeffizientToleranzbereich && this.truebungsKoeffizient.soll &&
                            this.renderToleranzBereich(this.truebungsKoeffizient.soll, this.truebungsKoeffizientToleranzbereich))),
                    !this.kalibrierungStore.eingabeKorrigierterKoeffizient &&
                        React.createElement("tr", null,
                            React.createElement("td", null),
                            React.createElement("td", { className: "eingabeCaption" }, "Korrigiert"),
                            [0, 1].map(function (index) { return (React.createElement("td", { key: index },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus', 'click'], placement: "bottom", overlay: React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" }, "F\u00FCr den Abgleich gegen den Filterwert wird der \u00FCber die Messkammerl\u00E4nge korrigierte Koeffizient verwendet") },
                                        React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, tabIndex: -1, value: _this.truebungsKoeffizient.korrigiert[index] !== undefined ? _this.truebungsKoeffizient.korrigiert[index] : '', className: _this.truebungsKoeffizientImToleranzbereich[index] === true ? 'text-success' : 'text-danger', style: { border: '0px', backgroundColor: 'inherit' } }))))); }),
                            React.createElement("td", null)))),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[fehlergrenzen][truebungsgrad]", value: this.truebungsGrad.fehlergrenze }),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.formdataprefix + "[fehlergrenzen][truebungskoeffizient]", value: this.truebungsKoeffizient.fehlergrenze })));
    };
    __decorate([
        decorators_2.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], AgtOpazimeterMessung.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_2.inject(AgtOpazimeterKalibrierungStore_1.AgtOpazimeterKalibrierungStore),
        __metadata("design:type", AgtOpazimeterKalibrierungStore_1.AgtOpazimeterKalibrierungStore)
    ], AgtOpazimeterMessung.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtOpazimeterMessung.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtOpazimeterMessung.prototype, "arbeitsmittel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtOpazimeterMessung.prototype, "gespeichertesArbeitsmittel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtOpazimeterMessung.prototype, "truebungsGrad", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtOpazimeterMessung.prototype, "truebungsKoeffizient", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "setTruebungsGrad", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "setTruebungsKoeffizient", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "setTruebungsKoeffizientKorrigiert", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "setFehlergrenzen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "titel", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "formdataName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "messunsicherheitTruebungsgrad", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "truebungsGradToleranzbereich", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "truebungsGradImToleranzbereich", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "truebungsKoeffizientToleranzbereich", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtOpazimeterMessung.prototype, "truebungsKoeffizientImToleranzbereich", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "setArbeitsmittel", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "setGespeichertesArbeitsmittel", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "handleArbeitsmittelChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "handleKoeffizientChange", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "handleGradChange", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "handleGradBlur", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "handleKoeffizientBlur", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "berechneKoeffizientAusTruebungsgrad", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], AgtOpazimeterMessung.prototype, "berechneTruebungsgradAusKoeffizient", null);
    AgtOpazimeterMessung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AgtOpazimeterMessung);
    return AgtOpazimeterMessung;
}(React.Component));
exports.default = AgtOpazimeterMessung;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
var AgtPruefortParameter2_1 = __webpack_require__(651);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_2 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var ApiTypes = __webpack_require__(21);
var AgtPartikelzaehlerMessung_1 = __webpack_require__(650);
var AgtPartikelzaehlerKalibrierungStore_1 = __webpack_require__(283);
var VorgangStore_1 = __webpack_require__(22);
/** Kapselkomponente für Messwerteingabe der Kalibrierung eines Abgasmessgerätes mit Partikelzählung */
var AgtPartikelzaehlerKalibrierung = (function (_super) {
    __extends(AgtPartikelzaehlerKalibrierung, _super);
    function AgtPartikelzaehlerKalibrierung(props) {
        var _this = _super.call(this, props) || this;
        _this.kalibrierungStore.clear();
        // Datenübernahme aus dem im Auftrag gesetzten Abgasmessgerät
        var kalGegenstand = _this.kalibrierungStore.getKalibrierGegenstand();
        // In einem Auftrag können beliebige Abgasmessgeräte-Typen gemischt werden, es muss gepürft werden ob ein Partikelzähler gewählt wurde
        if (kalGegenstand && ((kalGegenstand.art === ApiTypes.AGT_PARTIKEL_DC) || (kalGegenstand.art === ApiTypes.AGT_PARTIKEL_CPC))) {
            _this.abgastester = kalGegenstand;
        }
        if (_this.props.value) {
            var obj = JSON.parse(_this.props.value);
            // Gespeicherte Optionen
            if (obj.optionen) {
                // Justage durchgeführt
                if (obj.optionen.justage) {
                    _this.kalibrierungStore.setJustage(obj.optionen.justage === 'on');
                }
            }
        }
        _this.kalibrierungStore.setReadOnly(_this.props.editable ? !_this.props.editable : true);
        return _this;
    }
    AgtPartikelzaehlerKalibrierung.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var kalibrierGegenstand, objektVorlage, vorgang, normale, messung;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        kalibrierGegenstand = this.kalibrierungStore.getKalibrierGegenstand();
                        if (!kalibrierGegenstand) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.objektVorlage(kalibrierGegenstand.objektguid)];
                    case 1:
                        objektVorlage = _a.sent();
                        if (objektVorlage.ok) {
                            this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
                        }
                        this.kalibrierungStore.setObjekt(kalibrierGegenstand);
                        return [3 /*break*/, 3];
                    case 2:
                        this.kalibrierungStore.setObjekt(undefined);
                        _a.label = 3;
                    case 3:
                        vorgang = this.vorgangStore.vorgang;
                        if (vorgang && vorgang.arbeitsmittel) {
                            normale = vorgang.arbeitsmittel.find(function (e) { return e.typ.toLowerCase() === 'agt_pck'; });
                            this.kalibrierungStore.setNormale(normale);
                        }
                        // Falls bereits Daten zu dieser Kalibrierung gespeichert wurden, werden diese beim erneuten Anzeigen übernommen
                        if (this.props.value) {
                            messung = this.kalibrierungStore.datensatz;
                            messung = JSON.parse(this.props.value);
                            this.kalibrierungStore.setMesswerte(messung);
                        }
                        this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AgtPartikelzaehlerKalibrierung.prototype.handleJustageChange = function (ev) {
        this.kalibrierungStore.setJustage(ev.target.checked);
    };
    AgtPartikelzaehlerKalibrierung.prototype.renderMessReihe = function (nachJustage) {
        var zielArray = nachJustage ? this.kalibrierungStore.datensatz.messreihenJustage : this.kalibrierungStore.datensatz.messreihen;
        return (React.createElement("div", null,
            React.createElement(AgtPartikelzaehlerMessung_1.default, { nennwert: 400000, ziel: zielArray[0], nachjustage: nachJustage }),
            React.createElement(AgtPartikelzaehlerMessung_1.default, { nennwert: 250000, ziel: zielArray[1], nachjustage: nachJustage }),
            React.createElement(AgtPartikelzaehlerMessung_1.default, { nennwert: 50000, ziel: zielArray[2], nachjustage: nachJustage })));
    };
    AgtPartikelzaehlerKalibrierung.prototype.render = function () {
        // Wenn bereits Werte erfasst wurden, in jeweiligen Komponenten übernehmen
        var parameter = undefined;
        if (this.props.value) {
            var obj = JSON.parse(this.props.value);
            if (obj.parameter) {
                parameter = obj.parameter;
            }
        }
        if (this.abgastester === undefined) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "F\u00FCr die Erstellung der Auswertung muss ein Partikelz\u00E4hlger\u00E4t ausgew\u00E4hlt werden.")));
        }
        if (this.kalibrierungStore.normale === undefined) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "F\u00FCr die Erstellung der Auswertung muss ein PCK als Messmittel ausgew\u00E4hlt werden.")));
        }
        return (React.createElement("div", null,
            React.createElement(AgtPruefortParameter2_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.beginn, readOnly: this.kalibrierungStore.readOnly }),
            this.renderMessReihe(false),
            React.createElement(Callout_1.default, { bsStyle: "default" },
                React.createElement(react_bootstrap_1.Checkbox, { inline: true, id: "checkbox_justage", disabled: !this.props.editable, onChange: this.props.editable ? this.handleJustageChange : undefined, checked: this.kalibrierungStore.datensatz.justage }, "Justage durchgef\u00FChrt"),
                React.createElement("div", { className: "text-hint-light" }, "Zeigt eine zweite Messwerteingabe f\u00FCr die Erfassung der Daten nach Durchf\u00FChrung einer Justage an. Beim Erzeugen des Kalibrierscheins werden diese Messwerte \u00FCbernommen.")),
            this.kalibrierungStore.datensatz.justage &&
                this.renderMessReihe(true),
            React.createElement(AgtPruefortParameter2_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.ende, readOnly: this.kalibrierungStore.readOnly }),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.kategorieguid + "[" + this.props.elementguid + "][json]", value: JSON.stringify(this.kalibrierungStore.datensatz) })));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], AgtPartikelzaehlerKalibrierung.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AgtPartikelzaehlerKalibrierung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], AgtPartikelzaehlerKalibrierung.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(AgtPartikelzaehlerKalibrierungStore_1.AgtPartikelzaehlerKalibrierungStore),
        __metadata("design:type", AgtPartikelzaehlerKalibrierungStore_1.AgtPartikelzaehlerKalibrierungStore)
    ], AgtPartikelzaehlerKalibrierung.prototype, "kalibrierungStore", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerKalibrierung.prototype, "handleJustageChange", null);
    AgtPartikelzaehlerKalibrierung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AgtPartikelzaehlerKalibrierung);
    return AgtPartikelzaehlerKalibrierung;
}(React.Component));
exports.default = AgtPartikelzaehlerKalibrierung;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_2 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var VorgangStore_1 = __webpack_require__(22);
var AgtPartikelzaehlerKalibrierungStore_1 = __webpack_require__(283);
var ApiTypesAgtPartikelzaehler = __webpack_require__(686);
/** @todo: document */
var AgtPartikelzaehlerMessungMesswert = (function (_super) {
    __extends(AgtPartikelzaehlerMessungMesswert, _super);
    function AgtPartikelzaehlerMessungMesswert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AgtPartikelzaehlerMessungMesswert.prototype.handleMesswertChanged = function (ev) {
        // @todo: leer / NaN
        this.props.ziel.wert = ev.target.valueAsNumber;
    };
    AgtPartikelzaehlerMessungMesswert.prototype.render = function () {
        var onHandleBlur = this.props.onHandleBlur;
        return (React.createElement(react_bootstrap_1.FormControl, { type: "number", value: this.props.ziel.wert || '', readOnly: this.props.readOnly, onChange: this.handleMesswertChanged, onBlur: (onHandleBlur) ? function () { return onHandleBlur(); } : undefined }));
    };
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerMessungMesswert.prototype, "handleMesswertChanged", null);
    AgtPartikelzaehlerMessungMesswert = __decorate([
        mobx_react_1.observer
    ], AgtPartikelzaehlerMessungMesswert);
    return AgtPartikelzaehlerMessungMesswert;
}(React.Component));
/** Messwerteingabe für eine Messreihe zur Kalibrierung eines Partikelzählers */
var AgtPartikelzaehlerMessung = (function (_super) {
    __extends(AgtPartikelzaehlerMessung, _super);
    // private abrufTimeout: number = 0;
    function AgtPartikelzaehlerMessung(props) {
        var _this = _super.call(this, props) || this;
        _this.validationstate = 'error';
        _this.arbeitsmittel = undefined;
        return _this;
    }
    AgtPartikelzaehlerMessung.prototype.setArbeitsmittel = function (arbeitsmittel) {
        this.arbeitsmittel = arbeitsmittel;
    };
    AgtPartikelzaehlerMessung.prototype.handleArbeitsmittelChanged = function (ev) {
        var arbeitsmittelguid = ev.target.value !== '' ? ev.target.value : undefined;
        if (arbeitsmittelguid && this.vorgangStore.vorgang && this.vorgangStore.vorgang.arbeitsmittel) {
            var arbeitsmittel = this.vorgangStore.vorgang.arbeitsmittel.find(function (am) { return am.arbeitsmittelguid === arbeitsmittelguid; });
            this.setArbeitsmittel(arbeitsmittel);
        }
        else {
            this.setArbeitsmittel(undefined);
        }
    };
    AgtPartikelzaehlerMessung.prototype.handleMesswertChanged = function (ziel, ev) {
        // @todo: NaN / empty
        ziel.wert = ev.target.valueAsNumber;
    };
    AgtPartikelzaehlerMessung.prototype.setBeurteilung = function (ergebnis) {
        for (var i = 0; i < ergebnis.beurteilung.length; i++) {
            this.kalibrierungStore.datensatz.messreihen[i].beurteilung = ergebnis.beurteilung[i].beurteilung;
        }
        if (ergebnis.justage) {
            for (var i = 0; i < ergebnis.justage.beurteilung.length; i++) {
                this.kalibrierungStore.datensatz.messreihenJustage[i].beurteilung = ergebnis.justage.beurteilung[i].beurteilung;
            }
        }
    };
    AgtPartikelzaehlerMessung.prototype.beurteilungAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var datensatz, datenVollstaendig, i, m, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        datensatz = this.kalibrierungStore.datensatz;
                        datenVollstaendig = true;
                        for (i = 0; i < datensatz.messreihen.length; i++) {
                            m = datensatz.messreihen[i];
                            if (m.anzeigenormal[0].wert === 0 || m.anzeigenormal[1].wert === 0) {
                                datenVollstaendig = false;
                                break;
                            }
                        }
                        if (!datenVollstaendig) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.apiStore.agtPartikelzaehlerChargingBeurteilung(this.kalibrierungStore.datensatz)];
                    case 1:
                        response = _a.sent();
                        if (response && response.ok) {
                            this.setBeurteilung(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AgtPartikelzaehlerMessung.prototype.render = function () {
        // @todo: work in progress, finales UI-Layout noch nicht entschieden (vertikal/horizontal/alle Messungen nebeneinander á la BPS)
        var titel = 'Messung bei Nennwert ' + this.props.nennwert.toLocaleString() + ' #/cm³';
        if (this.props.nachjustage) {
            titel += ' nach Justage';
        }
        var beurteilung = this.props.ziel.beurteilung !== null ? (this.props.ziel.beurteilung === true ? 'i.O.' : 'n.i.O.') : 'n/a';
        var cssClassName = "agt-dc-beurteilung-" + beurteilung.replace(/\./g, '').toLowerCase();
        var readOnly = this.kalibrierungStore.readOnly;
        return (React.createElement(react_bootstrap_1.Panel, { header: titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "agt-auswertung" },
                React.createElement("thead", null,
                    React.createElement("tr", { className: "tabelle-separator" },
                        React.createElement("th", { style: { textAlign: 'left' } }, "Zeitpunkt"),
                        React.createElement("th", null, "0s"),
                        React.createElement("th", null, "5s"),
                        React.createElement("th", null, "10s"),
                        React.createElement("th", null, "15s"),
                        React.createElement("th", null, "20s"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 6 },
                            React.createElement("b", null, "Normale"))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { whiteSpace: 'nowrap' } }, "Partikelgr\u00F6\u00DFe (nm)"),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.partikelgroesse[0], readOnly: readOnly })),
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.partikelgroesse[1], readOnly: readOnly }))),
                    React.createElement("tr", { className: "tabelle-separator" },
                        React.createElement("td", { style: { whiteSpace: 'nowrap' } }, "Anzeige (#/cm\u00B3)"),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigenormal[0], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen })),
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigenormal[1], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen }))),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 6 },
                            React.createElement("b", null, "Ger\u00E4t (Device under Test)"))),
                    React.createElement("tr", { className: "tabelle-separator" },
                        React.createElement("td", { style: { whiteSpace: 'nowrap' } }, "Anzeige (#/cm\u00B3)"),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigegeraet[0], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen })),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigegeraet[1], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen })),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigegeraet[2], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen })),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigegeraet[3], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen })),
                        React.createElement("td", null,
                            React.createElement(AgtPartikelzaehlerMessungMesswert, { ziel: this.props.ziel.anzeigegeraet[4], readOnly: readOnly, onHandleBlur: this.beurteilungAbrufen }))),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 6, style: { textAlign: 'center' } },
                            React.createElement("br", null),
                            "Beurteilung: ",
                            React.createElement("span", { className: cssClassName, style: { textAlign: 'right' } }, beurteilung)))))));
    };
    __decorate([
        decorators_2.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], AgtPartikelzaehlerMessung.prototype, "apiStore", void 0);
    __decorate([
        decorators_2.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], AgtPartikelzaehlerMessung.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_2.inject(AgtPartikelzaehlerKalibrierungStore_1.AgtPartikelzaehlerKalibrierungStore),
        __metadata("design:type", AgtPartikelzaehlerKalibrierungStore_1.AgtPartikelzaehlerKalibrierungStore)
    ], AgtPartikelzaehlerMessung.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtPartikelzaehlerMessung.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtPartikelzaehlerMessung.prototype, "arbeitsmittel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AgtPartikelzaehlerMessung.prototype, "gespeichertesArbeitsmittel", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerMessung.prototype, "setArbeitsmittel", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerMessung.prototype, "handleArbeitsmittelChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerMessung.prototype, "handleMesswertChanged", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPartikelzaehlerMessung.prototype, "setBeurteilung", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AgtPartikelzaehlerMessung.prototype, "beurteilungAbrufen", null);
    AgtPartikelzaehlerMessung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AgtPartikelzaehlerMessung);
    return AgtPartikelzaehlerMessung;
}(React.Component));
exports.default = AgtPartikelzaehlerMessung;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var AgtPruefortParameterKomponente = (function (_super) {
    __extends(AgtPruefortParameterKomponente, _super);
    function AgtPruefortParameterKomponente() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AgtPruefortParameterKomponente.prototype.handleIstWertChange = function (ev) {
        this.props.ziel.wert = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(AgtPruefortParameterKomponente.prototype, "imToleranzbereich", {
        get: function () {
            var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
            if ((wert !== null) && ((wert < min) || (wert > max))) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    AgtPruefortParameterKomponente.prototype.render = function () {
        var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "beschriftung" }, this.props.beschriftung),
            React.createElement("td", { className: "min" }, min),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: wert === null ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: this.props.readOnly, onChange: this.handleIstWertChange, value: wert !== null ? wert : '', className: wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, this.props.einheit)))),
            React.createElement("td", { className: "max" }, max)));
    };
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AgtPruefortParameterKomponente.prototype, "handleIstWertChange", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AgtPruefortParameterKomponente.prototype, "imToleranzbereich", null);
    AgtPruefortParameterKomponente = __decorate([
        mobx_react_1.observer
    ], AgtPruefortParameterKomponente);
    return AgtPruefortParameterKomponente;
}(React.Component));
/** Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Bremsenprüfstand */
var AgtPruefortParameter2 = (function (_super) {
    __extends(AgtPruefortParameter2, _super);
    function AgtPruefortParameter2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AgtPruefortParameter2.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-pruefortparameter" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Min."),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Max."))),
                React.createElement("tbody", null,
                    React.createElement(AgtPruefortParameterKomponente, { ziel: this.props.ziel.lufttemperatur, beschriftung: "Lufttemperatur", einheit: "°C", readOnly: this.props.readOnly }),
                    React.createElement(AgtPruefortParameterKomponente, { ziel: this.props.ziel.luftfeuchtigkeit, beschriftung: "Luftfeuchtigkeit", einheit: "%", readOnly: this.props.readOnly }),
                    React.createElement(AgtPruefortParameterKomponente, { ziel: this.props.ziel.umgebungsdruck, beschriftung: "Umgebungsdruck", einheit: "mbar", readOnly: this.props.readOnly })))));
    };
    AgtPruefortParameter2 = __decorate([
        mobx_react_1.observer
    ], AgtPruefortParameter2);
    return AgtPruefortParameter2;
}(React.Component));
exports.default = AgtPruefortParameter2;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var BpsPruefortParameterKomponente = (function (_super) {
    __extends(BpsPruefortParameterKomponente, _super);
    function BpsPruefortParameterKomponente() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsPruefortParameterKomponente.prototype.handleIstWertChange = function (ev) {
        this.props.ziel.wert = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(BpsPruefortParameterKomponente.prototype, "imToleranzbereich", {
        get: function () {
            var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
            if ((wert !== null) && ((wert < min) || (wert > max))) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    BpsPruefortParameterKomponente.prototype.render = function () {
        var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "beschriftung" }, this.props.beschriftung),
            React.createElement("td", { className: "min" }, min),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: wert === null ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: this.store.readOnly, onChange: this.handleIstWertChange, value: wert !== null ? wert : '', className: wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, this.props.einheit)))),
            React.createElement("td", { className: "max" }, max)));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsPruefortParameterKomponente.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsPruefortParameterKomponente.prototype, "handleIstWertChange", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsPruefortParameterKomponente.prototype, "imToleranzbereich", null);
    BpsPruefortParameterKomponente = __decorate([
        mobx_react_1.observer
    ], BpsPruefortParameterKomponente);
    return BpsPruefortParameterKomponente;
}(React.Component));
/**
 * Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Bremsenprüfstand
 */
var BpsPruefortParameter = (function (_super) {
    __extends(BpsPruefortParameter, _super);
    function BpsPruefortParameter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsPruefortParameter.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-pruefortparameter" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Min."),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Max."))),
                React.createElement("tbody", null,
                    React.createElement(BpsPruefortParameterKomponente, { ziel: this.props.ziel.lufttemperatur, beschriftung: "Lufttemperatur", einheit: "°C" }),
                    React.createElement(BpsPruefortParameterKomponente, { ziel: this.props.ziel.luftfeuchtigkeit, beschriftung: "Luftfeuchtigkeit", einheit: "%" })))));
    };
    BpsPruefortParameter = __decorate([
        mobx_react_1.observer
    ], BpsPruefortParameter);
    return BpsPruefortParameter;
}(React.Component));
exports.default = BpsPruefortParameter;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit = (function (_super) {
    __extends(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, _super);
    function BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype.handleValueChanged = function (ev) {
        this.props.ziel.geschwindigkeit[this.props.index] = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    Object.defineProperty(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "imToleranzbereich", {
        get: function () {
            var drehzahlschlupf = this.store.datensatz.drehzahlschlupf;
            var geschwindigkeit = this.props.ziel.geschwindigkeit[this.props.index];
            return (geschwindigkeit && (geschwindigkeit >= drehzahlschlupf.mingeschwindigkeit));
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype.render = function () {
        var geschwindigkeit = this.props.ziel.geschwindigkeit;
        return (React.createElement(react_bootstrap_1.InputGroup, null,
            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: (geschwindigkeit[this.props.index] !== undefined && geschwindigkeit[this.props.index] !== null) ? geschwindigkeit[this.props.index] : '', onChange: this.handleValueChanged, className: this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "km/h")));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "handleValueChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "imToleranzbereich", null);
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit);
    return BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit;
}(React.Component));
var BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf = (function (_super) {
    __extends(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf, _super);
    function BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype.handleValueChanged = function (ev) {
        this.props.ziel.schlupf = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "imToleranzbereich", {
        get: function () {
            var drehzahlschlupf = this.store.datensatz.drehzahlschlupf;
            var schlupf = this.props.ziel.schlupf;
            return (schlupf && (schlupf <= drehzahlschlupf.maxschlupf));
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype.render = function () {
        var schlupf = this.props.ziel.schlupf;
        return (React.createElement(react_bootstrap_1.InputGroup, null,
            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: schlupf !== null ? schlupf : '', onChange: this.handleValueChanged, className: this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "%")));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "handleValueChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "imToleranzbereich", null);
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf);
    return BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf;
}(React.Component));
/**
 * Exportierte Komponente für Eingabe und Validierung Rollendrehzahl und Abschaltschlupf
 */
var BpsReferenzkraftDrehzahlSchlupf = (function (_super) {
    __extends(BpsReferenzkraftDrehzahlSchlupf, _super);
    function BpsReferenzkraftDrehzahlSchlupf() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftDrehzahlSchlupf.prototype.render = function () {
        var drehzahlschlupf = this.store.datensatz.drehzahlschlupf;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Rollendrehzahl und Abschaltschlupf", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-drehzahl-schlupf" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Rolle links"),
                        React.createElement("th", null, "Rolle rechts"),
                        React.createElement("th", null))),
                React.createElement("tbody", null,
                    [drehzahlschlupf.links, drehzahlschlupf.rechts].map(function (rs, key) {
                        return React.createElement("tr", { key: key },
                            React.createElement("td", { className: "beschriftung" },
                                "Geschw. ",
                                key === 0 ? 'vor' : 'nach',
                                " Abbrems."),
                            [0, 1].map(function (index) {
                                return React.createElement("td", { className: "messwert", key: index },
                                    React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, { key: "" + key + index, ziel: rs, index: index }));
                            }),
                            React.createElement("td", null,
                                "\u2265 ",
                                drehzahlschlupf.mingeschwindigkeit,
                                " km/h "));
                    }),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "beschriftung" }, "Abschaltschlupf"),
                        [drehzahlschlupf.links, drehzahlschlupf.rechts].map(function (rs, key) {
                            return React.createElement("td", { className: "messwert", key: key },
                                React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf, { key: key, ziel: rs }));
                        }),
                        React.createElement("td", null,
                            "\u2264 ",
                            drehzahlschlupf.maxschlupf,
                            " %"))))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftDrehzahlSchlupf.prototype, "store", void 0);
    BpsReferenzkraftDrehzahlSchlupf = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftDrehzahlSchlupf);
    return BpsReferenzkraftDrehzahlSchlupf;
}(React.Component));
exports.default = BpsReferenzkraftDrehzahlSchlupf;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var ApiStore_1 = __webpack_require__(13);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var BpsReferenzkraftObjektInfo_1 = __webpack_require__(655);
var BpsReferenzkraftRollenDurchmesser_1 = __webpack_require__(656);
var BpsReferenzkraftRollensaetze_1 = __webpack_require__(657);
var react_bootstrap_1 = __webpack_require__(2);
var BpsPruefortParameter_1 = __webpack_require__(652);
var BpsReferenzkraftWaegezelle_1 = __webpack_require__(659);
var BpsReferenzkraftDrehzahlSchlupf_1 = __webpack_require__(653);
var BpsReferenzkraftKMGInfo_1 = __webpack_require__(169);
/**
 * Kapselkomponemnte für die BPS Kalibrierung nach Referenzkraftverfahren
 */
var BpsReferenzkraftKalibrierung = (function (_super) {
    __extends(BpsReferenzkraftKalibrierung, _super);
    function BpsReferenzkraftKalibrierung(props) {
        var _this = _super.call(this, props) || this;
        _this.kalibrierungStore.clear();
        return _this;
    }
    BpsReferenzkraftKalibrierung.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objekt, auftrag, _i, _a, obj, objektVorlage, messung;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        objekt = undefined;
                        auftrag = this.auftragStore.auftrag;
                        if (auftrag) {
                            for (_i = 0, _a = auftrag.objekte; _i < _a.length; _i++) {
                                obj = _a[_i];
                                if (obj.typ.toLocaleLowerCase() === 'bps') {
                                    objekt = obj;
                                    break;
                                }
                            }
                        }
                        this.kalibrierungStore.setKalibrierGegenstand(objekt);
                        if (!objekt) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.objektVorlage(objekt.objektguid)];
                    case 1:
                        objektVorlage = _b.sent();
                        if (objektVorlage.ok) {
                            this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
                        }
                        _b.label = 2;
                    case 2:
                        // Gespeicherte Messung übernehmen
                        if (this.props.value) {
                            messung = this.kalibrierungStore.datensatz;
                            messung = JSON.parse(this.props.value);
                            this.kalibrierungStore.setMesswerte(messung);
                        }
                        this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
                        return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierung.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(BpsReferenzkraftObjektInfo_1.default, null),
            React.createElement(BpsReferenzkraftKMGInfo_1.default, null),
            this.kalibrierungStore.objektVorlage ?
                React.createElement("div", null,
                    React.createElement(BpsPruefortParameter_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.beginn }),
                    React.createElement(BpsReferenzkraftRollenDurchmesser_1.default, null),
                    React.createElement(BpsReferenzkraftWaegezelle_1.default, null),
                    React.createElement(BpsReferenzkraftRollensaetze_1.default, null),
                    React.createElement(BpsReferenzkraftDrehzahlSchlupf_1.default, null),
                    React.createElement(BpsPruefortParameter_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.ende }))
                :
                    React.createElement("div", null, "Rufe Objektvorlage ab..."),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.kategorieguid + "[" + this.props.elementguid + "][json]", value: JSON.stringify(this.kalibrierungStore.datensatz) })));
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], BpsReferenzkraftKalibrierung.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftKalibrierung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftKalibrierung.prototype, "kalibrierungStore", void 0);
    BpsReferenzkraftKalibrierung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], BpsReferenzkraftKalibrierung);
    return BpsReferenzkraftKalibrierung;
}(React.Component));
exports.default = BpsReferenzkraftKalibrierung;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var Callout_1 = __webpack_require__(16);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
/** Komponente zur Anzeige der für die Kalibrierung relevanten Daten zum gewählten Bremsenprüfstand */
var BpsReferenzkraftObjektInfo = (function (_super) {
    __extends(BpsReferenzkraftObjektInfo, _super);
    function BpsReferenzkraftObjektInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftObjektInfo.prototype.render = function () {
        var kalibrierGegenstand = this.kalibrierungStore.kalibrierGegenstand;
        if (kalibrierGegenstand && kalibrierGegenstand.objekt) {
            var bezeichner = kalibrierGegenstand.objekt.hersteller + " " + kalibrierGegenstand.objekt.typbezeichnung + " (" + kalibrierGegenstand.meta('fzart') + ")";
            return (React.createElement(react_bootstrap_1.Panel, { header: bezeichner, collapsible: true, defaultExpanded: false },
                React.createElement("p", null, kalibrierGegenstand.objekt.art),
                React.createElement("br", null),
                React.createElement("b", null, "Hebelarml\u00E4nge:"),
                " ",
                kalibrierGegenstand.meta('hebelarmlänge'),
                " mm",
                React.createElement("br", null),
                React.createElement("b", null, "Nenndurchmesser Rolle:"),
                " ",
                kalibrierGegenstand.meta('rollendurchmesser'),
                " mm",
                React.createElement("br", null),
                React.createElement("b", null, "\u00DCbersetzung:"),
                " ",
                kalibrierGegenstand.meta('übersetzungsverhältnis_zähler'),
                " : ",
                kalibrierGegenstand.meta('übersetzungsverhältnis_nenner'),
                React.createElement("br", null),
                React.createElement("b", null, "Anzeige:"),
                " ",
                React.createElement("span", { className: "capitalize" }, kalibrierGegenstand.meta('anzeigeart')),
                " mit ",
                kalibrierGegenstand.meta('anzeigeaufloesung'),
                " N Aufl\u00F6sung",
                React.createElement("br", null)));
        }
        else {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Es wurde noch kein Bremsenpr\u00FCfstand im Auftrag ausgew\u00E4hlt!")));
        }
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], BpsReferenzkraftObjektInfo.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftObjektInfo.prototype, "kalibrierungStore", void 0);
    BpsReferenzkraftObjektInfo = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftObjektInfo);
    return BpsReferenzkraftObjektInfo;
}(React.Component));
exports.default = BpsReferenzkraftObjektInfo;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
var round_1 = __webpack_require__(33);
var numberformat_1 = __webpack_require__(56);
var BpsReferenzkraftRollenDurchmesserMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesserMesspunkt, _super);
    function BpsReferenzkraftRollenDurchmesserMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollenDurchmesserMesspunkt.prototype.handleValueChanged = function (event) {
        var _a = this.props, x = _a.x, y = _a.y;
        this.store.setMesswert(x, y, parseFloat(event.target.value));
    };
    BpsReferenzkraftRollenDurchmesserMesspunkt.prototype.render = function () {
        var _a = this.props, x = _a.x, y = _a.y;
        var messwerte = this.store.datensatz.rollendurchmesser.messwerte;
        return (React.createElement("td", null,
            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: (messwerte[x][y] !== undefined && messwerte[x][y] !== null) ? messwerte[x][y] : '', onChange: this.handleValueChanged })));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftRollenDurchmesserMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesserMesspunkt.prototype, "handleValueChanged", null);
    BpsReferenzkraftRollenDurchmesserMesspunkt = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesserMesspunkt);
    return BpsReferenzkraftRollenDurchmesserMesspunkt;
}(React.Component));
var BpsReferenzkraftRollenDurchmesserMessreihe = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesserMessreihe, _super);
    function BpsReferenzkraftRollenDurchmesserMessreihe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollenDurchmesserMessreihe.prototype.render = function () {
        var _this = this;
        return (React.createElement("tr", null,
            React.createElement("td", { style: { whiteSpace: 'nowrap' } }, this.props.caption),
            [0, 1, 2, 3].map(function (x) { return (React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { key: x, x: x, y: _this.props.index })); })));
    };
    BpsReferenzkraftRollenDurchmesserMessreihe = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesserMessreihe);
    return BpsReferenzkraftRollenDurchmesserMessreihe;
}(React.Component));
var BpsReferenzkraftRollenDurchmesserMittelwerte = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesserMittelwerte, _super);
    function BpsReferenzkraftRollenDurchmesserMittelwerte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BpsReferenzkraftRollenDurchmesserMittelwerte.prototype, "nenndurchmesser", {
        get: function () {
            var kalibrierGegenstand = this.kalibrierungStore.kalibrierGegenstand;
            if (!kalibrierGegenstand) {
                return undefined;
            }
            var rollendurchmesser = kalibrierGegenstand.meta('rollendurchmesser');
            if (rollendurchmesser) {
                return parseFloat(rollendurchmesser);
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftRollenDurchmesserMittelwerte.prototype.renderMittelwert = function (wertabsolut, position) {
        if (!wertabsolut || !this.nenndurchmesser) {
            return React.createElement("div", null, "-");
        }
        var durchmesserRelativ = round_1.round(wertabsolut / this.nenndurchmesser * 100, 1);
        var cssClass = durchmesserRelativ < 98 ? 'mittelwert-error' : 'mittelwert-success';
        return (React.createElement("div", { className: cssClass },
            numberformat_1.numberformat(wertabsolut),
            " (",
            React.createElement("span", { className: cssClass },
                numberformat_1.numberformat(durchmesserRelativ),
                "%"),
            ")"));
    };
    BpsReferenzkraftRollenDurchmesserMittelwerte.prototype.render = function () {
        var datensatz = this.kalibrierungStore.datensatz;
        return (React.createElement("tr", null,
            React.createElement("td", null, "Mittelwert (wirksam)"),
            React.createElement("td", { colSpan: 2 }, this.renderMittelwert(datensatz.rollendurchmesser.mittelwert.links, 'links')),
            React.createElement("td", { colSpan: 2 }, this.renderMittelwert(datensatz.rollendurchmesser.mittelwert.rechts, 'rechts'))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftRollenDurchmesserMittelwerte.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftRollenDurchmesserMittelwerte.prototype, "nenndurchmesser", null);
    BpsReferenzkraftRollenDurchmesserMittelwerte = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesserMittelwerte);
    return BpsReferenzkraftRollenDurchmesserMittelwerte;
}(React.Component));
/**
 * Exportierte Komponente für Eingabe und Berechnungen Rollendurchmesser BPS für das Verfahren Referenzkraftmessung
 */
var BpsReferenzkraftRollenDurchmesser = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesser, _super);
    function BpsReferenzkraftRollenDurchmesser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollenDurchmesser.prototype.componentDidMount = function () {
        this.store.berechneMittelwerteRolle();
    };
    BpsReferenzkraftRollenDurchmesser.prototype.handleOberflaecheChanged = function (event) {
        this.store.setOberflaeche(event.target.value);
        this.store.berechneMittelwerteRolle();
    };
    BpsReferenzkraftRollenDurchmesser.prototype.handleMessungChanged = function (event) {
        this.store.setMessart(event.target.value);
        this.store.berechneMittelwerteRolle();
    };
    BpsReferenzkraftRollenDurchmesser.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: "Rollendurchmesser", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Col, { sm: 6 },
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Oberfläche" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Oberfl\u00E4che"),
                    React.createElement(react_bootstrap_1.Col, { sm: 8, className: "text-va-middle" },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", onChange: this.handleOberflaecheChanged, defaultValue: this.store.datensatz.oberflaeche, disabled: this.store.readOnly },
                            React.createElement("option", { value: "beschichtet" }, "Beschichtet"),
                            React.createElement("option", { value: "geschweisst" }, "Geschwei\u00DFt"))))),
            React.createElement(react_bootstrap_1.Col, { sm: 6 },
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messung" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messung"),
                    React.createElement(react_bootstrap_1.Col, { sm: 8 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", onChange: this.handleMessungChanged, defaultValue: this.store.datensatz.messart, disabled: this.store.readOnly },
                            React.createElement("option", { value: "durchmesser" }, "Durchmesser"),
                            React.createElement("option", { value: "umfang" }, "Umfang"))))),
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-eingabe-rolle" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", { colSpan: 2 }, "Rolle links [mm]"),
                        React.createElement("th", { colSpan: 2 }, "Rolle rechts [mm]")),
                    React.createElement("tr", null,
                        React.createElement("th", null, "Messpunkt"),
                        React.createElement("th", null, "Vorne"),
                        React.createElement("th", null, "Hinten"),
                        React.createElement("th", null, "Vorne"),
                        React.createElement("th", null, "Hinten"))),
                React.createElement("tbody", null,
                    React.createElement(BpsReferenzkraftRollenDurchmesserMessreihe, { index: 0, caption: "10 cm rechts der Mitte" }),
                    React.createElement(BpsReferenzkraftRollenDurchmesserMessreihe, { index: 1, caption: "Mitte der Rolle" }),
                    React.createElement(BpsReferenzkraftRollenDurchmesserMessreihe, { index: 2, caption: "10 cm links der Mitte" }),
                    React.createElement(BpsReferenzkraftRollenDurchmesserMittelwerte, null)))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "handleOberflaecheChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "handleMessungChanged", null);
    BpsReferenzkraftRollenDurchmesser = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesser);
    return BpsReferenzkraftRollenDurchmesser;
}(React.Component));
exports.default = BpsReferenzkraftRollenDurchmesser;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var ApiStore_1 = __webpack_require__(13);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftVorbelastungRolle_1 = __webpack_require__(658);
var Callout_1 = __webpack_require__(16);
var round_1 = __webpack_require__(33);
var BpsReferenzkraftRollensatzMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftRollensatzMesspunkt, _super);
    function BpsReferenzkraftRollensatzMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollensatzMesspunkt.prototype.validate = function () {
        if (this.props.validieren) {
            return (this.props.ziel.messwerte.every(function (mw) { return mw !== null; }));
        }
        return true;
    };
    BpsReferenzkraftRollensatzMesspunkt.prototype.handleMesswertChanged = function (index, ev) {
        this.props.ziel.messwerte[index] = ev.target.value !== '' ? ev.target.valueAsNumber : null;
        this.props.onChangeHandler();
    };
    BpsReferenzkraftRollensatzMesspunkt.prototype.render = function () {
        var _this = this;
        var messwerte = this.props.ziel.messwerte;
        return (React.createElement("tr", null,
            React.createElement("td", null, this.props.ziel.anzeige),
            React.createElement("td", null, this.props.ziel.normal),
            messwerte.map(function (wert, index) {
                return React.createElement("td", { key: index },
                    React.createElement(react_bootstrap_1.FormGroup, { validationState: _this.validate() ? undefined : 'error', style: { margin: '0px' } },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", onChange: function (e) { return _this.handleMesswertChanged(index, e); }, readOnly: _this.store.readOnly, value: (wert !== undefined && wert !== null) ? wert : '' }))));
            }),
            React.createElement("td", { style: { fontSize: '10px' } }, this.props.ziel.mittelwertabweichung && round_1.round(this.props.ziel.mittelwertabweichung, 3)),
            React.createElement("td", { style: { fontSize: '10px' } }, this.props.ziel.messunsicherheit && round_1.round(this.props.ziel.messunsicherheit, 3)),
            React.createElement("td", { style: { fontSize: '10px' } }, this.props.ziel.fehlergrenze),
            React.createElement("td", null,
                React.createElement("div", { className: this.props.ziel.konformitaet ? "konformitaet-" + this.props.ziel.konformitaet.toLowerCase() : 'konformitaet-x', style: { width: '48px' } },
                    " ",
                    this.props.ziel.konformitaet ? this.props.ziel.konformitaet : '-'))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftRollensatzMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensatzMesspunkt.prototype, "handleMesswertChanged", null);
    BpsReferenzkraftRollensatzMesspunkt = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatzMesspunkt);
    return BpsReferenzkraftRollensatzMesspunkt;
}(React.Component));
var BpsReferenzkraftRollensatzMesswertEingabe = (function (_super) {
    __extends(BpsReferenzkraftRollensatzMesswertEingabe, _super);
    function BpsReferenzkraftRollensatzMesswertEingabe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BpsReferenzkraftRollensatzMesswertEingabe.prototype, "nullpunktVollstaendig", {
        /**
         * Ermittelt ob der Nullpunkt komplett erfasst wurde
         * Dieser wird für die Betrachtung der Konformitätsaussagen benötigt
         */
        get: function () {
            var ziel = this.props.ziel;
            return ziel.messpunkte[0].messwerte.every(function (wert) { return wert !== null; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BpsReferenzkraftRollensatzMesswertEingabe.prototype, "messpunkteNachNullpunktErfasst", {
        /**
         * Ermittelt ob neben dem Nullpunkt bereits weitere Messpunkte erfasst wurden
         * Wird genutzt um zu visualisieren dass die Beurteilung erst abgerufen wird wenn der Nullpunkt erfasst wurde
         */
        get: function () {
            var werteVorhanden = false;
            this.props.ziel.messpunkte.forEach(function (mp, index) {
                if ((index > 0) && (mp.messwerte.some(function (mw) { return mw !== null; }))) {
                    werteVorhanden = true;
                }
            });
            return werteVorhanden;
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftRollensatzMesswertEingabe.prototype.render = function () {
        var _this = this;
        var datensatz = this.store.datensatz;
        var ziel = this.props.ziel;
        if (ziel.messpunkte.length > 0 && this.store.messbereichGueltig()) {
            return (React.createElement("div", null,
                datensatz.anzeige === 'analog' && 'Einstellung am BPS, Anzeige am Normal',
                datensatz.anzeige === 'digital' && 'Einstellung am Normal, Anzeige am BPS',
                React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-auswertung" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Anzeige"),
                            React.createElement("th", null, "Normal"),
                            React.createElement("th", null,
                                "F",
                                React.createElement("sub", null, "1")),
                            React.createElement("th", null,
                                "F",
                                React.createElement("sub", null, "2")),
                            React.createElement("th", null,
                                "F",
                                React.createElement("sub", null, "3")),
                            React.createElement("th", null, "MWA"),
                            React.createElement("th", null, "MU"),
                            React.createElement("th", null, "FG"),
                            React.createElement("th", { style: { width: '48px' } }, "Fall"))),
                    React.createElement("tbody", null, ziel.messpunkte.map(function (mp, index) {
                        return React.createElement(BpsReferenzkraftRollensatzMesspunkt, { key: index, onChangeHandler: function () { return _this.store.beurteilungAbrufenDelayed(ziel); }, ziel: mp, validieren: index === 0 && _this.messpunkteNachNullpunktErfasst });
                    })))));
        }
        else {
            return (React.createElement("div", null, "Die Messwerteingabe ist erst nach Auswahl der BPS-Daten m\u00F6glich."));
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftRollensatzMesswertEingabe.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftRollensatzMesswertEingabe.prototype, "store", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftRollensatzMesswertEingabe.prototype, "nullpunktVollstaendig", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftRollensatzMesswertEingabe.prototype, "messpunkteNachNullpunktErfasst", null);
    BpsReferenzkraftRollensatzMesswertEingabe = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatzMesswertEingabe);
    return BpsReferenzkraftRollensatzMesswertEingabe;
}(React.Component));
var BpsReferenzkraftRollensatz = (function (_super) {
    __extends(BpsReferenzkraftRollensatz, _super);
    function BpsReferenzkraftRollensatz() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollensatz.prototype.render = function () {
        var ziel = this.props.ziel;
        var header = 'Rollensatz ' + ziel.position;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { header: header + " - Vorbelastung", collapsible: true, defaultExpanded: true },
                React.createElement(BpsReferenzkraftVorbelastungRolle_1.default, { ziel: ziel })),
            React.createElement(react_bootstrap_1.Panel, { header: header + " - Messung", collapsible: true, defaultExpanded: true },
                React.createElement(BpsReferenzkraftRollensatzMesswertEingabe, { ziel: ziel }))));
    };
    BpsReferenzkraftRollensatz = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatz);
    return BpsReferenzkraftRollensatz;
}(React.Component));
/**
 * Exportierte Komponente für die Messwerteingabe und -auswertung der BPS Rollensätze links und rechts
 */
var BpsReferenzkraftRollensaetze = (function (_super) {
    __extends(BpsReferenzkraftRollensaetze, _super);
    function BpsReferenzkraftRollensaetze() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messpunkte = [];
        return _this;
    }
    BpsReferenzkraftRollensaetze.prototype.setReferenzpunkte = function (referenzpunkte) {
        var rollensatz = this.store.datensatz.rollensatz;
        var anzahlReferenzpunkte = referenzpunkte.length;
        // Anzahl der Messpunkte der Rollensätze an Anzahl der Referenzmesspunkte anpassen
        if (referenzpunkte.length !== rollensatz.links.messpunkte.length || referenzpunkte.length || rollensatz.rechts.messpunkte.length) {
            [rollensatz.links, rollensatz.rechts].forEach(function (rs) {
                if (rs.messpunkte.length < referenzpunkte.length) {
                    // Mehr Referenzpunkte als Messpunkte
                    for (var i = rs.messpunkte.length; i < anzahlReferenzpunkte; i++) {
                        rs.messpunkte.push({
                            anzeige: 0,
                            normal: 0,
                            mittelwert: undefined,
                            mittelwertabweichung: null,
                            fehlergrenze: 0,
                            messunsicherheit: null,
                            messwerte: [null, null, null],
                            konformitaet: null
                        });
                    }
                }
                else if (rs.messpunkte.length > anzahlReferenzpunkte) {
                    rs.messpunkte = rs.messpunkte.slice(0, anzahlReferenzpunkte);
                }
                // Daten aus Referenzpunkten übernehmen
                referenzpunkte.forEach(function (rp, index) {
                    rs.messpunkte[index].anzeige = rp.anzeige;
                    rs.messpunkte[index].normal = rs.position === 'links' ? rp.normal.links : rp.normal.rechts;
                    rs.messpunkte[index].fehlergrenze = rp.fehlergrenze;
                });
            });
        }
    };
    BpsReferenzkraftRollensaetze.prototype.messpunkteAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, datensatz, kalibrierGegenstand, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.store, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
                        if (!(kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich && datensatz.rollendurchmesser.mittelwert.links && datensatz.rollendurchmesser.mittelwert.rechts)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.store.messpunkteAbrufen()];
                    case 1:
                        response = _b.sent();
                        if (response && response.ok) {
                            this.setReferenzpunkte(response.json);
                        }
                        else {
                            // @todo: Hinweis/Ergebnis bereinigen
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftRollensaetze.prototype.handleMessbereichChanged = function (event) {
        this.store.setMessbereich(event.target.value);
        this.messpunkteAbrufen();
        this.store.beurteilungAbrufenGesamt();
    };
    BpsReferenzkraftRollensaetze.prototype.handleMessbereichKleinChanged = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                val = parseInt(event.target.value, 10);
                this.store.setMessbereichKlein(!isNaN(val) ? val : undefined);
                this.messpunkteAbrufen();
                this.store.beurteilungAbrufenGesamt();
                return [2 /*return*/];
            });
        });
    };
    BpsReferenzkraftRollensaetze.prototype.handleMessbereichGrossChanged = function (event) {
        var val = parseInt(event.target.value, 10);
        this.store.setMessbereichGross(!isNaN(val) ? val : undefined);
        this.messpunkteAbrufen();
        this.store.beurteilungAbrufenGesamt();
    };
    BpsReferenzkraftRollensaetze.prototype.renderOptionen = function () {
        var _a = this.store, datensatz = _a.datensatz, messbereiche = _a.messbereiche;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messbereich" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messbereich"),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleMessbereichChanged, value: datensatz.messbereich, disabled: this.store.readOnly },
                        React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                        React.createElement("option", { value: 'klein' }, "Klein"),
                        React.createElement("option", { value: 'groß' }, "Gro\u00DF"),
                        React.createElement("option", { value: 'kombiniert' }, "Kombiniert")))),
            (datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert') &&
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messbereich (klein)" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messbereich (klein)"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleMessbereichKleinChanged, value: datensatz.messbereichKlein ? datensatz.messbereichKlein.toString() : undefined, disabled: this.store.readOnly },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            messbereiche.map(function (wert) { return React.createElement("option", { key: wert, value: wert },
                                wert,
                                " kN"); })))),
            (datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert') &&
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messbereich (groß)" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messbereich (gro\u00DF)"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleMessbereichGrossChanged, value: datensatz.messbereichGross ? datensatz.messbereichGross.toString() : undefined, disabled: this.store.readOnly },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            messbereiche.map(function (wert) { return React.createElement("option", { key: wert, value: wert },
                                wert,
                                " kN"); }))))));
    };
    BpsReferenzkraftRollensaetze.prototype.render = function () {
        var datensatz = this.store.datensatz;
        var mittelwerteVorhanden = true;
        if (!datensatz.rollendurchmesser.mittelwert.links || !datensatz.rollendurchmesser.mittelwert.rechts) {
            mittelwerteVorhanden = false;
        }
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { header: "Kalibrierung Rollensätze - BPS-Daten", collapsible: true, defaultExpanded: true }, mittelwerteVorhanden ?
                this.renderOptionen()
                :
                    React.createElement("div", { className: "text-muted" }, "Die Auswahl der BPS-Daten ist erst nach Eingabe der Rollendurchmesser m\u00F6glich")),
            (mittelwerteVorhanden && this.store.messbereichGueltig()) ?
                React.createElement("div", null,
                    React.createElement(BpsReferenzkraftRollensatz, { ziel: datensatz.rollensatz.links, rollenDurchmesser: datensatz.rollendurchmesser.mittelwert.links }),
                    React.createElement(BpsReferenzkraftRollensatz, { ziel: datensatz.rollensatz.rechts, rollenDurchmesser: datensatz.rollendurchmesser.mittelwert.rechts }))
                :
                    React.createElement(Callout_1.default, { bsStyle: "warning" }, "Zur Messwerteingabe bitte Messbereiche ausw\u00E4hlen.")));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], BpsReferenzkraftRollensaetze.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftRollensaetze.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftRollensaetze.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftRollensaetze.prototype, "messpunkte", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensaetze.prototype, "setReferenzpunkte", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftRollensaetze.prototype, "messpunkteAbrufen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensaetze.prototype, "handleMessbereichChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftRollensaetze.prototype, "handleMessbereichKleinChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensaetze.prototype, "handleMessbereichGrossChanged", null);
    BpsReferenzkraftRollensaetze = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensaetze);
    return BpsReferenzkraftRollensaetze;
}(React.Component));
exports.default = BpsReferenzkraftRollensaetze;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
/**
 * Exportierte Komponente für die Erfassung der Vorbelastung eines einzelnen Rollensatzes
 */
var BpsReferenzkraftVorbelastungRolle = (function (_super) {
    __extends(BpsReferenzkraftVorbelastungRolle, _super);
    function BpsReferenzkraftVorbelastungRolle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftVorbelastungRolle.prototype.handleWertAnzeigeChanged = function (index, ev) {
        this.props.ziel.vorbelastung.messpunkte[index].anzeige = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    BpsReferenzkraftVorbelastungRolle.prototype.handleWertNormalChanged = function (index, ev) {
        this.props.ziel.vorbelastung.messpunkte[index].normal = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    BpsReferenzkraftVorbelastungRolle.prototype.render = function () {
        var _this = this;
        var vorbelastung = this.props.ziel.vorbelastung;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-vorbelastung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Anzeige BPS"),
                        React.createElement("th", null, "Normal"))),
                React.createElement("tbody", null, vorbelastung.messpunkte.map(function (mp, index) {
                    return React.createElement("tr", { key: index },
                        React.createElement("td", { className: "beschriftung" }, index + 1 + ". Vorbelastung"),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1.0", onChange: function (e) { return _this.handleWertAnzeigeChanged(index, e); }, readOnly: _this.store.readOnly, value: mp.anzeige !== null ? mp.anzeige : '' }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1.0", onChange: function (e) { return _this.handleWertNormalChanged(index, e); }, readOnly: _this.store.readOnly, value: mp.normal !== null ? mp.normal : '' }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))));
                })))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftVorbelastungRolle.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftVorbelastungRolle.prototype, "handleWertAnzeigeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftVorbelastungRolle.prototype, "handleWertNormalChanged", null);
    BpsReferenzkraftVorbelastungRolle = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftVorbelastungRolle);
    return BpsReferenzkraftVorbelastungRolle;
}(React.Component));
exports.default = BpsReferenzkraftVorbelastungRolle;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var decorators_2 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungStore_1 = __webpack_require__(45);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftWaegezelleMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftWaegezelleMesspunkt, _super);
    function BpsReferenzkraftWaegezelleMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftWaegezelleMesspunkt.prototype.handleValueChanged = function (index, ev) {
        this.store.datensatz.waegezelle.messwerte[index] = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    BpsReferenzkraftWaegezelleMesspunkt.prototype.imToleranzbereich = function (wert) {
        var waegezelle = this.store.datensatz.waegezelle;
        if (wert === undefined) {
            return false;
        }
        return ((wert >= waegezelle.sollwert - waegezelle.toleranz) && (wert <= waegezelle.sollwert + waegezelle.toleranz));
    };
    BpsReferenzkraftWaegezelleMesspunkt.prototype.render = function () {
        var _this = this;
        var waegezelle = this.store.datensatz.waegezelle;
        return (React.createElement("tr", null,
            React.createElement("td", null,
                this.props.index + 1,
                ".Messung"),
            React.createElement("td", { className: "sollwert" }, waegezelle.sollwert),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: waegezelle.messwerte[this.props.index] ? waegezelle.messwerte[this.props.index] : '', onChange: function (e) { return _this.handleValueChanged(_this.props.index, e); }, className: this.imToleranzbereich(waegezelle.messwerte[this.props.index]) ? 'text-success' : 'text-danger' }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))),
            React.createElement("td", { className: "toleranz" },
                "\u00B1 ",
                waegezelle.toleranz,
                " N")));
    };
    __decorate([
        decorators_2.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftWaegezelleMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftWaegezelleMesspunkt.prototype, "handleValueChanged", null);
    BpsReferenzkraftWaegezelleMesspunkt = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftWaegezelleMesspunkt);
    return BpsReferenzkraftWaegezelleMesspunkt;
}(React.Component));
/**
 * Exportierte Komponente für Eingabe und Valiidierung der Wägezelle
 */
var BpsReferenzkraftWaegezelle = (function (_super) {
    __extends(BpsReferenzkraftWaegezelle, _super);
    function BpsReferenzkraftWaegezelle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftWaegezelle.prototype.render = function () {
        var waegezelle = this.store.datensatz.waegezelle;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Überprüfung der Wägezelle", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-waegezelle" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Soll"),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Toleranz"))),
                React.createElement("tbody", null, waegezelle.messwerte.map(function (mp, index) {
                    return React.createElement(BpsReferenzkraftWaegezelleMesspunkt, { key: index, index: index });
                })))));
    };
    __decorate([
        decorators_2.inject(BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungStore_1.BpsReferenzkraftKalibrierungStore)
    ], BpsReferenzkraftWaegezelle.prototype, "store", void 0);
    BpsReferenzkraftWaegezelle = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftWaegezelle);
    return BpsReferenzkraftWaegezelle;
}(React.Component));
exports.default = BpsReferenzkraftWaegezelle;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftKalibrierungPlatteStore_1 = __webpack_require__(74);
var BpsPruefortParameterKomponente = (function (_super) {
    __extends(BpsPruefortParameterKomponente, _super);
    function BpsPruefortParameterKomponente() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsPruefortParameterKomponente.prototype.handleIstWertChange = function (ev) {
        this.props.ziel.wert = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(BpsPruefortParameterKomponente.prototype, "imToleranzbereich", {
        get: function () {
            var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
            if ((wert !== null) && ((wert < min) || (wert > max))) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    BpsPruefortParameterKomponente.prototype.render = function () {
        var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "beschriftung" }, this.props.beschriftung),
            React.createElement("td", { className: "min" }, min),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: wert === null ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: this.store.readOnly, onChange: this.handleIstWertChange, value: wert !== null ? wert : '', className: wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, this.props.einheit)))),
            React.createElement("td", { className: "max" }, max)));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsPruefortParameterKomponente.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsPruefortParameterKomponente.prototype, "handleIstWertChange", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsPruefortParameterKomponente.prototype, "imToleranzbereich", null);
    BpsPruefortParameterKomponente = __decorate([
        mobx_react_1.observer
    ], BpsPruefortParameterKomponente);
    return BpsPruefortParameterKomponente;
}(React.Component));
/** Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Bremsenprüfstand */
var BpsPruefortParameter = (function (_super) {
    __extends(BpsPruefortParameter, _super);
    function BpsPruefortParameter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsPruefortParameter.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-pruefortparameter" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Min."),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Max."))),
                React.createElement("tbody", null,
                    React.createElement(BpsPruefortParameterKomponente, { ziel: this.props.ziel.lufttemperatur, beschriftung: "Lufttemperatur", einheit: "°C" })))));
    };
    BpsPruefortParameter = __decorate([
        mobx_react_1.observer
    ], BpsPruefortParameter);
    return BpsPruefortParameter;
}(React.Component));
exports.default = BpsPruefortParameter;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var BpsReferenzkraftKalibrierungPlatteStore_1 = __webpack_require__(74);
var react_bootstrap_1 = __webpack_require__(2);
/** Komponente zum Aktivieren der Justage für die Kalibrierung von Bremsprüfständen */
var BpsReferenzkraftJustageInfo = (function (_super) {
    __extends(BpsReferenzkraftJustageInfo, _super);
    function BpsReferenzkraftJustageInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftJustageInfo.prototype.handleJustageChange = function (ev) {
        this.kalibrierungStore.setJustageInfo(ev.target.value);
    };
    BpsReferenzkraftJustageInfo.prototype.render = function () {
        return (React.createElement(Callout_1.default, { bsStyle: "default" },
            React.createElement("h4", null, "Justage"),
            React.createElement("div", { className: "text-hint-light" }, "Bitte geben Sie hier an, ob im Rahmen der Kalibrierung eine Justage, Reparatur oder Neuinstallation durchgef\u00FChrt wurde."),
            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleJustageChange, value: this.kalibrierungStore.datensatz.justageInfo, disabled: this.kalibrierungStore.readOnly },
                React.createElement("option", { value: 'keine' }, "Nicht erforderlich"),
                React.createElement("option", { value: 'justage' }, "Durchgef\u00FChrt"),
                React.createElement("option", { value: 'reparatur' }, "Reparatur/Instandsetzung durchgef\u00FChrt"),
                React.createElement("option", { value: 'neuinstallation' }, "Neuinstallation"))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftJustageInfo.prototype, "kalibrierungStore", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftJustageInfo.prototype, "handleJustageChange", null);
    BpsReferenzkraftJustageInfo = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftJustageInfo);
    return BpsReferenzkraftJustageInfo;
}(React.Component));
exports.default = BpsReferenzkraftJustageInfo;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var ApiStore_1 = __webpack_require__(13);
var BpsReferenzkraftKalibrierungPlatteStore_1 = __webpack_require__(74);
var BpsPruefortParameter_1 = __webpack_require__(660);
var BpsReferenzkraftKMGInfo_1 = __webpack_require__(169);
var ApiTypesBps = __webpack_require__(281);
var Callout_1 = __webpack_require__(16);
var BpsReferenzkraftPlattensaetze_1 = __webpack_require__(663);
var BpsReferenzkraftWaegezelle_1 = __webpack_require__(665);
/** Kapselkomponente für die Kalibrierung von Plattenbremsprüfständen nach Referenzkraftverfahren nach Richtlinie 2021 */
var BpsReferenzkraftKalibrierungPlatteRili2021 = (function (_super) {
    __extends(BpsReferenzkraftKalibrierungPlatteRili2021, _super);
    function BpsReferenzkraftKalibrierungPlatteRili2021(props) {
        var _this = _super.call(this, props) || this;
        _this.kalibrierungStore.clear();
        return _this;
    }
    BpsReferenzkraftKalibrierungPlatteRili2021.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgang, kmg, bps, response, messung;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgang = this.vorgangStore.vorgang;
                        if (!(vorgang && vorgang.objekte)) return [3 /*break*/, 2];
                        kmg = vorgang.arbeitsmittel.find(function (e) { return e.typ.toLowerCase() === 'bps_kmg'; });
                        this.kalibrierungStore.setKraftMessGeraet(kmg);
                        bps = vorgang.objekte.find(function (e) { return e.typ.toLowerCase() === 'bps'; });
                        this.kalibrierungStore.setKalibrierGegenstand(bps);
                        if (!bps) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.objektVorlage(bps.objektguid)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.kalibrierungStore.setObjektVorlage(response.json);
                        }
                        _a.label = 2;
                    case 2:
                        // Gespeicherte Messung übernehmen
                        if (this.props.value) {
                            messung = this.kalibrierungStore.datensatz;
                            messung = JSON.parse(this.props.value);
                            this.kalibrierungStore.setMesswerte(messung);
                        }
                        this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
                        return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierungPlatteRili2021.prototype.render = function () {
        if (!this.kalibrierungStore.kalibrierGegenstand || !this.kalibrierungStore.objektVorlage || !this.kalibrierungStore.kraftMessGeraet) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Bitte w\u00E4hlen Sie f\u00FCr die Auswertung zuerst einen Plattenbremspr\u00FCfstand und ein Arbeitsmittelset mit einem Kraftmessger\u00E4t aus")));
        }
        if (this.kalibrierungStore.kalibrierGegenstand.objekt && this.kalibrierungStore.kalibrierGegenstand.objekt.art !== ApiTypesBps.BpsArt.Platte) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "Bitte w\u00E4hlen Sie f\u00FCr die Auswertung einen Plattenbremspr\u00FCfstand aus (es wurde ein Rollenpr\u00FCfstand gew\u00E4hlt)")));
        }
        return (React.createElement("div", null,
            React.createElement(BpsReferenzkraftKMGInfo_1.default, null),
            React.createElement(BpsPruefortParameter_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.beginn }),
            React.createElement(BpsReferenzkraftWaegezelle_1.default, null),
            React.createElement(BpsReferenzkraftPlattensaetze_1.default, null),
            React.createElement(BpsPruefortParameter_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.ende }),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.kategorieguid + "[" + this.props.elementguid + "][json]", value: JSON.stringify(this.kalibrierungStore.datensatz) })));
    };
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], BpsReferenzkraftKalibrierungPlatteRili2021.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftKalibrierungPlatteRili2021.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftKalibrierungPlatteRili2021.prototype, "kalibrierungStore", void 0);
    BpsReferenzkraftKalibrierungPlatteRili2021 = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], BpsReferenzkraftKalibrierungPlatteRili2021);
    return BpsReferenzkraftKalibrierungPlatteRili2021;
}(React.Component));
exports.default = BpsReferenzkraftKalibrierungPlatteRili2021;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var ApiStore_1 = __webpack_require__(13);
var BpsReferenzkraftKalibrierungPlatteStore_1 = __webpack_require__(74);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftVorbelastungPlatte_1 = __webpack_require__(664);
var BpsReferenzkraftJustageInfo_1 = __webpack_require__(661);
var Callout_1 = __webpack_require__(16);
var ApiTypeFactory = __webpack_require__(54);
var BpsReferenzkraftGesamtBeurteilung_1 = __webpack_require__(276);
var BpsReferenzkraftRollensatzMesspunktBeurteilung = (function (_super) {
    __extends(BpsReferenzkraftRollensatzMesspunktBeurteilung, _super);
    function BpsReferenzkraftRollensatzMesspunktBeurteilung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype, "beurteilungMesspunkt", {
        get: function () {
            var _a = this.props, position = _a.position, index = _a.index, nachJustage = _a.nachJustage;
            var quelle = null;
            if (position === 'links') {
                quelle = nachJustage ? this.store.datensatz.plattensatzJustage.links : this.store.datensatz.plattensatz.links;
            }
            if (position === 'rechts') {
                quelle = nachJustage ? this.store.datensatz.plattensatzJustage.rechts : this.store.datensatz.plattensatz.rechts;
            }
            if ((quelle !== null) && (quelle.messpunkte.length > index)) {
                if (quelle.messpunkte[index].beurteilung !== null) {
                    return quelle.messpunkte[index].beurteilung === true ? 'i.O' : 'n.i.O';
                }
            }
            return '-';
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype.render = function () {
        var beurteilung = this.beurteilungMesspunkt;
        var className = '';
        if (beurteilung !== null) {
            className = "beurteilung-" + beurteilung.replace(/\./g, '').toLowerCase();
        }
        return React.createElement("div", { className: className }, beurteilung);
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype, "store", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype, "beurteilungMesspunkt", null);
    BpsReferenzkraftRollensatzMesspunktBeurteilung = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatzMesspunktBeurteilung);
    return BpsReferenzkraftRollensatzMesspunktBeurteilung;
}(React.Component));
var BpsReferenzkraftRollensatzMessreihe = (function (_super) {
    __extends(BpsReferenzkraftRollensatzMessreihe, _super);
    function BpsReferenzkraftRollensatzMessreihe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollensatzMessreihe.prototype.handleMesswertBpsChanged = function (index, ev) {
        this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps = ev.target.valueAsNumber;
        this.store.berechneReferenzWerte();
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.handleMesswertSensorChanged = function (index, ev) {
        this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor = ev.target.valueAsNumber;
        this.store.berechneReferenzWerte();
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.getMesswertBps = function (index) {
        var val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps;
        return (val !== null) ? val : undefined;
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.getMesswertSensor = function (index) {
        var val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor;
        return (val !== null) ? val : undefined;
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.render = function () {
        var _this = this;
        var ziel = this.props.ziel;
        return (React.createElement("div", null,
            React.createElement("h4", null,
                "Messreihe ",
                this.props.messreihe + 1),
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-auswertung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Kraftstufe"),
                        React.createElement("th", null, "Messwert BPS"),
                        React.createElement("th", null, "Referenzwert"),
                        React.createElement("th", null, "Abweichung"),
                        React.createElement("th", { style: { width: '48px' } }))),
                React.createElement("tbody", null, ziel.messpunkte.map(function (mp, index) {
                    return React.createElement("tr", { key: "mp-" + index },
                        React.createElement("td", null, mp.anzeige),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.FormGroup, { style: { margin: '0px' } },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", onChange: function (e) { return _this.handleMesswertBpsChanged(index, e); }, readOnly: _this.store.readOnly, value: _this.getMesswertBps(index) })))),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.FormGroup, { style: { margin: '0px' } },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", onChange: function (e) { return _this.handleMesswertSensorChanged(index, e); }, readOnly: _this.store.readOnly, value: _this.getMesswertSensor(index) })))),
                        React.createElement("td", null, mp.messwerte[_this.props.messreihe].messwertabweichung),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollensatzMesspunktBeurteilung, { position: ziel.position, index: index, nachJustage: _this.props.nachJustage })));
                })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "handleMesswertBpsChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "handleMesswertSensorChanged", null);
    BpsReferenzkraftRollensatzMessreihe = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatzMessreihe);
    return BpsReferenzkraftRollensatzMessreihe;
}(React.Component));
var BpsReferenzkraftPlattensatz = (function (_super) {
    __extends(BpsReferenzkraftPlattensatz, _super);
    function BpsReferenzkraftPlattensatz() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftPlattensatz.prototype.render = function () {
        var ziel = this.props.ziel;
        var header = 'Platte ' + ziel.position;
        var zusatz = '';
        if (this.props.nachJustage) {
            zusatz = 'nach Justage';
        }
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { header: header + " - Vorbelastung " + zusatz, collapsible: true, defaultExpanded: true },
                React.createElement(BpsReferenzkraftVorbelastungPlatte_1.default, { ziel: ziel })),
            React.createElement(react_bootstrap_1.Panel, { header: header + " - Messung " + zusatz, collapsible: true, defaultExpanded: true },
                React.createElement(BpsReferenzkraftRollensatzMessreihe, { messreihe: 0, ziel: ziel, nachJustage: this.props.nachJustage }),
                React.createElement(BpsReferenzkraftRollensatzMessreihe, { messreihe: 1, ziel: ziel, nachJustage: this.props.nachJustage }),
                React.createElement(BpsReferenzkraftRollensatzMessreihe, { messreihe: 2, ziel: ziel, nachJustage: this.props.nachJustage }))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftPlattensatz.prototype, "store", void 0);
    BpsReferenzkraftPlattensatz = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftPlattensatz);
    return BpsReferenzkraftPlattensatz;
}(React.Component));
/** Exportierte Komponente für die Messwerteingabe und -auswertung der BPS Plattensätze links und rechts nach 2021er Rili */
var BpsReferenzkraftPlattensaetze = (function (_super) {
    __extends(BpsReferenzkraftPlattensaetze, _super);
    function BpsReferenzkraftPlattensaetze() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messpunkte = [];
        return _this;
    }
    BpsReferenzkraftPlattensaetze.prototype.setReferenzpunkte = function (referenzpunkte) {
        var plattensatz = this.store.datensatz.plattensatz;
        var anzahlReferenzpunkte = referenzpunkte.length;
        // Anzahl der Messpunkte der Rollensätze an Anzahl der Referenzmesspunkte anpassen
        if (referenzpunkte.length !== plattensatz.links.messpunkte.length || referenzpunkte.length || plattensatz.rechts.messpunkte.length) {
            var rollensaetze = [plattensatz.links, plattensatz.rechts];
            // Bei gewählter und aktiver Justage müssen auch die Messreihen für die Eingabe nach Justage angepasst werden
            if (this.store.datensatz.justageInfo === 'justage') {
                rollensaetze.push(this.store.datensatz.plattensatz.links);
                rollensaetze.push(this.store.datensatz.plattensatz.rechts);
            }
            rollensaetze.forEach(function (rs) {
                if (rs.messpunkte.length < referenzpunkte.length) {
                    // Mehr Referenzpunkte als Messpunkte
                    for (var i = rs.messpunkte.length; i < anzahlReferenzpunkte; i++) {
                        rs.messpunkte.push(ApiTypeFactory.leererBPSMesspunktPlatte());
                    }
                }
                else if (rs.messpunkte.length > anzahlReferenzpunkte) {
                    rs.messpunkte = rs.messpunkte.slice(0, anzahlReferenzpunkte);
                }
                // Daten aus Referenzpunkten übernehmen
                referenzpunkte.forEach(function (rp, index) {
                    rs.messpunkte[index].anzeige = rp.anzeige;
                    // Messwerte BPS vorbelegen, erleichtert die Eingabe
                    rs.messpunkte[index].messwerte.forEach(function (mp) { mp.bps = rp.anzeige; });
                });
            });
        }
    };
    BpsReferenzkraftPlattensaetze.prototype.messpunkteAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, datensatz, kalibrierGegenstand, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.store, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
                        if (!(kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.store.messpunkteAbrufen()];
                    case 1:
                        response = _b.sent();
                        if (response && response.ok) {
                            this.setReferenzpunkte(response.json);
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftPlattensaetze.prototype.handleMessbereichChanged = function (event) {
        var val = parseFloat(event.target.value);
        this.store.setMessbereich(val);
        this.messpunkteAbrufen();
    };
    BpsReferenzkraftPlattensaetze.prototype.render = function () {
        var datensatz = this.store.datensatz;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { header: "Kalibrierung Plattensätze - Messbereich", collapsible: true, defaultExpanded: true },
                React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-pruefortparameter" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { style: { minWidth: '64px !important' } }, " von "),
                            React.createElement("td", { style: { maxWidth: '110px' } },
                                React.createElement(react_bootstrap_1.FormGroup, null,
                                    React.createElement(react_bootstrap_1.InputGroup, null,
                                        React.createElement(react_bootstrap_1.FormControl, { type: "number", disabled: true, value: 0 }),
                                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N")))),
                            React.createElement("td", { style: { minWidth: '64px !important' } }, " bis "),
                            React.createElement("td", { style: { maxWidth: '140px' } },
                                React.createElement(react_bootstrap_1.FormGroup, null,
                                    React.createElement(react_bootstrap_1.InputGroup, null,
                                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", onChange: this.handleMessbereichChanged, value: datensatz.messbereich, disabled: this.store.readOnly }),
                                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N")))))))),
            (this.store.messbereichGueltig()) ?
                React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Row, { style: { maxWidth: '1600px !important' } },
                        React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                            React.createElement(BpsReferenzkraftPlattensatz, { ziel: datensatz.plattensatz.links, nachJustage: false })),
                        React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                            React.createElement(BpsReferenzkraftPlattensatz, { ziel: datensatz.plattensatz.rechts, nachJustage: false }))),
                    React.createElement(BpsReferenzkraftGesamtBeurteilung_1.default, { ziel: datensatz.gesamtErgebnis, nachJustage: false }),
                    React.createElement(BpsReferenzkraftJustageInfo_1.default, null),
                    (this.store.datensatz.justageInfo === 'justage') &&
                        React.createElement("div", null,
                            React.createElement(react_bootstrap_1.Row, { style: { maxWidth: '1600px !important' } },
                                React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                                    React.createElement(BpsReferenzkraftPlattensatz, { ziel: datensatz.plattensatzJustage.links, nachJustage: true })),
                                React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                                    React.createElement(BpsReferenzkraftPlattensatz, { ziel: datensatz.plattensatzJustage.rechts, nachJustage: true }))),
                            React.createElement(BpsReferenzkraftGesamtBeurteilung_1.default, { ziel: datensatz.plattensatzJustage.gesamtErgebnis, nachJustage: true })))
                :
                    React.createElement(Callout_1.default, { bsStyle: "warning" }, "Zur Messwerteingabe bitte einen g\u00FCltigen Messbereich angeben.")));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], BpsReferenzkraftPlattensaetze.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftPlattensaetze.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftPlattensaetze.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftPlattensaetze.prototype, "messpunkte", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftPlattensaetze.prototype, "setReferenzpunkte", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftPlattensaetze.prototype, "messpunkteAbrufen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftPlattensaetze.prototype, "handleMessbereichChanged", null);
    BpsReferenzkraftPlattensaetze = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftPlattensaetze);
    return BpsReferenzkraftPlattensaetze;
}(React.Component));
exports.default = BpsReferenzkraftPlattensaetze;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungPlatteStore_1 = __webpack_require__(74);
var react_bootstrap_1 = __webpack_require__(2);
/** Exportierte Komponente für die Erfassung der Vorbelastung eines einzelnen Plattensatzes */
var BpsReferenzkraftVorbelastungPlatte = (function (_super) {
    __extends(BpsReferenzkraftVorbelastungPlatte, _super);
    function BpsReferenzkraftVorbelastungPlatte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftVorbelastungPlatte.prototype.handleWertAnzeigeChanged = function (index, ev) {
        this.props.ziel.vorbelastung.messpunkte[index].anzeige = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    BpsReferenzkraftVorbelastungPlatte.prototype.handleWertNormalChanged = function (index, ev) {
        this.props.ziel.vorbelastung.messpunkte[index].normal = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    BpsReferenzkraftVorbelastungPlatte.prototype.render = function () {
        var _this = this;
        var vorbelastung = this.props.ziel.vorbelastung;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-vorbelastung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Anzeige BPS"),
                        React.createElement("th", null, "Normal"))),
                React.createElement("tbody", null, vorbelastung.messpunkte.map(function (mp, index) {
                    return React.createElement("tr", { key: index },
                        React.createElement("td", { className: "beschriftung" }, index + 1 + ". Vorbelastung"),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1.0", onChange: function (e) { return _this.handleWertAnzeigeChanged(index, e); }, readOnly: _this.store.readOnly, value: mp.anzeige !== null ? mp.anzeige : '' }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1.0", onChange: function (e) { return _this.handleWertNormalChanged(index, e); }, readOnly: _this.store.readOnly, value: mp.normal !== null ? mp.normal : '' }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))));
                })))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftVorbelastungPlatte.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftVorbelastungPlatte.prototype, "handleWertAnzeigeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftVorbelastungPlatte.prototype, "handleWertNormalChanged", null);
    BpsReferenzkraftVorbelastungPlatte = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftVorbelastungPlatte);
    return BpsReferenzkraftVorbelastungPlatte;
}(React.Component));
exports.default = BpsReferenzkraftVorbelastungPlatte;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var decorators_2 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungPlatteStore_1 = __webpack_require__(74);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftWaegezelleMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftWaegezelleMesspunkt, _super);
    function BpsReferenzkraftWaegezelleMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftWaegezelleMesspunkt.prototype.handleValueChanged = function (index, ev) {
        this.store.datensatz.waegezelle.messwerte[index] = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    BpsReferenzkraftWaegezelleMesspunkt.prototype.imToleranzbereich = function (wert) {
        var waegezelle = this.store.datensatz.waegezelle;
        if (wert === undefined) {
            return false;
        }
        return ((wert >= waegezelle.sollwert - waegezelle.toleranz) && (wert <= waegezelle.sollwert + waegezelle.toleranz));
    };
    BpsReferenzkraftWaegezelleMesspunkt.prototype.render = function () {
        var _this = this;
        var waegezelle = this.store.datensatz.waegezelle;
        return (React.createElement("tr", null,
            React.createElement("td", null,
                this.props.index + 1,
                ".Messung"),
            React.createElement("td", { className: "sollwert" }, waegezelle.sollwert),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: waegezelle.messwerte[this.props.index] ? waegezelle.messwerte[this.props.index] : '', onChange: function (e) { return _this.handleValueChanged(_this.props.index, e); }, className: this.imToleranzbereich(waegezelle.messwerte[this.props.index]) ? 'text-success' : 'text-danger' }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))),
            React.createElement("td", { className: "toleranz" },
                "\u00B1 ",
                waegezelle.toleranz,
                " N")));
    };
    __decorate([
        decorators_2.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftWaegezelleMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftWaegezelleMesspunkt.prototype, "handleValueChanged", null);
    BpsReferenzkraftWaegezelleMesspunkt = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftWaegezelleMesspunkt);
    return BpsReferenzkraftWaegezelleMesspunkt;
}(React.Component));
/** Exportierte Komponente für Eingabe und Validierung der Wägezelle */
var BpsReferenzkraftWaegezelle = (function (_super) {
    __extends(BpsReferenzkraftWaegezelle, _super);
    function BpsReferenzkraftWaegezelle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftWaegezelle.prototype.render = function () {
        var waegezelle = this.store.datensatz.waegezelle;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Überprüfung der Wägezelle", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-waegezelle" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Soll"),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Toleranz"))),
                React.createElement("tbody", null, waegezelle.messwerte.map(function (mp, index) {
                    return React.createElement(BpsReferenzkraftWaegezelleMesspunkt, { key: index, index: index });
                })))));
    };
    __decorate([
        decorators_2.inject(BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore),
        __metadata("design:type", BpsReferenzkraftKalibrierungPlatteStore_1.BpsReferenzkraftKalibrierungPlatteStore)
    ], BpsReferenzkraftWaegezelle.prototype, "store", void 0);
    BpsReferenzkraftWaegezelle = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftWaegezelle);
    return BpsReferenzkraftWaegezelle;
}(React.Component));
exports.default = BpsReferenzkraftWaegezelle;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var BpsPruefortParameterKomponente = (function (_super) {
    __extends(BpsPruefortParameterKomponente, _super);
    function BpsPruefortParameterKomponente() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsPruefortParameterKomponente.prototype.handleIstWertChange = function (ev) {
        this.props.ziel.wert = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(BpsPruefortParameterKomponente.prototype, "imToleranzbereich", {
        get: function () {
            var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
            if ((wert !== null) && ((wert < min) || (wert > max))) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    BpsPruefortParameterKomponente.prototype.render = function () {
        var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "beschriftung" }, this.props.beschriftung),
            React.createElement("td", { className: "min" }, min),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: wert === null ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: this.store.readOnly, onChange: this.handleIstWertChange, value: wert !== null ? wert : '', className: wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, this.props.einheit)))),
            React.createElement("td", { className: "max" }, max)));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsPruefortParameterKomponente.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsPruefortParameterKomponente.prototype, "handleIstWertChange", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsPruefortParameterKomponente.prototype, "imToleranzbereich", null);
    BpsPruefortParameterKomponente = __decorate([
        mobx_react_1.observer
    ], BpsPruefortParameterKomponente);
    return BpsPruefortParameterKomponente;
}(React.Component));
/** Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Bremsenprüfstand */
var BpsPruefortParameter = (function (_super) {
    __extends(BpsPruefortParameter, _super);
    function BpsPruefortParameter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsPruefortParameter.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-pruefortparameter" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Min."),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Max."))),
                React.createElement("tbody", null,
                    React.createElement(BpsPruefortParameterKomponente, { ziel: this.props.ziel.lufttemperatur, beschriftung: "Lufttemperatur", einheit: "°C" }),
                    React.createElement(BpsPruefortParameterKomponente, { ziel: this.props.ziel.luftfeuchtigkeit, beschriftung: "Luftfeuchtigkeit", einheit: "%" })))));
    };
    BpsPruefortParameter = __decorate([
        mobx_react_1.observer
    ], BpsPruefortParameter);
    return BpsPruefortParameter;
}(React.Component));
exports.default = BpsPruefortParameter;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit = (function (_super) {
    __extends(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, _super);
    function BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype.handleValueChanged = function (ev) {
        this.props.ziel.geschwindigkeit[this.props.index] = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    Object.defineProperty(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "imToleranzbereich", {
        get: function () {
            var drehzahlschlupf = this.store.datensatz.drehzahlschlupf;
            var geschwindigkeit = this.props.ziel.geschwindigkeit[this.props.index];
            return (geschwindigkeit && (geschwindigkeit >= drehzahlschlupf.mingeschwindigkeit));
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype.render = function () {
        var geschwindigkeit = this.props.ziel.geschwindigkeit;
        return (React.createElement(react_bootstrap_1.InputGroup, null,
            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: (geschwindigkeit[this.props.index] !== undefined && geschwindigkeit[this.props.index] !== null) ? geschwindigkeit[this.props.index] : '', onChange: this.handleValueChanged, className: this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "km/h")));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "handleValueChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit.prototype, "imToleranzbereich", null);
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit);
    return BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit;
}(React.Component));
var BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf = (function (_super) {
    __extends(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf, _super);
    function BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype.handleValueChanged = function (ev) {
        this.props.ziel.schlupf = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "imToleranzbereich", {
        get: function () {
            var drehzahlschlupf = this.store.datensatz.drehzahlschlupf;
            var schlupf = this.props.ziel.schlupf;
            return (schlupf && (schlupf <= drehzahlschlupf.maxschlupf));
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype.render = function () {
        var schlupf = this.props.ziel.schlupf;
        return (React.createElement(react_bootstrap_1.InputGroup, null,
            React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: schlupf !== null ? schlupf : '', onChange: this.handleValueChanged, className: this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "%")));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "handleValueChanged", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf.prototype, "imToleranzbereich", null);
    BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf);
    return BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf;
}(React.Component));
/**
 * Exportierte Komponente für Eingabe und Validierung Rollendrehzahl und Abschaltschlupf
 */
var BpsReferenzkraftDrehzahlSchlupf = (function (_super) {
    __extends(BpsReferenzkraftDrehzahlSchlupf, _super);
    function BpsReferenzkraftDrehzahlSchlupf() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftDrehzahlSchlupf.prototype.render = function () {
        var drehzahlschlupf = this.store.datensatz.drehzahlschlupf;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Rollendrehzahl und Abschaltschlupf", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-drehzahl-schlupf" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Rolle links"),
                        React.createElement("th", null, "Rolle rechts"),
                        React.createElement("th", null))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "beschriftung" }, "Geschw. vor Abbrems."),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, { ziel: drehzahlschlupf.links, index: 0 })),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, { ziel: drehzahlschlupf.rechts, index: 0 })),
                        React.createElement("td", null,
                            "\u2265 ",
                            drehzahlschlupf.mingeschwindigkeit,
                            " km/h ")),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "beschriftung" }, "Geschw. nach Abbrems."),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, { ziel: drehzahlschlupf.links, index: 1 })),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit, { ziel: drehzahlschlupf.rechts, index: 1 })),
                        React.createElement("td", null,
                            "\u2265 ",
                            drehzahlschlupf.mingeschwindigkeit,
                            " km/h ")),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "beschriftung" }, "Abschaltschlupf"),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf, { ziel: drehzahlschlupf.links })),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf, { ziel: drehzahlschlupf.rechts })),
                        React.createElement("td", null,
                            "\u2264 ",
                            drehzahlschlupf.maxschlupf,
                            " %"))))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftDrehzahlSchlupf.prototype, "store", void 0);
    BpsReferenzkraftDrehzahlSchlupf = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftDrehzahlSchlupf);
    return BpsReferenzkraftDrehzahlSchlupf;
}(React.Component));
exports.default = BpsReferenzkraftDrehzahlSchlupf;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var react_bootstrap_1 = __webpack_require__(2);
/** Komponente zum Aktivieren der Justage für die Kalibrierung von Bremsprüfständen */
var BpsReferenzkraftJustageInfo = (function (_super) {
    __extends(BpsReferenzkraftJustageInfo, _super);
    function BpsReferenzkraftJustageInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftJustageInfo.prototype.handleJustageChange = function (ev) {
        this.kalibrierungStore.setJustageInfo(ev.target.value);
    };
    BpsReferenzkraftJustageInfo.prototype.render = function () {
        return (React.createElement(Callout_1.default, { bsStyle: "default" },
            React.createElement("h4", null, "Justage"),
            React.createElement("div", { className: "text-hint-light" }, "Bitte geben Sie hier an, ob im Rahmen der Kalibrierung eine Justage, Reparatur oder Neuinstallation durchgef\u00FChrt wurde."),
            React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleJustageChange, value: this.kalibrierungStore.datensatz.justageInfo, disabled: this.kalibrierungStore.readOnly },
                React.createElement("option", { value: 'keine' }, "Nicht erforderlich"),
                React.createElement("option", { value: 'justage' }, "Durchgef\u00FChrt"),
                React.createElement("option", { value: 'reparatur' }, "Reparatur/Instandsetzung durchgef\u00FChrt"),
                React.createElement("option", { value: 'neuinstallation' }, "Neuinstallation"))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftJustageInfo.prototype, "kalibrierungStore", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftJustageInfo.prototype, "handleJustageChange", null);
    BpsReferenzkraftJustageInfo = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftJustageInfo);
    return BpsReferenzkraftJustageInfo;
}(React.Component));
exports.default = BpsReferenzkraftJustageInfo;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var AuftragStore_1 = __webpack_require__(25);
var VorgangStore_1 = __webpack_require__(22);
var ApiStore_1 = __webpack_require__(13);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var BpsReferenzkraftRollenDurchmesser_1 = __webpack_require__(670);
var BpsReferenzkraftRollensaetze_1 = __webpack_require__(671);
var BpsPruefortParameter_1 = __webpack_require__(666);
var BpsReferenzkraftWaegezelle_1 = __webpack_require__(673);
var BpsReferenzkraftDrehzahlSchlupf_1 = __webpack_require__(667);
var BpsReferenzkraftKMGInfo_1 = __webpack_require__(169);
var Callout_1 = __webpack_require__(16);
/** Kapselkomponemnte für die BPS Kalibrierung nach Referenzkraftverfahren nach Richtlinie 2021 */
var BpsReferenzkraftKalibrierungRili2021 = (function (_super) {
    __extends(BpsReferenzkraftKalibrierungRili2021, _super);
    function BpsReferenzkraftKalibrierungRili2021(props) {
        var _this = _super.call(this, props) || this;
        _this.kalibrierungStore.clear();
        return _this;
    }
    BpsReferenzkraftKalibrierungRili2021.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objekt, vorgang, _i, _a, obj, objektVorlage, messung;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        objekt = undefined;
                        vorgang = this.vorgangStore.vorgang;
                        if (vorgang && vorgang.objekte) {
                            for (_i = 0, _a = vorgang.objekte; _i < _a.length; _i++) {
                                obj = _a[_i];
                                if (obj.typ.toLocaleLowerCase() === 'bps') {
                                    objekt = obj;
                                    break;
                                }
                            }
                        }
                        this.kalibrierungStore.setKalibrierGegenstand(objekt);
                        if (!objekt) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.objektVorlage(objekt.objektguid)];
                    case 1:
                        objektVorlage = _b.sent();
                        if (objektVorlage.ok) {
                            this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
                        }
                        _b.label = 2;
                    case 2:
                        // Gespeicherte Messung übernehmen
                        if (this.props.value) {
                            messung = this.kalibrierungStore.datensatz;
                            messung = JSON.parse(this.props.value);
                            this.kalibrierungStore.setMesswerte(messung);
                        }
                        this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
                        return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftKalibrierungRili2021.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(BpsReferenzkraftKMGInfo_1.default, null),
            (!this.kalibrierungStore.kalibrierGegenstand || !this.kalibrierungStore.objektVorlage) ?
                React.createElement(Callout_1.default, { bsStyle: "danger" },
                    React.createElement("p", null, "Bitte w\u00E4hlen Sie f\u00FCr die Auswertung zuerst einen Bremspr\u00FCfstand aus"))
                :
                    React.createElement("div", null,
                        React.createElement(BpsPruefortParameter_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.beginn }),
                        React.createElement(BpsReferenzkraftRollenDurchmesser_1.default, null),
                        React.createElement(BpsReferenzkraftWaegezelle_1.default, null),
                        React.createElement(BpsReferenzkraftRollensaetze_1.default, null),
                        React.createElement(BpsReferenzkraftDrehzahlSchlupf_1.default, null),
                        React.createElement(BpsPruefortParameter_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", ziel: this.kalibrierungStore.datensatz.pruefortparameter.ende })),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.kategorieguid + "[" + this.props.elementguid + "][json]", value: JSON.stringify(this.kalibrierungStore.datensatz) })));
    };
    __decorate([
        decorators_1.inject(AuftragStore_1.AuftragStore),
        __metadata("design:type", AuftragStore_1.AuftragStore)
    ], BpsReferenzkraftKalibrierungRili2021.prototype, "auftragStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], BpsReferenzkraftKalibrierungRili2021.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftKalibrierungRili2021.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftKalibrierungRili2021.prototype, "kalibrierungStore", void 0);
    BpsReferenzkraftKalibrierungRili2021 = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], BpsReferenzkraftKalibrierungRili2021);
    return BpsReferenzkraftKalibrierungRili2021;
}(React.Component));
exports.default = BpsReferenzkraftKalibrierungRili2021;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var react_bootstrap_2 = __webpack_require__(2);
var round_1 = __webpack_require__(33);
var numberformat_1 = __webpack_require__(56);
var BpsReferenzkraftRollenDurchmesserMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesserMesspunkt, _super);
    function BpsReferenzkraftRollenDurchmesserMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollenDurchmesserMesspunkt.prototype.handleValueChanged = function (event) {
        if (!this.store.readOnly) {
            var neuerWert = isNaN(event.target.valueAsNumber) ? null : event.target.valueAsNumber;
            this.store.setMesswertRollendurchmesser(this.props.x, this.props.y, neuerWert);
            this.store.berechneMittelwerteRolle();
        }
    };
    BpsReferenzkraftRollenDurchmesserMesspunkt.prototype.render = function () {
        var _a = this.props, x = _a.x, y = _a.y;
        var messwerte = this.store.datensatz.rollendurchmesser.messwerte;
        var mw = (messwerte[x][y] !== undefined && messwerte[x][y] !== null) ? messwerte[x][y] : undefined;
        return (React.createElement(react_bootstrap_2.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: mw ? mw : '', onChange: this.handleValueChanged }));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollenDurchmesserMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesserMesspunkt.prototype, "handleValueChanged", null);
    BpsReferenzkraftRollenDurchmesserMesspunkt = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesserMesspunkt);
    return BpsReferenzkraftRollenDurchmesserMesspunkt;
}(React.Component));
var BpsReferenzkraftRollenDurchmesserMittelwerte = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesserMittelwerte, _super);
    function BpsReferenzkraftRollenDurchmesserMittelwerte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BpsReferenzkraftRollenDurchmesserMittelwerte.prototype, "nenndurchmesser", {
        get: function () {
            var kalibrierGegenstand = this.kalibrierungStore.kalibrierGegenstand;
            if (!kalibrierGegenstand) {
                return undefined;
            }
            var rollendurchmesser = kalibrierGegenstand.meta('rollendurchmesser');
            if (rollendurchmesser) {
                return parseFloat(rollendurchmesser);
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftRollenDurchmesserMittelwerte.prototype.renderMittelwert = function (wertabsolut) {
        if (!wertabsolut || !this.nenndurchmesser) {
            return React.createElement("div", null, "-");
        }
        // Wert farblich hervorheben
        var durchmesserRelativ = round_1.round(wertabsolut / this.nenndurchmesser * 100, 1);
        var cssClass = durchmesserRelativ < 98 ? 'mittelwert-error' : 'mittelwert-success';
        return (React.createElement("div", { className: cssClass },
            numberformat_1.numberformat(wertabsolut),
            " (",
            React.createElement("span", { className: cssClass },
                numberformat_1.numberformat(durchmesserRelativ),
                "%"),
            ")"));
    };
    BpsReferenzkraftRollenDurchmesserMittelwerte.prototype.render = function () {
        var datensatz = this.kalibrierungStore.datensatz;
        return (React.createElement("tr", { style: { textAlign: 'center' } },
            React.createElement("td", { colSpan: 3 }, this.renderMittelwert(datensatz.rollendurchmesser.mittelwert.links)),
            React.createElement("td", { colSpan: 1 },
                "Kalibrier-",
                React.createElement("br", null),
                "durchmesser"),
            React.createElement("td", { colSpan: 3 }, this.renderMittelwert(datensatz.rollendurchmesser.mittelwert.rechts))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollenDurchmesserMittelwerte.prototype, "kalibrierungStore", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftRollenDurchmesserMittelwerte.prototype, "nenndurchmesser", null);
    BpsReferenzkraftRollenDurchmesserMittelwerte = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesserMittelwerte);
    return BpsReferenzkraftRollenDurchmesserMittelwerte;
}(React.Component));
/** Komponente für die Eingabe und Auswertung des Rollendurchmessers des Bremsprüfstands */
var BpsReferenzkraftRollenDurchmesser = (function (_super) {
    __extends(BpsReferenzkraftRollenDurchmesser, _super);
    function BpsReferenzkraftRollenDurchmesser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollenDurchmesser.prototype.handleOberflaecheChanged = function (event) {
        this.store.setOberflaeche(event.target.value);
        this.store.berechneMittelwerteRolle();
    };
    BpsReferenzkraftRollenDurchmesser.prototype.handleMessungChanged = function (event) {
        this.store.setMessart(event.target.value);
        this.store.berechneMittelwerteRolle();
    };
    BpsReferenzkraftRollenDurchmesser.prototype.handleGrunddurchmesserChanged = function (event) {
        this.store.setGrunddurchmesser(event.target.valueAsNumber);
        this.store.berechneMittelwerteRolle();
    };
    BpsReferenzkraftRollenDurchmesser.prototype.render = function () {
        return (React.createElement(react_bootstrap_2.Panel, { header: "Rollendurchmesser", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_2.Col, { sm: 6 },
                React.createElement(react_bootstrap_2.FormGroup, { controlId: "Oberfläche" },
                    React.createElement(react_bootstrap_2.Col, { componentClass: react_bootstrap_2.ControlLabel, sm: 4 }, "Oberfl\u00E4che"),
                    React.createElement(react_bootstrap_2.Col, { sm: 8 },
                        React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", onChange: this.handleOberflaecheChanged, value: this.store.datensatz.oberflaeche, disabled: this.store.readOnly },
                            React.createElement("option", { value: "beschichtet" }, "Beschichtet"),
                            React.createElement("option", { value: "geschweisst" }, "Geschwei\u00DFt"))))),
            React.createElement(react_bootstrap_2.Col, { sm: 6 },
                React.createElement(react_bootstrap_2.FormGroup, { controlId: "Messung" },
                    React.createElement(react_bootstrap_2.Col, { componentClass: react_bootstrap_2.ControlLabel, sm: 4 }, "Messung"),
                    React.createElement(react_bootstrap_2.Col, { sm: 8 },
                        React.createElement(react_bootstrap_2.FormControl, { componentClass: "select", onChange: this.handleMessungChanged, value: this.store.datensatz.messart, disabled: this.store.readOnly },
                            React.createElement("option", { value: "durchmesser" }, "Durchmesser"),
                            React.createElement("option", { value: "umfang" }, "Umfang"))))),
            this.store.datensatz.oberflaeche === 'geschweisst' && React.createElement(react_bootstrap_2.Col, { sm: 12 },
                React.createElement(react_bootstrap_2.FormGroup, { controlId: "Grunddurchmesser" },
                    React.createElement(react_bootstrap_2.Col, { componentClass: react_bootstrap_2.ControlLabel, sm: 8 }, "Grunddurchmesser Rolle"),
                    React.createElement(react_bootstrap_2.Col, { sm: 4 },
                        React.createElement(react_bootstrap_2.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: this.store.datensatz.rollendurchmesser.grunddurchmesser ? this.store.datensatz.rollendurchmesser.grunddurchmesser.toString() : '', onChange: this.handleGrunddurchmesserChanged })))),
            React.createElement(react_bootstrap_2.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-eingabe-rolle" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { colSpan: 3 }, "Rolle links [mm]"),
                        React.createElement("th", null),
                        React.createElement("th", { colSpan: 3 }, "Rolle rechts [mm]"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 0, y: 0 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 0, y: 1 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 0, y: 2 })),
                        React.createElement("td", { rowSpan: 3 },
                            React.createElement(react_bootstrap_1.Image, { src: __webpack_require__(692), style: { width: '56px' } }),
                            "Fahrtrichtung"),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 2, y: 0 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 2, y: 1 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 2, y: 2 }))),
                    React.createElement("tr", { className: "position" },
                        React.createElement("td", null, "10 cm links"),
                        React.createElement("td", null, "Mitte"),
                        React.createElement("td", null, "10 cm rechts"),
                        React.createElement("td", null, "10 cm links"),
                        React.createElement("td", null, "Mitte"),
                        React.createElement("td", null, "10 cm rechts")),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 1, y: 0 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 1, y: 1 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 1, y: 2 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 3, y: 0 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 3, y: 1 })),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollenDurchmesserMesspunkt, { x: 3, y: 2 })))),
                React.createElement("tfoot", null,
                    React.createElement(BpsReferenzkraftRollenDurchmesserMittelwerte, null)))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "handleOberflaecheChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "handleMessungChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollenDurchmesser.prototype, "handleGrunddurchmesserChanged", null);
    BpsReferenzkraftRollenDurchmesser = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollenDurchmesser);
    return BpsReferenzkraftRollenDurchmesser;
}(React.Component));
exports.default = BpsReferenzkraftRollenDurchmesser;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var UiStore_1 = __webpack_require__(14);
var ApiStore_1 = __webpack_require__(13);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftVorbelastungRolle_1 = __webpack_require__(672);
var BpsReferenzkraftJustageInfo_1 = __webpack_require__(668);
var Callout_1 = __webpack_require__(16);
var BpsReferenzkraftGesamtBeurteilung_1 = __webpack_require__(276);
var BpsReferenzkraftRollensatzMesspunktBeurteilung = (function (_super) {
    __extends(BpsReferenzkraftRollensatzMesspunktBeurteilung, _super);
    function BpsReferenzkraftRollensatzMesspunktBeurteilung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype, "beurteilungMesspunkt", {
        get: function () {
            var _a = this.props, position = _a.position, index = _a.index, nachJustage = _a.nachJustage;
            var quelle = null;
            if (position === 'links') {
                quelle = nachJustage ? this.store.datensatz.rollensatzJustage.links : this.store.datensatz.rollensatz.links;
            }
            if (position === 'rechts') {
                quelle = nachJustage ? this.store.datensatz.rollensatzJustage.rechts : this.store.datensatz.rollensatz.rechts;
            }
            if ((quelle !== null) && (quelle.messpunkte.length > index)) {
                if (quelle.messpunkte[index].beurteilung !== null) {
                    return quelle.messpunkte[index].beurteilung === true ? 'i.O' : 'n.i.O';
                }
            }
            return '-';
        },
        enumerable: true,
        configurable: true
    });
    BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype.render = function () {
        var beurteilung = this.beurteilungMesspunkt;
        var className = '';
        if (beurteilung !== null) {
            className = "beurteilung-" + beurteilung.replace(/\./g, '').toLowerCase();
        }
        return React.createElement("div", { className: className }, beurteilung);
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype, "store", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BpsReferenzkraftRollensatzMesspunktBeurteilung.prototype, "beurteilungMesspunkt", null);
    BpsReferenzkraftRollensatzMesspunktBeurteilung = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatzMesspunktBeurteilung);
    return BpsReferenzkraftRollensatzMesspunktBeurteilung;
}(React.Component));
var BpsReferenzkraftRollensatzMessreihe = (function (_super) {
    __extends(BpsReferenzkraftRollensatzMessreihe, _super);
    function BpsReferenzkraftRollensatzMessreihe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollensatzMessreihe.prototype.handleMesswertBpsChanged = function (index, ev) {
        this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps = ev.target.valueAsNumber;
        this.store.berechneReferenzWerte();
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.handleMesswertSensorChanged = function (index, ev) {
        this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor = ev.target.valueAsNumber;
        this.store.berechneReferenzWerte();
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.getMesswertBps = function (index) {
        var val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps;
        return (val !== null) ? val : undefined;
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.getMesswertSensor = function (index) {
        var val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor;
        return (val !== null) ? val : undefined;
    };
    BpsReferenzkraftRollensatzMessreihe.prototype.render = function () {
        var _this = this;
        var ziel = this.props.ziel;
        return (React.createElement("div", null,
            React.createElement("h4", null,
                "Messreihe ",
                this.props.messreihe + 1),
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-auswertung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Kraftstufe"),
                        React.createElement("th", null, "Messwert BPS"),
                        React.createElement("th", null, "Ref-Sensor"),
                        React.createElement("th", { title: "Referenzwert" }, "RW"),
                        React.createElement("th", { title: "Mittelwertabweichung" }, "MWA"),
                        React.createElement("th", { style: { width: '48px' } }))),
                React.createElement("tbody", null, ziel.messpunkte.map(function (mp, index) {
                    return React.createElement("tr", { key: "mp-" + index },
                        React.createElement("td", null, mp.anzeige),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.FormGroup, { style: { margin: '0px' } },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", onChange: function (e) { return _this.handleMesswertBpsChanged(index, e); }, readOnly: _this.store.readOnly, value: _this.getMesswertBps(index) })))),
                        React.createElement("td", null,
                            React.createElement(react_bootstrap_1.FormGroup, { style: { margin: '0px' } },
                                React.createElement(react_bootstrap_1.InputGroup, null,
                                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", onChange: function (e) { return _this.handleMesswertSensorChanged(index, e); }, readOnly: _this.store.readOnly, value: _this.getMesswertSensor(index) })))),
                        React.createElement("td", null, mp.messwerte[_this.props.messreihe].referenzwert),
                        React.createElement("td", null, mp.messwerte[_this.props.messreihe].messwertabweichung),
                        React.createElement("td", null,
                            React.createElement(BpsReferenzkraftRollensatzMesspunktBeurteilung, { position: ziel.position, index: index, nachJustage: _this.props.nachJustage })));
                })))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "handleMesswertBpsChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensatzMessreihe.prototype, "handleMesswertSensorChanged", null);
    BpsReferenzkraftRollensatzMessreihe = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatzMessreihe);
    return BpsReferenzkraftRollensatzMessreihe;
}(React.Component));
var BpsReferenzkraftRollensatz = (function (_super) {
    __extends(BpsReferenzkraftRollensatz, _super);
    function BpsReferenzkraftRollensatz() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftRollensatz.prototype.render = function () {
        var ziel = this.props.ziel;
        var header = 'Rollensatz ' + ziel.position;
        var zusatz = '';
        if (this.props.nachJustage) {
            zusatz = 'nach Justage';
        }
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { header: header + " - Vorbelastung " + zusatz, collapsible: true, defaultExpanded: true },
                React.createElement(BpsReferenzkraftVorbelastungRolle_1.default, { ziel: ziel })),
            React.createElement(react_bootstrap_1.Panel, { header: header + " - Messung " + zusatz, collapsible: true, defaultExpanded: true },
                React.createElement(BpsReferenzkraftRollensatzMessreihe, { messreihe: 0, ziel: ziel, nachJustage: this.props.nachJustage }),
                React.createElement(BpsReferenzkraftRollensatzMessreihe, { messreihe: 1, ziel: ziel, nachJustage: this.props.nachJustage }),
                React.createElement(BpsReferenzkraftRollensatzMessreihe, { messreihe: 2, ziel: ziel, nachJustage: this.props.nachJustage }))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollensatz.prototype, "store", void 0);
    BpsReferenzkraftRollensatz = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensatz);
    return BpsReferenzkraftRollensatz;
}(React.Component));
/** Exportierte Komponente für die Messwerteingabe und -auswertung der BPS Rollensätze links und rechts nach 2021er Rili */
var BpsReferenzkraftRollensaetze = (function (_super) {
    __extends(BpsReferenzkraftRollensaetze, _super);
    function BpsReferenzkraftRollensaetze() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messpunkte = [];
        return _this;
    }
    BpsReferenzkraftRollensaetze.prototype.setReferenzpunkte = function (referenzpunkte) {
        var rollensatz = this.store.datensatz.rollensatz;
        var anzahlReferenzpunkte = referenzpunkte.length;
        // Anzahl der Messpunkte der Rollensätze an Anzahl der Referenzmesspunkte anpassen
        if (referenzpunkte.length !== rollensatz.links.messpunkte.length || referenzpunkte.length || rollensatz.rechts.messpunkte.length) {
            var rollensaetze = [rollensatz.links, rollensatz.rechts];
            // Bei gewählter und aktiver Justage müssen auch die Messreihen für die Eingabe nach Justage angepasst werden
            if (this.store.datensatz.justageInfo === 'justage') {
                rollensaetze.push(this.store.datensatz.rollensatzJustage.links);
                rollensaetze.push(this.store.datensatz.rollensatzJustage.rechts);
            }
            rollensaetze.forEach(function (rs) {
                if (rs.messpunkte.length < referenzpunkte.length) {
                    // Mehr Referenzpunkte als Messpunkte
                    for (var i = rs.messpunkte.length; i < anzahlReferenzpunkte; i++) {
                        rs.messpunkte.push({
                            anzeige: 0,
                            mittelwert: undefined,
                            mittelwertabweichung: null,
                            messunsicherheit: null,
                            beurteilung: null,
                            messwerte: [
                                { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null },
                                { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null },
                                { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null }
                            ]
                        });
                    }
                }
                else if (rs.messpunkte.length > anzahlReferenzpunkte) {
                    rs.messpunkte = rs.messpunkte.slice(0, anzahlReferenzpunkte);
                }
                // Daten aus Referenzpunkten übernehmen
                referenzpunkte.forEach(function (rp, index) {
                    rs.messpunkte[index].anzeige = rp.anzeige;
                    // Messwerte BPS vorbelegen, erleichtert die Eingabe
                    rs.messpunkte[index].messwerte.forEach(function (mp) { mp.bps = rp.anzeige; });
                });
            });
        }
    };
    BpsReferenzkraftRollensaetze.prototype.messpunkteAbrufen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, datensatz, kalibrierGegenstand, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.store, datensatz = _a.datensatz, kalibrierGegenstand = _a.kalibrierGegenstand;
                        if (!(kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich && datensatz.rollendurchmesser.mittelwert.links && datensatz.rollendurchmesser.mittelwert.rechts)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.store.messpunkteAbrufen()];
                    case 1:
                        response = _b.sent();
                        if (response && response.ok) {
                            this.setReferenzpunkte(response.json);
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BpsReferenzkraftRollensaetze.prototype.handleMessbereichChanged = function (event) {
        this.store.setMessbereich(event.target.value);
        this.messpunkteAbrufen();
    };
    BpsReferenzkraftRollensaetze.prototype.handleMessbereichKleinChanged = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                val = parseFloat(event.target.value);
                this.store.setMessbereichKlein(!isNaN(val) ? val : undefined);
                this.messpunkteAbrufen();
                return [2 /*return*/];
            });
        });
    };
    BpsReferenzkraftRollensaetze.prototype.handleMessbereichGrossChanged = function (event) {
        var val = parseFloat(event.target.value);
        this.store.setMessbereichGross(!isNaN(val) ? val : undefined);
        this.messpunkteAbrufen();
    };
    BpsReferenzkraftRollensaetze.prototype.renderOptionen = function () {
        var _a = this.store, datensatz = _a.datensatz, messbereiche = _a.messbereiche;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messbereich" },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messbereich"),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleMessbereichChanged, value: datensatz.messbereich, disabled: this.store.readOnly },
                        React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                        React.createElement("option", { value: 'klein' }, "Klein"),
                        React.createElement("option", { value: 'groß' }, "Gro\u00DF"),
                        React.createElement("option", { value: 'kombiniert' }, "Kombiniert")))),
            (datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert') &&
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messbereich (klein)" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messbereich (klein)"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleMessbereichKleinChanged, value: datensatz.messbereichKlein ? datensatz.messbereichKlein.toString() : undefined, disabled: this.store.readOnly },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            messbereiche.map(function (wert) { return React.createElement("option", { key: wert, value: wert },
                                wert,
                                " kN"); })))),
            (datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert') &&
                React.createElement(react_bootstrap_1.FormGroup, { controlId: "Messbereich (groß)" },
                    React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 4 }, "Messbereich (gro\u00DF)"),
                    React.createElement(react_bootstrap_1.Col, { sm: 4 },
                        React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", onChange: this.handleMessbereichGrossChanged, value: datensatz.messbereichGross ? datensatz.messbereichGross.toString() : undefined, disabled: this.store.readOnly },
                            React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                            messbereiche.map(function (wert) { return React.createElement("option", { key: wert, value: wert },
                                wert,
                                " kN"); }))))));
    };
    BpsReferenzkraftRollensaetze.prototype.render = function () {
        var datensatz = this.store.datensatz;
        var mittelwerteVorhanden = true;
        if (!datensatz.rollendurchmesser.mittelwert.links || !datensatz.rollendurchmesser.mittelwert.rechts) {
            mittelwerteVorhanden = false;
        }
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Panel, { header: "Kalibrierung Rollensätze - Messbereich", collapsible: true, defaultExpanded: true }, mittelwerteVorhanden ?
                this.renderOptionen()
                :
                    React.createElement("div", { className: "text-muted" }, "Die Auswahl der BPS-Daten ist erst nach Eingabe der Rollendurchmesser m\u00F6glich")),
            (mittelwerteVorhanden && this.store.messbereichGueltig()) ?
                React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Row, { style: { maxWidth: '1600px !important' } },
                        React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                            React.createElement(BpsReferenzkraftRollensatz, { ziel: datensatz.rollensatz.links, rollenDurchmesser: datensatz.rollendurchmesser.mittelwert.links, nachJustage: false })),
                        React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                            React.createElement(BpsReferenzkraftRollensatz, { ziel: datensatz.rollensatz.rechts, rollenDurchmesser: datensatz.rollendurchmesser.mittelwert.rechts, nachJustage: false }))),
                    React.createElement(BpsReferenzkraftGesamtBeurteilung_1.default, { ziel: datensatz.gesamtErgebnis, nachJustage: false }),
                    React.createElement(BpsReferenzkraftJustageInfo_1.default, null),
                    (this.store.datensatz.justageInfo === 'justage') &&
                        React.createElement("div", null,
                            React.createElement(react_bootstrap_1.Row, { style: { maxWidth: '1600px !important' } },
                                React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                                    React.createElement(BpsReferenzkraftRollensatz, { ziel: datensatz.rollensatzJustage.links, rollenDurchmesser: datensatz.rollendurchmesser.mittelwert.links, nachJustage: true })),
                                React.createElement(react_bootstrap_1.Col, { md: 6, sm: 12 },
                                    React.createElement(BpsReferenzkraftRollensatz, { ziel: datensatz.rollensatzJustage.rechts, rollenDurchmesser: datensatz.rollendurchmesser.mittelwert.rechts, nachJustage: true }))),
                            React.createElement(BpsReferenzkraftGesamtBeurteilung_1.default, { ziel: datensatz.rollensatzJustage.gesamtErgebnis, nachJustage: true })))
                :
                    React.createElement(Callout_1.default, { bsStyle: "warning" }, "Zur Messwerteingabe bitte Messbereiche ausw\u00E4hlen.")));
    };
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], BpsReferenzkraftRollensaetze.prototype, "uiStore", void 0);
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], BpsReferenzkraftRollensaetze.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftRollensaetze.prototype, "store", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BpsReferenzkraftRollensaetze.prototype, "messpunkte", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensaetze.prototype, "setReferenzpunkte", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftRollensaetze.prototype, "messpunkteAbrufen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensaetze.prototype, "handleMessbereichChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BpsReferenzkraftRollensaetze.prototype, "handleMessbereichKleinChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftRollensaetze.prototype, "handleMessbereichGrossChanged", null);
    BpsReferenzkraftRollensaetze = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftRollensaetze);
    return BpsReferenzkraftRollensaetze;
}(React.Component));
exports.default = BpsReferenzkraftRollensaetze;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var react_bootstrap_1 = __webpack_require__(2);
/**
 * Exportierte Komponente für die Erfassung der Vorbelastung eines einzelnen Rollensatzes
 */
var BpsReferenzkraftVorbelastungRolle = (function (_super) {
    __extends(BpsReferenzkraftVorbelastungRolle, _super);
    function BpsReferenzkraftVorbelastungRolle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftVorbelastungRolle.prototype.handleWertAnzeigeChanged = function (index, ev) {
        this.props.ziel.vorbelastung.messpunkte[index].anzeige = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    BpsReferenzkraftVorbelastungRolle.prototype.handleWertNormalChanged = function (index, ev) {
        this.props.ziel.vorbelastung.messpunkte[index].normal = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    BpsReferenzkraftVorbelastungRolle.prototype.render = function () {
        var _this = this;
        var vorbelastung = this.props.ziel.vorbelastung;
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-vorbelastung" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Anzeige BPS"),
                        React.createElement("th", null, "Normal"))),
                React.createElement("tbody", null, vorbelastung.messpunkte.map(function (mp, index) {
                    return React.createElement("tr", { key: index },
                        React.createElement("td", { className: "beschriftung" }, index + 1 + ". Vorbelastung"),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1.0", onChange: function (e) { return _this.handleWertAnzeigeChanged(index, e); }, readOnly: _this.store.readOnly, value: mp.anzeige !== null ? mp.anzeige : '' }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))),
                        React.createElement("td", { className: "messwert" },
                            React.createElement(react_bootstrap_1.InputGroup, null,
                                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1.0", onChange: function (e) { return _this.handleWertNormalChanged(index, e); }, readOnly: _this.store.readOnly, value: mp.normal !== null ? mp.normal : '' }),
                                React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))));
                })))));
    };
    __decorate([
        decorators_1.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftVorbelastungRolle.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftVorbelastungRolle.prototype, "handleWertAnzeigeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftVorbelastungRolle.prototype, "handleWertNormalChanged", null);
    BpsReferenzkraftVorbelastungRolle = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftVorbelastungRolle);
    return BpsReferenzkraftVorbelastungRolle;
}(React.Component));
exports.default = BpsReferenzkraftVorbelastungRolle;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var decorators_2 = __webpack_require__(1);
var BpsReferenzkraftKalibrierungRili2021Store_1 = __webpack_require__(55);
var react_bootstrap_1 = __webpack_require__(2);
var BpsReferenzkraftWaegezelleMesspunkt = (function (_super) {
    __extends(BpsReferenzkraftWaegezelleMesspunkt, _super);
    function BpsReferenzkraftWaegezelleMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftWaegezelleMesspunkt.prototype.handleValueChanged = function (index, ev) {
        this.store.datensatz.waegezelle.messwerte[index] = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
    };
    BpsReferenzkraftWaegezelleMesspunkt.prototype.imToleranzbereich = function (wert) {
        var waegezelle = this.store.datensatz.waegezelle;
        if (wert === undefined) {
            return false;
        }
        return ((wert >= waegezelle.sollwert - waegezelle.toleranz) && (wert <= waegezelle.sollwert + waegezelle.toleranz));
    };
    BpsReferenzkraftWaegezelleMesspunkt.prototype.render = function () {
        var _this = this;
        var waegezelle = this.store.datensatz.waegezelle;
        return (React.createElement("tr", null,
            React.createElement("td", null,
                this.props.index + 1,
                ".Messung"),
            React.createElement("td", { className: "sollwert" }, waegezelle.sollwert),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", readOnly: this.store.readOnly, value: waegezelle.messwerte[this.props.index] ? waegezelle.messwerte[this.props.index] : '', onChange: function (e) { return _this.handleValueChanged(_this.props.index, e); }, className: this.imToleranzbereich(waegezelle.messwerte[this.props.index]) ? 'text-success' : 'text-danger' }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, null, "N"))),
            React.createElement("td", { className: "toleranz" },
                "\u00B1 ",
                waegezelle.toleranz,
                " N")));
    };
    __decorate([
        decorators_2.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftWaegezelleMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], BpsReferenzkraftWaegezelleMesspunkt.prototype, "handleValueChanged", null);
    BpsReferenzkraftWaegezelleMesspunkt = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftWaegezelleMesspunkt);
    return BpsReferenzkraftWaegezelleMesspunkt;
}(React.Component));
/** Exportierte Komponente für Eingabe und Validierung der Wägezelle */
var BpsReferenzkraftWaegezelle = (function (_super) {
    __extends(BpsReferenzkraftWaegezelle, _super);
    function BpsReferenzkraftWaegezelle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BpsReferenzkraftWaegezelle.prototype.render = function () {
        var waegezelle = this.store.datensatz.waegezelle;
        return (React.createElement(react_bootstrap_1.Panel, { header: "Überprüfung der Wägezelle", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-waegezelle" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Soll"),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Toleranz"))),
                React.createElement("tbody", null, waegezelle.messwerte.map(function (mp, index) {
                    return React.createElement(BpsReferenzkraftWaegezelleMesspunkt, { key: index, index: index });
                })))));
    };
    __decorate([
        decorators_2.inject(BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store),
        __metadata("design:type", BpsReferenzkraftKalibrierungRili2021Store_1.BpsReferenzkraftKalibrierungRili2021Store)
    ], BpsReferenzkraftWaegezelle.prototype, "store", void 0);
    BpsReferenzkraftWaegezelle = __decorate([
        mobx_react_1.observer
    ], BpsReferenzkraftWaegezelle);
    return BpsReferenzkraftWaegezelle;
}(React.Component));
exports.default = BpsReferenzkraftWaegezelle;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var Callout_1 = __webpack_require__(16);
var DmgPruefortParameter_1 = __webpack_require__(675);
var decorators_2 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var react_bootstrap_1 = __webpack_require__(2);
var KalibrierGegenstand_1 = __webpack_require__(112);
var DmgKalibrierungStore_1 = __webpack_require__(284);
var DmgArtMessung;
(function (DmgArtMessung) {
    DmgArtMessung[DmgArtMessung["Aufsteigend"] = 0] = "Aufsteigend";
    DmgArtMessung[DmgArtMessung["Absteigend"] = 1] = "Absteigend";
})(DmgArtMessung || (DmgArtMessung = {}));
var DmgMesspunkt = (function (_super) {
    __extends(DmgMesspunkt, _super);
    function DmgMesspunkt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgMesspunkt.prototype.handleMesswertM1Changed = function (event) {
        var value = event.target.value !== '' ? event.target.valueAsNumber : null;
        var id = event.target.id;
        this.props.ziel.m1[id] = value;
    };
    DmgMesspunkt.prototype.handleMesswertM2Changed = function (event) {
        var value = event.target.value !== '' ? event.target.valueAsNumber : null;
        var id = event.target.id;
        this.props.ziel.m2[id] = value;
    };
    DmgMesspunkt.prototype.render = function () {
        var _this = this;
        var _a = this.props, ziel = _a.ziel, editable = _a.editable, schrittweite = _a.schrittweite;
        return (React.createElement("tr", null,
            React.createElement("td", { style: { textAlign: 'center' } }, this.props.ziel.index),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", readOnly: true, value: this.props.ziel.nenndruck, tabIndex: -1 }),
                    React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar"))),
            React.createElement("td", null, this.props.art === DmgArtMessung.Aufsteigend ?
                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", id: "normal", readOnly: !editable, onChange: function (e) { return _this.handleMesswertM1Changed(e); }, value: ziel.m1.normal !== null ? ziel.m1.normal : '' })
                :
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "0.1", id: "normal", readOnly: !editable, onChange: function (e) { return _this.handleMesswertM2Changed(e); }, value: ziel.m2.normal !== null ? ziel.m2.normal : '' })),
            React.createElement("td", null, this.props.art === DmgArtMessung.Aufsteigend ?
                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: schrittweite, id: "anzeige", readOnly: !editable, onChange: function (e) { return _this.handleMesswertM1Changed(e); }, value: ziel.m1.anzeige !== null ? ziel.m1.anzeige : '' })
                :
                    React.createElement(react_bootstrap_1.FormControl, { type: "number", step: schrittweite, id: "anzeige", readOnly: !editable, onChange: function (e) { return _this.handleMesswertM2Changed(e); }, value: ziel.m2.anzeige !== null ? ziel.m2.anzeige : '' }))));
    };
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgMesspunkt.prototype, "store", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgMesspunkt.prototype, "handleMesswertM1Changed", null);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgMesspunkt.prototype, "handleMesswertM2Changed", null);
    DmgMesspunkt = __decorate([
        mobx_react_1.observer
    ], DmgMesspunkt);
    return DmgMesspunkt;
}(React.Component));
var DmgKalibrierungHaltezeit = (function (_super) {
    __extends(DmgKalibrierungHaltezeit, _super);
    function DmgKalibrierungHaltezeit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgKalibrierungHaltezeit.prototype.handleHaltezeitEingehaltenChange = function (ev) {
        this.store.setHalteZeitEingehalten(ev.target.checked);
    };
    DmgKalibrierungHaltezeit.prototype.render = function () {
        var haltezeit = 0;
        // Die Haltezeit hängt von der Art des Kalibriergegenstands ab
        if (this.props.kalibrierGegenstand) {
            var meta = this.props.kalibrierGegenstand.meta('anzeige');
            if (meta) {
                if (meta.indexOf('analog') > -1) {
                    haltezeit = 5;
                }
                else if (meta.indexOf('digital') > -1) {
                    haltezeit = 2;
                }
            }
        }
        return (React.createElement(Callout_1.default, { bsStyle: this.store.datensatz.haltezeiteingehalten ? 'success' : 'danger' },
            React.createElement(react_bootstrap_1.Checkbox, { inline: true, disabled: this.store.readOnly, onChange: !this.store.readOnly ? this.handleHaltezeitEingehaltenChange : undefined, defaultChecked: this.store.datensatz.haltezeiteingehalten }, haltezeit > 0 ? "Haltezeit von " + haltezeit.toString() + " Minuten wurde eingehalten" : 'Haltezeit wurde eingehalten')));
    };
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgKalibrierungHaltezeit.prototype, "store", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungHaltezeit.prototype, "handleHaltezeitEingehaltenChange", null);
    DmgKalibrierungHaltezeit = __decorate([
        mobx_react_1.observer
    ], DmgKalibrierungHaltezeit);
    return DmgKalibrierungHaltezeit;
}(React.Component));
var DmgKalibrierungVorbelastung = (function (_super) {
    __extends(DmgKalibrierungVorbelastung, _super);
    function DmgKalibrierungVorbelastung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgKalibrierungVorbelastung.prototype.handleVorbelastungChange = function (ev) {
        this.store.setVorbelastungBisEndwert(ev.target.checked);
    };
    DmgKalibrierungVorbelastung.prototype.render = function () {
        return (React.createElement(Callout_1.default, { bsStyle: this.store.datensatz.vorbelastungbisendwert ? 'success' : 'danger' },
            React.createElement(react_bootstrap_1.Checkbox, { inline: true, disabled: this.store.readOnly, onChange: !this.store.readOnly ? this.handleVorbelastungChange : undefined, defaultChecked: this.store.datensatz.vorbelastungbisendwert }, "Vorbelastung bis Endwert wurde durchgef\u00FChrt")));
    };
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgKalibrierungVorbelastung.prototype, "store", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungVorbelastung.prototype, "handleVorbelastungChange", null);
    DmgKalibrierungVorbelastung = __decorate([
        mobx_react_1.observer
    ], DmgKalibrierungVorbelastung);
    return DmgKalibrierungVorbelastung;
}(React.Component));
var DmgKalibrierungKalibrierbereich = (function (_super) {
    __extends(DmgKalibrierungKalibrierbereich, _super);
    function DmgKalibrierungKalibrierbereich() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgKalibrierungKalibrierbereich.prototype.handleBisChange = function (ev) {
        this.store.setKalibrierbereich(this.store.datensatz.kalibrierbereich.von, ev.target.valueAsNumber);
    };
    DmgKalibrierungKalibrierbereich.prototype.render = function () {
        var editable = !this.store.readOnly;
        if (!this.props.kalibrierGegenstand) {
            return null;
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: "Kalibrierbereich", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.FormGroup, { validationState: (this.store.datensatz.kalibrierbereich.von === null || this.store.datensatz.kalibrierbereich.bis === null) ? 'error' : undefined, style: { maxWidth: '80%', margin: 'auto' } },
                React.createElement(react_bootstrap_1.Col, { sm: 3, componentClass: react_bootstrap_1.ControlLabel }, "Kalibrierbereich"),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1", readOnly: true, id: "kalibrierbereichvon", value: this.store.datensatz.kalibrierbereich.von !== null ? this.store.datensatz.kalibrierbereich.von : '' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar"))),
                React.createElement(react_bootstrap_1.Col, { sm: 1, style: { paddingTop: '7px' } }, "bis"),
                React.createElement(react_bootstrap_1.Col, { sm: 4 },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "1", readOnly: !editable, id: "kalibrierbereichbis", value: this.store.datensatz.kalibrierbereich.bis !== null ? this.store.datensatz.kalibrierbereich.bis : '', onChange: this.handleBisChange }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "bar"))))));
    };
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgKalibrierungKalibrierbereich.prototype, "store", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungKalibrierbereich.prototype, "handleBisChange", null);
    DmgKalibrierungKalibrierbereich = __decorate([
        mobx_react_1.observer
    ], DmgKalibrierungKalibrierbereich);
    return DmgKalibrierungKalibrierbereich;
}(React.Component));
var DmgKalibrierungObjektEigenschaften = (function (_super) {
    __extends(DmgKalibrierungObjektEigenschaften, _super);
    function DmgKalibrierungObjektEigenschaften() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgKalibrierungObjektEigenschaften.prototype.handleZeigerArtChange = function (ev) {
        this.store.setZeigerArt(ev.target.value);
    };
    DmgKalibrierungObjektEigenschaften.prototype.render = function () {
        var editable = !this.store.readOnly;
        if (!this.props.kalibrierGegenstand) {
            return null;
        }
        var doppelManometer = this.props.kalibrierGegenstand.objekt ? this.props.kalibrierGegenstand.objekt.name.toLocaleLowerCase().indexOf('doppelmanometer') > -1 : false;
        if (!doppelManometer) {
            return null;
        }
        return (React.createElement(react_bootstrap_1.Panel, { header: "Objekteigenschaften", collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.FormGroup, { validationState: this.store.datensatz.zeigerart === '' ? 'error' : undefined, controlId: "zeigerart", style: { maxWidth: '80%', margin: 'auto', marginBottom: '20px' } },
                React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3 }, "Zeigerart"),
                React.createElement(react_bootstrap_1.Col, { sm: 8 },
                    React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", readOnly: !editable, placeholder: "select", value: this.store.datensatz.zeigerart, onChange: this.handleZeigerArtChange },
                        React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen..."),
                        React.createElement("option", { value: "schwarz" }, "Schwarzer Zeiger"),
                        React.createElement("option", { value: "rot" }, "Roter Zeiger"))))));
    };
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgKalibrierungObjektEigenschaften.prototype, "store", void 0);
    __decorate([
        decorators_2.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgKalibrierungObjektEigenschaften.prototype, "handleZeigerArtChange", null);
    DmgKalibrierungObjektEigenschaften = __decorate([
        mobx_react_1.observer
    ], DmgKalibrierungObjektEigenschaften);
    return DmgKalibrierungObjektEigenschaften;
}(React.Component));
/** Messwerteingabe der Kalibrierung eines Druckmessgeräts */
var DmgKalibrierung = (function (_super) {
    __extends(DmgKalibrierung, _super);
    function DmgKalibrierung(props) {
        var _this = _super.call(this, props) || this;
        _this.schrittweite = 0.1;
        _this.kalibrierGegenstand = undefined;
        _this.store.clear();
        _this.store.setReadOnly(_this.props.editable ? !_this.props.editable : true);
        // Zu betrachtendes DMG aus Auftrag ermitteln
        var vorgang = _this.vorgangStore.vorgang;
        if (vorgang && vorgang.objekte) {
            for (var _i = 0, _a = vorgang.objekte; _i < _a.length; _i++) {
                var vgobj = _a[_i];
                if (vgobj.typ.toLocaleLowerCase() === 'dmg') {
                    _this.kalibrierGegenstand = new KalibrierGegenstand_1.default(vgobj);
                    // Die Skalenteilung wird für die Schrittweite der Anzeigewerte verwendet
                    var meta = _this.kalibrierGegenstand.meta('skalenteilung');
                    if (meta) {
                        _this.schrittweite = parseFloat(meta);
                    }
                    break;
                }
            }
        }
        // Gespeicherte Messung übernehmen
        if (_this.props.value) {
            var messung = _this.store.datensatz;
            messung = JSON.parse(_this.props.value);
            _this.store.setMesswerte(messung);
        }
        // Wenn noch kein Kalibrierbereich gesetzt ist, wird dieser aus dem im Druckmessgerät angegebenen Messbereich übernommen
        if (_this.kalibrierGegenstand && ((_this.store.datensatz.kalibrierbereich.von === null) || (_this.store.datensatz.kalibrierbereich.bis === null))) {
            var metaVon = _this.kalibrierGegenstand.meta('messbereichvon');
            var metaBis = _this.kalibrierGegenstand.meta('messbereichbis');
            if (metaVon || metaBis) {
                _this.store.setKalibrierbereich(metaVon ? parseInt(metaVon, 10) : null, metaBis ? parseInt(metaBis, 10) : null);
            }
        }
        return _this;
    }
    DmgKalibrierung.prototype.renderMessPunkte = function (art) {
        var _this = this;
        if (art === DmgArtMessung.Aufsteigend) {
            return (this.store.datensatz.messpunkte.map(function (mp, index) {
                return React.createElement(DmgMesspunkt, { key: index, ziel: mp, art: DmgArtMessung.Aufsteigend, editable: _this.props.editable ? _this.props.editable : false, schrittweite: _this.schrittweite });
            }));
        }
        else {
            return (this.store.datensatz.messpunkte.reverse().map(function (mp, index) {
                return React.createElement(DmgMesspunkt, { key: index, ziel: mp, art: DmgArtMessung.Absteigend, editable: _this.props.editable ? _this.props.editable : false, schrittweite: _this.schrittweite });
            }));
        }
    };
    DmgKalibrierung.prototype.renderMessReihe = function (art) {
        var caption = art === DmgArtMessung.Aufsteigend ? 'Aufsteigend' : 'Absteigend';
        return (React.createElement(react_bootstrap_1.Panel, { header: "Messung nach Ablauf C - " + caption, collapsible: true, defaultExpanded: true, className: "dmg-eingabe-messwerte" },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "dmg-auswertung", style: { maxWidth: '80%', margin: 'auto', marginBottom: '20px' } },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Messpunkt"),
                        React.createElement("th", null, "Nenndruck"),
                        React.createElement("th", null, "Normal"),
                        React.createElement("th", null, "Anzeige"))),
                React.createElement("tbody", null, this.renderMessPunkte(art)))));
    };
    DmgKalibrierung.prototype.render = function () {
        if (!this.kalibrierGegenstand) {
            return (React.createElement(Callout_1.default, { bsStyle: "danger" },
                React.createElement("p", null, "F\u00FCr die Erstellung der Auswertung muss ein Druckmessger\u00E4t ausgew\u00E4hlt werden.")));
        }
        return (React.createElement("div", null,
            React.createElement(DmgPruefortParameter_1.default, { titel: "Prüfortparameter zu Beginn der Kalibrierung", ziel: this.store.datensatz.pruefortparameter.beginn }),
            React.createElement(DmgKalibrierungObjektEigenschaften, { kalibrierGegenstand: this.kalibrierGegenstand }),
            React.createElement(DmgKalibrierungVorbelastung, null),
            React.createElement(DmgKalibrierungKalibrierbereich, { kalibrierGegenstand: this.kalibrierGegenstand }),
            this.renderMessReihe(DmgArtMessung.Aufsteigend),
            React.createElement(DmgKalibrierungHaltezeit, { kalibrierGegenstand: this.kalibrierGegenstand }),
            this.renderMessReihe(DmgArtMessung.Absteigend),
            React.createElement(DmgPruefortParameter_1.default, { titel: "Prüfortparameter am Ende der Kalibrierung", ziel: this.store.datensatz.pruefortparameter.ende, referenz: this.store.datensatz.pruefortparameter.beginn }),
            React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.kategorieguid + "[" + this.props.elementguid + "][json]", value: JSON.stringify(this.store.datensatz) })));
    };
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], DmgKalibrierung.prototype, "vorgangStore", void 0);
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgKalibrierung.prototype, "store", void 0);
    DmgKalibrierung = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], DmgKalibrierung);
    return DmgKalibrierung;
}(React.Component));
exports.default = DmgKalibrierung;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var decorators_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var DmgKalibrierungStore_1 = __webpack_require__(284);
var DmgPruefortParameterKomponente = (function (_super) {
    __extends(DmgPruefortParameterKomponente, _super);
    function DmgPruefortParameterKomponente() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgPruefortParameterKomponente.prototype.handleIstWertChange = function (ev) {
        this.props.ziel.wert = ev.target.value !== '' ? ev.target.valueAsNumber : null;
    };
    Object.defineProperty(DmgPruefortParameterKomponente.prototype, "imToleranzbereich", {
        get: function () {
            var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
            if ((wert !== null) && ((wert < min) || (wert > max))) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    DmgPruefortParameterKomponente.prototype.render = function () {
        var _a = this.props.ziel, wert = _a.wert, min = _a.min, max = _a.max;
        return (React.createElement("tr", null,
            React.createElement("td", { className: "beschriftung" }, this.props.beschriftung),
            React.createElement("td", { className: "min" }, min),
            React.createElement("td", { className: "messwert" },
                React.createElement(react_bootstrap_1.FormGroup, { validationState: wert === null ? 'error' : undefined },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", readOnly: this.store.readOnly, onChange: this.handleIstWertChange, value: wert !== null ? wert : '', className: wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger' }),
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, this.props.einheit)))),
            React.createElement("td", { className: "max" }, max)));
    };
    __decorate([
        decorators_1.inject(DmgKalibrierungStore_1.DmgKalibrierungStore),
        __metadata("design:type", DmgKalibrierungStore_1.DmgKalibrierungStore)
    ], DmgPruefortParameterKomponente.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DmgPruefortParameterKomponente.prototype, "handleIstWertChange", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DmgPruefortParameterKomponente.prototype, "imToleranzbereich", null);
    DmgPruefortParameterKomponente = __decorate([
        mobx_react_1.observer
    ], DmgPruefortParameterKomponente);
    return DmgPruefortParameterKomponente;
}(React.Component));
var DmgPruefortTemperaturHinweis = (function (_super) {
    __extends(DmgPruefortTemperaturHinweis, _super);
    function DmgPruefortTemperaturHinweis() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DmgPruefortTemperaturHinweis.prototype.render = function () {
        return (React.createElement("tr", null,
            React.createElement("td", { colSpan: 4 },
                React.createElement("div", { className: "value-error", style: { textAlign: 'left' } }, "Der Temperaturunterschied zum Beginn muss unter \u00B11\u00B0C liegen"))));
    };
    return DmgPruefortTemperaturHinweis;
}(React.Component));
/** Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Druckmessgerät */
var DmgPruefortParameter = (function (_super) {
    __extends(DmgPruefortParameter, _super);
    function DmgPruefortParameter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DmgPruefortParameter.prototype, "temperaturHinweis", {
        get: function () {
            if (!this.props.referenz || this.props.ziel.lufttemperatur.wert == null) {
                return false;
            }
            if (this.props.referenz.lufttemperatur.wert !== null) {
                return (Math.abs(this.props.referenz.lufttemperatur.wert - this.props.ziel.lufttemperatur.wert) > 1.0);
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    DmgPruefortParameter.prototype.render = function () {
        return (React.createElement(react_bootstrap_1.Panel, { header: this.props.titel, collapsible: true, defaultExpanded: true },
            React.createElement(react_bootstrap_1.Table, { striped: false, bordered: false, condensed: true, hover: false, className: "bps-pruefortparameter" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        React.createElement("th", null, "Min."),
                        React.createElement("th", null, "Messwert"),
                        React.createElement("th", null, "Max."))),
                React.createElement("tbody", null,
                    React.createElement(DmgPruefortParameterKomponente, { ziel: this.props.ziel.lufttemperatur, beschriftung: "Lufttemperatur", einheit: "°C" }),
                    this.temperaturHinweis && React.createElement(DmgPruefortTemperaturHinweis, null),
                    React.createElement(DmgPruefortParameterKomponente, { ziel: this.props.ziel.luftfeuchtigkeit, beschriftung: "Luftfeuchtigkeit", einheit: "%" })))));
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DmgPruefortParameter.prototype, "temperaturHinweis", null);
    DmgPruefortParameter = __decorate([
        mobx_react_1.observer
    ], DmgPruefortParameter);
    return DmgPruefortParameter;
}(React.Component));
exports.default = DmgPruefortParameter;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
/** Komponente für Suche und Übernahme einer DocID aus einem Auftrag. Die Suchparameter werden in der Vorlage (im QIT) definiert. */
var FormularElementDocId = (function (_super) {
    __extends(FormularElementDocId, _super);
    function FormularElementDocId() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = _this.props.value ? _this.props.value : '';
        _this.modalVisible = false;
        _this.dokumente = [];
        _this.popoverHint = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" }, "\u00DCbernimmt, sofern vorhanden, das Aktenzeichen automatisch aus dem zur Eingabe passenden Dokument im Auftrag (z.B. Kalibrierschein)."));
        return _this;
    }
    FormularElementDocId.prototype.setDokumente = function (dokumente) {
        this.dokumente = dokumente;
    };
    FormularElementDocId.prototype.sucheDokumente = function (anr) {
        return __awaiter(this, void 0, void 0, function () {
            var dokumente;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragDokumentenSuche(anr, this.props.werte)];
                    case 1:
                        dokumente = _a.sent();
                        if (dokumente.ok) {
                            this.setDokumente(dokumente.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FormularElementDocId.prototype.setWert = function (wert) {
        this.value = wert;
        this.modalVisible = false;
        if (this.props.onHandleValidation) {
            this.props.onHandleValidation(this.getValidationState());
        }
    };
    FormularElementDocId.prototype.setModal = function (value) {
        this.modalVisible = value;
    };
    FormularElementDocId.prototype.showModal = function () {
        var _this = this;
        // Dokumente laden
        if (this.props.anr) {
            this.sucheDokumente(this.props.anr).then(function (resp) {
                // Wenn es nur ein Dokument gibt, wir dessen DocID direkt übernommen
                if (_this.dokumente.length === 1) {
                    _this.setWert(_this.dokumente[0].docid);
                    return;
                }
                if (_this.dokumente.length === 0) {
                    // @todo: Meldung anzeigen?
                    return;
                }
                // Wenn es mehrere Dokumente gibt, dann muss der Nutzer in einem modalen Dialog das korrekte auswählen
                _this.setModal(true);
            });
        }
    };
    FormularElementDocId.prototype.hideModal = function () {
        this.setModal(false);
    };
    FormularElementDocId.prototype.handleValueChanged = function (event) {
        this.setWert(event.target.value);
    };
    FormularElementDocId.prototype.getValidationState = function () {
        if (!this.props.editable) {
            return undefined;
        }
        return (this.value.length === 10) ? 'success' : 'error';
    };
    FormularElementDocId.prototype.render = function () {
        var _this = this;
        var validationState = this.getValidationState();
        var btnClass = 'btn-group';
        if (validationState === 'error') {
            btnClass += ' button-error';
        }
        if (validationState === 'success') {
            btnClass += ' button-success';
        }
        return (React.createElement(react_bootstrap_1.FormGroup, { controlId: this.props.text, validationState: validationState, className: "formular-element-row" },
            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, this.props.text),
            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3, className: "formular-element" },
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { readOnly: !this.props.editable, onChange: this.handleValueChanged, type: "text", name: this.props.kategorieguid + "[" + this.props.elementguid + "]", value: this.value, placeholder: this.props.platzhalter }),
                    this.props.editable &&
                        React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus', 'click'], placement: "top", overlay: this.popoverHint },
                            React.createElement(react_bootstrap_1.InputGroup.Button, { style: { width: '28px' } },
                                React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: btnClass, disabled: false, onClick: this.showModal },
                                    " ",
                                    React.createElement(FaIcon_1.default, { icon: "files-o" })))))),
            React.createElement(react_bootstrap_1.Modal, { show: this.modalVisible, onHide: this.hideModal, className: "modal-vertical-centered", backdrop: 'static' },
                React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                    React.createElement(react_bootstrap_1.Modal.Title, null,
                        "Aktenzeichen f\u00FCr ",
                        this.props.text,
                        " ausw\u00E4hlen")),
                React.createElement(react_bootstrap_1.Modal.Body, null,
                    React.createElement(react_bootstrap_1.ListGroup, { fill: true }, this.dokumente.map(function (dokument, index) { return (React.createElement(react_bootstrap_1.ListGroupItem, { key: index, onClick: function () { return _this.setWert(dokument.docid); } },
                        dokument.datum,
                        " - ",
                        dokument.titel,
                        " (",
                        dokument.docid,
                        ")")); }))),
                React.createElement(react_bootstrap_1.Modal.Footer, null,
                    React.createElement(react_bootstrap_1.Button, { onClick: this.hideModal, bsStyle: "default" }, "Abbrechen")))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FormularElementDocId.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FormularElementDocId.prototype, "value", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FormularElementDocId.prototype, "modalVisible", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], FormularElementDocId.prototype, "dokumente", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormularElementDocId.prototype, "setDokumente", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], FormularElementDocId.prototype, "setWert", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FormularElementDocId.prototype, "setModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormularElementDocId.prototype, "showModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormularElementDocId.prototype, "hideModal", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormularElementDocId.prototype, "handleValueChanged", null);
    FormularElementDocId = __decorate([
        mobx_react_1.observer
    ], FormularElementDocId);
    return FormularElementDocId;
}(React.Component));
exports.default = FormularElementDocId;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var Dropzone = __webpack_require__(104);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var FaIcon_1 = __webpack_require__(20);
var FormularElementFileUpload = (function (_super) {
    __extends(FormularElementFileUpload, _super);
    function FormularElementFileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestInProgress = false;
        _this.dragging = false;
        _this.dokumentTitel = '';
        _this.uploadedFileName = '';
        return _this;
    }
    FormularElementFileUpload.prototype.componentDidMount = function () {
        this.dokumentTitel = this.props.dokumentTitel ? this.props.dokumentTitel : '';
        if (this.props.wert) {
            this.setUploadedFileName(this.props.wert);
        }
    };
    FormularElementFileUpload.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.dokumentTitel !== this.props.dokumentTitel) {
            this.dokumentTitel = nextProps.dokumentTitel ? nextProps.dokumentTitel : '';
        }
    };
    Object.defineProperty(FormularElementFileUpload.prototype, "FileUploaded", {
        get: function () {
            return this.acceptedFile !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormularElementFileUpload.prototype, "fileSize", {
        get: function () {
            return (this.acceptedFile && this.acceptedFile.size && !isNaN(this.acceptedFile.size))
                ? "(~" + Math.ceil(10 * this.acceptedFile.size / 1024 / 1024) / 10 + " MB)"
                : '';
        },
        enumerable: true,
        configurable: true
    });
    FormularElementFileUpload.prototype.handleFileDrop = function (accepted) {
        if (accepted.length > 0) {
            this.acceptedFile = accepted.shift();
        }
        this.handleSetDragging(false);
    };
    FormularElementFileUpload.prototype.handleFileDropRejected = function (rejected) {
        this.handleClearAcceptedFile();
        this.handleSetDragging(false);
    };
    FormularElementFileUpload.prototype.handleClearAcceptedFile = function () {
        this.acceptedFile = undefined;
    };
    FormularElementFileUpload.prototype.clear = function () {
        this.acceptedFile = undefined;
    };
    FormularElementFileUpload.prototype.setUploadedFileName = function (value) {
        this.uploadedFileName = value;
        if (this.props.onHandleValidation) {
            this.props.onHandleValidation('success');
        }
    };
    FormularElementFileUpload.prototype.setRequesInProgress = function (value) {
        this.requestInProgress = value;
    };
    FormularElementFileUpload.prototype.handleSetDragging = function (dragging) {
        this.dragging = dragging;
    };
    FormularElementFileUpload.prototype.handleUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((this.acceptedFile !== undefined) && (this.dokumentTitel !== ''))) return [3 /*break*/, 2];
                        vorgangId = this.props.vorgangId;
                        if (!vorgangId) {
                            return [2 /*return*/];
                        }
                        this.setRequesInProgress(true);
                        return [4 /*yield*/, this.apiStore.vorgangDateiUpload(vorgangId, this.dokumentTitel, this.acceptedFile)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setUploadedFileName(this.acceptedFile.name);
                            this.handleClearAcceptedFile();
                            // this.vorgangStore.loadVorgang(vorgangId);
                            // @todo: Visuelles update
                        }
                        this.setRequesInProgress(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FormularElementFileUpload.prototype.renderUploadStatus = function () {
        if (this.uploadedFileName !== '') {
            return (React.createElement("div", { className: "text-center value-success", style: { marginBottom: '10px' } },
                "Hochgeladenes Dokument: ",
                this.uploadedFileName));
        }
        else {
            return (React.createElement("div", { className: "text-center value-error", style: { marginBottom: '10px' } }, "Es wurde noch kein Dokument hochgeladen"));
        }
    };
    FormularElementFileUpload.prototype.renderFileArea = function () {
        if (this.acceptedFile) {
            return (React.createElement("div", { className: "text-center" },
                "Ausgew\u00E4hlte Datei: ",
                this.acceptedFile.name,
                " (",
                Math.ceil(10 * this.acceptedFile.size / 1024 / 1024) / 10,
                " MB)"));
        }
        else {
            if (this.uploadedFileName === '') {
                return (React.createElement("div", { className: "text-center" },
                    React.createElement("div", null, this.props.text),
                    React.createElement("div", { style: { fontSize: '3em' } },
                        React.createElement(FaIcon_1.default, { icon: "cloud-upload" })),
                    React.createElement("div", null,
                        "Datei ausw\u00E4hlen oder per Drag&Drop auf die Fl\u00E4che fallen lassen.",
                        React.createElement("br", null))));
            }
            else {
                return (React.createElement("div", { className: "text-center" }, "Das Dokument wurde erfolgreich im Vorgang hinterlegt."));
            }
        }
    };
    FormularElementFileUpload.prototype.render = function () {
        var _this = this;
        // tslint:disable-next-line:no-any
        var dropZone;
        return (React.createElement("div", null,
            React.createElement(Dropzone, { accept: ".pdf,.docx,.tif,.tiff,.xlsx,.jpg,.jpeg,.png", ref: function (ref) { return dropZone = ref; }, disableClick: true, className: "upload-dropzone " + (this.dragging ? 'upload-dropzone-dragging' : ''), style: { margin: 'inherit', padding: '0px' }, onDragEnter: function () { return _this.handleSetDragging(true); }, onDragLeave: function () { return _this.handleSetDragging(false); }, onDropAccepted: this.handleFileDrop, onDropRejected: this.handleFileDropRejected },
                React.createElement(react_bootstrap_1.Panel, { className: this.uploadedFileName === '' ? 'formular-element-upload-fehlt' : 'formular-element-upload-vorhanden', footer: (React.createElement("div", { className: "text-center" }, this.acceptedFile ? (React.createElement("div", null,
                        React.createElement(react_bootstrap_1.Button, { className: "btn-sm", disabled: this.requestInProgress, onClick: this.handleClearAcceptedFile }, "Abbrechen"),
                        React.createElement(react_bootstrap_1.Button, { className: "btn-sm", bsStyle: "primary", disabled: this.requestInProgress, onClick: this.handleUpload }, "Datei hochladen"))) : (React.createElement(react_bootstrap_1.Button, { className: "btn-sm", onClick: function () { return dropZone.open(); } }, this.uploadedFileName === '' ? 'Datei auswählen' : 'Neue Datei auswählen')))) },
                    this.renderUploadStatus(),
                    this.renderFileArea(),
                    React.createElement(react_bootstrap_1.FormGroup, null,
                        React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.name, value: this.uploadedFileName }))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FormularElementFileUpload.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], FormularElementFileUpload.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FormularElementFileUpload.prototype, "requestInProgress", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", File)
    ], FormularElementFileUpload.prototype, "acceptedFile", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FormularElementFileUpload.prototype, "dragging", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FormularElementFileUpload.prototype, "dokumentTitel", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FormularElementFileUpload.prototype, "uploadedFileName", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FormularElementFileUpload.prototype, "FileUploaded", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FormularElementFileUpload.prototype, "fileSize", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "handleFileDrop", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "handleFileDropRejected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "handleClearAcceptedFile", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "clear", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "setUploadedFileName", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "setRequesInProgress", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FormularElementFileUpload.prototype, "handleSetDragging", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], FormularElementFileUpload.prototype, "handleUpload", null);
    FormularElementFileUpload = __decorate([
        mobx_react_1.observer
    ], FormularElementFileUpload);
    return FormularElementFileUpload;
}(React.Component));
exports.default = FormularElementFileUpload;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var Dropzone = __webpack_require__(104);
var react_bootstrap_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var VorgangStore_1 = __webpack_require__(22);
var FaIcon_1 = __webpack_require__(20);
var FormularElementFotoUploadThumbnail = (function (_super) {
    __extends(FormularElementFotoUploadThumbnail, _super);
    function FormularElementFotoUploadThumbnail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormularElementFotoUploadThumbnail.prototype.render = function () {
        var _a = this.props, thumbnail = _a.thumbnail, vorgangId = _a.vorgangId;
        var downloadUrl = this.apiStore.vorgangDokumentDownloadUrl(vorgangId, thumbnail.eintrag_guid);
        var previewUrl = this.apiStore.vorgangThumbnailPreviewUrl(vorgangId, thumbnail.eintrag_guid);
        return (React.createElement("a", { href: downloadUrl, target: "_blank" },
            React.createElement("img", { src: previewUrl, className: "img-thumbnail foto-thumb" })));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FormularElementFotoUploadThumbnail.prototype, "apiStore", void 0);
    return FormularElementFotoUploadThumbnail;
}(React.Component));
/** Komponente für den Upload von Fotos inkl. Thumbnailanzeige als Teil der Formulareingaben */
var FormularElementFotoUpload = (function (_super) {
    __extends(FormularElementFotoUpload, _super);
    function FormularElementFotoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragging = false;
        return _this;
    }
    FormularElementFotoUpload.prototype.componentDidMount = function () {
        this.kategorie = this.props.kategorie;
        this.refresh();
    };
    FormularElementFotoUpload.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.kategorie !== this.props.kategorie) {
            this.kategorie = nextProps.kategorie;
        }
    };
    FormularElementFotoUpload.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.vorgangThumbnails(this.props.vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response && response.ok) {
                            this.setThumbnails(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FormularElementFotoUpload.prototype.setThumbnails = function (thumbnails) {
        this.thumbnails = thumbnails;
        if (this.props.onHandleValidation) {
            if (thumbnails.length > 0) {
                this.props.onHandleValidation('success');
            }
            else {
                this.props.onHandleValidation('error');
            }
        }
    };
    Object.defineProperty(FormularElementFotoUpload.prototype, "filesSelected", {
        get: function () {
            return ((this.acceptedFiles !== undefined) && this.acceptedFiles.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    FormularElementFotoUpload.prototype.handleFileDrop = function (accepted) {
        if (accepted.length > 0) {
            this.acceptedFiles = Array.from(accepted);
        }
        this.handleSetDragging(false);
    };
    FormularElementFotoUpload.prototype.handleFileDropRejected = function (rejected) {
        this.handleClearAcceptedFile();
        this.handleSetDragging(false);
    };
    FormularElementFotoUpload.prototype.handleClearAcceptedFile = function () {
        this.acceptedFiles = undefined;
    };
    FormularElementFotoUpload.prototype.handleSetDragging = function (dragging) {
        this.dragging = dragging;
    };
    FormularElementFotoUpload.prototype.handleUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.acceptedFiles && this.kategorie)) return [3 /*break*/, 2];
                        vorgangId = this.props.vorgangId;
                        return [4 /*yield*/, this.apiStore.vorgangFotoUpload(vorgangId, this.kategorie, this.acceptedFiles)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.handleClearAcceptedFile();
                            this.refresh();
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FormularElementFotoUpload.prototype.handleKategorieChanged = function (event) {
        this.kategorie = event.target.value;
    };
    FormularElementFotoUpload.prototype.render = function () {
        var _this = this;
        // tslint:disable-next-line:no-any
        var dropZone;
        return (React.createElement("div", null,
            React.createElement(Dropzone, { accept: ".jpg,.jpeg,.png", ref: function (ref) { return dropZone = ref; }, multiple: true, disableClick: true, style: {}, className: "upload-dropzone " + (this.dragging ? 'upload-dropzone-dragging' : ''), onDragEnter: function () { return _this.handleSetDragging(true); }, onDragLeave: function () { return _this.handleSetDragging(false); }, onDropAccepted: this.handleFileDrop, onDropRejected: this.handleFileDropRejected }, this.filesSelected ? (React.createElement("div", null, this.acceptedFiles ?
                React.createElement("div", null,
                    React.createElement("h4", null,
                        this.acceptedFiles.length,
                        " Datei(en) ausgew\u00E4hlt:"),
                    React.createElement("div", null,
                        React.createElement("ul", null, this.acceptedFiles.map(function (file, index) { return React.createElement("li", { key: index },
                            file.name,
                            " (",
                            Math.ceil(10 * file.size / 1024 / 1024) / 10,
                            " MB) "); })))) : null)) : (React.createElement("div", null,
                React.createElement("div", { className: "text-center" },
                    React.createElement("div", { style: { fontSize: '4em' } },
                        React.createElement(FaIcon_1.default, { icon: "cloud-upload" })),
                    React.createElement("div", null,
                        "Dateien ausw\u00E4hlen oder per Drag&Drop auf die Fl\u00E4che fallen lassen.",
                        React.createElement("br", null),
                        "Unterst\u00FCtzte Formate: jpg, jpeg, png"))))),
            React.createElement("div", { className: "text-center" }, this.filesSelected ? (React.createElement("div", null,
                React.createElement(react_bootstrap_1.Button, { onClick: this.handleClearAcceptedFile }, "Abbrechen"),
                React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: this.handleUpload, disabled: !this.kategorie }, "Ausgew\u00E4hlte Datei hochladen"))) : (React.createElement(react_bootstrap_1.Button, { onClick: function () { return dropZone.open(); } }, "Dateien ausw\u00E4hlen"))),
            React.createElement("div", { className: "foto-upload-thumblist" }, !this.thumbnails ? (React.createElement("span", null, "Lade Bilder...")) : (this.thumbnails.length === 0) ? (React.createElement("span", null, "Es wurden noch keine Bilder hochgeladen")) : React.createElement("div", null,
                "Gespeicherte Bilder:",
                React.createElement("br", null),
                this.thumbnails.map(function (thumbnail, index) { return React.createElement(FormularElementFotoUploadThumbnail, { key: index, vorgangId: _this.props.vorgangId, thumbnail: thumbnail }); }))),
            (this.thumbnails && this.thumbnails.length > 0) &&
                React.createElement(react_bootstrap_1.FormGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: this.props.name, value: this.thumbnails.length }))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FormularElementFotoUpload.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], FormularElementFotoUpload.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], FormularElementFotoUpload.prototype, "dragging", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], FormularElementFotoUpload.prototype, "acceptedFiles", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FormularElementFotoUpload.prototype, "kategorie", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], FormularElementFotoUpload.prototype, "thumbnails", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormularElementFotoUpload.prototype, "setThumbnails", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FormularElementFotoUpload.prototype, "filesSelected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormularElementFotoUpload.prototype, "handleFileDrop", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormularElementFotoUpload.prototype, "handleFileDropRejected", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormularElementFotoUpload.prototype, "handleClearAcceptedFile", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], FormularElementFotoUpload.prototype, "handleSetDragging", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], FormularElementFotoUpload.prototype, "handleUpload", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormularElementFotoUpload.prototype, "handleKategorieChanged", null);
    FormularElementFotoUpload = __decorate([
        mobx_react_1.observer
    ], FormularElementFotoUpload);
    return FormularElementFotoUpload;
}(React.Component));
exports.default = FormularElementFotoUpload;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
/** Komponente für Übernahme eines Formulardatums aus einem anderen Vorgang einem Auftrag. Das zu übernehmende Formulardatum wird in der Vorlage (im QIT) definiert. */
var FormularElementTextUebernahme = (function (_super) {
    __extends(FormularElementTextUebernahme, _super);
    function FormularElementTextUebernahme() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = _this.props.value ? _this.props.value : '';
        _this.formularWert = null;
        _this.popoverHint = (React.createElement(react_bootstrap_1.Popover, { id: "popover-trigger-hover-focus" }, "\u00DCbernimmt, sofern vorhanden, Daten automatisch aus einem anderen Vorgang in diesem Auftrag."));
        return _this;
    }
    FormularElementTextUebernahme.prototype.setFormularWert = function (wert) {
        this.formularWert = wert;
    };
    FormularElementTextUebernahme.prototype.sucheFormularDatum = function (anr, kuerzel) {
        return __awaiter(this, void 0, void 0, function () {
            var dokumente;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.auftragFormularDatenSuche(anr, this.props.werte)];
                    case 1:
                        dokumente = _a.sent();
                        if (dokumente.ok) {
                            this.setFormularWert(dokumente.json.wert);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FormularElementTextUebernahme.prototype.setWert = function (wert) {
        this.value = wert;
        if (this.props.onHandleValidation) {
            this.props.onHandleValidation(this.getValidationState());
        }
    };
    FormularElementTextUebernahme.prototype.uebernehmeFormularDatum = function () {
        var _this = this;
        if (this.props.anr) {
            this.sucheFormularDatum(this.props.anr, this.props.werte).then(function (resp) {
                _this.setWert(_this.formularWert || '');
            });
        }
    };
    FormularElementTextUebernahme.prototype.handleValueChanged = function (event) {
        this.setWert(event.target.value);
    };
    FormularElementTextUebernahme.prototype.getValidationState = function () {
        if (!this.props.editable) {
            return undefined;
        }
        return (this.value.length > 0) ? 'success' : 'error';
    };
    FormularElementTextUebernahme.prototype.render = function () {
        var validationState = this.getValidationState();
        var btnClass = 'btn-group';
        if (validationState === 'error') {
            btnClass += ' button-error';
        }
        if (validationState === 'success') {
            btnClass += ' button-success';
        }
        return (React.createElement(react_bootstrap_1.FormGroup, { controlId: this.props.text, validationState: validationState, className: "formular-element-row" },
            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 9, className: "formular-element-caption" }, this.props.text),
            React.createElement(react_bootstrap_1.Col, { componentClass: react_bootstrap_1.ControlLabel, sm: 3, className: "formular-element" },
                React.createElement(react_bootstrap_1.InputGroup, null,
                    React.createElement(react_bootstrap_1.FormControl, { readOnly: !this.props.editable, onChange: this.handleValueChanged, type: "text", name: this.props.kategorieguid + "[" + this.props.elementguid + "]", value: this.value, placeholder: this.props.platzhalter }),
                    this.props.editable &&
                        React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: ['hover', 'focus', 'click'], placement: "top", overlay: this.popoverHint },
                            React.createElement(react_bootstrap_1.InputGroup.Button, { style: { width: '28px' } },
                                React.createElement(react_bootstrap_1.Button, { bsStyle: "default", className: btnClass, disabled: false, onClick: this.uebernehmeFormularDatum },
                                    " ",
                                    React.createElement(FaIcon_1.default, { icon: "files-o" }))))))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FormularElementTextUebernahme.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], FormularElementTextUebernahme.prototype, "value", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], FormularElementTextUebernahme.prototype, "formularWert", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormularElementTextUebernahme.prototype, "setFormularWert", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], FormularElementTextUebernahme.prototype, "setWert", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormularElementTextUebernahme.prototype, "uebernehmeFormularDatum", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormularElementTextUebernahme.prototype, "handleValueChanged", null);
    FormularElementTextUebernahme = __decorate([
        mobx_react_1.observer
    ], FormularElementTextUebernahme);
    return FormularElementTextUebernahme;
}(React.Component));
exports.default = FormularElementTextUebernahme;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
var FormularElementUrl = (function (_super) {
    __extends(FormularElementUrl, _super);
    function FormularElementUrl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormularElementUrl.prototype.render = function () {
        var url = this.props.url;
        if (this.props.tokenErfoderlich) {
            url = url + ("?token=" + this.apiStore.token);
        }
        var _a = this.props, target = _a.target, text = _a.text;
        var icon = this.props.icon ? this.props.icon : 'lightbulb-o';
        return (React.createElement(react_bootstrap_1.Panel, { className: "formular-element-url", onClick: function () { return window.open(url, target); } },
            React.createElement("div", { className: "text-center" },
                React.createElement("div", { style: { fontSize: '1.5em' } },
                    React.createElement(FaIcon_1.default, { icon: icon })),
                React.createElement("div", null, text))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], FormularElementUrl.prototype, "apiStore", void 0);
    return FormularElementUrl;
}(React.Component));
exports.default = FormularElementUrl;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Messwerteingabe für die Beurteilung der Gradheit der Säule Scheinwerer-Einstellgerät
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var Messpunkt = (function () {
    function Messpunkt(editable, abweichung, hoehe) {
        this.editable = editable;
        this.abweichung = abweichung;
        this.hoehe = hoehe;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Messpunkt.prototype, "abweichung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Messpunkt.prototype, "hoehe", void 0);
    return Messpunkt;
}());
var SepBeurteilungSaeule = (function (_super) {
    __extends(SepBeurteilungSaeule, _super);
    function SepBeurteilungSaeule(props) {
        var _this = _super.call(this, props) || this;
        _this.validationstate = 'error';
        _this.deltaAbweichung = undefined;
        _this.deltaHoehe = undefined;
        _this.maxDeltaAbweichung = 0.2;
        _this.minDeltaHoehe = 450;
        _this.maxDeltaHoehe = 550;
        _this.daten = new Array();
        _this.state = { messpunkte: new Array() };
        // Im Vorgang hinterlegte Werte parsen
        if (_this.props.value) {
            try {
                _this.daten = JSON.parse(_this.props.value);
            }
            catch (e) {
                _this.daten = [];
            }
        }
        for (var i = 0; i < 2; i++) {
            var hoehe = (_this.daten.length > i && _this.daten[i] !== null) ? parseInt(_this.daten[i][0], 10) : undefined;
            var abweichung = (_this.daten.length > i && _this.daten[i] !== null) ? parseFloat(_this.daten[i][1]) : undefined;
            var messpunkt = new Messpunkt(_this.props.editable ? _this.props.editable : true, abweichung, hoehe);
            _this.state.messpunkte.push(messpunkt);
        }
        // Ergebnisdaten im Vorgang hinterlegt?
        if (_this.daten.length > 2) {
            try {
                _this.deltaHoehe = parseInt(_this.daten[2][0], 10);
                _this.deltaAbweichung = parseFloat(_this.daten[2][1]);
            }
            catch (e) {
                _this.deltaHoehe = undefined;
                _this.deltaAbweichung = undefined;
            }
        }
        _this.validate();
        return _this;
    }
    SepBeurteilungSaeule.prototype.statusBeurteilung = function () {
        if ((this.deltaAbweichung !== undefined && this.deltaAbweichung <= this.maxDeltaAbweichung) && (this.deltaHoehe !== undefined && (this.deltaHoehe >= this.minDeltaHoehe && this.deltaHoehe <= this.maxDeltaHoehe))) {
            return 'in Ordnung';
        }
        else {
            return 'nicht in Ordnung';
        }
    };
    SepBeurteilungSaeule.prototype.handleHoeheChange = function (messpunkt, ev) {
        messpunkt.hoehe = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
        this.validate();
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this.props.element);
        }
    };
    SepBeurteilungSaeule.prototype.handleAbweichungChanged = function (messpunkt, ev) {
        messpunkt.abweichung = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
        this.validate();
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this.props.element);
        }
    };
    SepBeurteilungSaeule.prototype.messpunktHoeheValidationState = function (p, index) {
        var res = 'error';
        res = p.hoehe !== undefined ? undefined : 'error';
        // Im ersten Messpunkt muss die Höhe zwischen 500 und 800 mm liegen
        if (index === 0 && p.hoehe && (p.hoehe < 500 || p.hoehe > 800)) {
            res = 'warning';
        }
        // TODO: Im zweiten Messpunkt muss das Delta im Bereich 450~550 mm liegen
        if (index === 1 && this.deltaHoehe && (this.deltaHoehe < this.minDeltaHoehe || this.deltaHoehe > this.maxDeltaHoehe)) {
            res = 'warning';
        }
        return res;
    };
    // private messpunktMinHoehe(p: Messpunkt, index: number) {
    // }
    SepBeurteilungSaeule.prototype.validate = function () {
        this.validationstate = this.state.messpunkte.some(function (el) { return (el.hoehe === undefined || el.abweichung === undefined); }) ? 'error' : 'success';
        // Beurteilung und Ergebnis berechnen
        var p0 = this.state.messpunkte[0];
        var p1 = this.state.messpunkte[1];
        if (this.state.messpunkte.some(function (el) { return (el.hoehe === undefined); })) {
            this.deltaHoehe = undefined;
        }
        else {
            if (p0.hoehe !== undefined && p1.hoehe !== undefined) {
                this.deltaHoehe = Math.abs(p1.hoehe - p0.hoehe);
            }
        }
        if (this.state.messpunkte.some(function (el) { return (el.abweichung === undefined); })) {
            this.deltaAbweichung = undefined;
        }
        else {
            if (p0.abweichung !== undefined && p1.abweichung !== undefined) {
                this.deltaAbweichung = Math.abs(p1.abweichung * 100.0 - p0.abweichung * 100.0);
                this.deltaAbweichung /= 100.0;
            }
        }
        this.props.element.validationstate = this.validationstate;
    };
    SepBeurteilungSaeule.prototype.renderMesswertTabelle = function () {
        var _this = this;
        var elemente = [];
        var _loop_1 = function (i) {
            var p = this_1.state.messpunkte[i];
            elemente.push(React.createElement("tr", { key: this_1.props.kategorieguid + "[" + this_1.props.elementguid + "][" + i + "][1]" },
                React.createElement("td", { style: { textAlign: 'center', verticalAlign: 'middle' } }, i + 1),
                React.createElement("td", null,
                    React.createElement(react_bootstrap_1.FormGroup, { validationState: this_1.messpunktHoeheValidationState(p, i), style: { margin: '0px' } },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !this_1.props.editable, step: 1.0, type: "number", min: i === 0 ? 500 : undefined, max: i === 0 ? 800 : undefined, name: this_1.props.kategorieguid + "[" + this_1.props.elementguid + "][" + i + "][0]", defaultValue: (p.hoehe !== undefined) ? p.hoehe.toFixed(0) : '', onChange: function (e) { return _this.handleHoeheChange(p, e); } }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "mm")),
                        this_1.messpunktHoeheValidationState(p, i) === 'warning' && React.createElement(react_bootstrap_1.HelpBlock, { style: { marginBottom: '0px', fontWeight: 100 }, className: "text-center" }, i === 0 ? '500 bis 800 mm' : 'Delta 450 bis 550 mm'))),
                React.createElement("td", null,
                    React.createElement(react_bootstrap_1.FormGroup, { validationState: p.abweichung !== undefined ? undefined : 'error', style: { margin: '0px' } },
                        React.createElement(react_bootstrap_1.InputGroup, null,
                            React.createElement(react_bootstrap_1.FormControl, { readOnly: !this_1.props.editable, step: 0.01, type: "number", name: this_1.props.kategorieguid + "[" + this_1.props.elementguid + "][" + i + "][1]", defaultValue: (p.abweichung !== undefined) ? p.abweichung.toFixed(2) : '', onChange: function (e) { return _this.handleAbweichungChanged(p, e); } }),
                            React.createElement(react_bootstrap_1.InputGroup.Addon, null, "%"))))));
        };
        var this_1 = this;
        for (var i = 0; i < this.state.messpunkte.length; i++) {
            _loop_1(i);
        }
        return elemente;
    };
    SepBeurteilungSaeule.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(react_bootstrap_1.Row, null,
                React.createElement(react_bootstrap_1.Col, { xs: 2 }),
                React.createElement(react_bootstrap_1.Col, { xs: 8 },
                    React.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, condensed: true, hover: true },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Messung"),
                                React.createElement("th", null, "Abstand"),
                                React.createElement("th", null, "Abweichung"))),
                        React.createElement("tbody", null,
                            this.renderMesswertTabelle(),
                            React.createElement("tr", { style: { textAlign: 'center', verticalAlign: 'middle' } },
                                React.createElement("td", { style: { textAlign: 'center', verticalAlign: 'middle' } }, "\u0394"),
                                React.createElement("td", null,
                                    React.createElement(react_bootstrap_1.InputGroup, null,
                                        React.createElement(react_bootstrap_1.FormControl, { type: "text", value: this.deltaHoehe !== undefined ? this.deltaHoehe : '', readOnly: true, className: this.deltaHoehe ? (((this.deltaHoehe >= this.minDeltaHoehe) && (this.deltaHoehe <= this.maxDeltaHoehe)) ? 'text-success' : 'text-danger') : '', name: this.props.kategorieguid + "[" + this.props.elementguid + "][2][0]" }),
                                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "mm"))),
                                React.createElement("td", null,
                                    React.createElement(react_bootstrap_1.InputGroup, null,
                                        React.createElement(react_bootstrap_1.FormControl, { type: "number", value: this.deltaAbweichung !== undefined ? this.deltaAbweichung : '', defaultValue: this.deltaAbweichung ? this.deltaAbweichung.toFixed(2) : '', readOnly: true, className: this.deltaAbweichung ? (this.deltaAbweichung > this.maxDeltaAbweichung ? 'text-danger' : 'text-success') : '', name: this.props.kategorieguid + "[" + this.props.elementguid + "][2][1]" }),
                                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "%"))))))),
                React.createElement(react_bootstrap_1.Col, { xs: 2 })),
            React.createElement(react_bootstrap_1.Row, null,
                React.createElement(react_bootstrap_1.Col, { xs: 2 }),
                React.createElement(react_bootstrap_1.Col, { xs: 8 },
                    React.createElement(react_bootstrap_1.InputGroup, null,
                        React.createElement(react_bootstrap_1.InputGroup.Addon, null, "Beurteilung der S\u00E4ule:"),
                        React.createElement(react_bootstrap_1.FormControl, { type: "text", readOnly: true, value: this.statusBeurteilung(), className: this.statusBeurteilung() === 'in Ordnung' ? 'text-success' : 'text-danger', name: this.props.kategorieguid + "[" + this.props.elementguid + "][3][0]" }))),
                React.createElement(react_bootstrap_1.Col, { xs: 2 }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SepBeurteilungSaeule.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SepBeurteilungSaeule.prototype, "deltaAbweichung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SepBeurteilungSaeule.prototype, "deltaHoehe", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Messpunkt, Object]),
        __metadata("design:returntype", void 0)
    ], SepBeurteilungSaeule.prototype, "handleHoeheChange", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Messpunkt, Object]),
        __metadata("design:returntype", void 0)
    ], SepBeurteilungSaeule.prototype, "handleAbweichungChanged", null);
    SepBeurteilungSaeule = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SepBeurteilungSaeule);
    return SepBeurteilungSaeule;
}(React.Component));
exports.default = SepBeurteilungSaeule;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Messwerteingabe für die Beurteilung der Hell/Dunkel-Grenze Scheinwerer-Einstellgerät
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var React = __webpack_require__(0);
var decorators_1 = __webpack_require__(1);
var react_bootstrap_1 = __webpack_require__(2);
var round_1 = __webpack_require__(33);
var Messpunkt = (function () {
    function Messpunkt(editable, soll, winkel, id, messwert) {
        this.abweichungIo = false;
        this.editable = editable;
        this.messwert = messwert;
        this.soll = soll;
        this.winkel = winkel;
        this.id = id;
    }
    Messpunkt.prototype.setMesswert = function (messwert) {
        this.messwert = messwert;
        if ((this.messwert !== undefined) && (!isNaN(this.messwert))) {
            this.abweichung = round_1.round(this.soll - this.messwert, 2);
            // Abweichung muss innerhalb von +/-0,2% liegen
            this.abweichungIo = (Math.abs(this.abweichung) <= 0.2);
        }
        else {
            this.abweichung = undefined;
            this.abweichungIo = false;
        }
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Messpunkt.prototype, "messwert", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Messpunkt.prototype, "abweichung", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], Messpunkt.prototype, "abweichungIo", void 0);
    return Messpunkt;
}());
var Messung = (function () {
    function Messung(nummer) {
        this.nummer = nummer;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], Messung.prototype, "messpunkte", void 0);
    return Messung;
}());
var SepHellDunkelGrenze = (function (_super) {
    __extends(SepHellDunkelGrenze, _super);
    function SepHellDunkelGrenze(props) {
        var _this = _super.call(this, props) || this;
        _this.validationstate = 'error';
        _this.messPunktePkw = [-0, -1, -2];
        _this.messWinkelPkw = ['0', '0,57', '1,15'];
        _this.messPunkteLkw = [-0, -2, -4];
        _this.messWinkelLkw = ['0', '1,15', '2,29'];
        _this.anzahlMessungen = 3;
        _this.typ = _this.props.typ;
        _this.daten = new Array();
        _this.state = { justage: false, messungen: { vorjustage: Array(), nachjustage: Array() } };
        if (_this.props.value) {
            _this.daten = JSON.parse(_this.props.value);
            // Zwei komplette Datensätze = Justage wurde durchgeführt
            _this.justage = (_this.daten.length > 1);
        }
        // Messpunkte vor und nach Justage erzeugen
        var sollwerte = (_this.props.typ === 'LKW') ? _this.messPunkteLkw : _this.messPunktePkw;
        var winkel = (_this.props.typ === 'LKW') ? _this.messWinkelLkw : _this.messWinkelPkw;
        for (var i = 0; i < _this.anzahlMessungen; i++) {
            for (var j = 0; j < 2; j++) {
                var messung = new Messung(i);
                messung.messpunkte = new Array();
                for (var k = 0; k < sollwerte.length; k++) {
                    var index = (i % 2 === 0) ? k : (sollwerte.length - 1 - k);
                    // Formular-ID die vom Back-End zur Übernahme der Daten genutzt wird
                    var id = _this.props.kategorieguid + "[" + _this.props.elementguid + "][" + j + "][" + (i * 3 + k) + "]";
                    var messpunkt = new Messpunkt(_this.props.editable ? _this.props.editable : true, sollwerte[index], winkel[index], id, undefined);
                    // Werte aus Datenübernahme
                    if ((_this.daten) && (_this.daten.length > j) && (_this.daten[j][i * 3 + k][1] !== null)) {
                        var wert = parseFloat(_this.daten[j][i * 3 + k][1]);
                        messpunkt.setMesswert(wert);
                    }
                    messung.messpunkte.push(messpunkt);
                }
                j === 0 ? _this.state.messungen.vorjustage.push(messung) : _this.state.messungen.nachjustage.push(messung);
            }
        }
        _this.validate();
        return _this;
    }
    SepHellDunkelGrenze.prototype.getMesspunktValidationState = function (p, vorjustage) {
        var res;
        res = p.messwert !== undefined ? undefined : 'error';
        // Bei Justage kann die Eingabe im ersten Durchgang vorzeitig abgebrochen werden, dann soll keine Validierung angzeigt werden
        if (vorjustage && this.justage) {
            res = undefined;
        }
        return res;
    };
    SepHellDunkelGrenze.prototype.renderMessungen = function (messungen, vorjustage) {
        var _this = this;
        return (messungen.map(function (messung, indexMessung) { return (React.createElement(react_bootstrap_1.Row, { key: "" + indexMessung },
            React.createElement(react_bootstrap_1.Col, { xs: 2 }),
            React.createElement(react_bootstrap_1.Col, { xs: 8 },
                React.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, condensed: true, hover: true },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { colSpan: 3 }, "Messung " + indexMessung)),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Soll [%]"),
                            React.createElement("th", null, "Messwert ist [%]"),
                            React.createElement("th", null, "Abweichung"))),
                    React.createElement("tbody", null, messung.messpunkte.map(function (p, indexPunkt) {
                        return React.createElement("tr", { key: indexMessung + "-" + indexPunkt },
                            React.createElement("td", { className: "tabelle-text-zentriert" }, p.soll + " (" + p.winkel + "\u00B0)"),
                            React.createElement("td", null,
                                React.createElement(react_bootstrap_1.FormGroup, { validationState: _this.getMesspunktValidationState(p, vorjustage), style: { margin: '0px' } },
                                    React.createElement(react_bootstrap_1.FormControl, { readOnly: !_this.props.editable, step: 0.01, onChange: function (e) { return _this.handleMesswertChange(p, e); }, type: "number", name: p.id + "[1]", value: p.messwert }),
                                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: p.id + "[2]", value: p.abweichung }),
                                    React.createElement(react_bootstrap_1.FormControl, { type: "hidden", name: p.id + "[0]", value: p.soll + " (" + p.winkel + "\u00B0)" }))),
                            React.createElement("td", { className: "tabelle-text-zentriert" },
                                React.createElement("span", { className: p.abweichungIo ? 'text-success' : 'text-danger' }, (p.abweichung !== undefined) ? p.abweichung.toLocaleString('de-DE') + " %" : '-')));
                    })))),
            React.createElement(react_bootstrap_1.Col, { xs: 2 }))); }));
    };
    SepHellDunkelGrenze.prototype.handleJustageChange = function (event) {
        this.justage = event.target.checked;
        this.validate();
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this.props.element);
        }
    };
    SepHellDunkelGrenze.prototype.handleMesswertChange = function (messpunkt, ev) {
        messpunkt.messwert = ev.target.value !== '' ? ev.target.valueAsNumber : undefined;
        if (messpunkt.messwert !== undefined) {
            messpunkt.abweichung = round_1.round(messpunkt.soll - messpunkt.messwert, 2);
            messpunkt.abweichungIo = (Math.abs(messpunkt.abweichung) <= 0.2);
        }
        else {
            messpunkt.abweichungIo = false;
        }
        this.validate();
        if (this.props.onHandleChange) {
            this.props.onHandleChange(this.props.element);
        }
    };
    SepHellDunkelGrenze.prototype.validate = function () {
        this.validationstate = 'success';
        // Messpunkte vor Justage nur validieren wenn keine Justage gewählt wurde
        if (!this.justage) {
            for (var _i = 0, _a = this.state.messungen.vorjustage; _i < _a.length; _i++) {
                var messung = _a[_i];
                for (var _b = 0, _c = messung.messpunkte; _b < _c.length; _b++) {
                    var messpunkt = _c[_b];
                    if (messpunkt.messwert === undefined) {
                        this.validationstate = 'error';
                        break;
                    }
                }
            }
        }
        if (this.justage) {
            for (var _d = 0, _e = this.state.messungen.nachjustage; _d < _e.length; _d++) {
                var messung = _e[_d];
                for (var _f = 0, _g = messung.messpunkte; _f < _g.length; _f++) {
                    var messpunkt = _g[_f];
                    if (messpunkt.messwert === undefined) {
                        this.validationstate = 'error';
                        break;
                    }
                }
            }
        }
        this.props.element.validationstate = this.validationstate;
    };
    SepHellDunkelGrenze.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", null,
                this.renderMessungen(this.state.messungen.vorjustage, true),
                React.createElement("div", { style: { textAlign: 'center', padding: '10px' } }, this.props.editable ? React.createElement(react_bootstrap_1.Checkbox, { onChange: this.handleJustageChange, inline: true, defaultChecked: this.justage }, "Justage notwendig") : 'Werte nach Justage'),
                this.justage && this.renderMessungen(this.state.messungen.nachjustage, false))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SepHellDunkelGrenze.prototype, "validationstate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], SepHellDunkelGrenze.prototype, "typ", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SepHellDunkelGrenze.prototype, "justage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SepHellDunkelGrenze.prototype, "abweichung", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SepHellDunkelGrenze.prototype, "handleJustageChange", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Messpunkt, Object]),
        __metadata("design:returntype", void 0)
    ], SepHellDunkelGrenze.prototype, "handleMesswertChange", null);
    SepHellDunkelGrenze = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SepHellDunkelGrenze);
    return SepHellDunkelGrenze;
}(React.Component));
exports.default = SepHellDunkelGrenze;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var react_bootstrap_1 = __webpack_require__(2);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var UiStore_1 = __webpack_require__(14);
var Callout_1 = __webpack_require__(16);
/** Zeigt die SES Systemneigungen des Gesamtsystems inkl. ihrer Beurteilung für abgeschlossene Auswertungen an */
var SesAnzeigeSystemneigung = (function (_super) {
    __extends(SesAnzeigeSystemneigung, _super);
    function SesAnzeigeSystemneigung() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SesAnzeigeSystemneigung.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.ergebnisBlockSes(this.props.vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (response.json) {
                                this.setErgebnisBlock(response.json);
                            }
                            else {
                                this.clearErgebnisBlock();
                            }
                        }
                        else {
                            this.clearErgebnisBlock();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SesAnzeigeSystemneigung.prototype.setErgebnisBlock = function (ergebnisBlock) {
        this.ergebnisBlock = ergebnisBlock;
    };
    SesAnzeigeSystemneigung.prototype.clearErgebnisBlock = function () {
        this.ergebnisBlock.datenvorhanden = false;
    };
    SesAnzeigeSystemneigung.prototype.render = function () {
        if (this.ergebnisBlock && this.ergebnisBlock.datenvorhanden) {
            var beurteilungStyle = void 0;
            var beurteilungText;
            var korrekturWertSEPohneNA = void 0;
            var korrekturWertSEPmitNA = void 0;
            var laengsneigungSEPio = void 0;
            var querneigungSEPio = void 0;
            var flaecheio = void 0;
            var neigungenio = void 0;
            var beurteilungio = void 0;
            // Korrekturwerte SEP für Ausführungen mit und ohne Niveauausgleich (NA) selektieren
            korrekturWertSEPohneNA = (this.ergebnisBlock.fahrzeug.laengs - this.ergebnisBlock.sep.quer).toLocaleString(undefined, { minimumFractionDigits: 1 });
            korrekturWertSEPmitNA = this.ergebnisBlock.fahrzeug.laengs.toLocaleString(undefined, { minimumFractionDigits: 1 });
            // Überprüfung der Gleichrichtiung der Flächen (nur für 2014er Rili)
            if (this.ergebnisBlock.richtlinie === '2014') {
                laengsneigungSEPio = ((this.ergebnisBlock.fahrzeug.laengs * this.ergebnisBlock.sep.quer) >= 0.0) ? true : false;
                querneigungSEPio = ((this.ergebnisBlock.fahrzeug.quer * this.ergebnisBlock.sep.laengs) >= 0.0) ? true : false;
            }
            else {
                laengsneigungSEPio = true;
                querneigungSEPio = true;
            }
            /*
              Beurteilung der Neigungen der Flächen zueinander
      
              Fläche in Ordnung wenn beide Kreuzvergleiche mit gleichem Vorzeichen
            */
            flaecheio = laengsneigungSEPio && querneigungSEPio;
            if (flaecheio) {
                beurteilungStyle = 'success';
                beurteilungText = (React.createElement("span", null,
                    "Korrekturwert f\u00FCr SEP ",
                    React.createElement("b", null, "ohne Niveauausgleich"),
                    ": ",
                    React.createElement("b", null,
                        korrekturWertSEPohneNA,
                        "%"),
                    React.createElement("br", null),
                    "Korrekturwert f\u00FCr SEP ",
                    React.createElement("b", null, "mit Niveauausgleich"),
                    ": ",
                    React.createElement("b", null,
                        korrekturWertSEPmitNA,
                        "%")));
            }
            else {
                beurteilungStyle = 'danger';
                beurteilungText = (React.createElement("span", null,
                    "Aufgrund der entgegengesetzten Neigungen Fahrzeug-Aufstellfl\u00E4che zu SEP Aufstellfl\u00E4che erf\u00FCllt diese Fl\u00E4che die Anforderungen nicht.",
                    React.createElement("br", null),
                    React.createElement("b", null, "Eine Korrektur des SEPs ist daher nicht m\u00F6glich!")));
            }
            /*
              Beurteilung der einzelnen Neigungen
      
              Alle Neigungen müssen im Bereich ±1,5% liegen
            */
            var maxNeigung = 1.5;
            neigungenio = ((Math.abs(this.ergebnisBlock.fahrzeug.laengs) <= maxNeigung) && (Math.abs(this.ergebnisBlock.fahrzeug.quer) <= maxNeigung)
                &&
                    (Math.abs(this.ergebnisBlock.sep.laengs) <= maxNeigung) && (Math.abs(this.ergebnisBlock.sep.quer) <= maxNeigung));
            if (flaecheio && !neigungenio) {
                beurteilungStyle = 'danger';
                beurteilungText = (React.createElement("span", null,
                    "Aufgrund der zu gro\u00DFen Neigungen (au\u00DFerhalb von \u00B11,5%) erf\u00FCllt diese Fl\u00E4che die Anforderungen nicht.",
                    React.createElement("br", null),
                    React.createElement("b", null, "Eine Korrektur des SEPs ist daher nicht m\u00F6glich!")));
            }
            beurteilungio = flaecheio && neigungenio;
            return (React.createElement(react_bootstrap_1.Panel, { header: "Systemneigung" },
                React.createElement(Callout_1.default, { bsStyle: "info" },
                    "Folgende Systemneigung wurde im Rahmen der Auswertung ermittelt.",
                    React.createElement("br", null),
                    "Details entnehmen Sie bitte den entsprechenden Dokumenten."),
                React.createElement(react_bootstrap_1.Table, { striped: false, bordered: true, condensed: false, hover: false, className: "auswertung-systemneigung" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { width: "20%" }),
                            React.createElement("th", { width: "40%" }, "Fahrzeug"),
                            React.createElement("th", { width: "40%" }, "SEP"))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "L\u00E4ngs"),
                            React.createElement("td", { className: (laengsneigungSEPio && Math.abs(this.ergebnisBlock.fahrzeug.laengs) <= maxNeigung) ? 'value-success' : 'value-error' },
                                this.ergebnisBlock.fahrzeug.laengs.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                                "%"),
                            React.createElement("td", { className: (querneigungSEPio && Math.abs(this.ergebnisBlock.sep.laengs) <= maxNeigung) ? 'value-success' : 'value-error' },
                                this.ergebnisBlock.sep.laengs.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                                "%")),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Quer"),
                            React.createElement("td", { className: (querneigungSEPio && Math.abs(this.ergebnisBlock.fahrzeug.quer) <= maxNeigung) ? 'value-success' : 'value-error' },
                                this.ergebnisBlock.fahrzeug.quer.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                                "%"),
                            React.createElement("td", { className: (laengsneigungSEPio && Math.abs(this.ergebnisBlock.sep.quer) <= maxNeigung) ? 'value-success' : 'value-error' },
                                this.ergebnisBlock.sep.quer.toLocaleString(undefined, { minimumFractionDigits: 1 }),
                                "%")))),
                React.createElement(Callout_1.default, { bsStyle: beurteilungStyle },
                    beurteilungText,
                    (beurteilungio) && (React.createElement("div", null, "Einzustellen an der Laser-Kalibriervorrichtung")))));
        }
        else {
            return React.createElement("div", null);
        }
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAnzeigeSystemneigung.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(UiStore_1.UiStore),
        __metadata("design:type", UiStore_1.UiStore)
    ], SesAnzeigeSystemneigung.prototype, "uiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAnzeigeSystemneigung.prototype, "ergebnisBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAnzeigeSystemneigung.prototype, "setErgebnisBlock", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesAnzeigeSystemneigung.prototype, "clearErgebnisBlock", null);
    SesAnzeigeSystemneigung = __decorate([
        mobx_react_1.observer
    ], SesAnzeigeSystemneigung);
    return SesAnzeigeSystemneigung;
}(React.Component));
exports.default = SesAnzeigeSystemneigung;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Callout_1 = __webpack_require__(16);
var decorators_1 = __webpack_require__(1);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var react_bootstrap_1 = __webpack_require__(2);
var FaIcon_1 = __webpack_require__(20);
var SesAuswertungFlaechenRili2025Store_1 = __webpack_require__(285);
var SesAuswertungSperrflaeche = (function (_super) {
    __extends(SesAuswertungSperrflaeche, _super);
    function SesAuswertungSperrflaeche() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SesAuswertungSperrflaeche.prototype.handleStartChanged = function (event) {
        var value = parseInt(event.target.value, 10);
        this.props.sperrFläche.start = value;
        this.props.onSperrFlächeÄndern(this.props.sperrFläche);
    };
    SesAuswertungSperrflaeche.prototype.handleEndeChanged = function (event) {
        var value = parseInt(event.target.value, 10);
        this.props.sperrFläche.ende = value;
        this.props.onSperrFlächeÄndern(this.props.sperrFläche);
    };
    SesAuswertungSperrflaeche.prototype.handleBeschreibungChanged = function (event) {
        this.props.sperrFläche.beschreibung = event.target.value;
    };
    SesAuswertungSperrflaeche.prototype.render = function () {
        var _this = this;
        var _a = this.props, sperrFläche = _a.sperrFläche, readonly = _a.readonly;
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", value: sperrFläche.start, onChange: this.handleStartChanged, readOnly: readonly })),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.FormControl, { type: "number", step: "any", className: "input-fahrspurlaenge", value: sperrFläche.ende, onChange: this.handleEndeChanged, readOnly: readonly })),
            React.createElement("td", null,
                React.createElement(react_bootstrap_1.FormControl, { type: "text", className: "input-fahrspurlaenge", value: sperrFläche.beschreibung, onChange: this.handleBeschreibungChanged, readOnly: readonly })),
            React.createElement("td", null, !readonly &&
                React.createElement(react_bootstrap_1.Button, { className: "btn-flat", style: { padding: '0px', margin: '0px' }, title: "Sperrfläche entfernen", onClick: function () { return _this.props.onSperrFlächeLöschen(sperrFläche); } },
                    React.createElement(FaIcon_1.default, { icon: "trash-o" })))));
    };
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaeche.prototype, "handleStartChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaeche.prototype, "handleEndeChanged", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaeche.prototype, "handleBeschreibungChanged", null);
    SesAuswertungSperrflaeche = __decorate([
        mobx_react_1.observer
    ], SesAuswertungSperrflaeche);
    return SesAuswertungSperrflaeche;
}(React.Component));
var SesAuswertungSperrflaechenEingabe = (function (_super) {
    __extends(SesAuswertungSperrflaechenEingabe, _super);
    function SesAuswertungSperrflaechenEingabe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.beurteilung = 'default';
        _this.hinweise = [];
        return _this;
    }
    SesAuswertungSperrflaechenEingabe.prototype.sperrFlächeHinzufügen = function (art) {
        this.store.messwerteFahrzeug.sperrflaechen.push({ start: 0, ende: 0, beschreibung: '', art: art });
    };
    SesAuswertungSperrflaechenEingabe.prototype.sperrFlächeLöschen = function (flaeche) {
        var index = this.store.messwerteFahrzeug.sperrflaechen.indexOf(flaeche);
        this.store.messwerteFahrzeug.sperrflaechen.splice(index, 1);
    };
    SesAuswertungSperrflaechenEingabe.prototype.sperrFlächeÄndern = function () {
        this.store.onSperrFlaecheGeaendert();
    };
    SesAuswertungSperrflaechenEingabe.prototype.setBeurteilung = function (beurteilung) {
        this.beurteilung = beurteilung;
    };
    SesAuswertungSperrflaechenEingabe.prototype.ermittleHinweise = function () {
        var _this = this;
        this.hinweise = [];
        // Die neue Richtlinie definiert unterschiedliche Kriterien für Sperrflächen, je nach Fahrzeugart
        var messwerteFahrzeug = this.store.messwerteFahrzeug;
        var sperrflaechen = messwerteFahrzeug.sperrflaechen.filter(function (flaeche) { return flaeche.art === _this.props.art; });
        if (this.props.art === 'kleinsteinbau') {
            // Lt. Richtlinie dürfen Kleinsteinbauten nie auf einem der Messpunkte liegen
            for (var _i = 0, _a = messwerteFahrzeug.messpunkte; _i < _a.length; _i++) {
                var messpunkt = _a[_i];
                var position = parseInt(messpunkt, 10);
                for (var _b = 0, sperrflaechen_1 = sperrflaechen; _b < sperrflaechen_1.length; _b++) {
                    var sperrflaeche = sperrflaechen_1[_b];
                    if (position >= sperrflaeche.start && position <= sperrflaeche.ende) {
                        this.hinweise.push("Kleinsteinbauten d\u00FCrfen nicht auf einem Messpunkt liegen (" + position + "mm)");
                    }
                }
            }
            for (var _c = 0, sperrflaechen_2 = sperrflaechen; _c < sperrflaechen_2.length; _c++) {
                var sperrflaeche = sperrflaechen_2[_c];
                // Kleinsteinbauten dürfen max. 10cm lang sein
                if ((sperrflaeche.ende - sperrflaeche.start > 100)) {
                    this.hinweise.push('Kleinsteinbauten dürfen max. 10cm lang sein');
                    break;
                }
                // Kleinsteinbauten müssen eine positive Länge haben
                if ((sperrflaeche.ende <= sperrflaeche.start)) {
                    this.hinweise.push('Länge der Kleinsteinbaut muss größer 0mm sein');
                    break;
                }
            }
        }
        else {
            // Regeln für Sperrflächen unterscheiden sich je nach Fahrzeugart
            // Regeln für PKW
            if (messwerteFahrzeug.typ === 'PKW') {
                for (var _d = 0, sperrflaechen_3 = sperrflaechen; _d < sperrflaechen_3.length; _d++) {
                    var sperrflaeche = sperrflaechen_3[_d];
                    if (sperrflaeche.start <= 600) {
                        this.hinweise.push('Sperrflächen müssen min. 60cm Abstand vom Beginn der Aufstellfläche haben');
                        break;
                    }
                }
                for (var _e = 0, sperrflaechen_4 = sperrflaechen; _e < sperrflaechen_4.length; _e++) {
                    var sperrflaeche = sperrflaechen_4[_e];
                    if ((sperrflaeche.ende - sperrflaeche.start > 1500)) {
                        this.hinweise.push('Sperrfläche dürfen max. 150cm lang sein');
                        break;
                    }
                }
                if (sperrflaechen.length > 1) {
                    this.hinweise.push('Es darf max. eine Sperrfläche vorhanden sein');
                }
            }
            // Regeln für LKW
            if (messwerteFahrzeug.typ === 'LKW') {
                for (var _f = 0, sperrflaechen_5 = sperrflaechen; _f < sperrflaechen_5.length; _f++) {
                    var sperrflaeche = sperrflaechen_5[_f];
                    if (sperrflaeche.start <= 900) {
                        this.hinweise.push('Sperrflächen müssen min. 90cm Abstand vom Beginn der Aufstellfläche haben');
                        break;
                    }
                }
                if (sperrflaechen.length > 1) {
                    for (var i = 1; i < sperrflaechen.length; i++) {
                        if (Math.abs(sperrflaechen[i].start - sperrflaechen[i - 1].ende) < 1000) {
                            this.hinweise.push('Sperrflächen müssen min. 100cm auseinanderliegen');
                            break;
                        }
                    }
                }
                var gesamtLaenge = 0;
                for (var _g = 0, sperrflaechen_6 = sperrflaechen; _g < sperrflaechen_6.length; _g++) {
                    var sperrflaeche = sperrflaechen_6[_g];
                    gesamtLaenge += (sperrflaeche.ende - sperrflaeche.start);
                }
                if (gesamtLaenge > 2700) {
                    this.hinweise.push('Die Gesamtlänge der Sperrflächen darf max. 270cm betragen');
                }
                if (sperrflaechen.filter(function (flaeche) { return flaeche.art === 'sperrflaeche'; }).length > 2) {
                    this.hinweise.push('Es dürfen max. zwei Sperrflächen vorhanden sein');
                }
            }
            // Regeln für KRAD
            if (messwerteFahrzeug.typ === 'KRAD') {
                for (var _h = 0, sperrflaechen_7 = sperrflaechen; _h < sperrflaechen_7.length; _h++) {
                    var sperrflaeche = sperrflaechen_7[_h];
                    if (sperrflaeche.art === 'sperrflaeche') {
                        this.hinweise.push('Bei KRAD Aufstellflächen sind keine Sperrflächen erlaubt');
                        break;
                    }
                }
            }
            // Sperrflächen müssen eine positive Länge haben
            for (var _j = 0, sperrflaechen_8 = sperrflaechen; _j < sperrflaechen_8.length; _j++) {
                var sperrflaeche = sperrflaechen_8[_j];
                if ((sperrflaeche.ende <= sperrflaeche.start)) {
                    this.hinweise.push('Länge der Sperrfläche muss größer 0mm sein');
                    break;
                }
            }
        }
        // Panel soll optisch hervorgehoben werden, damit direkt erkennbar ist ob die Eingabe korrekt ist
        var beurteilung = 'default';
        if (sperrflaechen.length > 0) {
            beurteilung = this.hinweise.length > 0 ? 'danger' : 'success';
        }
        this.setBeurteilung(beurteilung);
    };
    SesAuswertungSperrflaechenEingabe.prototype.render = function () {
        var _this = this;
        this.ermittleHinweise();
        var flaechen = this.store.messwerteFahrzeug.sperrflaechen.filter(function (el) { return el.art === _this.props.art; });
        var header = (this.props.art === 'sperrflaeche') ? 'Sperrflächen' : 'Kleinsteinbauten';
        header += " (" + flaechen.length + ")";
        return (React.createElement(react_bootstrap_1.Panel, { header: header, collapsible: true, defaultExpanded: false, bsStyle: this.beurteilung },
            flaechen.length > 0 &&
                React.createElement(react_bootstrap_1.Table, { striped: false, bordered: true, condensed: true, hover: false, className: "aufstellflaeche-punkte" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { style: { textAlign: 'center', width: '96px' } },
                                "Von ",
                                React.createElement("small", null, "[mm]")),
                            React.createElement("th", { style: { textAlign: 'center', width: '96px' } },
                                "Bis ",
                                React.createElement("small", null, "[mm]")),
                            React.createElement("th", { style: { textAlign: 'center' } }, "Beschreibung"),
                            React.createElement("th", { style: { textAlign: 'center', width: '32px' } }))),
                    React.createElement("tbody", null, flaechen.map(function (flaeche, index) { return (React.createElement(SesAuswertungSperrflaeche, { key: index, "sperrFl\u00E4che": flaeche, "onSperrFl\u00E4cheL\u00F6schen": _this.sperrFlächeLöschen, "onSperrFl\u00E4che\u00C4ndern": _this.sperrFlächeÄndern, readonly: !_this.store.editable })); }))),
            React.createElement("div", null, (this.hinweise.length > 0) &&
                React.createElement(Callout_1.default, { bsStyle: "danger" }, this.hinweise.map(function (hinweis, index) { return (React.createElement("p", { key: index }, hinweis)); }))),
            React.createElement("div", { className: "text-right" }, this.store.editable && React.createElement(react_bootstrap_1.Button, { onClick: function () { return _this.sperrFlächeHinzufügen(_this.props.art); } }, "Hinzuf\u00FCgen"))));
    };
    __decorate([
        decorators_1.inject(SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store),
        __metadata("design:type", SesAuswertungFlaechenRili2025Store_1.SesAuswertungFlaechenRili2025Store)
    ], SesAuswertungSperrflaechenEingabe.prototype, "store", void 0);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaechenEingabe.prototype, "sperrFl\u00E4cheHinzuf\u00FCgen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaechenEingabe.prototype, "sperrFl\u00E4cheL\u00F6schen", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaechenEingabe.prototype, "sperrFl\u00E4che\u00C4ndern", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungSperrflaechenEingabe.prototype, "setBeurteilung", null);
    SesAuswertungSperrflaechenEingabe = __decorate([
        mobx_react_1.observer
    ], SesAuswertungSperrflaechenEingabe);
    return SesAuswertungSperrflaechenEingabe;
}(React.Component));
var SesAuswertungSperrflaechen = (function (_super) {
    __extends(SesAuswertungSperrflaechen, _super);
    function SesAuswertungSperrflaechen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SesAuswertungSperrflaechen.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(SesAuswertungSperrflaechenEingabe, { art: 'sperrflaeche' }),
            React.createElement(SesAuswertungSperrflaechenEingabe, { art: 'kleinsteinbau' })));
    };
    SesAuswertungSperrflaechen = __decorate([
        mobx_react_1.observer
    ], SesAuswertungSperrflaechen);
    return SesAuswertungSperrflaechen;
}(React.Component));
exports.default = SesAuswertungSperrflaechen;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(4);
var mobx_1 = __webpack_require__(3);
var Callout_1 = __webpack_require__(16);
var decorators_1 = __webpack_require__(1);
var ApiStore_1 = __webpack_require__(13);
var VorgangStore_1 = __webpack_require__(22);
var react_bootstrap_1 = __webpack_require__(2);
var react_select_1 = __webpack_require__(574);
__webpack_require__(356);
/** Komponente zur Übernahme von Messwerten SES aus einem alten Auftrag */
var SesUebernahmeMesswerte = (function (_super) {
    __extends(SesUebernahmeMesswerte, _super);
    function SesUebernahmeMesswerte() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SesUebernahmeMesswerte.prototype.setAuftraege = function (auftraege) {
        this.auftraege = auftraege;
    };
    SesUebernahmeMesswerte.prototype.clearAuftraege = function () {
        this.auftraege = undefined;
    };
    SesUebernahmeMesswerte.prototype.handleQuellAuftragChanged = function (option) {
        this.quellAuftrag = option.value ? option.value : '';
    };
    SesUebernahmeMesswerte.prototype.handleUebernehmeMesswerte = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vorgangId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vorgangId = this.props.vorgangId;
                        if (!this.quellAuftrag) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiStore.ubernehmeMesswerteSes(this.props.vorgangId, this.quellAuftrag.toString())];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.vorgangStore.loadVorgang(vorgangId);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SesUebernahmeMesswerte.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearAuftraege();
                        return [4 /*yield*/, this.apiStore.auftraegemesswerte('ses')];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setAuftraege(response.json);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SesUebernahmeMesswerte.prototype.render = function () {
        var _this = this;
        var auftraegeArray;
        auftraegeArray = [];
        if (this.auftraege) {
            for (var _i = 0, _a = this.auftraege; _i < _a.length; _i++) {
                var auftrag = _a[_i];
                var option = { value: auftrag.refnr, label: auftrag.auftrag_name + " (" + auftrag.refnr + ")", key: auftrag.refnr };
                auftraegeArray.push(option);
            }
        }
        return (React.createElement("div", { className: "auswertung-messwerte" }, this.props.vorgangId && ((true)
            ?
                React.createElement("div", null,
                    React.createElement(react_bootstrap_1.Form, { horizontal: true },
                        React.createElement(react_bootstrap_1.Panel, { header: "Quelle", footer: (React.createElement("div", { className: "text-right" },
                                React.createElement(react_bootstrap_1.Button, { disabled: !this.quellAuftrag, bsStyle: "success", onClick: function () { return _this.handleUebernehmeMesswerte(); } }, "Daten \u00FCbernehmen"))) },
                            React.createElement(Callout_1.default, { bsStyle: "success" },
                                "W\u00E4hlen Sie hier den Auftrag aus dem die Messwerte \u00FCbernommen werden sollen. Nach der Best\u00E4tigung werden die Daten in den aktuellen Auftrag kopiert (inkl. Dokumente).",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Im Anschlu\u00DF k\u00F6nnen die Vorg\u00E4nge abgeschlossen werden, f\u00FCr die Messwerte erforderlich sind (z.B. Kalibrierung, St\u00FCckpr\u00FCfung)."),
                            React.createElement(react_bootstrap_1.FormGroup, { controlId: "Übernehmen aus" },
                                React.createElement(react_bootstrap_1.Col, { sm: 1 }),
                                React.createElement(react_bootstrap_1.Col, { sm: 10 },
                                    React.createElement(react_select_1.default, { name: "auftrag-quelle", clearable: false, value: this.quellAuftrag, onChange: this.handleQuellAuftragChanged, options: auftraegeArray, placeholder: "Auftrag auswählen...", noResultsText: "Keine Aufträge entsprechen der Suche..." })),
                                React.createElement(react_bootstrap_1.Col, { sm: 1 })))))
            :
                React.createElement(Callout_1.default, { bsStyle: "danger" }, "Das Erzeugen der Auswertung ist erst m\u00F6glich wenn f\u00FCr beide Aufstellfl\u00E4chen alle ben\u00F6tigten Messwerte eingegeben wurden."))));
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesUebernahmeMesswerte.prototype, "apiStore", void 0);
    __decorate([
        decorators_1.inject(VorgangStore_1.VorgangStore),
        __metadata("design:type", VorgangStore_1.VorgangStore)
    ], SesUebernahmeMesswerte.prototype, "vorgangStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SesUebernahmeMesswerte.prototype, "auftraege", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesUebernahmeMesswerte.prototype, "quellAuftrag", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SesUebernahmeMesswerte.prototype, "setAuftraege", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesUebernahmeMesswerte.prototype, "clearAuftraege", null);
    __decorate([
        decorators_1.bind, mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesUebernahmeMesswerte.prototype, "handleQuellAuftragChanged", null);
    __decorate([
        decorators_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SesUebernahmeMesswerte.prototype, "handleUebernehmeMesswerte", null);
    SesUebernahmeMesswerte = __decorate([
        mobx_react_1.observer
    ], SesUebernahmeMesswerte);
    return SesUebernahmeMesswerte;
}(React.Component));
exports.default = SesUebernahmeMesswerte;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** Für die Kalibrierung eines Abgasmessgerätes mit Partikelzählung verwendete Typen */
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var SesAuswertungFlaechenRili2014Store = (function () {
    function SesAuswertungFlaechenRili2014Store() {
        this.messwerteFahrzeug = {
            messpunkte: ['0', '1000', '2000', '3000', '4000', '6000', '8000'],
            sperrpunkte: [],
            sperrflaechen: [],
            messwerte: {
                links: ['0', '', '', '', '', '', ''],
                rechts: ['', '', '', '', '', '', '']
            },
            fahrspur: {
                breite: '',
                laenge: ''
            },
            flaeche: {
                steigung: '',
                achsenabschnitt: '0'
            },
            typ: undefined
        };
        this.messwerteSep = {
            messpunkte: ['0', '250', '500', '750', '1000', '1250', '1500', '1750', '2000', '2250', '2500'],
            sperrpunkte: [],
            sperrflaechen: [],
            messwerte: {
                links: ['0', '', '', '', '', '', '', '', '', '', ''],
                rechts: ['', '', '', '', '', '', '', '', '', '', '']
            },
            fahrspur: {
                breite: '',
                laenge: '2500'
            },
            flaeche: {
                steigung: '',
                achsenabschnitt: '0'
            },
            typ: undefined
        };
        this.beurteilungFahrzeug = {
            beurteilung: [],
            neigungen: {
                quer: 0,
                laengs: 0,
                ermittelt: 0
            }
        };
        this.beurteilungSep = {
            beurteilung: [],
            neigungen: {
                quer: 0,
                laengs: 0,
                ermittelt: 0
            }
        };
        this.zeitpunktGespeichert = undefined;
        this.gespeicherteEingabenVorhanden = false;
        this.editable = true;
        this.validateTimeoutRef = 0;
        this.validateTimeOutTyp = undefined;
    }
    SesAuswertungFlaechenRili2014Store_1 = SesAuswertungFlaechenRili2014Store;
    SesAuswertungFlaechenRili2014Store.prototype.validateMesswerteDelayed = function (aufstellflaechenTyp, maximaleSpurAnzahl) {
        var _this = this;
        if ((this.validateTimeoutRef > 0) && (this.validateTimeOutTyp === aufstellflaechenTyp)) {
            window.clearTimeout(this.validateTimeoutRef);
            this.validateTimeoutRef = 0;
        }
        var validateTimeoutInMs = 400;
        this.validateTimeOutTyp = aufstellflaechenTyp;
        this.validateTimeoutRef = window.setTimeout(function () {
            _this.validateMesswerte(aufstellflaechenTyp, maximaleSpurAnzahl);
        }, validateTimeoutInMs);
    };
    SesAuswertungFlaechenRili2014Store.prototype.validateMesswerte = function (aufstellflaechenTyp, maximaleSpurAnzahl) {
        return __awaiter(this, void 0, void 0, function () {
            var messung, response, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(aufstellflaechenTyp === 'fahrzeug')) return [3 /*break*/, 2];
                        messung = {
                            messpunkte: this.messwerteFahrzeug.messpunkte,
                            messwerte: {
                                links: this.messwerteFahrzeug.messwerte.links,
                                rechts: this.messwerteFahrzeug.messwerte.rechts
                            },
                            fahrspur: this.messwerteFahrzeug.fahrspur,
                            flaeche: this.messwerteFahrzeug.flaeche,
                            typ: this.messwerteFahrzeug.typ,
                            sperrpunkte: [],
                            sperrflaechen: []
                        };
                        messung.messpunkte = messung.messpunkte.slice(0, maximaleSpurAnzahl);
                        messung.messwerte.links = messung.messwerte.links.slice(0, maximaleSpurAnzahl);
                        messung.messwerte.rechts = messung.messwerte.rechts.slice(0, maximaleSpurAnzahl);
                        return [4 /*yield*/, this.apiStore.beurteilungFahrzeugAufstellflaeche(messung)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setBeurteilungFahrzeug(response.json);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(aufstellflaechenTyp === 'sep')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiStore.beurteilungSepAufstellflaeche(this.messwerteSep)];
                    case 3:
                        response = _a.sent();
                        if (response.ok) {
                            this.setBeurteilungSep(response.json);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2014Store.prototype.clear = function () {
        this.messwerteFahrzeug.messpunkte = ['0', '1000', '2000', '3000', '4000', '6000', '8000'];
        this.messwerteFahrzeug.messwerte.links = ['0', '', '', '', '', '', ''];
        this.messwerteFahrzeug.messwerte.rechts = ['', '', '', '', '', '', ''];
        this.messwerteFahrzeug.fahrspur.breite = '';
        this.messwerteFahrzeug.fahrspur.laenge = '';
        this.messwerteFahrzeug.flaeche.steigung = '';
        this.messwerteFahrzeug.flaeche.achsenabschnitt = '0';
        this.messwerteFahrzeug.typ = undefined;
        this.messwerteSep.messpunkte = ['0', '250', '500', '750', '1000', '1250', '1500', '1750', '2000', '2250', '2500'];
        this.messwerteSep.messwerte.links = ['0', '', '', '', '', '', '', '', '', '', ''];
        this.messwerteSep.messwerte.rechts = ['', '', '', '', '', '', '', '', '', '', ''];
        this.messwerteSep.fahrspur.breite = '';
        this.messwerteSep.fahrspur.laenge = '2500';
        this.messwerteSep.flaeche.steigung = '';
        this.messwerteSep.flaeche.achsenabschnitt = '0';
        this.messwerteSep.typ = undefined;
        this.beurteilungFahrzeug.beurteilung = [];
        this.beurteilungSep.beurteilung = [];
    };
    SesAuswertungFlaechenRili2014Store.prototype.setBeurteilungFahrzeug = function (ergebnis) {
        this.beurteilungFahrzeug = ergebnis;
    };
    SesAuswertungFlaechenRili2014Store.prototype.setBeurteilungSep = function (ergebnis) {
        this.beurteilungSep = ergebnis;
    };
    SesAuswertungFlaechenRili2014Store.prototype.setEditable = function (value) {
        this.editable = value;
    };
    SesAuswertungFlaechenRili2014Store.prototype.setZeitpunktGespeichert = function (value) {
        this.zeitpunktGespeichert = value;
    };
    /** Übernimmt alle zwischengspeicherten Werte der Messung, leere Felder (null) werden übersprungen */
    SesAuswertungFlaechenRili2014Store.prototype.uebernehmeMessung = function (quelle, ziel) {
        for (var i = 0; i < quelle.messwerte.links.length; i++) {
            if (quelle.messwerte.links[i] !== null) {
                ziel.messwerte.links[i] = quelle.messwerte.links[i];
            }
        }
        for (var i = 0; i < quelle.messwerte.rechts.length; i++) {
            if (quelle.messwerte.rechts[i] !== null) {
                ziel.messwerte.rechts[i] = quelle.messwerte.rechts[i];
            }
        }
        for (var i = 0; i < quelle.messpunkte.length; i++) {
            if (quelle.messpunkte[i] !== null) {
                ziel.messpunkte[i] = quelle.messpunkte[i];
            }
        }
        if (quelle.fahrspur.breite !== null) {
            ziel.fahrspur.breite = quelle.fahrspur.breite;
        }
        if (quelle.fahrspur.laenge !== null) {
            ziel.fahrspur.laenge = quelle.fahrspur.laenge;
        }
        if (quelle.flaeche.steigung !== null) {
            ziel.flaeche.steigung = quelle.flaeche.steigung;
        }
        if (quelle.flaeche.achsenabschnitt !== null) {
            ziel.flaeche.achsenabschnitt = quelle.flaeche.achsenabschnitt;
        }
    };
    SesAuswertungFlaechenRili2014Store.prototype.setMesswerteFahrzeug = function (messwerte) {
        this.uebernehmeMessung(messwerte, this.messwerteFahrzeug);
    };
    SesAuswertungFlaechenRili2014Store.prototype.setMesswerteSep = function (messwerte) {
        this.uebernehmeMessung(messwerte, this.messwerteSep);
    };
    SesAuswertungFlaechenRili2014Store.prototype.setGespeicherteEingabenVorhanden = function (wert) {
        this.gespeicherteEingabenVorhanden = wert;
    };
    /** Speichert die aktuellen Eingaben zwischen */
    SesAuswertungFlaechenRili2014Store.prototype.eingabenSpeichern = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, zeitpunkt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, this.messwerteFahrzeug, this.messwerteSep)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            zeitpunkt = new Date();
                            this.setZeitpunktGespeichert(zeitpunkt.toLocaleDateString() + ' ' + zeitpunkt.toLocaleTimeString());
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Lädt bereits zwischengespeicherte Eingaben */
    SesAuswertungFlaechenRili2014Store.prototype.eingabenLaden = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, mw;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.eingabenAuswertungSesLaden(vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (response.json.wert) {
                                try {
                                    mw = JSON.parse(response.json.wert);
                                    this.setMesswerteFahrzeug(mw.messdaten.fahrzeug);
                                    this.setMesswerteSep(mw.messdaten.sep);
                                    this.setGespeicherteEingabenVorhanden(true);
                                }
                                catch (e) {
                                    console.log('Eingabedaten konnten nicht geladen werden');
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungFlaechenRili2014Store.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2014Store.prototype, "messwerteFahrzeug", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2014Store.prototype, "messwerteSep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2014Store.prototype, "beurteilungFahrzeug", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2014Store.prototype, "beurteilungSep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2014Store.prototype, "zeitpunktGespeichert", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2014Store.prototype, "gespeicherteEingabenVorhanden", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setBeurteilungFahrzeug", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setBeurteilungSep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setEditable", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setZeitpunktGespeichert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setMesswerteFahrzeug", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setMesswerteSep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2014Store.prototype, "setGespeicherteEingabenVorhanden", null);
    SesAuswertungFlaechenRili2014Store = SesAuswertungFlaechenRili2014Store_1 = __decorate([
        decorators_1.provideSingleton(SesAuswertungFlaechenRili2014Store_1)
    ], SesAuswertungFlaechenRili2014Store);
    return SesAuswertungFlaechenRili2014Store;
    var SesAuswertungFlaechenRili2014Store_1;
}());
exports.SesAuswertungFlaechenRili2014Store = SesAuswertungFlaechenRili2014Store;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(3);
var ApiStore_1 = __webpack_require__(13);
var decorators_1 = __webpack_require__(1);
var SesAuswertungFlaechenRili2018Store = (function () {
    function SesAuswertungFlaechenRili2018Store() {
        this.messRaster = 250;
        this.messwerteFahrzeug = {
            messpunkte: [],
            sperrpunkte: [],
            sperrflaechen: [],
            messwerte: {
                links: [],
                rechts: []
            },
            fahrspur: {
                breite: '',
                laenge: ''
            },
            flaeche: {
                steigung: '',
                achsenabschnitt: '0'
            },
            typ: undefined
        };
        this.messwerteSep = {
            messpunkte: ['0', '250', '500', '750', '1000', '1250', '1500', '1750', '2000', '2250', '2500'],
            sperrpunkte: [],
            sperrflaechen: [],
            messwerte: {
                links: ['0', '', '', '', '', '', '', '', '', '', ''],
                rechts: ['', '', '', '', '', '', '', '', '', '', '']
            },
            fahrspur: {
                breite: '',
                laenge: '2500'
            },
            flaeche: {
                steigung: '',
                achsenabschnitt: '0'
            },
            typ: undefined,
            richtlinie: '2018'
        };
        this.beurteilungFahrzeug = {
            beurteilung: [],
            neigungen: {
                quer: 0,
                laengs: 0,
                ermittelt: 0
            }
        };
        this.beurteilungSep = {
            beurteilung: [],
            neigungen: {
                quer: 0,
                laengs: 0,
                ermittelt: 0
            }
        };
        this.zeitpunktGespeichert = undefined;
        this.gespeicherteEingabenVorhanden = false;
        this.editable = true;
        this.validateTimeoutRef = 0;
        this.validateTimeOutTyp = undefined;
    }
    SesAuswertungFlaechenRili2018Store_1 = SesAuswertungFlaechenRili2018Store;
    SesAuswertungFlaechenRili2018Store.prototype.validateMesswerteDelayed = function (aufstellflaechenTyp, maximaleSpurAnzahl) {
        var _this = this;
        if ((this.validateTimeoutRef > 0) && (this.validateTimeOutTyp === aufstellflaechenTyp)) {
            window.clearTimeout(this.validateTimeoutRef);
            this.validateTimeoutRef = 0;
        }
        var validateTimeoutInMs = 400;
        this.validateTimeOutTyp = aufstellflaechenTyp;
        this.validateTimeoutRef = window.setTimeout(function () {
            _this.validateMesswerte(aufstellflaechenTyp, maximaleSpurAnzahl);
        }, validateTimeoutInMs);
    };
    SesAuswertungFlaechenRili2018Store.prototype.validateMesswerte = function (aufstellflaechenTyp, maximaleSpurAnzahl) {
        return __awaiter(this, void 0, void 0, function () {
            var messung, response, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(aufstellflaechenTyp === 'fahrzeug')) return [3 /*break*/, 2];
                        messung = {
                            messpunkte: this.messwerteFahrzeug.messpunkte,
                            messwerte: {
                                links: this.messwerteFahrzeug.messwerte.links,
                                rechts: this.messwerteFahrzeug.messwerte.rechts
                            },
                            fahrspur: this.messwerteFahrzeug.fahrspur,
                            flaeche: this.messwerteFahrzeug.flaeche,
                            typ: this.messwerteFahrzeug.typ,
                            sperrpunkte: this.messwerteFahrzeug.sperrpunkte,
                            sperrflaechen: []
                        };
                        messung.messpunkte = messung.messpunkte.slice(0, maximaleSpurAnzahl);
                        messung.messwerte.links = messung.messwerte.links.slice(0, maximaleSpurAnzahl);
                        messung.messwerte.rechts = messung.messwerte.rechts.slice(0, maximaleSpurAnzahl);
                        return [4 /*yield*/, this.apiStore.beurteilungFahrzeugAufstellflaecheRili2018(messung)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.setBeurteilungFahrzeug(response.json);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(aufstellflaechenTyp === 'sep')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiStore.beurteilungSepAufstellflaeche(this.messwerteSep)];
                    case 3:
                        response = _a.sent();
                        if (response.ok) {
                            this.setBeurteilungSep(response.json);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2018Store.prototype.clear = function () {
        this.messwerteFahrzeug.messpunkte = [];
        this.messwerteFahrzeug.messwerte.links = [];
        this.messwerteFahrzeug.messwerte.rechts = [];
        this.messwerteFahrzeug.sperrpunkte = [];
        for (var i = 0; i < (8000 / this.messRaster) + 1; i++) {
            this.messwerteFahrzeug.messpunkte.push((i * this.messRaster).toString());
            this.messwerteFahrzeug.messwerte.links.push(i === 0 ? '0' : '');
            this.messwerteFahrzeug.messwerte.rechts.push('');
            this.messwerteFahrzeug.sperrpunkte.push(false);
        }
        this.messwerteFahrzeug.fahrspur.breite = '';
        this.messwerteFahrzeug.fahrspur.laenge = '';
        this.messwerteFahrzeug.flaeche.steigung = '';
        this.messwerteFahrzeug.flaeche.achsenabschnitt = '0';
        this.messwerteFahrzeug.typ = undefined;
        this.messwerteSep.messpunkte = ['0', '250', '500', '750', '1000', '1250', '1500', '1750', '2000', '2250', '2500'];
        this.messwerteSep.messwerte.links = ['0', '', '', '', '', '', '', '', '', '', ''];
        this.messwerteSep.messwerte.rechts = ['', '', '', '', '', '', '', '', '', '', ''];
        this.messwerteSep.fahrspur.breite = '';
        this.messwerteSep.fahrspur.laenge = '2500';
        this.messwerteSep.flaeche.steigung = '';
        this.messwerteSep.flaeche.achsenabschnitt = '0';
        this.messwerteSep.typ = undefined;
        this.messwerteSep.richtlinie = '2018';
        this.beurteilungFahrzeug.beurteilung = [];
        this.beurteilungSep.beurteilung = [];
    };
    SesAuswertungFlaechenRili2018Store.prototype.setBeurteilungFahrzeug = function (ergebnis) {
        this.beurteilungFahrzeug = ergebnis;
    };
    SesAuswertungFlaechenRili2018Store.prototype.setBeurteilungSep = function (ergebnis) {
        this.beurteilungSep = ergebnis;
    };
    SesAuswertungFlaechenRili2018Store.prototype.setZeitpunktGespeichert = function (value) {
        this.zeitpunktGespeichert = value;
    };
    SesAuswertungFlaechenRili2018Store.prototype.setEditable = function (value) {
        this.editable = value;
    };
    SesAuswertungFlaechenRili2018Store.prototype.uebernehmeMessung = function (quelle, ziel) {
        // Im JSON werden leere Felder als null gespeichert, Inputs erwarten dann aber einen Leerstring, also übernehmen wir nur wirklich zwischengespeicherte Werte
        for (var i = 0; i < quelle.messwerte.links.length; i++) {
            if (quelle.messwerte.links[i] !== null) {
                ziel.messwerte.links[i] = quelle.messwerte.links[i];
            }
        }
        for (var i = 0; i < quelle.messwerte.rechts.length; i++) {
            if (quelle.messwerte.rechts[i] !== null) {
                ziel.messwerte.rechts[i] = quelle.messwerte.rechts[i];
            }
        }
        for (var i = 0; i < quelle.sperrpunkte.length; i++) {
            if (quelle.sperrpunkte[i] !== null) {
                ziel.sperrpunkte[i] = quelle.sperrpunkte[i];
            }
        }
        if (quelle.fahrspur.breite !== null) {
            ziel.fahrspur.breite = quelle.fahrspur.breite;
        }
        if (quelle.fahrspur.laenge !== null) {
            ziel.fahrspur.laenge = quelle.fahrspur.laenge;
        }
        if (quelle.flaeche.steigung !== null) {
            ziel.flaeche.steigung = quelle.flaeche.steigung;
        }
        if (quelle.flaeche.achsenabschnitt !== null) {
            ziel.flaeche.achsenabschnitt = quelle.flaeche.achsenabschnitt;
        }
    };
    SesAuswertungFlaechenRili2018Store.prototype.setMesswerteFahrzeug = function (messwerte) {
        this.uebernehmeMessung(messwerte, this.messwerteFahrzeug);
    };
    SesAuswertungFlaechenRili2018Store.prototype.setMesswerteSep = function (messwerte) {
        this.uebernehmeMessung(messwerte, this.messwerteSep);
    };
    SesAuswertungFlaechenRili2018Store.prototype.setGespeicherteEingabenVorhanden = function (wert) {
        this.gespeicherteEingabenVorhanden = wert;
    };
    SesAuswertungFlaechenRili2018Store.prototype.eingabenSpeichern = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, zeitpunkt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.eingabenAuswertungSesSpeichern(vorgangId, this.messwerteFahrzeug, this.messwerteSep)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            zeitpunkt = new Date();
                            this.setZeitpunktGespeichert(zeitpunkt.toLocaleDateString() + ' ' + zeitpunkt.toLocaleTimeString());
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SesAuswertungFlaechenRili2018Store.prototype.eingabenLaden = function (vorgangId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, mw;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStore.eingabenAuswertungSesLaden(vorgangId)];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            if (response.json.wert) {
                                try {
                                    mw = JSON.parse(response.json.wert);
                                    this.setMesswerteFahrzeug(mw.messdaten.fahrzeug);
                                    this.setMesswerteSep(mw.messdaten.sep);
                                    this.setGespeicherteEingabenVorhanden(true);
                                }
                                catch (e) {
                                    console.log('Eingabedaten konnten nicht geladen werden');
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        decorators_1.inject(ApiStore_1.ApiStore),
        __metadata("design:type", ApiStore_1.ApiStore)
    ], SesAuswertungFlaechenRili2018Store.prototype, "apiStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2018Store.prototype, "messwerteFahrzeug", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2018Store.prototype, "messwerteSep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2018Store.prototype, "beurteilungFahrzeug", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2018Store.prototype, "beurteilungSep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SesAuswertungFlaechenRili2018Store.prototype, "zeitpunktGespeichert", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SesAuswertungFlaechenRili2018Store.prototype, "gespeicherteEingabenVorhanden", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setBeurteilungFahrzeug", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setBeurteilungSep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setZeitpunktGespeichert", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setEditable", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setMesswerteFahrzeug", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setMesswerteSep", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SesAuswertungFlaechenRili2018Store.prototype, "setGespeicherteEingabenVorhanden", null);
    SesAuswertungFlaechenRili2018Store = SesAuswertungFlaechenRili2018Store_1 = __decorate([
        decorators_1.provideSingleton(SesAuswertungFlaechenRili2018Store_1)
    ], SesAuswertungFlaechenRili2018Store);
    return SesAuswertungFlaechenRili2018Store;
    var SesAuswertungFlaechenRili2018Store_1;
}());
exports.SesAuswertungFlaechenRili2018Store = SesAuswertungFlaechenRili2018Store;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(59);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(691);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(59);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAEdCAMAAAB+AtiEAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA/UExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgIDAwMH9/f5+fn7+/v9/f3////2xHyq0AAAANdFJOUwAIMEhweIC+v9/v9/4mZdoPAAAACXBIWXMAADLAAAAywAEoZFrbAAADBUlEQVR4Xu3R2XJTMRBFUROGDBAISf7/WylXBMRDfKRzNXS79n7Si7q1SrsJ3Xwuh+TdPHy/CsnNw+PjNUj2jmuQvDnyS/46skv+O3JL3jsySw4deSXHjqySU0dOyTlHRsl5Rz7JgePpdznsyyU5dLy+ZpUcO7JKTh05JeccGSXnHfkkHzmyST525JJccmSSXHbkkShHFol25JDUODJI6hzxJbWO6JJ6R2xJiyOypM0RV9LqiCppd8SUOI6IEs8RT+I6okl8RyzJFkckyTZHHMlWRxTJdkcMSQ9HBEkfx3pJL8dqST/HWklPx0pJX8c6SW/HKkl/xxrJCMcKyRjHfMkox2zJOMdcyUjHTMlYxzzJaMcsyXjHHMkMxwzJHMd4ySzHaMk8x1jJTMdIyVzHOMlsxyjJfMcYyQrHCMkaR3/JKkdvyTpHX8lKR0/JWkc/yWpHL8l6Rx9JBEcPSQzHdkkUx1ZJHMc2SSTHFkkshy+J5nAl8RyeJKLDkcR0tEuiOlolcR1tksiOFklsR70kuqNWEt9RJ8ngqJEcOH4+1fRShnfqpYy93K/yxH3nJAeOyp7LCzr1XMY2dCpxHAEgJxLLEQFyJPEcISAHEtMRA/JO4jqCQP5JbEcUSJH4jjCQN8mXb63dl+vDIPdlUX1fP+3/pLW7sm8Y5K4sGh0QERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbkBEQNyAiIC4AREBcQMiAuIGRATEDYgIiBsQERA3ICIgbtcHGRWQxoDUBqQxILUBaez2x+Buy6L6drs/Tkm8bSX7mlwAAAAASUVORK5CYII="

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.47fa6382.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_diqz.688a4156.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287);
module.exports = __webpack_require__(288);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.bc33ea37.js